import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;

export const typeDefs = gql`
  schema {
    query: Query
    mutation: Mutation
    subscription: Subscription
  }
  """
  Result of an existing user opening a generic Contacts / Invite Friends link
  """
  type AcceptUserInvitePayload {
    """
    DM chat with the inviter; null for self / invalid
    """
    chat: Chat
    inviter: PublicUser
    """
    request_sent | already_friends | self | invalid
    """
    status: String!
  }
  """
  The connection type for Audit.
  """
  type ActivityFeedConnection {
    """
    A list of edges.
    """
    edges: [AuditEdge]
    isPaywalled: Boolean!
    """
    A list of nodes.
    """
    nodes: [Audit]
    """
    Information to aid in pagination.
    """
    pageInfo: PageInfo!
    totalEventCount: Int!
    upgradeTeam: Team
  }
  enum ActivityScope {
    """
    Every activity the viewer has access to.
    """
    ALL_ACTIVITIES
    """
    Only activities where the viewer is the target of another person's action.
    """
    FOR_YOU
  }
  enum ActivitySignificance {
    """
    Awaiting a decision. Never clears from being viewed, scrolled past or tapped
    -- only from Approve/Decline, Accept/Decline or Snooze.
    """
    ACTION_REQUIRED
    """
    FYI. Clears its unread state once the viewer has actually seen it.
    """
    LOWBAR
  }
  """
  Attributes for adding a new project checklist item
  """
  input AddProjectChecklistAttributes {
    name: String!
    sort: Int
  }
  type AppVersions {
    currentAndroidBuild: String!
    currentIosBuild: String!
    message: String!
  }
  """
  An assignee (or the unassigned bucket, when assignee is null) and the subset of the current My Tasks scope assigned to them
  """
  type AssigneeTaskGroup implements TaskGroupInterface {
    assignee: User
    completedCount: Int!
    completedTasks(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
    ): TaskConnection!
    taskCount: Int!
    tasks(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
    ): TaskConnection!
  }
  """
  Attachable objects such as Projects, Tasks, and Check-ins
  """
  union Attachment =
    | Document
    | EntityUser
    | Folder
    | LocalFile
    | Message
    | MessageProject
    | MessageTask
    | MessageTaskAssignment
    | MessageTaskComplete
    | Project
    | ProjectUser
    | PublicTeam
    | Task
    | TaskUser
    | UserRequest
  """
  Audit type representing an audit record in the system
  """
  type Audit {
    attachment: Attachment
    changes: JSON
    checkinStatus: String
    completionNote: String
    createdAt: ISO8601DateTime!
    documents: [Document!]!
    event: String!
    fieldEditSummary: String
    id: ID!
    projectRole: ProjectMemberRole
    significance: ActivitySignificance!
    taskRole: TaskMemberRole
    user: User
    userRequestSummary: String
  }
  """
  The connection type for Audit.
  """
  type AuditConnection {
    """
    A list of edges.
    """
    edges: [AuditEdge]
    """
    A list of nodes.
    """
    nodes: [Audit]
    """
    Information to aid in pagination.
    """
    pageInfo: PageInfo!
  }
  """
  An edge in a connection.
  """
  type AuditEdge {
    """
    A cursor for use in pagination.
    """
    cursor: String!
    """
    The item at the end of the edge.
    """
    node: Audit
  }
  """
  Represents non-fractional signed whole numeric values. Since the value may
  exceed the size of a 32-bit integer, it's encoded as a string.
  """
  scalar BigInt
  type BulkExportDocument {
    error: String
    resourceId: ID!
    resourceType: String!
    success: Boolean!
    url: String
  }
  """
  Chat type representing a chat in the system
  """
  type Chat {
    audits: [Audit!]
    avatar: File
    avatarUrl: String
    canCurrentUserDecide: Boolean!
    createdAt: ISO8601DateTime!
    description: String
    friendRequestAccepted: Boolean
    groupChat: Boolean!
    id: ID!
    inviteStatuses: [ChatInviteStatus!]!
    isGroupChat: Boolean!
    isNewChat: Boolean
    isPendingRequest: Boolean!
    isUserBlocked: Boolean
    leaveOn: ISO8601DateTime
    messageBody: String
    messageIcon: String
    messagePublishedAt: ISO8601DateTime
    messagesCount: Int
    name: String!
    owner: User!
    ownerId: ID!
    ownerName: String!
    pendingInvitations: [ChatInvitation!]!
    recentActivityAt: ISO8601DateTime
    settings: UserChatSetting
    settingsArchivedAt: ISO8601DateTime
    settingsMute: Boolean
    settingsPin: Boolean
    unreadCount: Int
    userIds: [ID!]!
    userRequests: [UserRequest!]!
    users: [User!]!
  }
  """
  Attributes for creating or updating a chat
  """
  input ChatAttributes {
    avatarBlobId: ID
    description: String
    """
    Email addresses to invite (for unregistered users)
    """
    emails: [String!]
    groupChat: Boolean
    mute: Boolean
    name: String
    pin: Boolean
    userIds: [ID!]
  }
  """
  The connection type for Chat.
  """
  type ChatConnection {
    """
    A list of edges.
    """
    edges: [ChatEdge]
    """
    A list of nodes.
    """
    nodes: [Chat]
    """
    Information to aid in pagination.
    """
    pageInfo: PageInfo!
  }
  """
  An edge in a connection.
  """
  type ChatEdge {
    """
    A cursor for use in pagination.
    """
    cursor: String!
    """
    The item at the end of the edge.
    """
    node: Chat
  }
  """
  Chat invitation type representing a chat invitation
  """
  type ChatInvitation {
    chat: Chat!
    createdAt: ISO8601DateTime!
    email: String!
    expiredAt: ISO8601DateTime!
    id: ID!
    invitedBy: User
    role: JSON
    """
    Status of the invitation (pending, expired, email_not_registered)
    """
    status: String!
  }
  enum ChatInviteSourceEnum {
    EMAIL_INVITE
    USER_REQUEST
  }
  """
  Unified invite status across email-based and registered-user invites for a chat
  """
  type ChatInviteStatus {
    createdAt: ISO8601DateTime!
    email: String
    id: ID!
    invitedBy: User
    source: ChatInviteSourceEnum!
    status: ChatInviteStatusEnum!
    user: User
  }
  enum ChatInviteStatusEnum {
    APPROVED
    EMAIL_NOT_REGISTERED
    EXPIRED
    JOINED
    PENDING
    REJECTED
  }
  """
  Chat project task type representing a task in a chat project
  """
  type ChatProjectTask {
    archivedAt: ISO8601DateTime
    createdAt: ISO8601DateTime!
    creator: User!
    currentUserRole: ProjectMemberRole!
    id: ID!
    name: String!
    tasks: [Task!]
  }
  """
  The connection type for ChatProjectTask.
  """
  type ChatProjectTaskConnection {
    """
    A list of edges.
    """
    edges: [ChatProjectTaskEdge]
    """
    A list of nodes.
    """
    nodes: [ChatProjectTask]
    """
    Information to aid in pagination.
    """
    pageInfo: PageInfo!
  }
  """
  An edge in a connection.
  """
  type ChatProjectTaskEdge {
    """
    A cursor for use in pagination.
    """
    cursor: String!
    """
    The item at the end of the edge.
    """
    node: ChatProjectTask
  }
  """
  Chat update type representing chat update information for subscriptions
  """
  type ChatUpdate {
    id: ID!
    messageBody: String
    name: String!
    recentActivityAt: ISO8601DateTime
    unreadCount: Int
  }
  """
  Checklist category type
  """
  type ChecklistCategory {
    categoryName: String!
    id: ID!
  }
  """
  Project checklist template type
  """
  type ChecklistTemplate {
    checklistCategory: ChecklistCategory!
    checklistTemplateItems: [ChecklistTemplateItem!]!
    favoritedAt: ISO8601DateTime
    id: ID!
    isFavorited: Boolean!
    itemCount: Int!
    owner: User!
    templateName: String!
  }
  """
  Checklist template item type representing an individual item in a template
  """
  type ChecklistTemplateItem {
    checklistTemplateItemName: String!
    id: ID!
  }
  """
  Type for CollectionMetadataType
  """
  type CollectionMetadata {
    """
    Current Page of loaded data
    """
    currentPage: Int!
    """
    The number of items per page
    """
    limitValue: Int!
    """
    The total number of items to be paginated
    """
    totalCount: Int!
    """
    The total number of pages in the pagination
    """
    totalPages: Int!
  }
  """
  Attributes for get contact invitation url
  """
  input CreateContactInvitationUrlAttributes {
    phoneNumber: [String!]!
  }
  """
  Autogenerated return type of CreateMediaShareLink.
  """
  type CreateMediaShareLinkPayload {
    token: String!
  }
  """
  Autogenerated return type of CreateShareLink.
  """
  type CreateShareLinkPayload {
    sharedUrl: String
  }
  """
  Payload returned after deleting a message document. Contains only the identifiers needed to update client caches.
  """
  type DeleteMessageDocumentPayload {
    clientId: String!
    id: ID!
  }
  type Device {
    createdAt: ISO8601DateTime!
    id: ID!
    platform: DevicePlatform
    token: String!
    tokenType: DeviceToken
    user: User!
  }
  """
  Attributes for creating a user device
  """
  input DeviceAttributes {
    platform: DevicePlatform
    token: String!
    tokenType: DeviceToken
  }
  enum DevicePlatform {
    ANDROID
    IOS
    WEB
  }
  enum DeviceToken {
    EXPO
    FIREBASE
  }
  """
  Represents direct upload credentials
  """
  type DirectUpload {
    """
    Created blob record ID
    """
    blobId: ID!
    """
    Client-side value used to correlate file with blob ID
    """
    clientId: ID!
    """
    HTTP request headers (JSON-encoded)
    """
    headers: String!
    """
    Created blob record signed ID
    """
    signedBlobId: ID!
    """
    Upload URL
    """
    url: String!
  }
  """
  File information required to prepare a direct upload
  """
  input DirectUploadAttributes {
    """
    File size (bytes)
    """
    byteSize: Int!
    """
    MD5 file checksum as base64
    """
    checksum: String!
    """
    Client-side value used to correlate file with blob ID
    """
    clientId: ID!
    """
    File content type
    """
    contentType: String
    """
    Original file name
    """
    filename: String!
  }
  """
  Document type representing a document in the system
  """
  type Document {
    blobId: ID
    clientId: String!
    contentType: String
    createdAt: ISO8601DateTime!
    duration: Int
    failedAt: ISO8601DateTime!
    file: File!
    folder: Folder
    height: Int
    id: ID!
    isAudio: Boolean!
    isImage: Boolean!
    isVideo: Boolean!
    messageClientId: String
    messageCreateYn: Boolean
    messageDocuments: [MessageDocument!]
    name: String!
    owner: User!
    projectDocuments: [ProjectDocument!]
    size: Int
    taskDocuments: [TaskDocument!]
    updatedAt: ISO8601DateTime!
    uuid: ID!
    width: Int
  }
  """
  Attributes for creating or updating a document
  """
  input DocumentAttributes {
    blobId: ID!
    clientId: ID!
    contentType: String
    duration: Int
    folderId: ID
    isAudio: Boolean!
    isImage: Boolean!
    name: String
    projectIds: [ID!]
    taskIds: [ID!]
  }
  """
  DocumentCollection type
  """
  type DocumentCollection {
    """
    A collection of paginated DocumentCollection
    """
    collection: [Document!]!
    """
    Pagination Metadata for navigating the Pagination
    """
    metadata: CollectionMetadata!
  }
  """
  The connection type for Document.
  """
  type DocumentConnection {
    """
    A list of edges.
    """
    edges: [DocumentEdge]
    """
    A list of nodes.
    """
    nodes: [Document]
    """
    Information to aid in pagination.
    """
    pageInfo: PageInfo!
  }
  """
  An edge in a connection.
  """
  type DocumentEdge {
    """
    A cursor for use in pagination.
    """
    cursor: String!
    """
    The item at the end of the edge.
    """
    node: Document
  }
  enum DocumentGroup {
    FILE
    MEDIA
  }
  enum DocumentSortOption {
    DATE_ASC
    DATE_DESC
    NAME_ASC
    NAME_DESC
  }
  type DraftMessage {
    body: String
    chatId: ID!
    checkin: MessageCheckin
    localFiles: [LocalFile]!
    replyMessage: Message
    tagsCollection: [TaskTagCollection]!
  }
  input DraftMessageAttributes {
    body: String
    checkin: MessageCheckinAttributes
    localFiles: [LocalFileInput]!
    replyMessage: ReplyMessageInput
    tagsCollection: [TaskTagCollectionInput]!
  }
  """
  Generic type representing users removed from project or task
  """
  type EntityUser {
    id: ID!
    project: Project
    task: Task
    user: User
  }
  """
  Autogenerated return type of ExportCheckins.
  """
  type ExportCheckinsPayload {
    filename: String!
    url: String!
  }
  """
  Autogenerated return type of ExportGlobalCheckins.
  """
  type ExportGlobalCheckinsPayload {
    filename: String!
    url: String!
  }
  """
  Features
  """
  type FeatureFlag {
    enabled: Boolean!
    name: String!
  }
  """
  File type representing a file attachment in the system
  """
  type File {
    cdnBaseUrl: String!
    """
    When the signed URL stops working. Only set for avatars, whose URL is signed
    fresh on every resolution; nil for files that may be served from cache.
    """
    expiresAt: ISO8601DateTime
    id: ID!
    isPreviewable: Boolean!
    path: String!
    """
    When the signed URL was issued. Only set for avatars; nil for files that may
    be served from cache, where receipt time says nothing about issuance.
    """
    signedAt: ISO8601DateTime
    thumbnail: String
    url: String!
  }
  """
  Folders
  """
  type Folder {
    id: ID!
    name: String!
    owner: User!
    parent: Folder
    projects: [Project!]
    tasks: [Task!]
  }
  """
  Attributes for creating or updating a folder
  """
  input FolderAttributes {
    name: String
    parentId: ID
    projectIds: [ID!]
    taskIds: [ID!]
  }
  """
  Autogenerated return type of ForwardDocuments.
  """
  type ForwardDocumentsPayload {
    errors: [String!]!
    messages: [Message!]!
  }
  """
  Autogenerated return type of GenerateReport.
  """
  type GenerateReportPayload {
    uuid: String!
  }
  type Group {
    createdAt: ISO8601DateTime!
    currentUserTeamRole: TeamRole
    id: ID!
    name: String!
    team: Team
    users: [User!]
    usersCount: Int!
    usersPreview: [User!]!
  }
  """
  Attributes for creating or updating a group
  """
  input GroupAttributes {
    accountId: ID!
    name: String!
    userIds: [ID!]
  }
  type Highlight {
    authorName: [String!]
    body: [String!]
    chatName: [String!]
    documentNames: [String!]
    email: [String!]
    name: [String!]
    projectNames: [String!]
    taskNames: [String!]
  }
  """
  An ISO 8601-encoded datetime
  """
  scalar ISO8601DateTime
    @specifiedBy(url: "https://tools.ietf.org/html/rfc3339")
  enum Invitation {
    CHAT
    PROJECT
    TASK
    TEAM
  }
  """
  Structure describing invitation auto-join eligibility and associated resources
  """
  type InvitationValidity {
    autoJoin: Boolean!
    """
    Chat details for group chat invite
    """
    chat: PublicChat
    """
    Email the invitation was sent to
    """
    invitationEmail: String
    """
    Name of the person the invitation was sent to
    """
    invitationName: String
    """
    Role assigned in the invitation (serialized as string for cross-type compatibility)
    """
    invitationRole: String
    """
    Explicit invitation state: "active", "expired", "invalid" (token not found),
    or "already_member" (current user is already a member of the invited project).
    Null only if the resolver cannot determine status (should not occur in practice).
    """
    invitationStatus: String
    """
    User who sent the invitation; null if absent
    """
    invitedBy: PublicUser
    """
    Name of the user who sent the invitation
    """
    invitedByName: String
    """
    Whether this is a shareable link invite (vs direct email invite)
    """
    isLinkInvite: Boolean!
    """
    Whether a task invitation link can no longer be used for direct join; false for non-task invitation types.
    """
    isTaskInvitationExpired: Boolean!
    """
    Project details if associated with a project
    """
    project: PublicProject
    """
    Task details if the token is associated with a task
    """
    task: PublicTask
    """
    Team details if the token is associated with a team
    """
    team: PublicTeam
  }
  """
  Invoice type representing an invoice in the system
  """
  type Invoice {
    amount: Int!
    date: ISO8601DateTime!
    description: String!
    id: ID!
    invoiceUrl: String!
    payment: Payment
    status: String!
  }
  """
  Represents untyped JSON
  """
  scalar JSON
  """
  LocalFile is strictly for generating an extendable type via codegen
  """
  type LocalFile {
    blobId: ID
    cdnBaseUrl: String!
    clientId: String!
    contentType: String!
    duration: Int
    id: ID!
    isAudio: Boolean!
    isImage: Boolean!
    isPreviewable: Boolean!
    isVideo: Boolean!
    name: String!
    path: String!
    size: Int
    thumbnail: String!
    url: String!
  }
  """
  Client-side schema extensions for offline/draft functionality
  """
  input LocalFileInput {
    blobId: ID
    cdnBaseUrl: String!
    clientId: String!
    contentType: String!
    duration: Int
    id: ID!
    isAudio: Boolean!
    isImage: Boolean!
    isPreviewable: Boolean!
    isVideo: Boolean!
    name: String!
    path: String!
    size: Int
    thumbnail: String!
    url: String!
  }
  """
  Autogenerated return type of MeUpdated.
  """
  type MeUpdatedPayload {
    chats: [Chat!]
    profile: Profile
    unviewedProjectAssignments: [Project!]
  }
  """
  Attributes for assigning membership to a user
  """
  input MemberAttributes {
    role: TeamRole!
    userId: ID!
  }
  """
  Message type representing a message in the system
  """
  type Message implements Node {
    attachments: [Attachment!]
    author: User!
    authorAvatarId: ID
    authorEmail: String
    authorFirstName: String
    authorId: ID!
    authorLastName: String
    authorName: String
    body: String
    chat: Chat!
    chatId: ID!
    checkin: MessageCheckin
    clientId: String!
    createdAt: ISO8601DateTime!
    deletedAt: ISO8601DateTime
    failedAt: ISO8601DateTime!
    filesCount: Int
    forwardedId: Int
    id: ID!
    imagesCount: Int
    isDraft: Boolean!
    isRetry: Boolean!
    isSender: Boolean!
    localFiles: [LocalFile]
    messageIcon: String
    projectIds: [ID!]
    projectsCount: Int
    publish: Boolean
    publishedAt: ISO8601DateTime
    reaction: [MessageReaction!]
    readAt: ISO8601DateTime
    readReceipts: [User!]
    replyId: ID
    replyMessage: Message
    taskIds: [ID!]
    tasksCount: Int
    userRequest: UserRequest
  }
  """
  Attributes for creating or updating a message
  """
  input MessageAttributes {
    body: String
    chatId: ID!
    checkin: MessageCheckinAttributes
    clientId: String
    documents: [DocumentAttributes!]
    folders: [FolderAttributes!]
    forwardedId: ID
    friendRequestAccepted: Boolean
    messageProjects: [MessageProjectAttributes!]
    messageTasks: [MessageTaskAttributes!]
    projectIds: [ID!]
    publish: Boolean
    replyId: ID
    taskIds: [ID!]
  }
  """
  Message checkin type representing a checkin in a message
  """
  type MessageCheckin {
    address: String
    city: String
    country: String
    id: ID!
    latitude: Float
    longitude: Float
    message: User
    state: String
    user: User
    withinGeofence: Boolean!
    zipcode: String
  }
  """
  Attributes for creating checkin when create a message
  """
  input MessageCheckinAttributes {
    address: String!
    city: String
    country: String
    county: String
    latitude: Float!
    longitude: Float!
    state: String
    zipcode: String
  }
  """
  The connection type for Message.
  """
  type MessageConnection {
    """
    A list of edges.
    """
    edges: [MessageEdge]
    """
    A list of nodes.
    """
    nodes: [Message]
    """
    Information to aid in pagination.
    """
    pageInfo: PageInfo!
  }
  """
  MessageDocument type
  """
  type MessageDocument {
    document: Document
    documentId: ID!
    id: ID!
    message: Message
    owner: User
  }
  """
  An edge in a connection.
  """
  type MessageEdge {
    """
    A cursor for use in pagination.
    """
    cursor: String!
    """
    The item at the end of the edge.
    """
    node: Message
  }
  """
  Message project type representing a message related to a project in the system
  """
  type MessageProject {
    author: User
    authorId: ID!
    id: ID!
    message: Message
    project: Project
    projectId: ID!
  }
  """
  Attributes for creating or updating a message
  """
  input MessageProjectAttributes {
    authorId: ID!
    projectId: ID!
  }
  """
  Message reaction type representing a reaction to a message in the system
  """
  type MessageReaction {
    count: Int!
    id: ID!
    message: Message
    reaction: String!
    reactionId: ID!
    user: [User!]
  }
  """
  Attributes for creating or updating message tags
  """
  input MessageTagAttributes {
    projectIds: [ID!]
    taskIds: [ID!]
  }
  """
  MessageTask type
  """
  type MessageTask {
    author: User
    authorId: ID!
    id: ID!
    message: Message
    task: Task
    taskId: ID!
  }
  """
  MessageTaskAssignment type
  """
  type MessageTaskAssignment {
    assignees: [User!]!
    id: ID!
    messageId: ID!
    task: Task
      @deprecated(
        reason: "Use \`tasks\` instead — a message can reference multiple tasks."
      )
    taskSnapshots: [MessageTaskSnapshot!]!
    tasks: [Task!]
  }
  """
  Attributes for creating or updating a message
  """
  input MessageTaskAttributes {
    authorId: ID!
    taskId: ID!
  }
  """
  MessageTaskComplete type
  """
  type MessageTaskComplete {
    completor: User
    id: ID!
    messageId: ID!
  }
  """
  Frozen per-task status captured when a task-assignment card was created — does
  not reflect later changes made outside the card itself
  """
  type MessageTaskSnapshot {
    assignees: [User!]!
    completedAt: ISO8601DateTime
    dueDate: ISO8601DateTime
    status: TaskStatus
    taskId: ID!
  }
  type Mutation {
    """
    Accept Chat Invitation
    """
    acceptChatInvitation(invitationToken: String!): Chat!
    """
    Accept Team Invitation
    """
    acceptTeamInvitation(invitationToken: String!): Team!
    """
    Connects the current user with the inviter behind a generic invitation link
    """
    acceptUserInvite(invitationToken: String!): AcceptUserInvitePayload!
    """
    Add checklist item to a project
    """
    addProjectChecklist(
      attributes: AddProjectChecklistAttributes!
      uuid: ID!
    ): [ProjectChecklist!]!
    """
    Upload files to a project
    """
    addProjectFiles(attributes: [DocumentAttributes!]!, id: ID!): Project!
    """
    Add checklist item to a task
    """
    addTaskChecklist(
      attributes: TaskChecklistAttributes!
      taskId: ID!
    ): [TaskChecklist!]!
    """
    Upload files to a task
    """
    addTaskFiles(attributes: [DocumentAttributes!]!, id: ID!): Task!
    """
    Apply a predefined template to a project
    """
    applyProjectChecklistTemplate(
      projectChecklistTemplateId: ID!
      selectedItemIds: [ID!]
      uuid: ID!
    ): [ProjectChecklist!]!
    """
    Approve a project invitation.
    """
    approveProjectInvitation(userRequestId: ID!): Boolean!
    """
    Approve a task invitation
    """
    approveTaskInvitation(userRequestId: ID!): Boolean!
    """
    Archive a chat
    """
    archiveChat(id: ID!): Chat!
    """
    Archive a project
    """
    archiveProject(id: ID!): Project!
    """
    Assign an owner to a task
    """
    assignTaskOwner(id: ID!, newOwnerId: ID!): Task!
    """
    Assign users to a task created by or assigned to the current user
    """
    assignTaskUsers(
      chatId: ID = null
      id: ID = null
      members: [TaskMemberAttributes!]
      """
      Send the assignment card now instead of batching it.
      """
      sendCardImmediately: Boolean = false
      """
      The MEMBER JOINED card the assignment card replaces when it is sent immediately.
      """
      sourceMessageId: ID = null
      taskIds: [ID!] = null
    ): Task!
    """
    Assign an owner to a team
    """
    assignTeamOwner(id: ID!, newOwnerId: ID!): Team!
    """
    Generates a ZIP file containing documents related to the resource and returns the ZIP file URL via subscription
    """
    bulkExportDocuments(resourceId: ID!, resourceType: String!): Boolean!
    cancelStripeSubscription(id: ID!): Team
    """
    Block a user
    """
    chatBlockUnblockUser(userIdToBlock: ID!): User!
    """
    Record an onboarding step as completed or skipped. Idempotent — duplicate step_key returns the existing record.
    """
    completeOnboardingProgress(
      skipped: Boolean = false
      stepKey: OnboardingStepKey!
    ): User!
    """
    Toggle task completion by ID and current user
    """
    completeTask(
      attachments: [DocumentAttributes!] = []
      chatId: ID = null
      id: ID!
      """
      The chat message whose card this action was taken through. Only meaningful
      together with \`chatId\` -- pins the card-driven completion to the exact card
      the user tapped, so it behaves correctly even when the same task has more
      than one card in that chat.
      """
      messageId: ID = null
      note: String = null
    ): Task!
    """
    Complete web tutorial flow for the current user.
    """
    completeWebTutorialFlows(flowType: WebTutorialFlow!): Boolean!
    """
    Convert a project checklist item to a task
    """
    convertProjectChecklistToTask(projectChecklistIds: [ID!]!): [Task!]!
    """
    Create a new chat
    """
    createChat(attributes: ChatAttributes!): Chat!
    """
    Create chat invitations for email addresses (works for both group and 1-to-1 chats)
    """
    createChatInvitation(emails: [String!]!, id: ID!): Chat
    createContactInvitationUrl(
      attributes: CreateContactInvitationUrlAttributes!
    ): String
    createDevice(attributes: DeviceAttributes!): Device
    createDirectUploads(
      attributes: [DirectUploadAttributes!]!
    ): [DirectUpload!]!
    """
    Create a new draft message
    """
    createDraftMessage(attributes: MessageAttributes!): Message!
    """
    Create a new group
    """
    createGroup(attributes: GroupAttributes!): Group!
    createInvite(
      chatId: ID = null
      projectId: ID = null
      taskId: ID = null
    ): String
    createMediaShareLink(documentIds: [ID!]!): CreateMediaShareLinkPayload
    """
    Create a new message
    """
    createMessageIndividual(attributes: MessageAttributes!): Message!
    """
    Create a message reaction
    """
    createMessageReaction(messageId: ID!, reaction: String!): MessageReaction!
    """
    Create a new phase
    """
    createPhase(attributes: PhaseAttributes!): Phase!
    createProject(attributes: ProjectAttributes!): Project
    """
    Create a project invitation
    """
    createProjectInvitation(
      id: ID!
      projectMembers: [ProjectMemberRoleAttributes!]!
    ): Project
    createShareLink(documentIds: [ID!]!): CreateShareLinkPayload
    createStripeSubscription(
      stripeSubscriptionAttributes: StripeSubscriptionAttributes!
      teamAttributes: TeamAttributes
    ): PaymentIntent
    """
    Create a new task
    """
    createTask(
      attributes: TaskAttributes!
      """
      Chat ID for auto-assignment context
      """
      chatId: ID
      """
      Send the assignment card now instead of batching it.
      """
      sendCardImmediately: Boolean = false
      """
      The MEMBER JOINED card the assignment card replaces when it is sent immediately.
      """
      sourceMessageId: ID = null
    ): Task!
    """
    Create a task invitation
    """
    createTaskInvitation(
      id: ID!
      taskMembers: [TaskMemberRoleAttributes!]!
    ): Task
    """
    Create a new team
    """
    createTeam(
      attributes: TeamAttributes!
      billingSource: String
      stripeSubscriptionAttributes: StripeSubscriptionAttributes
    ): Team!
    """
    Create a team invitation
    """
    createTeamInvitation(
      """
      Email address to send invitation to
      """
      email: String
      id: ID!
      """
      Name of the person being invited
      """
      name: String
    ): String!
    """
    Create team member invitations with roles
    """
    createTeamMemberInvitation(
      id: ID!
      teamMembers: [TeamMemberRoleAttributes!]!
    ): Team
    """
    Create a new user request
    """
    createUserRequest(attributes: UserRequestAttributes!): UserRequest!
    """
    Delete a chat invitation
    """
    deleteChatInvitation(chatInvitationId: ID!): Boolean
    deleteDevice(apiToken: String, expoToken: String!): Device
    deleteDirectUploads(blobId: ID!): Boolean
    """
    User declined the friend request
    """
    deleteFriendRequest(friendRequest: Boolean!, id: ID!): Chat
    """
    Delete a contact group
    """
    deleteGroup(id: ID!): Group
    """
    User deleting the group chat after leaving the chat group
    """
    deleteGroupChat(id: ID!): Chat
    """
    Owner deleting the group chat for everyone with notifications
    """
    deleteGroupChatForEveryone(id: ID!): Boolean!
    """
    Delete a new message
    """
    deleteMessage(id: ID!): Message!
    """
    Delete a document from a chat message (image viewer context). Only documents
    attached to at least one message are reachable. The caller must be the
    document owner or the author of a message containing the document. The parent
    message is left untouched.
    """
    deleteMessageDocument(id: ID!): DeleteMessageDocumentPayload!
    """
    Delete a project
    """
    deleteProject(id: ID!): Project!
    """
    Delete a project asynchronously via background job
    """
    deleteProjectAsync(id: ID!): Boolean!
    """
    Delete a project files
    """
    deleteProjectFiles(ids: [ID!]): [ProjectDocument!]!
    """
    Delete a project invitation
    """
    deleteProjectInvitation(projectInvitationId: ID!): Boolean
    """
    Delete a task
    """
    deleteTask(id: ID!): Task
    """
    Delete a task files
    """
    deleteTaskFiles(ids: [ID!]): [TaskDocument!]!
    """
    Delete a task invitation
    """
    deleteTaskInvitation(taskInvitationId: ID!): Boolean
    """
    Delete a team
    """
    deleteTeam(id: ID!): Team
    """
    Delete a team invitation or user request
    """
    deleteTeamInvitation(accountInvitationId: ID, userRequestId: ID): Boolean
    """
    Delete a user request
    """
    deleteUserRequest(id: ID!): UserRequest!
    """
    Duplicate project with optional associated records
    """
    duplicateProject(
      id: ID!
      includeAdmins: Boolean = false
      includeEditors: Boolean = false
      includeFiles: Boolean = false
      includeMembers: Boolean = false
      includePhases: Boolean = false
      includeTasks: Boolean = false
      includeViewers: Boolean = false
    ): Project!
    """
    Duplicate task with optional associated records
    """
    duplicateTask(
      id: ID!
      includeAssignees: Boolean
      includeCheckLists: Boolean
      includeCreator: Boolean
      includeFiles: Boolean
      includeViewers: Boolean
    ): Task!
    """
    Duplicate task files from source to destination.
    """
    duplicateTaskFiles(destinationId: ID!, sourceId: ID!): [TaskDocument!]!
    editStripeSubscription(
      stripeSubscriptionAttributes: StripeSubscriptionAttributes!
    ): PaymentIntent
    """
    Export project checkins as CSV with optional date range filtering
    """
    exportCheckins(
      from: ISO8601DateTime
      projectId: ID!
      to: ISO8601DateTime
    ): ExportCheckinsPayload
    """
    Export checkins across all projects as CSV with optional date range filtering
    """
    exportGlobalCheckins(
      from: ISO8601DateTime
      to: ISO8601DateTime
    ): ExportGlobalCheckinsPayload
    """
    Forward source documents to one or more target chats server-side, reusing existing blobs
    """
    forwardDocuments(
      documentIds: [ID!]!
      targetChatIds: [ID!]!
    ): ForwardDocumentsPayload
    """
    Create a new chat with friend request
    """
    friendRequest(attributes: ChatAttributes!): Chat!
    generateProjectReport(projectId: ID!): GenerateReportPayload
    """
    generate new public calendar url for current user
    """
    generatePublicCalendarUrl: String!
    """
    invalidate public calendar url for current user
    """
    invalidatePublicCalendarUrl: Boolean!
    """
    Join a project via user request
    """
    joinRequestedProject(userRequestId: ID!): Boolean!
    """
    Join a task via user request
    """
    joinRequestedTask(userRequestId: ID!): Boolean!
    """
    Leave a group chat
    """
    leaveChat(id: ID!): Chat
    """
    Leave a project
    """
    leaveProject(id: ID!): Project
    leaveTask(id: ID!, userId: ID!): Task
    """
    Leave a team
    """
    leaveTeam(id: ID!): Team!
    """
    Marks the current activity feed state as viewed, clearing the Activity nav red dot
    """
    markActivityViewed: User!
    """
    Create read receipts for all active log by ID
    """
    markAuditsRead(attributes: ReadReceiptAuditAttributes!): [Audit!]!
    """
    Create read receipts for all messages by chat ID
    """
    markChatsRead(attributes: ReadReceiptChatAttributes!): [Chat!]!
    """
    Mark the project onboarding card as seen for the current user
    """
    markProjectOnboarded(id: ID!): Boolean!
    """
    Mark a task as acknowledged by the current assignee
    """
    markTaskAcknowledged(id: ID!): Task
    markTaskOpened(id: ID!): Task
    """
    Notify team about trial expiry; owners/admins send email, members send in-app message
    """
    notifyTeamExpiry(projectId: ID!): NotifyTeamExpiryPayload
    """
    Notify team owners and admins about subscription reactivation request
    """
    notifyTeamOwner(teamId: ID!): NotifyTeamOwnerPayload
    """
    Reorder one or more tasks within a My Tasks section. The tasks array is placed
    as a contiguous ordered block between the two anchors. Pass a single-element
    array to move one task.
    """
    orderTasks(
      """
      The task immediately preceding the group (lower rank)
      """
      afterTaskId: ID
      """
      The task immediately following the group (higher rank)
      """
      beforeTaskId: ID
      section: TaskSection!
      taskIds: [ID!]!
    ): [UserTaskOrder!]
    """
    Reject a project invitation
    """
    rejectProjectInvitation(userRequestId: ID!): Boolean!
    """
    Reject a task invitation
    """
    rejectTaskInvitation(userRequestId: ID!): Boolean!
    """
    Remove a member from a group chat
    """
    removeChatMember(id: ID!, userId: ID!): Boolean
    """
    Removes current user and related data asynchronously
    """
    removeMe: User!
    """
    Remove a message reaction
    """
    removeMessageReaction(id: ID!): MessageReaction!
    """
    Remove a project checklist
    """
    removeProjectChecklist(projectChecklistId: ID!): Boolean!
    """
    Remove a member from a project
    """
    removeProjectMember(id: ID!, userId: ID!): Project!
    """
    Remove checklist item from a task
    """
    removeTaskChecklist(id: ID!): TaskChecklist!
    """
    Update a members role on a team
    """
    removeTeamMember(id: ID!, userId: ID!): Team!
    """
    Rename a document
    """
    renameDocument(id: ID!, name: String!): Document!
    """
    Resend a chat invitation to an invitee
    """
    resendChatInvitation(chatInvitationId: ID!): Boolean
    """
    Resend a project invitation to an invitee
    """
    resendProjectInvitation(projectInvitationId: ID!): Boolean
    """
    Resend a task invitation to an invitee
    """
    resendTaskInvitation(taskInvitationId: ID!): Boolean
    """
    Resend a team invitation or user request
    """
    resendTeamInvitation(accountInvitationId: ID, userRequestId: ID): Boolean
    """
    Save an existing project checklist as a reusable template.
    """
    saveChecklistAsTemplate(
      attributes: SaveChecklistAsTemplateAttributes!
      projectUuid: ID!
      templateName: String!
    ): ChecklistTemplate!
    """
    Set user primary team
    """
    setPrimaryTeam(accountId: ID!): User!
    """
    Snoozes a pending decision (invite/join request) so it drops out of the Needs a Decision block until snoozed_until passes
    """
    snoozePendingDecision(
      """
      Defaults to 24 hours from now. Must be in the future, no more than 30 days.
      """
      snoozedUntil: ISO8601DateTime
      userRequestId: ID!
    ): UserRequest!
    """
    Toggle favorite status of a checklist template
    """
    toggleChecklistTemplateFavorite(checklistTemplateId: ID!): Boolean!
    """
    Unarchive a chat
    """
    unarchiveChat(id: ID!): Chat!
    """
    Unarchive a project
    """
    unarchiveProject(id: ID!): Project!
    """
    Update billing Period
    """
    updateBillingPeriod(priceId: String!, teamId: ID!): PaymentIntent
    """
    Update a chat
    """
    updateChat(attributes: ChatAttributes!, id: ID!): Chat!
    """
    Update group chat admin
    """
    updateChatAdmin(id: ID!, userId: ID!): Chat!
    """
    Update project/task tags for a single document within its chat message, without affecting sibling documents
    """
    updateDocumentTags(
      attributes: MessageTagAttributes!
      id: ID!
      messageId: ID!
    ): Document!
    """
    Update the draft message for the given chat
    """
    updateDraftMessage(
      attributes: DraftMessageAttributes!
      chatId: ID!
    ): DraftMessage
    """
    update a group
    """
    updateGroup(attributes: GroupAttributes!, id: ID!): Group!
    """
    Mark the hashtag first-use tooltip as seen for the current user on a given platform
    """
    updateHashtagTooltipSeen(
      """
      Pass true for the web tooltip, false for native
      """
      web: Boolean!
    ): User!
    """
    Update current user profile information
    """
    updateMe(attributes: UserAttributes!): User!
    """
    Update a message
    """
    updateMessageIndividual(
      attributes: MessageAttributes!
      clientId: String
      id: ID
    ): Message!
    """
    Update message tags
    """
    updateMessageTags(attributes: MessageTagAttributes!, id: ID!): Message!
    """
    Update notification setting
    """
    updateNotificationSetting(
      attributes: [NotificationSettingAttributes!]!
    ): [UserNotificationSetting!]!
    """
    Update user onboarding progress
    """
    updateOnboardingProgress(onboardingFlow: OnboardingFlow!): User!
    """
    Mark onboarding steps complete for the current user. Forward-only fields.
    """
    updateOnboardingState(attributes: OnboardingStateAttributes!): User!
    """
    Update payment processor's customer's payment method.
    """
    updatePaymentMethod(paymentMethodToken: String!, teamId: ID!): Team!
    updateProject(attributes: ProjectAttributes!, id: ID!): Project
    """
    Update a project checklist
    """
    updateProjectChecklist(
      attributes: UpdateProjectChecklistAttributes!
      projectChecklistId: ID!
    ): ProjectChecklist!
    """
    Update sort order of project checklists
    """
    updateProjectChecklistSort(
      attributes: [ProjectChecklistSortAttributes!]!
      uuid: ID!
    ): [ProjectChecklist!]!
    """
    Update project file tags
    """
    updateProjectFileTags(id: ID!, projectId: ID!, taskIds: [ID!]): Document!
    """
    Update a project member role
    """
    updateProjectMemberRole(
      projectUserId: ID!
      role: ProjectMemberRole!
    ): Project!
    """
    Update project members
    """
    updateProjectMembers(
      attributes: [ProjectMemberAttributes!]!
      id: ID!
    ): Project!
    """
    Merge Rate Us state for the current user. Booleans are forward-only (true
    wins). Trigger counts and stages take the higher value; timestamps take the later value.
    """
    updateRateUsState(attributes: UpdateRateUsStateAttributes!): RateUsState!
    """
    Update a task created by the current user
    """
    updateTask(attributes: TaskAttributes!, id: ID!): Task!
    """
    Update a task checklist
    """
    updateTaskChecklist(
      attributes: TaskChecklistAttributes!
      id: ID!
    ): TaskChecklist!
    """
    Update a task checklist
    """
    updateTaskChecklistSort(
      attributes: [TaskChecklistAttributes!]!
      taskId: ID!
    ): [TaskChecklist!]!
    """
    Update a task members
    """
    updateTaskMembers(attributes: [TaskMemberAttributes!]!, id: ID!): Task!
    """
    Update a team
    """
    updateTeam(attributes: TeamAttributes!, id: ID!): Team!
    """
    Update a members role on a team
    """
    updateTeamMembers(attributes: [MemberAttributes!]!, teamId: ID!): Team!
    """
    Update tutoralization setting
    """
    updateTutoralizationSetting(
      attributes: [TutoralizationSettingAttributes!]!
    ): [UserTutoralizationSetting!]!
    """
    Approve or reject a user request
    """
    updateUserRequestStatus(id: ID!, status: String!): UserRequest!
    uploadContacts(attributes: UploadContactAttributes!): User
  }
  """
  An object with an ID.
  """
  interface Node {
    """
    ID of the object.
    """
    id: ID!
  }
  enum NotificationSetting {
    CHAT
    DAILY_DIGEST
    FILE
    PROJECT
    TASK
    WEEKLY_UPDATE
  }
  """
  Attributes for updating notification setting
  """
  input NotificationSettingAttributes {
    duration: NotificationSettingDuration
    mute: Boolean!
    settingType: NotificationSetting!
  }
  enum NotificationSettingDuration {
    DAY
    FOREVER
    WEEK
  }
  """
  Autogenerated return type of NotifyTeamExpiry.
  """
  type NotifyTeamExpiryPayload {
    success: Boolean!
  }
  """
  Autogenerated return type of NotifyTeamOwner.
  """
  type NotifyTeamOwnerPayload {
    success: Boolean!
  }
  enum OnboardingFlow {
    COMPLETED
    EXPLORATION
    PROJECT_CREATION
    TASK_CREATION
    TEAM_SETUP
  }
  """
  A single onboarding step record for a user
  """
  type OnboardingProgress {
    completedAt: ISO8601DateTime
    skipped: Boolean!
    stepKey: OnboardingStepKey!
  }
  """
  Per-user onboarding state — includes checklist completion steps and UI coachmark/nudge visibility flags
  """
  type OnboardingState {
    checklistCreationComplete: Boolean!
    firstChatSent: Boolean!
    firstTagUsed: Boolean!
    inviteMemberComplete: Boolean!
    photoRequestNudgeShown: Boolean!
    projectCreationComplete: Boolean!
    tagPillCoachmarkShown: Boolean!
    taskCreationComplete: Boolean!
    welcomeModalSeen: Boolean!
  }
  """
  Forward-only onboarding state flags — includes checklist completion steps and UI coachmark/nudge visibility flags
  """
  input OnboardingStateAttributes {
    checklistCreationComplete: Boolean
    firstChatSent: Boolean
    firstTagUsed: Boolean
    inviteMemberComplete: Boolean
    photoRequestNudgeShown: Boolean
    projectCreationComplete: Boolean
    tagPillCoachmarkShown: Boolean
    taskCreationComplete: Boolean
    welcomeModalSeen: Boolean
  }
  enum OnboardingStepKey {
    ADD_MEMBERS
    ASSIGN_TASK
    CARLOS_FIRST_CHAT
    CARLOS_FIRST_TAG
    CARLOS_TAG_PILL
    CARLOS_TASK_DETAIL
    CARLOS_TASK_LIST
    FIRST_CHAT
    FIRST_PHOTO
    FIRST_TAG
    FIRST_TAG_PILL
    PROJECT_CREATION
    TASK_CREATION
    WELCOME_GREETING
  }
  """
  Information about pagination in a connection.
  """
  type PageInfo {
    """
    When paginating forwards, the cursor to continue.
    """
    endCursor: String
    """
    When paginating forwards, are there more items?
    """
    hasNextPage: Boolean!
    """
    When paginating backwards, are there more items?
    """
    hasPreviousPage: Boolean!
    """
    When paginating backwards, the cursor to continue.
    """
    startCursor: String
  }
  """
  Payment type representing payment method information in the system
  """
  type Payment {
    brand: String!
    expMonth: String
    expYear: String
    last4: String
  }
  """
  Payment intent type representing payment intent information in the system
  """
  type PaymentIntent {
    clientSecret: String!
    id: String!
    intentType: String!
    team: Team!
  }
  """
  Paywall status for the current user
  """
  type PaywallStatus {
    isPaywalled: Boolean!
    """
    First eligible owned team for upgrade, if any. Nil when not paywalled or when the user owns no upgradeable teams.
    """
    upgradeTeam: Team
  }
  type PendingDecisionsResult {
    rows: [Audit!]!
    totalUnresolvedCount: Int!
  }
  """
  Phase type representing a phase in the system
  """
  type Phase {
    createdAt: ISO8601DateTime!
    id: ID!
    name: String!
    user: User!
  }
  """
  Attributes for creating a phase
  """
  input PhaseAttributes {
    name: String!
    taskIds: [ID!]
  }
  """
  Plan type representing subscription plan information in the system
  """
  type Plan {
    amount: Int!
    expiration: ISO8601DateTime!
    id: ID!
    interval: String!
    isCanceled: Boolean!
    isResumable: Boolean!
    name: String!
    payment: Payment
    quantity: Int!
    status: String!
  }
  """
  Price type representing subscription price information in the system
  """
  type Price {
    amount: Int!
    externalId: String!
    id: ID!
    interval: String!
    intervalCount: Int!
  }
  """
  A priority tier (High/Medium/Low) and the subset of the current My Tasks scope at that priority
  """
  type PriorityTaskGroup implements TaskGroupInterface {
    completedCount: Int!
    completedTasks(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
    ): TaskConnection!
    priority: TaskPriority!
    taskCount: Int!
    tasks(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
    ): TaskConnection!
  }
  """
  Product type representing subscription product information in the system
  """
  type Product {
    allowMembers: Boolean!
    externalId: String!
    features: JSON!
    guestsOnly: Boolean!
    id: ID!
    maxDocumentStorage: BigInt!
    maxNumberOfProjects: BigInt!
    name: String!
    position: Int!
    prices: [Price!]!
  }
  """
  Profile type representing a user profile in the system
  """
  type Profile {
    address: String
    avatar: File
    email: String!
    firstName: String
    id: ID!
    lastName: String
    name: String
    phoneNumber: String!
    skills: [Skill!]
    teams: [Team!]
    timeZone: String
    userActiveTasksCount: Int!
  }
  """
  Project type representing a project in the system
  """
  type Project {
    activeTasksCount: Int!
    address: String
    archivedAt: ISO8601DateTime
    audits: [Audit!]
    auditsCount: Int
    authorId: ID!
    chatProjectsCount: Int!
    color: String!
    completedChecklistCount: Int!
    completedTasksCount: Int!
    coverImage: File
    createdAt: ISO8601DateTime!
    creator: User!
    currentUserHasPendingMemberAdditionRequest: Boolean!
    currentUserRole: ProjectMemberRole
    currentUserTeamRole: TeamMemberRole
    description: String
    documentCount: Int!
    """
    Set only on a project created via duplicateProject -- null for ordinary projects.
    """
    duplicationStatus: ProjectDuplicationStatus
    group: Group
    icon: String
    id: ID!
    imageCount: Int!
    initials: String!
    invitations: [ProjectInvitation!]
    isTaskMember: Boolean!
    latitude: Float
    longitude: Float
    memberPreviews: [ProjectMember!]!
    members: [ProjectMember!]!
      @deprecated(
        reason: "Use memberPreviews for list-view avatar stacks or membersConnection for paginated full member retrieval."
      )
    """
    Paginated full member list for a single project detail view. Not batched — do
    not nest inside listProjects or another multi-project list.
    """
    membersConnection(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
    ): ProjectMembershipConnection!
    name: String!
    overdueTasksCount: Int!
    personal: Boolean!
    projectChecklists: [ProjectChecklist!]
    settings: UserProjectSetting
    tasks: [Task!]
      @deprecated(
        reason: "listTasks query accepts a projectId argument and paginates results"
      )
    tasksCount: Int!
    tasksTagList: [Task!]
    team: Team
    teamId: ID!
    unreadAudits: [Audit!]
    unreadAuditsCount: Int
    upcomingTasksCount: Int!
    userRequests: [UserRequest!]
    usersCount: Int!
    uuid: ID!
  }
  """
  Attributes for creating or updating a project
  """
  input ProjectAttributes {
    address: String
    color: String!
    description: String
    files: [DocumentAttributes!]
    groupId: ID
    icon: String
    latitude: Float
    longitude: Float
    members: [ProjectMemberAttributes!]!
    name: String!
    pin: Boolean
    projectMembers: [ProjectMemberRoleAttributes!]
    teamId: ID!
  }
  """
  Project checklist type representing a checklist item in a project
  """
  type ProjectChecklist {
    completedAt: ISO8601DateTime
    createdAt: ISO8601DateTime!
    id: ID!
    name: String!
    projectId: ID!
    sort: Int
  }
  """
  Attributes for updating project checklist sort order
  """
  input ProjectChecklistSortAttributes {
    projectChecklistId: ID!
    sort: Int!
  }
  """
  The connection type for Project.
  """
  type ProjectConnection {
    """
    A list of edges.
    """
    edges: [ProjectEdge]
    """
    A list of nodes.
    """
    nodes: [Project]
    """
    Information to aid in pagination.
    """
    pageInfo: PageInfo!
  }
  """
  Autogenerated return type of ProjectDeleted.
  """
  type ProjectDeletedPayload {
    projectId: ID!
    projectName: String!
  }
  """
  Project document type representing a document attached to a project in the system
  """
  type ProjectDocument {
    document: Document
    id: ID!
    owner: User
    project: Project
  }
  enum ProjectDuplicationStatus {
    COMPLETED
    DUPLICATING
    FAILED
  }
  """
  An edge in a connection.
  """
  type ProjectEdge {
    """
    A cursor for use in pagination.
    """
    cursor: String!
    """
    The item at the end of the edge.
    """
    node: Project
  }
  """
  Project invitation type representing a project invitation
  """
  type ProjectInvitation {
    createdAt: ISO8601DateTime!
    email: String!
    expiredAt: ISO8601DateTime
    id: ID!
    invitedBy: User!
    role: ProjectMemberRole!
  }
  """
  Project member type representing a member of a project in the system
  """
  type ProjectMember {
    id: ID!
    project: Project!
    role: ProjectMemberRole!
    user: User!
  }
  """
  Attributes for assigning project membership to a user
  """
  input ProjectMemberAttributes {
    groupId: ID
    role: ProjectMemberRole!
    userId: ID!
  }
  enum ProjectMemberRole {
    ADMIN
    EDITOR
    OWNER
    VIEWER
  }
  """
  Attributes for invite a user to be a member when create a project
  """
  input ProjectMemberRoleAttributes {
    email: String!
    role: ProjectMemberRole!
  }
  """
  Paginated project membership record (see membersConnection on ProjectType)
  """
  type ProjectMembership {
    id: ID!
    project: Project!
    role: ProjectMemberRole!
    user: User!
  }
  """
  The connection type for ProjectMembership.
  """
  type ProjectMembershipConnection {
    """
    A list of edges.
    """
    edges: [ProjectMembershipEdge]
    """
    A list of nodes.
    """
    nodes: [ProjectMembership]
    """
    Information to aid in pagination.
    """
    pageInfo: PageInfo!
  }
  """
  An edge in a connection.
  """
  type ProjectMembershipEdge {
    """
    A cursor for use in pagination.
    """
    cursor: String!
    """
    The item at the end of the edge.
    """
    node: ProjectMembership
  }
  """
  Returns ProjectType if current user is a member, otherwise PublicProjectType
  """
  union ProjectOrPublicProject = Project | PublicProject
  """
  Project report overview type representing project overview information in the system
  """
  type ProjectReportOverview {
    address: String
    createdAt: ISO8601DateTime!
    creator: User!
    description: String
    id: ID!
    members: [ProjectMember!]!
    name: String!
    teamName: String!
  }
  enum ProjectSortOption {
    ACTIVITY_DESC
    ID_ASC
    ID_DESC
    NAME_ASC
    NAME_DESC
    RECENT_TAGGED_MESSAGE_DESC
  }
  type ProjectTag {
    id: ID!
    name: String!
    uuid: ID!
  }
  input ProjectTagInput {
    id: ID!
    name: String!
    uuid: ID!
  }
  """
  Project task type representing a project with its tasks in the system
  """
  type ProjectTask {
    archivedAt: ISO8601DateTime
    createdAt: ISO8601DateTime!
    creator: User!
    currentUserRole: ProjectMemberRole
    currentUserTeamRole: TeamMemberRole
    id: ID!
    members: [ProjectMember!]!
    name: String!
    tasks: [Task!]
    team: Team
    uuid: ID!
  }
  """
  The connection type for ProjectTask.
  """
  type ProjectTaskConnection {
    """
    A list of edges.
    """
    edges: [ProjectTaskEdge]
    """
    A list of nodes.
    """
    nodes: [ProjectTask]
    """
    Information to aid in pagination.
    """
    pageInfo: PageInfo!
  }
  """
  An edge in a connection.
  """
  type ProjectTaskEdge {
    """
    A cursor for use in pagination.
    """
    cursor: String!
    """
    The item at the end of the edge.
    """
    node: ProjectTask
  }
  """
  A project and the subset of the current My Tasks scope that belongs to it (TA-10312)
  """
  type ProjectTaskGroup implements TaskGroupInterface {
    completedCount: Int!
    completedTasks(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
    ): TaskConnection!
    project: Project!
    taskCount: Int!
    tasks(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
    ): TaskConnection!
  }
  """
  Project tasks report type representing task report information in the system
  """
  type ProjectTasksReport {
    completedAt: ISO8601DateTime
    creator: User
    description: String
    dueDate: ISO8601DateTime
    id: ID!
    members: [TaskMember!]!
    name: String!
    priority: TaskPriority
    startDate: ISO8601DateTime
    status: String
  }
  """
  Project user type representing a user in a project in the system
  """
  type ProjectUser {
    id: ID!
    onboardedAt: ISO8601DateTime
    project: Project!
    user: User
  }
  """
  Public chat information safe for unauthenticated contexts (e.g. invite link previews)
  """
  type PublicChat {
    groupChat: Boolean!
    id: ID!
    name: String!
    ownerName: String
    userCount: Int!
  }
  """
  Public project information safe for non-members
  """
  type PublicProject {
    address: String
    color: String
    description: String
    hasPendingMemberAdditionRequest: Boolean!
    icon: String
    id: ID!
    invitationEmail: String
    invitationType: String
    inviteeRole: String
    inviterName: String
    members: [PublicProjectMember!]
    name: String!
    team: PublicProjectTeam
    teamName: String
    usersCount: Int!
    uuid: ID!
  }
  """
  Project member info safe for unauthenticated invitation previews
  """
  type PublicProjectMember {
    avatar: File
    id: ID!
    name: String
    role: ProjectMemberRole!
  }
  """
  Minimal team info safe to expose on public project invitation previews
  """
  type PublicProjectTeam {
    avatarFile: File
    name: String
  }
  """
  Public task information safe for non-members
  """
  type PublicTask {
    description: String
    dueDate: ISO8601DateTime
    hasPendingMemberAdditionRequest: Boolean!
    id: ID!
    inviterName: String
    name: String!
    ownerName: String
    priority: TaskPriority
    projectIcon: String
    projectName: String
    projectUuid: ID
    startDate: ISO8601DateTime
    usersCount: Int!
  }
  """
  Public team information safe for non-members
  """
  type PublicTeam {
    address: String
    avatarFile: File
    createdAt: ISO8601DateTime!
    hasPendingMemberAdditionRequest: Boolean!
    name: String!
    skills: [Skill!]!
    totalMembers: Int!
    uuid: ID!
  }
  """
  Public user information safe for unauthenticated contexts (e.g. invite previews)
  """
  type PublicUser {
    firstName: String
    id: ID!
    lastName: String
    name: String
  }
  type Query {
    """
    Retrieves the latest app version configuration
    """
    appVersions: AppVersions!
    """
    Retrieves chat avatars with specified IDs
    """
    chatAvatarsByIds(ids: [ID!]): [File!]
    """
    Checks if user coordinates are within geofence of project coordinates
    """
    checkGeofence(
      projectLatitude: Float!
      projectLongitude: Float!
      userLatitude: Float!
      userLongitude: Float!
    ): Boolean!
    """
    Retrieves documents associated with specified client IDs
    """
    documentsByClientIds(clientIds: [ID!]): [Document!]
    """
    Retrieves files with specified IDs
    """
    filesByIds(ids: [ID!]): [File!]
    """
    Retrieves a single chat by its ID
    """
    getChat(id: ID!): Chat!
    """
    Return a draft message for a chat
    """
    getDraftMessage(chatId: ID!): DraftMessage
    """
    Retrieves the feature flag status for the current user
    """
    getFeatureFlag(name: String!): FeatureFlag!
    """
    Retrieves a group by its ID
    """
    getGroup(id: ID!): Group
    """
    Retrieves the current authenticated user's information
    """
    getMe: User!
    """
    Returns whether the current user has an active paid team subscription, and the
    first owned team eligible for upgrade when paywalled.
    """
    getPaywallStatus: PaywallStatus!
    """
    Retrieves a product by its ID
    """
    getProduct(id: ID!): Product!
    """
    Retrieves a user profile by its ID
    """
    getProfile(id: ID!): Profile!
    """
    Retrieves a single project by its ID
    """
    getProject(id: ID!): Project!
    """
    Retrieves activity history for a project tagged in chat
    """
    getProjectChatActivityReport(limit: Int = null, uuid: ID!): [Audit!]
    """
    Retrieves a project report by its ID
    """
    getProjectReport(id: ID!): String
    """
    Retrieves activity history for a specific task in a project report
    """
    getProjectTaskActivityReport(
      limit: Int = null
      taskId: ID!
      uuid: ID!
    ): [Audit!]
    """
    Retrieves detailed information about a specific task in a project report
    """
    getProjectTaskReport(taskId: ID!, uuid: ID!): ProjectTasksReport
    """
    Retrieves public information for a project by its ID (safe for non-members)
    """
    getPublicProject(id: ID!, token: String): ProjectOrPublicProject!
    """
    Retrieves public information for a task by its ID (safe for non-members)
    """
    getPublicTask(id: ID!): TaskOrPublicTask!
    """
    Retrieves public information for a team by its ID (safe for non-members)
    """
    getPublicTeam(id: ID!, includePending: Boolean = false): TeamOrPublicTeam!
    """
    Returns the Rate Us state for the current user, with zero defaults for first-time users.
    """
    getRateUsState: RateUsState!
    """
    Retrieves a single task by its ID
    """
    getTask(id: ID!): Task!
    """
    Retrieves a team by its ID
    """
    getTeam(id: ID!, includePending: Boolean = false): Team!
    """
    Return global activity search results. When term is blank, all accessible
    activities are returned (filter-only mode). When term is present, full-text
    search is applied.
    """
    globalActivitySearch(
      """
      Filter by end date
      """
      endDate: ISO8601DateTime
      from: Int = 0
      """
      Filter by one or more project IDs
      """
      projectIds: [ID!]
      size: Int = 25
      """
      Filter by start date
      """
      startDate: ISO8601DateTime
      """
      Filter by one or more team IDs
      """
      teamIds: [ID!]
      """
      Full-text search term. When blank or omitted, all activities are returned.
      """
      term: String
      """
      Filter by one or more user IDs
      """
      userIds: [ID!]
    ): [Search!]!
    """
    Retrieves details about an invitation including validity and team ID
    """
    invitationDetails(
      entityId: String
      token: String!
      type: Invitation!
    ): InvitationValidity!
    """
    Whether an invitation is valid or not
    """
    invitationValid(token: String!, type: Invitation!): Boolean!
    """
    Retrieves activity items across all projects the user has access to
    """
    listActivities(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Filter by end date
      """
      endDate: ISO8601DateTime
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
      """
      Filter by one or more project IDs
      """
      projectIds: [ID!]
      """
      Which Activity tab to return. Defaults to ALL_ACTIVITIES.
      """
      scope: ActivityScope = ALL_ACTIVITIES
      """
      Filter by start date
      """
      startDate: ISO8601DateTime
      """
      Filter by one or more team IDs
      """
      teamIds: [ID!]
      """
      Filter by one or more user IDs
      """
      userIds: [ID!]
    ): ActivityFeedConnection
    """
    Retrieves a list of activities for a specific project
    """
    listActivitiesByProject(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Filter by end date
      """
      endDate: ISO8601DateTime
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
      projectId: ID!
      """
      Which Activity tab to return. Defaults to ALL_ACTIVITIES.
      """
      scope: ActivityScope = ALL_ACTIVITIES
      """
      Filter by start date
      """
      startDate: ISO8601DateTime
      """
      Full-text search term. When blank or omitted, all activities are returned.
      """
      term: String
      """
      Filter by one or more user IDs
      """
      userIds: [ID!]
    ): AuditConnection
    """
    Retrieves a list of activities for a specific task
    """
    listActivitiesByTask(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Filter by end date
      """
      endDate: ISO8601DateTime
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
      """
      Which Activity tab to return. Defaults to ALL_ACTIVITIES.
      """
      scope: ActivityScope = ALL_ACTIVITIES
      """
      Filter by start date
      """
      startDate: ISO8601DateTime
      taskId: ID!
      """
      Full-text search term. When blank or omitted, all activities are returned.
      """
      term: String
      """
      Filter by one or more user IDs
      """
      userIds: [ID!]
    ): AuditConnection
    """
    Retrieves all users blocked by the current user
    """
    listBlockedUsers: [User!]!
    """
    Retrieves all projects and their related tasks tagged in a chat
    """
    listChatRelatedProjects(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      chatId: ID
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
      sortBy: ProjectSortOption = ID_ASC
    ): ChatProjectTaskConnection
    """
    Retrieves chats the user participates in or has a pending request for
    """
    listChatsPagination(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      archivesOnly: Boolean = false
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
    ): ChatConnection!
    """
    List available project checklist templates
    """
    listChecklistTemplates: [ChecklistTemplate!]!
    """
    Retrieves all contacts associated with the current user
    """
    listContactUsers(term: String = ""): [User!]!
    """
    Retrieves all deleted message IDs for a specific chat
    """
    listDeletedMessageIds(chatId: ID): [ID!]!
    """
    Return a list of draft Documents for a chat
    """
    listDraftDocuments(chatId: ID!): [Document!]!
    """
    Retrieves all draft messages for a specific chat
    """
    listDraftMessages: [Message!]!
    """
    Return a list of draft Documents for a project
    """
    listDraftProjectDocuments(projectId: ID!): [Document!]!
    """
    Return a list of draft Documents for a task
    """
    listDraftTaskDocuments(taskId: ID!): [Document!]!
    """
    Retrieves all feature flag statuses for the current user
    """
    listFeatureFlags: [FeatureFlag!]!
    """
    Retrieves all contact groups accessible to the current user
    """
    listGroups: [Group!]
    """
    Retrieves all messages for a specific chat
    """
    listMessages(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      chatId: ID!
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      includeDraft: Boolean = false
      includePublished: Boolean = true
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
    ): MessageConnection
    """
    Retrieves My Tasks grouped by project, priority, or assignee (via \`groupBy\`,
    default project), ordered by most-recent group activity for project groups, or
    a fixed dimension order for priority/assignee groups. For assignee grouping
    the unassigned bucket (\`assignee: null\`) is always the first edge of the first
    page when it is non-empty, ahead of the named assignees (which stay ordered by
    display name); it is emitted exactly once and never reappears on a later page.
    Each group exposes its own independently paginated \`tasks\`/\`completedTasks\`
    connections (TA-10312/TA-10373). Note: priority grouping always returns all 3
    buckets in a single page, so \`first\` is ignored for that dimension.
    """
    listMyTasksProjectGroups(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      collaboratorsOnly: Boolean = false
      """
      Start day of the due date when filtering tasks
      """
      dueDateBegin: ISO8601DateTime
      """
      End day of the due date when filtering tasks
      """
      dueDateEnd: ISO8601DateTime
      dueGroup: TaskGroup
      excludeCompleted: Boolean = false
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      groupBy: TaskGroupBy = PROJECT
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
      memberIds: [ID!]
      phaseId: ID
      priority: [TaskPriority!]
      projectIds: [ID!]
      """
      When true (the default), only tasks with a due_date are returned.
      """
      requireDueDate: Boolean = true
      sortBy: TaskSortOption = ID_ASC
      status: TaskStatus
      taskCollaborators: Boolean = false
      teamIds: [ID!]
      userId: ID = null
      withoutPhase: Boolean = false
    ): TaskGroupInterfaceConnection!
    """
    Retrieves messages surrounding a specified message ID
    """
    listNearbyMessages(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
      messageId: ID!
      nearbyCount: Int = 30
    ): MessageConnection
    """
    Retrieves the pinned Needs a Decision rows for a specific project
    """
    listPendingDecisionsByProject(
      projectId: ID!
      """
      When true, returns every unresolved row instead of just the default oldest 3.
      """
      viewAll: Boolean = false
    ): PendingDecisionsResult!
    """
    Retrieves the pinned Needs a Decision rows for a specific task
    """
    listPendingDecisionsByTask(
      taskId: ID!
      """
      When true, returns every unresolved row instead of just the default oldest 3.
      """
      viewAll: Boolean = false
    ): PendingDecisionsResult!
    """
    Retrieves pending user requests for a specific requestable object
    """
    listPendingUserRequests(attributes: UserRequestAttributes!): [UserRequest!]!
    """
    Retrieves all phases ordered by name
    """
    listPhases: [Phase!]!
    """
    Retrieves all visible products
    """
    listProducts: [Product!]!
    """
    Retrieves checklists for a specific project by its ID
    """
    listProjectChecklist(uuid: ID!): [ProjectChecklist!]!
    """
    Retrieves all documents associated with specified projects
    """
    listProjectDocuments(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      includeFiles: Boolean = false
      includeMedia: Boolean = false
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
      ownerIds: [ID!] = null
      projectIds: [ID!] = null
      sortBy: DocumentSortOption = NAME_ASC
    ): DocumentConnection
    """
    Retrieves all media files associated with a project report
    """
    listProjectMedia(uuid: ID!): [Document!]
    """
    Retrieves all tasks associated with a project report
    """
    listProjectReportTasks(uuid: ID!): [ProjectTasksReport!]
    """
    Retrieves a list of projects based on specified filters
    """
    listProjects(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      archivesOnly: Boolean = false
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      filterTeamsProjects: Boolean = false
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
      locationOnly: Boolean = false
      memberIds: [ID!]
      ownerIds: [ID!]
      role: ProjectMemberRole
      sortBy: ProjectSortOption = ID_ASC
      teamIds: [ID!]
      userId: ID = null
    ): ProjectConnection
    """
    Retrieves nearest projects based on latitude and longitude coordinates
    """
    listProjectsByLocation(latitude: Float!, longitude: Float!): [Project!]!
    """
    Retrieves a list of projects scoped by team ID, with an optional filter for user roles.
    """
    listProjectsByTeam(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
      role: ProjectMemberRole = null
      teamId: ID!
    ): ProjectConnection
    """
    Retrieves all projects and their related tasks
    """
    listProjectsTasks(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      chatId: ID
      collaboratorsOnly: Boolean = false
      excludeCompleted: Boolean = false
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
      sortBy: ProjectSortOption = ACTIVITY_DESC
    ): ProjectTaskConnection
    """
    Retrieves all projects that have associated documents
    """
    listProjectsWithDocuments: [Project!]!
    """
    Retrieves all projects excluding those with specified roles
    """
    listProjectsWithoutSpecifiedRoles(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
      roles: [ProjectMemberRole!]!
      sortBy: ProjectSortOption = ID_ASC
    ): ProjectConnection
    """
    Retrieves recent projects and their related tasks tagged in a chat
    """
    listRecentProjectsTasks(
      chatId: ID!
      collaboratorsOnly: Boolean = false
      excludeCompleted: Boolean = false
    ): [RecentProjectTask!]!
    """
    Retrieves recently updated tasks with their associated projects
    """
    listRecentTasks(
      excludeCompleted: Boolean = false
      projectCollaborators: Boolean = false
      projectIds: [ID!]
      sortBy: TaskSortOption = ID_ASC
    ): [RecentTask!]!
    """
    Retrieves all skills ordered by name
    """
    listSkills: [Skill!]!
    """
    Retrieves all tag groups associated with the user
    """
    listTagGroups(limit: Int = 5): [TagGroup!]!
    """
    Retrieves checklists for a specific task by its ID
    """
    listTaskChecklist(id: ID!): [TaskChecklist!]!
    """
    Retrieves all documents associated with specified tasks
    """
    listTaskDocuments(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      includeFiles: Boolean = false
      includeMedia: Boolean = false
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
      ownerIds: [ID!] = null
      projectIds: [ID!] = null
      sortBy: DocumentSortOption = NAME_ASC
      taskIds: [ID!] = null
    ): DocumentConnection
    """
    Retrieves a list of tasks based on specified filters
    """
    listTasks(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      chatId: ID
      collaboratorsOnly: Boolean = false
      dueDate: ISO8601DateTime
      """
      Start day of the due date when filtering tasks
      """
      dueDateBegin: ISO8601DateTime
      """
      End day of the due date when filtering tasks
      """
      dueDateEnd: ISO8601DateTime
      dueGroup: TaskGroup
      excludeCompleted: Boolean = false
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
      memberIds: [ID!]
      phaseId: ID
      priority: [TaskPriority!]
      projectId: ID @deprecated(reason: "Use \`project_ids\` instead.")
      projectIds: [ID!]
      sortBy: TaskSortOption = ID_ASC
      startDate: ISO8601DateTime
      status: TaskStatus
      taskCollaborators: Boolean = false
      teamIds: [ID!]
      userId: ID = null
      withoutDueDate: Boolean = false
      withoutPhase: Boolean = false
    ): TaskConnection
    """
    Retrieves all teams the user is associated with
    """
    listTeams(
      includePending: Boolean = false
      role: ProjectMemberRole = null
    ): [Team!]!
    """
    Retrieves all unread messages for the current user and their chats
    """
    listUnreadMessages(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
    ): MessageConnection
    """
    Retrieves a list of users matching the search term, excluding contacts
    """
    listUsers(size: Int = 10, term: String!): [User!]!
    """
    Retrieves users associated with a specific team, optionally filtered by search term
    """
    listUsersByResource(teamId: ID!, term: String): [User!]!
    """
    Retrieves a list of users matching the search term, excluding current user and contacts
    """
    listUsersPagination(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
      term: String!
    ): UserConnection
    """
    Retrieves all documents with pagination support
    """
    newListDocuments(
      chatId: ID = null
      includeMedia: Boolean = false
      limit: Int = 10
      page: Int = 1
      sortBy: DocumentSortOption = NAME_ASC
      taskIds: [ID!] = null
    ): DocumentCollection!
    """
    Retrieves the cover page information for a project report
    """
    projectReportCoverPage(uuid: ID!): ReportCoverPage
    """
    Retrieves an overview of a project report
    """
    projectReportOverview(uuid: ID!): ProjectReportOverview
    """
    Return search results by term
    """
    search(
      archiveProjectsOnly: Boolean = false
      chatId: ID = null
      checkins: Boolean = false
      collaboratorsOnly: Boolean = false
      completedTasksOnly: Boolean = false
      documentGroup: DocumentGroup = null
      documentOwnerIds: [ID!] = null
      files: Boolean = false
      from: Int = 0
      includeActivities: Boolean = false
      includeChats: Boolean = true
      includeCompletedTask: Boolean = false
      includeContacts: Boolean = false
      includeDocuments: Boolean = true
      includeGroups: Boolean = false
      includeMessages: Boolean = true
      includeProjects: Boolean = true
      includeTasks: Boolean = true
      includeTasksTags: Boolean = false
      includeTeams: Boolean = false
      includeUsers: Boolean = false
      media: Boolean = false
      projectId: ID = null
      projectIds: [ID!] = null
      projectOwnerIds: [ID!] = null
      projectUserIds: [ID!] = null
      size: Int = 25
      tags: Boolean = false
      """
      Start of due date range. Only applies when task_due_group is blank
      """
      taskDueDateBegin: ISO8601DateTime = null
      """
      End of due date range. Only applies when task_due_group is blank
      """
      taskDueDateEnd: ISO8601DateTime = null
      taskDueGroup: TaskGroup = null
      taskId: ID = null
      taskPriority: [TaskPriority!] = null
      taskSort: TaskSearchSortOption = null
      taskUserIds: [ID!] = null
      teamIds: [ID!] = null
      term: String!
    ): [Search!]!
    """
    Searches chats the user participates in by chat name or participant name
    """
    searchChats(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
      term: String!
    ): ChatConnection!
    """
    Search and filter checklist templates
    """
    searchTemplates(term: String!): [ChecklistTemplate!]!
    """
    Retrieves documents publically associated with specified client IDs
    """
    sharedDocumentsByClientIds(clientIds: [ID!]): [Document!]
    """
    Retrieves media documents and sharer info for a media share link by token
    """
    sharedMediaByToken(token: String!): SharedMedia!
    """
    Retrieves team avatars with specified IDs
    """
    teamAvatarsByIds(ids: [ID!]): [File!]
    """
    Retrieves user avatars with specified IDs
    """
    userAvatarsByIds(ids: [ID!]): [File!]
    """
    Validates if a given content type is supported by the system
    """
    validateContentType(contentType: String!): Boolean!
  }
  """
  Persisted Rate Us state for the current user
  """
  type RateUsState {
    hasRated: Boolean!
    permanentlySuppressed: Boolean!
    triggers: RateUsTriggerMap!
  }
  """
  Partial update for a single Rate Us trigger. Omit any field to leave it unchanged.
  """
  input RateUsTriggerInput {
    count: Int
    lastPromptAt: ISO8601DateTime
    promptStage: Int
  }
  """
  Rate Us per-trigger state for all 6 tracked triggers
  """
  type RateUsTriggerMap {
    assignTasks: RateUsTriggerState!
    chatTags: RateUsTriggerState!
    checkin: RateUsTriggerState!
    checklist: RateUsTriggerState!
    tasks: RateUsTriggerState!
    uploadMedia: RateUsTriggerState!
  }
  """
  Partial update for Rate Us triggers. Omit any trigger to leave it unchanged.
  """
  input RateUsTriggerMapInput {
    assignTasks: RateUsTriggerInput
    chatTags: RateUsTriggerInput
    checkin: RateUsTriggerInput
    checklist: RateUsTriggerInput
    tasks: RateUsTriggerInput
    uploadMedia: RateUsTriggerInput
  }
  """
  Per-trigger Rate Us state — cumulative count, prompt ladder stage, and last prompt time
  """
  type RateUsTriggerState {
    count: Int!
    lastPromptAt: ISO8601DateTime
    promptStage: Int!
  }
  """
  Attributes for updating read receipts for active log
  """
  input ReadReceiptAuditAttributes {
    auditIds: [ID!]
  }
  """
  Attributes for updating read receipts for chat messages
  """
  input ReadReceiptChatAttributes {
    chatIds: [ID!]
  }
  union RecentProjectTask = Project | Task
  """
  Recent task type representing a recently accessed task in the system
  """
  type RecentTask implements Node {
    archivedAt: ISO8601DateTime
    authorId: ID!
    checklists: [TaskChecklist!]
    completedAt: ISO8601DateTime
    completor: User
    createdAt: ISO8601DateTime!
    creator: User!
    deletedAt: ISO8601DateTime
    dependencies: [Task!]
    description: String
    dueDate: ISO8601DateTime
    id: ID!
    members: [TaskMember!]!
    name: String!
    priority: TaskPriority
    project: Project!
    projectId: ID!
    startDate: ISO8601DateTime
    userIds: [ID!]!
  }
  input ReplyMessageInput {
    cacheIdentifier: String!
    id: ID!
  }
  """
  Report cover page type representing a cover page in the system
  """
  type ReportCoverPage {
    createdAt: ISO8601DateTime!
    generatedBy: String!
    projectName: String
    team: Team
    title: String
  }
  """
  Attributes for saving a project checklist as a template
  """
  input SaveChecklistAsTemplateAttributes {
    checklistItemIds: [ID!]!
    templateId: ID
  }
  """
  Search type representing search results in the system
  """
  type Search {
    highlight: Highlight
    record: SearchableResult!
    total: Int!
  }
  union SearchableResult =
    | Audit
    | Chat
    | Document
    | Group
    | Message
    | Project
    | Task
    | Team
    | User
  """
  Minimal document fields safe to expose via an unauthenticated media share link token
  """
  type SharedDocument {
    clientId: String!
    file: File!
    id: ID!
    name: String!
  }
  """
  Media documents and sharer info resolved from a media share link token
  """
  type SharedMedia {
    documents: [SharedDocument!]!
    sharerAvatar: File
    sharerName: String
  }
  """
  Skill type representing a skill in the system
  """
  type Skill {
    createdAt: ISO8601DateTime!
    id: ID!
    name: String!
  }
  """
  Attributes for creating a Stripe customer and subscription
  """
  input StripeSubscriptionAttributes {
    name: String!
    priceId: String!
    quantity: Int
    teamId: ID
  }
  type Subscription {
    """
    Subscribe to bulk export documents request results
    """
    bulkExportDocumentsResult: BulkExportDocument
    """
    Subscribe to chat updates
    """
    chatUpdate: ChatUpdate
    """
    Subscribe to personal updates
    """
    meUpdated: MeUpdatedPayload!
    """
    Subscribe to message is deleted by author
    """
    messageDelete(chatId: ID!): Message
    """
    Subscribe to message updates by chat ID
    """
    messageUpdate(chatId: ID!): Message
    """
    Subscribe to project deletion notifications
    """
    projectDeleted: ProjectDeletedPayload!
    """
    Subscribe to project updates
    """
    projectUpdated: Project
    """
    Subscribe to task files duplication results
    """
    taskFilesDuplicated: TaskFilesDuplicatedPayload!
    """
    Subscribe to task updates by task ID
    """
    taskUpdated(taskId: ID!): Task
  }
  """
  Subscription details type representing subscription information in the system
  """
  type SubscriptionDetails {
    canceledAt: ISO8601DateTime
    createdAt: ISO8601DateTime
    currentPeriodEnd: ISO8601DateTime
      @deprecated(
        reason: "This field is deprecated, use \`expiration_date\` instead."
      )
    currentPeriodStart: ISO8601DateTime
    currentSeatCount: Int
    expirationDate: ISO8601DateTime
    isSubscriptionActive: Boolean!
    isSubscriptionCanceled: Boolean!
    isSubscriptionOnTrial: Boolean!
    paymentCardBrand: String
    paymentCardExpMonth: String
    paymentCardExpYear: String
    paymentCardLast4: String
    pricePerSeat: String
    stripeCustomerId: String
    stripePaymentId: String
    stripePriceId: String
    stripeProductId: String
    stripeSubscriptionId: String
    subscriptionInterval: String
    subscriptionPlanName: String
    subscriptionStatus: String
    trialEndsAt: ISO8601DateTime
    updatedAt: ISO8601DateTime
  }
  """
  Tag group type representing a group of tags in the system
  """
  type TagGroup {
    author: User!
    createdAt: ISO8601DateTime!
    documents: [Document!]
    id: ID!
    isImageGroup: Boolean!
    message: Message
    project: Project!
    task: Task
    updatedAt: ISO8601DateTime!
  }
  """
  Task type representing a task in the system
  """
  type Task implements Node {
    archivedAt: ISO8601DateTime
    audits: [Audit!]
    auditsCount: Int
    authorId: ID!
    chatTasksCount: Int!
    checklists: [TaskChecklist!]
    completedAt: ISO8601DateTime
    completor: User
    createdAt: ISO8601DateTime!
    creator: User!
    currentUserProjectRole: ProjectMemberRole
    currentUserProjectTeamRole: TeamMemberRole
    currentUserRole: TaskMemberRole
    deletedAt: ISO8601DateTime
    dependencies: [Task!]
    description: String
    documents: [Document!]
    dueDate: ISO8601DateTime
    dueGroup: String
    fixedOrder: Boolean
    frequency: TaskFrequency
    id: ID!
    invitations: [TaskInvitation!]
    members: [TaskMember!]!
    name: String!
    phase: Phase
    phaseId: ID
    priority: TaskPriority
    project: Project!
    projectColor: String
    projectIcon: String
    projectId: ID!
    projectName: String
    projectUuid: ID
    recurring: Boolean
    requiresCompletionPhoto: Boolean
    skillIds: [ID!]
    skills: [Skill!]
    startDate: ISO8601DateTime
    status: TaskStatus
    unreadAudits: [Audit!]
    unreadAuditsCount: Int
    userIds: [ID!]!
    userRequests: [UserRequest!]
  }
  """
  Attributes for creating or updating a task
  """
  input TaskAttributes {
    checklists: [TaskChecklistAttributes!]
    completedAt: ISO8601DateTime
    completedById: ID
    dependencyIds: [ID!]
    description: String
    dueDate: ISO8601DateTime
    files: [DocumentAttributes!]
    fixedOrder: Boolean
    frequency: TaskFrequency
    members: [TaskMemberAttributes!]
    name: String!
    phaseId: ID
    priority: TaskPriority
    projectId: ID!
    recurring: Boolean
    requiresCompletionPhoto: Boolean
    skillIds: [ID!]
    startDate: ISO8601DateTime
    status: TaskStatus
    taskMembers: [TaskMemberRoleAttributes!]
    userIds: [ID!]
  }
  """
  Task checklist type representing a checklist item in a task
  """
  type TaskChecklist {
    completedAt: ISO8601DateTime
    createdAt: ISO8601DateTime!
    id: ID!
    name: String!
    sort: Int
    taskId: ID!
  }
  """
  Attributes for assigning task membership to a user
  """
  input TaskChecklistAttributes {
    completed: Boolean = false
    id: ID = 0
    name: String = ""
    sort: Int = 0
  }
  """
  The connection type for Task.
  """
  type TaskConnection {
    """
    A list of edges.
    """
    edges: [TaskEdge]
    """
    A list of nodes.
    """
    nodes: [Task]
    """
    Information to aid in pagination.
    """
    pageInfo: PageInfo!
  }
  """
  Task document type representing a document attached to a task in the system
  """
  type TaskDocument {
    document: Document
    id: ID!
    owner: User
    task: Task
  }
  """
  An edge in a connection.
  """
  type TaskEdge {
    """
    A cursor for use in pagination.
    """
    cursor: String!
    """
    The item at the end of the edge.
    """
    node: Task
  }
  """
  Autogenerated return type of TaskFilesDuplicated.
  """
  type TaskFilesDuplicatedPayload {
    error: String
    success: Boolean!
    task: Task
  }
  enum TaskFrequency {
    DAILY
    MONTHLY
    WEEKLY
  }
  enum TaskGroup {
    CURRENT
    OVERDUE
    TODAY
    UPCOMING
  }
  enum TaskGroupBy {
    ASSIGNEE
    PRIORITY
    PROJECT
  }
  """
  A group of the current My Tasks scope, grouped by project, priority, or assignee
  """
  interface TaskGroupInterface {
    completedCount: Int!
    completedTasks(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
    ): TaskConnection!
    taskCount: Int!
    tasks(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
    ): TaskConnection!
  }
  """
  The connection type for TaskGroupInterface.
  """
  type TaskGroupInterfaceConnection {
    """
    A list of edges.
    """
    edges: [TaskGroupInterfaceEdge]
    """
    A list of nodes.
    """
    nodes: [TaskGroupInterface]
    """
    Information to aid in pagination.
    """
    pageInfo: PageInfo!
    """
    Number of groups matching the same filters across all pages, independent of \`first\`/\`after\` (TA-11028).
    """
    totalCount: Int!
  }
  """
  An edge in a connection.
  """
  type TaskGroupInterfaceEdge {
    """
    A cursor for use in pagination.
    """
    cursor: String!
    """
    The item at the end of the edge.
    """
    node: TaskGroupInterface
  }
  """
  Task invitation type representing a task invitation
  """
  type TaskInvitation {
    createdAt: ISO8601DateTime!
    email: String!
    expiredAt: ISO8601DateTime
    id: ID!
    invitedBy: User
    role: TaskMemberRole!
  }
  """
  Task member type representing a member of a task in the system
  """
  type TaskMember {
    id: ID!
    role: TaskMemberRole!
    subject: Task!
    user: User!
  }
  """
  Attributes for assigning task membership to a user
  """
  input TaskMemberAttributes {
    role: TaskMemberRole!
    userId: ID!
  }
  enum TaskMemberRole {
    ASSIGNEE
    OWNER
    VIEWER
  }
  """
  Attributes for invite a user to be a member when create a task
  """
  input TaskMemberRoleAttributes {
    email: String!
    role: TaskMemberRole!
  }
  """
  Returns TaskType if current user is a member, otherwise PublicTaskType
  """
  union TaskOrPublicTask = PublicTask | Task
  enum TaskPriority {
    HIGH
    LOW
    MEDIUM
  }
  enum TaskSearchSortOption {
    CREATED_AT_ASC
    CREATED_AT_DESC
    DUE_DATE_ASC
    DUE_DATE_DESC
    PRIORITY_ASC
    PRIORITY_DESC
    UPDATED_AT_ASC
    UPDATED_AT_DESC
  }
  """
  The section a task belongs to in the My Tasks view
  """
  enum TaskSection {
    """
    Tasks that have been marked as completed
    """
    COMPLETED
    """
    Tasks that are currently active and not overdue
    """
    CURRENT
    """
    Tasks whose due date has passed
    """
    OVERDUE
  }
  enum TaskSortOption {
    CREATED_AT_ASC
    CREATED_AT_DESC
    DUE_DATE
    DUE_DATE_ASC
    DUE_DATE_DESC
    ID_ASC
    ID_DESC
    NAME_ASC
    NAME_DESC
    """
    Sort by due_date ascending (earliest/most-overdue first), then priority descending, then id ascending
    """
    OVERDUE_LOW
    PRIORITY_ASC
    PRIORITY_DESC
    PROJECT_NAME_ASC
    PROJECT_NAME_DESC
    """
    Sort by user-defined rank within a My Tasks section
    """
    RANK
    UPDATED_AT_ASC
    UPDATED_AT_DESC
  }
  enum TaskStatus {
    COMPLETED
    DELETED
    NOT_STARTED
    ONGOING
    ON_HOLD
    OVERDUE
  }
  type TaskTag {
    id: ID!
    name: String!
    project: ProjectTag
    projectId: ID!
    status: TaskStatus
    userIds: [ID!]!
  }
  type TaskTagCollection {
    author: User!
    project: ProjectTag!
    tasks: [TaskTag]!
  }
  input TaskTagCollectionInput {
    author: TaskTagUserInput!
    project: ProjectTagInput!
    tasks: [TaskTagInput]!
  }
  input TaskTagInput {
    id: ID!
    name: String!
    project: ProjectTagInput
    projectId: ID!
    status: TaskStatus
    userIds: [ID!]!
  }
  input TaskTagUserInput {
    id: ID!
    name: String!
  }
  """
  Task user type representing a user assigned to a task in the system
  """
  type TaskUser {
    id: ID!
    task: Task!
    user: User
  }
  """
  Team type representing a team in the system
  """
  type Team {
    address: String
    avatar: String
      @deprecated(reason: "Please use avatarFile to retrieve Team avatars")
    avatarFile: File
    billingSource: String
    completedTasksCount: Int!
    createdAt: ISO8601DateTime!
    currentUserRole: TeamRole
    entitlementExpiration: ISO8601DateTime
    fileStorageUsed: BigInt!
    guestsOnly: Boolean!
    hasPendingMemberAdditionRequest: Boolean!
    hasProjects: Boolean!
    hasReachedMaxProjects: Boolean!
    highPriorityCompletionRate: Float
    id: ID!
    initials: String!
    invitations: [TeamInvitation!]
    invoices: [Invoice!]
    latitude: Float
    longitude: Float
    maxDocumentStorage: BigInt!
    maxNumberOfProjects: Int!
    mediaStorageUsed: BigInt!
    memberPreviews: [TeamMember!]!
    """
    Paginated full member list for a single team detail view. Not batched — do not
    nest inside listTeams or another multi-team list.
    """
    membersConnection(
      """
      Returns the elements in the list that come after the specified cursor.
      """
      after: String
      """
      Returns the elements in the list that come before the specified cursor.
      """
      before: String
      """
      Returns the first _n_ elements from the list.
      """
      first: Int
      """
      Returns the last _n_ elements from the list.
      """
      last: Int
    ): TeamMembershipConnection!
    name: String!
    numberOfProjectsUsed: Int!
    onTimeDeliveryRate: Float
    owner: User!
    pending: Boolean!
    personal: Boolean!
    plan: Plan @deprecated(reason: "Use SubscriptionDetailsType.")
    product: Product
    projectPreviews: [Project!]!
    projects: [Project!]!
      @deprecated(
        reason: "Use projectPreviews for list-view previews or the root query field \`listProjectsByTeam\` for paginated project retrieval."
      )
    skills: [Skill!]!
    storageRemaining: BigInt!
    stripeCustomerId: String
    subscriptionDetails: SubscriptionDetails
    tasksCount: Int!
    teamSubscriptionStatus: String
    userRequests: [UserRequest!]
    users: [User!]!
      @deprecated(
        reason: "Use memberPreviews for list-view avatar stacks or membersConnection for paginated full member retrieval."
      )
    usersCount: Int!
    uuid: ID!
  }
  """
  Attributes for creating or updating a team
  """
  input TeamAttributes {
    address: String
    avatarBlobId: ID
    emails: [String!]
    latitude: Float
    longitude: Float
    members: [MemberAttributes!]
    name: String!
    skillIds: [ID!]
    teamMembers: [TeamMemberRoleAttributes!]
  }
  """
  Team invitation type representing a team invitation
  """
  type TeamInvitation {
    createdAt: ISO8601DateTime!
    email: String
    expiredAt: ISO8601DateTime
    id: ID!
    invitedBy: User
    role: TeamRole
    user: User
  }
  """
  Team member type representing a member in a team
  """
  type TeamMember {
    id: ID!
    role: TeamMemberRole!
    team: Team!
    user: User!
  }
  enum TeamMemberRole {
    ADMIN
    MEMBER
    OWNER
  }
  """
  Attributes for inviting a user to be a member of a team
  """
  input TeamMemberRoleAttributes {
    email: String!
    role: TeamMemberRole!
  }
  """
  Paginated team membership record (see membersConnection on TeamType)
  """
  type TeamMembership {
    id: ID!
    role: TeamMemberRole!
    team: Team!
    user: User!
  }
  """
  The connection type for TeamMembership.
  """
  type TeamMembershipConnection {
    """
    A list of edges.
    """
    edges: [TeamMembershipEdge]
    """
    A list of nodes.
    """
    nodes: [TeamMembership]
    """
    Information to aid in pagination.
    """
    pageInfo: PageInfo!
  }
  """
  An edge in a connection.
  """
  type TeamMembershipEdge {
    """
    A cursor for use in pagination.
    """
    cursor: String!
    """
    The item at the end of the edge.
    """
    node: TeamMembership
  }
  """
  Returns TeamType if current user is a member, otherwise PublicTeamType
  """
  union TeamOrPublicTeam = PublicTeam | Team
  enum TeamRole {
    ADMIN
    MEMBER
    OWNER
  }
  enum TutoralizationSetting {
    ASSIGN_TASK
    CHAT
    HASHTAG
    PROJECT
    TAG_MESSAGE
    TASK
    TEAM
  }
  """
  Attributes for updating tutoralization setting
  """
  input TutoralizationSettingAttributes {
    close: Boolean!
    settingType: TutoralizationSetting!
  }
  """
  Attributes for updating a project checklist item
  """
  input UpdateProjectChecklistAttributes {
    completed: Boolean
    name: String
    sort: Int
  }
  """
  Partial update for Rate Us state. Booleans are forward-only (true wins).
  """
  input UpdateRateUsStateAttributes {
    hasRated: Boolean
    permanentlySuppressed: Boolean
    triggers: RateUsTriggerMapInput
  }
  """
  Attributes for uploading user contacts
  """
  input UploadContactAttributes {
    phoneNumbers: [String!]
  }
  """
  User type representing a user in the system
  """
  type User {
    address: String
    avatar: File
    avatarId: ID
    avatarIsPreviewable: Boolean
    calendarUrl: String
    completedWebTutorialFlows: [String!]
    contactsCount: Int!
    contactsSyncedAt: ISO8601DateTime
    createdAt: ISO8601DateTime!
    email: String!
    firstName: String
    friendRequestPending: Boolean
    hasSeenTagTooltipNative: Boolean!
    hasSeenTagTooltipWeb: Boolean!
    """
    True if any qualifying activity audit (per globalActivitySearch scope) was
    created after the current user's last activity view. Only resolves for the
    current user; false for any other user.
    """
    hasUnreadActivity: Boolean!
    id: ID!
    inviteUrl: String!
    lastActiveDatetime: ISO8601DateTime
    lastName: String
    latitude: Float
    longitude: Float
    name: String
    notificationSetting: [UserNotificationSetting!]
    onboardingComplete: Boolean!
    onboardingFlow: OnboardingFlow!
    onboardingProgresses: [OnboardingProgress!]!
    onboardingState: OnboardingState!
    ownedProjectsCount: Int
    ownedTasksCount: Int
    personalProjectsCount: Int!
    phoneNumber: String!
    primaryTeamId: ID
    provider: String
    skills: [Skill!]
    teamRoles: [TeamRole!]
    teams: [Team!]
    timeZone: String
    tutoralizationSetting: [UserTutoralizationSetting!]
    uid: String
    unviewedProjectAssignments: [Project!]!
  }
  """
  Attributes for creating or updating a user
  """
  input UserAttributes {
    address: String
    avatarBlobId: ID
    latitude: Float
    longitude: Float
    name: String!
    phoneNumber: String!
    skillIds: [ID!]!
    timeZone: String
  }
  """
  User chat setting type representing chat settings for a user in the system
  """
  type UserChatSetting {
    archivedAt: ISO8601DateTime
    id: ID!
    mute: Boolean!
    pin: Boolean!
  }
  """
  The connection type for User.
  """
  type UserConnection {
    """
    A list of edges.
    """
    edges: [UserEdge]
    """
    A list of nodes.
    """
    nodes: [User]
    """
    Information to aid in pagination.
    """
    pageInfo: PageInfo!
  }
  """
  An edge in a connection.
  """
  type UserEdge {
    """
    A cursor for use in pagination.
    """
    cursor: String!
    """
    The item at the end of the edge.
    """
    node: User
  }
  """
  User notification setting type representing notification settings for a user in the system
  """
  type UserNotificationSetting {
    duration: NotificationSettingDuration
    mute: Boolean!
    settingType: NotificationSetting!
  }
  """
  User project setting type representing project settings for a user in the system
  """
  type UserProjectSetting {
    id: ID!
    pin: Boolean!
  }
  """
  User request type representing a user request in the system
  """
  type UserRequest {
    canBeReviewed: Boolean!
    canCurrentUserDecide: Boolean!
    createdAt: ISO8601DateTime!
    expiredAt: ISO8601DateTime
    id: ID!
    invitedBy: User
    requestType: UserRequestCategory!
    reviewedBy: User
    role: String
    status: String!
    user: User
    userRequestableId: ID!
    userRequestableType: UserRequestable!
  }
  """
  Attributes for creating user requests
  """
  input UserRequestAttributes {
    requestType: UserRequestCategory!
    userRequestableId: ID!
    userRequestableType: UserRequestable!
  }
  enum UserRequestCategory {
    MEMBER_ADDITION
    TEAM_REACTIVATION
  }
  enum UserRequestable {
    ACCOUNT
    CHAT
    PROJECT
    TASK
  }
  """
  User task order type representing the order of tasks for a user
  """
  type UserTaskOrder {
    id: ID!
    position: Int!
    rank: BigInt
    section: TaskSection
    taskId: ID!
  }
  """
  Tutoralization setting type
  """
  type UserTutoralizationSetting {
    close: Boolean!
    settingType: TutoralizationSetting!
  }
  enum WebTutorialFlow {
    CHAT
    EXPAND_COLLAPSE
    INVITE_MEMBER
    PROJECT_CREATION
    TAG_ON_CHAT_PANEL_CLOSED
    TAG_ON_CHAT_PANEL_OPEN
    TASK_CREATION
  }
`;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: any; output: any };
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any };
  /** Represents untyped JSON */
  JSON: { input: any; output: any };
};

/** Result of an existing user opening a generic Contacts / Invite Friends link */
export type AcceptUserInvitePayload = {
  __typename?: 'AcceptUserInvitePayload';
  /** DM chat with the inviter; null for self / invalid */
  chat?: Maybe<Chat>;
  inviter?: Maybe<PublicUser>;
  /** request_sent | already_friends | self | invalid */
  status: Scalars['String']['output'];
};

/** The connection type for Audit. */
export type ActivityFeedConnection = {
  __typename?: 'ActivityFeedConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AuditEdge>>>;
  isPaywalled: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Audit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalEventCount: Scalars['Int']['output'];
  upgradeTeam?: Maybe<Team>;
};

export enum ActivityScope {
  /** Every activity the viewer has access to. */
  AllActivities = 'ALL_ACTIVITIES',
  /** Only activities where the viewer is the target of another person's action. */
  ForYou = 'FOR_YOU',
}

export enum ActivitySignificance {
  /**
   * Awaiting a decision. Never clears from being viewed, scrolled past or tapped
   * -- only from Approve/Decline, Accept/Decline or Snooze.
   */
  ActionRequired = 'ACTION_REQUIRED',
  /** FYI. Clears its unread state once the viewer has actually seen it. */
  Lowbar = 'LOWBAR',
}

/** Attributes for adding a new project checklist item */
export type AddProjectChecklistAttributes = {
  name: Scalars['String']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type AppVersions = {
  __typename?: 'AppVersions';
  currentAndroidBuild: Scalars['String']['output'];
  currentIosBuild: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** An assignee (or the unassigned bucket, when assignee is null) and the subset of the current My Tasks scope assigned to them */
export type AssigneeTaskGroup = TaskGroupInterface & {
  __typename?: 'AssigneeTaskGroup';
  assignee?: Maybe<User>;
  completedCount: Scalars['Int']['output'];
  completedTasks: TaskConnection;
  taskCount: Scalars['Int']['output'];
  tasks: TaskConnection;
};

/** An assignee (or the unassigned bucket, when assignee is null) and the subset of the current My Tasks scope assigned to them */
export type AssigneeTaskGroupCompletedTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An assignee (or the unassigned bucket, when assignee is null) and the subset of the current My Tasks scope assigned to them */
export type AssigneeTaskGroupTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Attachable objects such as Projects, Tasks, and Check-ins */
export type Attachment =
  | Document
  | EntityUser
  | Folder
  | LocalFile
  | Message
  | MessageProject
  | MessageTask
  | MessageTaskAssignment
  | MessageTaskComplete
  | Project
  | ProjectUser
  | PublicTeam
  | Task
  | TaskUser
  | UserRequest;

/** Audit type representing an audit record in the system */
export type Audit = {
  __typename?: 'Audit';
  attachment?: Maybe<Attachment>;
  changes?: Maybe<Scalars['JSON']['output']>;
  checkinStatus?: Maybe<Scalars['String']['output']>;
  completionNote?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  documents: Array<Document>;
  event: Scalars['String']['output'];
  fieldEditSummary?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  projectRole?: Maybe<ProjectMemberRole>;
  significance: ActivitySignificance;
  taskRole?: Maybe<TaskMemberRole>;
  user?: Maybe<User>;
  userRequestSummary?: Maybe<Scalars['String']['output']>;
};

/** The connection type for Audit. */
export type AuditConnection = {
  __typename?: 'AuditConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AuditEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Audit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AuditEdge = {
  __typename?: 'AuditEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Audit>;
};

export type BulkExportDocument = {
  __typename?: 'BulkExportDocument';
  error?: Maybe<Scalars['String']['output']>;
  resourceId: Scalars['ID']['output'];
  resourceType: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** Chat type representing a chat in the system */
export type Chat = {
  __typename?: 'Chat';
  audits?: Maybe<Array<Audit>>;
  avatar?: Maybe<File>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  canCurrentUserDecide: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  friendRequestAccepted?: Maybe<Scalars['Boolean']['output']>;
  groupChat: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inviteStatuses: Array<ChatInviteStatus>;
  isGroupChat: Scalars['Boolean']['output'];
  isNewChat?: Maybe<Scalars['Boolean']['output']>;
  isPendingRequest: Scalars['Boolean']['output'];
  isUserBlocked?: Maybe<Scalars['Boolean']['output']>;
  leaveOn?: Maybe<Scalars['ISO8601DateTime']['output']>;
  messageBody?: Maybe<Scalars['String']['output']>;
  messageIcon?: Maybe<Scalars['String']['output']>;
  messagePublishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  messagesCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  owner: User;
  ownerId: Scalars['ID']['output'];
  ownerName: Scalars['String']['output'];
  pendingInvitations: Array<ChatInvitation>;
  recentActivityAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  settings?: Maybe<UserChatSetting>;
  settingsArchivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  settingsMute?: Maybe<Scalars['Boolean']['output']>;
  settingsPin?: Maybe<Scalars['Boolean']['output']>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
  userIds: Array<Scalars['ID']['output']>;
  userRequests: Array<UserRequest>;
  users: Array<User>;
};

/** Attributes for creating or updating a chat */
export type ChatAttributes = {
  avatarBlobId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Email addresses to invite (for unregistered users) */
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  groupChat?: InputMaybe<Scalars['Boolean']['input']>;
  mute?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The connection type for Chat. */
export type ChatConnection = {
  __typename?: 'ChatConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ChatEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Chat>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ChatEdge = {
  __typename?: 'ChatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Chat>;
};

/** Chat invitation type representing a chat invitation */
export type ChatInvitation = {
  __typename?: 'ChatInvitation';
  chat: Chat;
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  expiredAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  invitedBy?: Maybe<User>;
  role?: Maybe<Scalars['JSON']['output']>;
  /** Status of the invitation (pending, expired, email_not_registered) */
  status: Scalars['String']['output'];
};

export enum ChatInviteSourceEnum {
  EmailInvite = 'EMAIL_INVITE',
  UserRequest = 'USER_REQUEST',
}

/** Unified invite status across email-based and registered-user invites for a chat */
export type ChatInviteStatus = {
  __typename?: 'ChatInviteStatus';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitedBy?: Maybe<User>;
  source: ChatInviteSourceEnum;
  status: ChatInviteStatusEnum;
  user?: Maybe<User>;
};

export enum ChatInviteStatusEnum {
  Approved = 'APPROVED',
  EmailNotRegistered = 'EMAIL_NOT_REGISTERED',
  Expired = 'EXPIRED',
  Joined = 'JOINED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

/** Chat project task type representing a task in a chat project */
export type ChatProjectTask = {
  __typename?: 'ChatProjectTask';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  currentUserRole: ProjectMemberRole;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tasks?: Maybe<Array<Task>>;
};

/** The connection type for ChatProjectTask. */
export type ChatProjectTaskConnection = {
  __typename?: 'ChatProjectTaskConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ChatProjectTaskEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ChatProjectTask>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ChatProjectTaskEdge = {
  __typename?: 'ChatProjectTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ChatProjectTask>;
};

/** Chat update type representing chat update information for subscriptions */
export type ChatUpdate = {
  __typename?: 'ChatUpdate';
  id: Scalars['ID']['output'];
  messageBody?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recentActivityAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

/** Checklist category type */
export type ChecklistCategory = {
  __typename?: 'ChecklistCategory';
  categoryName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** Project checklist template type */
export type ChecklistTemplate = {
  __typename?: 'ChecklistTemplate';
  checklistCategory: ChecklistCategory;
  checklistTemplateItems: Array<ChecklistTemplateItem>;
  favoritedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  isFavorited: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  owner: User;
  templateName: Scalars['String']['output'];
};

/** Checklist template item type representing an individual item in a template */
export type ChecklistTemplateItem = {
  __typename?: 'ChecklistTemplateItem';
  checklistTemplateItemName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** Type for CollectionMetadataType */
export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  /** Current Page of loaded data */
  currentPage: Scalars['Int']['output'];
  /** The number of items per page */
  limitValue: Scalars['Int']['output'];
  /** The total number of items to be paginated */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages in the pagination */
  totalPages: Scalars['Int']['output'];
};

/** Attributes for get contact invitation url */
export type CreateContactInvitationUrlAttributes = {
  phoneNumber: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateMediaShareLink. */
export type CreateMediaShareLinkPayload = {
  __typename?: 'CreateMediaShareLinkPayload';
  token: Scalars['String']['output'];
};

/** Autogenerated return type of CreateShareLink. */
export type CreateShareLinkPayload = {
  __typename?: 'CreateShareLinkPayload';
  sharedUrl?: Maybe<Scalars['String']['output']>;
};

/** Payload returned after deleting a message document. Contains only the identifiers needed to update client caches. */
export type DeleteMessageDocumentPayload = {
  __typename?: 'DeleteMessageDocumentPayload';
  clientId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Device = {
  __typename?: 'Device';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  platform?: Maybe<DevicePlatform>;
  token: Scalars['String']['output'];
  tokenType?: Maybe<DeviceToken>;
  user: User;
};

/** Attributes for creating a user device */
export type DeviceAttributes = {
  platform?: InputMaybe<DevicePlatform>;
  token: Scalars['String']['input'];
  tokenType?: InputMaybe<DeviceToken>;
};

export enum DevicePlatform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB',
}

export enum DeviceToken {
  Expo = 'EXPO',
  Firebase = 'FIREBASE',
}

/** Represents direct upload credentials */
export type DirectUpload = {
  __typename?: 'DirectUpload';
  /** Created blob record ID */
  blobId: Scalars['ID']['output'];
  /** Client-side value used to correlate file with blob ID */
  clientId: Scalars['ID']['output'];
  /** HTTP request headers (JSON-encoded) */
  headers: Scalars['String']['output'];
  /** Created blob record signed ID */
  signedBlobId: Scalars['ID']['output'];
  /** Upload URL */
  url: Scalars['String']['output'];
};

/** File information required to prepare a direct upload */
export type DirectUploadAttributes = {
  /** File size (bytes) */
  byteSize: Scalars['Int']['input'];
  /** MD5 file checksum as base64 */
  checksum: Scalars['String']['input'];
  /** Client-side value used to correlate file with blob ID */
  clientId: Scalars['ID']['input'];
  /** File content type */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Original file name */
  filename: Scalars['String']['input'];
};

/** Document type representing a document in the system */
export type Document = {
  __typename?: 'Document';
  blobId?: Maybe<Scalars['ID']['output']>;
  clientId: Scalars['String']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  failedAt: Scalars['ISO8601DateTime']['output'];
  file: File;
  folder?: Maybe<Folder>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isAudio: Scalars['Boolean']['output'];
  isImage: Scalars['Boolean']['output'];
  isVideo: Scalars['Boolean']['output'];
  messageClientId?: Maybe<Scalars['String']['output']>;
  messageCreateYn?: Maybe<Scalars['Boolean']['output']>;
  messageDocuments?: Maybe<Array<MessageDocument>>;
  name: Scalars['String']['output'];
  owner: User;
  projectDocuments?: Maybe<Array<ProjectDocument>>;
  size?: Maybe<Scalars['Int']['output']>;
  taskDocuments?: Maybe<Array<TaskDocument>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uuid: Scalars['ID']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

/** Attributes for creating or updating a document */
export type DocumentAttributes = {
  blobId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  isAudio: Scalars['Boolean']['input'];
  isImage: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** DocumentCollection type */
export type DocumentCollection = {
  __typename?: 'DocumentCollection';
  /** A collection of paginated DocumentCollection */
  collection: Array<Document>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** The connection type for Document. */
export type DocumentConnection = {
  __typename?: 'DocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DocumentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Document>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DocumentEdge = {
  __typename?: 'DocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Document>;
};

export enum DocumentGroup {
  File = 'FILE',
  Media = 'MEDIA',
}

export enum DocumentSortOption {
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
}

export type DraftMessage = {
  __typename?: 'DraftMessage';
  body?: Maybe<Scalars['String']['output']>;
  chatId: Scalars['ID']['output'];
  checkin?: Maybe<MessageCheckin>;
  localFiles: Array<Maybe<LocalFile>>;
  replyMessage?: Maybe<Message>;
  tagsCollection: Array<Maybe<TaskTagCollection>>;
};

export type DraftMessageAttributes = {
  body?: InputMaybe<Scalars['String']['input']>;
  checkin?: InputMaybe<MessageCheckinAttributes>;
  localFiles: Array<InputMaybe<LocalFileInput>>;
  replyMessage?: InputMaybe<ReplyMessageInput>;
  tagsCollection: Array<InputMaybe<TaskTagCollectionInput>>;
};

/** Generic type representing users removed from project or task */
export type EntityUser = {
  __typename?: 'EntityUser';
  id: Scalars['ID']['output'];
  project?: Maybe<Project>;
  task?: Maybe<Task>;
  user?: Maybe<User>;
};

/** Autogenerated return type of ExportCheckins. */
export type ExportCheckinsPayload = {
  __typename?: 'ExportCheckinsPayload';
  filename: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Autogenerated return type of ExportGlobalCheckins. */
export type ExportGlobalCheckinsPayload = {
  __typename?: 'ExportGlobalCheckinsPayload';
  filename: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Features */
export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** File type representing a file attachment in the system */
export type File = {
  __typename?: 'File';
  cdnBaseUrl: Scalars['String']['output'];
  /**
   * When the signed URL stops working. Only set for avatars, whose URL is signed
   * fresh on every resolution; nil for files that may be served from cache.
   */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  isPreviewable: Scalars['Boolean']['output'];
  path: Scalars['String']['output'];
  /**
   * When the signed URL was issued. Only set for avatars; nil for files that may
   * be served from cache, where receipt time says nothing about issuance.
   */
  signedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** Folders */
export type Folder = {
  __typename?: 'Folder';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: User;
  parent?: Maybe<Folder>;
  projects?: Maybe<Array<Project>>;
  tasks?: Maybe<Array<Task>>;
};

/** Attributes for creating or updating a folder */
export type FolderAttributes = {
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of ForwardDocuments. */
export type ForwardDocumentsPayload = {
  __typename?: 'ForwardDocumentsPayload';
  errors: Array<Scalars['String']['output']>;
  messages: Array<Message>;
};

/** Autogenerated return type of GenerateReport. */
export type GenerateReportPayload = {
  __typename?: 'GenerateReportPayload';
  uuid: Scalars['String']['output'];
};

export type Group = {
  __typename?: 'Group';
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentUserTeamRole?: Maybe<TeamRole>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  team?: Maybe<Team>;
  users?: Maybe<Array<User>>;
  usersCount: Scalars['Int']['output'];
  usersPreview: Array<User>;
};

/** Attributes for creating or updating a group */
export type GroupAttributes = {
  accountId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Highlight = {
  __typename?: 'Highlight';
  authorName?: Maybe<Array<Scalars['String']['output']>>;
  body?: Maybe<Array<Scalars['String']['output']>>;
  chatName?: Maybe<Array<Scalars['String']['output']>>;
  documentNames?: Maybe<Array<Scalars['String']['output']>>;
  email?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Array<Scalars['String']['output']>>;
  projectNames?: Maybe<Array<Scalars['String']['output']>>;
  taskNames?: Maybe<Array<Scalars['String']['output']>>;
};

export enum Invitation {
  Chat = 'CHAT',
  Project = 'PROJECT',
  Task = 'TASK',
  Team = 'TEAM',
}

/** Structure describing invitation auto-join eligibility and associated resources */
export type InvitationValidity = {
  __typename?: 'InvitationValidity';
  autoJoin: Scalars['Boolean']['output'];
  /** Chat details for group chat invite */
  chat?: Maybe<PublicChat>;
  /** Email the invitation was sent to */
  invitationEmail?: Maybe<Scalars['String']['output']>;
  /** Name of the person the invitation was sent to */
  invitationName?: Maybe<Scalars['String']['output']>;
  /** Role assigned in the invitation (serialized as string for cross-type compatibility) */
  invitationRole?: Maybe<Scalars['String']['output']>;
  /**
   * Explicit invitation state: "active", "expired", "invalid" (token not found),
   * or "already_member" (current user is already a member of the invited project).
   * Null only if the resolver cannot determine status (should not occur in practice).
   */
  invitationStatus?: Maybe<Scalars['String']['output']>;
  /** User who sent the invitation; null if absent */
  invitedBy?: Maybe<PublicUser>;
  /** Name of the user who sent the invitation */
  invitedByName?: Maybe<Scalars['String']['output']>;
  /** Whether this is a shareable link invite (vs direct email invite) */
  isLinkInvite: Scalars['Boolean']['output'];
  /** Whether a task invitation link can no longer be used for direct join; false for non-task invitation types. */
  isTaskInvitationExpired: Scalars['Boolean']['output'];
  /** Project details if associated with a project */
  project?: Maybe<PublicProject>;
  /** Task details if the token is associated with a task */
  task?: Maybe<PublicTask>;
  /** Team details if the token is associated with a team */
  team?: Maybe<PublicTeam>;
};

/** Invoice type representing an invoice in the system */
export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Int']['output'];
  date: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceUrl: Scalars['String']['output'];
  payment?: Maybe<Payment>;
  status: Scalars['String']['output'];
};

/** LocalFile is strictly for generating an extendable type via codegen */
export type LocalFile = {
  __typename?: 'LocalFile';
  blobId?: Maybe<Scalars['ID']['output']>;
  cdnBaseUrl: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isAudio: Scalars['Boolean']['output'];
  isImage: Scalars['Boolean']['output'];
  isPreviewable: Scalars['Boolean']['output'];
  isVideo: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  thumbnail: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Client-side schema extensions for offline/draft functionality */
export type LocalFileInput = {
  blobId?: InputMaybe<Scalars['ID']['input']>;
  cdnBaseUrl: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  isAudio: Scalars['Boolean']['input'];
  isImage: Scalars['Boolean']['input'];
  isPreviewable: Scalars['Boolean']['input'];
  isVideo: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  thumbnail: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** Autogenerated return type of MeUpdated. */
export type MeUpdatedPayload = {
  __typename?: 'MeUpdatedPayload';
  chats?: Maybe<Array<Chat>>;
  profile?: Maybe<Profile>;
  unviewedProjectAssignments?: Maybe<Array<Project>>;
};

/** Attributes for assigning membership to a user */
export type MemberAttributes = {
  role: TeamRole;
  userId: Scalars['ID']['input'];
};

/** Message type representing a message in the system */
export type Message = Node & {
  __typename?: 'Message';
  attachments?: Maybe<Array<Attachment>>;
  author: User;
  authorAvatarId?: Maybe<Scalars['ID']['output']>;
  authorEmail?: Maybe<Scalars['String']['output']>;
  authorFirstName?: Maybe<Scalars['String']['output']>;
  authorId: Scalars['ID']['output'];
  authorLastName?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  chat: Chat;
  chatId: Scalars['ID']['output'];
  checkin?: Maybe<MessageCheckin>;
  clientId: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  failedAt: Scalars['ISO8601DateTime']['output'];
  filesCount?: Maybe<Scalars['Int']['output']>;
  forwardedId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imagesCount?: Maybe<Scalars['Int']['output']>;
  isDraft: Scalars['Boolean']['output'];
  isRetry: Scalars['Boolean']['output'];
  isSender: Scalars['Boolean']['output'];
  localFiles?: Maybe<Array<Maybe<LocalFile>>>;
  messageIcon?: Maybe<Scalars['String']['output']>;
  projectIds?: Maybe<Array<Scalars['ID']['output']>>;
  projectsCount?: Maybe<Scalars['Int']['output']>;
  publish?: Maybe<Scalars['Boolean']['output']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  reaction?: Maybe<Array<MessageReaction>>;
  readAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readReceipts?: Maybe<Array<User>>;
  replyId?: Maybe<Scalars['ID']['output']>;
  replyMessage?: Maybe<Message>;
  taskIds?: Maybe<Array<Scalars['ID']['output']>>;
  tasksCount?: Maybe<Scalars['Int']['output']>;
  userRequest?: Maybe<UserRequest>;
};

/** Attributes for creating or updating a message */
export type MessageAttributes = {
  body?: InputMaybe<Scalars['String']['input']>;
  chatId: Scalars['ID']['input'];
  checkin?: InputMaybe<MessageCheckinAttributes>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<DocumentAttributes>>;
  folders?: InputMaybe<Array<FolderAttributes>>;
  forwardedId?: InputMaybe<Scalars['ID']['input']>;
  friendRequestAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  messageProjects?: InputMaybe<Array<MessageProjectAttributes>>;
  messageTasks?: InputMaybe<Array<MessageTaskAttributes>>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  publish?: InputMaybe<Scalars['Boolean']['input']>;
  replyId?: InputMaybe<Scalars['ID']['input']>;
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Message checkin type representing a checkin in a message */
export type MessageCheckin = {
  __typename?: 'MessageCheckin';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<User>;
  state?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  withinGeofence: Scalars['Boolean']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

/** Attributes for creating checkin when create a message */
export type MessageCheckinAttributes = {
  address: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Message. */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MessageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Message>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** MessageDocument type */
export type MessageDocument = {
  __typename?: 'MessageDocument';
  document?: Maybe<Document>;
  documentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Message>;
  owner?: Maybe<User>;
};

/** An edge in a connection. */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Message>;
};

/** Message project type representing a message related to a project in the system */
export type MessageProject = {
  __typename?: 'MessageProject';
  author?: Maybe<User>;
  authorId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Message>;
  project?: Maybe<Project>;
  projectId: Scalars['ID']['output'];
};

/** Attributes for creating or updating a message */
export type MessageProjectAttributes = {
  authorId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};

/** Message reaction type representing a reaction to a message in the system */
export type MessageReaction = {
  __typename?: 'MessageReaction';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Message>;
  reaction: Scalars['String']['output'];
  reactionId: Scalars['ID']['output'];
  user?: Maybe<Array<User>>;
};

/** Attributes for creating or updating message tags */
export type MessageTagAttributes = {
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** MessageTask type */
export type MessageTask = {
  __typename?: 'MessageTask';
  author?: Maybe<User>;
  authorId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Message>;
  task?: Maybe<Task>;
  taskId: Scalars['ID']['output'];
};

/** MessageTaskAssignment type */
export type MessageTaskAssignment = {
  __typename?: 'MessageTaskAssignment';
  assignees: Array<User>;
  id: Scalars['ID']['output'];
  messageId: Scalars['ID']['output'];
  /** @deprecated Use `tasks` instead — a message can reference multiple tasks. */
  task?: Maybe<Task>;
  taskSnapshots: Array<MessageTaskSnapshot>;
  tasks?: Maybe<Array<Task>>;
};

/** Attributes for creating or updating a message */
export type MessageTaskAttributes = {
  authorId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

/** MessageTaskComplete type */
export type MessageTaskComplete = {
  __typename?: 'MessageTaskComplete';
  completor?: Maybe<User>;
  id: Scalars['ID']['output'];
  messageId: Scalars['ID']['output'];
};

/**
 * Frozen per-task status captured when a task-assignment card was created — does
 * not reflect later changes made outside the card itself
 */
export type MessageTaskSnapshot = {
  __typename?: 'MessageTaskSnapshot';
  assignees: Array<User>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status?: Maybe<TaskStatus>;
  taskId: Scalars['ID']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept Chat Invitation */
  acceptChatInvitation: Chat;
  /** Accept Team Invitation */
  acceptTeamInvitation: Team;
  /** Connects the current user with the inviter behind a generic invitation link */
  acceptUserInvite: AcceptUserInvitePayload;
  /** Add checklist item to a project */
  addProjectChecklist: Array<ProjectChecklist>;
  /** Upload files to a project */
  addProjectFiles: Project;
  /** Add checklist item to a task */
  addTaskChecklist: Array<TaskChecklist>;
  /** Upload files to a task */
  addTaskFiles: Task;
  /** Apply a predefined template to a project */
  applyProjectChecklistTemplate: Array<ProjectChecklist>;
  /** Approve a project invitation. */
  approveProjectInvitation: Scalars['Boolean']['output'];
  /** Approve a task invitation */
  approveTaskInvitation: Scalars['Boolean']['output'];
  /** Archive a chat */
  archiveChat: Chat;
  /** Archive a project */
  archiveProject: Project;
  /** Assign an owner to a task */
  assignTaskOwner: Task;
  /** Assign users to a task created by or assigned to the current user */
  assignTaskUsers: Task;
  /** Assign an owner to a team */
  assignTeamOwner: Team;
  /** Generates a ZIP file containing documents related to the resource and returns the ZIP file URL via subscription */
  bulkExportDocuments: Scalars['Boolean']['output'];
  cancelStripeSubscription?: Maybe<Team>;
  /** Block a user */
  chatBlockUnblockUser: User;
  /** Record an onboarding step as completed or skipped. Idempotent — duplicate step_key returns the existing record. */
  completeOnboardingProgress: User;
  /** Toggle task completion by ID and current user */
  completeTask: Task;
  /** Complete web tutorial flow for the current user. */
  completeWebTutorialFlows: Scalars['Boolean']['output'];
  /** Convert a project checklist item to a task */
  convertProjectChecklistToTask: Array<Task>;
  /** Create a new chat */
  createChat: Chat;
  /** Create chat invitations for email addresses (works for both group and 1-to-1 chats) */
  createChatInvitation?: Maybe<Chat>;
  createContactInvitationUrl?: Maybe<Scalars['String']['output']>;
  createDevice?: Maybe<Device>;
  createDirectUploads: Array<DirectUpload>;
  /** Create a new draft message */
  createDraftMessage: Message;
  /** Create a new group */
  createGroup: Group;
  createInvite?: Maybe<Scalars['String']['output']>;
  createMediaShareLink?: Maybe<CreateMediaShareLinkPayload>;
  /** Create a new message */
  createMessageIndividual: Message;
  /** Create a message reaction */
  createMessageReaction: MessageReaction;
  /** Create a new phase */
  createPhase: Phase;
  createProject?: Maybe<Project>;
  /** Create a project invitation */
  createProjectInvitation?: Maybe<Project>;
  createShareLink?: Maybe<CreateShareLinkPayload>;
  createStripeSubscription?: Maybe<PaymentIntent>;
  /** Create a new task */
  createTask: Task;
  /** Create a task invitation */
  createTaskInvitation?: Maybe<Task>;
  /** Create a new team */
  createTeam: Team;
  /** Create a team invitation */
  createTeamInvitation: Scalars['String']['output'];
  /** Create team member invitations with roles */
  createTeamMemberInvitation?: Maybe<Team>;
  /** Create a new user request */
  createUserRequest: UserRequest;
  /** Delete a chat invitation */
  deleteChatInvitation?: Maybe<Scalars['Boolean']['output']>;
  deleteDevice?: Maybe<Device>;
  deleteDirectUploads?: Maybe<Scalars['Boolean']['output']>;
  /** User declined the friend request */
  deleteFriendRequest?: Maybe<Chat>;
  /** Delete a contact group */
  deleteGroup?: Maybe<Group>;
  /** User deleting the group chat after leaving the chat group */
  deleteGroupChat?: Maybe<Chat>;
  /** Owner deleting the group chat for everyone with notifications */
  deleteGroupChatForEveryone: Scalars['Boolean']['output'];
  /** Delete a new message */
  deleteMessage: Message;
  /**
   * Delete a document from a chat message (image viewer context). Only documents
   * attached to at least one message are reachable. The caller must be the
   * document owner or the author of a message containing the document. The parent
   * message is left untouched.
   */
  deleteMessageDocument: DeleteMessageDocumentPayload;
  /** Delete a project */
  deleteProject: Project;
  /** Delete a project asynchronously via background job */
  deleteProjectAsync: Scalars['Boolean']['output'];
  /** Delete a project files */
  deleteProjectFiles: Array<ProjectDocument>;
  /** Delete a project invitation */
  deleteProjectInvitation?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a task */
  deleteTask?: Maybe<Task>;
  /** Delete a task files */
  deleteTaskFiles: Array<TaskDocument>;
  /** Delete a task invitation */
  deleteTaskInvitation?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a team */
  deleteTeam?: Maybe<Team>;
  /** Delete a team invitation or user request */
  deleteTeamInvitation?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a user request */
  deleteUserRequest: UserRequest;
  /** Duplicate project with optional associated records */
  duplicateProject: Project;
  /** Duplicate task with optional associated records */
  duplicateTask: Task;
  /** Duplicate task files from source to destination. */
  duplicateTaskFiles: Array<TaskDocument>;
  editStripeSubscription?: Maybe<PaymentIntent>;
  /** Export project checkins as CSV with optional date range filtering */
  exportCheckins?: Maybe<ExportCheckinsPayload>;
  /** Export checkins across all projects as CSV with optional date range filtering */
  exportGlobalCheckins?: Maybe<ExportGlobalCheckinsPayload>;
  /** Forward source documents to one or more target chats server-side, reusing existing blobs */
  forwardDocuments?: Maybe<ForwardDocumentsPayload>;
  /** Create a new chat with friend request */
  friendRequest: Chat;
  generateProjectReport?: Maybe<GenerateReportPayload>;
  /** generate new public calendar url for current user */
  generatePublicCalendarUrl: Scalars['String']['output'];
  /** invalidate public calendar url for current user */
  invalidatePublicCalendarUrl: Scalars['Boolean']['output'];
  /** Join a project via user request */
  joinRequestedProject: Scalars['Boolean']['output'];
  /** Join a task via user request */
  joinRequestedTask: Scalars['Boolean']['output'];
  /** Leave a group chat */
  leaveChat?: Maybe<Chat>;
  /** Leave a project */
  leaveProject?: Maybe<Project>;
  leaveTask?: Maybe<Task>;
  /** Leave a team */
  leaveTeam: Team;
  /** Marks the current activity feed state as viewed, clearing the Activity nav red dot */
  markActivityViewed: User;
  /** Create read receipts for all active log by ID */
  markAuditsRead: Array<Audit>;
  /** Create read receipts for all messages by chat ID */
  markChatsRead: Array<Chat>;
  /** Mark the project onboarding card as seen for the current user */
  markProjectOnboarded: Scalars['Boolean']['output'];
  /** Mark a task as acknowledged by the current assignee */
  markTaskAcknowledged?: Maybe<Task>;
  markTaskOpened?: Maybe<Task>;
  /** Notify team about trial expiry; owners/admins send email, members send in-app message */
  notifyTeamExpiry?: Maybe<NotifyTeamExpiryPayload>;
  /** Notify team owners and admins about subscription reactivation request */
  notifyTeamOwner?: Maybe<NotifyTeamOwnerPayload>;
  /**
   * Reorder one or more tasks within a My Tasks section. The tasks array is placed
   * as a contiguous ordered block between the two anchors. Pass a single-element
   * array to move one task.
   */
  orderTasks?: Maybe<Array<UserTaskOrder>>;
  /** Reject a project invitation */
  rejectProjectInvitation: Scalars['Boolean']['output'];
  /** Reject a task invitation */
  rejectTaskInvitation: Scalars['Boolean']['output'];
  /** Remove a member from a group chat */
  removeChatMember?: Maybe<Scalars['Boolean']['output']>;
  /** Removes current user and related data asynchronously */
  removeMe: User;
  /** Remove a message reaction */
  removeMessageReaction: MessageReaction;
  /** Remove a project checklist */
  removeProjectChecklist: Scalars['Boolean']['output'];
  /** Remove a member from a project */
  removeProjectMember: Project;
  /** Remove checklist item from a task */
  removeTaskChecklist: TaskChecklist;
  /** Update a members role on a team */
  removeTeamMember: Team;
  /** Rename a document */
  renameDocument: Document;
  /** Resend a chat invitation to an invitee */
  resendChatInvitation?: Maybe<Scalars['Boolean']['output']>;
  /** Resend a project invitation to an invitee */
  resendProjectInvitation?: Maybe<Scalars['Boolean']['output']>;
  /** Resend a task invitation to an invitee */
  resendTaskInvitation?: Maybe<Scalars['Boolean']['output']>;
  /** Resend a team invitation or user request */
  resendTeamInvitation?: Maybe<Scalars['Boolean']['output']>;
  /** Save an existing project checklist as a reusable template. */
  saveChecklistAsTemplate: ChecklistTemplate;
  /** Set user primary team */
  setPrimaryTeam: User;
  /** Snoozes a pending decision (invite/join request) so it drops out of the Needs a Decision block until snoozed_until passes */
  snoozePendingDecision: UserRequest;
  /** Toggle favorite status of a checklist template */
  toggleChecklistTemplateFavorite: Scalars['Boolean']['output'];
  /** Unarchive a chat */
  unarchiveChat: Chat;
  /** Unarchive a project */
  unarchiveProject: Project;
  /** Update billing Period */
  updateBillingPeriod?: Maybe<PaymentIntent>;
  /** Update a chat */
  updateChat: Chat;
  /** Update group chat admin */
  updateChatAdmin: Chat;
  /** Update project/task tags for a single document within its chat message, without affecting sibling documents */
  updateDocumentTags: Document;
  /** Update the draft message for the given chat */
  updateDraftMessage?: Maybe<DraftMessage>;
  /** update a group */
  updateGroup: Group;
  /** Mark the hashtag first-use tooltip as seen for the current user on a given platform */
  updateHashtagTooltipSeen: User;
  /** Update current user profile information */
  updateMe: User;
  /** Update a message */
  updateMessageIndividual: Message;
  /** Update message tags */
  updateMessageTags: Message;
  /** Update notification setting */
  updateNotificationSetting: Array<UserNotificationSetting>;
  /** Update user onboarding progress */
  updateOnboardingProgress: User;
  /** Mark onboarding steps complete for the current user. Forward-only fields. */
  updateOnboardingState: User;
  /** Update payment processor's customer's payment method. */
  updatePaymentMethod: Team;
  updateProject?: Maybe<Project>;
  /** Update a project checklist */
  updateProjectChecklist: ProjectChecklist;
  /** Update sort order of project checklists */
  updateProjectChecklistSort: Array<ProjectChecklist>;
  /** Update project file tags */
  updateProjectFileTags: Document;
  /** Update a project member role */
  updateProjectMemberRole: Project;
  /** Update project members */
  updateProjectMembers: Project;
  /**
   * Merge Rate Us state for the current user. Booleans are forward-only (true
   * wins). Trigger counts and stages take the higher value; timestamps take the later value.
   */
  updateRateUsState: RateUsState;
  /** Update a task created by the current user */
  updateTask: Task;
  /** Update a task checklist */
  updateTaskChecklist: TaskChecklist;
  /** Update a task checklist */
  updateTaskChecklistSort: Array<TaskChecklist>;
  /** Update a task members */
  updateTaskMembers: Task;
  /** Update a team */
  updateTeam: Team;
  /** Update a members role on a team */
  updateTeamMembers: Team;
  /** Update tutoralization setting */
  updateTutoralizationSetting: Array<UserTutoralizationSetting>;
  /** Approve or reject a user request */
  updateUserRequestStatus: UserRequest;
  uploadContacts?: Maybe<User>;
};

export type MutationAcceptChatInvitationArgs = {
  invitationToken: Scalars['String']['input'];
};

export type MutationAcceptTeamInvitationArgs = {
  invitationToken: Scalars['String']['input'];
};

export type MutationAcceptUserInviteArgs = {
  invitationToken: Scalars['String']['input'];
};

export type MutationAddProjectChecklistArgs = {
  attributes: AddProjectChecklistAttributes;
  uuid: Scalars['ID']['input'];
};

export type MutationAddProjectFilesArgs = {
  attributes: Array<DocumentAttributes>;
  id: Scalars['ID']['input'];
};

export type MutationAddTaskChecklistArgs = {
  attributes: TaskChecklistAttributes;
  taskId: Scalars['ID']['input'];
};

export type MutationAddTaskFilesArgs = {
  attributes: Array<DocumentAttributes>;
  id: Scalars['ID']['input'];
};

export type MutationApplyProjectChecklistTemplateArgs = {
  projectChecklistTemplateId: Scalars['ID']['input'];
  selectedItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  uuid: Scalars['ID']['input'];
};

export type MutationApproveProjectInvitationArgs = {
  userRequestId: Scalars['ID']['input'];
};

export type MutationApproveTaskInvitationArgs = {
  userRequestId: Scalars['ID']['input'];
};

export type MutationArchiveChatArgs = {
  id: Scalars['ID']['input'];
};

export type MutationArchiveProjectArgs = {
  id: Scalars['ID']['input'];
};

export type MutationAssignTaskOwnerArgs = {
  id: Scalars['ID']['input'];
  newOwnerId: Scalars['ID']['input'];
};

export type MutationAssignTaskUsersArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  members?: InputMaybe<Array<TaskMemberAttributes>>;
  sendCardImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  sourceMessageId?: InputMaybe<Scalars['ID']['input']>;
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationAssignTeamOwnerArgs = {
  id: Scalars['ID']['input'];
  newOwnerId: Scalars['ID']['input'];
};

export type MutationBulkExportDocumentsArgs = {
  resourceId: Scalars['ID']['input'];
  resourceType: Scalars['String']['input'];
};

export type MutationCancelStripeSubscriptionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationChatBlockUnblockUserArgs = {
  userIdToBlock: Scalars['ID']['input'];
};

export type MutationCompleteOnboardingProgressArgs = {
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  stepKey: OnboardingStepKey;
};

export type MutationCompleteTaskArgs = {
  attachments?: InputMaybe<Array<DocumentAttributes>>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCompleteWebTutorialFlowsArgs = {
  flowType: WebTutorialFlow;
};

export type MutationConvertProjectChecklistToTaskArgs = {
  projectChecklistIds: Array<Scalars['ID']['input']>;
};

export type MutationCreateChatArgs = {
  attributes: ChatAttributes;
};

export type MutationCreateChatInvitationArgs = {
  emails: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationCreateContactInvitationUrlArgs = {
  attributes: CreateContactInvitationUrlAttributes;
};

export type MutationCreateDeviceArgs = {
  attributes: DeviceAttributes;
};

export type MutationCreateDirectUploadsArgs = {
  attributes: Array<DirectUploadAttributes>;
};

export type MutationCreateDraftMessageArgs = {
  attributes: MessageAttributes;
};

export type MutationCreateGroupArgs = {
  attributes: GroupAttributes;
};

export type MutationCreateInviteArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreateMediaShareLinkArgs = {
  documentIds: Array<Scalars['ID']['input']>;
};

export type MutationCreateMessageIndividualArgs = {
  attributes: MessageAttributes;
};

export type MutationCreateMessageReactionArgs = {
  messageId: Scalars['ID']['input'];
  reaction: Scalars['String']['input'];
};

export type MutationCreatePhaseArgs = {
  attributes: PhaseAttributes;
};

export type MutationCreateProjectArgs = {
  attributes: ProjectAttributes;
};

export type MutationCreateProjectInvitationArgs = {
  id: Scalars['ID']['input'];
  projectMembers: Array<ProjectMemberRoleAttributes>;
};

export type MutationCreateShareLinkArgs = {
  documentIds: Array<Scalars['ID']['input']>;
};

export type MutationCreateStripeSubscriptionArgs = {
  stripeSubscriptionAttributes: StripeSubscriptionAttributes;
  teamAttributes?: InputMaybe<TeamAttributes>;
};

export type MutationCreateTaskArgs = {
  attributes: TaskAttributes;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  sendCardImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  sourceMessageId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreateTaskInvitationArgs = {
  id: Scalars['ID']['input'];
  taskMembers: Array<TaskMemberRoleAttributes>;
};

export type MutationCreateTeamArgs = {
  attributes: TeamAttributes;
  billingSource?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionAttributes?: InputMaybe<StripeSubscriptionAttributes>;
};

export type MutationCreateTeamInvitationArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateTeamMemberInvitationArgs = {
  id: Scalars['ID']['input'];
  teamMembers: Array<TeamMemberRoleAttributes>;
};

export type MutationCreateUserRequestArgs = {
  attributes: UserRequestAttributes;
};

export type MutationDeleteChatInvitationArgs = {
  chatInvitationId: Scalars['ID']['input'];
};

export type MutationDeleteDeviceArgs = {
  apiToken?: InputMaybe<Scalars['String']['input']>;
  expoToken: Scalars['String']['input'];
};

export type MutationDeleteDirectUploadsArgs = {
  blobId: Scalars['ID']['input'];
};

export type MutationDeleteFriendRequestArgs = {
  friendRequest: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDeleteGroupArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteGroupChatArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteGroupChatForEveryoneArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteMessageArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteMessageDocumentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteProjectAsyncArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteProjectFilesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationDeleteProjectInvitationArgs = {
  projectInvitationId: Scalars['ID']['input'];
};

export type MutationDeleteTaskArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteTaskFilesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationDeleteTaskInvitationArgs = {
  taskInvitationId: Scalars['ID']['input'];
};

export type MutationDeleteTeamArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteTeamInvitationArgs = {
  accountInvitationId?: InputMaybe<Scalars['ID']['input']>;
  userRequestId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationDeleteUserRequestArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDuplicateProjectArgs = {
  id: Scalars['ID']['input'];
  includeAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  includeEditors?: InputMaybe<Scalars['Boolean']['input']>;
  includeFiles?: InputMaybe<Scalars['Boolean']['input']>;
  includeMembers?: InputMaybe<Scalars['Boolean']['input']>;
  includePhases?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasks?: InputMaybe<Scalars['Boolean']['input']>;
  includeViewers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationDuplicateTaskArgs = {
  id: Scalars['ID']['input'];
  includeAssignees?: InputMaybe<Scalars['Boolean']['input']>;
  includeCheckLists?: InputMaybe<Scalars['Boolean']['input']>;
  includeCreator?: InputMaybe<Scalars['Boolean']['input']>;
  includeFiles?: InputMaybe<Scalars['Boolean']['input']>;
  includeViewers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationDuplicateTaskFilesArgs = {
  destinationId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
};

export type MutationEditStripeSubscriptionArgs = {
  stripeSubscriptionAttributes: StripeSubscriptionAttributes;
};

export type MutationExportCheckinsArgs = {
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  projectId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type MutationExportGlobalCheckinsArgs = {
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  to?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type MutationForwardDocumentsArgs = {
  documentIds: Array<Scalars['ID']['input']>;
  targetChatIds: Array<Scalars['ID']['input']>;
};

export type MutationFriendRequestArgs = {
  attributes: ChatAttributes;
};

export type MutationGenerateProjectReportArgs = {
  projectId: Scalars['ID']['input'];
};

export type MutationJoinRequestedProjectArgs = {
  userRequestId: Scalars['ID']['input'];
};

export type MutationJoinRequestedTaskArgs = {
  userRequestId: Scalars['ID']['input'];
};

export type MutationLeaveChatArgs = {
  id: Scalars['ID']['input'];
};

export type MutationLeaveProjectArgs = {
  id: Scalars['ID']['input'];
};

export type MutationLeaveTaskArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationLeaveTeamArgs = {
  id: Scalars['ID']['input'];
};

export type MutationMarkAuditsReadArgs = {
  attributes: ReadReceiptAuditAttributes;
};

export type MutationMarkChatsReadArgs = {
  attributes: ReadReceiptChatAttributes;
};

export type MutationMarkProjectOnboardedArgs = {
  id: Scalars['ID']['input'];
};

export type MutationMarkTaskAcknowledgedArgs = {
  id: Scalars['ID']['input'];
};

export type MutationMarkTaskOpenedArgs = {
  id: Scalars['ID']['input'];
};

export type MutationNotifyTeamExpiryArgs = {
  projectId: Scalars['ID']['input'];
};

export type MutationNotifyTeamOwnerArgs = {
  teamId: Scalars['ID']['input'];
};

export type MutationOrderTasksArgs = {
  afterTaskId?: InputMaybe<Scalars['ID']['input']>;
  beforeTaskId?: InputMaybe<Scalars['ID']['input']>;
  section: TaskSection;
  taskIds: Array<Scalars['ID']['input']>;
};

export type MutationRejectProjectInvitationArgs = {
  userRequestId: Scalars['ID']['input'];
};

export type MutationRejectTaskInvitationArgs = {
  userRequestId: Scalars['ID']['input'];
};

export type MutationRemoveChatMemberArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationRemoveMessageReactionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveProjectChecklistArgs = {
  projectChecklistId: Scalars['ID']['input'];
};

export type MutationRemoveProjectMemberArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationRemoveTaskChecklistArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveTeamMemberArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationRenameDocumentArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MutationResendChatInvitationArgs = {
  chatInvitationId: Scalars['ID']['input'];
};

export type MutationResendProjectInvitationArgs = {
  projectInvitationId: Scalars['ID']['input'];
};

export type MutationResendTaskInvitationArgs = {
  taskInvitationId: Scalars['ID']['input'];
};

export type MutationResendTeamInvitationArgs = {
  accountInvitationId?: InputMaybe<Scalars['ID']['input']>;
  userRequestId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationSaveChecklistAsTemplateArgs = {
  attributes: SaveChecklistAsTemplateAttributes;
  projectUuid: Scalars['ID']['input'];
  templateName: Scalars['String']['input'];
};

export type MutationSetPrimaryTeamArgs = {
  accountId: Scalars['ID']['input'];
};

export type MutationSnoozePendingDecisionArgs = {
  snoozedUntil?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  userRequestId: Scalars['ID']['input'];
};

export type MutationToggleChecklistTemplateFavoriteArgs = {
  checklistTemplateId: Scalars['ID']['input'];
};

export type MutationUnarchiveChatArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUnarchiveProjectArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUpdateBillingPeriodArgs = {
  priceId: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};

export type MutationUpdateChatArgs = {
  attributes: ChatAttributes;
  id: Scalars['ID']['input'];
};

export type MutationUpdateChatAdminArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationUpdateDocumentTagsArgs = {
  attributes: MessageTagAttributes;
  id: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
};

export type MutationUpdateDraftMessageArgs = {
  attributes: DraftMessageAttributes;
  chatId: Scalars['ID']['input'];
};

export type MutationUpdateGroupArgs = {
  attributes: GroupAttributes;
  id: Scalars['ID']['input'];
};

export type MutationUpdateHashtagTooltipSeenArgs = {
  web: Scalars['Boolean']['input'];
};

export type MutationUpdateMeArgs = {
  attributes: UserAttributes;
};

export type MutationUpdateMessageIndividualArgs = {
  attributes: MessageAttributes;
  clientId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateMessageTagsArgs = {
  attributes: MessageTagAttributes;
  id: Scalars['ID']['input'];
};

export type MutationUpdateNotificationSettingArgs = {
  attributes: Array<NotificationSettingAttributes>;
};

export type MutationUpdateOnboardingProgressArgs = {
  onboardingFlow: OnboardingFlow;
};

export type MutationUpdateOnboardingStateArgs = {
  attributes: OnboardingStateAttributes;
};

export type MutationUpdatePaymentMethodArgs = {
  paymentMethodToken: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};

export type MutationUpdateProjectArgs = {
  attributes: ProjectAttributes;
  id: Scalars['ID']['input'];
};

export type MutationUpdateProjectChecklistArgs = {
  attributes: UpdateProjectChecklistAttributes;
  projectChecklistId: Scalars['ID']['input'];
};

export type MutationUpdateProjectChecklistSortArgs = {
  attributes: Array<ProjectChecklistSortAttributes>;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateProjectFileTagsArgs = {
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationUpdateProjectMemberRoleArgs = {
  projectUserId: Scalars['ID']['input'];
  role: ProjectMemberRole;
};

export type MutationUpdateProjectMembersArgs = {
  attributes: Array<ProjectMemberAttributes>;
  id: Scalars['ID']['input'];
};

export type MutationUpdateRateUsStateArgs = {
  attributes: UpdateRateUsStateAttributes;
};

export type MutationUpdateTaskArgs = {
  attributes: TaskAttributes;
  id: Scalars['ID']['input'];
};

export type MutationUpdateTaskChecklistArgs = {
  attributes: TaskChecklistAttributes;
  id: Scalars['ID']['input'];
};

export type MutationUpdateTaskChecklistSortArgs = {
  attributes: Array<TaskChecklistAttributes>;
  taskId: Scalars['ID']['input'];
};

export type MutationUpdateTaskMembersArgs = {
  attributes: Array<TaskMemberAttributes>;
  id: Scalars['ID']['input'];
};

export type MutationUpdateTeamArgs = {
  attributes: TeamAttributes;
  id: Scalars['ID']['input'];
};

export type MutationUpdateTeamMembersArgs = {
  attributes: Array<MemberAttributes>;
  teamId: Scalars['ID']['input'];
};

export type MutationUpdateTutoralizationSettingArgs = {
  attributes: Array<TutoralizationSettingAttributes>;
};

export type MutationUpdateUserRequestStatusArgs = {
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

export type MutationUploadContactsArgs = {
  attributes: UploadContactAttributes;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

export enum NotificationSetting {
  Chat = 'CHAT',
  DailyDigest = 'DAILY_DIGEST',
  File = 'FILE',
  Project = 'PROJECT',
  Task = 'TASK',
  WeeklyUpdate = 'WEEKLY_UPDATE',
}

/** Attributes for updating notification setting */
export type NotificationSettingAttributes = {
  duration?: InputMaybe<NotificationSettingDuration>;
  mute: Scalars['Boolean']['input'];
  settingType: NotificationSetting;
};

export enum NotificationSettingDuration {
  Day = 'DAY',
  Forever = 'FOREVER',
  Week = 'WEEK',
}

/** Autogenerated return type of NotifyTeamExpiry. */
export type NotifyTeamExpiryPayload = {
  __typename?: 'NotifyTeamExpiryPayload';
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of NotifyTeamOwner. */
export type NotifyTeamOwnerPayload = {
  __typename?: 'NotifyTeamOwnerPayload';
  success: Scalars['Boolean']['output'];
};

export enum OnboardingFlow {
  Completed = 'COMPLETED',
  Exploration = 'EXPLORATION',
  ProjectCreation = 'PROJECT_CREATION',
  TaskCreation = 'TASK_CREATION',
  TeamSetup = 'TEAM_SETUP',
}

/** A single onboarding step record for a user */
export type OnboardingProgress = {
  __typename?: 'OnboardingProgress';
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  skipped: Scalars['Boolean']['output'];
  stepKey: OnboardingStepKey;
};

/** Per-user onboarding state — includes checklist completion steps and UI coachmark/nudge visibility flags */
export type OnboardingState = {
  __typename?: 'OnboardingState';
  checklistCreationComplete: Scalars['Boolean']['output'];
  firstChatSent: Scalars['Boolean']['output'];
  firstTagUsed: Scalars['Boolean']['output'];
  inviteMemberComplete: Scalars['Boolean']['output'];
  photoRequestNudgeShown: Scalars['Boolean']['output'];
  projectCreationComplete: Scalars['Boolean']['output'];
  tagPillCoachmarkShown: Scalars['Boolean']['output'];
  taskCreationComplete: Scalars['Boolean']['output'];
  welcomeModalSeen: Scalars['Boolean']['output'];
};

/** Forward-only onboarding state flags — includes checklist completion steps and UI coachmark/nudge visibility flags */
export type OnboardingStateAttributes = {
  checklistCreationComplete?: InputMaybe<Scalars['Boolean']['input']>;
  firstChatSent?: InputMaybe<Scalars['Boolean']['input']>;
  firstTagUsed?: InputMaybe<Scalars['Boolean']['input']>;
  inviteMemberComplete?: InputMaybe<Scalars['Boolean']['input']>;
  photoRequestNudgeShown?: InputMaybe<Scalars['Boolean']['input']>;
  projectCreationComplete?: InputMaybe<Scalars['Boolean']['input']>;
  tagPillCoachmarkShown?: InputMaybe<Scalars['Boolean']['input']>;
  taskCreationComplete?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeModalSeen?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OnboardingStepKey {
  AddMembers = 'ADD_MEMBERS',
  AssignTask = 'ASSIGN_TASK',
  CarlosFirstChat = 'CARLOS_FIRST_CHAT',
  CarlosFirstTag = 'CARLOS_FIRST_TAG',
  CarlosTagPill = 'CARLOS_TAG_PILL',
  CarlosTaskDetail = 'CARLOS_TASK_DETAIL',
  CarlosTaskList = 'CARLOS_TASK_LIST',
  FirstChat = 'FIRST_CHAT',
  FirstPhoto = 'FIRST_PHOTO',
  FirstTag = 'FIRST_TAG',
  FirstTagPill = 'FIRST_TAG_PILL',
  ProjectCreation = 'PROJECT_CREATION',
  TaskCreation = 'TASK_CREATION',
  WelcomeGreeting = 'WELCOME_GREETING',
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Payment type representing payment method information in the system */
export type Payment = {
  __typename?: 'Payment';
  brand: Scalars['String']['output'];
  expMonth?: Maybe<Scalars['String']['output']>;
  expYear?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

/** Payment intent type representing payment intent information in the system */
export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  clientSecret: Scalars['String']['output'];
  id: Scalars['String']['output'];
  intentType: Scalars['String']['output'];
  team: Team;
};

/** Paywall status for the current user */
export type PaywallStatus = {
  __typename?: 'PaywallStatus';
  isPaywalled: Scalars['Boolean']['output'];
  /** First eligible owned team for upgrade, if any. Nil when not paywalled or when the user owns no upgradeable teams. */
  upgradeTeam?: Maybe<Team>;
};

export type PendingDecisionsResult = {
  __typename?: 'PendingDecisionsResult';
  rows: Array<Audit>;
  totalUnresolvedCount: Scalars['Int']['output'];
};

/** Phase type representing a phase in the system */
export type Phase = {
  __typename?: 'Phase';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  user: User;
};

/** Attributes for creating a phase */
export type PhaseAttributes = {
  name: Scalars['String']['input'];
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Plan type representing subscription plan information in the system */
export type Plan = {
  __typename?: 'Plan';
  amount: Scalars['Int']['output'];
  expiration: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  interval: Scalars['String']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isResumable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  payment?: Maybe<Payment>;
  quantity: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

/** Price type representing subscription price information in the system */
export type Price = {
  __typename?: 'Price';
  amount: Scalars['Int']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  interval: Scalars['String']['output'];
  intervalCount: Scalars['Int']['output'];
};

/** A priority tier (High/Medium/Low) and the subset of the current My Tasks scope at that priority */
export type PriorityTaskGroup = TaskGroupInterface & {
  __typename?: 'PriorityTaskGroup';
  completedCount: Scalars['Int']['output'];
  completedTasks: TaskConnection;
  priority: TaskPriority;
  taskCount: Scalars['Int']['output'];
  tasks: TaskConnection;
};

/** A priority tier (High/Medium/Low) and the subset of the current My Tasks scope at that priority */
export type PriorityTaskGroupCompletedTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A priority tier (High/Medium/Low) and the subset of the current My Tasks scope at that priority */
export type PriorityTaskGroupTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Product type representing subscription product information in the system */
export type Product = {
  __typename?: 'Product';
  allowMembers: Scalars['Boolean']['output'];
  externalId: Scalars['String']['output'];
  features: Scalars['JSON']['output'];
  guestsOnly: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  maxDocumentStorage: Scalars['BigInt']['output'];
  maxNumberOfProjects: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  prices: Array<Price>;
};

/** Profile type representing a user profile in the system */
export type Profile = {
  __typename?: 'Profile';
  address?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<File>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  skills?: Maybe<Array<Skill>>;
  teams?: Maybe<Array<Team>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  userActiveTasksCount: Scalars['Int']['output'];
};

/** Project type representing a project in the system */
export type Project = {
  __typename?: 'Project';
  activeTasksCount: Scalars['Int']['output'];
  address?: Maybe<Scalars['String']['output']>;
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  audits?: Maybe<Array<Audit>>;
  auditsCount?: Maybe<Scalars['Int']['output']>;
  authorId: Scalars['ID']['output'];
  chatProjectsCount: Scalars['Int']['output'];
  color: Scalars['String']['output'];
  completedChecklistCount: Scalars['Int']['output'];
  completedTasksCount: Scalars['Int']['output'];
  coverImage?: Maybe<File>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  currentUserHasPendingMemberAdditionRequest: Scalars['Boolean']['output'];
  currentUserRole?: Maybe<ProjectMemberRole>;
  currentUserTeamRole?: Maybe<TeamMemberRole>;
  description?: Maybe<Scalars['String']['output']>;
  documentCount: Scalars['Int']['output'];
  /** Set only on a project created via duplicateProject -- null for ordinary projects. */
  duplicationStatus?: Maybe<ProjectDuplicationStatus>;
  group?: Maybe<Group>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageCount: Scalars['Int']['output'];
  initials: Scalars['String']['output'];
  invitations?: Maybe<Array<ProjectInvitation>>;
  isTaskMember: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  memberPreviews: Array<ProjectMember>;
  /** @deprecated Use memberPreviews for list-view avatar stacks or membersConnection for paginated full member retrieval. */
  members: Array<ProjectMember>;
  /**
   * Paginated full member list for a single project detail view. Not batched — do
   * not nest inside listProjects or another multi-project list.
   */
  membersConnection: ProjectMembershipConnection;
  name: Scalars['String']['output'];
  overdueTasksCount: Scalars['Int']['output'];
  personal: Scalars['Boolean']['output'];
  projectChecklists?: Maybe<Array<ProjectChecklist>>;
  settings?: Maybe<UserProjectSetting>;
  /** @deprecated listTasks query accepts a projectId argument and paginates results */
  tasks?: Maybe<Array<Task>>;
  tasksCount: Scalars['Int']['output'];
  tasksTagList?: Maybe<Array<Task>>;
  team?: Maybe<Team>;
  teamId: Scalars['ID']['output'];
  unreadAudits?: Maybe<Array<Audit>>;
  unreadAuditsCount?: Maybe<Scalars['Int']['output']>;
  upcomingTasksCount: Scalars['Int']['output'];
  userRequests?: Maybe<Array<UserRequest>>;
  usersCount: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
};

/** Project type representing a project in the system */
export type ProjectMembersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Attributes for creating or updating a project */
export type ProjectAttributes = {
  address?: InputMaybe<Scalars['String']['input']>;
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<DocumentAttributes>>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  members: Array<ProjectMemberAttributes>;
  name: Scalars['String']['input'];
  pin?: InputMaybe<Scalars['Boolean']['input']>;
  projectMembers?: InputMaybe<Array<ProjectMemberRoleAttributes>>;
  teamId: Scalars['ID']['input'];
};

/** Project checklist type representing a checklist item in a project */
export type ProjectChecklist = {
  __typename?: 'ProjectChecklist';
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  sort?: Maybe<Scalars['Int']['output']>;
};

/** Attributes for updating project checklist sort order */
export type ProjectChecklistSortAttributes = {
  projectChecklistId: Scalars['ID']['input'];
  sort: Scalars['Int']['input'];
};

/** The connection type for Project. */
export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Project>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Autogenerated return type of ProjectDeleted. */
export type ProjectDeletedPayload = {
  __typename?: 'ProjectDeletedPayload';
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
};

/** Project document type representing a document attached to a project in the system */
export type ProjectDocument = {
  __typename?: 'ProjectDocument';
  document?: Maybe<Document>;
  id: Scalars['ID']['output'];
  owner?: Maybe<User>;
  project?: Maybe<Project>;
};

export enum ProjectDuplicationStatus {
  Completed = 'COMPLETED',
  Duplicating = 'DUPLICATING',
  Failed = 'FAILED',
}

/** An edge in a connection. */
export type ProjectEdge = {
  __typename?: 'ProjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Project>;
};

/** Project invitation type representing a project invitation */
export type ProjectInvitation = {
  __typename?: 'ProjectInvitation';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  expiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitedBy: User;
  role: ProjectMemberRole;
};

/** Project member type representing a member of a project in the system */
export type ProjectMember = {
  __typename?: 'ProjectMember';
  id: Scalars['ID']['output'];
  project: Project;
  role: ProjectMemberRole;
  user: User;
};

/** Attributes for assigning project membership to a user */
export type ProjectMemberAttributes = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
  role: ProjectMemberRole;
  userId: Scalars['ID']['input'];
};

export enum ProjectMemberRole {
  Admin = 'ADMIN',
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER',
}

/** Attributes for invite a user to be a member when create a project */
export type ProjectMemberRoleAttributes = {
  email: Scalars['String']['input'];
  role: ProjectMemberRole;
};

/** Paginated project membership record (see membersConnection on ProjectType) */
export type ProjectMembership = {
  __typename?: 'ProjectMembership';
  id: Scalars['ID']['output'];
  project: Project;
  role: ProjectMemberRole;
  user: User;
};

/** The connection type for ProjectMembership. */
export type ProjectMembershipConnection = {
  __typename?: 'ProjectMembershipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectMembershipEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectMembership>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProjectMembershipEdge = {
  __typename?: 'ProjectMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectMembership>;
};

/** Returns ProjectType if current user is a member, otherwise PublicProjectType */
export type ProjectOrPublicProject = Project | PublicProject;

/** Project report overview type representing project overview information in the system */
export type ProjectReportOverview = {
  __typename?: 'ProjectReportOverview';
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  members: Array<ProjectMember>;
  name: Scalars['String']['output'];
  teamName: Scalars['String']['output'];
};

export enum ProjectSortOption {
  ActivityDesc = 'ACTIVITY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  RecentTaggedMessageDesc = 'RECENT_TAGGED_MESSAGE_DESC',
}

export type ProjectTag = {
  __typename?: 'ProjectTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type ProjectTagInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};

/** Project task type representing a project with its tasks in the system */
export type ProjectTask = {
  __typename?: 'ProjectTask';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  currentUserRole?: Maybe<ProjectMemberRole>;
  currentUserTeamRole?: Maybe<TeamMemberRole>;
  id: Scalars['ID']['output'];
  members: Array<ProjectMember>;
  name: Scalars['String']['output'];
  tasks?: Maybe<Array<Task>>;
  team?: Maybe<Team>;
  uuid: Scalars['ID']['output'];
};

/** The connection type for ProjectTask. */
export type ProjectTaskConnection = {
  __typename?: 'ProjectTaskConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectTaskEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectTask>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProjectTaskEdge = {
  __typename?: 'ProjectTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectTask>;
};

/** A project and the subset of the current My Tasks scope that belongs to it (TA-10312) */
export type ProjectTaskGroup = TaskGroupInterface & {
  __typename?: 'ProjectTaskGroup';
  completedCount: Scalars['Int']['output'];
  completedTasks: TaskConnection;
  project: Project;
  taskCount: Scalars['Int']['output'];
  tasks: TaskConnection;
};

/** A project and the subset of the current My Tasks scope that belongs to it (TA-10312) */
export type ProjectTaskGroupCompletedTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A project and the subset of the current My Tasks scope that belongs to it (TA-10312) */
export type ProjectTaskGroupTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Project tasks report type representing task report information in the system */
export type ProjectTasksReport = {
  __typename?: 'ProjectTasksReport';
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creator?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  members: Array<TaskMember>;
  name: Scalars['String']['output'];
  priority?: Maybe<TaskPriority>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Project user type representing a user in a project in the system */
export type ProjectUser = {
  __typename?: 'ProjectUser';
  id: Scalars['ID']['output'];
  onboardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  project: Project;
  user?: Maybe<User>;
};

/** Public chat information safe for unauthenticated contexts (e.g. invite link previews) */
export type PublicChat = {
  __typename?: 'PublicChat';
  groupChat: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  userCount: Scalars['Int']['output'];
};

/** Public project information safe for non-members */
export type PublicProject = {
  __typename?: 'PublicProject';
  address?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hasPendingMemberAdditionRequest: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitationEmail?: Maybe<Scalars['String']['output']>;
  invitationType?: Maybe<Scalars['String']['output']>;
  inviteeRole?: Maybe<Scalars['String']['output']>;
  inviterName?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<PublicProjectMember>>;
  name: Scalars['String']['output'];
  team?: Maybe<PublicProjectTeam>;
  teamName?: Maybe<Scalars['String']['output']>;
  usersCount: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
};

/** Project member info safe for unauthenticated invitation previews */
export type PublicProjectMember = {
  __typename?: 'PublicProjectMember';
  avatar?: Maybe<File>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  role: ProjectMemberRole;
};

/** Minimal team info safe to expose on public project invitation previews */
export type PublicProjectTeam = {
  __typename?: 'PublicProjectTeam';
  avatarFile?: Maybe<File>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Public task information safe for non-members */
export type PublicTask = {
  __typename?: 'PublicTask';
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  hasPendingMemberAdditionRequest: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inviterName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<TaskPriority>;
  projectIcon?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  projectUuid?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  usersCount: Scalars['Int']['output'];
};

/** Public team information safe for non-members */
export type PublicTeam = {
  __typename?: 'PublicTeam';
  address?: Maybe<Scalars['String']['output']>;
  avatarFile?: Maybe<File>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  hasPendingMemberAdditionRequest: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  skills: Array<Skill>;
  totalMembers: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
};

/** Public user information safe for unauthenticated contexts (e.g. invite previews) */
export type PublicUser = {
  __typename?: 'PublicUser';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieves the latest app version configuration */
  appVersions: AppVersions;
  /** Retrieves chat avatars with specified IDs */
  chatAvatarsByIds?: Maybe<Array<File>>;
  /** Checks if user coordinates are within geofence of project coordinates */
  checkGeofence: Scalars['Boolean']['output'];
  /** Retrieves documents associated with specified client IDs */
  documentsByClientIds?: Maybe<Array<Document>>;
  /** Retrieves files with specified IDs */
  filesByIds?: Maybe<Array<File>>;
  /** Retrieves a single chat by its ID */
  getChat: Chat;
  /** Return a draft message for a chat */
  getDraftMessage?: Maybe<DraftMessage>;
  /** Retrieves the feature flag status for the current user */
  getFeatureFlag: FeatureFlag;
  /** Retrieves a group by its ID */
  getGroup?: Maybe<Group>;
  /** Retrieves the current authenticated user's information */
  getMe: User;
  /**
   * Returns whether the current user has an active paid team subscription, and the
   * first owned team eligible for upgrade when paywalled.
   */
  getPaywallStatus: PaywallStatus;
  /** Retrieves a product by its ID */
  getProduct: Product;
  /** Retrieves a user profile by its ID */
  getProfile: Profile;
  /** Retrieves a single project by its ID */
  getProject: Project;
  /** Retrieves activity history for a project tagged in chat */
  getProjectChatActivityReport?: Maybe<Array<Audit>>;
  /** Retrieves a project report by its ID */
  getProjectReport?: Maybe<Scalars['String']['output']>;
  /** Retrieves activity history for a specific task in a project report */
  getProjectTaskActivityReport?: Maybe<Array<Audit>>;
  /** Retrieves detailed information about a specific task in a project report */
  getProjectTaskReport?: Maybe<ProjectTasksReport>;
  /** Retrieves public information for a project by its ID (safe for non-members) */
  getPublicProject: ProjectOrPublicProject;
  /** Retrieves public information for a task by its ID (safe for non-members) */
  getPublicTask: TaskOrPublicTask;
  /** Retrieves public information for a team by its ID (safe for non-members) */
  getPublicTeam: TeamOrPublicTeam;
  /** Returns the Rate Us state for the current user, with zero defaults for first-time users. */
  getRateUsState: RateUsState;
  /** Retrieves a single task by its ID */
  getTask: Task;
  /** Retrieves a team by its ID */
  getTeam: Team;
  /**
   * Return global activity search results. When term is blank, all accessible
   * activities are returned (filter-only mode). When term is present, full-text
   * search is applied.
   */
  globalActivitySearch: Array<Search>;
  /** Retrieves details about an invitation including validity and team ID */
  invitationDetails: InvitationValidity;
  /** Whether an invitation is valid or not */
  invitationValid: Scalars['Boolean']['output'];
  /** Retrieves activity items across all projects the user has access to */
  listActivities?: Maybe<ActivityFeedConnection>;
  /** Retrieves a list of activities for a specific project */
  listActivitiesByProject?: Maybe<AuditConnection>;
  /** Retrieves a list of activities for a specific task */
  listActivitiesByTask?: Maybe<AuditConnection>;
  /** Retrieves all users blocked by the current user */
  listBlockedUsers: Array<User>;
  /** Retrieves all projects and their related tasks tagged in a chat */
  listChatRelatedProjects?: Maybe<ChatProjectTaskConnection>;
  /** Retrieves chats the user participates in or has a pending request for */
  listChatsPagination: ChatConnection;
  /** List available project checklist templates */
  listChecklistTemplates: Array<ChecklistTemplate>;
  /** Retrieves all contacts associated with the current user */
  listContactUsers: Array<User>;
  /** Retrieves all deleted message IDs for a specific chat */
  listDeletedMessageIds: Array<Scalars['ID']['output']>;
  /** Return a list of draft Documents for a chat */
  listDraftDocuments: Array<Document>;
  /** Retrieves all draft messages for a specific chat */
  listDraftMessages: Array<Message>;
  /** Return a list of draft Documents for a project */
  listDraftProjectDocuments: Array<Document>;
  /** Return a list of draft Documents for a task */
  listDraftTaskDocuments: Array<Document>;
  /** Retrieves all feature flag statuses for the current user */
  listFeatureFlags: Array<FeatureFlag>;
  /** Retrieves all contact groups accessible to the current user */
  listGroups?: Maybe<Array<Group>>;
  /** Retrieves all messages for a specific chat */
  listMessages?: Maybe<MessageConnection>;
  /**
   * Retrieves My Tasks grouped by project, priority, or assignee (via `groupBy`,
   * default project), ordered by most-recent group activity for project groups, or
   * a fixed dimension order for priority/assignee groups. For assignee grouping
   * the unassigned bucket (`assignee: null`) is always the first edge of the first
   * page when it is non-empty, ahead of the named assignees (which stay ordered by
   * display name); it is emitted exactly once and never reappears on a later page.
   * Each group exposes its own independently paginated `tasks`/`completedTasks`
   * connections (TA-10312/TA-10373). Note: priority grouping always returns all 3
   * buckets in a single page, so `first` is ignored for that dimension.
   */
  listMyTasksProjectGroups: TaskGroupInterfaceConnection;
  /** Retrieves messages surrounding a specified message ID */
  listNearbyMessages?: Maybe<MessageConnection>;
  /** Retrieves the pinned Needs a Decision rows for a specific project */
  listPendingDecisionsByProject: PendingDecisionsResult;
  /** Retrieves the pinned Needs a Decision rows for a specific task */
  listPendingDecisionsByTask: PendingDecisionsResult;
  /** Retrieves pending user requests for a specific requestable object */
  listPendingUserRequests: Array<UserRequest>;
  /** Retrieves all phases ordered by name */
  listPhases: Array<Phase>;
  /** Retrieves all visible products */
  listProducts: Array<Product>;
  /** Retrieves checklists for a specific project by its ID */
  listProjectChecklist: Array<ProjectChecklist>;
  /** Retrieves all documents associated with specified projects */
  listProjectDocuments?: Maybe<DocumentConnection>;
  /** Retrieves all media files associated with a project report */
  listProjectMedia?: Maybe<Array<Document>>;
  /** Retrieves all tasks associated with a project report */
  listProjectReportTasks?: Maybe<Array<ProjectTasksReport>>;
  /** Retrieves a list of projects based on specified filters */
  listProjects?: Maybe<ProjectConnection>;
  /** Retrieves nearest projects based on latitude and longitude coordinates */
  listProjectsByLocation: Array<Project>;
  /** Retrieves a list of projects scoped by team ID, with an optional filter for user roles. */
  listProjectsByTeam?: Maybe<ProjectConnection>;
  /** Retrieves all projects and their related tasks */
  listProjectsTasks?: Maybe<ProjectTaskConnection>;
  /** Retrieves all projects that have associated documents */
  listProjectsWithDocuments: Array<Project>;
  /** Retrieves all projects excluding those with specified roles */
  listProjectsWithoutSpecifiedRoles?: Maybe<ProjectConnection>;
  /** Retrieves recent projects and their related tasks tagged in a chat */
  listRecentProjectsTasks: Array<RecentProjectTask>;
  /** Retrieves recently updated tasks with their associated projects */
  listRecentTasks: Array<RecentTask>;
  /** Retrieves all skills ordered by name */
  listSkills: Array<Skill>;
  /** Retrieves all tag groups associated with the user */
  listTagGroups: Array<TagGroup>;
  /** Retrieves checklists for a specific task by its ID */
  listTaskChecklist: Array<TaskChecklist>;
  /** Retrieves all documents associated with specified tasks */
  listTaskDocuments?: Maybe<DocumentConnection>;
  /** Retrieves a list of tasks based on specified filters */
  listTasks?: Maybe<TaskConnection>;
  /** Retrieves all teams the user is associated with */
  listTeams: Array<Team>;
  /** Retrieves all unread messages for the current user and their chats */
  listUnreadMessages?: Maybe<MessageConnection>;
  /** Retrieves a list of users matching the search term, excluding contacts */
  listUsers: Array<User>;
  /** Retrieves users associated with a specific team, optionally filtered by search term */
  listUsersByResource: Array<User>;
  /** Retrieves a list of users matching the search term, excluding current user and contacts */
  listUsersPagination?: Maybe<UserConnection>;
  /** Retrieves all documents with pagination support */
  newListDocuments: DocumentCollection;
  /** Retrieves the cover page information for a project report */
  projectReportCoverPage?: Maybe<ReportCoverPage>;
  /** Retrieves an overview of a project report */
  projectReportOverview?: Maybe<ProjectReportOverview>;
  /** Return search results by term */
  search: Array<Search>;
  /** Searches chats the user participates in by chat name or participant name */
  searchChats: ChatConnection;
  /** Search and filter checklist templates */
  searchTemplates: Array<ChecklistTemplate>;
  /** Retrieves documents publically associated with specified client IDs */
  sharedDocumentsByClientIds?: Maybe<Array<Document>>;
  /** Retrieves media documents and sharer info for a media share link by token */
  sharedMediaByToken: SharedMedia;
  /** Retrieves team avatars with specified IDs */
  teamAvatarsByIds?: Maybe<Array<File>>;
  /** Retrieves user avatars with specified IDs */
  userAvatarsByIds?: Maybe<Array<File>>;
  /** Validates if a given content type is supported by the system */
  validateContentType: Scalars['Boolean']['output'];
};

export type QueryChatAvatarsByIdsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryCheckGeofenceArgs = {
  projectLatitude: Scalars['Float']['input'];
  projectLongitude: Scalars['Float']['input'];
  userLatitude: Scalars['Float']['input'];
  userLongitude: Scalars['Float']['input'];
};

export type QueryDocumentsByClientIdsArgs = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryFilesByIdsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetChatArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetDraftMessageArgs = {
  chatId: Scalars['ID']['input'];
};

export type QueryGetFeatureFlagArgs = {
  name: Scalars['String']['input'];
};

export type QueryGetGroupArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetProductArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetProfileArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetProjectArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetProjectChatActivityReportArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  uuid: Scalars['ID']['input'];
};

export type QueryGetProjectReportArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetProjectTaskActivityReportArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  taskId: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type QueryGetProjectTaskReportArgs = {
  taskId: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type QueryGetPublicProjectArgs = {
  id: Scalars['ID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetPublicTaskArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetPublicTeamArgs = {
  id: Scalars['ID']['input'];
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetTaskArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetTeamArgs = {
  id: Scalars['ID']['input'];
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGlobalActivitySearchArgs = {
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  term?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryInvitationDetailsArgs = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  type: Invitation;
};

export type QueryInvitationValidArgs = {
  token: Scalars['String']['input'];
  type: Invitation;
};

export type QueryListActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  scope?: InputMaybe<ActivityScope>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryListActivitiesByProjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
  scope?: InputMaybe<ActivityScope>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryListActivitiesByTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<ActivityScope>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  taskId: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryListChatRelatedProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ProjectSortOption>;
};

export type QueryListChatsPaginationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryListContactUsersArgs = {
  term?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListDeletedMessageIdsArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryListDraftDocumentsArgs = {
  chatId: Scalars['ID']['input'];
};

export type QueryListDraftProjectDocumentsArgs = {
  projectId: Scalars['ID']['input'];
};

export type QueryListDraftTaskDocumentsArgs = {
  taskId: Scalars['ID']['input'];
};

export type QueryListMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chatId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDraft?: InputMaybe<Scalars['Boolean']['input']>;
  includePublished?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryListMyTasksProjectGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collaboratorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  dueDateBegin?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  dueDateEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  dueGroup?: InputMaybe<TaskGroup>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy?: InputMaybe<TaskGroupBy>;
  last?: InputMaybe<Scalars['Int']['input']>;
  memberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  phaseId?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Array<TaskPriority>>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  requireDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<TaskSortOption>;
  status?: InputMaybe<TaskStatus>;
  taskCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  withoutPhase?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryListNearbyMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageId: Scalars['ID']['input'];
  nearbyCount?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryListPendingDecisionsByProjectArgs = {
  projectId: Scalars['ID']['input'];
  viewAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryListPendingDecisionsByTaskArgs = {
  taskId: Scalars['ID']['input'];
  viewAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryListPendingUserRequestsArgs = {
  attributes: UserRequestAttributes;
};

export type QueryListProjectChecklistArgs = {
  uuid: Scalars['ID']['input'];
};

export type QueryListProjectDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeFiles?: InputMaybe<Scalars['Boolean']['input']>;
  includeMedia?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sortBy?: InputMaybe<DocumentSortOption>;
};

export type QueryListProjectMediaArgs = {
  uuid: Scalars['ID']['input'];
};

export type QueryListProjectReportTasksArgs = {
  uuid: Scalars['ID']['input'];
};

export type QueryListProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterTeamsProjects?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  memberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  role?: InputMaybe<ProjectMemberRole>;
  sortBy?: InputMaybe<ProjectSortOption>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryListProjectsByLocationArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type QueryListProjectsByTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<ProjectMemberRole>;
  teamId: Scalars['ID']['input'];
};

export type QueryListProjectsTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  collaboratorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ProjectSortOption>;
};

export type QueryListProjectsWithoutSpecifiedRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  roles: Array<ProjectMemberRole>;
  sortBy?: InputMaybe<ProjectSortOption>;
};

export type QueryListRecentProjectsTasksArgs = {
  chatId: Scalars['ID']['input'];
  collaboratorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryListRecentTasksArgs = {
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  projectCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sortBy?: InputMaybe<TaskSortOption>;
};

export type QueryListTagGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryListTaskChecklistArgs = {
  id: Scalars['ID']['input'];
};

export type QueryListTaskDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeFiles?: InputMaybe<Scalars['Boolean']['input']>;
  includeMedia?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sortBy?: InputMaybe<DocumentSortOption>;
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryListTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  collaboratorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  dueDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  dueDateBegin?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  dueDateEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  dueGroup?: InputMaybe<TaskGroup>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  memberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  phaseId?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Array<TaskPriority>>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sortBy?: InputMaybe<TaskSortOption>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  status?: InputMaybe<TaskStatus>;
  taskCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  withoutDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  withoutPhase?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryListTeamsArgs = {
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<ProjectMemberRole>;
};

export type QueryListUnreadMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryListUsersArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
};

export type QueryListUsersByResourceArgs = {
  teamId: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListUsersPaginationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
};

export type QueryNewListDocumentsArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  includeMedia?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<DocumentSortOption>;
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryProjectReportCoverPageArgs = {
  uuid: Scalars['ID']['input'];
};

export type QueryProjectReportOverviewArgs = {
  uuid: Scalars['ID']['input'];
};

export type QuerySearchArgs = {
  archiveProjectsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  checkins?: InputMaybe<Scalars['Boolean']['input']>;
  collaboratorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  completedTasksOnly?: InputMaybe<Scalars['Boolean']['input']>;
  documentGroup?: InputMaybe<DocumentGroup>;
  documentOwnerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  files?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  includeActivities?: InputMaybe<Scalars['Boolean']['input']>;
  includeChats?: InputMaybe<Scalars['Boolean']['input']>;
  includeCompletedTask?: InputMaybe<Scalars['Boolean']['input']>;
  includeContacts?: InputMaybe<Scalars['Boolean']['input']>;
  includeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  includeGroups?: InputMaybe<Scalars['Boolean']['input']>;
  includeMessages?: InputMaybe<Scalars['Boolean']['input']>;
  includeProjects?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasks?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksTags?: InputMaybe<Scalars['Boolean']['input']>;
  includeTeams?: InputMaybe<Scalars['Boolean']['input']>;
  includeUsers?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectOwnerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Scalars['Boolean']['input']>;
  taskDueDateBegin?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  taskDueDateEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  taskDueGroup?: InputMaybe<TaskGroup>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  taskPriority?: InputMaybe<Array<TaskPriority>>;
  taskSort?: InputMaybe<TaskSearchSortOption>;
  taskUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  term: Scalars['String']['input'];
};

export type QuerySearchChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
};

export type QuerySearchTemplatesArgs = {
  term: Scalars['String']['input'];
};

export type QuerySharedDocumentsByClientIdsArgs = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QuerySharedMediaByTokenArgs = {
  token: Scalars['String']['input'];
};

export type QueryTeamAvatarsByIdsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryUserAvatarsByIdsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryValidateContentTypeArgs = {
  contentType: Scalars['String']['input'];
};

/** Persisted Rate Us state for the current user */
export type RateUsState = {
  __typename?: 'RateUsState';
  hasRated: Scalars['Boolean']['output'];
  permanentlySuppressed: Scalars['Boolean']['output'];
  triggers: RateUsTriggerMap;
};

/** Partial update for a single Rate Us trigger. Omit any field to leave it unchanged. */
export type RateUsTriggerInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  lastPromptAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  promptStage?: InputMaybe<Scalars['Int']['input']>;
};

/** Rate Us per-trigger state for all 6 tracked triggers */
export type RateUsTriggerMap = {
  __typename?: 'RateUsTriggerMap';
  assignTasks: RateUsTriggerState;
  chatTags: RateUsTriggerState;
  checkin: RateUsTriggerState;
  checklist: RateUsTriggerState;
  tasks: RateUsTriggerState;
  uploadMedia: RateUsTriggerState;
};

/** Partial update for Rate Us triggers. Omit any trigger to leave it unchanged. */
export type RateUsTriggerMapInput = {
  assignTasks?: InputMaybe<RateUsTriggerInput>;
  chatTags?: InputMaybe<RateUsTriggerInput>;
  checkin?: InputMaybe<RateUsTriggerInput>;
  checklist?: InputMaybe<RateUsTriggerInput>;
  tasks?: InputMaybe<RateUsTriggerInput>;
  uploadMedia?: InputMaybe<RateUsTriggerInput>;
};

/** Per-trigger Rate Us state — cumulative count, prompt ladder stage, and last prompt time */
export type RateUsTriggerState = {
  __typename?: 'RateUsTriggerState';
  count: Scalars['Int']['output'];
  lastPromptAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  promptStage: Scalars['Int']['output'];
};

/** Attributes for updating read receipts for active log */
export type ReadReceiptAuditAttributes = {
  auditIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Attributes for updating read receipts for chat messages */
export type ReadReceiptChatAttributes = {
  chatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RecentProjectTask = Project | Task;

/** Recent task type representing a recently accessed task in the system */
export type RecentTask = Node & {
  __typename?: 'RecentTask';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  authorId: Scalars['ID']['output'];
  checklists?: Maybe<Array<TaskChecklist>>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  completor?: Maybe<User>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dependencies?: Maybe<Array<Task>>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  members: Array<TaskMember>;
  name: Scalars['String']['output'];
  priority?: Maybe<TaskPriority>;
  project: Project;
  projectId: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userIds: Array<Scalars['ID']['output']>;
};

export type ReplyMessageInput = {
  cacheIdentifier: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Report cover page type representing a cover page in the system */
export type ReportCoverPage = {
  __typename?: 'ReportCoverPage';
  createdAt: Scalars['ISO8601DateTime']['output'];
  generatedBy: Scalars['String']['output'];
  projectName?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Team>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Attributes for saving a project checklist as a template */
export type SaveChecklistAsTemplateAttributes = {
  checklistItemIds: Array<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Search type representing search results in the system */
export type Search = {
  __typename?: 'Search';
  highlight?: Maybe<Highlight>;
  record: SearchableResult;
  total: Scalars['Int']['output'];
};

export type SearchableResult =
  | Audit
  | Chat
  | Document
  | Group
  | Message
  | Project
  | Task
  | Team
  | User;

/** Minimal document fields safe to expose via an unauthenticated media share link token */
export type SharedDocument = {
  __typename?: 'SharedDocument';
  clientId: Scalars['String']['output'];
  file: File;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Media documents and sharer info resolved from a media share link token */
export type SharedMedia = {
  __typename?: 'SharedMedia';
  documents: Array<SharedDocument>;
  sharerAvatar?: Maybe<File>;
  sharerName?: Maybe<Scalars['String']['output']>;
};

/** Skill type representing a skill in the system */
export type Skill = {
  __typename?: 'Skill';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Attributes for creating a Stripe customer and subscription */
export type StripeSubscriptionAttributes = {
  name: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Subscribe to bulk export documents request results */
  bulkExportDocumentsResult?: Maybe<BulkExportDocument>;
  /** Subscribe to chat updates */
  chatUpdate?: Maybe<ChatUpdate>;
  /** Subscribe to personal updates */
  meUpdated: MeUpdatedPayload;
  /** Subscribe to message is deleted by author */
  messageDelete?: Maybe<Message>;
  /** Subscribe to message updates by chat ID */
  messageUpdate?: Maybe<Message>;
  /** Subscribe to project deletion notifications */
  projectDeleted: ProjectDeletedPayload;
  /** Subscribe to project updates */
  projectUpdated?: Maybe<Project>;
  /** Subscribe to task files duplication results */
  taskFilesDuplicated: TaskFilesDuplicatedPayload;
  /** Subscribe to task updates by task ID */
  taskUpdated?: Maybe<Task>;
};

export type SubscriptionMessageDeleteArgs = {
  chatId: Scalars['ID']['input'];
};

export type SubscriptionMessageUpdateArgs = {
  chatId: Scalars['ID']['input'];
};

export type SubscriptionTaskUpdatedArgs = {
  taskId: Scalars['ID']['input'];
};

/** Subscription details type representing subscription information in the system */
export type SubscriptionDetails = {
  __typename?: 'SubscriptionDetails';
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated This field is deprecated, use `expiration_date` instead. */
  currentPeriodEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['ISO8601DateTime']['output']>;
  currentSeatCount?: Maybe<Scalars['Int']['output']>;
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isSubscriptionActive: Scalars['Boolean']['output'];
  isSubscriptionCanceled: Scalars['Boolean']['output'];
  isSubscriptionOnTrial: Scalars['Boolean']['output'];
  paymentCardBrand?: Maybe<Scalars['String']['output']>;
  paymentCardExpMonth?: Maybe<Scalars['String']['output']>;
  paymentCardExpYear?: Maybe<Scalars['String']['output']>;
  paymentCardLast4?: Maybe<Scalars['String']['output']>;
  pricePerSeat?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentId?: Maybe<Scalars['String']['output']>;
  stripePriceId?: Maybe<Scalars['String']['output']>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionInterval?: Maybe<Scalars['String']['output']>;
  subscriptionPlanName?: Maybe<Scalars['String']['output']>;
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
  trialEndsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Tag group type representing a group of tags in the system */
export type TagGroup = {
  __typename?: 'TagGroup';
  author: User;
  createdAt: Scalars['ISO8601DateTime']['output'];
  documents?: Maybe<Array<Document>>;
  id: Scalars['ID']['output'];
  isImageGroup: Scalars['Boolean']['output'];
  message?: Maybe<Message>;
  project: Project;
  task?: Maybe<Task>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Task type representing a task in the system */
export type Task = Node & {
  __typename?: 'Task';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  audits?: Maybe<Array<Audit>>;
  auditsCount?: Maybe<Scalars['Int']['output']>;
  authorId: Scalars['ID']['output'];
  chatTasksCount: Scalars['Int']['output'];
  checklists?: Maybe<Array<TaskChecklist>>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  completor?: Maybe<User>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  currentUserProjectRole?: Maybe<ProjectMemberRole>;
  currentUserProjectTeamRole?: Maybe<TeamMemberRole>;
  currentUserRole?: Maybe<TaskMemberRole>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dependencies?: Maybe<Array<Task>>;
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Document>>;
  dueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dueGroup?: Maybe<Scalars['String']['output']>;
  fixedOrder?: Maybe<Scalars['Boolean']['output']>;
  frequency?: Maybe<TaskFrequency>;
  id: Scalars['ID']['output'];
  invitations?: Maybe<Array<TaskInvitation>>;
  members: Array<TaskMember>;
  name: Scalars['String']['output'];
  phase?: Maybe<Phase>;
  phaseId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<TaskPriority>;
  project: Project;
  projectColor?: Maybe<Scalars['String']['output']>;
  projectIcon?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['ID']['output'];
  projectName?: Maybe<Scalars['String']['output']>;
  projectUuid?: Maybe<Scalars['ID']['output']>;
  recurring?: Maybe<Scalars['Boolean']['output']>;
  requiresCompletionPhoto?: Maybe<Scalars['Boolean']['output']>;
  skillIds?: Maybe<Array<Scalars['ID']['output']>>;
  skills?: Maybe<Array<Skill>>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status?: Maybe<TaskStatus>;
  unreadAudits?: Maybe<Array<Audit>>;
  unreadAuditsCount?: Maybe<Scalars['Int']['output']>;
  userIds: Array<Scalars['ID']['output']>;
  userRequests?: Maybe<Array<UserRequest>>;
};

/** Attributes for creating or updating a task */
export type TaskAttributes = {
  checklists?: InputMaybe<Array<TaskChecklistAttributes>>;
  completedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  completedById?: InputMaybe<Scalars['ID']['input']>;
  dependencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  files?: InputMaybe<Array<DocumentAttributes>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<TaskFrequency>;
  members?: InputMaybe<Array<TaskMemberAttributes>>;
  name: Scalars['String']['input'];
  phaseId?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<TaskPriority>;
  projectId: Scalars['ID']['input'];
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCompletionPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  status?: InputMaybe<TaskStatus>;
  taskMembers?: InputMaybe<Array<TaskMemberRoleAttributes>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Task checklist type representing a checklist item in a task */
export type TaskChecklist = {
  __typename?: 'TaskChecklist';
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sort?: Maybe<Scalars['Int']['output']>;
  taskId: Scalars['ID']['output'];
};

/** Attributes for assigning task membership to a user */
export type TaskChecklistAttributes = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Task. */
export type TaskConnection = {
  __typename?: 'TaskConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TaskEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Task>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Task document type representing a document attached to a task in the system */
export type TaskDocument = {
  __typename?: 'TaskDocument';
  document?: Maybe<Document>;
  id: Scalars['ID']['output'];
  owner?: Maybe<User>;
  task?: Maybe<Task>;
};

/** An edge in a connection. */
export type TaskEdge = {
  __typename?: 'TaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Task>;
};

/** Autogenerated return type of TaskFilesDuplicated. */
export type TaskFilesDuplicatedPayload = {
  __typename?: 'TaskFilesDuplicatedPayload';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  task?: Maybe<Task>;
};

export enum TaskFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

export enum TaskGroup {
  Current = 'CURRENT',
  Overdue = 'OVERDUE',
  Today = 'TODAY',
  Upcoming = 'UPCOMING',
}

export enum TaskGroupBy {
  Assignee = 'ASSIGNEE',
  Priority = 'PRIORITY',
  Project = 'PROJECT',
}

/** A group of the current My Tasks scope, grouped by project, priority, or assignee */
export type TaskGroupInterface = {
  completedCount: Scalars['Int']['output'];
  completedTasks: TaskConnection;
  taskCount: Scalars['Int']['output'];
  tasks: TaskConnection;
};

/** A group of the current My Tasks scope, grouped by project, priority, or assignee */
export type TaskGroupInterfaceCompletedTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A group of the current My Tasks scope, grouped by project, priority, or assignee */
export type TaskGroupInterfaceTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for TaskGroupInterface. */
export type TaskGroupInterfaceConnection = {
  __typename?: 'TaskGroupInterfaceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TaskGroupInterfaceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TaskGroupInterface>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of groups matching the same filters across all pages, independent of `first`/`after` (TA-11028). */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TaskGroupInterfaceEdge = {
  __typename?: 'TaskGroupInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TaskGroupInterface>;
};

/** Task invitation type representing a task invitation */
export type TaskInvitation = {
  __typename?: 'TaskInvitation';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  expiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitedBy?: Maybe<User>;
  role: TaskMemberRole;
};

/** Task member type representing a member of a task in the system */
export type TaskMember = {
  __typename?: 'TaskMember';
  id: Scalars['ID']['output'];
  role: TaskMemberRole;
  subject: Task;
  user: User;
};

/** Attributes for assigning task membership to a user */
export type TaskMemberAttributes = {
  role: TaskMemberRole;
  userId: Scalars['ID']['input'];
};

export enum TaskMemberRole {
  Assignee = 'ASSIGNEE',
  Owner = 'OWNER',
  Viewer = 'VIEWER',
}

/** Attributes for invite a user to be a member when create a task */
export type TaskMemberRoleAttributes = {
  email: Scalars['String']['input'];
  role: TaskMemberRole;
};

/** Returns TaskType if current user is a member, otherwise PublicTaskType */
export type TaskOrPublicTask = PublicTask | Task;

export enum TaskPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export enum TaskSearchSortOption {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DueDateAsc = 'DUE_DATE_ASC',
  DueDateDesc = 'DUE_DATE_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
}

/** The section a task belongs to in the My Tasks view */
export enum TaskSection {
  /** Tasks that have been marked as completed */
  Completed = 'COMPLETED',
  /** Tasks that are currently active and not overdue */
  Current = 'CURRENT',
  /** Tasks whose due date has passed */
  Overdue = 'OVERDUE',
}

export enum TaskSortOption {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DueDate = 'DUE_DATE',
  DueDateAsc = 'DUE_DATE_ASC',
  DueDateDesc = 'DUE_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  /** Sort by due_date ascending (earliest/most-overdue first), then priority descending, then id ascending */
  OverdueLow = 'OVERDUE_LOW',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  ProjectNameAsc = 'PROJECT_NAME_ASC',
  ProjectNameDesc = 'PROJECT_NAME_DESC',
  /** Sort by user-defined rank within a My Tasks section */
  Rank = 'RANK',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
}

export enum TaskStatus {
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  NotStarted = 'NOT_STARTED',
  Ongoing = 'ONGOING',
  OnHold = 'ON_HOLD',
  Overdue = 'OVERDUE',
}

export type TaskTag = {
  __typename?: 'TaskTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project?: Maybe<ProjectTag>;
  projectId: Scalars['ID']['output'];
  status?: Maybe<TaskStatus>;
  userIds: Array<Scalars['ID']['output']>;
};

export type TaskTagCollection = {
  __typename?: 'TaskTagCollection';
  author: User;
  project: ProjectTag;
  tasks: Array<Maybe<TaskTag>>;
};

export type TaskTagCollectionInput = {
  author: TaskTagUserInput;
  project: ProjectTagInput;
  tasks: Array<InputMaybe<TaskTagInput>>;
};

export type TaskTagInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  project?: InputMaybe<ProjectTagInput>;
  projectId: Scalars['ID']['input'];
  status?: InputMaybe<TaskStatus>;
  userIds: Array<Scalars['ID']['input']>;
};

export type TaskTagUserInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Task user type representing a user assigned to a task in the system */
export type TaskUser = {
  __typename?: 'TaskUser';
  id: Scalars['ID']['output'];
  task: Task;
  user?: Maybe<User>;
};

/** Team type representing a team in the system */
export type Team = {
  __typename?: 'Team';
  address?: Maybe<Scalars['String']['output']>;
  /** @deprecated Please use avatarFile to retrieve Team avatars */
  avatar?: Maybe<Scalars['String']['output']>;
  avatarFile?: Maybe<File>;
  billingSource?: Maybe<Scalars['String']['output']>;
  completedTasksCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentUserRole?: Maybe<TeamRole>;
  entitlementExpiration?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fileStorageUsed: Scalars['BigInt']['output'];
  guestsOnly: Scalars['Boolean']['output'];
  hasPendingMemberAdditionRequest: Scalars['Boolean']['output'];
  hasProjects: Scalars['Boolean']['output'];
  hasReachedMaxProjects: Scalars['Boolean']['output'];
  highPriorityCompletionRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  initials: Scalars['String']['output'];
  invitations?: Maybe<Array<TeamInvitation>>;
  invoices?: Maybe<Array<Invoice>>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  maxDocumentStorage: Scalars['BigInt']['output'];
  maxNumberOfProjects: Scalars['Int']['output'];
  mediaStorageUsed: Scalars['BigInt']['output'];
  memberPreviews: Array<TeamMember>;
  /**
   * Paginated full member list for a single team detail view. Not batched — do not
   * nest inside listTeams or another multi-team list.
   */
  membersConnection: TeamMembershipConnection;
  name: Scalars['String']['output'];
  numberOfProjectsUsed: Scalars['Int']['output'];
  onTimeDeliveryRate?: Maybe<Scalars['Float']['output']>;
  owner: User;
  pending: Scalars['Boolean']['output'];
  personal: Scalars['Boolean']['output'];
  /** @deprecated Use SubscriptionDetailsType. */
  plan?: Maybe<Plan>;
  product?: Maybe<Product>;
  projectPreviews: Array<Project>;
  /** @deprecated Use projectPreviews for list-view previews or the root query field `listProjectsByTeam` for paginated project retrieval. */
  projects: Array<Project>;
  skills: Array<Skill>;
  storageRemaining: Scalars['BigInt']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  subscriptionDetails?: Maybe<SubscriptionDetails>;
  tasksCount: Scalars['Int']['output'];
  teamSubscriptionStatus?: Maybe<Scalars['String']['output']>;
  userRequests?: Maybe<Array<UserRequest>>;
  /** @deprecated Use memberPreviews for list-view avatar stacks or membersConnection for paginated full member retrieval. */
  users: Array<User>;
  usersCount: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
};

/** Team type representing a team in the system */
export type TeamMembersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Attributes for creating or updating a team */
export type TeamAttributes = {
  address?: InputMaybe<Scalars['String']['input']>;
  avatarBlobId?: InputMaybe<Scalars['ID']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  members?: InputMaybe<Array<MemberAttributes>>;
  name: Scalars['String']['input'];
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamMembers?: InputMaybe<Array<TeamMemberRoleAttributes>>;
};

/** Team invitation type representing a team invitation */
export type TeamInvitation = {
  __typename?: 'TeamInvitation';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitedBy?: Maybe<User>;
  role?: Maybe<TeamRole>;
  user?: Maybe<User>;
};

/** Team member type representing a member in a team */
export type TeamMember = {
  __typename?: 'TeamMember';
  id: Scalars['ID']['output'];
  role: TeamMemberRole;
  team: Team;
  user: User;
};

export enum TeamMemberRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER',
}

/** Attributes for inviting a user to be a member of a team */
export type TeamMemberRoleAttributes = {
  email: Scalars['String']['input'];
  role: TeamMemberRole;
};

/** Paginated team membership record (see membersConnection on TeamType) */
export type TeamMembership = {
  __typename?: 'TeamMembership';
  id: Scalars['ID']['output'];
  role: TeamMemberRole;
  team: Team;
  user: User;
};

/** The connection type for TeamMembership. */
export type TeamMembershipConnection = {
  __typename?: 'TeamMembershipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TeamMembershipEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TeamMembership>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TeamMembershipEdge = {
  __typename?: 'TeamMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TeamMembership>;
};

/** Returns TeamType if current user is a member, otherwise PublicTeamType */
export type TeamOrPublicTeam = PublicTeam | Team;

export enum TeamRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER',
}

export enum TutoralizationSetting {
  AssignTask = 'ASSIGN_TASK',
  Chat = 'CHAT',
  Hashtag = 'HASHTAG',
  Project = 'PROJECT',
  TagMessage = 'TAG_MESSAGE',
  Task = 'TASK',
  Team = 'TEAM',
}

/** Attributes for updating tutoralization setting */
export type TutoralizationSettingAttributes = {
  close: Scalars['Boolean']['input'];
  settingType: TutoralizationSetting;
};

/** Attributes for updating a project checklist item */
export type UpdateProjectChecklistAttributes = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

/** Partial update for Rate Us state. Booleans are forward-only (true wins). */
export type UpdateRateUsStateAttributes = {
  hasRated?: InputMaybe<Scalars['Boolean']['input']>;
  permanentlySuppressed?: InputMaybe<Scalars['Boolean']['input']>;
  triggers?: InputMaybe<RateUsTriggerMapInput>;
};

/** Attributes for uploading user contacts */
export type UploadContactAttributes = {
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** User type representing a user in the system */
export type User = {
  __typename?: 'User';
  address?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<File>;
  avatarId?: Maybe<Scalars['ID']['output']>;
  avatarIsPreviewable?: Maybe<Scalars['Boolean']['output']>;
  calendarUrl?: Maybe<Scalars['String']['output']>;
  completedWebTutorialFlows?: Maybe<Array<Scalars['String']['output']>>;
  contactsCount: Scalars['Int']['output'];
  contactsSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  friendRequestPending?: Maybe<Scalars['Boolean']['output']>;
  hasSeenTagTooltipNative: Scalars['Boolean']['output'];
  hasSeenTagTooltipWeb: Scalars['Boolean']['output'];
  /**
   * True if any qualifying activity audit (per globalActivitySearch scope) was
   * created after the current user's last activity view. Only resolves for the
   * current user; false for any other user.
   */
  hasUnreadActivity: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inviteUrl: Scalars['String']['output'];
  lastActiveDatetime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notificationSetting?: Maybe<Array<UserNotificationSetting>>;
  onboardingComplete: Scalars['Boolean']['output'];
  onboardingFlow: OnboardingFlow;
  onboardingProgresses: Array<OnboardingProgress>;
  onboardingState: OnboardingState;
  ownedProjectsCount?: Maybe<Scalars['Int']['output']>;
  ownedTasksCount?: Maybe<Scalars['Int']['output']>;
  personalProjectsCount: Scalars['Int']['output'];
  phoneNumber: Scalars['String']['output'];
  primaryTeamId?: Maybe<Scalars['ID']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<Skill>>;
  teamRoles?: Maybe<Array<TeamRole>>;
  teams?: Maybe<Array<Team>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  tutoralizationSetting?: Maybe<Array<UserTutoralizationSetting>>;
  uid?: Maybe<Scalars['String']['output']>;
  unviewedProjectAssignments: Array<Project>;
};

/** Attributes for creating or updating a user */
export type UserAttributes = {
  address?: InputMaybe<Scalars['String']['input']>;
  avatarBlobId?: InputMaybe<Scalars['ID']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  skillIds: Array<Scalars['ID']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

/** User chat setting type representing chat settings for a user in the system */
export type UserChatSetting = {
  __typename?: 'UserChatSetting';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  mute: Scalars['Boolean']['output'];
  pin: Scalars['Boolean']['output'];
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

/** User notification setting type representing notification settings for a user in the system */
export type UserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  duration?: Maybe<NotificationSettingDuration>;
  mute: Scalars['Boolean']['output'];
  settingType: NotificationSetting;
};

/** User project setting type representing project settings for a user in the system */
export type UserProjectSetting = {
  __typename?: 'UserProjectSetting';
  id: Scalars['ID']['output'];
  pin: Scalars['Boolean']['output'];
};

/** User request type representing a user request in the system */
export type UserRequest = {
  __typename?: 'UserRequest';
  canBeReviewed: Scalars['Boolean']['output'];
  canCurrentUserDecide: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  expiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitedBy?: Maybe<User>;
  requestType: UserRequestCategory;
  reviewedBy?: Maybe<User>;
  role?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  user?: Maybe<User>;
  userRequestableId: Scalars['ID']['output'];
  userRequestableType: UserRequestable;
};

/** Attributes for creating user requests */
export type UserRequestAttributes = {
  requestType: UserRequestCategory;
  userRequestableId: Scalars['ID']['input'];
  userRequestableType: UserRequestable;
};

export enum UserRequestCategory {
  MemberAddition = 'MEMBER_ADDITION',
  TeamReactivation = 'TEAM_REACTIVATION',
}

export enum UserRequestable {
  Account = 'ACCOUNT',
  Chat = 'CHAT',
  Project = 'PROJECT',
  Task = 'TASK',
}

/** User task order type representing the order of tasks for a user */
export type UserTaskOrder = {
  __typename?: 'UserTaskOrder';
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  rank?: Maybe<Scalars['BigInt']['output']>;
  section?: Maybe<TaskSection>;
  taskId: Scalars['ID']['output'];
};

/** Tutoralization setting type */
export type UserTutoralizationSetting = {
  __typename?: 'UserTutoralizationSetting';
  close: Scalars['Boolean']['output'];
  settingType: TutoralizationSetting;
};

export enum WebTutorialFlow {
  Chat = 'CHAT',
  ExpandCollapse = 'EXPAND_COLLAPSE',
  InviteMember = 'INVITE_MEMBER',
  ProjectCreation = 'PROJECT_CREATION',
  TagOnChatPanelClosed = 'TAG_ON_CHAT_PANEL_CLOSED',
  TagOnChatPanelOpen = 'TAG_ON_CHAT_PANEL_OPEN',
  TaskCreation = 'TASK_CREATION',
}

type Attachments_Document_Fragment = {
  __typename?: 'Document';
  id: string;
  blobId?: string | null;
  size?: number | null;
  name: string;
  contentType?: string | null;
  clientId: string;
  isImage: boolean;
  isAudio: boolean;
  duration?: number | null;
  file: {
    __typename?: 'File';
    id: string;
    url: string;
    cdnBaseUrl: string;
    path: string;
    isPreviewable: boolean;
    thumbnail?: string | null;
  };
};

type Attachments_EntityUser_Fragment = { __typename?: 'EntityUser' };

type Attachments_Folder_Fragment = { __typename?: 'Folder' };

type Attachments_LocalFile_Fragment = { __typename?: 'LocalFile' };

type Attachments_Message_Fragment = { __typename?: 'Message' };

type Attachments_MessageProject_Fragment = {
  __typename?: 'MessageProject';
  id: string;
  authorId: string;
  author?: {
    __typename?: 'User';
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
  } | null;
  project?: {
    __typename?: 'Project';
    id: string;
    uuid: string;
    name: string;
    team?: {
      __typename?: 'Team';
      subscriptionDetails?: {
        __typename?: 'SubscriptionDetails';
        expirationDate?: any | null;
        subscriptionStatus?: string | null;
      } | null;
    } | null;
  } | null;
};

type Attachments_MessageTask_Fragment = {
  __typename?: 'MessageTask';
  id: string;
  authorId: string;
  author?: {
    __typename?: 'User';
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
  } | null;
  task?: { __typename?: 'Task'; id: string; name: string } | null;
};

type Attachments_MessageTaskAssignment_Fragment = {
  __typename?: 'MessageTaskAssignment';
};

type Attachments_MessageTaskComplete_Fragment = {
  __typename?: 'MessageTaskComplete';
};

type Attachments_Project_Fragment = { __typename?: 'Project' };

type Attachments_ProjectUser_Fragment = { __typename?: 'ProjectUser' };

type Attachments_PublicTeam_Fragment = { __typename?: 'PublicTeam' };

type Attachments_Task_Fragment = { __typename?: 'Task' };

type Attachments_TaskUser_Fragment = { __typename?: 'TaskUser' };

type Attachments_UserRequest_Fragment = { __typename?: 'UserRequest' };

export type AttachmentsFragment =
  | Attachments_Document_Fragment
  | Attachments_EntityUser_Fragment
  | Attachments_Folder_Fragment
  | Attachments_LocalFile_Fragment
  | Attachments_Message_Fragment
  | Attachments_MessageProject_Fragment
  | Attachments_MessageTask_Fragment
  | Attachments_MessageTaskAssignment_Fragment
  | Attachments_MessageTaskComplete_Fragment
  | Attachments_Project_Fragment
  | Attachments_ProjectUser_Fragment
  | Attachments_PublicTeam_Fragment
  | Attachments_Task_Fragment
  | Attachments_TaskUser_Fragment
  | Attachments_UserRequest_Fragment;

export type AvatarDetailFragment = {
  __typename?: 'File';
  id: string;
  cdnBaseUrl: string;
  path: string;
  isPreviewable: boolean;
  thumbnail?: string | null;
};

export type ChatDetailFragment = {
  __typename?: 'Chat';
  id: string;
  name: string;
  description?: string | null;
  avatarUrl?: string | null;
  isGroupChat: boolean;
  messageIcon?: string | null;
  messageBody?: string | null;
  recentActivityAt?: any | null;
  unreadCount?: number | null;
  createdAt: any;
  leaveOn?: any | null;
  isPendingRequest: boolean;
  settings?: {
    __typename?: 'UserChatSetting';
    id: string;
    pin: boolean;
    mute: boolean;
    archivedAt?: any | null;
  } | null;
  users: Array<{
    __typename?: 'User';
    id: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
  }>;
  pendingInvitations: Array<{
    __typename?: 'ChatInvitation';
    email: string;
    expiredAt: any;
    id: string;
  }>;
  userRequests: Array<{
    __typename?: 'UserRequest';
    id: string;
    status: string;
    expiredAt?: any | null;
    user?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email: string;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    } | null;
  }>;
  owner: {
    __typename?: 'User';
    id: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
  };
};

export type DocumentDetailFragment = {
  __typename?: 'Document';
  id: string;
  blobId?: string | null;
  name: string;
  contentType?: string | null;
  createdAt: any;
  size?: number | null;
  isImage: boolean;
  isVideo: boolean;
  clientId: string;
  isAudio: boolean;
  duration?: number | null;
  file: {
    __typename?: 'File';
    id: string;
    cdnBaseUrl: string;
    path: string;
    isPreviewable: boolean;
    thumbnail?: string | null;
  };
  owner: {
    __typename?: 'User';
    id: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    createdAt: any;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
  };
};

export type DraftMessageDetailFragment = {
  __typename?: 'DraftMessage';
  chatId: string;
  body?: string | null;
  tagsCollection: Array<{
    __typename?: 'TaskTagCollection';
    tasks: Array<{
      __typename?: 'TaskTag';
      id: string;
      name: string;
      userIds: Array<string>;
      status?: TaskStatus | null;
      projectId: string;
      project?: {
        __typename?: 'ProjectTag';
        id: string;
        name: string;
        uuid: string;
      } | null;
    } | null>;
    project: {
      __typename?: 'ProjectTag';
      id: string;
      name: string;
      uuid: string;
    };
    author: { __typename?: 'User'; id: string; name?: string | null };
  } | null>;
  localFiles: Array<{
    __typename?: 'LocalFile';
    id: string;
    name: string;
    clientId: string;
    url: string;
    cdnBaseUrl: string;
    path: string;
    contentType: string;
    isImage: boolean;
    isVideo: boolean;
    size?: number | null;
    isAudio: boolean;
    duration?: number | null;
    isPreviewable: boolean;
    thumbnail: string;
    blobId?: string | null;
  } | null>;
  replyMessage?: {
    __typename?: 'Message';
    id: string;
    chatId: string;
    clientId: string;
    body?: string | null;
    createdAt: any;
    isSender: boolean;
    isDraft: boolean;
    publishedAt?: any | null;
    authorId: string;
    authorAvatarId?: string | null;
    authorName?: string | null;
    authorFirstName?: string | null;
    authorLastName?: string | null;
    authorEmail?: string | null;
    readAt?: any | null;
    isRetry: boolean;
    replyId?: string | null;
    readReceipts?: Array<{
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    }> | null;
    checkin?: {
      __typename?: 'MessageCheckin';
      id: string;
      address?: string | null;
      city?: string | null;
      zipcode?: string | null;
      state?: string | null;
      country?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      withinGeofence: boolean;
    } | null;
    userRequest?: {
      __typename?: 'UserRequest';
      id: string;
      requestType: UserRequestCategory;
      status: string;
      canBeReviewed: boolean;
      expiredAt?: any | null;
      userRequestableId: string;
      userRequestableType: UserRequestable;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
      } | null;
      reviewedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
      } | null;
    } | null;
    replyMessage?: {
      __typename?: 'Message';
      id: string;
      chatId: string;
      clientId: string;
      body?: string | null;
      deletedAt?: any | null;
      createdAt: any;
      isSender: boolean;
      isDraft: boolean;
      publishedAt?: any | null;
      authorId: string;
      authorAvatarId?: string | null;
      authorName?: string | null;
      authorFirstName?: string | null;
      authorLastName?: string | null;
      authorEmail?: string | null;
      attachments?: Array<
        | {
            __typename?: 'Document';
            id: string;
            name: string;
            contentType?: string | null;
            createdAt: any;
            size?: number | null;
            isImage: boolean;
            clientId: string;
            isAudio: boolean;
            duration?: number | null;
            file: {
              __typename?: 'File';
              id: string;
              url: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            };
            owner: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              createdAt: any;
            };
          }
        | { __typename?: 'EntityUser' }
        | { __typename?: 'Folder' }
        | { __typename?: 'LocalFile' }
        | { __typename?: 'Message' }
        | {
            __typename?: 'MessageProject';
            id: string;
            authorId: string;
            author?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
            project?: {
              __typename?: 'Project';
              id: string;
              uuid: string;
              name: string;
              team?: {
                __typename?: 'Team';
                subscriptionDetails?: {
                  __typename?: 'SubscriptionDetails';
                  expirationDate?: any | null;
                  subscriptionStatus?: string | null;
                } | null;
              } | null;
            } | null;
          }
        | {
            __typename?: 'MessageTask';
            id: string;
            authorId: string;
            author?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
            task?: {
              __typename?: 'Task';
              id: string;
              projectId: string;
              name: string;
            } | null;
          }
        | {
            __typename?: 'MessageTaskAssignment';
            id: string;
            messageId: string;
            assignees: Array<{
              __typename?: 'User';
              id: string;
              email: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              phoneNumber: string;
              primaryTeamId?: string | null;
              createdAt: any;
              inviteUrl: string;
              avatarId?: string | null;
              avatarIsPreviewable?: boolean | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
              skills?: Array<{
                __typename?: 'Skill';
                id: string;
                name: string;
                createdAt: any;
              }> | null;
            }>;
            task?: {
              __typename?: 'Task';
              id: string;
              name: string;
              deletedAt?: any | null;
              completedAt?: any | null;
            } | null;
          }
        | {
            __typename?: 'MessageTaskComplete';
            id: string;
            messageId: string;
            completor?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
          }
        | { __typename?: 'Project' }
        | { __typename?: 'ProjectUser' }
        | { __typename?: 'PublicTeam' }
        | { __typename?: 'Task' }
        | { __typename?: 'TaskUser' }
        | { __typename?: 'UserRequest' }
      > | null;
    } | null;
    attachments?: Array<
      | {
          __typename?: 'Document';
          id: string;
          blobId?: string | null;
          name: string;
          contentType?: string | null;
          createdAt: any;
          size?: number | null;
          isImage: boolean;
          clientId: string;
          isAudio: boolean;
          duration?: number | null;
          file: {
            __typename?: 'File';
            id: string;
            url: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          };
          owner: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            createdAt: any;
          };
          taskDocuments?: Array<{
            __typename?: 'TaskDocument';
            id: string;
            owner?: { __typename?: 'User'; id: string } | null;
            task?: {
              __typename?: 'Task';
              id: string;
              name: string;
              projectId: string;
              project: { __typename?: 'Project'; id: string; name: string };
            } | null;
          }> | null;
          projectDocuments?: Array<{
            __typename?: 'ProjectDocument';
            id: string;
            owner?: { __typename?: 'User'; id: string } | null;
            project?: {
              __typename?: 'Project';
              id: string;
              name: string;
            } | null;
          }> | null;
        }
      | { __typename?: 'EntityUser' }
      | { __typename?: 'Folder' }
      | { __typename?: 'LocalFile' }
      | { __typename?: 'Message' }
      | {
          __typename?: 'MessageProject';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
          project?: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
            team?: {
              __typename?: 'Team';
              subscriptionDetails?: {
                __typename?: 'SubscriptionDetails';
                expirationDate?: any | null;
                subscriptionStatus?: string | null;
              } | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'MessageTask';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
          task?: {
            __typename?: 'Task';
            id: string;
            projectId: string;
            deletedAt?: any | null;
            name: string;
          } | null;
        }
      | {
          __typename?: 'MessageTaskAssignment';
          id: string;
          messageId: string;
          assignees: Array<{
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          }>;
          task?: {
            __typename?: 'Task';
            id: string;
            name: string;
            deletedAt?: any | null;
            completedAt?: any | null;
            currentUserRole?: TaskMemberRole | null;
          } | null;
        }
      | {
          __typename?: 'MessageTaskComplete';
          id: string;
          messageId: string;
          completor?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
        }
      | { __typename?: 'Project' }
      | { __typename?: 'ProjectUser' }
      | { __typename?: 'PublicTeam' }
      | { __typename?: 'Task' }
      | { __typename?: 'TaskUser' }
      | { __typename?: 'UserRequest' }
    > | null;
    reaction?: Array<{
      __typename?: 'MessageReaction';
      id: string;
      reaction: string;
      count: number;
      user?: Array<{
        __typename?: 'User';
        id: string;
        name?: string | null;
      }> | null;
    }> | null;
  } | null;
  checkin?: {
    __typename?: 'MessageCheckin';
    id: string;
    address?: string | null;
    city?: string | null;
    zipcode?: string | null;
    state?: string | null;
    country?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    withinGeofence: boolean;
  } | null;
};

export type FileDetailsFragment = {
  __typename?: 'File';
  id: string;
  url: string;
  cdnBaseUrl: string;
  path: string;
  isPreviewable: boolean;
  thumbnail?: string | null;
};

export type GetChatDetailFragment = {
  __typename?: 'Chat';
  id: string;
  name: string;
  description?: string | null;
  avatarUrl?: string | null;
  isGroupChat: boolean;
  messageIcon?: string | null;
  messageBody?: string | null;
  recentActivityAt?: any | null;
  unreadCount?: number | null;
  isNewChat?: boolean | null;
  isUserBlocked?: boolean | null;
  canCurrentUserDecide: boolean;
  isPendingRequest: boolean;
  friendRequestAccepted?: boolean | null;
  createdAt: any;
  leaveOn?: any | null;
  userIds: Array<string>;
  avatar?: {
    __typename?: 'File';
    id: string;
    cdnBaseUrl: string;
    path: string;
    isPreviewable: boolean;
    thumbnail?: string | null;
  } | null;
  owner: {
    __typename?: 'User';
    id: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
  };
  settings?: {
    __typename?: 'UserChatSetting';
    id: string;
    pin: boolean;
    mute: boolean;
    archivedAt?: any | null;
  } | null;
  users: Array<{
    __typename?: 'User';
    id: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email: string;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
  }>;
  pendingInvitations: Array<{
    __typename?: 'ChatInvitation';
    email: string;
    expiredAt: any;
    id: string;
  }>;
  userRequests: Array<{
    __typename?: 'UserRequest';
    id: string;
    status: string;
    expiredAt?: any | null;
    user?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email: string;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    } | null;
  }>;
};

export type LocalDocumentDetailFragment = {
  __typename?: 'Document';
  id: string;
  blobId?: string | null;
  name: string;
  contentType?: string | null;
  createdAt: any;
  size?: number | null;
  isImage: boolean;
  isVideo: boolean;
  clientId: string;
  isAudio: boolean;
  duration?: number | null;
  failedAt: any;
  file: {
    __typename?: 'File';
    id: string;
    cdnBaseUrl: string;
    path: string;
    isPreviewable: boolean;
    thumbnail?: string | null;
    url: string;
  };
  owner: {
    __typename?: 'User';
    id: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    createdAt: any;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
  };
};

export type CheckinDetailFragment = {
  __typename?: 'MessageCheckin';
  id: string;
  address?: string | null;
  city?: string | null;
  zipcode?: string | null;
  state?: string | null;
  country?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  withinGeofence: boolean;
};

export type MessageDetailForQueryFragment = {
  __typename?: 'Message';
  id: string;
  chatId: string;
  clientId: string;
  body?: string | null;
  createdAt: any;
  isSender: boolean;
  isDraft: boolean;
  publishedAt?: any | null;
  authorId: string;
  authorAvatarId?: string | null;
  authorName?: string | null;
  authorFirstName?: string | null;
  authorLastName?: string | null;
  authorEmail?: string | null;
  readAt?: any | null;
  isRetry: boolean;
  replyId?: string | null;
  readReceipts?: Array<{
    __typename?: 'User';
    id: string;
    email: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber: string;
    primaryTeamId?: string | null;
    createdAt: any;
    inviteUrl: string;
    avatarId?: string | null;
    avatarIsPreviewable?: boolean | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    skills?: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }> | null;
  }> | null;
  checkin?: {
    __typename?: 'MessageCheckin';
    id: string;
    address?: string | null;
    city?: string | null;
    zipcode?: string | null;
    state?: string | null;
    country?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    withinGeofence: boolean;
  } | null;
  userRequest?: {
    __typename?: 'UserRequest';
    id: string;
    requestType: UserRequestCategory;
    status: string;
    canBeReviewed: boolean;
    expiredAt?: any | null;
    userRequestableId: string;
    userRequestableType: UserRequestable;
    invitedBy?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
    } | null;
    reviewedBy?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
    } | null;
    user?: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
    } | null;
  } | null;
  replyMessage?: {
    __typename?: 'Message';
    id: string;
    chatId: string;
    clientId: string;
    body?: string | null;
    deletedAt?: any | null;
    createdAt: any;
    isSender: boolean;
    isDraft: boolean;
    publishedAt?: any | null;
    authorId: string;
    authorAvatarId?: string | null;
    authorName?: string | null;
    authorFirstName?: string | null;
    authorLastName?: string | null;
    authorEmail?: string | null;
    attachments?: Array<
      | {
          __typename?: 'Document';
          id: string;
          name: string;
          contentType?: string | null;
          createdAt: any;
          size?: number | null;
          isImage: boolean;
          clientId: string;
          isAudio: boolean;
          duration?: number | null;
          file: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            url: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          };
          owner: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            createdAt: any;
          };
        }
      | { __typename?: 'EntityUser' }
      | { __typename?: 'Folder' }
      | { __typename?: 'LocalFile' }
      | { __typename?: 'Message' }
      | {
          __typename?: 'MessageProject';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: { __typename?: 'File'; id: string } | null;
          } | null;
          project?: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
            team?: {
              __typename?: 'Team';
              subscriptionDetails?: {
                __typename?: 'SubscriptionDetails';
                expirationDate?: any | null;
                subscriptionStatus?: string | null;
              } | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'MessageTask';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: { __typename?: 'File'; id: string } | null;
          } | null;
          task?: {
            __typename?: 'Task';
            id: string;
            projectId: string;
            name: string;
          } | null;
        }
      | {
          __typename?: 'MessageTaskAssignment';
          id: string;
          messageId: string;
          assignees: Array<{
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          }>;
          task?: {
            __typename?: 'Task';
            id: string;
            name: string;
            deletedAt?: any | null;
            completedAt?: any | null;
          } | null;
        }
      | {
          __typename?: 'MessageTaskComplete';
          id: string;
          messageId: string;
          completor?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: { __typename?: 'File'; id: string } | null;
          } | null;
        }
      | { __typename?: 'Project' }
      | { __typename?: 'ProjectUser' }
      | { __typename?: 'PublicTeam' }
      | { __typename?: 'Task' }
      | { __typename?: 'TaskUser' }
      | { __typename?: 'UserRequest' }
    > | null;
  } | null;
  attachments?: Array<
    | {
        __typename?: 'Document';
        id: string;
        blobId?: string | null;
        name: string;
        contentType?: string | null;
        createdAt: any;
        size?: number | null;
        isImage: boolean;
        clientId: string;
        isAudio: boolean;
        duration?: number | null;
        file: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          url: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        };
        owner: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          createdAt: any;
        };
        taskDocuments?: Array<{
          __typename?: 'TaskDocument';
          id: string;
          owner?: { __typename?: 'User'; id: string } | null;
          task?: {
            __typename?: 'Task';
            id: string;
            name: string;
            projectId: string;
            project: { __typename?: 'Project'; id: string; name: string };
          } | null;
        }> | null;
        projectDocuments?: Array<{
          __typename?: 'ProjectDocument';
          id: string;
          owner?: { __typename?: 'User'; id: string } | null;
          project?: { __typename?: 'Project'; id: string; name: string } | null;
        }> | null;
      }
    | { __typename?: 'EntityUser' }
    | { __typename?: 'Folder' }
    | { __typename?: 'LocalFile' }
    | { __typename?: 'Message' }
    | {
        __typename?: 'MessageProject';
        id: string;
        authorId: string;
        author?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          avatar?: { __typename?: 'File'; id: string } | null;
        } | null;
        project?: {
          __typename?: 'Project';
          id: string;
          uuid: string;
          name: string;
          team?: {
            __typename?: 'Team';
            subscriptionDetails?: {
              __typename?: 'SubscriptionDetails';
              expirationDate?: any | null;
              subscriptionStatus?: string | null;
            } | null;
          } | null;
        } | null;
      }
    | {
        __typename?: 'MessageTask';
        id: string;
        authorId: string;
        author?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          avatar?: { __typename?: 'File'; id: string } | null;
        } | null;
        task?: {
          __typename?: 'Task';
          id: string;
          projectId: string;
          deletedAt?: any | null;
          name: string;
          priority?: TaskPriority | null;
          dueDate?: any | null;
          members: Array<{
            __typename?: 'TaskMember';
            id: string;
            role: TaskMemberRole;
            user: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: { __typename?: 'File'; id: string } | null;
            };
          }>;
        } | null;
      }
    | {
        __typename?: 'MessageTaskAssignment';
        id: string;
        messageId: string;
        assignees: Array<{
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName?: string | null;
          avatar?: { __typename?: 'File'; id: string } | null;
        }>;
        task?: {
          __typename?: 'Task';
          id: string;
          name: string;
          deletedAt?: any | null;
          completedAt?: any | null;
          currentUserRole?: TaskMemberRole | null;
        } | null;
      }
    | {
        __typename?: 'MessageTaskComplete';
        id: string;
        messageId: string;
        completor?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          avatar?: { __typename?: 'File'; id: string } | null;
        } | null;
      }
    | { __typename?: 'Project' }
    | { __typename?: 'ProjectUser' }
    | {
        __typename?: 'PublicTeam';
        uuid: string;
        name: string;
        hasPendingMemberAdditionRequest: boolean;
        avatarFile?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      }
    | { __typename?: 'Task' }
    | { __typename?: 'TaskUser' }
    | { __typename?: 'UserRequest' }
  > | null;
  reaction?: Array<{
    __typename?: 'MessageReaction';
    id: string;
    reaction: string;
    count: number;
    user?: Array<{
      __typename?: 'User';
      id: string;
      name?: string | null;
    }> | null;
  }> | null;
};

export type MessageDetailFragment = {
  __typename?: 'Message';
  id: string;
  chatId: string;
  clientId: string;
  body?: string | null;
  createdAt: any;
  isSender: boolean;
  isDraft: boolean;
  publishedAt?: any | null;
  authorId: string;
  authorAvatarId?: string | null;
  authorName?: string | null;
  authorFirstName?: string | null;
  authorLastName?: string | null;
  authorEmail?: string | null;
  readAt?: any | null;
  isRetry: boolean;
  replyId?: string | null;
  readReceipts?: Array<{
    __typename?: 'User';
    id: string;
    email: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber: string;
    primaryTeamId?: string | null;
    createdAt: any;
    inviteUrl: string;
    avatarId?: string | null;
    avatarIsPreviewable?: boolean | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    skills?: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }> | null;
  }> | null;
  checkin?: {
    __typename?: 'MessageCheckin';
    id: string;
    address?: string | null;
    city?: string | null;
    zipcode?: string | null;
    state?: string | null;
    country?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    withinGeofence: boolean;
  } | null;
  userRequest?: {
    __typename?: 'UserRequest';
    id: string;
    requestType: UserRequestCategory;
    status: string;
    canBeReviewed: boolean;
    expiredAt?: any | null;
    userRequestableId: string;
    userRequestableType: UserRequestable;
    invitedBy?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
    } | null;
    reviewedBy?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
    } | null;
    user?: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
    } | null;
  } | null;
  replyMessage?: {
    __typename?: 'Message';
    id: string;
    chatId: string;
    clientId: string;
    body?: string | null;
    deletedAt?: any | null;
    createdAt: any;
    isSender: boolean;
    isDraft: boolean;
    publishedAt?: any | null;
    authorId: string;
    authorAvatarId?: string | null;
    authorName?: string | null;
    authorFirstName?: string | null;
    authorLastName?: string | null;
    authorEmail?: string | null;
    attachments?: Array<
      | {
          __typename?: 'Document';
          id: string;
          name: string;
          contentType?: string | null;
          createdAt: any;
          size?: number | null;
          isImage: boolean;
          clientId: string;
          isAudio: boolean;
          duration?: number | null;
          file: {
            __typename?: 'File';
            id: string;
            url: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          };
          owner: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            createdAt: any;
          };
        }
      | { __typename?: 'EntityUser' }
      | { __typename?: 'Folder' }
      | { __typename?: 'LocalFile' }
      | { __typename?: 'Message' }
      | {
          __typename?: 'MessageProject';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
          project?: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
            team?: {
              __typename?: 'Team';
              subscriptionDetails?: {
                __typename?: 'SubscriptionDetails';
                expirationDate?: any | null;
                subscriptionStatus?: string | null;
              } | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'MessageTask';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
          task?: {
            __typename?: 'Task';
            id: string;
            projectId: string;
            name: string;
          } | null;
        }
      | {
          __typename?: 'MessageTaskAssignment';
          id: string;
          messageId: string;
          assignees: Array<{
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          }>;
          task?: {
            __typename?: 'Task';
            id: string;
            name: string;
            deletedAt?: any | null;
            completedAt?: any | null;
          } | null;
        }
      | {
          __typename?: 'MessageTaskComplete';
          id: string;
          messageId: string;
          completor?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
        }
      | { __typename?: 'Project' }
      | { __typename?: 'ProjectUser' }
      | { __typename?: 'PublicTeam' }
      | { __typename?: 'Task' }
      | { __typename?: 'TaskUser' }
      | { __typename?: 'UserRequest' }
    > | null;
  } | null;
  attachments?: Array<
    | {
        __typename?: 'Document';
        id: string;
        blobId?: string | null;
        name: string;
        contentType?: string | null;
        createdAt: any;
        size?: number | null;
        isImage: boolean;
        clientId: string;
        isAudio: boolean;
        duration?: number | null;
        file: {
          __typename?: 'File';
          id: string;
          url: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        };
        owner: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          createdAt: any;
        };
        taskDocuments?: Array<{
          __typename?: 'TaskDocument';
          id: string;
          owner?: { __typename?: 'User'; id: string } | null;
          task?: {
            __typename?: 'Task';
            id: string;
            name: string;
            projectId: string;
            project: { __typename?: 'Project'; id: string; name: string };
          } | null;
        }> | null;
        projectDocuments?: Array<{
          __typename?: 'ProjectDocument';
          id: string;
          owner?: { __typename?: 'User'; id: string } | null;
          project?: { __typename?: 'Project'; id: string; name: string } | null;
        }> | null;
      }
    | { __typename?: 'EntityUser' }
    | { __typename?: 'Folder' }
    | { __typename?: 'LocalFile' }
    | { __typename?: 'Message' }
    | {
        __typename?: 'MessageProject';
        id: string;
        authorId: string;
        author?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        } | null;
        project?: {
          __typename?: 'Project';
          id: string;
          uuid: string;
          name: string;
          team?: {
            __typename?: 'Team';
            subscriptionDetails?: {
              __typename?: 'SubscriptionDetails';
              expirationDate?: any | null;
              subscriptionStatus?: string | null;
            } | null;
          } | null;
        } | null;
      }
    | {
        __typename?: 'MessageTask';
        id: string;
        authorId: string;
        author?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        } | null;
        task?: {
          __typename?: 'Task';
          id: string;
          projectId: string;
          deletedAt?: any | null;
          name: string;
        } | null;
      }
    | {
        __typename?: 'MessageTaskAssignment';
        id: string;
        messageId: string;
        assignees: Array<{
          __typename?: 'User';
          id: string;
          name?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        }>;
        task?: {
          __typename?: 'Task';
          id: string;
          name: string;
          deletedAt?: any | null;
          completedAt?: any | null;
          currentUserRole?: TaskMemberRole | null;
        } | null;
      }
    | {
        __typename?: 'MessageTaskComplete';
        id: string;
        messageId: string;
        completor?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        } | null;
      }
    | { __typename?: 'Project' }
    | { __typename?: 'ProjectUser' }
    | { __typename?: 'PublicTeam' }
    | { __typename?: 'Task' }
    | { __typename?: 'TaskUser' }
    | { __typename?: 'UserRequest' }
  > | null;
  reaction?: Array<{
    __typename?: 'MessageReaction';
    id: string;
    reaction: string;
    count: number;
    user?: Array<{
      __typename?: 'User';
      id: string;
      name?: string | null;
    }> | null;
  }> | null;
};

export type MessageUpdateLiteFragment = {
  __typename?: 'Message';
  id: string;
  chatId: string;
  clientId: string;
  body?: string | null;
  createdAt: any;
  isSender: boolean;
  isDraft: boolean;
  publishedAt?: any | null;
  authorId: string;
  authorAvatarId?: string | null;
  authorName?: string | null;
  authorFirstName?: string | null;
  authorLastName?: string | null;
  authorEmail?: string | null;
  readAt?: any | null;
  isRetry: boolean;
  replyId?: string | null;
  readReceipts?: Array<{
    __typename?: 'User';
    id: string;
    name?: string | null;
  }> | null;
  checkin?: {
    __typename?: 'MessageCheckin';
    id: string;
    address?: string | null;
    city?: string | null;
    zipcode?: string | null;
    state?: string | null;
    country?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    withinGeofence: boolean;
  } | null;
  userRequest?: {
    __typename?: 'UserRequest';
    id: string;
    requestType: UserRequestCategory;
    status: string;
    canBeReviewed: boolean;
    expiredAt?: any | null;
    userRequestableId: string;
    userRequestableType: UserRequestable;
    invitedBy?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
    } | null;
    reviewedBy?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
    } | null;
    user?: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
    } | null;
  } | null;
  replyMessage?: {
    __typename?: 'Message';
    id: string;
    chatId: string;
    clientId: string;
    body?: string | null;
    deletedAt?: any | null;
    createdAt: any;
    isSender: boolean;
    isDraft: boolean;
    publishedAt?: any | null;
    authorId: string;
    authorAvatarId?: string | null;
    authorName?: string | null;
    authorFirstName?: string | null;
    authorLastName?: string | null;
    authorEmail?: string | null;
  } | null;
  attachments?: Array<
    | {
        __typename?: 'Document';
        id: string;
        blobId?: string | null;
        name: string;
        contentType?: string | null;
        createdAt: any;
        size?: number | null;
        isImage: boolean;
        clientId: string;
        isAudio: boolean;
        duration?: number | null;
        file: {
          __typename?: 'File';
          id: string;
          url: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        };
        owner: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          createdAt: any;
        };
        taskDocuments?: Array<{
          __typename?: 'TaskDocument';
          id: string;
          owner?: { __typename?: 'User'; id: string } | null;
          task?: {
            __typename?: 'Task';
            id: string;
            name: string;
            projectId: string;
            project: { __typename?: 'Project'; id: string; name: string };
          } | null;
        }> | null;
        projectDocuments?: Array<{
          __typename?: 'ProjectDocument';
          id: string;
          owner?: { __typename?: 'User'; id: string } | null;
          project?: { __typename?: 'Project'; id: string; name: string } | null;
        }> | null;
      }
    | { __typename?: 'EntityUser' }
    | { __typename?: 'Folder' }
    | { __typename?: 'LocalFile' }
    | { __typename?: 'Message' }
    | {
        __typename?: 'MessageProject';
        id: string;
        authorId: string;
        author?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        } | null;
        project?: {
          __typename?: 'Project';
          id: string;
          uuid: string;
          name: string;
          team?: {
            __typename?: 'Team';
            subscriptionDetails?: {
              __typename?: 'SubscriptionDetails';
              expirationDate?: any | null;
              subscriptionStatus?: string | null;
            } | null;
          } | null;
        } | null;
      }
    | {
        __typename?: 'MessageTask';
        id: string;
        authorId: string;
        author?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        } | null;
        task?: {
          __typename?: 'Task';
          id: string;
          projectId: string;
          deletedAt?: any | null;
          name: string;
        } | null;
      }
    | {
        __typename?: 'MessageTaskAssignment';
        id: string;
        messageId: string;
        assignees: Array<{
          __typename?: 'User';
          id: string;
          name?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        }>;
        task?: {
          __typename?: 'Task';
          id: string;
          name: string;
          deletedAt?: any | null;
          completedAt?: any | null;
          currentUserRole?: TaskMemberRole | null;
        } | null;
      }
    | {
        __typename?: 'MessageTaskComplete';
        id: string;
        messageId: string;
        completor?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        } | null;
      }
    | { __typename?: 'Project' }
    | { __typename?: 'ProjectUser' }
    | { __typename?: 'PublicTeam' }
    | { __typename?: 'Task' }
    | { __typename?: 'TaskUser' }
    | { __typename?: 'UserRequest' }
  > | null;
  reaction?: Array<{
    __typename?: 'MessageReaction';
    id: string;
    reaction: string;
    count: number;
    user?: Array<{
      __typename?: 'User';
      id: string;
      name?: string | null;
    }> | null;
  }> | null;
};

export type MyTasksGroupTaskFragment = {
  __typename?: 'Task';
  id: string;
  name: string;
  status?: TaskStatus | null;
  priority?: TaskPriority | null;
  startDate?: any | null;
  dueDate?: any | null;
  completedAt?: any | null;
  createdAt: any;
  projectId: string;
  currentUserRole?: TaskMemberRole | null;
  currentUserProjectRole?: ProjectMemberRole | null;
  currentUserProjectTeamRole?: TeamMemberRole | null;
  project: {
    __typename?: 'Project';
    id: string;
    name: string;
    icon?: string | null;
    color: string;
  };
  members: Array<{
    __typename?: 'TaskMember';
    role: TaskMemberRole;
    user: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    };
  }>;
};

export type PageInfoFragment = {
  __typename?: 'PageInfo';
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  endCursor?: string | null;
  startCursor?: string | null;
};

export type ProjectDetailFragment = {
  __typename?: 'Project';
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  archivedAt?: any | null;
  usersCount: number;
  tasksCount: number;
  currentUserRole?: ProjectMemberRole | null;
  currentUserTeamRole?: TeamMemberRole | null;
  currentUserHasPendingMemberAdditionRequest: boolean;
  isTaskMember: boolean;
  teamId: string;
  color: string;
  icon?: string | null;
  createdAt: any;
  description?: string | null;
  id: string;
  uuid: string;
  initials: string;
  name: string;
  unreadAuditsCount?: number | null;
  activeTasksCount: number;
  upcomingTasksCount: number;
  overdueTasksCount: number;
  completedTasksCount: number;
  completedChecklistCount: number;
  creator: {
    __typename?: 'User';
    id: string;
    email: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber: string;
    primaryTeamId?: string | null;
    createdAt: any;
    inviteUrl: string;
    avatarId?: string | null;
    avatarIsPreviewable?: boolean | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    skills?: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }> | null;
  };
  coverImage?: {
    __typename?: 'File';
    id: string;
    url: string;
    cdnBaseUrl: string;
    path: string;
    isPreviewable: boolean;
    thumbnail?: string | null;
  } | null;
  team?: {
    __typename?: 'Team';
    avatar?: string | null;
    createdAt: any;
    id: string;
    uuid: string;
    name: string;
    personal: boolean;
    hasReachedMaxProjects: boolean;
    currentUserRole?: TeamRole | null;
    storageRemaining: any;
    owner: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    subscriptionDetails?: {
      __typename?: 'SubscriptionDetails';
      expirationDate?: any | null;
      subscriptionInterval?: string | null;
      subscriptionPlanName?: string | null;
      subscriptionStatus?: string | null;
      isSubscriptionCanceled: boolean;
      isSubscriptionActive: boolean;
      isSubscriptionOnTrial: boolean;
      trialEndsAt?: any | null;
      updatedAt?: any | null;
    } | null;
  } | null;
  memberPreviews: Array<{
    __typename?: 'ProjectMember';
    id: string;
    role: ProjectMemberRole;
    user: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        url: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
  }>;
  members: Array<{
    __typename?: 'ProjectMember';
    id: string;
    role: ProjectMemberRole;
    user: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        url: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
  }>;
  audits?: Array<{ __typename?: 'Audit'; id: string; event: string }> | null;
  settings?: {
    __typename?: 'UserProjectSetting';
    id: string;
    pin: boolean;
  } | null;
  invitations?: Array<{
    __typename?: 'ProjectInvitation';
    id: string;
    email: string;
    role: ProjectMemberRole;
    expiredAt?: any | null;
    createdAt: any;
    invitedBy: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    };
  }> | null;
  userRequests?: Array<{
    __typename?: 'UserRequest';
    id: string;
    role?: string | null;
    status: string;
    expiredAt?: any | null;
    createdAt: any;
    requestType: UserRequestCategory;
    userRequestableId: string;
    userRequestableType: UserRequestable;
    user?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    } | null;
    invitedBy?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    } | null;
    reviewedBy?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
  }> | null;
};

export type ProjectListNodeFragment = {
  __typename?: 'Project';
  id: string;
  uuid: string;
  name: string;
  initials: string;
  description?: string | null;
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  archivedAt?: any | null;
  usersCount: number;
  tasksCount: number;
  currentUserRole?: ProjectMemberRole | null;
  teamId: string;
  color: string;
  icon?: string | null;
  createdAt: any;
  team?: {
    __typename?: 'Team';
    id: string;
    name: string;
    personal: boolean;
    avatarFile?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
  } | null;
  creator: {
    __typename?: 'User';
    id: string;
    name?: string | null;
    firstName?: string | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      thumbnail?: string | null;
    } | null;
  };
  settings?: {
    __typename?: 'UserProjectSetting';
    id: string;
    pin: boolean;
  } | null;
};

export type PublicUserDetailFragment = {
  __typename?: 'User';
  id: string;
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  avatar?: {
    __typename?: 'File';
    id: string;
    url: string;
    cdnBaseUrl: string;
    path: string;
    isPreviewable: boolean;
    thumbnail?: string | null;
  } | null;
};

export type RateUsTriggerStateDetailFragment = {
  __typename?: 'RateUsTriggerState';
  count: number;
  promptStage: number;
  lastPromptAt?: any | null;
};

export type RateUsStateDetailFragment = {
  __typename?: 'RateUsState';
  hasRated: boolean;
  permanentlySuppressed: boolean;
  triggers: {
    __typename?: 'RateUsTriggerMap';
    uploadMedia: {
      __typename?: 'RateUsTriggerState';
      count: number;
      promptStage: number;
      lastPromptAt?: any | null;
    };
    checkin: {
      __typename?: 'RateUsTriggerState';
      count: number;
      promptStage: number;
      lastPromptAt?: any | null;
    };
    checklist: {
      __typename?: 'RateUsTriggerState';
      count: number;
      promptStage: number;
      lastPromptAt?: any | null;
    };
    tasks: {
      __typename?: 'RateUsTriggerState';
      count: number;
      promptStage: number;
      lastPromptAt?: any | null;
    };
    chatTags: {
      __typename?: 'RateUsTriggerState';
      count: number;
      promptStage: number;
      lastPromptAt?: any | null;
    };
    assignTasks: {
      __typename?: 'RateUsTriggerState';
      count: number;
      promptStage: number;
      lastPromptAt?: any | null;
    };
  };
};

export type TaskDetailFragment = {
  __typename?: 'Task';
  id: string;
  name: string;
  status?: TaskStatus | null;
  priority?: TaskPriority | null;
  startDate?: any | null;
  dueDate?: any | null;
  completedAt?: any | null;
  createdAt: any;
  phaseId?: string | null;
  projectId: string;
  deletedAt?: any | null;
  skillIds?: Array<string> | null;
  userIds: Array<string>;
  dueGroup?: string | null;
  fixedOrder?: boolean | null;
  recurring?: boolean | null;
  description?: string | null;
  frequency?: TaskFrequency | null;
  currentUserRole?: TaskMemberRole | null;
  currentUserProjectRole?: ProjectMemberRole | null;
  currentUserProjectTeamRole?: TeamMemberRole | null;
  project: {
    __typename?: 'Project';
    id: string;
    uuid: string;
    name: string;
    color: string;
    icon?: string | null;
    currentUserTeamRole?: TeamMemberRole | null;
    currentUserRole?: ProjectMemberRole | null;
    initials: string;
    archivedAt?: any | null;
    team?: {
      __typename?: 'Team';
      avatar?: string | null;
      createdAt: any;
      id: string;
      name: string;
      personal: boolean;
      subscriptionDetails?: {
        __typename?: 'SubscriptionDetails';
        expirationDate?: any | null;
        subscriptionStatus?: string | null;
        isSubscriptionCanceled: boolean;
        isSubscriptionActive: boolean;
        isSubscriptionOnTrial: boolean;
        paymentCardLast4?: string | null;
      } | null;
    } | null;
  };
  dependencies?: Array<{
    __typename?: 'Task';
    id: string;
    name: string;
  }> | null;
  checklists?: Array<{
    __typename?: 'TaskChecklist';
    id: string;
    name: string;
    completedAt?: any | null;
    createdAt: any;
  }> | null;
  members: Array<{
    __typename?: 'TaskMember';
    id: string;
    role: TaskMemberRole;
    user: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
  }>;
  invitations?: Array<{
    __typename?: 'TaskInvitation';
    id: string;
    email: string;
    role: TaskMemberRole;
    expiredAt?: any | null;
  }> | null;
  userRequests?: Array<{
    __typename?: 'UserRequest';
    id: string;
    role?: string | null;
    expiredAt?: any | null;
    user?: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    } | null;
  }> | null;
  creator: {
    __typename?: 'User';
    id: string;
    email: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber: string;
    primaryTeamId?: string | null;
    createdAt: any;
    inviteUrl: string;
    avatarId?: string | null;
    avatarIsPreviewable?: boolean | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    skills?: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }> | null;
  };
  completor?: {
    __typename?: 'User';
    id: string;
    email: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber: string;
    primaryTeamId?: string | null;
    createdAt: any;
    inviteUrl: string;
    avatarId?: string | null;
    avatarIsPreviewable?: boolean | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    skills?: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }> | null;
  } | null;
  phase?: { __typename?: 'Phase'; id: string; name: string } | null;
};

export type TaskDocumentDetailFragment = {
  __typename?: 'Task';
  id: string;
  name: string;
  startDate?: any | null;
  dueDate?: any | null;
  completedAt?: any | null;
  projectId: string;
  deletedAt?: any | null;
  currentUserRole?: TaskMemberRole | null;
  currentUserProjectRole?: ProjectMemberRole | null;
  currentUserProjectTeamRole?: TeamMemberRole | null;
  project: {
    __typename?: 'Project';
    id: string;
    uuid: string;
    name: string;
    archivedAt?: any | null;
    team?: {
      __typename?: 'Team';
      subscriptionDetails?: {
        __typename?: 'SubscriptionDetails';
        expirationDate?: any | null;
        subscriptionInterval?: string | null;
        subscriptionPlanName?: string | null;
        subscriptionStatus?: string | null;
        isSubscriptionCanceled: boolean;
        isSubscriptionActive: boolean;
        isSubscriptionOnTrial: boolean;
        trialEndsAt?: any | null;
        updatedAt?: any | null;
      } | null;
    } | null;
  };
  documents?: Array<{
    __typename?: 'Document';
    id: string;
    name: string;
    contentType?: string | null;
    createdAt: any;
    size?: number | null;
    isImage: boolean;
    clientId: string;
    isAudio: boolean;
    duration?: number | null;
    owner: { __typename?: 'User'; id: string; name?: string | null };
    file: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    };
    messageDocuments?: Array<{
      __typename?: 'MessageDocument';
      id: string;
      message?: {
        __typename?: 'Message';
        id: string;
        clientId: string;
        chatId: string;
        createdAt: any;
        isSender: boolean;
        isDraft: boolean;
        publishedAt?: any | null;
        authorId: string;
      } | null;
    }> | null;
    projectDocuments?: Array<{
      __typename?: 'ProjectDocument';
      id: string;
      project?: {
        __typename?: 'Project';
        id: string;
        uuid: string;
        name: string;
      } | null;
      owner?: { __typename?: 'User'; id: string; name?: string | null } | null;
    }> | null;
    taskDocuments?: Array<{
      __typename?: 'TaskDocument';
      id: string;
      task?: {
        __typename?: 'Task';
        id: string;
        name: string;
        projectId: string;
        project: {
          __typename?: 'Project';
          id: string;
          uuid: string;
          name: string;
        };
      } | null;
      owner?: { __typename?: 'User'; id: string; name?: string | null } | null;
    }> | null;
  }> | null;
};

export type TaskRowFragment = {
  __typename?: 'Task';
  id: string;
  name: string;
  status?: TaskStatus | null;
  priority?: TaskPriority | null;
  startDate?: any | null;
  dueDate?: any | null;
  completedAt?: any | null;
  createdAt: any;
  phaseId?: string | null;
  projectId: string;
  deletedAt?: any | null;
  skillIds?: Array<string> | null;
  userIds: Array<string>;
  dueGroup?: string | null;
  fixedOrder?: boolean | null;
  recurring?: boolean | null;
  description?: string | null;
  frequency?: TaskFrequency | null;
  currentUserRole?: TaskMemberRole | null;
  currentUserProjectRole?: ProjectMemberRole | null;
  currentUserProjectTeamRole?: TeamMemberRole | null;
  dependencies?: Array<{
    __typename?: 'Task';
    id: string;
    name: string;
  }> | null;
  checklists?: Array<{
    __typename?: 'TaskChecklist';
    id: string;
    name: string;
    completedAt?: any | null;
    createdAt: any;
  }> | null;
  members: Array<{
    __typename?: 'TaskMember';
    id: string;
    role: TaskMemberRole;
    user: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
  }>;
  invitations?: Array<{
    __typename?: 'TaskInvitation';
    id: string;
    email: string;
    role: TaskMemberRole;
    expiredAt?: any | null;
  }> | null;
  userRequests?: Array<{
    __typename?: 'UserRequest';
    id: string;
    role?: string | null;
    expiredAt?: any | null;
    user?: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    } | null;
  }> | null;
  creator: {
    __typename?: 'User';
    id: string;
    email: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber: string;
    primaryTeamId?: string | null;
    createdAt: any;
    inviteUrl: string;
    avatarId?: string | null;
    avatarIsPreviewable?: boolean | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    skills?: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }> | null;
  };
  completor?: {
    __typename?: 'User';
    id: string;
    email: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber: string;
    primaryTeamId?: string | null;
    createdAt: any;
    inviteUrl: string;
    avatarId?: string | null;
    avatarIsPreviewable?: boolean | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    skills?: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }> | null;
  } | null;
  project: {
    __typename?: 'Project';
    id: string;
    uuid: string;
    name: string;
    color: string;
    icon?: string | null;
    currentUserTeamRole?: TeamMemberRole | null;
    currentUserRole?: ProjectMemberRole | null;
    initials: string;
    archivedAt?: any | null;
    team?: {
      __typename?: 'Team';
      avatar?: string | null;
      createdAt: any;
      id: string;
      name: string;
      personal: boolean;
    } | null;
  };
  phase?: { __typename?: 'Phase'; id: string; name: string } | null;
};

export type TeamDetailFragment = {
  __typename?: 'Team';
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  id: string;
  uuid: string;
  avatar?: string | null;
  createdAt: any;
  name: string;
  usersCount: number;
  fileStorageUsed: any;
  mediaStorageUsed: any;
  pending: boolean;
  maxDocumentStorage: any;
  storageRemaining: any;
  currentUserRole?: TeamRole | null;
  hasReachedMaxProjects: boolean;
  numberOfProjectsUsed: number;
  maxNumberOfProjects: number;
  personal: boolean;
  billingSource?: string | null;
  teamSubscriptionStatus?: string | null;
  entitlementExpiration?: any | null;
  tasksCount: number;
  completedTasksCount: number;
  avatarFile?: {
    __typename?: 'File';
    id: string;
    cdnBaseUrl: string;
    path: string;
    isPreviewable: boolean;
    thumbnail?: string | null;
  } | null;
  subscriptionDetails?: {
    __typename?: 'SubscriptionDetails';
    expirationDate?: any | null;
    subscriptionInterval?: string | null;
    subscriptionPlanName?: string | null;
    subscriptionStatus?: string | null;
    trialEndsAt?: any | null;
    canceledAt?: any | null;
    stripeProductId?: string | null;
    isSubscriptionCanceled: boolean;
    isSubscriptionActive: boolean;
    isSubscriptionOnTrial: boolean;
    updatedAt?: any | null;
    paymentCardLast4?: string | null;
    paymentCardBrand?: string | null;
    paymentCardExpMonth?: string | null;
    paymentCardExpYear?: string | null;
    currentSeatCount?: number | null;
    pricePerSeat?: string | null;
  } | null;
  owner: {
    __typename?: 'User';
    id: string;
    email: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber: string;
    primaryTeamId?: string | null;
    createdAt: any;
    inviteUrl: string;
    avatarId?: string | null;
    avatarIsPreviewable?: boolean | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    skills?: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }> | null;
  };
  skills: Array<{
    __typename?: 'Skill';
    id: string;
    name: string;
    createdAt: any;
  }>;
  product?: {
    __typename?: 'Product';
    id: string;
    name: string;
    prices: Array<{
      __typename?: 'Price';
      id: string;
      interval: string;
      intervalCount: number;
      externalId: string;
    }>;
  } | null;
};

export type TeamMembersDetailFragment = {
  __typename?: 'Team';
  users: Array<{
    __typename?: 'User';
    teamRoles?: Array<TeamRole> | null;
    id: string;
    email: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber: string;
    primaryTeamId?: string | null;
    createdAt: any;
    inviteUrl: string;
    avatarId?: string | null;
    avatarIsPreviewable?: boolean | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    skills?: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }> | null;
  }>;
  invitations?: Array<{
    __typename?: 'TeamInvitation';
    email?: string | null;
    expiredAt?: any | null;
    id: string;
    role?: TeamRole | null;
    invitedBy?: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    } | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    } | null;
  }> | null;
  invoices?: Array<{
    __typename?: 'Invoice';
    id: string;
    invoiceUrl: string;
    amount: number;
    date: any;
    description: string;
    status: string;
  }> | null;
};

export type TeamSubscriptionFragment = {
  __typename?: 'Team';
  id: string;
  personal: boolean;
  subscriptionDetails?: {
    __typename?: 'SubscriptionDetails';
    expirationDate?: any | null;
    subscriptionStatus?: string | null;
    isSubscriptionCanceled: boolean;
    isSubscriptionActive: boolean;
    isSubscriptionOnTrial: boolean;
    paymentCardLast4?: string | null;
  } | null;
};

export type UserDetailFragment = {
  __typename?: 'User';
  id: string;
  email: string;
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber: string;
  primaryTeamId?: string | null;
  createdAt: any;
  inviteUrl: string;
  avatarId?: string | null;
  avatarIsPreviewable?: boolean | null;
  avatar?: {
    __typename?: 'File';
    id: string;
    cdnBaseUrl: string;
    path: string;
    isPreviewable: boolean;
    thumbnail?: string | null;
  } | null;
  skills?: Array<{
    __typename?: 'Skill';
    id: string;
    name: string;
    createdAt: any;
  }> | null;
};

export type UserProfileFragment = {
  __typename?: 'Profile';
  address?: string | null;
  id: string;
  email: string;
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber: string;
  userActiveTasksCount: number;
  avatar?: {
    __typename?: 'File';
    id: string;
    cdnBaseUrl: string;
    path: string;
    isPreviewable: boolean;
    thumbnail?: string | null;
  } | null;
  skills?: Array<{
    __typename?: 'Skill';
    id: string;
    name: string;
    createdAt: any;
  }> | null;
  teams?: Array<{
    __typename?: 'Team';
    id: string;
    uuid: string;
    name: string;
    usersCount: number;
    users: Array<{ __typename?: 'User'; id: string; name?: string | null }>;
  }> | null;
};

export type GenerateProjectReportMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;

export type GenerateProjectReportMutation = {
  __typename?: 'Mutation';
  generateProjectReport?: {
    __typename?: 'GenerateReportPayload';
    uuid: string;
  } | null;
};

export type AcceptChatInvitationMutationVariables = Exact<{
  invitationToken: Scalars['String']['input'];
}>;

export type AcceptChatInvitationMutation = {
  __typename?: 'Mutation';
  acceptChatInvitation: { __typename?: 'Chat'; id: string; name: string };
};

export type AcceptTeamInvitationMutationVariables = Exact<{
  invitationToken: Scalars['String']['input'];
}>;

export type AcceptTeamInvitationMutation = {
  __typename?: 'Mutation';
  acceptTeamInvitation: {
    __typename?: 'Team';
    id: string;
    name: string;
    users: Array<{ __typename?: 'User'; id: string; name?: string | null }>;
  };
};

export type AcceptUserInviteMutationVariables = Exact<{
  invitationToken: Scalars['String']['input'];
}>;

export type AcceptUserInviteMutation = {
  __typename?: 'Mutation';
  acceptUserInvite: {
    __typename?: 'AcceptUserInvitePayload';
    status: string;
    chat?: { __typename?: 'Chat'; id: string } | null;
    inviter?: {
      __typename?: 'PublicUser';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
  };
};

export type AddProjectChecklistMutationVariables = Exact<{
  projectUUId: Scalars['ID']['input'];
  attributes: AddProjectChecklistAttributes;
}>;

export type AddProjectChecklistMutation = {
  __typename?: 'Mutation';
  addProjectChecklist: Array<{
    __typename?: 'ProjectChecklist';
    projectId: string;
    id: string;
    name: string;
    completedAt?: any | null;
    createdAt: any;
    sort?: number | null;
  }>;
};

export type AddProjectFilesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: Array<DocumentAttributes> | DocumentAttributes;
}>;

export type AddProjectFilesMutation = {
  __typename?: 'Mutation';
  addProjectFiles: { __typename?: 'Project'; id: string };
};

export type AddTaskChecklistMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  attributes: TaskChecklistAttributes;
}>;

export type AddTaskChecklistMutation = {
  __typename?: 'Mutation';
  addTaskChecklist: Array<{
    __typename?: 'TaskChecklist';
    taskId: string;
    id: string;
    name: string;
    completedAt?: any | null;
    createdAt: any;
    sort?: number | null;
  }>;
};

export type AddTaskFilesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: Array<DocumentAttributes> | DocumentAttributes;
}>;

export type AddTaskFilesMutation = {
  __typename?: 'Mutation';
  addTaskFiles: { __typename?: 'Task'; id: string };
};

export type ApplyProjectChecklistTemplateMutationVariables = Exact<{
  projectChecklistTemplateId: Scalars['ID']['input'];
  selectedItemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
}>;

export type ApplyProjectChecklistTemplateMutation = {
  __typename?: 'Mutation';
  applyProjectChecklistTemplate: Array<{
    __typename?: 'ProjectChecklist';
    id: string;
  }>;
};

export type ApproveTaskInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ApproveTaskInvitationMutation = {
  __typename?: 'Mutation';
  approveTaskInvitation: boolean;
};

export type ArchiveChatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ArchiveChatMutation = {
  __typename?: 'Mutation';
  archiveChat: {
    __typename?: 'Chat';
    id: string;
    name: string;
    description?: string | null;
    users: Array<{ __typename?: 'User'; id: string }>;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    settings?: {
      __typename?: 'UserChatSetting';
      mute: boolean;
      pin: boolean;
      archivedAt?: any | null;
    } | null;
  };
};

export type ArchiveProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ArchiveProjectMutation = {
  __typename?: 'Mutation';
  archiveProject: {
    __typename?: 'Project';
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    archivedAt?: any | null;
    usersCount: number;
    tasksCount: number;
    currentUserRole?: ProjectMemberRole | null;
    currentUserTeamRole?: TeamMemberRole | null;
    currentUserHasPendingMemberAdditionRequest: boolean;
    isTaskMember: boolean;
    teamId: string;
    color: string;
    icon?: string | null;
    createdAt: any;
    description?: string | null;
    id: string;
    uuid: string;
    initials: string;
    name: string;
    unreadAuditsCount?: number | null;
    activeTasksCount: number;
    upcomingTasksCount: number;
    overdueTasksCount: number;
    completedTasksCount: number;
    completedChecklistCount: number;
    creator: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    coverImage?: {
      __typename?: 'File';
      id: string;
      url: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    team?: {
      __typename?: 'Team';
      avatar?: string | null;
      createdAt: any;
      id: string;
      uuid: string;
      name: string;
      personal: boolean;
      hasReachedMaxProjects: boolean;
      currentUserRole?: TeamRole | null;
      storageRemaining: any;
      owner: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
      subscriptionDetails?: {
        __typename?: 'SubscriptionDetails';
        expirationDate?: any | null;
        subscriptionInterval?: string | null;
        subscriptionPlanName?: string | null;
        subscriptionStatus?: string | null;
        isSubscriptionCanceled: boolean;
        isSubscriptionActive: boolean;
        isSubscriptionOnTrial: boolean;
        trialEndsAt?: any | null;
        updatedAt?: any | null;
      } | null;
    } | null;
    memberPreviews: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          url: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    members: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          url: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    audits?: Array<{ __typename?: 'Audit'; id: string; event: string }> | null;
    settings?: {
      __typename?: 'UserProjectSetting';
      id: string;
      pin: boolean;
    } | null;
    invitations?: Array<{
      __typename?: 'ProjectInvitation';
      id: string;
      email: string;
      role: ProjectMemberRole;
      expiredAt?: any | null;
      createdAt: any;
      invitedBy: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      };
    }> | null;
    userRequests?: Array<{
      __typename?: 'UserRequest';
      id: string;
      role?: string | null;
      status: string;
      expiredAt?: any | null;
      createdAt: any;
      requestType: UserRequestCategory;
      userRequestableId: string;
      userRequestableType: UserRequestable;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
      reviewedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    }> | null;
  };
};

export type AssignTaskOwnerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  newOwnerId: Scalars['ID']['input'];
}>;

export type AssignTaskOwnerMutation = {
  __typename?: 'Mutation';
  assignTaskOwner: { __typename?: 'Task'; id: string };
};

export type AssignTaskUsersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  members: Array<TaskMemberAttributes> | TaskMemberAttributes;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  sendCardImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  sourceMessageId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AssignTaskUsersMutation = {
  __typename?: 'Mutation';
  assignTaskUsers: { __typename?: 'Task'; id: string };
};

export type AssignTeamOwnerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  newOwnerId: Scalars['ID']['input'];
}>;

export type AssignTeamOwnerMutation = {
  __typename?: 'Mutation';
  assignTeamOwner: { __typename?: 'Team'; id: string };
};

export type CancelStripeSubscriptionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CancelStripeSubscriptionMutation = {
  __typename?: 'Mutation';
  cancelStripeSubscription?: { __typename?: 'Team'; id: string } | null;
};

export type ChatBlockUnblockUserMutationVariables = Exact<{
  userIdToBlock: Scalars['ID']['input'];
}>;

export type ChatBlockUnblockUserMutation = {
  __typename?: 'Mutation';
  chatBlockUnblockUser: {
    __typename?: 'User';
    id: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
  };
};

export type CompleteTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  chatId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type CompleteTaskMutation = {
  __typename?: 'Mutation';
  completeTask: {
    __typename?: 'Task';
    id: string;
    status?: TaskStatus | null;
    completedAt?: any | null;
  };
};

export type CompleteWebTutorialFlowsMutationVariables = Exact<{
  flowType: WebTutorialFlow;
}>;

export type CompleteWebTutorialFlowsMutation = {
  __typename?: 'Mutation';
  completeWebTutorialFlows: boolean;
};

export type ConvertProjectChecklistToTaskMutationVariables = Exact<{
  projectChecklistIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ConvertProjectChecklistToTaskMutation = {
  __typename?: 'Mutation';
  convertProjectChecklistToTask: Array<{
    __typename?: 'Task';
    projectId: string;
    id: string;
    name: string;
  }>;
};

export type CreateChatMutationVariables = Exact<{
  attributes: ChatAttributes;
}>;

export type CreateChatMutation = {
  __typename?: 'Mutation';
  createChat: {
    __typename?: 'Chat';
    id: string;
    name: string;
    description?: string | null;
    avatarUrl?: string | null;
    isGroupChat: boolean;
    messageIcon?: string | null;
    messageBody?: string | null;
    recentActivityAt?: any | null;
    unreadCount?: number | null;
    isNewChat?: boolean | null;
    isUserBlocked?: boolean | null;
    canCurrentUserDecide: boolean;
    isPendingRequest: boolean;
    friendRequestAccepted?: boolean | null;
    createdAt: any;
    leaveOn?: any | null;
    userIds: Array<string>;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    owner: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
    };
    settings?: {
      __typename?: 'UserChatSetting';
      id: string;
      pin: boolean;
      mute: boolean;
      archivedAt?: any | null;
    } | null;
    users: Array<{
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email: string;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    }>;
    pendingInvitations: Array<{
      __typename?: 'ChatInvitation';
      email: string;
      expiredAt: any;
      id: string;
    }>;
    userRequests: Array<{
      __typename?: 'UserRequest';
      id: string;
      status: string;
      expiredAt?: any | null;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email: string;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
    }>;
  };
};

export type CreateChatInvitationMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type CreateChatInvitationMutation = {
  __typename?: 'Mutation';
  createChatInvitation?: {
    __typename?: 'Chat';
    id: string;
    name: string;
  } | null;
};

export type CreateChatInviteMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;

export type CreateChatInviteMutation = {
  __typename?: 'Mutation';
  createInvite?: string | null;
};

export type CreateContactInvitationUrlMutationVariables = Exact<{
  attributes: CreateContactInvitationUrlAttributes;
}>;

export type CreateContactInvitationUrlMutation = {
  __typename?: 'Mutation';
  createContactInvitationUrl?: string | null;
};

export type CreateDeviceMutationVariables = Exact<{
  attributes: DeviceAttributes;
}>;

export type CreateDeviceMutation = {
  __typename?: 'Mutation';
  createDevice?: { __typename?: 'Device'; token: string } | null;
};

export type CreateDirectUploadsMutationVariables = Exact<{
  attributes: Array<DirectUploadAttributes> | DirectUploadAttributes;
}>;

export type CreateDirectUploadsMutation = {
  __typename?: 'Mutation';
  createDirectUploads: Array<{
    __typename?: 'DirectUpload';
    clientId: string;
    url: string;
    headers: string;
    blobId: string;
    signedBlobId: string;
  }>;
};

export type CreateGroupMutationVariables = Exact<{
  attributes: GroupAttributes;
}>;

export type CreateGroupMutation = {
  __typename?: 'Mutation';
  createGroup: {
    __typename?: 'Group';
    id: string;
    name: string;
    team?: { __typename?: 'Team'; id: string; name: string } | null;
    users?: Array<{
      __typename?: 'User';
      id: string;
      name?: string | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    }> | null;
  };
};

export type CreateInviteMutationVariables = Exact<{
  projectId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type CreateInviteMutation = {
  __typename?: 'Mutation';
  createInvite?: string | null;
};

export type CreateMediaShareLinkMutationVariables = Exact<{
  documentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type CreateMediaShareLinkMutation = {
  __typename?: 'Mutation';
  createMediaShareLink?: {
    __typename?: 'CreateMediaShareLinkPayload';
    token: string;
  } | null;
};

export type CreateMessageIndividualMutationVariables = Exact<{
  attributes: MessageAttributes;
}>;

export type CreateMessageIndividualMutation = {
  __typename?: 'Mutation';
  createMessageIndividual: {
    __typename?: 'Message';
    id: string;
    chatId: string;
    clientId: string;
    body?: string | null;
    createdAt: any;
    isSender: boolean;
    isDraft: boolean;
    publishedAt?: any | null;
    authorId: string;
    author: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    chat: { __typename?: 'Chat'; id: string; name: string };
    replyMessage?: {
      __typename?: 'Message';
      id: string;
      chatId: string;
      clientId: string;
      body?: string | null;
      createdAt: any;
      isSender: boolean;
      isDraft: boolean;
      publishedAt?: any | null;
      authorId: string;
      author: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    } | null;
    attachments?: Array<
      | {
          __typename?: 'Document';
          id: string;
          blobId?: string | null;
          name: string;
          contentType?: string | null;
          createdAt: any;
          size?: number | null;
          isImage: boolean;
          isVideo: boolean;
          clientId: string;
          isAudio: boolean;
          duration?: number | null;
          file: {
            __typename?: 'File';
            id: string;
            url: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          };
          owner: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            createdAt: any;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          };
          taskDocuments?: Array<{
            __typename?: 'TaskDocument';
            id: string;
            owner?: { __typename?: 'User'; id: string } | null;
            task?: {
              __typename?: 'Task';
              id: string;
              name: string;
              projectId: string;
              project: { __typename?: 'Project'; id: string; name: string };
            } | null;
          }> | null;
          projectDocuments?: Array<{
            __typename?: 'ProjectDocument';
            id: string;
            owner?: { __typename?: 'User'; id: string } | null;
            project?: {
              __typename?: 'Project';
              id: string;
              name: string;
            } | null;
          }> | null;
        }
      | { __typename?: 'EntityUser' }
      | { __typename?: 'Folder' }
      | { __typename?: 'LocalFile' }
      | { __typename?: 'Message' }
      | {
          __typename?: 'MessageProject';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          } | null;
          project?: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
          } | null;
        }
      | {
          __typename?: 'MessageTask';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          } | null;
          task?: {
            __typename?: 'Task';
            id: string;
            projectId: string;
            name: string;
          } | null;
        }
      | { __typename?: 'MessageTaskAssignment' }
      | { __typename?: 'MessageTaskComplete' }
      | { __typename?: 'Project' }
      | { __typename?: 'ProjectUser' }
      | { __typename?: 'PublicTeam' }
      | { __typename?: 'Task' }
      | { __typename?: 'TaskUser' }
      | { __typename?: 'UserRequest' }
    > | null;
  };
};

export type CreateMessageReactionMutationVariables = Exact<{
  messageId: Scalars['ID']['input'];
  reaction: Scalars['String']['input'];
}>;

export type CreateMessageReactionMutation = {
  __typename?: 'Mutation';
  createMessageReaction: {
    __typename?: 'MessageReaction';
    count: number;
    id: string;
    reaction: string;
    reactionId: string;
  };
};

export type CreatePhaseMutationVariables = Exact<{
  attributes: PhaseAttributes;
}>;

export type CreatePhaseMutation = {
  __typename?: 'Mutation';
  createPhase: { __typename?: 'Phase'; id: string; name: string };
};

export type CreateProjectMutationVariables = Exact<{
  attributes: ProjectAttributes;
}>;

export type CreateProjectMutation = {
  __typename?: 'Mutation';
  createProject?: {
    __typename?: 'Project';
    id: string;
    uuid: string;
    name: string;
    description?: string | null;
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    color: string;
    icon?: string | null;
    createdAt: any;
    creator: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    team?: {
      __typename?: 'Team';
      id: string;
      name: string;
      avatar?: string | null;
      personal: boolean;
    } | null;
    members: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    invitations?: Array<{
      __typename?: 'ProjectInvitation';
      email: string;
      role: ProjectMemberRole;
      expiredAt?: any | null;
    }> | null;
  } | null;
};

export type CreateProjectInvitationMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  projectMembers:
    | Array<ProjectMemberRoleAttributes>
    | ProjectMemberRoleAttributes;
}>;

export type CreateProjectInvitationMutation = {
  __typename?: 'Mutation';
  createProjectInvitation?: {
    __typename?: 'Project';
    id: string;
    name: string;
    invitations?: Array<{
      __typename?: 'ProjectInvitation';
      id: string;
      email: string;
      role: ProjectMemberRole;
      expiredAt?: any | null;
      createdAt: any;
      invitedBy: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      };
    }> | null;
  } | null;
};

export type CreateShareLinkMutationVariables = Exact<{
  documentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type CreateShareLinkMutation = {
  __typename?: 'Mutation';
  createShareLink?: {
    __typename?: 'CreateShareLinkPayload';
    sharedUrl?: string | null;
  } | null;
};

export type CreateStripeSubscriptionMutationVariables = Exact<{
  teamAttributes?: InputMaybe<TeamAttributes>;
  stripeSubscriptionAttributes: StripeSubscriptionAttributes;
}>;

export type CreateStripeSubscriptionMutation = {
  __typename?: 'Mutation';
  createStripeSubscription?: {
    __typename?: 'PaymentIntent';
    clientSecret: string;
    id: string;
    intentType: string;
    team: { __typename?: 'Team'; id: string; uuid: string };
  } | null;
};

export type CreateTaskMutationVariables = Exact<{
  attributes: TaskAttributes;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  sourceMessageId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type CreateTaskMutation = {
  __typename?: 'Mutation';
  createTask: {
    __typename?: 'Task';
    id: string;
    name: string;
    status?: TaskStatus | null;
    priority?: TaskPriority | null;
    startDate?: any | null;
    dueDate?: any | null;
    completedAt?: any | null;
    createdAt: any;
    phaseId?: string | null;
    projectId: string;
    deletedAt?: any | null;
    skillIds?: Array<string> | null;
    userIds: Array<string>;
    dueGroup?: string | null;
    fixedOrder?: boolean | null;
    recurring?: boolean | null;
    description?: string | null;
    frequency?: TaskFrequency | null;
    currentUserRole?: TaskMemberRole | null;
    currentUserProjectRole?: ProjectMemberRole | null;
    currentUserProjectTeamRole?: TeamMemberRole | null;
    project: {
      __typename?: 'Project';
      id: string;
      uuid: string;
      name: string;
      color: string;
      icon?: string | null;
      currentUserTeamRole?: TeamMemberRole | null;
      currentUserRole?: ProjectMemberRole | null;
      initials: string;
      archivedAt?: any | null;
      team?: {
        __typename?: 'Team';
        avatar?: string | null;
        createdAt: any;
        id: string;
        name: string;
        personal: boolean;
        subscriptionDetails?: {
          __typename?: 'SubscriptionDetails';
          expirationDate?: any | null;
          subscriptionStatus?: string | null;
          isSubscriptionCanceled: boolean;
          isSubscriptionActive: boolean;
          isSubscriptionOnTrial: boolean;
          paymentCardLast4?: string | null;
        } | null;
      } | null;
    };
    dependencies?: Array<{
      __typename?: 'Task';
      id: string;
      name: string;
    }> | null;
    checklists?: Array<{
      __typename?: 'TaskChecklist';
      id: string;
      name: string;
      completedAt?: any | null;
      createdAt: any;
    }> | null;
    members: Array<{
      __typename?: 'TaskMember';
      id: string;
      role: TaskMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    invitations?: Array<{
      __typename?: 'TaskInvitation';
      id: string;
      email: string;
      role: TaskMemberRole;
      expiredAt?: any | null;
    }> | null;
    userRequests?: Array<{
      __typename?: 'UserRequest';
      id: string;
      role?: string | null;
      expiredAt?: any | null;
      user?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      } | null;
    }> | null;
    creator: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    completor?: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    } | null;
    phase?: { __typename?: 'Phase'; id: string; name: string } | null;
  };
};

export type CreateTaskInvitationMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  taskMembers: Array<TaskMemberRoleAttributes> | TaskMemberRoleAttributes;
}>;

export type CreateTaskInvitationMutation = {
  __typename?: 'Mutation';
  createTaskInvitation?: {
    __typename?: 'Task';
    id: string;
    name: string;
    invitations?: Array<{
      __typename?: 'TaskInvitation';
      email: string;
      role: TaskMemberRole;
      expiredAt?: any | null;
    }> | null;
    userRequests?: Array<{
      __typename?: 'UserRequest';
      id: string;
      role?: string | null;
      expiredAt?: any | null;
      user?: { __typename?: 'User'; id: string; email: string } | null;
    }> | null;
  } | null;
};

export type CreateTeamMutationVariables = Exact<{
  attributes: TeamAttributes;
  billingSource?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateTeamMutation = {
  __typename?: 'Mutation';
  createTeam: {
    __typename?: 'Team';
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    id: string;
    uuid: string;
    avatar?: string | null;
    createdAt: any;
    name: string;
    usersCount: number;
    fileStorageUsed: any;
    mediaStorageUsed: any;
    pending: boolean;
    maxDocumentStorage: any;
    storageRemaining: any;
    currentUserRole?: TeamRole | null;
    hasReachedMaxProjects: boolean;
    numberOfProjectsUsed: number;
    maxNumberOfProjects: number;
    personal: boolean;
    billingSource?: string | null;
    teamSubscriptionStatus?: string | null;
    entitlementExpiration?: any | null;
    tasksCount: number;
    completedTasksCount: number;
    avatarFile?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    subscriptionDetails?: {
      __typename?: 'SubscriptionDetails';
      expirationDate?: any | null;
      subscriptionInterval?: string | null;
      subscriptionPlanName?: string | null;
      subscriptionStatus?: string | null;
      trialEndsAt?: any | null;
      canceledAt?: any | null;
      stripeProductId?: string | null;
      isSubscriptionCanceled: boolean;
      isSubscriptionActive: boolean;
      isSubscriptionOnTrial: boolean;
      updatedAt?: any | null;
      paymentCardLast4?: string | null;
      paymentCardBrand?: string | null;
      paymentCardExpMonth?: string | null;
      paymentCardExpYear?: string | null;
      currentSeatCount?: number | null;
      pricePerSeat?: string | null;
    } | null;
    owner: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    skills: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }>;
    product?: {
      __typename?: 'Product';
      id: string;
      name: string;
      prices: Array<{
        __typename?: 'Price';
        id: string;
        interval: string;
        intervalCount: number;
        externalId: string;
      }>;
    } | null;
    users: Array<{
      __typename?: 'User';
      teamRoles?: Array<TeamRole> | null;
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    }>;
    invitations?: Array<{
      __typename?: 'TeamInvitation';
      email?: string | null;
      expiredAt?: any | null;
      id: string;
      role?: TeamRole | null;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
    }> | null;
    invoices?: Array<{
      __typename?: 'Invoice';
      id: string;
      invoiceUrl: string;
      amount: number;
      date: any;
      description: string;
      status: string;
    }> | null;
  };
};

export type CreateTeamInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CreateTeamInvitationMutation = {
  __typename?: 'Mutation';
  createTeamInvitation: string;
};

export type CreateTeamMemberInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  teamMembers: Array<TeamMemberRoleAttributes> | TeamMemberRoleAttributes;
}>;

export type CreateTeamMemberInvitationMutation = {
  __typename?: 'Mutation';
  createTeamMemberInvitation?: {
    __typename?: 'Team';
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    id: string;
    uuid: string;
    avatar?: string | null;
    createdAt: any;
    name: string;
    usersCount: number;
    fileStorageUsed: any;
    mediaStorageUsed: any;
    pending: boolean;
    maxDocumentStorage: any;
    storageRemaining: any;
    currentUserRole?: TeamRole | null;
    hasReachedMaxProjects: boolean;
    numberOfProjectsUsed: number;
    maxNumberOfProjects: number;
    personal: boolean;
    billingSource?: string | null;
    teamSubscriptionStatus?: string | null;
    entitlementExpiration?: any | null;
    tasksCount: number;
    completedTasksCount: number;
    avatarFile?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    subscriptionDetails?: {
      __typename?: 'SubscriptionDetails';
      expirationDate?: any | null;
      subscriptionInterval?: string | null;
      subscriptionPlanName?: string | null;
      subscriptionStatus?: string | null;
      trialEndsAt?: any | null;
      canceledAt?: any | null;
      stripeProductId?: string | null;
      isSubscriptionCanceled: boolean;
      isSubscriptionActive: boolean;
      isSubscriptionOnTrial: boolean;
      updatedAt?: any | null;
      paymentCardLast4?: string | null;
      paymentCardBrand?: string | null;
      paymentCardExpMonth?: string | null;
      paymentCardExpYear?: string | null;
      currentSeatCount?: number | null;
      pricePerSeat?: string | null;
    } | null;
    owner: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    skills: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }>;
    product?: {
      __typename?: 'Product';
      id: string;
      name: string;
      prices: Array<{
        __typename?: 'Price';
        id: string;
        interval: string;
        intervalCount: number;
        externalId: string;
      }>;
    } | null;
    users: Array<{
      __typename?: 'User';
      teamRoles?: Array<TeamRole> | null;
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    }>;
    invitations?: Array<{
      __typename?: 'TeamInvitation';
      email?: string | null;
      expiredAt?: any | null;
      id: string;
      role?: TeamRole | null;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
    }> | null;
    invoices?: Array<{
      __typename?: 'Invoice';
      id: string;
      invoiceUrl: string;
      amount: number;
      date: any;
      description: string;
      status: string;
    }> | null;
  } | null;
};

export type CreateUserRequestMutationVariables = Exact<{
  attributes: UserRequestAttributes;
}>;

export type CreateUserRequestMutation = {
  __typename?: 'Mutation';
  createUserRequest: {
    __typename?: 'UserRequest';
    id: string;
    requestType: UserRequestCategory;
    status: string;
    userRequestableType: UserRequestable;
    userRequestableId: string;
  };
};

export type DeleteChatInvitationMutationVariables = Exact<{
  chatInvitationId: Scalars['ID']['input'];
}>;

export type DeleteChatInvitationMutation = {
  __typename?: 'Mutation';
  deleteChatInvitation?: boolean | null;
};

export type DeleteDeviceMutationVariables = Exact<{
  expoToken: Scalars['String']['input'];
  apiToken: Scalars['String']['input'];
}>;

export type DeleteDeviceMutation = {
  __typename?: 'Mutation';
  deleteDevice?: { __typename?: 'Device'; id: string } | null;
};

export type DeleteDirectUploadsMutationVariables = Exact<{
  blobId: Scalars['ID']['input'];
}>;

export type DeleteDirectUploadsMutation = {
  __typename?: 'Mutation';
  deleteDirectUploads?: boolean | null;
};

export type DeleteFriendRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  friendRequest: Scalars['Boolean']['input'];
}>;

export type DeleteFriendRequestMutation = {
  __typename?: 'Mutation';
  deleteFriendRequest?: { __typename?: 'Chat'; id: string } | null;
};

export type DeleteGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteGroupMutation = {
  __typename?: 'Mutation';
  deleteGroup?: { __typename?: 'Group'; id: string } | null;
};

export type DeleteGroupChatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteGroupChatMutation = {
  __typename?: 'Mutation';
  deleteGroupChat?: { __typename?: 'Chat'; id: string } | null;
};

export type DeleteMessageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteMessageMutation = {
  __typename?: 'Mutation';
  deleteMessage: {
    __typename?: 'Message';
    id: string;
    clientId: string;
    authorId: string;
  };
};

export type DeleteMessageDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteMessageDocumentMutation = {
  __typename?: 'Mutation';
  deleteMessageDocument: {
    __typename?: 'DeleteMessageDocumentPayload';
    id: string;
    clientId: string;
  };
};

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteProjectMutation = {
  __typename?: 'Mutation';
  deleteProject: { __typename?: 'Project'; id: string };
};

export type DeleteProjectFilesMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type DeleteProjectFilesMutation = {
  __typename?: 'Mutation';
  deleteProjectFiles: Array<{ __typename?: 'ProjectDocument'; id: string }>;
};

export type DeleteProjectInvitationMutationVariables = Exact<{
  projectInvitationId: Scalars['ID']['input'];
}>;

export type DeleteProjectInvitationMutation = {
  __typename?: 'Mutation';
  deleteProjectInvitation?: boolean | null;
};

export type DeleteTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteTaskMutation = {
  __typename?: 'Mutation';
  deleteTask?: { __typename?: 'Task'; id: string } | null;
};

export type DeleteTaskFilesMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type DeleteTaskFilesMutation = {
  __typename?: 'Mutation';
  deleteTaskFiles: Array<{ __typename?: 'TaskDocument'; id: string }>;
};

export type DeleteTaskInvitationMutationVariables = Exact<{
  taskInvitationId: Scalars['ID']['input'];
}>;

export type DeleteTaskInvitationMutation = {
  __typename?: 'Mutation';
  deleteTaskInvitation?: boolean | null;
};

export type DeleteTeamMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteTeamMutation = {
  __typename?: 'Mutation';
  deleteTeam?: { __typename?: 'Team'; id: string } | null;
};

export type DeleteTeamInvitationMutationVariables = Exact<{
  accountInvitationId?: InputMaybe<Scalars['ID']['input']>;
  userRequestId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DeleteTeamInvitationMutation = {
  __typename?: 'Mutation';
  deleteTeamInvitation?: boolean | null;
};

export type DeleteUserRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteUserRequestMutation = {
  __typename?: 'Mutation';
  deleteUserRequest: { __typename?: 'UserRequest'; id: string };
};

export type DuplicateProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  includeTasks?: InputMaybe<Scalars['Boolean']['input']>;
  includeMembers?: InputMaybe<Scalars['Boolean']['input']>;
  includePhases?: InputMaybe<Scalars['Boolean']['input']>;
  includeAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  includeEditors?: InputMaybe<Scalars['Boolean']['input']>;
  includeViewers?: InputMaybe<Scalars['Boolean']['input']>;
  includeFiles?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type DuplicateProjectMutation = {
  __typename?: 'Mutation';
  duplicateProject: {
    __typename?: 'Project';
    duplicationStatus?: ProjectDuplicationStatus | null;
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    archivedAt?: any | null;
    usersCount: number;
    tasksCount: number;
    currentUserRole?: ProjectMemberRole | null;
    currentUserTeamRole?: TeamMemberRole | null;
    currentUserHasPendingMemberAdditionRequest: boolean;
    isTaskMember: boolean;
    teamId: string;
    color: string;
    icon?: string | null;
    createdAt: any;
    description?: string | null;
    id: string;
    uuid: string;
    initials: string;
    name: string;
    unreadAuditsCount?: number | null;
    activeTasksCount: number;
    upcomingTasksCount: number;
    overdueTasksCount: number;
    completedTasksCount: number;
    completedChecklistCount: number;
    creator: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    coverImage?: {
      __typename?: 'File';
      id: string;
      url: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    team?: {
      __typename?: 'Team';
      avatar?: string | null;
      createdAt: any;
      id: string;
      uuid: string;
      name: string;
      personal: boolean;
      hasReachedMaxProjects: boolean;
      currentUserRole?: TeamRole | null;
      storageRemaining: any;
      owner: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
      subscriptionDetails?: {
        __typename?: 'SubscriptionDetails';
        expirationDate?: any | null;
        subscriptionInterval?: string | null;
        subscriptionPlanName?: string | null;
        subscriptionStatus?: string | null;
        isSubscriptionCanceled: boolean;
        isSubscriptionActive: boolean;
        isSubscriptionOnTrial: boolean;
        trialEndsAt?: any | null;
        updatedAt?: any | null;
      } | null;
    } | null;
    memberPreviews: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          url: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    members: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          url: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    audits?: Array<{ __typename?: 'Audit'; id: string; event: string }> | null;
    settings?: {
      __typename?: 'UserProjectSetting';
      id: string;
      pin: boolean;
    } | null;
    invitations?: Array<{
      __typename?: 'ProjectInvitation';
      id: string;
      email: string;
      role: ProjectMemberRole;
      expiredAt?: any | null;
      createdAt: any;
      invitedBy: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      };
    }> | null;
    userRequests?: Array<{
      __typename?: 'UserRequest';
      id: string;
      role?: string | null;
      status: string;
      expiredAt?: any | null;
      createdAt: any;
      requestType: UserRequestCategory;
      userRequestableId: string;
      userRequestableType: UserRequestable;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
      reviewedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    }> | null;
  };
};

export type DuplicateTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  includeCheckLists?: InputMaybe<Scalars['Boolean']['input']>;
  includeCreator?: InputMaybe<Scalars['Boolean']['input']>;
  includeAssignees?: InputMaybe<Scalars['Boolean']['input']>;
  includeViewers?: InputMaybe<Scalars['Boolean']['input']>;
  includeFiles?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type DuplicateTaskMutation = {
  __typename?: 'Mutation';
  duplicateTask: {
    __typename?: 'Task';
    id: string;
    name: string;
    status?: TaskStatus | null;
    priority?: TaskPriority | null;
    startDate?: any | null;
    dueDate?: any | null;
    completedAt?: any | null;
    createdAt: any;
    phaseId?: string | null;
    projectId: string;
    skillIds?: Array<string> | null;
    members: Array<{
      __typename?: 'TaskMember';
      id: string;
      role: TaskMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    skills?: Array<{ __typename?: 'Skill'; id: string; name: string }> | null;
    creator: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    completor?: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    } | null;
    project: {
      __typename?: 'Project';
      id: string;
      uuid: string;
      name: string;
      color: string;
    };
  };
};

export type DuplicateTaskFilesMutationVariables = Exact<{
  sourceId: Scalars['ID']['input'];
  destinationId: Scalars['ID']['input'];
}>;

export type DuplicateTaskFilesMutation = {
  __typename?: 'Mutation';
  duplicateTaskFiles: Array<{ __typename?: 'TaskDocument'; id: string }>;
};

export type EditStripeSubscriptionMutationVariables = Exact<{
  stripeSubscriptionAttributes: StripeSubscriptionAttributes;
}>;

export type EditStripeSubscriptionMutation = {
  __typename?: 'Mutation';
  editStripeSubscription?: {
    __typename?: 'PaymentIntent';
    clientSecret: string;
    id: string;
    intentType: string;
    team: { __typename?: 'Team'; id: string };
  } | null;
};

export type ExportCheckinsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  to?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;

export type ExportCheckinsMutation = {
  __typename?: 'Mutation';
  exportCheckins?: {
    __typename?: 'ExportCheckinsPayload';
    url: string;
    filename: string;
  } | null;
};

export type ExportGlobalCheckinsMutationVariables = Exact<{
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  to?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;

export type ExportGlobalCheckinsMutation = {
  __typename?: 'Mutation';
  exportGlobalCheckins?: {
    __typename?: 'ExportGlobalCheckinsPayload';
    url: string;
    filename: string;
  } | null;
};

export type ForwardDocumentsMutationVariables = Exact<{
  documentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  targetChatIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ForwardDocumentsMutation = {
  __typename?: 'Mutation';
  forwardDocuments?: {
    __typename?: 'ForwardDocumentsPayload';
    errors: Array<string>;
    messages: Array<{
      __typename?: 'Message';
      id: string;
      clientId: string;
      chatId: string;
    }>;
  } | null;
};

export type FriendRequestMutationVariables = Exact<{
  attributes: ChatAttributes;
}>;

export type FriendRequestMutation = {
  __typename?: 'Mutation';
  friendRequest: {
    __typename?: 'Chat';
    id: string;
    name: string;
    description?: string | null;
    isGroupChat: boolean;
    createdAt: any;
    owner: { __typename?: 'User'; id: string };
    users: Array<{ __typename?: 'User'; id: string }>;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    settings?: {
      __typename?: 'UserChatSetting';
      mute: boolean;
      pin: boolean;
    } | null;
  };
};

export type GeneratePublicCalendarUrlMutationVariables = Exact<{
  [key: string]: never;
}>;

export type GeneratePublicCalendarUrlMutation = {
  __typename?: 'Mutation';
  generatePublicCalendarUrl: string;
};

export type InvalidatePublicCalendarUrlMutationVariables = Exact<{
  [key: string]: never;
}>;

export type InvalidatePublicCalendarUrlMutation = {
  __typename?: 'Mutation';
  invalidatePublicCalendarUrl: boolean;
};

export type JoinRequestedTaskMutationVariables = Exact<{
  userRequestId: Scalars['ID']['input'];
}>;

export type JoinRequestedTaskMutation = {
  __typename?: 'Mutation';
  joinRequestedTask: boolean;
};

export type LeaveChatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type LeaveChatMutation = {
  __typename?: 'Mutation';
  leaveChat?: { __typename?: 'Chat'; id: string } | null;
};

export type LeaveProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type LeaveProjectMutation = {
  __typename?: 'Mutation';
  leaveProject?: { __typename?: 'Project'; id: string } | null;
};

export type LeaveTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;

export type LeaveTaskMutation = {
  __typename?: 'Mutation';
  leaveTask?: {
    __typename?: 'Task';
    id: string;
    name: string;
    status?: TaskStatus | null;
    priority?: TaskPriority | null;
    startDate?: any | null;
    dueDate?: any | null;
    completedAt?: any | null;
    createdAt: any;
    phaseId?: string | null;
    projectId: string;
    skillIds?: Array<string> | null;
    userIds: Array<string>;
    members: Array<{
      __typename?: 'TaskMember';
      id: string;
      role: TaskMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    skills?: Array<{ __typename?: 'Skill'; id: string; name: string }> | null;
    creator: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    completor?: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    } | null;
    project: {
      __typename?: 'Project';
      id: string;
      uuid: string;
      name: string;
      color: string;
    };
  } | null;
};

export type LeaveTeamMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type LeaveTeamMutation = {
  __typename?: 'Mutation';
  leaveTeam: { __typename?: 'Team'; id: string; name: string };
};

export type MarkAuditsReadMutationVariables = Exact<{
  attributes: ReadReceiptAuditAttributes;
}>;

export type MarkAuditsReadMutation = {
  __typename?: 'Mutation';
  markAuditsRead: Array<{ __typename?: 'Audit'; id: string; event: string }>;
};

export type MarkChatsReadMutationVariables = Exact<{
  attributes: ReadReceiptChatAttributes;
}>;

export type MarkChatsReadMutation = {
  __typename?: 'Mutation';
  markChatsRead: Array<{
    __typename?: 'Chat';
    id: string;
    unreadCount?: number | null;
    recentActivityAt?: any | null;
  }>;
};

export type NotifyTeamExpiryMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;

export type NotifyTeamExpiryMutation = {
  __typename?: 'Mutation';
  notifyTeamExpiry?: {
    __typename?: 'NotifyTeamExpiryPayload';
    success: boolean;
  } | null;
};

export type NotifyTeamOwnerMutationVariables = Exact<{
  teamId: Scalars['ID']['input'];
}>;

export type NotifyTeamOwnerMutation = {
  __typename?: 'Mutation';
  notifyTeamOwner?: {
    __typename?: 'NotifyTeamOwnerPayload';
    success: boolean;
  } | null;
};

export type OrderTasksMutationVariables = Exact<{
  taskIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  section: TaskSection;
  afterTaskId?: InputMaybe<Scalars['ID']['input']>;
  beforeTaskId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type OrderTasksMutation = {
  __typename?: 'Mutation';
  orderTasks?: Array<{
    __typename?: 'UserTaskOrder';
    id: string;
    position: number;
    rank?: any | null;
    section?: TaskSection | null;
    taskId: string;
  }> | null;
};

export type UpdateOnboardingProgressMutationVariables = Exact<{
  onboardingFlow: OnboardingFlow;
}>;

export type UpdateOnboardingProgressMutation = {
  __typename?: 'Mutation';
  updateOnboardingProgress: {
    __typename?: 'User';
    id: string;
    onboardingFlow: OnboardingFlow;
    name?: string | null;
    email: string;
  };
};

export type RejectTaskInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RejectTaskInvitationMutation = {
  __typename?: 'Mutation';
  rejectTaskInvitation: boolean;
};

export type RemoveMeMutationVariables = Exact<{ [key: string]: never }>;

export type RemoveMeMutation = {
  __typename?: 'Mutation';
  removeMe: { __typename?: 'User'; id: string };
};

export type RemoveMessageReactionMutationVariables = Exact<{
  messageReactionId: Scalars['ID']['input'];
}>;

export type RemoveMessageReactionMutation = {
  __typename?: 'Mutation';
  removeMessageReaction: {
    __typename?: 'MessageReaction';
    id: string;
    reaction: string;
    count: number;
  };
};

export type RemoveProjectChecklistMutationVariables = Exact<{
  projectChecklistId: Scalars['ID']['input'];
}>;

export type RemoveProjectChecklistMutation = {
  __typename?: 'Mutation';
  removeProjectChecklist: boolean;
};

export type RemoveProjectMembersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: ProjectAttributes;
}>;

export type RemoveProjectMembersMutation = {
  __typename?: 'Mutation';
  updateProject?: {
    __typename?: 'Project';
    id: string;
    usersCount: number;
    members: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
  } | null;
};

export type RemoveProjectMemberByIdMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;

export type RemoveProjectMemberByIdMutation = {
  __typename?: 'Mutation';
  removeProjectMember: {
    __typename?: 'Project';
    id: string;
    usersCount: number;
    members: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
    }>;
  };
};

export type RemoveTaskChecklistMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RemoveTaskChecklistMutation = {
  __typename?: 'Mutation';
  removeTaskChecklist: {
    __typename?: 'TaskChecklist';
    taskId: string;
    id: string;
    name: string;
    completedAt?: any | null;
    createdAt: any;
    sort?: number | null;
  };
};

export type RemoveTeamMemberMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;

export type RemoveTeamMemberMutation = {
  __typename?: 'Mutation';
  removeTeamMember: {
    __typename?: 'Team';
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    id: string;
    uuid: string;
    avatar?: string | null;
    createdAt: any;
    name: string;
    usersCount: number;
    fileStorageUsed: any;
    mediaStorageUsed: any;
    pending: boolean;
    maxDocumentStorage: any;
    storageRemaining: any;
    currentUserRole?: TeamRole | null;
    hasReachedMaxProjects: boolean;
    numberOfProjectsUsed: number;
    maxNumberOfProjects: number;
    personal: boolean;
    billingSource?: string | null;
    teamSubscriptionStatus?: string | null;
    entitlementExpiration?: any | null;
    tasksCount: number;
    completedTasksCount: number;
    avatarFile?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    subscriptionDetails?: {
      __typename?: 'SubscriptionDetails';
      expirationDate?: any | null;
      subscriptionInterval?: string | null;
      subscriptionPlanName?: string | null;
      subscriptionStatus?: string | null;
      trialEndsAt?: any | null;
      canceledAt?: any | null;
      stripeProductId?: string | null;
      isSubscriptionCanceled: boolean;
      isSubscriptionActive: boolean;
      isSubscriptionOnTrial: boolean;
      updatedAt?: any | null;
      paymentCardLast4?: string | null;
      paymentCardBrand?: string | null;
      paymentCardExpMonth?: string | null;
      paymentCardExpYear?: string | null;
      currentSeatCount?: number | null;
      pricePerSeat?: string | null;
    } | null;
    owner: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    skills: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }>;
    product?: {
      __typename?: 'Product';
      id: string;
      name: string;
      prices: Array<{
        __typename?: 'Price';
        id: string;
        interval: string;
        intervalCount: number;
        externalId: string;
      }>;
    } | null;
    users: Array<{
      __typename?: 'User';
      teamRoles?: Array<TeamRole> | null;
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    }>;
    invitations?: Array<{
      __typename?: 'TeamInvitation';
      email?: string | null;
      expiredAt?: any | null;
      id: string;
      role?: TeamRole | null;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
    }> | null;
    invoices?: Array<{
      __typename?: 'Invoice';
      id: string;
      invoiceUrl: string;
      amount: number;
      date: any;
      description: string;
      status: string;
    }> | null;
  };
};

export type RenameDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;

export type RenameDocumentMutation = {
  __typename?: 'Mutation';
  renameDocument: {
    __typename?: 'Document';
    id: string;
    clientId: string;
    name: string;
  };
};

export type ResendChatInvitationMutationVariables = Exact<{
  chatInvitationId: Scalars['ID']['input'];
}>;

export type ResendChatInvitationMutation = {
  __typename?: 'Mutation';
  resendChatInvitation?: boolean | null;
};

export type ResendProjectInvitationMutationVariables = Exact<{
  projectInvitationId: Scalars['ID']['input'];
}>;

export type ResendProjectInvitationMutation = {
  __typename?: 'Mutation';
  resendProjectInvitation?: boolean | null;
};

export type ResendTaskInvitationMutationVariables = Exact<{
  taskInvitationId: Scalars['ID']['input'];
}>;

export type ResendTaskInvitationMutation = {
  __typename?: 'Mutation';
  resendTaskInvitation?: boolean | null;
};

export type ResendTeamInvitationMutationVariables = Exact<{
  accountInvitationId?: InputMaybe<Scalars['ID']['input']>;
  userRequestId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ResendTeamInvitationMutation = {
  __typename?: 'Mutation';
  resendTeamInvitation?: boolean | null;
};

export type SaveChecklistAsTemplateMutationVariables = Exact<{
  projectUuid: Scalars['ID']['input'];
  attributes: SaveChecklistAsTemplateAttributes;
  templateName: Scalars['String']['input'];
}>;

export type SaveChecklistAsTemplateMutation = {
  __typename?: 'Mutation';
  saveChecklistAsTemplate: { __typename?: 'ChecklistTemplate'; id: string };
};

export type SetPrimaryTeamMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type SetPrimaryTeamMutation = {
  __typename?: 'Mutation';
  setPrimaryTeam: { __typename?: 'User'; id: string; name?: string | null };
};

export type ToggleChecklistTemplateFavoriteMutationVariables = Exact<{
  checklistTemplateId: Scalars['ID']['input'];
}>;

export type ToggleChecklistTemplateFavoriteMutation = {
  __typename?: 'Mutation';
  toggleChecklistTemplateFavorite: boolean;
};

export type UnarchiveChatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type UnarchiveChatMutation = {
  __typename?: 'Mutation';
  unarchiveChat: {
    __typename?: 'Chat';
    id: string;
    name: string;
    description?: string | null;
    users: Array<{ __typename?: 'User'; id: string }>;
  };
};

export type UnarchiveProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type UnarchiveProjectMutation = {
  __typename?: 'Mutation';
  unarchiveProject: {
    __typename?: 'Project';
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    archivedAt?: any | null;
    usersCount: number;
    tasksCount: number;
    currentUserRole?: ProjectMemberRole | null;
    currentUserTeamRole?: TeamMemberRole | null;
    currentUserHasPendingMemberAdditionRequest: boolean;
    isTaskMember: boolean;
    teamId: string;
    color: string;
    icon?: string | null;
    createdAt: any;
    description?: string | null;
    id: string;
    uuid: string;
    initials: string;
    name: string;
    unreadAuditsCount?: number | null;
    activeTasksCount: number;
    upcomingTasksCount: number;
    overdueTasksCount: number;
    completedTasksCount: number;
    completedChecklistCount: number;
    creator: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    coverImage?: {
      __typename?: 'File';
      id: string;
      url: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    team?: {
      __typename?: 'Team';
      avatar?: string | null;
      createdAt: any;
      id: string;
      uuid: string;
      name: string;
      personal: boolean;
      hasReachedMaxProjects: boolean;
      currentUserRole?: TeamRole | null;
      storageRemaining: any;
      owner: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
      subscriptionDetails?: {
        __typename?: 'SubscriptionDetails';
        expirationDate?: any | null;
        subscriptionInterval?: string | null;
        subscriptionPlanName?: string | null;
        subscriptionStatus?: string | null;
        isSubscriptionCanceled: boolean;
        isSubscriptionActive: boolean;
        isSubscriptionOnTrial: boolean;
        trialEndsAt?: any | null;
        updatedAt?: any | null;
      } | null;
    } | null;
    memberPreviews: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          url: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    members: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          url: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    audits?: Array<{ __typename?: 'Audit'; id: string; event: string }> | null;
    settings?: {
      __typename?: 'UserProjectSetting';
      id: string;
      pin: boolean;
    } | null;
    invitations?: Array<{
      __typename?: 'ProjectInvitation';
      id: string;
      email: string;
      role: ProjectMemberRole;
      expiredAt?: any | null;
      createdAt: any;
      invitedBy: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      };
    }> | null;
    userRequests?: Array<{
      __typename?: 'UserRequest';
      id: string;
      role?: string | null;
      status: string;
      expiredAt?: any | null;
      createdAt: any;
      requestType: UserRequestCategory;
      userRequestableId: string;
      userRequestableType: UserRequestable;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
      reviewedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    }> | null;
  };
};

export type UpdateChatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: ChatAttributes;
}>;

export type UpdateChatMutation = {
  __typename?: 'Mutation';
  updateChat: {
    __typename?: 'Chat';
    id: string;
    name: string;
    description?: string | null;
    settingsPin?: boolean | null;
    settingsMute?: boolean | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    settings?: {
      __typename?: 'UserChatSetting';
      id: string;
      pin: boolean;
      mute: boolean;
      archivedAt?: any | null;
    } | null;
  };
};

export type UpdateChatAdminMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;

export type UpdateChatAdminMutation = {
  __typename?: 'Mutation';
  updateChatAdmin: {
    __typename?: 'Chat';
    id: string;
    name: string;
    description?: string | null;
    owner: { __typename?: 'User'; id: string };
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    settings?: {
      __typename?: 'UserChatSetting';
      mute: boolean;
      pin: boolean;
    } | null;
  };
};

export type UpdateDocumentTagsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
  attributes: MessageTagAttributes;
}>;

export type UpdateDocumentTagsMutation = {
  __typename?: 'Mutation';
  updateDocumentTags: {
    __typename?: 'Document';
    id: string;
    clientId: string;
    taskDocuments?: Array<{
      __typename?: 'TaskDocument';
      id: string;
      owner?: { __typename?: 'User'; id: string } | null;
      task?: {
        __typename?: 'Task';
        id: string;
        name: string;
        projectId: string;
        project: { __typename?: 'Project'; id: string; name: string };
      } | null;
    }> | null;
    projectDocuments?: Array<{
      __typename?: 'ProjectDocument';
      id: string;
      owner?: { __typename?: 'User'; id: string } | null;
      project?: { __typename?: 'Project'; id: string; name: string } | null;
    }> | null;
    messageDocuments?: Array<{
      __typename?: 'MessageDocument';
      message?: {
        __typename?: 'Message';
        id: string;
        chatId: string;
        clientId: string;
        body?: string | null;
        createdAt: any;
        isSender: boolean;
        isDraft: boolean;
        publishedAt?: any | null;
        authorId: string;
        authorAvatarId?: string | null;
        authorName?: string | null;
        authorFirstName?: string | null;
        authorLastName?: string | null;
        authorEmail?: string | null;
        readAt?: any | null;
        isRetry: boolean;
        replyId?: string | null;
        readReceipts?: Array<{
          __typename?: 'User';
          id: string;
          email: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          phoneNumber: string;
          primaryTeamId?: string | null;
          createdAt: any;
          inviteUrl: string;
          avatarId?: string | null;
          avatarIsPreviewable?: boolean | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
          skills?: Array<{
            __typename?: 'Skill';
            id: string;
            name: string;
            createdAt: any;
          }> | null;
        }> | null;
        checkin?: {
          __typename?: 'MessageCheckin';
          id: string;
          address?: string | null;
          city?: string | null;
          zipcode?: string | null;
          state?: string | null;
          country?: string | null;
          latitude?: number | null;
          longitude?: number | null;
          withinGeofence: boolean;
        } | null;
        userRequest?: {
          __typename?: 'UserRequest';
          id: string;
          requestType: UserRequestCategory;
          status: string;
          canBeReviewed: boolean;
          expiredAt?: any | null;
          userRequestableId: string;
          userRequestableType: UserRequestable;
          invitedBy?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
          } | null;
          reviewedBy?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
          } | null;
          user?: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
          } | null;
        } | null;
        replyMessage?: {
          __typename?: 'Message';
          id: string;
          chatId: string;
          clientId: string;
          body?: string | null;
          deletedAt?: any | null;
          createdAt: any;
          isSender: boolean;
          isDraft: boolean;
          publishedAt?: any | null;
          authorId: string;
          authorAvatarId?: string | null;
          authorName?: string | null;
          authorFirstName?: string | null;
          authorLastName?: string | null;
          authorEmail?: string | null;
          attachments?: Array<
            | {
                __typename?: 'Document';
                id: string;
                name: string;
                contentType?: string | null;
                createdAt: any;
                size?: number | null;
                isImage: boolean;
                clientId: string;
                isAudio: boolean;
                duration?: number | null;
                file: {
                  __typename?: 'File';
                  id: string;
                  url: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                };
                owner: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  createdAt: any;
                };
              }
            | { __typename?: 'EntityUser' }
            | { __typename?: 'Folder' }
            | { __typename?: 'LocalFile' }
            | { __typename?: 'Message' }
            | {
                __typename?: 'MessageProject';
                id: string;
                authorId: string;
                author?: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                } | null;
                project?: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                  team?: {
                    __typename?: 'Team';
                    subscriptionDetails?: {
                      __typename?: 'SubscriptionDetails';
                      expirationDate?: any | null;
                      subscriptionStatus?: string | null;
                    } | null;
                  } | null;
                } | null;
              }
            | {
                __typename?: 'MessageTask';
                id: string;
                authorId: string;
                author?: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                } | null;
                task?: {
                  __typename?: 'Task';
                  id: string;
                  projectId: string;
                  name: string;
                } | null;
              }
            | {
                __typename?: 'MessageTaskAssignment';
                id: string;
                messageId: string;
                assignees: Array<{
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  phoneNumber: string;
                  primaryTeamId?: string | null;
                  createdAt: any;
                  inviteUrl: string;
                  avatarId?: string | null;
                  avatarIsPreviewable?: boolean | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                  skills?: Array<{
                    __typename?: 'Skill';
                    id: string;
                    name: string;
                    createdAt: any;
                  }> | null;
                }>;
                task?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  deletedAt?: any | null;
                  completedAt?: any | null;
                } | null;
              }
            | {
                __typename?: 'MessageTaskComplete';
                id: string;
                messageId: string;
                completor?: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                } | null;
              }
            | { __typename?: 'Project' }
            | { __typename?: 'ProjectUser' }
            | { __typename?: 'PublicTeam' }
            | { __typename?: 'Task' }
            | { __typename?: 'TaskUser' }
            | { __typename?: 'UserRequest' }
          > | null;
        } | null;
        attachments?: Array<
          | {
              __typename?: 'Document';
              id: string;
              blobId?: string | null;
              name: string;
              contentType?: string | null;
              createdAt: any;
              size?: number | null;
              isImage: boolean;
              clientId: string;
              isAudio: boolean;
              duration?: number | null;
              file: {
                __typename?: 'File';
                id: string;
                url: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              };
              owner: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                createdAt: any;
              };
              taskDocuments?: Array<{
                __typename?: 'TaskDocument';
                id: string;
                owner?: { __typename?: 'User'; id: string } | null;
                task?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  projectId: string;
                  project: { __typename?: 'Project'; id: string; name: string };
                } | null;
              }> | null;
              projectDocuments?: Array<{
                __typename?: 'ProjectDocument';
                id: string;
                owner?: { __typename?: 'User'; id: string } | null;
                project?: {
                  __typename?: 'Project';
                  id: string;
                  name: string;
                } | null;
              }> | null;
            }
          | { __typename?: 'EntityUser' }
          | { __typename?: 'Folder' }
          | { __typename?: 'LocalFile' }
          | { __typename?: 'Message' }
          | {
              __typename?: 'MessageProject';
              id: string;
              authorId: string;
              author?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              } | null;
              project?: {
                __typename?: 'Project';
                id: string;
                uuid: string;
                name: string;
                team?: {
                  __typename?: 'Team';
                  subscriptionDetails?: {
                    __typename?: 'SubscriptionDetails';
                    expirationDate?: any | null;
                    subscriptionStatus?: string | null;
                  } | null;
                } | null;
              } | null;
            }
          | {
              __typename?: 'MessageTask';
              id: string;
              authorId: string;
              author?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              } | null;
              task?: {
                __typename?: 'Task';
                id: string;
                projectId: string;
                deletedAt?: any | null;
                name: string;
              } | null;
            }
          | {
              __typename?: 'MessageTaskAssignment';
              id: string;
              messageId: string;
              assignees: Array<{
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              }>;
              task?: {
                __typename?: 'Task';
                id: string;
                name: string;
                deletedAt?: any | null;
                completedAt?: any | null;
                currentUserRole?: TaskMemberRole | null;
              } | null;
            }
          | {
              __typename?: 'MessageTaskComplete';
              id: string;
              messageId: string;
              completor?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              } | null;
            }
          | { __typename?: 'Project' }
          | { __typename?: 'ProjectUser' }
          | { __typename?: 'PublicTeam' }
          | { __typename?: 'Task' }
          | { __typename?: 'TaskUser' }
          | { __typename?: 'UserRequest' }
        > | null;
        reaction?: Array<{
          __typename?: 'MessageReaction';
          id: string;
          reaction: string;
          count: number;
          user?: Array<{
            __typename?: 'User';
            id: string;
            name?: string | null;
          }> | null;
        }> | null;
      } | null;
    }> | null;
  };
};

export type UpdateDraftMessageMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
  attributes: DraftMessageAttributes;
}>;

export type UpdateDraftMessageMutation = {
  __typename?: 'Mutation';
  updateDraftMessage?: {
    __typename?: 'DraftMessage';
    chatId: string;
    body?: string | null;
    tagsCollection: Array<{
      __typename?: 'TaskTagCollection';
      tasks: Array<{
        __typename?: 'TaskTag';
        id: string;
        name: string;
        userIds: Array<string>;
        status?: TaskStatus | null;
        projectId: string;
        project?: {
          __typename?: 'ProjectTag';
          id: string;
          name: string;
          uuid: string;
        } | null;
      } | null>;
      project: {
        __typename?: 'ProjectTag';
        id: string;
        name: string;
        uuid: string;
      };
      author: { __typename?: 'User'; id: string; name?: string | null };
    } | null>;
    localFiles: Array<{
      __typename?: 'LocalFile';
      id: string;
      name: string;
      clientId: string;
      url: string;
      cdnBaseUrl: string;
      path: string;
      contentType: string;
      isImage: boolean;
      isVideo: boolean;
      size?: number | null;
      isAudio: boolean;
      duration?: number | null;
      isPreviewable: boolean;
      thumbnail: string;
      blobId?: string | null;
    } | null>;
    replyMessage?: {
      __typename?: 'Message';
      id: string;
      chatId: string;
      clientId: string;
      body?: string | null;
      createdAt: any;
      isSender: boolean;
      isDraft: boolean;
      publishedAt?: any | null;
      authorId: string;
      authorAvatarId?: string | null;
      authorName?: string | null;
      authorFirstName?: string | null;
      authorLastName?: string | null;
      authorEmail?: string | null;
      readAt?: any | null;
      isRetry: boolean;
      replyId?: string | null;
      readReceipts?: Array<{
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      }> | null;
      checkin?: {
        __typename?: 'MessageCheckin';
        id: string;
        address?: string | null;
        city?: string | null;
        zipcode?: string | null;
        state?: string | null;
        country?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        withinGeofence: boolean;
      } | null;
      userRequest?: {
        __typename?: 'UserRequest';
        id: string;
        requestType: UserRequestCategory;
        status: string;
        canBeReviewed: boolean;
        expiredAt?: any | null;
        userRequestableId: string;
        userRequestableType: UserRequestable;
        invitedBy?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName?: string | null;
        } | null;
        reviewedBy?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName?: string | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          email: string;
          name?: string | null;
        } | null;
      } | null;
      replyMessage?: {
        __typename?: 'Message';
        id: string;
        chatId: string;
        clientId: string;
        body?: string | null;
        deletedAt?: any | null;
        createdAt: any;
        isSender: boolean;
        isDraft: boolean;
        publishedAt?: any | null;
        authorId: string;
        authorAvatarId?: string | null;
        authorName?: string | null;
        authorFirstName?: string | null;
        authorLastName?: string | null;
        authorEmail?: string | null;
        attachments?: Array<
          | {
              __typename?: 'Document';
              id: string;
              name: string;
              contentType?: string | null;
              createdAt: any;
              size?: number | null;
              isImage: boolean;
              clientId: string;
              isAudio: boolean;
              duration?: number | null;
              file: {
                __typename?: 'File';
                id: string;
                url: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              };
              owner: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                createdAt: any;
              };
            }
          | { __typename?: 'EntityUser' }
          | { __typename?: 'Folder' }
          | { __typename?: 'LocalFile' }
          | { __typename?: 'Message' }
          | {
              __typename?: 'MessageProject';
              id: string;
              authorId: string;
              author?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              } | null;
              project?: {
                __typename?: 'Project';
                id: string;
                uuid: string;
                name: string;
                team?: {
                  __typename?: 'Team';
                  subscriptionDetails?: {
                    __typename?: 'SubscriptionDetails';
                    expirationDate?: any | null;
                    subscriptionStatus?: string | null;
                  } | null;
                } | null;
              } | null;
            }
          | {
              __typename?: 'MessageTask';
              id: string;
              authorId: string;
              author?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              } | null;
              task?: {
                __typename?: 'Task';
                id: string;
                projectId: string;
                name: string;
              } | null;
            }
          | {
              __typename?: 'MessageTaskAssignment';
              id: string;
              messageId: string;
              assignees: Array<{
                __typename?: 'User';
                id: string;
                email: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                phoneNumber: string;
                primaryTeamId?: string | null;
                createdAt: any;
                inviteUrl: string;
                avatarId?: string | null;
                avatarIsPreviewable?: boolean | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
                skills?: Array<{
                  __typename?: 'Skill';
                  id: string;
                  name: string;
                  createdAt: any;
                }> | null;
              }>;
              task?: {
                __typename?: 'Task';
                id: string;
                name: string;
                deletedAt?: any | null;
                completedAt?: any | null;
              } | null;
            }
          | {
              __typename?: 'MessageTaskComplete';
              id: string;
              messageId: string;
              completor?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              } | null;
            }
          | { __typename?: 'Project' }
          | { __typename?: 'ProjectUser' }
          | { __typename?: 'PublicTeam' }
          | { __typename?: 'Task' }
          | { __typename?: 'TaskUser' }
          | { __typename?: 'UserRequest' }
        > | null;
      } | null;
      attachments?: Array<
        | {
            __typename?: 'Document';
            id: string;
            blobId?: string | null;
            name: string;
            contentType?: string | null;
            createdAt: any;
            size?: number | null;
            isImage: boolean;
            clientId: string;
            isAudio: boolean;
            duration?: number | null;
            file: {
              __typename?: 'File';
              id: string;
              url: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            };
            owner: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              createdAt: any;
            };
            taskDocuments?: Array<{
              __typename?: 'TaskDocument';
              id: string;
              owner?: { __typename?: 'User'; id: string } | null;
              task?: {
                __typename?: 'Task';
                id: string;
                name: string;
                projectId: string;
                project: { __typename?: 'Project'; id: string; name: string };
              } | null;
            }> | null;
            projectDocuments?: Array<{
              __typename?: 'ProjectDocument';
              id: string;
              owner?: { __typename?: 'User'; id: string } | null;
              project?: {
                __typename?: 'Project';
                id: string;
                name: string;
              } | null;
            }> | null;
          }
        | { __typename?: 'EntityUser' }
        | { __typename?: 'Folder' }
        | { __typename?: 'LocalFile' }
        | { __typename?: 'Message' }
        | {
            __typename?: 'MessageProject';
            id: string;
            authorId: string;
            author?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
            project?: {
              __typename?: 'Project';
              id: string;
              uuid: string;
              name: string;
              team?: {
                __typename?: 'Team';
                subscriptionDetails?: {
                  __typename?: 'SubscriptionDetails';
                  expirationDate?: any | null;
                  subscriptionStatus?: string | null;
                } | null;
              } | null;
            } | null;
          }
        | {
            __typename?: 'MessageTask';
            id: string;
            authorId: string;
            author?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
            task?: {
              __typename?: 'Task';
              id: string;
              projectId: string;
              deletedAt?: any | null;
              name: string;
            } | null;
          }
        | {
            __typename?: 'MessageTaskAssignment';
            id: string;
            messageId: string;
            assignees: Array<{
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            }>;
            task?: {
              __typename?: 'Task';
              id: string;
              name: string;
              deletedAt?: any | null;
              completedAt?: any | null;
              currentUserRole?: TaskMemberRole | null;
            } | null;
          }
        | {
            __typename?: 'MessageTaskComplete';
            id: string;
            messageId: string;
            completor?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
          }
        | { __typename?: 'Project' }
        | { __typename?: 'ProjectUser' }
        | { __typename?: 'PublicTeam' }
        | { __typename?: 'Task' }
        | { __typename?: 'TaskUser' }
        | { __typename?: 'UserRequest' }
      > | null;
      reaction?: Array<{
        __typename?: 'MessageReaction';
        id: string;
        reaction: string;
        count: number;
        user?: Array<{
          __typename?: 'User';
          id: string;
          name?: string | null;
        }> | null;
      }> | null;
    } | null;
    checkin?: {
      __typename?: 'MessageCheckin';
      id: string;
      address?: string | null;
      city?: string | null;
      zipcode?: string | null;
      state?: string | null;
      country?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      withinGeofence: boolean;
    } | null;
  } | null;
};

export type UpdateGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: GroupAttributes;
}>;

export type UpdateGroupMutation = {
  __typename?: 'Mutation';
  updateGroup: {
    __typename?: 'Group';
    id: string;
    name: string;
    team?: { __typename?: 'Team'; id: string } | null;
    users?: Array<{ __typename?: 'User'; id: string }> | null;
  };
};

export type UpdateHashtagTooltipSeenMutationVariables = Exact<{
  web: Scalars['Boolean']['input'];
}>;

export type UpdateHashtagTooltipSeenMutation = {
  __typename?: 'Mutation';
  updateHashtagTooltipSeen: {
    __typename?: 'User';
    id: string;
    hasSeenTagTooltipWeb: boolean;
    hasSeenTagTooltipNative: boolean;
  };
};

export type UpdateMeMutationVariables = Exact<{
  attributes: UserAttributes;
}>;

export type UpdateMeMutation = {
  __typename?: 'Mutation';
  updateMe: {
    __typename?: 'User';
    id: string;
    name?: string | null;
    email: string;
    phoneNumber: string;
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    timeZone?: string | null;
    skills?: Array<{ __typename?: 'Skill'; name: string }> | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
  };
};

export type UpdateMessageIndividualMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  attributes: MessageAttributes;
}>;

export type UpdateMessageIndividualMutation = {
  __typename?: 'Mutation';
  updateMessageIndividual: {
    __typename?: 'Message';
    id: string;
    chatId: string;
    clientId: string;
    body?: string | null;
    createdAt: any;
    isSender: boolean;
    isDraft: boolean;
    publishedAt?: any | null;
    authorId: string;
    authorAvatarId?: string | null;
    authorName?: string | null;
    authorFirstName?: string | null;
    authorLastName?: string | null;
    authorEmail?: string | null;
    readAt?: any | null;
    isRetry: boolean;
    replyId?: string | null;
    readReceipts?: Array<{
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    }> | null;
    checkin?: {
      __typename?: 'MessageCheckin';
      id: string;
      address?: string | null;
      city?: string | null;
      zipcode?: string | null;
      state?: string | null;
      country?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      withinGeofence: boolean;
    } | null;
    userRequest?: {
      __typename?: 'UserRequest';
      id: string;
      requestType: UserRequestCategory;
      status: string;
      canBeReviewed: boolean;
      expiredAt?: any | null;
      userRequestableId: string;
      userRequestableType: UserRequestable;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
      } | null;
      reviewedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
      } | null;
    } | null;
    replyMessage?: {
      __typename?: 'Message';
      id: string;
      chatId: string;
      clientId: string;
      body?: string | null;
      deletedAt?: any | null;
      createdAt: any;
      isSender: boolean;
      isDraft: boolean;
      publishedAt?: any | null;
      authorId: string;
      authorAvatarId?: string | null;
      authorName?: string | null;
      authorFirstName?: string | null;
      authorLastName?: string | null;
      authorEmail?: string | null;
      attachments?: Array<
        | {
            __typename?: 'Document';
            id: string;
            name: string;
            contentType?: string | null;
            createdAt: any;
            size?: number | null;
            isImage: boolean;
            clientId: string;
            isAudio: boolean;
            duration?: number | null;
            file: {
              __typename?: 'File';
              id: string;
              url: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            };
            owner: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              createdAt: any;
            };
          }
        | { __typename?: 'EntityUser' }
        | { __typename?: 'Folder' }
        | { __typename?: 'LocalFile' }
        | { __typename?: 'Message' }
        | {
            __typename?: 'MessageProject';
            id: string;
            authorId: string;
            author?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
            project?: {
              __typename?: 'Project';
              id: string;
              uuid: string;
              name: string;
              team?: {
                __typename?: 'Team';
                subscriptionDetails?: {
                  __typename?: 'SubscriptionDetails';
                  expirationDate?: any | null;
                  subscriptionStatus?: string | null;
                } | null;
              } | null;
            } | null;
          }
        | {
            __typename?: 'MessageTask';
            id: string;
            authorId: string;
            author?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
            task?: {
              __typename?: 'Task';
              id: string;
              projectId: string;
              name: string;
            } | null;
          }
        | {
            __typename?: 'MessageTaskAssignment';
            id: string;
            messageId: string;
            assignees: Array<{
              __typename?: 'User';
              id: string;
              email: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              phoneNumber: string;
              primaryTeamId?: string | null;
              createdAt: any;
              inviteUrl: string;
              avatarId?: string | null;
              avatarIsPreviewable?: boolean | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
              skills?: Array<{
                __typename?: 'Skill';
                id: string;
                name: string;
                createdAt: any;
              }> | null;
            }>;
            task?: {
              __typename?: 'Task';
              id: string;
              name: string;
              deletedAt?: any | null;
              completedAt?: any | null;
            } | null;
          }
        | {
            __typename?: 'MessageTaskComplete';
            id: string;
            messageId: string;
            completor?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
          }
        | { __typename?: 'Project' }
        | { __typename?: 'ProjectUser' }
        | { __typename?: 'PublicTeam' }
        | { __typename?: 'Task' }
        | { __typename?: 'TaskUser' }
        | { __typename?: 'UserRequest' }
      > | null;
    } | null;
    attachments?: Array<
      | {
          __typename?: 'Document';
          id: string;
          blobId?: string | null;
          name: string;
          contentType?: string | null;
          createdAt: any;
          size?: number | null;
          isImage: boolean;
          clientId: string;
          isAudio: boolean;
          duration?: number | null;
          file: {
            __typename?: 'File';
            id: string;
            url: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          };
          owner: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            createdAt: any;
          };
          taskDocuments?: Array<{
            __typename?: 'TaskDocument';
            id: string;
            owner?: { __typename?: 'User'; id: string } | null;
            task?: {
              __typename?: 'Task';
              id: string;
              name: string;
              projectId: string;
              project: { __typename?: 'Project'; id: string; name: string };
            } | null;
          }> | null;
          projectDocuments?: Array<{
            __typename?: 'ProjectDocument';
            id: string;
            owner?: { __typename?: 'User'; id: string } | null;
            project?: {
              __typename?: 'Project';
              id: string;
              name: string;
            } | null;
          }> | null;
        }
      | { __typename?: 'EntityUser' }
      | { __typename?: 'Folder' }
      | { __typename?: 'LocalFile' }
      | { __typename?: 'Message' }
      | {
          __typename?: 'MessageProject';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
          project?: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
            team?: {
              __typename?: 'Team';
              subscriptionDetails?: {
                __typename?: 'SubscriptionDetails';
                expirationDate?: any | null;
                subscriptionStatus?: string | null;
              } | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'MessageTask';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
          task?: {
            __typename?: 'Task';
            id: string;
            projectId: string;
            deletedAt?: any | null;
            name: string;
          } | null;
        }
      | {
          __typename?: 'MessageTaskAssignment';
          id: string;
          messageId: string;
          assignees: Array<{
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          }>;
          task?: {
            __typename?: 'Task';
            id: string;
            name: string;
            deletedAt?: any | null;
            completedAt?: any | null;
            currentUserRole?: TaskMemberRole | null;
          } | null;
        }
      | {
          __typename?: 'MessageTaskComplete';
          id: string;
          messageId: string;
          completor?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
        }
      | { __typename?: 'Project' }
      | { __typename?: 'ProjectUser' }
      | { __typename?: 'PublicTeam' }
      | { __typename?: 'Task' }
      | { __typename?: 'TaskUser' }
      | { __typename?: 'UserRequest' }
    > | null;
    reaction?: Array<{
      __typename?: 'MessageReaction';
      id: string;
      reaction: string;
      count: number;
      user?: Array<{
        __typename?: 'User';
        id: string;
        name?: string | null;
      }> | null;
    }> | null;
  };
};

export type UpdateMessageTagsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: MessageTagAttributes;
}>;

export type UpdateMessageTagsMutation = {
  __typename?: 'Mutation';
  updateMessageTags: {
    __typename?: 'Message';
    id: string;
    chatId: string;
    clientId: string;
    body?: string | null;
    createdAt: any;
    isSender: boolean;
    isDraft: boolean;
    publishedAt?: any | null;
    authorId: string;
    authorAvatarId?: string | null;
    authorName?: string | null;
    authorFirstName?: string | null;
    authorLastName?: string | null;
    authorEmail?: string | null;
    readAt?: any | null;
    isRetry: boolean;
    replyId?: string | null;
    readReceipts?: Array<{
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    }> | null;
    checkin?: {
      __typename?: 'MessageCheckin';
      id: string;
      address?: string | null;
      city?: string | null;
      zipcode?: string | null;
      state?: string | null;
      country?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      withinGeofence: boolean;
    } | null;
    userRequest?: {
      __typename?: 'UserRequest';
      id: string;
      requestType: UserRequestCategory;
      status: string;
      canBeReviewed: boolean;
      expiredAt?: any | null;
      userRequestableId: string;
      userRequestableType: UserRequestable;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
      } | null;
      reviewedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
      } | null;
    } | null;
    replyMessage?: {
      __typename?: 'Message';
      id: string;
      chatId: string;
      clientId: string;
      body?: string | null;
      deletedAt?: any | null;
      createdAt: any;
      isSender: boolean;
      isDraft: boolean;
      publishedAt?: any | null;
      authorId: string;
      authorAvatarId?: string | null;
      authorName?: string | null;
      authorFirstName?: string | null;
      authorLastName?: string | null;
      authorEmail?: string | null;
      attachments?: Array<
        | {
            __typename?: 'Document';
            id: string;
            name: string;
            contentType?: string | null;
            createdAt: any;
            size?: number | null;
            isImage: boolean;
            clientId: string;
            isAudio: boolean;
            duration?: number | null;
            file: {
              __typename?: 'File';
              id: string;
              url: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            };
            owner: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              createdAt: any;
            };
          }
        | { __typename?: 'EntityUser' }
        | { __typename?: 'Folder' }
        | { __typename?: 'LocalFile' }
        | { __typename?: 'Message' }
        | {
            __typename?: 'MessageProject';
            id: string;
            authorId: string;
            author?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
            project?: {
              __typename?: 'Project';
              id: string;
              uuid: string;
              name: string;
              team?: {
                __typename?: 'Team';
                subscriptionDetails?: {
                  __typename?: 'SubscriptionDetails';
                  expirationDate?: any | null;
                  subscriptionStatus?: string | null;
                } | null;
              } | null;
            } | null;
          }
        | {
            __typename?: 'MessageTask';
            id: string;
            authorId: string;
            author?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
            task?: {
              __typename?: 'Task';
              id: string;
              projectId: string;
              name: string;
            } | null;
          }
        | {
            __typename?: 'MessageTaskAssignment';
            id: string;
            messageId: string;
            assignees: Array<{
              __typename?: 'User';
              id: string;
              email: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              phoneNumber: string;
              primaryTeamId?: string | null;
              createdAt: any;
              inviteUrl: string;
              avatarId?: string | null;
              avatarIsPreviewable?: boolean | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
              skills?: Array<{
                __typename?: 'Skill';
                id: string;
                name: string;
                createdAt: any;
              }> | null;
            }>;
            task?: {
              __typename?: 'Task';
              id: string;
              name: string;
              deletedAt?: any | null;
              completedAt?: any | null;
            } | null;
          }
        | {
            __typename?: 'MessageTaskComplete';
            id: string;
            messageId: string;
            completor?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
          }
        | { __typename?: 'Project' }
        | { __typename?: 'ProjectUser' }
        | { __typename?: 'PublicTeam' }
        | { __typename?: 'Task' }
        | { __typename?: 'TaskUser' }
        | { __typename?: 'UserRequest' }
      > | null;
    } | null;
    attachments?: Array<
      | {
          __typename?: 'Document';
          id: string;
          blobId?: string | null;
          name: string;
          contentType?: string | null;
          createdAt: any;
          size?: number | null;
          isImage: boolean;
          clientId: string;
          isAudio: boolean;
          duration?: number | null;
          file: {
            __typename?: 'File';
            id: string;
            url: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          };
          owner: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            createdAt: any;
          };
          taskDocuments?: Array<{
            __typename?: 'TaskDocument';
            id: string;
            owner?: { __typename?: 'User'; id: string } | null;
            task?: {
              __typename?: 'Task';
              id: string;
              name: string;
              projectId: string;
              project: { __typename?: 'Project'; id: string; name: string };
            } | null;
          }> | null;
          projectDocuments?: Array<{
            __typename?: 'ProjectDocument';
            id: string;
            owner?: { __typename?: 'User'; id: string } | null;
            project?: {
              __typename?: 'Project';
              id: string;
              name: string;
            } | null;
          }> | null;
        }
      | { __typename?: 'EntityUser' }
      | { __typename?: 'Folder' }
      | { __typename?: 'LocalFile' }
      | { __typename?: 'Message' }
      | {
          __typename?: 'MessageProject';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
          project?: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
            team?: {
              __typename?: 'Team';
              subscriptionDetails?: {
                __typename?: 'SubscriptionDetails';
                expirationDate?: any | null;
                subscriptionStatus?: string | null;
              } | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'MessageTask';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
          task?: {
            __typename?: 'Task';
            id: string;
            projectId: string;
            deletedAt?: any | null;
            name: string;
          } | null;
        }
      | {
          __typename?: 'MessageTaskAssignment';
          id: string;
          messageId: string;
          assignees: Array<{
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          }>;
          task?: {
            __typename?: 'Task';
            id: string;
            name: string;
            deletedAt?: any | null;
            completedAt?: any | null;
            currentUserRole?: TaskMemberRole | null;
          } | null;
        }
      | {
          __typename?: 'MessageTaskComplete';
          id: string;
          messageId: string;
          completor?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
        }
      | { __typename?: 'Project' }
      | { __typename?: 'ProjectUser' }
      | { __typename?: 'PublicTeam' }
      | { __typename?: 'Task' }
      | { __typename?: 'TaskUser' }
      | { __typename?: 'UserRequest' }
    > | null;
    reaction?: Array<{
      __typename?: 'MessageReaction';
      id: string;
      reaction: string;
      count: number;
      user?: Array<{
        __typename?: 'User';
        id: string;
        name?: string | null;
      }> | null;
    }> | null;
  };
};

export type UpdateNotificationSettingMutationVariables = Exact<{
  attributes:
    | Array<NotificationSettingAttributes>
    | NotificationSettingAttributes;
}>;

export type UpdateNotificationSettingMutation = {
  __typename?: 'Mutation';
  updateNotificationSetting: Array<{
    __typename?: 'UserNotificationSetting';
    settingType: NotificationSetting;
    mute: boolean;
    duration?: NotificationSettingDuration | null;
  }>;
};

export type UpdateOnboardingStateMutationVariables = Exact<{
  attributes: OnboardingStateAttributes;
}>;

export type UpdateOnboardingStateMutation = {
  __typename?: 'Mutation';
  updateOnboardingState: { __typename?: 'User'; id: string };
};

export type UpdatePaymentMethodMutationVariables = Exact<{
  teamId: Scalars['ID']['input'];
  paymentMethodToken: Scalars['String']['input'];
}>;

export type UpdatePaymentMethodMutation = {
  __typename?: 'Mutation';
  updatePaymentMethod: {
    __typename?: 'Team';
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    id: string;
    uuid: string;
    avatar?: string | null;
    createdAt: any;
    name: string;
    usersCount: number;
    fileStorageUsed: any;
    mediaStorageUsed: any;
    pending: boolean;
    maxDocumentStorage: any;
    storageRemaining: any;
    currentUserRole?: TeamRole | null;
    hasReachedMaxProjects: boolean;
    numberOfProjectsUsed: number;
    maxNumberOfProjects: number;
    personal: boolean;
    billingSource?: string | null;
    teamSubscriptionStatus?: string | null;
    entitlementExpiration?: any | null;
    tasksCount: number;
    completedTasksCount: number;
    avatarFile?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    subscriptionDetails?: {
      __typename?: 'SubscriptionDetails';
      expirationDate?: any | null;
      subscriptionInterval?: string | null;
      subscriptionPlanName?: string | null;
      subscriptionStatus?: string | null;
      trialEndsAt?: any | null;
      canceledAt?: any | null;
      stripeProductId?: string | null;
      isSubscriptionCanceled: boolean;
      isSubscriptionActive: boolean;
      isSubscriptionOnTrial: boolean;
      updatedAt?: any | null;
      paymentCardLast4?: string | null;
      paymentCardBrand?: string | null;
      paymentCardExpMonth?: string | null;
      paymentCardExpYear?: string | null;
      currentSeatCount?: number | null;
      pricePerSeat?: string | null;
    } | null;
    owner: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    skills: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }>;
    product?: {
      __typename?: 'Product';
      id: string;
      name: string;
      prices: Array<{
        __typename?: 'Price';
        id: string;
        interval: string;
        intervalCount: number;
        externalId: string;
      }>;
    } | null;
    users: Array<{
      __typename?: 'User';
      teamRoles?: Array<TeamRole> | null;
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    }>;
    invitations?: Array<{
      __typename?: 'TeamInvitation';
      email?: string | null;
      expiredAt?: any | null;
      id: string;
      role?: TeamRole | null;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
    }> | null;
    invoices?: Array<{
      __typename?: 'Invoice';
      id: string;
      invoiceUrl: string;
      amount: number;
      date: any;
      description: string;
      status: string;
    }> | null;
  };
};

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: ProjectAttributes;
}>;

export type UpdateProjectMutation = {
  __typename?: 'Mutation';
  updateProject?: {
    __typename?: 'Project';
    id: string;
    teamId: string;
    initials: string;
    name: string;
    description?: string | null;
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    color: string;
    icon?: string | null;
    createdAt: any;
    archivedAt?: any | null;
    coverImage?: {
      __typename?: 'File';
      id: string;
      url: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    team?: {
      __typename?: 'Team';
      id: string;
      name: string;
      avatar?: string | null;
    } | null;
    members: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    creator: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    tasks?: Array<{ __typename?: 'Task'; id: string }> | null;
    settings?: {
      __typename?: 'UserProjectSetting';
      id: string;
      pin: boolean;
    } | null;
  } | null;
};

export type UpdateProjectChecklistMutationVariables = Exact<{
  projectChecklistId: Scalars['ID']['input'];
  attributes: UpdateProjectChecklistAttributes;
}>;

export type UpdateProjectChecklistMutation = {
  __typename?: 'Mutation';
  updateProjectChecklist: {
    __typename?: 'ProjectChecklist';
    projectId: string;
    id: string;
    name: string;
    completedAt?: any | null;
    createdAt: any;
    sort?: number | null;
  };
};

export type UpdateProjectChecklistSortMutationVariables = Exact<{
  projectUUId: Scalars['ID']['input'];
  attributes:
    | Array<ProjectChecklistSortAttributes>
    | ProjectChecklistSortAttributes;
}>;

export type UpdateProjectChecklistSortMutation = {
  __typename?: 'Mutation';
  updateProjectChecklistSort: Array<{
    __typename?: 'ProjectChecklist';
    projectId: string;
  }>;
};

export type UpdateProjectFileTagsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  taskIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
}>;

export type UpdateProjectFileTagsMutation = {
  __typename?: 'Mutation';
  updateProjectFileTags: {
    __typename?: 'Document';
    id: string;
    clientId: string;
  };
};

export type UpdateProjectMembersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: Array<ProjectMemberAttributes> | ProjectMemberAttributes;
}>;

export type UpdateProjectMembersMutation = {
  __typename?: 'Mutation';
  updateProjectMembers: {
    __typename?: 'Project';
    id: string;
    usersCount: number;
    members: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
  };
};

export type UpdateRateUsStateMutationVariables = Exact<{
  attributes: UpdateRateUsStateAttributes;
}>;

export type UpdateRateUsStateMutation = {
  __typename?: 'Mutation';
  updateRateUsState: {
    __typename?: 'RateUsState';
    hasRated: boolean;
    permanentlySuppressed: boolean;
    triggers: {
      __typename?: 'RateUsTriggerMap';
      uploadMedia: {
        __typename?: 'RateUsTriggerState';
        count: number;
        promptStage: number;
        lastPromptAt?: any | null;
      };
      checkin: {
        __typename?: 'RateUsTriggerState';
        count: number;
        promptStage: number;
        lastPromptAt?: any | null;
      };
      checklist: {
        __typename?: 'RateUsTriggerState';
        count: number;
        promptStage: number;
        lastPromptAt?: any | null;
      };
      tasks: {
        __typename?: 'RateUsTriggerState';
        count: number;
        promptStage: number;
        lastPromptAt?: any | null;
      };
      chatTags: {
        __typename?: 'RateUsTriggerState';
        count: number;
        promptStage: number;
        lastPromptAt?: any | null;
      };
      assignTasks: {
        __typename?: 'RateUsTriggerState';
        count: number;
        promptStage: number;
        lastPromptAt?: any | null;
      };
    };
  };
};

export type UpdateTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: TaskAttributes;
}>;

export type UpdateTaskMutation = {
  __typename?: 'Mutation';
  updateTask: {
    __typename?: 'Task';
    id: string;
    name: string;
    status?: TaskStatus | null;
    priority?: TaskPriority | null;
    startDate?: any | null;
    dueDate?: any | null;
    completedAt?: any | null;
    createdAt: any;
    phaseId?: string | null;
    projectId: string;
    deletedAt?: any | null;
    skillIds?: Array<string> | null;
    userIds: Array<string>;
    dueGroup?: string | null;
    fixedOrder?: boolean | null;
    recurring?: boolean | null;
    description?: string | null;
    frequency?: TaskFrequency | null;
    currentUserRole?: TaskMemberRole | null;
    currentUserProjectRole?: ProjectMemberRole | null;
    currentUserProjectTeamRole?: TeamMemberRole | null;
    project: {
      __typename?: 'Project';
      id: string;
      uuid: string;
      name: string;
      color: string;
      icon?: string | null;
      currentUserTeamRole?: TeamMemberRole | null;
      currentUserRole?: ProjectMemberRole | null;
      initials: string;
      archivedAt?: any | null;
      team?: {
        __typename?: 'Team';
        avatar?: string | null;
        createdAt: any;
        id: string;
        name: string;
        personal: boolean;
        subscriptionDetails?: {
          __typename?: 'SubscriptionDetails';
          expirationDate?: any | null;
          subscriptionStatus?: string | null;
          isSubscriptionCanceled: boolean;
          isSubscriptionActive: boolean;
          isSubscriptionOnTrial: boolean;
          paymentCardLast4?: string | null;
        } | null;
      } | null;
    };
    dependencies?: Array<{
      __typename?: 'Task';
      id: string;
      name: string;
    }> | null;
    checklists?: Array<{
      __typename?: 'TaskChecklist';
      id: string;
      name: string;
      completedAt?: any | null;
      createdAt: any;
    }> | null;
    members: Array<{
      __typename?: 'TaskMember';
      id: string;
      role: TaskMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    invitations?: Array<{
      __typename?: 'TaskInvitation';
      id: string;
      email: string;
      role: TaskMemberRole;
      expiredAt?: any | null;
    }> | null;
    userRequests?: Array<{
      __typename?: 'UserRequest';
      id: string;
      role?: string | null;
      expiredAt?: any | null;
      user?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      } | null;
    }> | null;
    creator: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    completor?: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    } | null;
    phase?: { __typename?: 'Phase'; id: string; name: string } | null;
  };
};

export type UpdateTaskChecklistMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: TaskChecklistAttributes;
}>;

export type UpdateTaskChecklistMutation = {
  __typename?: 'Mutation';
  updateTaskChecklist: {
    __typename?: 'TaskChecklist';
    taskId: string;
    id: string;
    name: string;
    completedAt?: any | null;
    createdAt: any;
    sort?: number | null;
  };
};

export type UpdateTaskChecklistSortMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  attributes: Array<TaskChecklistAttributes> | TaskChecklistAttributes;
}>;

export type UpdateTaskChecklistSortMutation = {
  __typename?: 'Mutation';
  updateTaskChecklistSort: Array<{
    __typename?: 'TaskChecklist';
    taskId: string;
    id: string;
    name: string;
    completedAt?: any | null;
    createdAt: any;
    sort?: number | null;
  }>;
};

export type UpdateTaskMembersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: Array<TaskMemberAttributes> | TaskMemberAttributes;
}>;

export type UpdateTaskMembersMutation = {
  __typename?: 'Mutation';
  updateTaskMembers: {
    __typename?: 'Task';
    id: string;
    members: Array<{
      __typename?: 'TaskMember';
      id: string;
      role: TaskMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
  };
};

export type UpdateTeamMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: TeamAttributes;
}>;

export type UpdateTeamMutation = {
  __typename?: 'Mutation';
  updateTeam: {
    __typename?: 'Team';
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    id: string;
    uuid: string;
    avatar?: string | null;
    createdAt: any;
    name: string;
    usersCount: number;
    fileStorageUsed: any;
    mediaStorageUsed: any;
    pending: boolean;
    maxDocumentStorage: any;
    storageRemaining: any;
    currentUserRole?: TeamRole | null;
    hasReachedMaxProjects: boolean;
    numberOfProjectsUsed: number;
    maxNumberOfProjects: number;
    personal: boolean;
    billingSource?: string | null;
    teamSubscriptionStatus?: string | null;
    entitlementExpiration?: any | null;
    tasksCount: number;
    completedTasksCount: number;
    avatarFile?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    subscriptionDetails?: {
      __typename?: 'SubscriptionDetails';
      expirationDate?: any | null;
      subscriptionInterval?: string | null;
      subscriptionPlanName?: string | null;
      subscriptionStatus?: string | null;
      trialEndsAt?: any | null;
      canceledAt?: any | null;
      stripeProductId?: string | null;
      isSubscriptionCanceled: boolean;
      isSubscriptionActive: boolean;
      isSubscriptionOnTrial: boolean;
      updatedAt?: any | null;
      paymentCardLast4?: string | null;
      paymentCardBrand?: string | null;
      paymentCardExpMonth?: string | null;
      paymentCardExpYear?: string | null;
      currentSeatCount?: number | null;
      pricePerSeat?: string | null;
    } | null;
    owner: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    skills: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }>;
    product?: {
      __typename?: 'Product';
      id: string;
      name: string;
      prices: Array<{
        __typename?: 'Price';
        id: string;
        interval: string;
        intervalCount: number;
        externalId: string;
      }>;
    } | null;
    users: Array<{
      __typename?: 'User';
      teamRoles?: Array<TeamRole> | null;
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    }>;
    invitations?: Array<{
      __typename?: 'TeamInvitation';
      email?: string | null;
      expiredAt?: any | null;
      id: string;
      role?: TeamRole | null;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
    }> | null;
    invoices?: Array<{
      __typename?: 'Invoice';
      id: string;
      invoiceUrl: string;
      amount: number;
      date: any;
      description: string;
      status: string;
    }> | null;
  };
};

export type UpdateTeamMembersMutationVariables = Exact<{
  teamId: Scalars['ID']['input'];
  attributes: Array<MemberAttributes> | MemberAttributes;
}>;

export type UpdateTeamMembersMutation = {
  __typename?: 'Mutation';
  updateTeamMembers: {
    __typename?: 'Team';
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    id: string;
    uuid: string;
    avatar?: string | null;
    createdAt: any;
    name: string;
    usersCount: number;
    fileStorageUsed: any;
    mediaStorageUsed: any;
    pending: boolean;
    maxDocumentStorage: any;
    storageRemaining: any;
    currentUserRole?: TeamRole | null;
    hasReachedMaxProjects: boolean;
    numberOfProjectsUsed: number;
    maxNumberOfProjects: number;
    personal: boolean;
    billingSource?: string | null;
    teamSubscriptionStatus?: string | null;
    entitlementExpiration?: any | null;
    tasksCount: number;
    completedTasksCount: number;
    avatarFile?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    subscriptionDetails?: {
      __typename?: 'SubscriptionDetails';
      expirationDate?: any | null;
      subscriptionInterval?: string | null;
      subscriptionPlanName?: string | null;
      subscriptionStatus?: string | null;
      trialEndsAt?: any | null;
      canceledAt?: any | null;
      stripeProductId?: string | null;
      isSubscriptionCanceled: boolean;
      isSubscriptionActive: boolean;
      isSubscriptionOnTrial: boolean;
      updatedAt?: any | null;
      paymentCardLast4?: string | null;
      paymentCardBrand?: string | null;
      paymentCardExpMonth?: string | null;
      paymentCardExpYear?: string | null;
      currentSeatCount?: number | null;
      pricePerSeat?: string | null;
    } | null;
    owner: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    skills: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }>;
    product?: {
      __typename?: 'Product';
      id: string;
      name: string;
      prices: Array<{
        __typename?: 'Price';
        id: string;
        interval: string;
        intervalCount: number;
        externalId: string;
      }>;
    } | null;
    users: Array<{
      __typename?: 'User';
      teamRoles?: Array<TeamRole> | null;
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    }>;
    invitations?: Array<{
      __typename?: 'TeamInvitation';
      email?: string | null;
      expiredAt?: any | null;
      id: string;
      role?: TeamRole | null;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
    }> | null;
    invoices?: Array<{
      __typename?: 'Invoice';
      id: string;
      invoiceUrl: string;
      amount: number;
      date: any;
      description: string;
      status: string;
    }> | null;
  };
};

export type UpdateTutoralizationSettingMutationVariables = Exact<{
  attributes:
    | Array<TutoralizationSettingAttributes>
    | TutoralizationSettingAttributes;
}>;

export type UpdateTutoralizationSettingMutation = {
  __typename?: 'Mutation';
  updateTutoralizationSetting: Array<{
    __typename?: 'UserTutoralizationSetting';
    close: boolean;
    settingType: TutoralizationSetting;
  }>;
};

export type UpdateUserRequestStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
}>;

export type UpdateUserRequestStatusMutation = {
  __typename?: 'Mutation';
  updateUserRequestStatus: {
    __typename?: 'UserRequest';
    id: string;
    status: string;
  };
};

export type UploadContactsMutationVariables = Exact<{
  attributes: UploadContactAttributes;
}>;

export type UploadContactsMutation = {
  __typename?: 'Mutation';
  uploadContacts?: { __typename?: 'User'; phoneNumber: string } | null;
};

export type GetProjectChatActivityReportQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetProjectChatActivityReportQuery = {
  __typename?: 'Query';
  getProjectChatActivityReport?: Array<{
    __typename?: 'Audit';
    createdAt: any;
    event: string;
    id: string;
    user?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        url: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    } | null;
    attachment?:
      | { __typename?: 'Document' }
      | { __typename?: 'EntityUser' }
      | { __typename?: 'Folder' }
      | { __typename?: 'LocalFile' }
      | {
          __typename?: 'Message';
          id: string;
          chatId: string;
          body?: string | null;
          clientId: string;
          createdAt: any;
          publishedAt?: any | null;
          authorId: string;
          author: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            createdAt: any;
          };
        }
      | { __typename?: 'MessageProject' }
      | { __typename?: 'MessageTask' }
      | { __typename?: 'MessageTaskAssignment' }
      | { __typename?: 'MessageTaskComplete' }
      | { __typename?: 'Project' }
      | { __typename?: 'ProjectUser' }
      | { __typename?: 'PublicTeam' }
      | { __typename?: 'Task' }
      | { __typename?: 'TaskUser' }
      | { __typename?: 'UserRequest' }
      | null;
  }> | null;
};

export type GetProjectReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetProjectReportQuery = {
  __typename?: 'Query';
  getProjectReport?: string | null;
};

export type GetProjectTaskActivityReportQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetProjectTaskActivityReportQuery = {
  __typename?: 'Query';
  getProjectTaskActivityReport?: Array<{
    __typename?: 'Audit';
    createdAt: any;
    event: string;
    id: string;
    user?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        url: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    } | null;
    attachment?:
      | {
          __typename?: 'Document';
          id: string;
          blobId?: string | null;
          name: string;
          contentType?: string | null;
          createdAt: any;
          size?: number | null;
          isImage: boolean;
          isVideo: boolean;
          clientId: string;
          isAudio: boolean;
          duration?: number | null;
          file: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          };
          owner: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            createdAt: any;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          };
        }
      | {
          __typename?: 'EntityUser';
          id: string;
          user?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              url: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
          entityTask?: {
            __typename?: 'Task';
            id: string;
            name: string;
            deletedAt?: any | null;
            members: Array<{
              __typename?: 'TaskMember';
              id: string;
              role: TaskMemberRole;
              user: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  url: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              };
            }>;
            project: {
              __typename?: 'Project';
              id: string;
              uuid: string;
              name: string;
            };
          } | null;
          entityProject?: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
          } | null;
        }
      | { __typename?: 'Folder' }
      | { __typename?: 'LocalFile' }
      | {
          __typename?: 'Message';
          id: string;
          chatId: string;
          clientId: string;
          body?: string | null;
          createdAt: any;
          publishedAt?: any | null;
          authorId: string;
          author: { __typename?: 'User'; id: string; name?: string | null };
        }
      | { __typename?: 'MessageProject' }
      | { __typename?: 'MessageTask' }
      | { __typename?: 'MessageTaskAssignment' }
      | { __typename?: 'MessageTaskComplete' }
      | { __typename?: 'Project' }
      | { __typename?: 'ProjectUser' }
      | { __typename?: 'PublicTeam' }
      | { __typename?: 'Task' }
      | { __typename?: 'TaskUser' }
      | { __typename?: 'UserRequest' }
      | null;
  }> | null;
};

export type ListProjectMediaQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type ListProjectMediaQuery = {
  __typename?: 'Query';
  listProjectMedia?: Array<{
    __typename?: 'Document';
    id: string;
    blobId?: string | null;
    name: string;
    contentType?: string | null;
    createdAt: any;
    size?: number | null;
    isImage: boolean;
    isVideo: boolean;
    clientId: string;
    isAudio: boolean;
    duration?: number | null;
    file: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    };
    owner: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      createdAt: any;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    };
  }> | null;
};

export type ListProjectReportTasksQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type ListProjectReportTasksQuery = {
  __typename?: 'Query';
  listProjectReportTasks?: Array<{
    __typename?: 'ProjectTasksReport';
    id: string;
    dueDate?: any | null;
    name: string;
    description?: string | null;
    priority?: TaskPriority | null;
    status?: string | null;
    startDate?: any | null;
    completedAt?: any | null;
    members: Array<{
      __typename?: 'TaskMember';
      id: string;
      role: TaskMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          url: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      };
    }>;
    creator?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        url: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    } | null;
  }> | null;
};

export type ProjectReportCoverPageQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type ProjectReportCoverPageQuery = {
  __typename?: 'Query';
  projectReportCoverPage?: {
    __typename?: 'ReportCoverPage';
    generatedBy: string;
    projectName?: string | null;
    createdAt: any;
    title?: string | null;
    team?: {
      __typename?: 'Team';
      name: string;
      avatarFile?: {
        __typename?: 'File';
        id: string;
        url: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    } | null;
  } | null;
};

export type ProjectReportOverviewQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type ProjectReportOverviewQuery = {
  __typename?: 'Query';
  projectReportOverview?: {
    __typename?: 'ProjectReportOverview';
    address?: string | null;
    createdAt: any;
    id: string;
    description?: string | null;
    name: string;
    creator: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        url: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    };
    members: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          url: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      };
    }>;
  } | null;
};

export type ChatAvatarsByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type ChatAvatarsByIdsQuery = {
  __typename?: 'Query';
  chatAvatarsByIds?: Array<{
    __typename?: 'File';
    id: string;
    thumbnail?: string | null;
    url: string;
  }> | null;
};

export type ChatAvatarsThumbnailByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type ChatAvatarsThumbnailByIdsQuery = {
  __typename?: 'Query';
  chatAvatarsByIds?: Array<{
    __typename?: 'File';
    id: string;
    thumbnail?: string | null;
  }> | null;
};

export type CheckGeofenceQueryVariables = Exact<{
  userLatitude: Scalars['Float']['input'];
  userLongitude: Scalars['Float']['input'];
  projectLatitude: Scalars['Float']['input'];
  projectLongitude: Scalars['Float']['input'];
}>;

export type CheckGeofenceQuery = {
  __typename?: 'Query';
  checkGeofence: boolean;
};

export type DocumentsByClientIdsQueryVariables = Exact<{
  clientIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
}>;

export type DocumentsByClientIdsQuery = {
  __typename?: 'Query';
  documentsByClientIds?: Array<{
    __typename?: 'Document';
    clientId: string;
    file: { __typename?: 'File'; id: string; url: string };
  }> | null;
};

export type DocumentsByClientIdsForEditImageQueryVariables = Exact<{
  clientIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
}>;

export type DocumentsByClientIdsForEditImageQuery = {
  __typename?: 'Query';
  documentsByClientIds?: Array<{
    __typename?: 'Document';
    id: string;
    name: string;
    contentType?: string | null;
    createdAt: any;
    size?: number | null;
    isImage: boolean;
    isVideo: boolean;
    clientId: string;
    owner: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    };
    file: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    };
    messageDocuments?: Array<{
      __typename?: 'MessageDocument';
      id: string;
      message?: {
        __typename?: 'Message';
        id: string;
        clientId: string;
        chatId: string;
      } | null;
    }> | null;
    projectDocuments?: Array<{
      __typename?: 'ProjectDocument';
      id: string;
      project?: {
        __typename?: 'Project';
        id: string;
        uuid: string;
        name: string;
      } | null;
    }> | null;
    taskDocuments?: Array<{
      __typename?: 'TaskDocument';
      id: string;
      task?: {
        __typename?: 'Task';
        id: string;
        name: string;
        projectId: string;
        project: {
          __typename?: 'Project';
          id: string;
          uuid: string;
          name: string;
        };
      } | null;
    }> | null;
  }> | null;
};

export type DocumentsByClientIdsForImageViewerQueryVariables = Exact<{
  clientIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
}>;

export type DocumentsByClientIdsForImageViewerQuery = {
  __typename?: 'Query';
  documentsByClientIds?: Array<{
    __typename?: 'Document';
    clientId: string;
    updatedAt: any;
    width?: number | null;
    height?: number | null;
  }> | null;
};

export type GetChatQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetChatQuery = {
  __typename?: 'Query';
  getChat: {
    __typename?: 'Chat';
    id: string;
    name: string;
    description?: string | null;
    avatarUrl?: string | null;
    isGroupChat: boolean;
    messageIcon?: string | null;
    messageBody?: string | null;
    recentActivityAt?: any | null;
    unreadCount?: number | null;
    isNewChat?: boolean | null;
    isUserBlocked?: boolean | null;
    canCurrentUserDecide: boolean;
    isPendingRequest: boolean;
    friendRequestAccepted?: boolean | null;
    createdAt: any;
    leaveOn?: any | null;
    userIds: Array<string>;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    owner: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
    };
    settings?: {
      __typename?: 'UserChatSetting';
      id: string;
      pin: boolean;
      mute: boolean;
      archivedAt?: any | null;
    } | null;
    users: Array<{
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email: string;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    }>;
    pendingInvitations: Array<{
      __typename?: 'ChatInvitation';
      email: string;
      expiredAt: any;
      id: string;
    }>;
    userRequests: Array<{
      __typename?: 'UserRequest';
      id: string;
      status: string;
      expiredAt?: any | null;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email: string;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
    }>;
  };
};

export type GetChatForNotificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetChatForNotificationQuery = {
  __typename?: 'Query';
  getChat: { __typename?: 'Chat'; id: string; name: string };
};

export type GetDraftMessageQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;

export type GetDraftMessageQuery = {
  __typename?: 'Query';
  getDraftMessage?: {
    __typename?: 'DraftMessage';
    chatId: string;
    body?: string | null;
    tagsCollection: Array<{
      __typename?: 'TaskTagCollection';
      tasks: Array<{
        __typename?: 'TaskTag';
        id: string;
        name: string;
        userIds: Array<string>;
        status?: TaskStatus | null;
        projectId: string;
        project?: {
          __typename?: 'ProjectTag';
          id: string;
          name: string;
          uuid: string;
        } | null;
      } | null>;
      project: {
        __typename?: 'ProjectTag';
        id: string;
        name: string;
        uuid: string;
      };
      author: { __typename?: 'User'; id: string; name?: string | null };
    } | null>;
    localFiles: Array<{
      __typename?: 'LocalFile';
      id: string;
      name: string;
      clientId: string;
      url: string;
      cdnBaseUrl: string;
      path: string;
      contentType: string;
      isImage: boolean;
      isVideo: boolean;
      size?: number | null;
      isAudio: boolean;
      duration?: number | null;
      isPreviewable: boolean;
      thumbnail: string;
      blobId?: string | null;
    } | null>;
    replyMessage?: {
      __typename?: 'Message';
      id: string;
      chatId: string;
      clientId: string;
      body?: string | null;
      createdAt: any;
      isSender: boolean;
      isDraft: boolean;
      publishedAt?: any | null;
      authorId: string;
      authorAvatarId?: string | null;
      authorName?: string | null;
      authorFirstName?: string | null;
      authorLastName?: string | null;
      authorEmail?: string | null;
      readAt?: any | null;
      isRetry: boolean;
      replyId?: string | null;
      readReceipts?: Array<{
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      }> | null;
      checkin?: {
        __typename?: 'MessageCheckin';
        id: string;
        address?: string | null;
        city?: string | null;
        zipcode?: string | null;
        state?: string | null;
        country?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        withinGeofence: boolean;
      } | null;
      userRequest?: {
        __typename?: 'UserRequest';
        id: string;
        requestType: UserRequestCategory;
        status: string;
        canBeReviewed: boolean;
        expiredAt?: any | null;
        userRequestableId: string;
        userRequestableType: UserRequestable;
        invitedBy?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName?: string | null;
        } | null;
        reviewedBy?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName?: string | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          email: string;
          name?: string | null;
        } | null;
      } | null;
      replyMessage?: {
        __typename?: 'Message';
        id: string;
        chatId: string;
        clientId: string;
        body?: string | null;
        deletedAt?: any | null;
        createdAt: any;
        isSender: boolean;
        isDraft: boolean;
        publishedAt?: any | null;
        authorId: string;
        authorAvatarId?: string | null;
        authorName?: string | null;
        authorFirstName?: string | null;
        authorLastName?: string | null;
        authorEmail?: string | null;
        attachments?: Array<
          | {
              __typename?: 'Document';
              id: string;
              name: string;
              contentType?: string | null;
              createdAt: any;
              size?: number | null;
              isImage: boolean;
              clientId: string;
              isAudio: boolean;
              duration?: number | null;
              file: {
                __typename?: 'File';
                id: string;
                url: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              };
              owner: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                createdAt: any;
              };
            }
          | { __typename?: 'EntityUser' }
          | { __typename?: 'Folder' }
          | { __typename?: 'LocalFile' }
          | { __typename?: 'Message' }
          | {
              __typename?: 'MessageProject';
              id: string;
              authorId: string;
              author?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              } | null;
              project?: {
                __typename?: 'Project';
                id: string;
                uuid: string;
                name: string;
                team?: {
                  __typename?: 'Team';
                  subscriptionDetails?: {
                    __typename?: 'SubscriptionDetails';
                    expirationDate?: any | null;
                    subscriptionStatus?: string | null;
                  } | null;
                } | null;
              } | null;
            }
          | {
              __typename?: 'MessageTask';
              id: string;
              authorId: string;
              author?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              } | null;
              task?: {
                __typename?: 'Task';
                id: string;
                projectId: string;
                name: string;
              } | null;
            }
          | {
              __typename?: 'MessageTaskAssignment';
              id: string;
              messageId: string;
              assignees: Array<{
                __typename?: 'User';
                id: string;
                email: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                phoneNumber: string;
                primaryTeamId?: string | null;
                createdAt: any;
                inviteUrl: string;
                avatarId?: string | null;
                avatarIsPreviewable?: boolean | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
                skills?: Array<{
                  __typename?: 'Skill';
                  id: string;
                  name: string;
                  createdAt: any;
                }> | null;
              }>;
              task?: {
                __typename?: 'Task';
                id: string;
                name: string;
                deletedAt?: any | null;
                completedAt?: any | null;
              } | null;
            }
          | {
              __typename?: 'MessageTaskComplete';
              id: string;
              messageId: string;
              completor?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              } | null;
            }
          | { __typename?: 'Project' }
          | { __typename?: 'ProjectUser' }
          | { __typename?: 'PublicTeam' }
          | { __typename?: 'Task' }
          | { __typename?: 'TaskUser' }
          | { __typename?: 'UserRequest' }
        > | null;
      } | null;
      attachments?: Array<
        | {
            __typename?: 'Document';
            id: string;
            blobId?: string | null;
            name: string;
            contentType?: string | null;
            createdAt: any;
            size?: number | null;
            isImage: boolean;
            clientId: string;
            isAudio: boolean;
            duration?: number | null;
            file: {
              __typename?: 'File';
              id: string;
              url: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            };
            owner: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              createdAt: any;
            };
            taskDocuments?: Array<{
              __typename?: 'TaskDocument';
              id: string;
              owner?: { __typename?: 'User'; id: string } | null;
              task?: {
                __typename?: 'Task';
                id: string;
                name: string;
                projectId: string;
                project: { __typename?: 'Project'; id: string; name: string };
              } | null;
            }> | null;
            projectDocuments?: Array<{
              __typename?: 'ProjectDocument';
              id: string;
              owner?: { __typename?: 'User'; id: string } | null;
              project?: {
                __typename?: 'Project';
                id: string;
                name: string;
              } | null;
            }> | null;
          }
        | { __typename?: 'EntityUser' }
        | { __typename?: 'Folder' }
        | { __typename?: 'LocalFile' }
        | { __typename?: 'Message' }
        | {
            __typename?: 'MessageProject';
            id: string;
            authorId: string;
            author?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
            project?: {
              __typename?: 'Project';
              id: string;
              uuid: string;
              name: string;
              team?: {
                __typename?: 'Team';
                subscriptionDetails?: {
                  __typename?: 'SubscriptionDetails';
                  expirationDate?: any | null;
                  subscriptionStatus?: string | null;
                } | null;
              } | null;
            } | null;
          }
        | {
            __typename?: 'MessageTask';
            id: string;
            authorId: string;
            author?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
            task?: {
              __typename?: 'Task';
              id: string;
              projectId: string;
              deletedAt?: any | null;
              name: string;
            } | null;
          }
        | {
            __typename?: 'MessageTaskAssignment';
            id: string;
            messageId: string;
            assignees: Array<{
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            }>;
            task?: {
              __typename?: 'Task';
              id: string;
              name: string;
              deletedAt?: any | null;
              completedAt?: any | null;
              currentUserRole?: TaskMemberRole | null;
            } | null;
          }
        | {
            __typename?: 'MessageTaskComplete';
            id: string;
            messageId: string;
            completor?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
          }
        | { __typename?: 'Project' }
        | { __typename?: 'ProjectUser' }
        | { __typename?: 'PublicTeam' }
        | { __typename?: 'Task' }
        | { __typename?: 'TaskUser' }
        | { __typename?: 'UserRequest' }
      > | null;
      reaction?: Array<{
        __typename?: 'MessageReaction';
        id: string;
        reaction: string;
        count: number;
        user?: Array<{
          __typename?: 'User';
          id: string;
          name?: string | null;
        }> | null;
      }> | null;
    } | null;
    checkin?: {
      __typename?: 'MessageCheckin';
      id: string;
      address?: string | null;
      city?: string | null;
      zipcode?: string | null;
      state?: string | null;
      country?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      withinGeofence: boolean;
    } | null;
  } | null;
};

export type GetGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetGroupQuery = {
  __typename?: 'Query';
  getGroup?: {
    __typename?: 'Group';
    id: string;
    name: string;
    currentUserTeamRole?: TeamRole | null;
    team?: {
      __typename?: 'Team';
      id: string;
      avatar?: string | null;
      name: string;
      personal: boolean;
      avatarFile?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    } | null;
    users?: Array<{
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    }> | null;
  } | null;
};

export type GetMeQueryVariables = Exact<{ [key: string]: never }>;

export type GetMeQuery = {
  __typename?: 'Query';
  getMe: {
    __typename?: 'User';
    calendarUrl?: string | null;
    contactsCount: number;
    contactsSyncedAt?: any | null;
    address?: string | null;
    latitude?: number | null;
    personalProjectsCount: number;
    longitude?: number | null;
    onboardingComplete: boolean;
    onboardingFlow: OnboardingFlow;
    lastActiveDatetime?: any | null;
    ownedProjectsCount?: number | null;
    ownedTasksCount?: number | null;
    completedWebTutorialFlows?: Array<string> | null;
    hasSeenTagTooltipWeb: boolean;
    hasSeenTagTooltipNative: boolean;
    timeZone?: string | null;
    id: string;
    email: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber: string;
    primaryTeamId?: string | null;
    createdAt: any;
    inviteUrl: string;
    avatarId?: string | null;
    avatarIsPreviewable?: boolean | null;
    notificationSetting?: Array<{
      __typename?: 'UserNotificationSetting';
      duration?: NotificationSettingDuration | null;
      mute: boolean;
      settingType: NotificationSetting;
    }> | null;
    teams?: Array<{ __typename?: 'Team'; id: string }> | null;
    onboardingState: {
      __typename?: 'OnboardingState';
      welcomeModalSeen: boolean;
      projectCreationComplete: boolean;
      taskCreationComplete: boolean;
      checklistCreationComplete: boolean;
      inviteMemberComplete: boolean;
      firstChatSent: boolean;
      firstTagUsed: boolean;
      photoRequestNudgeShown: boolean;
      tagPillCoachmarkShown: boolean;
    };
    tutoralizationSetting?: Array<{
      __typename?: 'UserTutoralizationSetting';
      settingType: TutoralizationSetting;
      close: boolean;
    }> | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    skills?: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }> | null;
  };
};

export type GetPaywallStatusQueryVariables = Exact<{ [key: string]: never }>;

export type GetPaywallStatusQuery = {
  __typename?: 'Query';
  getPaywallStatus: {
    __typename?: 'PaywallStatus';
    isPaywalled: boolean;
    upgradeTeam?: {
      __typename?: 'Team';
      id: string;
      uuid: string;
      name: string;
      usersCount: number;
    } | null;
  };
};

export type GetProductQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetProductQuery = {
  __typename?: 'Query';
  getProduct: {
    __typename?: 'Product';
    allowMembers: boolean;
    externalId: string;
    guestsOnly: boolean;
    id: string;
    maxDocumentStorage: any;
    maxNumberOfProjects: any;
    name: string;
  };
};

export type GetProfileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetProfileQuery = {
  __typename?: 'Query';
  getProfile: {
    __typename?: 'Profile';
    address?: string | null;
    id: string;
    email: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber: string;
    userActiveTasksCount: number;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    skills?: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }> | null;
    teams?: Array<{
      __typename?: 'Team';
      id: string;
      uuid: string;
      name: string;
      usersCount: number;
      users: Array<{ __typename?: 'User'; id: string; name?: string | null }>;
    }> | null;
  };
};

export type GetProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetProjectQuery = {
  __typename?: 'Query';
  getProject: {
    __typename?: 'Project';
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    archivedAt?: any | null;
    usersCount: number;
    tasksCount: number;
    currentUserRole?: ProjectMemberRole | null;
    currentUserTeamRole?: TeamMemberRole | null;
    currentUserHasPendingMemberAdditionRequest: boolean;
    isTaskMember: boolean;
    teamId: string;
    color: string;
    icon?: string | null;
    createdAt: any;
    description?: string | null;
    id: string;
    uuid: string;
    initials: string;
    name: string;
    unreadAuditsCount?: number | null;
    activeTasksCount: number;
    upcomingTasksCount: number;
    overdueTasksCount: number;
    completedTasksCount: number;
    completedChecklistCount: number;
    creator: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    coverImage?: {
      __typename?: 'File';
      id: string;
      url: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    team?: {
      __typename?: 'Team';
      avatar?: string | null;
      createdAt: any;
      id: string;
      uuid: string;
      name: string;
      personal: boolean;
      hasReachedMaxProjects: boolean;
      currentUserRole?: TeamRole | null;
      storageRemaining: any;
      owner: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
      subscriptionDetails?: {
        __typename?: 'SubscriptionDetails';
        expirationDate?: any | null;
        subscriptionInterval?: string | null;
        subscriptionPlanName?: string | null;
        subscriptionStatus?: string | null;
        isSubscriptionCanceled: boolean;
        isSubscriptionActive: boolean;
        isSubscriptionOnTrial: boolean;
        trialEndsAt?: any | null;
        updatedAt?: any | null;
      } | null;
    } | null;
    memberPreviews: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          url: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    members: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          url: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    audits?: Array<{ __typename?: 'Audit'; id: string; event: string }> | null;
    settings?: {
      __typename?: 'UserProjectSetting';
      id: string;
      pin: boolean;
    } | null;
    invitations?: Array<{
      __typename?: 'ProjectInvitation';
      id: string;
      email: string;
      role: ProjectMemberRole;
      expiredAt?: any | null;
      createdAt: any;
      invitedBy: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      };
    }> | null;
    userRequests?: Array<{
      __typename?: 'UserRequest';
      id: string;
      role?: string | null;
      status: string;
      expiredAt?: any | null;
      createdAt: any;
      requestType: UserRequestCategory;
      userRequestableId: string;
      userRequestableType: UserRequestable;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
      reviewedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    }> | null;
  };
};

export type GetProjectByInvitationTokenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetProjectByInvitationTokenQuery = {
  __typename?: 'Query';
  getProjectByInvitationToken:
    | { __typename?: 'Project' }
    | {
        __typename?: 'PublicProject';
        id: string;
        uuid: string;
        name: string;
        description?: string | null;
        address?: string | null;
        usersCount: number;
        members?: Array<{
          __typename?: 'PublicProjectMember';
          id: string;
          role: ProjectMemberRole;
          name?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        }> | null;
      };
};

export type GetProjectForNotificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetProjectForNotificationQuery = {
  __typename?: 'Query';
  getProject: { __typename?: 'Project'; id: string; name: string };
};

export type GetProjectMembersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetProjectMembersQuery = {
  __typename?: 'Query';
  getProject: {
    __typename?: 'Project';
    id: string;
    teamId: string;
    name: string;
    address?: string | null;
    description?: string | null;
    color: string;
    members: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
  };
};

export type GetProjectTasksQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetProjectTasksQuery = {
  __typename?: 'Query';
  getProject: {
    __typename?: 'Project';
    id: string;
    name: string;
    tasks?: Array<{ __typename?: 'Task'; id: string; name: string }> | null;
  };
};

export type GetProjectTeamSubscriptionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetProjectTeamSubscriptionQuery = {
  __typename?: 'Query';
  getProject: {
    __typename?: 'Project';
    id: string;
    team?: {
      __typename?: 'Team';
      id: string;
      personal: boolean;
      subscriptionDetails?: {
        __typename?: 'SubscriptionDetails';
        expirationDate?: any | null;
        subscriptionStatus?: string | null;
        isSubscriptionCanceled: boolean;
        isSubscriptionActive: boolean;
        isSubscriptionOnTrial: boolean;
        paymentCardLast4?: string | null;
      } | null;
    } | null;
  };
};

export type GetProjectUnreadAuditsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetProjectUnreadAuditsQuery = {
  __typename?: 'Query';
  getProject: {
    __typename?: 'Project';
    id: string;
    unreadAudits?: Array<{ __typename?: 'Audit'; id: string }> | null;
  };
};

export type GetPublicProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetPublicProjectQuery = {
  __typename?: 'Query';
  getPublicProject:
    | {
        __typename?: 'Project';
        id: string;
        uuid: string;
        name: string;
        description?: string | null;
        address?: string | null;
        usersCount: number;
      }
    | {
        __typename?: 'PublicProject';
        id: string;
        uuid: string;
        name: string;
        description?: string | null;
        address?: string | null;
        usersCount: number;
        hasPendingMemberAdditionRequest: boolean;
        invitationEmail?: string | null;
        invitationType?: string | null;
        inviteeRole?: string | null;
        inviterName?: string | null;
        icon?: string | null;
        color?: string | null;
        team?: {
          __typename?: 'PublicProjectTeam';
          name?: string | null;
          avatarFile?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        } | null;
        members?: Array<{
          __typename?: 'PublicProjectMember';
          id: string;
          role: ProjectMemberRole;
          name?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        }> | null;
      };
};

export type GetPublicTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetPublicTaskQuery = {
  __typename?: 'Query';
  getPublicTask:
    | {
        __typename?: 'PublicTask';
        id: string;
        hasPendingMemberAdditionRequest: boolean;
      }
    | { __typename?: 'Task'; id: string };
};

export type GetPublicTeamQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetPublicTeamQuery = {
  __typename?: 'Query';
  getPublicTeam:
    | {
        __typename?: 'PublicTeam';
        address?: string | null;
        createdAt: any;
        hasPendingMemberAdditionRequest: boolean;
        name: string;
        uuid: string;
        totalMembers: number;
        avatarFile?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills: Array<{ __typename?: 'Skill'; id: string; name: string }>;
      }
    | {
        __typename?: 'Team';
        address?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        id: string;
        uuid: string;
        avatar?: string | null;
        createdAt: any;
        name: string;
        usersCount: number;
        fileStorageUsed: any;
        mediaStorageUsed: any;
        pending: boolean;
        maxDocumentStorage: any;
        storageRemaining: any;
        currentUserRole?: TeamRole | null;
        hasPendingMemberAdditionRequest: boolean;
        hasReachedMaxProjects: boolean;
        numberOfProjectsUsed: number;
        maxNumberOfProjects: number;
        personal: boolean;
        tasksCount: number;
        completedTasksCount: number;
        avatarFile?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      };
};

export type GetRateUsStateQueryVariables = Exact<{ [key: string]: never }>;

export type GetRateUsStateQuery = {
  __typename?: 'Query';
  getRateUsState: {
    __typename?: 'RateUsState';
    hasRated: boolean;
    permanentlySuppressed: boolean;
    triggers: {
      __typename?: 'RateUsTriggerMap';
      uploadMedia: {
        __typename?: 'RateUsTriggerState';
        count: number;
        promptStage: number;
        lastPromptAt?: any | null;
      };
      checkin: {
        __typename?: 'RateUsTriggerState';
        count: number;
        promptStage: number;
        lastPromptAt?: any | null;
      };
      checklist: {
        __typename?: 'RateUsTriggerState';
        count: number;
        promptStage: number;
        lastPromptAt?: any | null;
      };
      tasks: {
        __typename?: 'RateUsTriggerState';
        count: number;
        promptStage: number;
        lastPromptAt?: any | null;
      };
      chatTags: {
        __typename?: 'RateUsTriggerState';
        count: number;
        promptStage: number;
        lastPromptAt?: any | null;
      };
      assignTasks: {
        __typename?: 'RateUsTriggerState';
        count: number;
        promptStage: number;
        lastPromptAt?: any | null;
      };
    };
  };
};

export type GetTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetTaskQuery = {
  __typename?: 'Query';
  getTask: {
    __typename?: 'Task';
    id: string;
    name: string;
    status?: TaskStatus | null;
    priority?: TaskPriority | null;
    startDate?: any | null;
    dueDate?: any | null;
    completedAt?: any | null;
    createdAt: any;
    phaseId?: string | null;
    projectId: string;
    deletedAt?: any | null;
    skillIds?: Array<string> | null;
    userIds: Array<string>;
    dueGroup?: string | null;
    fixedOrder?: boolean | null;
    recurring?: boolean | null;
    description?: string | null;
    frequency?: TaskFrequency | null;
    currentUserRole?: TaskMemberRole | null;
    currentUserProjectRole?: ProjectMemberRole | null;
    currentUserProjectTeamRole?: TeamMemberRole | null;
    auditsCount?: number | null;
    unreadAuditsCount?: number | null;
    dependencies?: Array<{
      __typename?: 'Task';
      id: string;
      name: string;
    }> | null;
    checklists?: Array<{
      __typename?: 'TaskChecklist';
      id: string;
      name: string;
      completedAt?: any | null;
      createdAt: any;
    }> | null;
    members: Array<{
      __typename?: 'TaskMember';
      id: string;
      role: TaskMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    userRequests?: Array<{
      __typename?: 'UserRequest';
      id: string;
      role?: string | null;
      expiredAt?: any | null;
      user?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      } | null;
    }> | null;
    invitations?: Array<{
      __typename?: 'TaskInvitation';
      id: string;
      email: string;
      role: TaskMemberRole;
      expiredAt?: any | null;
    }> | null;
    creator: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    completor?: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    } | null;
    project: {
      __typename?: 'Project';
      id: string;
      uuid: string;
      name: string;
      icon?: string | null;
      color: string;
      currentUserTeamRole?: TeamMemberRole | null;
      currentUserRole?: ProjectMemberRole | null;
      initials: string;
      archivedAt?: any | null;
      team?: {
        __typename?: 'Team';
        avatar?: string | null;
        createdAt: any;
        id: string;
        name: string;
        personal: boolean;
        storageRemaining: any;
        subscriptionDetails?: {
          __typename?: 'SubscriptionDetails';
          expirationDate?: any | null;
          subscriptionInterval?: string | null;
          subscriptionPlanName?: string | null;
          subscriptionStatus?: string | null;
          isSubscriptionCanceled: boolean;
          isSubscriptionActive: boolean;
          isSubscriptionOnTrial: boolean;
          paymentCardLast4?: string | null;
          trialEndsAt?: any | null;
          updatedAt?: any | null;
        } | null;
      } | null;
    };
    phase?: { __typename?: 'Phase'; id: string; name: string } | null;
  };
};

export type GetTaskCompletionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetTaskCompletionQuery = {
  __typename?: 'Query';
  getTask: {
    __typename?: 'Task';
    id: string;
    status?: TaskStatus | null;
    completedAt?: any | null;
  };
};

export type GetTaskForNotificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetTaskForNotificationQuery = {
  __typename?: 'Query';
  getTask: { __typename?: 'Task'; id: string; name: string };
};

export type GetTaskMembersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetTaskMembersQuery = {
  __typename?: 'Query';
  getTask: {
    __typename?: 'Task';
    id: string;
    name: string;
    members: Array<{
      __typename?: 'TaskMember';
      id: string;
      role: TaskMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
  };
};

export type GetTaskUnreadAuditsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetTaskUnreadAuditsQuery = {
  __typename?: 'Query';
  getTask: {
    __typename?: 'Task';
    id: string;
    name: string;
    unreadAudits?: Array<{ __typename?: 'Audit'; id: string }> | null;
  };
};

export type GetTeamQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
  withMembers?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetTeamQuery = {
  __typename?: 'Query';
  getTeam: {
    __typename?: 'Team';
    highPriorityCompletionRate?: number | null;
    onTimeDeliveryRate?: number | null;
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    id: string;
    uuid: string;
    avatar?: string | null;
    createdAt: any;
    name: string;
    usersCount: number;
    fileStorageUsed: any;
    mediaStorageUsed: any;
    pending: boolean;
    maxDocumentStorage: any;
    storageRemaining: any;
    currentUserRole?: TeamRole | null;
    hasReachedMaxProjects: boolean;
    numberOfProjectsUsed: number;
    maxNumberOfProjects: number;
    personal: boolean;
    billingSource?: string | null;
    teamSubscriptionStatus?: string | null;
    entitlementExpiration?: any | null;
    tasksCount: number;
    completedTasksCount: number;
    avatarFile?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    subscriptionDetails?: {
      __typename?: 'SubscriptionDetails';
      expirationDate?: any | null;
      subscriptionInterval?: string | null;
      subscriptionPlanName?: string | null;
      subscriptionStatus?: string | null;
      trialEndsAt?: any | null;
      canceledAt?: any | null;
      stripeProductId?: string | null;
      isSubscriptionCanceled: boolean;
      isSubscriptionActive: boolean;
      isSubscriptionOnTrial: boolean;
      updatedAt?: any | null;
      paymentCardLast4?: string | null;
      paymentCardBrand?: string | null;
      paymentCardExpMonth?: string | null;
      paymentCardExpYear?: string | null;
      currentSeatCount?: number | null;
      pricePerSeat?: string | null;
    } | null;
    owner: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    skills: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }>;
    product?: {
      __typename?: 'Product';
      id: string;
      name: string;
      prices: Array<{
        __typename?: 'Price';
        id: string;
        interval: string;
        intervalCount: number;
        externalId: string;
      }>;
    } | null;
    users: Array<{
      __typename?: 'User';
      teamRoles?: Array<TeamRole> | null;
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    }>;
    invitations?: Array<{
      __typename?: 'TeamInvitation';
      email?: string | null;
      expiredAt?: any | null;
      id: string;
      role?: TeamRole | null;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
    }> | null;
    invoices?: Array<{
      __typename?: 'Invoice';
      id: string;
      invoiceUrl: string;
      amount: number;
      date: any;
      description: string;
      status: string;
    }> | null;
  };
};

export type GetTeamBillingQueryVariables = Exact<{
  role?: InputMaybe<ProjectMemberRole>;
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetTeamBillingQuery = {
  __typename?: 'Query';
  listTeams: Array<{
    __typename?: 'Team';
    id: string;
    product?: {
      __typename?: 'Product';
      allowMembers: boolean;
      externalId: string;
      features: any;
      guestsOnly: boolean;
      id: string;
      maxDocumentStorage: any;
      maxNumberOfProjects: any;
      name: string;
      position: number;
      prices: Array<{
        __typename?: 'Price';
        amount: number;
        externalId: string;
        id: string;
        interval: string;
        intervalCount: number;
      }>;
    } | null;
    invoices?: Array<{
      __typename?: 'Invoice';
      amount: number;
      date: any;
      description: string;
      id: string;
      invoiceUrl: string;
      status: string;
    }> | null;
    subscriptionDetails?: {
      __typename?: 'SubscriptionDetails';
      paymentCardLast4?: string | null;
      paymentCardBrand?: string | null;
      paymentCardExpMonth?: string | null;
      paymentCardExpYear?: string | null;
      expirationDate?: any | null;
      subscriptionInterval?: string | null;
      subscriptionPlanName?: string | null;
      subscriptionStatus?: string | null;
      stripeProductId?: string | null;
      trialEndsAt?: any | null;
      isSubscriptionCanceled: boolean;
      isSubscriptionActive: boolean;
      isSubscriptionOnTrial: boolean;
      updatedAt?: any | null;
      currentSeatCount?: number | null;
      pricePerSeat?: string | null;
    } | null;
  }>;
};

export type GetTeamDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
  withMembers?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetTeamDetailQuery = {
  __typename?: 'Query';
  getPublicTeam:
    | {
        __typename?: 'PublicTeam';
        address?: string | null;
        createdAt: any;
        hasPendingMemberAdditionRequest: boolean;
        name: string;
        uuid: string;
        totalMembers: number;
        avatarFile?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills: Array<{ __typename?: 'Skill'; id: string; name: string }>;
      }
    | {
        __typename?: 'Team';
        hasPendingMemberAdditionRequest: boolean;
        highPriorityCompletionRate?: number | null;
        onTimeDeliveryRate?: number | null;
        address?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        id: string;
        uuid: string;
        avatar?: string | null;
        createdAt: any;
        name: string;
        usersCount: number;
        fileStorageUsed: any;
        mediaStorageUsed: any;
        pending: boolean;
        maxDocumentStorage: any;
        storageRemaining: any;
        currentUserRole?: TeamRole | null;
        hasReachedMaxProjects: boolean;
        numberOfProjectsUsed: number;
        maxNumberOfProjects: number;
        personal: boolean;
        billingSource?: string | null;
        teamSubscriptionStatus?: string | null;
        entitlementExpiration?: any | null;
        tasksCount: number;
        completedTasksCount: number;
        avatarFile?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        subscriptionDetails?: {
          __typename?: 'SubscriptionDetails';
          expirationDate?: any | null;
          subscriptionInterval?: string | null;
          subscriptionPlanName?: string | null;
          subscriptionStatus?: string | null;
          trialEndsAt?: any | null;
          canceledAt?: any | null;
          stripeProductId?: string | null;
          isSubscriptionCanceled: boolean;
          isSubscriptionActive: boolean;
          isSubscriptionOnTrial: boolean;
          updatedAt?: any | null;
          paymentCardLast4?: string | null;
          paymentCardBrand?: string | null;
          paymentCardExpMonth?: string | null;
          paymentCardExpYear?: string | null;
          currentSeatCount?: number | null;
          pricePerSeat?: string | null;
        } | null;
        owner: {
          __typename?: 'User';
          id: string;
          email: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          phoneNumber: string;
          primaryTeamId?: string | null;
          createdAt: any;
          inviteUrl: string;
          avatarId?: string | null;
          avatarIsPreviewable?: boolean | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
          skills?: Array<{
            __typename?: 'Skill';
            id: string;
            name: string;
            createdAt: any;
          }> | null;
        };
        skills: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }>;
        product?: {
          __typename?: 'Product';
          id: string;
          name: string;
          prices: Array<{
            __typename?: 'Price';
            id: string;
            interval: string;
            intervalCount: number;
            externalId: string;
          }>;
        } | null;
        users: Array<{
          __typename?: 'User';
          teamRoles?: Array<TeamRole> | null;
          id: string;
          email: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          phoneNumber: string;
          primaryTeamId?: string | null;
          createdAt: any;
          inviteUrl: string;
          avatarId?: string | null;
          avatarIsPreviewable?: boolean | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
          skills?: Array<{
            __typename?: 'Skill';
            id: string;
            name: string;
            createdAt: any;
          }> | null;
        }>;
        invitations?: Array<{
          __typename?: 'TeamInvitation';
          email?: string | null;
          expiredAt?: any | null;
          id: string;
          role?: TeamRole | null;
          invitedBy?: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          } | null;
          user?: {
            __typename?: 'User';
            id: string;
            firstName?: string | null;
            lastName?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
        }> | null;
        invoices?: Array<{
          __typename?: 'Invoice';
          id: string;
          invoiceUrl: string;
          amount: number;
          date: any;
          description: string;
          status: string;
        }> | null;
      };
};

export type GetTeamForNotificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetTeamForNotificationQuery = {
  __typename?: 'Query';
  getTeam: { __typename?: 'Team'; id: string; name: string };
};

export type GlobalActivitySearchQueryVariables = Exact<{
  term: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  projectIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;

export type GlobalActivitySearchQuery = {
  __typename?: 'Query';
  globalActivitySearch: Array<{
    __typename?: 'Search';
    total: number;
    highlight?: {
      __typename?: 'Highlight';
      authorName?: Array<string> | null;
      body?: Array<string> | null;
      chatName?: Array<string> | null;
      name?: Array<string> | null;
      projectNames?: Array<string> | null;
      taskNames?: Array<string> | null;
    } | null;
    record:
      | {
          __typename?: 'Audit';
          event: string;
          createdAt: any;
          id: string;
          changes?: any | null;
          projectRole?: ProjectMemberRole | null;
          user?: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          } | null;
          documents: Array<{
            __typename?: 'Document';
            id: string;
            blobId?: string | null;
            name: string;
            contentType?: string | null;
            createdAt: any;
            size?: number | null;
            isImage: boolean;
            isVideo: boolean;
            clientId: string;
            isAudio: boolean;
            duration?: number | null;
            file: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            };
            owner: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              createdAt: any;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            };
          }>;
          attachment?:
            | {
                __typename?: 'Document';
                id: string;
                blobId?: string | null;
                name: string;
                contentType?: string | null;
                createdAt: any;
                size?: number | null;
                isImage: boolean;
                isVideo: boolean;
                clientId: string;
                isAudio: boolean;
                duration?: number | null;
                projectDocuments?: Array<{
                  __typename?: 'ProjectDocument';
                  id: string;
                  project?: {
                    __typename?: 'Project';
                    id: string;
                    uuid: string;
                    name: string;
                  } | null;
                }> | null;
                taskDocuments?: Array<{
                  __typename?: 'TaskDocument';
                  id: string;
                  task?: {
                    __typename?: 'Task';
                    id: string;
                    name: string;
                    projectId: string;
                    deletedAt?: any | null;
                    project: {
                      __typename?: 'Project';
                      id: string;
                      uuid: string;
                      name: string;
                    };
                  } | null;
                }> | null;
                file: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                };
                owner: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  createdAt: any;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                };
              }
            | {
                __typename?: 'EntityUser';
                id: string;
                user?: {
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  phoneNumber: string;
                  primaryTeamId?: string | null;
                  createdAt: any;
                  inviteUrl: string;
                  avatarId?: string | null;
                  avatarIsPreviewable?: boolean | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                  skills?: Array<{
                    __typename?: 'Skill';
                    id: string;
                    name: string;
                    createdAt: any;
                  }> | null;
                } | null;
                entityTask?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  deletedAt?: any | null;
                  members: Array<{
                    __typename?: 'TaskMember';
                    id: string;
                    role: TaskMemberRole;
                    user: {
                      __typename?: 'User';
                      id: string;
                      email: string;
                      name?: string | null;
                      firstName?: string | null;
                      lastName?: string | null;
                      phoneNumber: string;
                      primaryTeamId?: string | null;
                      createdAt: any;
                      inviteUrl: string;
                      avatarId?: string | null;
                      avatarIsPreviewable?: boolean | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                      skills?: Array<{
                        __typename?: 'Skill';
                        id: string;
                        name: string;
                        createdAt: any;
                      }> | null;
                    };
                  }>;
                  project: {
                    __typename?: 'Project';
                    id: string;
                    uuid: string;
                    name: string;
                  };
                } | null;
                entityProject?: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                } | null;
              }
            | { __typename?: 'Folder' }
            | { __typename?: 'LocalFile' }
            | {
                __typename?: 'Message';
                id: string;
                chatId: string;
                clientId: string;
                body?: string | null;
                createdAt: any;
                isSender: boolean;
                isDraft: boolean;
                publishedAt?: any | null;
                authorId: string;
                authorAvatarId?: string | null;
                authorName?: string | null;
                authorFirstName?: string | null;
                authorLastName?: string | null;
                authorEmail?: string | null;
                readAt?: any | null;
                isRetry: boolean;
                replyId?: string | null;
                readReceipts?: Array<{
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  phoneNumber: string;
                  primaryTeamId?: string | null;
                  createdAt: any;
                  inviteUrl: string;
                  avatarId?: string | null;
                  avatarIsPreviewable?: boolean | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                  skills?: Array<{
                    __typename?: 'Skill';
                    id: string;
                    name: string;
                    createdAt: any;
                  }> | null;
                }> | null;
                checkin?: {
                  __typename?: 'MessageCheckin';
                  id: string;
                  address?: string | null;
                  city?: string | null;
                  zipcode?: string | null;
                  state?: string | null;
                  country?: string | null;
                  latitude?: number | null;
                  longitude?: number | null;
                  withinGeofence: boolean;
                } | null;
                userRequest?: {
                  __typename?: 'UserRequest';
                  id: string;
                  requestType: UserRequestCategory;
                  status: string;
                  canBeReviewed: boolean;
                  expiredAt?: any | null;
                  userRequestableId: string;
                  userRequestableType: UserRequestable;
                  invitedBy?: {
                    __typename?: 'User';
                    id: string;
                    name?: string | null;
                    firstName?: string | null;
                  } | null;
                  reviewedBy?: {
                    __typename?: 'User';
                    id: string;
                    name?: string | null;
                    firstName?: string | null;
                  } | null;
                  user?: {
                    __typename?: 'User';
                    id: string;
                    email: string;
                    name?: string | null;
                  } | null;
                } | null;
                replyMessage?: {
                  __typename?: 'Message';
                  id: string;
                  chatId: string;
                  clientId: string;
                  body?: string | null;
                  deletedAt?: any | null;
                  createdAt: any;
                  isSender: boolean;
                  isDraft: boolean;
                  publishedAt?: any | null;
                  authorId: string;
                  authorAvatarId?: string | null;
                  authorName?: string | null;
                  authorFirstName?: string | null;
                  authorLastName?: string | null;
                  authorEmail?: string | null;
                  attachments?: Array<
                    | {
                        __typename?: 'Document';
                        id: string;
                        name: string;
                        contentType?: string | null;
                        createdAt: any;
                        size?: number | null;
                        isImage: boolean;
                        clientId: string;
                        isAudio: boolean;
                        duration?: number | null;
                        file: {
                          __typename?: 'File';
                          id: string;
                          url: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        };
                        owner: {
                          __typename?: 'User';
                          id: string;
                          name?: string | null;
                          firstName?: string | null;
                          lastName?: string | null;
                          createdAt: any;
                        };
                      }
                    | { __typename?: 'EntityUser' }
                    | { __typename?: 'Folder' }
                    | { __typename?: 'LocalFile' }
                    | { __typename?: 'Message' }
                    | {
                        __typename?: 'MessageProject';
                        id: string;
                        authorId: string;
                        author?: {
                          __typename?: 'User';
                          id: string;
                          name?: string | null;
                          avatar?: {
                            __typename?: 'File';
                            id: string;
                            cdnBaseUrl: string;
                            path: string;
                            isPreviewable: boolean;
                            thumbnail?: string | null;
                          } | null;
                        } | null;
                        project?: {
                          __typename?: 'Project';
                          id: string;
                          uuid: string;
                          name: string;
                          team?: {
                            __typename?: 'Team';
                            subscriptionDetails?: {
                              __typename?: 'SubscriptionDetails';
                              expirationDate?: any | null;
                              subscriptionStatus?: string | null;
                            } | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: 'MessageTask';
                        id: string;
                        authorId: string;
                        author?: {
                          __typename?: 'User';
                          id: string;
                          name?: string | null;
                          avatar?: {
                            __typename?: 'File';
                            id: string;
                            cdnBaseUrl: string;
                            path: string;
                            isPreviewable: boolean;
                            thumbnail?: string | null;
                          } | null;
                        } | null;
                        task?: {
                          __typename?: 'Task';
                          id: string;
                          projectId: string;
                          name: string;
                        } | null;
                      }
                    | {
                        __typename?: 'MessageTaskAssignment';
                        id: string;
                        messageId: string;
                        assignees: Array<{
                          __typename?: 'User';
                          id: string;
                          email: string;
                          name?: string | null;
                          firstName?: string | null;
                          lastName?: string | null;
                          phoneNumber: string;
                          primaryTeamId?: string | null;
                          createdAt: any;
                          inviteUrl: string;
                          avatarId?: string | null;
                          avatarIsPreviewable?: boolean | null;
                          avatar?: {
                            __typename?: 'File';
                            id: string;
                            cdnBaseUrl: string;
                            path: string;
                            isPreviewable: boolean;
                            thumbnail?: string | null;
                          } | null;
                          skills?: Array<{
                            __typename?: 'Skill';
                            id: string;
                            name: string;
                            createdAt: any;
                          }> | null;
                        }>;
                        task?: {
                          __typename?: 'Task';
                          id: string;
                          name: string;
                          deletedAt?: any | null;
                          completedAt?: any | null;
                        } | null;
                      }
                    | {
                        __typename?: 'MessageTaskComplete';
                        id: string;
                        messageId: string;
                        completor?: {
                          __typename?: 'User';
                          id: string;
                          name?: string | null;
                          avatar?: {
                            __typename?: 'File';
                            id: string;
                            cdnBaseUrl: string;
                            path: string;
                            isPreviewable: boolean;
                            thumbnail?: string | null;
                          } | null;
                        } | null;
                      }
                    | { __typename?: 'Project' }
                    | { __typename?: 'ProjectUser' }
                    | { __typename?: 'PublicTeam' }
                    | { __typename?: 'Task' }
                    | { __typename?: 'TaskUser' }
                    | { __typename?: 'UserRequest' }
                  > | null;
                } | null;
                attachments?: Array<
                  | {
                      __typename?: 'Document';
                      id: string;
                      blobId?: string | null;
                      name: string;
                      contentType?: string | null;
                      createdAt: any;
                      size?: number | null;
                      isImage: boolean;
                      clientId: string;
                      isAudio: boolean;
                      duration?: number | null;
                      file: {
                        __typename?: 'File';
                        id: string;
                        url: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      };
                      owner: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        createdAt: any;
                      };
                      taskDocuments?: Array<{
                        __typename?: 'TaskDocument';
                        id: string;
                        owner?: { __typename?: 'User'; id: string } | null;
                        task?: {
                          __typename?: 'Task';
                          id: string;
                          name: string;
                          projectId: string;
                          project: {
                            __typename?: 'Project';
                            id: string;
                            name: string;
                          };
                        } | null;
                      }> | null;
                      projectDocuments?: Array<{
                        __typename?: 'ProjectDocument';
                        id: string;
                        owner?: { __typename?: 'User'; id: string } | null;
                        project?: {
                          __typename?: 'Project';
                          id: string;
                          name: string;
                        } | null;
                      }> | null;
                    }
                  | { __typename?: 'EntityUser' }
                  | { __typename?: 'Folder' }
                  | { __typename?: 'LocalFile' }
                  | { __typename?: 'Message' }
                  | {
                      __typename?: 'MessageProject';
                      id: string;
                      authorId: string;
                      author?: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                      } | null;
                      project?: {
                        __typename?: 'Project';
                        id: string;
                        uuid: string;
                        name: string;
                        team?: {
                          __typename?: 'Team';
                          subscriptionDetails?: {
                            __typename?: 'SubscriptionDetails';
                            expirationDate?: any | null;
                            subscriptionStatus?: string | null;
                          } | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: 'MessageTask';
                      id: string;
                      authorId: string;
                      author?: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                      } | null;
                      task?: {
                        __typename?: 'Task';
                        id: string;
                        projectId: string;
                        deletedAt?: any | null;
                        name: string;
                      } | null;
                    }
                  | {
                      __typename?: 'MessageTaskAssignment';
                      id: string;
                      messageId: string;
                      assignees: Array<{
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                      }>;
                      task?: {
                        __typename?: 'Task';
                        id: string;
                        name: string;
                        deletedAt?: any | null;
                        completedAt?: any | null;
                        currentUserRole?: TaskMemberRole | null;
                      } | null;
                    }
                  | {
                      __typename?: 'MessageTaskComplete';
                      id: string;
                      messageId: string;
                      completor?: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                      } | null;
                    }
                  | { __typename?: 'Project' }
                  | { __typename?: 'ProjectUser' }
                  | { __typename?: 'PublicTeam' }
                  | { __typename?: 'Task' }
                  | { __typename?: 'TaskUser' }
                  | { __typename?: 'UserRequest' }
                > | null;
                reaction?: Array<{
                  __typename?: 'MessageReaction';
                  id: string;
                  reaction: string;
                  count: number;
                  user?: Array<{
                    __typename?: 'User';
                    id: string;
                    name?: string | null;
                  }> | null;
                }> | null;
              }
            | { __typename?: 'MessageProject' }
            | { __typename?: 'MessageTask' }
            | { __typename?: 'MessageTaskAssignment' }
            | { __typename?: 'MessageTaskComplete' }
            | { __typename?: 'Project'; id: string; uuid: string; name: string }
            | { __typename?: 'ProjectUser' }
            | { __typename?: 'PublicTeam' }
            | {
                __typename?: 'Task';
                id: string;
                name: string;
                projectId: string;
                deletedAt?: any | null;
                project: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                };
              }
            | {
                __typename?: 'TaskUser';
                id: string;
                task: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  deletedAt?: any | null;
                  project: {
                    __typename?: 'Project';
                    id: string;
                    uuid: string;
                    name: string;
                  };
                };
                user?: {
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  phoneNumber: string;
                  primaryTeamId?: string | null;
                  createdAt: any;
                  inviteUrl: string;
                  avatarId?: string | null;
                  avatarIsPreviewable?: boolean | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                  skills?: Array<{
                    __typename?: 'Skill';
                    id: string;
                    name: string;
                    createdAt: any;
                  }> | null;
                } | null;
              }
            | { __typename?: 'UserRequest' }
            | null;
        }
      | { __typename?: 'Chat'; id: string; name: string }
      | {
          __typename?: 'Document';
          id: string;
          name: string;
          contentType?: string | null;
          createdAt: any;
          size?: number | null;
          isImage: boolean;
          clientId: string;
          owner: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          };
          file: {
            __typename?: 'File';
            id: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          };
          messageDocuments?: Array<{
            __typename?: 'MessageDocument';
            id: string;
            message?: {
              __typename?: 'Message';
              id: string;
              clientId: string;
              authorId: string;
              chat: { __typename?: 'Chat'; id: string; name: string };
            } | null;
          }> | null;
          projectDocuments?: Array<{
            __typename?: 'ProjectDocument';
            id: string;
            project?: {
              __typename?: 'Project';
              id: string;
              uuid: string;
              name: string;
              team?: {
                __typename?: 'Team';
                avatar?: string | null;
                createdAt: any;
                id: string;
                name: string;
                personal: boolean;
              } | null;
            } | null;
          }> | null;
        }
      | { __typename?: 'Group' }
      | {
          __typename?: 'Message';
          id: string;
          body?: string | null;
          publishedAt?: any | null;
          isSender: boolean;
          clientId: string;
          authorId: string;
          chatId: string;
          createdAt: any;
          isDraft: boolean;
          author: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            email: string;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          };
          chat: {
            __typename?: 'Chat';
            id: string;
            name: string;
            description?: string | null;
            avatarUrl?: string | null;
            isGroupChat: boolean;
            messageIcon?: string | null;
            messageBody?: string | null;
            recentActivityAt?: any | null;
            unreadCount?: number | null;
            createdAt: any;
            leaveOn?: any | null;
            isPendingRequest: boolean;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            settings?: {
              __typename?: 'UserChatSetting';
              id: string;
              pin: boolean;
              mute: boolean;
              archivedAt?: any | null;
            } | null;
            users: Array<{
              __typename?: 'User';
              id: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            }>;
            pendingInvitations: Array<{
              __typename?: 'ChatInvitation';
              email: string;
              expiredAt: any;
              id: string;
            }>;
            userRequests: Array<{
              __typename?: 'UserRequest';
              id: string;
              status: string;
              expiredAt?: any | null;
              user?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                email: string;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              } | null;
            }>;
            owner: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
            };
          };
          reaction?: Array<{
            __typename?: 'MessageReaction';
            id: string;
            reaction: string;
            count: number;
            user?: Array<{ __typename?: 'User'; id: string }> | null;
          }> | null;
          attachments?: Array<
            | {
                __typename?: 'Document';
                id: string;
                isImage: boolean;
                isAudio: boolean;
                clientId: string;
                duration?: number | null;
                name: string;
                createdAt: any;
                contentType?: string | null;
                blobId?: string | null;
                size?: number | null;
                isVideo: boolean;
                file: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                };
                owner: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  createdAt: any;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                };
              }
            | { __typename?: 'EntityUser' }
            | { __typename?: 'Folder' }
            | { __typename?: 'LocalFile' }
            | { __typename?: 'Message' }
            | {
                __typename?: 'MessageProject';
                id: string;
                author?: {
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  phoneNumber: string;
                  primaryTeamId?: string | null;
                  createdAt: any;
                  inviteUrl: string;
                  avatarId?: string | null;
                  avatarIsPreviewable?: boolean | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                  skills?: Array<{
                    __typename?: 'Skill';
                    id: string;
                    name: string;
                    createdAt: any;
                  }> | null;
                } | null;
                project?: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  initials: string;
                  name: string;
                  description?: string | null;
                  address?: string | null;
                  color: string;
                  createdAt: any;
                  creator: {
                    __typename?: 'User';
                    id: string;
                    email: string;
                    name?: string | null;
                    firstName?: string | null;
                    lastName?: string | null;
                    phoneNumber: string;
                    primaryTeamId?: string | null;
                    createdAt: any;
                    inviteUrl: string;
                    avatarId?: string | null;
                    avatarIsPreviewable?: boolean | null;
                    avatar?: {
                      __typename?: 'File';
                      id: string;
                      cdnBaseUrl: string;
                      path: string;
                      isPreviewable: boolean;
                      thumbnail?: string | null;
                    } | null;
                    skills?: Array<{
                      __typename?: 'Skill';
                      id: string;
                      name: string;
                      createdAt: any;
                    }> | null;
                  };
                } | null;
              }
            | {
                __typename?: 'MessageTask';
                id: string;
                author?: {
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  phoneNumber: string;
                  primaryTeamId?: string | null;
                  createdAt: any;
                  inviteUrl: string;
                  avatarId?: string | null;
                  avatarIsPreviewable?: boolean | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                  skills?: Array<{
                    __typename?: 'Skill';
                    id: string;
                    name: string;
                    createdAt: any;
                  }> | null;
                } | null;
                task?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  status?: TaskStatus | null;
                  priority?: TaskPriority | null;
                  dueDate?: any | null;
                  projectId: string;
                  userIds: Array<string>;
                  deletedAt?: any | null;
                  creator: {
                    __typename?: 'User';
                    id: string;
                    email: string;
                    name?: string | null;
                    firstName?: string | null;
                    lastName?: string | null;
                    phoneNumber: string;
                    primaryTeamId?: string | null;
                    createdAt: any;
                    inviteUrl: string;
                    avatarId?: string | null;
                    avatarIsPreviewable?: boolean | null;
                    avatar?: {
                      __typename?: 'File';
                      id: string;
                      cdnBaseUrl: string;
                      path: string;
                      isPreviewable: boolean;
                      thumbnail?: string | null;
                    } | null;
                    skills?: Array<{
                      __typename?: 'Skill';
                      id: string;
                      name: string;
                      createdAt: any;
                    }> | null;
                  };
                  project: {
                    __typename?: 'Project';
                    id: string;
                    uuid: string;
                    name: string;
                    color: string;
                  };
                } | null;
              }
            | { __typename?: 'MessageTaskAssignment' }
            | { __typename?: 'MessageTaskComplete' }
            | { __typename?: 'Project' }
            | { __typename?: 'ProjectUser' }
            | { __typename?: 'PublicTeam' }
            | { __typename?: 'Task' }
            | { __typename?: 'TaskUser' }
            | { __typename?: 'UserRequest' }
          > | null;
        }
      | {
          __typename?: 'Project';
          id: string;
          uuid: string;
          initials: string;
          name: string;
          description?: string | null;
          address?: string | null;
          color: string;
          createdAt: any;
          icon?: string | null;
          team?: {
            __typename?: 'Team';
            avatar?: string | null;
            createdAt: any;
            id: string;
            name: string;
            personal: boolean;
          } | null;
          creator: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          };
        }
      | {
          __typename?: 'Task';
          id: string;
          name: string;
          status?: TaskStatus | null;
          priority?: TaskPriority | null;
          dueDate?: any | null;
          projectId: string;
          userIds: Array<string>;
          completedAt?: any | null;
          deletedAt?: any | null;
          currentUserRole?: TaskMemberRole | null;
          creator: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          };
          members: Array<{
            __typename?: 'TaskMember';
            id: string;
            role: TaskMemberRole;
            user: {
              __typename?: 'User';
              id: string;
              email: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              phoneNumber: string;
              primaryTeamId?: string | null;
              createdAt: any;
              inviteUrl: string;
              avatarId?: string | null;
              avatarIsPreviewable?: boolean | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
              skills?: Array<{
                __typename?: 'Skill';
                id: string;
                name: string;
                createdAt: any;
              }> | null;
            };
          }>;
          project: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
            color: string;
            team?: {
              __typename?: 'Team';
              name: string;
              personal: boolean;
            } | null;
          };
        }
      | { __typename?: 'Team' }
      | {
          __typename?: 'User';
          id: string;
          firstName?: string | null;
          lastName?: string | null;
          email: string;
          fullName?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        };
  }>;
};

export type InvitationDetailsQueryVariables = Exact<{
  token: Scalars['String']['input'];
  type: Invitation;
  entityId?: InputMaybe<Scalars['String']['input']>;
}>;

export type InvitationDetailsQuery = {
  __typename?: 'Query';
  invitationDetails: {
    __typename?: 'InvitationValidity';
    autoJoin: boolean;
    invitationStatus?: string | null;
    isLinkInvite: boolean;
    invitationEmail?: string | null;
    invitationName?: string | null;
    invitationRole?: string | null;
    invitedByName?: string | null;
    invitedBy?: { __typename?: 'PublicUser'; id: string } | null;
    chat?: {
      __typename?: 'PublicChat';
      id: string;
      name: string;
      userCount: number;
      ownerName?: string | null;
    } | null;
    team?: {
      __typename?: 'PublicTeam';
      address?: string | null;
      createdAt: any;
      hasPendingMemberAdditionRequest: boolean;
      name: string;
      totalMembers: number;
      uuid: string;
      avatarFile?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    } | null;
    project?: {
      __typename?: 'PublicProject';
      id: string;
      uuid: string;
      name: string;
      address?: string | null;
      description?: string | null;
      usersCount: number;
      icon?: string | null;
      color?: string | null;
      team?: {
        __typename?: 'PublicProjectTeam';
        name?: string | null;
        avatarFile?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
    } | null;
    task?: {
      __typename?: 'PublicTask';
      description?: string | null;
      dueDate?: any | null;
      id: string;
      inviterName?: string | null;
      name: string;
      ownerName?: string | null;
      priority?: TaskPriority | null;
      projectIcon?: string | null;
      projectName?: string | null;
      projectUuid?: string | null;
      startDate?: any | null;
      usersCount: number;
    } | null;
  };
};

export type ListActivitiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  projectIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;

export type ListActivitiesQuery = {
  __typename?: 'Query';
  listActivities?: {
    __typename?: 'ActivityFeedConnection';
    isPaywalled: boolean;
    totalEventCount: number;
    upgradeTeam?: {
      __typename?: 'Team';
      id: string;
      uuid: string;
      name: string;
      usersCount: number;
    } | null;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'AuditEdge';
      cursor: string;
      node?: {
        __typename?: 'Audit';
        event: string;
        createdAt: any;
        id: string;
        changes?: any | null;
        projectRole?: ProjectMemberRole | null;
        user?: {
          __typename?: 'User';
          id: string;
          email: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          phoneNumber: string;
          primaryTeamId?: string | null;
          createdAt: any;
          inviteUrl: string;
          avatarId?: string | null;
          avatarIsPreviewable?: boolean | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
          skills?: Array<{
            __typename?: 'Skill';
            id: string;
            name: string;
            createdAt: any;
          }> | null;
        } | null;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          blobId?: string | null;
          name: string;
          contentType?: string | null;
          createdAt: any;
          size?: number | null;
          isImage: boolean;
          isVideo: boolean;
          clientId: string;
          isAudio: boolean;
          duration?: number | null;
          file: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          };
          owner: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            createdAt: any;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          };
        }>;
        attachment?:
          | {
              __typename?: 'Document';
              id: string;
              blobId?: string | null;
              name: string;
              contentType?: string | null;
              createdAt: any;
              size?: number | null;
              isImage: boolean;
              isVideo: boolean;
              clientId: string;
              isAudio: boolean;
              duration?: number | null;
              projectDocuments?: Array<{
                __typename?: 'ProjectDocument';
                id: string;
                project?: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                } | null;
              }> | null;
              taskDocuments?: Array<{
                __typename?: 'TaskDocument';
                id: string;
                task?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  projectId: string;
                  project: {
                    __typename?: 'Project';
                    id: string;
                    uuid: string;
                    name: string;
                  };
                } | null;
              }> | null;
              file: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              };
              owner: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                createdAt: any;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              };
            }
          | {
              __typename?: 'EntityUser';
              id: string;
              user?: {
                __typename?: 'User';
                id: string;
                email: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                phoneNumber: string;
                primaryTeamId?: string | null;
                createdAt: any;
                inviteUrl: string;
                avatarId?: string | null;
                avatarIsPreviewable?: boolean | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
                skills?: Array<{
                  __typename?: 'Skill';
                  id: string;
                  name: string;
                  createdAt: any;
                }> | null;
              } | null;
              entityTask?: {
                __typename?: 'Task';
                id: string;
                name: string;
                deletedAt?: any | null;
                members: Array<{
                  __typename?: 'TaskMember';
                  id: string;
                  role: TaskMemberRole;
                  user: {
                    __typename?: 'User';
                    id: string;
                    email: string;
                    name?: string | null;
                    firstName?: string | null;
                    lastName?: string | null;
                    phoneNumber: string;
                    primaryTeamId?: string | null;
                    createdAt: any;
                    inviteUrl: string;
                    avatarId?: string | null;
                    avatarIsPreviewable?: boolean | null;
                    avatar?: {
                      __typename?: 'File';
                      id: string;
                      cdnBaseUrl: string;
                      path: string;
                      isPreviewable: boolean;
                      thumbnail?: string | null;
                    } | null;
                    skills?: Array<{
                      __typename?: 'Skill';
                      id: string;
                      name: string;
                      createdAt: any;
                    }> | null;
                  };
                }>;
                project: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                };
              } | null;
              entityProject?: {
                __typename?: 'Project';
                id: string;
                uuid: string;
                name: string;
              } | null;
            }
          | { __typename?: 'Folder' }
          | { __typename?: 'LocalFile' }
          | {
              __typename?: 'Message';
              id: string;
              chatId: string;
              clientId: string;
              body?: string | null;
              createdAt: any;
              isSender: boolean;
              isDraft: boolean;
              publishedAt?: any | null;
              authorId: string;
              authorAvatarId?: string | null;
              authorName?: string | null;
              authorFirstName?: string | null;
              authorLastName?: string | null;
              authorEmail?: string | null;
              readAt?: any | null;
              isRetry: boolean;
              replyId?: string | null;
              readReceipts?: Array<{
                __typename?: 'User';
                id: string;
                email: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                phoneNumber: string;
                primaryTeamId?: string | null;
                createdAt: any;
                inviteUrl: string;
                avatarId?: string | null;
                avatarIsPreviewable?: boolean | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
                skills?: Array<{
                  __typename?: 'Skill';
                  id: string;
                  name: string;
                  createdAt: any;
                }> | null;
              }> | null;
              checkin?: {
                __typename?: 'MessageCheckin';
                id: string;
                address?: string | null;
                city?: string | null;
                zipcode?: string | null;
                state?: string | null;
                country?: string | null;
                latitude?: number | null;
                longitude?: number | null;
                withinGeofence: boolean;
              } | null;
              userRequest?: {
                __typename?: 'UserRequest';
                id: string;
                requestType: UserRequestCategory;
                status: string;
                canBeReviewed: boolean;
                expiredAt?: any | null;
                userRequestableId: string;
                userRequestableType: UserRequestable;
                invitedBy?: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                } | null;
                reviewedBy?: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                } | null;
                user?: {
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                  firstName?: string | null;
                } | null;
              } | null;
              replyMessage?: {
                __typename?: 'Message';
                id: string;
                chatId: string;
                clientId: string;
                body?: string | null;
                deletedAt?: any | null;
                createdAt: any;
                isSender: boolean;
                isDraft: boolean;
                publishedAt?: any | null;
                authorId: string;
                authorAvatarId?: string | null;
                authorName?: string | null;
                authorFirstName?: string | null;
                authorLastName?: string | null;
                authorEmail?: string | null;
                attachments?: Array<
                  | {
                      __typename?: 'Document';
                      id: string;
                      name: string;
                      contentType?: string | null;
                      createdAt: any;
                      size?: number | null;
                      isImage: boolean;
                      clientId: string;
                      isAudio: boolean;
                      duration?: number | null;
                      file: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        url: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      };
                      owner: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        createdAt: any;
                      };
                    }
                  | { __typename?: 'EntityUser' }
                  | { __typename?: 'Folder' }
                  | { __typename?: 'LocalFile' }
                  | { __typename?: 'Message' }
                  | {
                      __typename?: 'MessageProject';
                      id: string;
                      authorId: string;
                      author?: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: { __typename?: 'File'; id: string } | null;
                      } | null;
                      project?: {
                        __typename?: 'Project';
                        id: string;
                        uuid: string;
                        name: string;
                        team?: {
                          __typename?: 'Team';
                          subscriptionDetails?: {
                            __typename?: 'SubscriptionDetails';
                            expirationDate?: any | null;
                            subscriptionStatus?: string | null;
                          } | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: 'MessageTask';
                      id: string;
                      authorId: string;
                      author?: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: { __typename?: 'File'; id: string } | null;
                      } | null;
                      task?: {
                        __typename?: 'Task';
                        id: string;
                        projectId: string;
                        name: string;
                      } | null;
                    }
                  | {
                      __typename?: 'MessageTaskAssignment';
                      id: string;
                      messageId: string;
                      assignees: Array<{
                        __typename?: 'User';
                        id: string;
                        email: string;
                        name?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        phoneNumber: string;
                        primaryTeamId?: string | null;
                        createdAt: any;
                        inviteUrl: string;
                        avatarId?: string | null;
                        avatarIsPreviewable?: boolean | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                        skills?: Array<{
                          __typename?: 'Skill';
                          id: string;
                          name: string;
                          createdAt: any;
                        }> | null;
                      }>;
                      task?: {
                        __typename?: 'Task';
                        id: string;
                        name: string;
                        deletedAt?: any | null;
                        completedAt?: any | null;
                      } | null;
                    }
                  | {
                      __typename?: 'MessageTaskComplete';
                      id: string;
                      messageId: string;
                      completor?: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: { __typename?: 'File'; id: string } | null;
                      } | null;
                    }
                  | { __typename?: 'Project' }
                  | { __typename?: 'ProjectUser' }
                  | { __typename?: 'PublicTeam' }
                  | { __typename?: 'Task' }
                  | { __typename?: 'TaskUser' }
                  | { __typename?: 'UserRequest' }
                > | null;
              } | null;
              attachments?: Array<
                | {
                    __typename?: 'Document';
                    id: string;
                    blobId?: string | null;
                    name: string;
                    contentType?: string | null;
                    createdAt: any;
                    size?: number | null;
                    isImage: boolean;
                    clientId: string;
                    isAudio: boolean;
                    duration?: number | null;
                    file: {
                      __typename?: 'File';
                      id: string;
                      cdnBaseUrl: string;
                      url: string;
                      isPreviewable: boolean;
                      thumbnail?: string | null;
                    };
                    owner: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      firstName?: string | null;
                      lastName?: string | null;
                      createdAt: any;
                    };
                    taskDocuments?: Array<{
                      __typename?: 'TaskDocument';
                      id: string;
                      owner?: { __typename?: 'User'; id: string } | null;
                      task?: {
                        __typename?: 'Task';
                        id: string;
                        name: string;
                        projectId: string;
                        project: {
                          __typename?: 'Project';
                          id: string;
                          name: string;
                        };
                      } | null;
                    }> | null;
                    projectDocuments?: Array<{
                      __typename?: 'ProjectDocument';
                      id: string;
                      owner?: { __typename?: 'User'; id: string } | null;
                      project?: {
                        __typename?: 'Project';
                        id: string;
                        name: string;
                      } | null;
                    }> | null;
                  }
                | { __typename?: 'EntityUser' }
                | { __typename?: 'Folder' }
                | { __typename?: 'LocalFile' }
                | { __typename?: 'Message' }
                | {
                    __typename?: 'MessageProject';
                    id: string;
                    authorId: string;
                    author?: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: { __typename?: 'File'; id: string } | null;
                    } | null;
                    project?: {
                      __typename?: 'Project';
                      id: string;
                      uuid: string;
                      name: string;
                      team?: {
                        __typename?: 'Team';
                        subscriptionDetails?: {
                          __typename?: 'SubscriptionDetails';
                          expirationDate?: any | null;
                          subscriptionStatus?: string | null;
                        } | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: 'MessageTask';
                    id: string;
                    authorId: string;
                    author?: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: { __typename?: 'File'; id: string } | null;
                    } | null;
                    task?: {
                      __typename?: 'Task';
                      id: string;
                      projectId: string;
                      deletedAt?: any | null;
                      name: string;
                      priority?: TaskPriority | null;
                      dueDate?: any | null;
                      members: Array<{
                        __typename?: 'TaskMember';
                        id: string;
                        role: TaskMemberRole;
                        user: {
                          __typename?: 'User';
                          id: string;
                          name?: string | null;
                          avatar?: { __typename?: 'File'; id: string } | null;
                        };
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'MessageTaskAssignment';
                    id: string;
                    messageId: string;
                    assignees: Array<{
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      firstName?: string | null;
                      avatar?: { __typename?: 'File'; id: string } | null;
                    }>;
                    task?: {
                      __typename?: 'Task';
                      id: string;
                      name: string;
                      deletedAt?: any | null;
                      completedAt?: any | null;
                      currentUserRole?: TaskMemberRole | null;
                    } | null;
                  }
                | {
                    __typename?: 'MessageTaskComplete';
                    id: string;
                    messageId: string;
                    completor?: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: { __typename?: 'File'; id: string } | null;
                    } | null;
                  }
                | { __typename?: 'Project' }
                | { __typename?: 'ProjectUser' }
                | {
                    __typename?: 'PublicTeam';
                    uuid: string;
                    name: string;
                    hasPendingMemberAdditionRequest: boolean;
                    avatarFile?: {
                      __typename?: 'File';
                      id: string;
                      cdnBaseUrl: string;
                      path: string;
                      isPreviewable: boolean;
                      thumbnail?: string | null;
                    } | null;
                  }
                | { __typename?: 'Task' }
                | { __typename?: 'TaskUser' }
                | { __typename?: 'UserRequest' }
              > | null;
              reaction?: Array<{
                __typename?: 'MessageReaction';
                id: string;
                reaction: string;
                count: number;
                user?: Array<{
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                }> | null;
              }> | null;
            }
          | { __typename?: 'MessageProject' }
          | { __typename?: 'MessageTask' }
          | { __typename?: 'MessageTaskAssignment' }
          | { __typename?: 'MessageTaskComplete' }
          | { __typename?: 'Project'; id: string; uuid: string; name: string }
          | {
              __typename?: 'ProjectUser';
              id: string;
              user?: {
                __typename?: 'User';
                id: string;
                email: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                phoneNumber: string;
                primaryTeamId?: string | null;
                createdAt: any;
                inviteUrl: string;
                avatarId?: string | null;
                avatarIsPreviewable?: boolean | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
                skills?: Array<{
                  __typename?: 'Skill';
                  id: string;
                  name: string;
                  createdAt: any;
                }> | null;
              } | null;
            }
          | { __typename?: 'PublicTeam' }
          | {
              __typename?: 'Task';
              id: string;
              name: string;
              projectId: string;
              deletedAt?: any | null;
              project: {
                __typename?: 'Project';
                id: string;
                uuid: string;
                name: string;
              };
            }
          | {
              __typename?: 'TaskUser';
              id: string;
              task: {
                __typename?: 'Task';
                id: string;
                name: string;
                project: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                };
              };
              user?: {
                __typename?: 'User';
                id: string;
                email: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                phoneNumber: string;
                primaryTeamId?: string | null;
                createdAt: any;
                inviteUrl: string;
                avatarId?: string | null;
                avatarIsPreviewable?: boolean | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
                skills?: Array<{
                  __typename?: 'Skill';
                  id: string;
                  name: string;
                  createdAt: any;
                }> | null;
              } | null;
            }
          | { __typename?: 'UserRequest' }
          | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListActivitiesByProjectForNudgeQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListActivitiesByProjectForNudgeQuery = {
  __typename?: 'Query';
  listActivitiesByProject?: {
    __typename?: 'AuditConnection';
    edges?: Array<{
      __typename?: 'AuditEdge';
      node?: { __typename?: 'Audit'; event: string } | null;
    } | null> | null;
  } | null;
};

export type ListActivitiesByTaskQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type ListActivitiesByTaskQuery = {
  __typename?: 'Query';
  listActivitiesByTask?: {
    __typename?: 'AuditConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'AuditEdge';
      cursor: string;
      node?: {
        __typename?: 'Audit';
        event: string;
        createdAt: any;
        id: string;
        changes?: any | null;
        user?: {
          __typename?: 'User';
          id: string;
          email: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          phoneNumber: string;
          primaryTeamId?: string | null;
          createdAt: any;
          inviteUrl: string;
          avatarId?: string | null;
          avatarIsPreviewable?: boolean | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
          skills?: Array<{
            __typename?: 'Skill';
            id: string;
            name: string;
            createdAt: any;
          }> | null;
        } | null;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          blobId?: string | null;
          name: string;
          contentType?: string | null;
          createdAt: any;
          size?: number | null;
          isImage: boolean;
          isVideo: boolean;
          clientId: string;
          isAudio: boolean;
          duration?: number | null;
          file: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          };
          owner: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            createdAt: any;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          };
        }>;
        attachment?:
          | {
              __typename?: 'Document';
              id: string;
              blobId?: string | null;
              name: string;
              contentType?: string | null;
              createdAt: any;
              size?: number | null;
              isImage: boolean;
              isVideo: boolean;
              clientId: string;
              isAudio: boolean;
              duration?: number | null;
              projectDocuments?: Array<{
                __typename?: 'ProjectDocument';
                id: string;
                project?: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                } | null;
              }> | null;
              taskDocuments?: Array<{
                __typename?: 'TaskDocument';
                id: string;
                task?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  projectId: string;
                  project: {
                    __typename?: 'Project';
                    id: string;
                    uuid: string;
                    name: string;
                  };
                } | null;
              }> | null;
              file: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              };
              owner: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                createdAt: any;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              };
            }
          | {
              __typename?: 'EntityUser';
              id: string;
              user?: {
                __typename?: 'User';
                id: string;
                email: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                phoneNumber: string;
                primaryTeamId?: string | null;
                createdAt: any;
                inviteUrl: string;
                avatarId?: string | null;
                avatarIsPreviewable?: boolean | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
                skills?: Array<{
                  __typename?: 'Skill';
                  id: string;
                  name: string;
                  createdAt: any;
                }> | null;
              } | null;
              entityTask?: {
                __typename?: 'Task';
                id: string;
                name: string;
                deletedAt?: any | null;
                members: Array<{
                  __typename?: 'TaskMember';
                  id: string;
                  role: TaskMemberRole;
                  user: {
                    __typename?: 'User';
                    id: string;
                    email: string;
                    name?: string | null;
                    firstName?: string | null;
                    lastName?: string | null;
                    phoneNumber: string;
                    primaryTeamId?: string | null;
                    createdAt: any;
                    inviteUrl: string;
                    avatarId?: string | null;
                    avatarIsPreviewable?: boolean | null;
                    avatar?: {
                      __typename?: 'File';
                      id: string;
                      cdnBaseUrl: string;
                      path: string;
                      isPreviewable: boolean;
                      thumbnail?: string | null;
                    } | null;
                    skills?: Array<{
                      __typename?: 'Skill';
                      id: string;
                      name: string;
                      createdAt: any;
                    }> | null;
                  };
                }>;
                project: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                };
              } | null;
              entityProject?: {
                __typename?: 'Project';
                id: string;
                uuid: string;
                name: string;
              } | null;
            }
          | { __typename?: 'Folder' }
          | { __typename?: 'LocalFile' }
          | {
              __typename?: 'Message';
              id: string;
              chatId: string;
              clientId: string;
              body?: string | null;
              createdAt: any;
              isSender: boolean;
              isDraft: boolean;
              publishedAt?: any | null;
              authorId: string;
              authorAvatarId?: string | null;
              authorName?: string | null;
              authorFirstName?: string | null;
              authorLastName?: string | null;
              authorEmail?: string | null;
              readAt?: any | null;
              isRetry: boolean;
              replyId?: string | null;
              readReceipts?: Array<{
                __typename?: 'User';
                id: string;
                email: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                phoneNumber: string;
                primaryTeamId?: string | null;
                createdAt: any;
                inviteUrl: string;
                avatarId?: string | null;
                avatarIsPreviewable?: boolean | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
                skills?: Array<{
                  __typename?: 'Skill';
                  id: string;
                  name: string;
                  createdAt: any;
                }> | null;
              }> | null;
              checkin?: {
                __typename?: 'MessageCheckin';
                id: string;
                address?: string | null;
                city?: string | null;
                zipcode?: string | null;
                state?: string | null;
                country?: string | null;
                latitude?: number | null;
                longitude?: number | null;
                withinGeofence: boolean;
              } | null;
              userRequest?: {
                __typename?: 'UserRequest';
                id: string;
                requestType: UserRequestCategory;
                status: string;
                canBeReviewed: boolean;
                expiredAt?: any | null;
                userRequestableId: string;
                userRequestableType: UserRequestable;
                invitedBy?: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  firstName?: string | null;
                } | null;
                reviewedBy?: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  firstName?: string | null;
                } | null;
                user?: {
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                } | null;
              } | null;
              replyMessage?: {
                __typename?: 'Message';
                id: string;
                chatId: string;
                clientId: string;
                body?: string | null;
                deletedAt?: any | null;
                createdAt: any;
                isSender: boolean;
                isDraft: boolean;
                publishedAt?: any | null;
                authorId: string;
                authorAvatarId?: string | null;
                authorName?: string | null;
                authorFirstName?: string | null;
                authorLastName?: string | null;
                authorEmail?: string | null;
                attachments?: Array<
                  | {
                      __typename?: 'Document';
                      id: string;
                      name: string;
                      contentType?: string | null;
                      createdAt: any;
                      size?: number | null;
                      isImage: boolean;
                      clientId: string;
                      isAudio: boolean;
                      duration?: number | null;
                      file: {
                        __typename?: 'File';
                        id: string;
                        url: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      };
                      owner: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        createdAt: any;
                      };
                    }
                  | { __typename?: 'EntityUser' }
                  | { __typename?: 'Folder' }
                  | { __typename?: 'LocalFile' }
                  | { __typename?: 'Message' }
                  | {
                      __typename?: 'MessageProject';
                      id: string;
                      authorId: string;
                      author?: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                      } | null;
                      project?: {
                        __typename?: 'Project';
                        id: string;
                        uuid: string;
                        name: string;
                        team?: {
                          __typename?: 'Team';
                          subscriptionDetails?: {
                            __typename?: 'SubscriptionDetails';
                            expirationDate?: any | null;
                            subscriptionStatus?: string | null;
                          } | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: 'MessageTask';
                      id: string;
                      authorId: string;
                      author?: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                      } | null;
                      task?: {
                        __typename?: 'Task';
                        id: string;
                        projectId: string;
                        name: string;
                      } | null;
                    }
                  | {
                      __typename?: 'MessageTaskAssignment';
                      id: string;
                      messageId: string;
                      assignees: Array<{
                        __typename?: 'User';
                        id: string;
                        email: string;
                        name?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        phoneNumber: string;
                        primaryTeamId?: string | null;
                        createdAt: any;
                        inviteUrl: string;
                        avatarId?: string | null;
                        avatarIsPreviewable?: boolean | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                        skills?: Array<{
                          __typename?: 'Skill';
                          id: string;
                          name: string;
                          createdAt: any;
                        }> | null;
                      }>;
                      task?: {
                        __typename?: 'Task';
                        id: string;
                        name: string;
                        deletedAt?: any | null;
                        completedAt?: any | null;
                      } | null;
                    }
                  | {
                      __typename?: 'MessageTaskComplete';
                      id: string;
                      messageId: string;
                      completor?: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                      } | null;
                    }
                  | { __typename?: 'Project' }
                  | { __typename?: 'ProjectUser' }
                  | { __typename?: 'PublicTeam' }
                  | { __typename?: 'Task' }
                  | { __typename?: 'TaskUser' }
                  | { __typename?: 'UserRequest' }
                > | null;
              } | null;
              attachments?: Array<
                | {
                    __typename?: 'Document';
                    id: string;
                    blobId?: string | null;
                    name: string;
                    contentType?: string | null;
                    createdAt: any;
                    size?: number | null;
                    isImage: boolean;
                    clientId: string;
                    isAudio: boolean;
                    duration?: number | null;
                    file: {
                      __typename?: 'File';
                      id: string;
                      url: string;
                      cdnBaseUrl: string;
                      path: string;
                      isPreviewable: boolean;
                      thumbnail?: string | null;
                    };
                    owner: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      firstName?: string | null;
                      lastName?: string | null;
                      createdAt: any;
                    };
                    taskDocuments?: Array<{
                      __typename?: 'TaskDocument';
                      id: string;
                      owner?: { __typename?: 'User'; id: string } | null;
                      task?: {
                        __typename?: 'Task';
                        id: string;
                        name: string;
                        projectId: string;
                        project: {
                          __typename?: 'Project';
                          id: string;
                          name: string;
                        };
                      } | null;
                    }> | null;
                    projectDocuments?: Array<{
                      __typename?: 'ProjectDocument';
                      id: string;
                      owner?: { __typename?: 'User'; id: string } | null;
                      project?: {
                        __typename?: 'Project';
                        id: string;
                        name: string;
                      } | null;
                    }> | null;
                  }
                | { __typename?: 'EntityUser' }
                | { __typename?: 'Folder' }
                | { __typename?: 'LocalFile' }
                | { __typename?: 'Message' }
                | {
                    __typename?: 'MessageProject';
                    id: string;
                    authorId: string;
                    author?: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                    } | null;
                    project?: {
                      __typename?: 'Project';
                      id: string;
                      uuid: string;
                      name: string;
                      team?: {
                        __typename?: 'Team';
                        subscriptionDetails?: {
                          __typename?: 'SubscriptionDetails';
                          expirationDate?: any | null;
                          subscriptionStatus?: string | null;
                        } | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: 'MessageTask';
                    id: string;
                    authorId: string;
                    author?: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                    } | null;
                    task?: {
                      __typename?: 'Task';
                      id: string;
                      projectId: string;
                      deletedAt?: any | null;
                      name: string;
                    } | null;
                  }
                | {
                    __typename?: 'MessageTaskAssignment';
                    id: string;
                    messageId: string;
                    assignees: Array<{
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                    }>;
                    task?: {
                      __typename?: 'Task';
                      id: string;
                      name: string;
                      deletedAt?: any | null;
                      completedAt?: any | null;
                      currentUserRole?: TaskMemberRole | null;
                    } | null;
                  }
                | {
                    __typename?: 'MessageTaskComplete';
                    id: string;
                    messageId: string;
                    completor?: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                    } | null;
                  }
                | { __typename?: 'Project' }
                | { __typename?: 'ProjectUser' }
                | { __typename?: 'PublicTeam' }
                | { __typename?: 'Task' }
                | { __typename?: 'TaskUser' }
                | { __typename?: 'UserRequest' }
              > | null;
              reaction?: Array<{
                __typename?: 'MessageReaction';
                id: string;
                reaction: string;
                count: number;
                user?: Array<{
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                }> | null;
              }> | null;
            }
          | { __typename?: 'MessageProject' }
          | { __typename?: 'MessageTask' }
          | { __typename?: 'MessageTaskAssignment' }
          | { __typename?: 'MessageTaskComplete' }
          | { __typename?: 'Project'; id: string; uuid: string; name: string }
          | {
              __typename?: 'ProjectUser';
              id: string;
              user?: {
                __typename?: 'User';
                id: string;
                email: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                phoneNumber: string;
                primaryTeamId?: string | null;
                createdAt: any;
                inviteUrl: string;
                avatarId?: string | null;
                avatarIsPreviewable?: boolean | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
                skills?: Array<{
                  __typename?: 'Skill';
                  id: string;
                  name: string;
                  createdAt: any;
                }> | null;
              } | null;
            }
          | { __typename?: 'PublicTeam' }
          | {
              __typename?: 'Task';
              id: string;
              name: string;
              projectId: string;
              deletedAt?: any | null;
              completedAt?: any | null;
              project: {
                __typename?: 'Project';
                id: string;
                uuid: string;
                name: string;
              };
              completor?: {
                __typename?: 'User';
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              } | null;
            }
          | {
              __typename?: 'TaskUser';
              id: string;
              task: {
                __typename?: 'Task';
                id: string;
                name: string;
                project: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                };
              };
              user?: {
                __typename?: 'User';
                id: string;
                email: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                phoneNumber: string;
                primaryTeamId?: string | null;
                createdAt: any;
                inviteUrl: string;
                avatarId?: string | null;
                avatarIsPreviewable?: boolean | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
                skills?: Array<{
                  __typename?: 'Skill';
                  id: string;
                  name: string;
                  createdAt: any;
                }> | null;
              } | null;
            }
          | { __typename?: 'UserRequest' }
          | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListBlockedUsersQueryVariables = Exact<{ [key: string]: never }>;

export type ListBlockedUsersQuery = {
  __typename?: 'Query';
  listBlockedUsers: Array<{
    __typename?: 'User';
    id: string;
    email: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber: string;
    primaryTeamId?: string | null;
    createdAt: any;
    inviteUrl: string;
    avatarId?: string | null;
    avatarIsPreviewable?: boolean | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    skills?: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }> | null;
  }>;
};

export type ListChatPaginationIdentifiersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListChatPaginationIdentifiersQuery = {
  __typename?: 'Query';
  listChatsPagination: {
    __typename?: 'ChatConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'ChatEdge';
      cursor: string;
      node?: {
        __typename?: 'Chat';
        id: string;
        name: string;
        description?: string | null;
        avatarUrl?: string | null;
        isGroupChat: boolean;
        messageIcon?: string | null;
        messageBody?: string | null;
        recentActivityAt?: any | null;
        unreadCount?: number | null;
        createdAt: any;
        leaveOn?: any | null;
        isPendingRequest: boolean;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        settings?: {
          __typename?: 'UserChatSetting';
          id: string;
          pin: boolean;
          mute: boolean;
          archivedAt?: any | null;
        } | null;
        users: Array<{
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        }>;
        pendingInvitations: Array<{
          __typename?: 'ChatInvitation';
          email: string;
          expiredAt: any;
          id: string;
        }>;
        userRequests: Array<{
          __typename?: 'UserRequest';
          id: string;
          status: string;
          expiredAt?: any | null;
          user?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            email: string;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
        }>;
        owner: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
        };
      } | null;
    } | null> | null;
  };
};

export type ListChatPaginationIdentifiersForwardQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListChatPaginationIdentifiersForwardQuery = {
  __typename?: 'Query';
  listChatsPagination: {
    __typename?: 'ChatConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'ChatEdge';
      cursor: string;
      node?: {
        __typename?: 'Chat';
        id: string;
        name: string;
        isGroupChat: boolean;
        avatarUrl?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        users: Array<{
          __typename?: 'User';
          id: string;
          name?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        }>;
      } | null;
    } | null> | null;
  };
};

export type ListChatRelatedProjectsQueryVariables = Exact<{
  chatId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListChatRelatedProjectsQuery = {
  __typename?: 'Query';
  listChatRelatedProjects?: {
    __typename?: 'ChatProjectTaskConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'ChatProjectTaskEdge';
      cursor: string;
      node?: {
        __typename?: 'ChatProjectTask';
        id: string;
        name: string;
        currentUserRole: ProjectMemberRole;
        archivedAt?: any | null;
        tasks?: Array<{
          __typename?: 'Task';
          id: string;
          name: string;
          status?: TaskStatus | null;
          priority?: TaskPriority | null;
          deletedAt?: any | null;
          dueDate?: any | null;
          completedAt?: any | null;
          projectId: string;
          userIds: Array<string>;
          currentUserRole?: TaskMemberRole | null;
          project: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
          };
          members: Array<{
            __typename?: 'TaskMember';
            id: string;
            role: TaskMemberRole;
            user: {
              __typename?: 'User';
              id: string;
              email: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              phoneNumber: string;
              primaryTeamId?: string | null;
              createdAt: any;
              inviteUrl: string;
              avatarId?: string | null;
              avatarIsPreviewable?: boolean | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
              skills?: Array<{
                __typename?: 'Skill';
                id: string;
                name: string;
                createdAt: any;
              }> | null;
            };
          }>;
        }> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListChatsPaginationQueryVariables = Exact<{
  archivesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListChatsPaginationQuery = {
  __typename?: 'Query';
  listChatsPagination: {
    __typename?: 'ChatConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'ChatEdge';
      cursor: string;
      node?: {
        __typename?: 'Chat';
        id: string;
        name: string;
        description?: string | null;
        avatarUrl?: string | null;
        isGroupChat: boolean;
        messageIcon?: string | null;
        messageBody?: string | null;
        recentActivityAt?: any | null;
        friendRequestAccepted?: boolean | null;
        unreadCount?: number | null;
        createdAt: any;
        leaveOn?: any | null;
        userIds: Array<string>;
        settingsPin?: boolean | null;
        settingsMute?: boolean | null;
        canCurrentUserDecide: boolean;
        isPendingRequest: boolean;
        settingsArchivedAt?: any | null;
        ownerId: string;
        ownerName: string;
        pendingInvitations: Array<{
          __typename?: 'ChatInvitation';
          email: string;
        }>;
      } | null;
    } | null> | null;
  };
};

export type ListChecklistTemplatesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ListChecklistTemplatesQuery = {
  __typename?: 'Query';
  listChecklistTemplates: Array<{
    __typename?: 'ChecklistTemplate';
    id: string;
    isFavorited: boolean;
    favoritedAt?: any | null;
    templateName: string;
    checklistTemplateItems: Array<{
      __typename?: 'ChecklistTemplateItem';
      id: string;
      checklistTemplateItemName: string;
    }>;
  }>;
};

export type ListChecklistTemplatesNoItemsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ListChecklistTemplatesNoItemsQuery = {
  __typename?: 'Query';
  listChecklistTemplates: Array<{
    __typename?: 'ChecklistTemplate';
    id: string;
    templateName: string;
    isFavorited: boolean;
    favoritedAt?: any | null;
    owner: { __typename?: 'User'; id: string };
  }>;
};

export type ListContactUsersQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;

export type ListContactUsersQuery = {
  __typename?: 'Query';
  listContactUsers: Array<{
    __typename?: 'User';
    id: string;
    email: string;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber: string;
    primaryTeamId?: string | null;
    createdAt: any;
    inviteUrl: string;
    avatarId?: string | null;
    avatarIsPreviewable?: boolean | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    skills?: Array<{
      __typename?: 'Skill';
      id: string;
      name: string;
      createdAt: any;
    }> | null;
  }>;
};

export type ListDeletedMessageIdsQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;

export type ListDeletedMessageIdsQuery = {
  __typename?: 'Query';
  listDeletedMessageIds: Array<string>;
};

export type ListDraftDocumentsQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;

export type ListDraftDocumentsQuery = {
  __typename?: 'Query';
  listDraftDocuments: Array<{
    __typename?: 'Document';
    messageClientId?: string | null;
    messageCreateYn?: boolean | null;
    blobId?: string | null;
    id: string;
    name: string;
    contentType?: string | null;
    createdAt: any;
    size?: number | null;
    isImage: boolean;
    isVideo: boolean;
    clientId: string;
    isAudio: boolean;
    duration?: number | null;
    file: {
      __typename?: 'File';
      id: string;
      url: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    };
    owner: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      createdAt: any;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    };
  }>;
};

export type ListDraftMessagesQueryVariables = Exact<{ [key: string]: never }>;

export type ListDraftMessagesQuery = {
  __typename?: 'Query';
  listDraftMessages: Array<{
    __typename?: 'Message';
    id: string;
    chatId: string;
    clientId: string;
    body?: string | null;
    createdAt: any;
    isSender: boolean;
    isDraft: boolean;
    publishedAt?: any | null;
    failedAt: any;
    isRetry: boolean;
    authorId: string;
    authorAvatarId?: string | null;
    authorName?: string | null;
    authorFirstName?: string | null;
    authorLastName?: string | null;
    authorEmail?: string | null;
    replyId?: string | null;
    chat: {
      __typename?: 'Chat';
      id: string;
      name: string;
      description?: string | null;
      avatarUrl?: string | null;
      isGroupChat: boolean;
      messageIcon?: string | null;
      messageBody?: string | null;
      recentActivityAt?: any | null;
      unreadCount?: number | null;
      createdAt: any;
      leaveOn?: any | null;
      isPendingRequest: boolean;
      settings?: {
        __typename?: 'UserChatSetting';
        id: string;
        pin: boolean;
        mute: boolean;
        archivedAt?: any | null;
      } | null;
      users: Array<{
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      }>;
      pendingInvitations: Array<{
        __typename?: 'ChatInvitation';
        email: string;
        expiredAt: any;
        id: string;
      }>;
      userRequests: Array<{
        __typename?: 'UserRequest';
        id: string;
        status: string;
        expiredAt?: any | null;
        user?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email: string;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        } | null;
      }>;
      owner: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      };
    };
    checkin?: {
      __typename?: 'MessageCheckin';
      id: string;
      address?: string | null;
      city?: string | null;
      zipcode?: string | null;
      state?: string | null;
      country?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      withinGeofence: boolean;
    } | null;
    replyMessage?: {
      __typename?: 'Message';
      id: string;
      chatId: string;
      clientId: string;
      body?: string | null;
      createdAt: any;
      isSender: boolean;
      isDraft: boolean;
      publishedAt?: any | null;
      authorId: string;
      authorAvatarId?: string | null;
      authorName?: string | null;
      authorFirstName?: string | null;
      authorLastName?: string | null;
      authorEmail?: string | null;
    } | null;
    attachments?: Array<
      | {
          __typename?: 'Document';
          id: string;
          blobId?: string | null;
          clientId: string;
          name: string;
          contentType?: string | null;
          isImage: boolean;
          size?: number | null;
          isAudio: boolean;
          duration?: number | null;
          file: {
            __typename?: 'File';
            id: string;
            url: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          };
        }
      | { __typename?: 'EntityUser' }
      | { __typename?: 'Folder' }
      | { __typename?: 'LocalFile' }
      | { __typename?: 'Message' }
      | {
          __typename?: 'MessageProject';
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
          } | null;
          project?: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
          } | null;
        }
      | {
          __typename?: 'MessageTask';
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
          } | null;
          task?: {
            __typename?: 'Task';
            id: string;
            name: string;
            projectId: string;
          } | null;
        }
      | { __typename?: 'MessageTaskAssignment' }
      | { __typename?: 'MessageTaskComplete' }
      | { __typename?: 'Project' }
      | { __typename?: 'ProjectUser' }
      | { __typename?: 'PublicTeam' }
      | { __typename?: 'Task' }
      | { __typename?: 'TaskUser' }
      | { __typename?: 'UserRequest' }
    > | null;
  }>;
};

export type ListDraftProjectDocumentsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;

export type ListDraftProjectDocumentsQuery = {
  __typename?: 'Query';
  listDraftProjectDocuments: Array<{
    __typename?: 'Document';
    id: string;
    blobId?: string | null;
    name: string;
    contentType?: string | null;
    createdAt: any;
    size?: number | null;
    isImage: boolean;
    isVideo: boolean;
    clientId: string;
    isAudio: boolean;
    duration?: number | null;
    failedAt: any;
    file: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
      url: string;
    };
    owner: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      createdAt: any;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    };
  }>;
};

export type ListDraftTaskDocumentsQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type ListDraftTaskDocumentsQuery = {
  __typename?: 'Query';
  listDraftTaskDocuments: Array<{
    __typename?: 'Document';
    id: string;
    blobId?: string | null;
    name: string;
    contentType?: string | null;
    createdAt: any;
    size?: number | null;
    isImage: boolean;
    isVideo: boolean;
    clientId: string;
    isAudio: boolean;
    duration?: number | null;
    failedAt: any;
    file: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
      url: string;
    };
    owner: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      createdAt: any;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    };
  }>;
};

export type ListFeatureFlagsQueryVariables = Exact<{ [key: string]: never }>;

export type ListFeatureFlagsQuery = {
  __typename?: 'Query';
  listFeatureFlags: Array<{
    __typename?: 'FeatureFlag';
    name: string;
    enabled: boolean;
  }>;
};

export type ListGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type ListGroupsQuery = {
  __typename?: 'Query';
  listGroups?: Array<{
    __typename?: 'Group';
    id: string;
    name: string;
    currentUserTeamRole?: TeamRole | null;
    team?: {
      __typename?: 'Team';
      id: string;
      avatar?: string | null;
      name: string;
      personal: boolean;
      avatarFile?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    } | null;
    users?: Array<{
      __typename?: 'User';
      id: string;
      name?: string | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    }> | null;
  }> | null;
};

export type ListMessagesQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
  includeDraft?: InputMaybe<Scalars['Boolean']['input']>;
  includePublished?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListMessagesQuery = {
  __typename?: 'Query';
  listMessages?: {
    __typename?: 'MessageConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'MessageEdge';
      cursor: string;
      node?: {
        __typename?: 'Message';
        id: string;
        chatId: string;
        clientId: string;
        body?: string | null;
        createdAt: any;
        isSender: boolean;
        isDraft: boolean;
        publishedAt?: any | null;
        authorId: string;
        authorAvatarId?: string | null;
        authorName?: string | null;
        authorFirstName?: string | null;
        authorLastName?: string | null;
        authorEmail?: string | null;
        readAt?: any | null;
        isRetry: boolean;
        replyId?: string | null;
        readReceipts?: Array<{
          __typename?: 'User';
          id: string;
          email: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          phoneNumber: string;
          primaryTeamId?: string | null;
          createdAt: any;
          inviteUrl: string;
          avatarId?: string | null;
          avatarIsPreviewable?: boolean | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
          skills?: Array<{
            __typename?: 'Skill';
            id: string;
            name: string;
            createdAt: any;
          }> | null;
        }> | null;
        checkin?: {
          __typename?: 'MessageCheckin';
          id: string;
          address?: string | null;
          city?: string | null;
          zipcode?: string | null;
          state?: string | null;
          country?: string | null;
          latitude?: number | null;
          longitude?: number | null;
          withinGeofence: boolean;
        } | null;
        userRequest?: {
          __typename?: 'UserRequest';
          id: string;
          requestType: UserRequestCategory;
          status: string;
          canBeReviewed: boolean;
          expiredAt?: any | null;
          userRequestableId: string;
          userRequestableType: UserRequestable;
          invitedBy?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
          } | null;
          reviewedBy?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
          } | null;
          user?: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
          } | null;
        } | null;
        replyMessage?: {
          __typename?: 'Message';
          id: string;
          chatId: string;
          clientId: string;
          body?: string | null;
          deletedAt?: any | null;
          createdAt: any;
          isSender: boolean;
          isDraft: boolean;
          publishedAt?: any | null;
          authorId: string;
          authorAvatarId?: string | null;
          authorName?: string | null;
          authorFirstName?: string | null;
          authorLastName?: string | null;
          authorEmail?: string | null;
          attachments?: Array<
            | {
                __typename?: 'Document';
                id: string;
                name: string;
                contentType?: string | null;
                createdAt: any;
                size?: number | null;
                isImage: boolean;
                clientId: string;
                isAudio: boolean;
                duration?: number | null;
                file: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  url: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                };
                owner: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  createdAt: any;
                };
              }
            | { __typename?: 'EntityUser' }
            | { __typename?: 'Folder' }
            | { __typename?: 'LocalFile' }
            | { __typename?: 'Message' }
            | {
                __typename?: 'MessageProject';
                id: string;
                authorId: string;
                author?: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  avatar?: { __typename?: 'File'; id: string } | null;
                } | null;
                project?: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                  team?: {
                    __typename?: 'Team';
                    subscriptionDetails?: {
                      __typename?: 'SubscriptionDetails';
                      expirationDate?: any | null;
                      subscriptionStatus?: string | null;
                    } | null;
                  } | null;
                } | null;
              }
            | {
                __typename?: 'MessageTask';
                id: string;
                authorId: string;
                author?: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  avatar?: { __typename?: 'File'; id: string } | null;
                } | null;
                task?: {
                  __typename?: 'Task';
                  id: string;
                  projectId: string;
                  name: string;
                } | null;
              }
            | {
                __typename?: 'MessageTaskAssignment';
                id: string;
                messageId: string;
                assignees: Array<{
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  phoneNumber: string;
                  primaryTeamId?: string | null;
                  createdAt: any;
                  inviteUrl: string;
                  avatarId?: string | null;
                  avatarIsPreviewable?: boolean | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                  skills?: Array<{
                    __typename?: 'Skill';
                    id: string;
                    name: string;
                    createdAt: any;
                  }> | null;
                }>;
                task?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  deletedAt?: any | null;
                  completedAt?: any | null;
                } | null;
              }
            | {
                __typename?: 'MessageTaskComplete';
                id: string;
                messageId: string;
                completor?: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  avatar?: { __typename?: 'File'; id: string } | null;
                } | null;
              }
            | { __typename?: 'Project' }
            | { __typename?: 'ProjectUser' }
            | { __typename?: 'PublicTeam' }
            | { __typename?: 'Task' }
            | { __typename?: 'TaskUser' }
            | { __typename?: 'UserRequest' }
          > | null;
        } | null;
        attachments?: Array<
          | {
              __typename?: 'Document';
              id: string;
              blobId?: string | null;
              name: string;
              contentType?: string | null;
              createdAt: any;
              size?: number | null;
              isImage: boolean;
              clientId: string;
              isAudio: boolean;
              duration?: number | null;
              file: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                url: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              };
              owner: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                createdAt: any;
              };
              taskDocuments?: Array<{
                __typename?: 'TaskDocument';
                id: string;
                owner?: { __typename?: 'User'; id: string } | null;
                task?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  projectId: string;
                  project: { __typename?: 'Project'; id: string; name: string };
                } | null;
              }> | null;
              projectDocuments?: Array<{
                __typename?: 'ProjectDocument';
                id: string;
                owner?: { __typename?: 'User'; id: string } | null;
                project?: {
                  __typename?: 'Project';
                  id: string;
                  name: string;
                } | null;
              }> | null;
            }
          | { __typename?: 'EntityUser' }
          | { __typename?: 'Folder' }
          | { __typename?: 'LocalFile' }
          | { __typename?: 'Message' }
          | {
              __typename?: 'MessageProject';
              id: string;
              authorId: string;
              author?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: { __typename?: 'File'; id: string } | null;
              } | null;
              project?: {
                __typename?: 'Project';
                id: string;
                uuid: string;
                name: string;
                team?: {
                  __typename?: 'Team';
                  subscriptionDetails?: {
                    __typename?: 'SubscriptionDetails';
                    expirationDate?: any | null;
                    subscriptionStatus?: string | null;
                  } | null;
                } | null;
              } | null;
            }
          | {
              __typename?: 'MessageTask';
              id: string;
              authorId: string;
              author?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: { __typename?: 'File'; id: string } | null;
              } | null;
              task?: {
                __typename?: 'Task';
                id: string;
                projectId: string;
                deletedAt?: any | null;
                name: string;
                priority?: TaskPriority | null;
                dueDate?: any | null;
                members: Array<{
                  __typename?: 'TaskMember';
                  id: string;
                  role: TaskMemberRole;
                  user: {
                    __typename?: 'User';
                    id: string;
                    name?: string | null;
                    avatar?: { __typename?: 'File'; id: string } | null;
                  };
                }>;
              } | null;
            }
          | {
              __typename?: 'MessageTaskAssignment';
              id: string;
              messageId: string;
              assignees: Array<{
                __typename?: 'User';
                id: string;
                name?: string | null;
                firstName?: string | null;
                avatar?: { __typename?: 'File'; id: string } | null;
              }>;
              task?: {
                __typename?: 'Task';
                id: string;
                name: string;
                deletedAt?: any | null;
                completedAt?: any | null;
                currentUserRole?: TaskMemberRole | null;
              } | null;
            }
          | {
              __typename?: 'MessageTaskComplete';
              id: string;
              messageId: string;
              completor?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: { __typename?: 'File'; id: string } | null;
              } | null;
            }
          | { __typename?: 'Project' }
          | { __typename?: 'ProjectUser' }
          | {
              __typename?: 'PublicTeam';
              uuid: string;
              name: string;
              hasPendingMemberAdditionRequest: boolean;
              avatarFile?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            }
          | { __typename?: 'Task' }
          | { __typename?: 'TaskUser' }
          | { __typename?: 'UserRequest' }
        > | null;
        reaction?: Array<{
          __typename?: 'MessageReaction';
          id: string;
          reaction: string;
          count: number;
          user?: Array<{
            __typename?: 'User';
            id: string;
            name?: string | null;
          }> | null;
        }> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListMyTasksProjectGroupsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  projectIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  memberIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  groupBy?: InputMaybe<TaskGroupBy>;
  sortBy?: InputMaybe<TaskSortOption>;
  status?: InputMaybe<TaskStatus>;
  priority?: InputMaybe<Array<TaskPriority> | TaskPriority>;
  dueDateBegin?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  dueDateEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  dueGroup?: InputMaybe<TaskGroup>;
  requireDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  taskCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
  collaboratorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  withoutPhase?: InputMaybe<Scalars['Boolean']['input']>;
  phaseId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tasksAfter?: InputMaybe<Scalars['String']['input']>;
  completedTasksAfter?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListMyTasksProjectGroupsQuery = {
  __typename?: 'Query';
  listMyTasksProjectGroups: {
    __typename?: 'TaskGroupInterfaceConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'TaskGroupInterfaceEdge';
      cursor: string;
      node?:
        | {
            __typename?: 'AssigneeTaskGroup';
            taskCount: number;
            completedCount: number;
            assignee?: {
              __typename?: 'User';
              id: string;
              email: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              phoneNumber: string;
              primaryTeamId?: string | null;
              createdAt: any;
              inviteUrl: string;
              avatarId?: string | null;
              avatarIsPreviewable?: boolean | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
              skills?: Array<{
                __typename?: 'Skill';
                id: string;
                name: string;
                createdAt: any;
              }> | null;
            } | null;
            tasks: {
              __typename?: 'TaskConnection';
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                hasPreviousPage: boolean;
                endCursor?: string | null;
                startCursor?: string | null;
              };
              edges?: Array<{
                __typename?: 'TaskEdge';
                node?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  status?: TaskStatus | null;
                  priority?: TaskPriority | null;
                  startDate?: any | null;
                  dueDate?: any | null;
                  completedAt?: any | null;
                  createdAt: any;
                  projectId: string;
                  currentUserRole?: TaskMemberRole | null;
                  currentUserProjectRole?: ProjectMemberRole | null;
                  currentUserProjectTeamRole?: TeamMemberRole | null;
                  project: {
                    __typename?: 'Project';
                    id: string;
                    name: string;
                    icon?: string | null;
                    color: string;
                  };
                  members: Array<{
                    __typename?: 'TaskMember';
                    role: TaskMemberRole;
                    user: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                    };
                  }>;
                } | null;
              } | null> | null;
            };
            completedTasks: {
              __typename?: 'TaskConnection';
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                hasPreviousPage: boolean;
                endCursor?: string | null;
                startCursor?: string | null;
              };
              edges?: Array<{
                __typename?: 'TaskEdge';
                node?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  status?: TaskStatus | null;
                  priority?: TaskPriority | null;
                  startDate?: any | null;
                  dueDate?: any | null;
                  completedAt?: any | null;
                  createdAt: any;
                  projectId: string;
                  currentUserRole?: TaskMemberRole | null;
                  currentUserProjectRole?: ProjectMemberRole | null;
                  currentUserProjectTeamRole?: TeamMemberRole | null;
                  project: {
                    __typename?: 'Project';
                    id: string;
                    name: string;
                    icon?: string | null;
                    color: string;
                  };
                  members: Array<{
                    __typename?: 'TaskMember';
                    role: TaskMemberRole;
                    user: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                    };
                  }>;
                } | null;
              } | null> | null;
            };
          }
        | {
            __typename?: 'PriorityTaskGroup';
            taskCount: number;
            completedCount: number;
            priority: TaskPriority;
            tasks: {
              __typename?: 'TaskConnection';
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                hasPreviousPage: boolean;
                endCursor?: string | null;
                startCursor?: string | null;
              };
              edges?: Array<{
                __typename?: 'TaskEdge';
                node?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  status?: TaskStatus | null;
                  priority?: TaskPriority | null;
                  startDate?: any | null;
                  dueDate?: any | null;
                  completedAt?: any | null;
                  createdAt: any;
                  projectId: string;
                  currentUserRole?: TaskMemberRole | null;
                  currentUserProjectRole?: ProjectMemberRole | null;
                  currentUserProjectTeamRole?: TeamMemberRole | null;
                  project: {
                    __typename?: 'Project';
                    id: string;
                    name: string;
                    icon?: string | null;
                    color: string;
                  };
                  members: Array<{
                    __typename?: 'TaskMember';
                    role: TaskMemberRole;
                    user: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                    };
                  }>;
                } | null;
              } | null> | null;
            };
            completedTasks: {
              __typename?: 'TaskConnection';
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                hasPreviousPage: boolean;
                endCursor?: string | null;
                startCursor?: string | null;
              };
              edges?: Array<{
                __typename?: 'TaskEdge';
                node?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  status?: TaskStatus | null;
                  priority?: TaskPriority | null;
                  startDate?: any | null;
                  dueDate?: any | null;
                  completedAt?: any | null;
                  createdAt: any;
                  projectId: string;
                  currentUserRole?: TaskMemberRole | null;
                  currentUserProjectRole?: ProjectMemberRole | null;
                  currentUserProjectTeamRole?: TeamMemberRole | null;
                  project: {
                    __typename?: 'Project';
                    id: string;
                    name: string;
                    icon?: string | null;
                    color: string;
                  };
                  members: Array<{
                    __typename?: 'TaskMember';
                    role: TaskMemberRole;
                    user: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                    };
                  }>;
                } | null;
              } | null> | null;
            };
          }
        | {
            __typename?: 'ProjectTaskGroup';
            taskCount: number;
            completedCount: number;
            project: { __typename?: 'Project'; id: string; name: string };
            tasks: {
              __typename?: 'TaskConnection';
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                hasPreviousPage: boolean;
                endCursor?: string | null;
                startCursor?: string | null;
              };
              edges?: Array<{
                __typename?: 'TaskEdge';
                node?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  status?: TaskStatus | null;
                  priority?: TaskPriority | null;
                  startDate?: any | null;
                  dueDate?: any | null;
                  completedAt?: any | null;
                  createdAt: any;
                  projectId: string;
                  currentUserRole?: TaskMemberRole | null;
                  currentUserProjectRole?: ProjectMemberRole | null;
                  currentUserProjectTeamRole?: TeamMemberRole | null;
                  project: {
                    __typename?: 'Project';
                    id: string;
                    name: string;
                    icon?: string | null;
                    color: string;
                  };
                  members: Array<{
                    __typename?: 'TaskMember';
                    role: TaskMemberRole;
                    user: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                    };
                  }>;
                } | null;
              } | null> | null;
            };
            completedTasks: {
              __typename?: 'TaskConnection';
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                hasPreviousPage: boolean;
                endCursor?: string | null;
                startCursor?: string | null;
              };
              edges?: Array<{
                __typename?: 'TaskEdge';
                node?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  status?: TaskStatus | null;
                  priority?: TaskPriority | null;
                  startDate?: any | null;
                  dueDate?: any | null;
                  completedAt?: any | null;
                  createdAt: any;
                  projectId: string;
                  currentUserRole?: TaskMemberRole | null;
                  currentUserProjectRole?: ProjectMemberRole | null;
                  currentUserProjectTeamRole?: TeamMemberRole | null;
                  project: {
                    __typename?: 'Project';
                    id: string;
                    name: string;
                    icon?: string | null;
                    color: string;
                  };
                  members: Array<{
                    __typename?: 'TaskMember';
                    role: TaskMemberRole;
                    user: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                    };
                  }>;
                } | null;
              } | null> | null;
            };
          }
        | null;
    } | null> | null;
  };
};

export type ListNearbyMessagesQueryVariables = Exact<{
  messageId: Scalars['ID']['input'];
  nearbyCount?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListNearbyMessagesQuery = {
  __typename?: 'Query';
  listNearbyMessages?: {
    __typename?: 'MessageConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'MessageEdge';
      cursor: string;
      node?: {
        __typename?: 'Message';
        id: string;
        chatId: string;
        clientId: string;
        body?: string | null;
        createdAt: any;
        isSender: boolean;
        isDraft: boolean;
        publishedAt?: any | null;
        authorId: string;
        authorAvatarId?: string | null;
        authorName?: string | null;
        authorFirstName?: string | null;
        authorLastName?: string | null;
        authorEmail?: string | null;
        readAt?: any | null;
        isRetry: boolean;
        replyId?: string | null;
        readReceipts?: Array<{
          __typename?: 'User';
          id: string;
          email: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          phoneNumber: string;
          primaryTeamId?: string | null;
          createdAt: any;
          inviteUrl: string;
          avatarId?: string | null;
          avatarIsPreviewable?: boolean | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
          skills?: Array<{
            __typename?: 'Skill';
            id: string;
            name: string;
            createdAt: any;
          }> | null;
        }> | null;
        checkin?: {
          __typename?: 'MessageCheckin';
          id: string;
          address?: string | null;
          city?: string | null;
          zipcode?: string | null;
          state?: string | null;
          country?: string | null;
          latitude?: number | null;
          longitude?: number | null;
          withinGeofence: boolean;
        } | null;
        userRequest?: {
          __typename?: 'UserRequest';
          id: string;
          requestType: UserRequestCategory;
          status: string;
          canBeReviewed: boolean;
          expiredAt?: any | null;
          userRequestableId: string;
          userRequestableType: UserRequestable;
          invitedBy?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
          } | null;
          reviewedBy?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
          } | null;
          user?: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
          } | null;
        } | null;
        replyMessage?: {
          __typename?: 'Message';
          id: string;
          chatId: string;
          clientId: string;
          body?: string | null;
          deletedAt?: any | null;
          createdAt: any;
          isSender: boolean;
          isDraft: boolean;
          publishedAt?: any | null;
          authorId: string;
          authorAvatarId?: string | null;
          authorName?: string | null;
          authorFirstName?: string | null;
          authorLastName?: string | null;
          authorEmail?: string | null;
          attachments?: Array<
            | {
                __typename?: 'Document';
                id: string;
                name: string;
                contentType?: string | null;
                createdAt: any;
                size?: number | null;
                isImage: boolean;
                clientId: string;
                isAudio: boolean;
                duration?: number | null;
                file: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  url: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                };
                owner: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  createdAt: any;
                };
              }
            | { __typename?: 'EntityUser' }
            | { __typename?: 'Folder' }
            | { __typename?: 'LocalFile' }
            | { __typename?: 'Message' }
            | {
                __typename?: 'MessageProject';
                id: string;
                authorId: string;
                author?: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  avatar?: { __typename?: 'File'; id: string } | null;
                } | null;
                project?: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                  team?: {
                    __typename?: 'Team';
                    subscriptionDetails?: {
                      __typename?: 'SubscriptionDetails';
                      expirationDate?: any | null;
                      subscriptionStatus?: string | null;
                    } | null;
                  } | null;
                } | null;
              }
            | {
                __typename?: 'MessageTask';
                id: string;
                authorId: string;
                author?: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  avatar?: { __typename?: 'File'; id: string } | null;
                } | null;
                task?: {
                  __typename?: 'Task';
                  id: string;
                  projectId: string;
                  name: string;
                } | null;
              }
            | {
                __typename?: 'MessageTaskAssignment';
                id: string;
                messageId: string;
                assignees: Array<{
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  phoneNumber: string;
                  primaryTeamId?: string | null;
                  createdAt: any;
                  inviteUrl: string;
                  avatarId?: string | null;
                  avatarIsPreviewable?: boolean | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                  skills?: Array<{
                    __typename?: 'Skill';
                    id: string;
                    name: string;
                    createdAt: any;
                  }> | null;
                }>;
                task?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  deletedAt?: any | null;
                  completedAt?: any | null;
                } | null;
              }
            | {
                __typename?: 'MessageTaskComplete';
                id: string;
                messageId: string;
                completor?: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  avatar?: { __typename?: 'File'; id: string } | null;
                } | null;
              }
            | { __typename?: 'Project' }
            | { __typename?: 'ProjectUser' }
            | { __typename?: 'PublicTeam' }
            | { __typename?: 'Task' }
            | { __typename?: 'TaskUser' }
            | { __typename?: 'UserRequest' }
          > | null;
        } | null;
        attachments?: Array<
          | {
              __typename?: 'Document';
              id: string;
              blobId?: string | null;
              name: string;
              contentType?: string | null;
              createdAt: any;
              size?: number | null;
              isImage: boolean;
              clientId: string;
              isAudio: boolean;
              duration?: number | null;
              file: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                url: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              };
              owner: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                createdAt: any;
              };
              taskDocuments?: Array<{
                __typename?: 'TaskDocument';
                id: string;
                owner?: { __typename?: 'User'; id: string } | null;
                task?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  projectId: string;
                  project: { __typename?: 'Project'; id: string; name: string };
                } | null;
              }> | null;
              projectDocuments?: Array<{
                __typename?: 'ProjectDocument';
                id: string;
                owner?: { __typename?: 'User'; id: string } | null;
                project?: {
                  __typename?: 'Project';
                  id: string;
                  name: string;
                } | null;
              }> | null;
            }
          | { __typename?: 'EntityUser' }
          | { __typename?: 'Folder' }
          | { __typename?: 'LocalFile' }
          | { __typename?: 'Message' }
          | {
              __typename?: 'MessageProject';
              id: string;
              authorId: string;
              author?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: { __typename?: 'File'; id: string } | null;
              } | null;
              project?: {
                __typename?: 'Project';
                id: string;
                uuid: string;
                name: string;
                team?: {
                  __typename?: 'Team';
                  subscriptionDetails?: {
                    __typename?: 'SubscriptionDetails';
                    expirationDate?: any | null;
                    subscriptionStatus?: string | null;
                  } | null;
                } | null;
              } | null;
            }
          | {
              __typename?: 'MessageTask';
              id: string;
              authorId: string;
              author?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: { __typename?: 'File'; id: string } | null;
              } | null;
              task?: {
                __typename?: 'Task';
                id: string;
                projectId: string;
                deletedAt?: any | null;
                name: string;
                priority?: TaskPriority | null;
                dueDate?: any | null;
                members: Array<{
                  __typename?: 'TaskMember';
                  id: string;
                  role: TaskMemberRole;
                  user: {
                    __typename?: 'User';
                    id: string;
                    name?: string | null;
                    avatar?: { __typename?: 'File'; id: string } | null;
                  };
                }>;
              } | null;
            }
          | {
              __typename?: 'MessageTaskAssignment';
              id: string;
              messageId: string;
              assignees: Array<{
                __typename?: 'User';
                id: string;
                name?: string | null;
                firstName?: string | null;
                avatar?: { __typename?: 'File'; id: string } | null;
              }>;
              task?: {
                __typename?: 'Task';
                id: string;
                name: string;
                deletedAt?: any | null;
                completedAt?: any | null;
                currentUserRole?: TaskMemberRole | null;
              } | null;
            }
          | {
              __typename?: 'MessageTaskComplete';
              id: string;
              messageId: string;
              completor?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                avatar?: { __typename?: 'File'; id: string } | null;
              } | null;
            }
          | { __typename?: 'Project' }
          | { __typename?: 'ProjectUser' }
          | {
              __typename?: 'PublicTeam';
              uuid: string;
              name: string;
              hasPendingMemberAdditionRequest: boolean;
              avatarFile?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            }
          | { __typename?: 'Task' }
          | { __typename?: 'TaskUser' }
          | { __typename?: 'UserRequest' }
        > | null;
        reaction?: Array<{
          __typename?: 'MessageReaction';
          id: string;
          reaction: string;
          count: number;
          user?: Array<{
            __typename?: 'User';
            id: string;
            name?: string | null;
          }> | null;
        }> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListPendingUserRequestsQueryVariables = Exact<{
  attributes: UserRequestAttributes;
}>;

export type ListPendingUserRequestsQuery = {
  __typename?: 'Query';
  listPendingUserRequests: Array<{
    __typename?: 'UserRequest';
    id: string;
    requestType: UserRequestCategory;
    status: string;
    canCurrentUserDecide: boolean;
    createdAt: any;
    expiredAt?: any | null;
    role?: string | null;
    userRequestableId: string;
    userRequestableType: UserRequestable;
    invitedBy?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      email: string;
      phoneNumber: string;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    } | null;
    user?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      email: string;
      phoneNumber: string;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    } | null;
  }>;
};

export type ListProductsQueryVariables = Exact<{ [key: string]: never }>;

export type ListProductsQuery = {
  __typename?: 'Query';
  listProducts: Array<{
    __typename?: 'Product';
    id: string;
    name: string;
    allowMembers: boolean;
    features: any;
    prices: Array<{
      __typename?: 'Price';
      id: string;
      amount: number;
      externalId: string;
      interval: string;
      intervalCount: number;
    }>;
  }>;
};

export type ListProjectActivityFeedQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;

export type ListProjectActivityFeedQuery = {
  __typename?: 'Query';
  listActivitiesByProject?: {
    __typename?: 'AuditConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'AuditEdge';
      cursor: string;
      node?: {
        __typename?: 'Audit';
        event: string;
        createdAt: any;
        id: string;
        changes?: any | null;
        projectRole?: ProjectMemberRole | null;
        user?: {
          __typename?: 'User';
          id: string;
          email: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          phoneNumber: string;
          primaryTeamId?: string | null;
          createdAt: any;
          inviteUrl: string;
          avatarId?: string | null;
          avatarIsPreviewable?: boolean | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
          skills?: Array<{
            __typename?: 'Skill';
            id: string;
            name: string;
            createdAt: any;
          }> | null;
        } | null;
        documents: Array<{
          __typename?: 'Document';
          id: string;
          blobId?: string | null;
          name: string;
          contentType?: string | null;
          createdAt: any;
          size?: number | null;
          isImage: boolean;
          isVideo: boolean;
          clientId: string;
          isAudio: boolean;
          duration?: number | null;
          file: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          };
          owner: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            createdAt: any;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          };
        }>;
        attachment?:
          | {
              __typename?: 'Document';
              id: string;
              blobId?: string | null;
              name: string;
              contentType?: string | null;
              createdAt: any;
              size?: number | null;
              isImage: boolean;
              isVideo: boolean;
              clientId: string;
              isAudio: boolean;
              duration?: number | null;
              projectDocuments?: Array<{
                __typename?: 'ProjectDocument';
                id: string;
                project?: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                } | null;
              }> | null;
              taskDocuments?: Array<{
                __typename?: 'TaskDocument';
                id: string;
                task?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  projectId: string;
                  deletedAt?: any | null;
                  project: {
                    __typename?: 'Project';
                    id: string;
                    uuid: string;
                    name: string;
                  };
                } | null;
              }> | null;
              file: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              };
              owner: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                createdAt: any;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              };
            }
          | {
              __typename?: 'EntityUser';
              id: string;
              user?: {
                __typename?: 'User';
                id: string;
                email: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                phoneNumber: string;
                primaryTeamId?: string | null;
                createdAt: any;
                inviteUrl: string;
                avatarId?: string | null;
                avatarIsPreviewable?: boolean | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
                skills?: Array<{
                  __typename?: 'Skill';
                  id: string;
                  name: string;
                  createdAt: any;
                }> | null;
              } | null;
              entityTask?: {
                __typename?: 'Task';
                id: string;
                name: string;
                deletedAt?: any | null;
                members: Array<{
                  __typename?: 'TaskMember';
                  id: string;
                  role: TaskMemberRole;
                  user: {
                    __typename?: 'User';
                    id: string;
                    email: string;
                    name?: string | null;
                    firstName?: string | null;
                    lastName?: string | null;
                    phoneNumber: string;
                    primaryTeamId?: string | null;
                    createdAt: any;
                    inviteUrl: string;
                    avatarId?: string | null;
                    avatarIsPreviewable?: boolean | null;
                    avatar?: {
                      __typename?: 'File';
                      id: string;
                      cdnBaseUrl: string;
                      path: string;
                      isPreviewable: boolean;
                      thumbnail?: string | null;
                    } | null;
                    skills?: Array<{
                      __typename?: 'Skill';
                      id: string;
                      name: string;
                      createdAt: any;
                    }> | null;
                  };
                }>;
                project: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                };
              } | null;
              entityProject?: {
                __typename?: 'Project';
                id: string;
                uuid: string;
                name: string;
              } | null;
            }
          | { __typename?: 'Folder' }
          | { __typename?: 'LocalFile' }
          | {
              __typename?: 'Message';
              id: string;
              chatId: string;
              clientId: string;
              body?: string | null;
              createdAt: any;
              isSender: boolean;
              isDraft: boolean;
              publishedAt?: any | null;
              authorId: string;
              authorAvatarId?: string | null;
              authorName?: string | null;
              authorFirstName?: string | null;
              authorLastName?: string | null;
              authorEmail?: string | null;
              readAt?: any | null;
              isRetry: boolean;
              replyId?: string | null;
              readReceipts?: Array<{
                __typename?: 'User';
                id: string;
                email: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                phoneNumber: string;
                primaryTeamId?: string | null;
                createdAt: any;
                inviteUrl: string;
                avatarId?: string | null;
                avatarIsPreviewable?: boolean | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
                skills?: Array<{
                  __typename?: 'Skill';
                  id: string;
                  name: string;
                  createdAt: any;
                }> | null;
              }> | null;
              checkin?: {
                __typename?: 'MessageCheckin';
                id: string;
                address?: string | null;
                city?: string | null;
                zipcode?: string | null;
                state?: string | null;
                country?: string | null;
                latitude?: number | null;
                longitude?: number | null;
                withinGeofence: boolean;
              } | null;
              userRequest?: {
                __typename?: 'UserRequest';
                id: string;
                requestType: UserRequestCategory;
                status: string;
                canBeReviewed: boolean;
                expiredAt?: any | null;
                userRequestableId: string;
                userRequestableType: UserRequestable;
                invitedBy?: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  firstName?: string | null;
                } | null;
                reviewedBy?: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  firstName?: string | null;
                } | null;
                user?: {
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                } | null;
              } | null;
              replyMessage?: {
                __typename?: 'Message';
                id: string;
                chatId: string;
                clientId: string;
                body?: string | null;
                deletedAt?: any | null;
                createdAt: any;
                isSender: boolean;
                isDraft: boolean;
                publishedAt?: any | null;
                authorId: string;
                authorAvatarId?: string | null;
                authorName?: string | null;
                authorFirstName?: string | null;
                authorLastName?: string | null;
                authorEmail?: string | null;
                attachments?: Array<
                  | {
                      __typename?: 'Document';
                      id: string;
                      name: string;
                      contentType?: string | null;
                      createdAt: any;
                      size?: number | null;
                      isImage: boolean;
                      clientId: string;
                      isAudio: boolean;
                      duration?: number | null;
                      file: {
                        __typename?: 'File';
                        id: string;
                        url: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      };
                      owner: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        createdAt: any;
                      };
                    }
                  | { __typename?: 'EntityUser' }
                  | { __typename?: 'Folder' }
                  | { __typename?: 'LocalFile' }
                  | { __typename?: 'Message' }
                  | {
                      __typename?: 'MessageProject';
                      id: string;
                      authorId: string;
                      author?: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                      } | null;
                      project?: {
                        __typename?: 'Project';
                        id: string;
                        uuid: string;
                        name: string;
                        team?: {
                          __typename?: 'Team';
                          subscriptionDetails?: {
                            __typename?: 'SubscriptionDetails';
                            expirationDate?: any | null;
                            subscriptionStatus?: string | null;
                          } | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: 'MessageTask';
                      id: string;
                      authorId: string;
                      author?: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                      } | null;
                      task?: {
                        __typename?: 'Task';
                        id: string;
                        projectId: string;
                        name: string;
                      } | null;
                    }
                  | {
                      __typename?: 'MessageTaskAssignment';
                      id: string;
                      messageId: string;
                      assignees: Array<{
                        __typename?: 'User';
                        id: string;
                        email: string;
                        name?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        phoneNumber: string;
                        primaryTeamId?: string | null;
                        createdAt: any;
                        inviteUrl: string;
                        avatarId?: string | null;
                        avatarIsPreviewable?: boolean | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                        skills?: Array<{
                          __typename?: 'Skill';
                          id: string;
                          name: string;
                          createdAt: any;
                        }> | null;
                      }>;
                      task?: {
                        __typename?: 'Task';
                        id: string;
                        name: string;
                        deletedAt?: any | null;
                        completedAt?: any | null;
                      } | null;
                    }
                  | {
                      __typename?: 'MessageTaskComplete';
                      id: string;
                      messageId: string;
                      completor?: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                      } | null;
                    }
                  | { __typename?: 'Project' }
                  | { __typename?: 'ProjectUser' }
                  | { __typename?: 'PublicTeam' }
                  | { __typename?: 'Task' }
                  | { __typename?: 'TaskUser' }
                  | { __typename?: 'UserRequest' }
                > | null;
              } | null;
              attachments?: Array<
                | {
                    __typename?: 'Document';
                    id: string;
                    blobId?: string | null;
                    name: string;
                    contentType?: string | null;
                    createdAt: any;
                    size?: number | null;
                    isImage: boolean;
                    clientId: string;
                    isAudio: boolean;
                    duration?: number | null;
                    file: {
                      __typename?: 'File';
                      id: string;
                      url: string;
                      cdnBaseUrl: string;
                      path: string;
                      isPreviewable: boolean;
                      thumbnail?: string | null;
                    };
                    owner: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      firstName?: string | null;
                      lastName?: string | null;
                      createdAt: any;
                    };
                    taskDocuments?: Array<{
                      __typename?: 'TaskDocument';
                      id: string;
                      owner?: { __typename?: 'User'; id: string } | null;
                      task?: {
                        __typename?: 'Task';
                        id: string;
                        name: string;
                        projectId: string;
                        project: {
                          __typename?: 'Project';
                          id: string;
                          name: string;
                        };
                      } | null;
                    }> | null;
                    projectDocuments?: Array<{
                      __typename?: 'ProjectDocument';
                      id: string;
                      owner?: { __typename?: 'User'; id: string } | null;
                      project?: {
                        __typename?: 'Project';
                        id: string;
                        name: string;
                      } | null;
                    }> | null;
                  }
                | { __typename?: 'EntityUser' }
                | { __typename?: 'Folder' }
                | { __typename?: 'LocalFile' }
                | { __typename?: 'Message' }
                | {
                    __typename?: 'MessageProject';
                    id: string;
                    authorId: string;
                    author?: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                    } | null;
                    project?: {
                      __typename?: 'Project';
                      id: string;
                      uuid: string;
                      name: string;
                      team?: {
                        __typename?: 'Team';
                        subscriptionDetails?: {
                          __typename?: 'SubscriptionDetails';
                          expirationDate?: any | null;
                          subscriptionStatus?: string | null;
                        } | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: 'MessageTask';
                    id: string;
                    authorId: string;
                    author?: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                    } | null;
                    task?: {
                      __typename?: 'Task';
                      id: string;
                      projectId: string;
                      deletedAt?: any | null;
                      name: string;
                    } | null;
                  }
                | {
                    __typename?: 'MessageTaskAssignment';
                    id: string;
                    messageId: string;
                    assignees: Array<{
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                    }>;
                    task?: {
                      __typename?: 'Task';
                      id: string;
                      name: string;
                      deletedAt?: any | null;
                      completedAt?: any | null;
                      currentUserRole?: TaskMemberRole | null;
                    } | null;
                  }
                | {
                    __typename?: 'MessageTaskComplete';
                    id: string;
                    messageId: string;
                    completor?: {
                      __typename?: 'User';
                      id: string;
                      name?: string | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                    } | null;
                  }
                | { __typename?: 'Project' }
                | { __typename?: 'ProjectUser' }
                | { __typename?: 'PublicTeam' }
                | { __typename?: 'Task' }
                | { __typename?: 'TaskUser' }
                | { __typename?: 'UserRequest' }
              > | null;
              reaction?: Array<{
                __typename?: 'MessageReaction';
                id: string;
                reaction: string;
                count: number;
                user?: Array<{
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                }> | null;
              }> | null;
            }
          | { __typename?: 'MessageProject' }
          | { __typename?: 'MessageTask' }
          | { __typename?: 'MessageTaskAssignment' }
          | { __typename?: 'MessageTaskComplete' }
          | { __typename?: 'Project'; id: string; uuid: string; name: string }
          | {
              __typename?: 'ProjectUser';
              id: string;
              user?: {
                __typename?: 'User';
                id: string;
                email: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                phoneNumber: string;
                primaryTeamId?: string | null;
                createdAt: any;
                inviteUrl: string;
                avatarId?: string | null;
                avatarIsPreviewable?: boolean | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
                skills?: Array<{
                  __typename?: 'Skill';
                  id: string;
                  name: string;
                  createdAt: any;
                }> | null;
              } | null;
            }
          | { __typename?: 'PublicTeam' }
          | {
              __typename?: 'Task';
              id: string;
              name: string;
              projectId: string;
              deletedAt?: any | null;
              project: {
                __typename?: 'Project';
                id: string;
                uuid: string;
                name: string;
              };
            }
          | {
              __typename?: 'TaskUser';
              id: string;
              task: {
                __typename?: 'Task';
                id: string;
                name: string;
                deletedAt?: any | null;
                project: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                };
              };
              user?: {
                __typename?: 'User';
                id: string;
                email: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                phoneNumber: string;
                primaryTeamId?: string | null;
                createdAt: any;
                inviteUrl: string;
                avatarId?: string | null;
                avatarIsPreviewable?: boolean | null;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
                skills?: Array<{
                  __typename?: 'Skill';
                  id: string;
                  name: string;
                  createdAt: any;
                }> | null;
              } | null;
            }
          | {
              __typename?: 'UserRequest';
              id: string;
              status: string;
              userRequestableId: string;
              userRequestableType: UserRequestable;
              user?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
              } | null;
            }
          | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListProjectChecklistQueryVariables = Exact<{
  projectUUId: Scalars['ID']['input'];
}>;

export type ListProjectChecklistQuery = {
  __typename?: 'Query';
  listProjectChecklist: Array<{
    __typename?: 'ProjectChecklist';
    id: string;
    projectId: string;
    name: string;
    createdAt: any;
    completedAt?: any | null;
    sort?: number | null;
  }>;
};

export type ListProjectDocumentsQueryVariables = Exact<{
  projectIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  sortBy?: InputMaybe<DocumentSortOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  includeFiles?: InputMaybe<Scalars['Boolean']['input']>;
  includeMedia?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListProjectDocumentsQuery = {
  __typename?: 'Query';
  listProjectDocuments?: {
    __typename?: 'DocumentConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'DocumentEdge';
      cursor: string;
      node?: {
        __typename?: 'Document';
        id: string;
        name: string;
        contentType?: string | null;
        createdAt: any;
        size?: number | null;
        isImage: boolean;
        isVideo: boolean;
        clientId: string;
        owner: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        };
        file: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        };
        messageDocuments?: Array<{
          __typename?: 'MessageDocument';
          id: string;
          message?: {
            __typename?: 'Message';
            id: string;
            clientId: string;
            chatId: string;
          } | null;
        }> | null;
        projectDocuments?: Array<{
          __typename?: 'ProjectDocument';
          id: string;
          project?: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
          } | null;
        }> | null;
        taskDocuments?: Array<{
          __typename?: 'TaskDocument';
          id: string;
          task?: {
            __typename?: 'Task';
            id: string;
            name: string;
            projectId: string;
            project: {
              __typename?: 'Project';
              id: string;
              uuid: string;
              name: string;
            };
          } | null;
        }> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListProjectTagsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListProjectTagsQuery = {
  __typename?: 'Query';
  listProjects?: {
    __typename?: 'ProjectConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'ProjectEdge';
      cursor: string;
      node?: {
        __typename?: 'Project';
        id: string;
        name: string;
        usersCount: number;
        tasksCount: number;
        chatProjectsCount: number;
      } | null;
    } | null> | null;
  } | null;
};

export type ListProjectsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<ProjectSortOption>;
  role?: InputMaybe<ProjectMemberRole>;
  archivesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  locationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  filterTeamsProjects?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  memberIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  recentFirst?: InputMaybe<Scalars['Int']['input']>;
  includeRecent?: Scalars['Boolean']['input'];
}>;

export type ListProjectsQuery = {
  __typename?: 'Query';
  allProjects?: {
    __typename?: 'ProjectConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'ProjectEdge';
      cursor: string;
      node?: {
        __typename?: 'Project';
        id: string;
        uuid: string;
        name: string;
        initials: string;
        description?: string | null;
        address?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        archivedAt?: any | null;
        usersCount: number;
        tasksCount: number;
        currentUserRole?: ProjectMemberRole | null;
        teamId: string;
        color: string;
        icon?: string | null;
        createdAt: any;
        team?: {
          __typename?: 'Team';
          id: string;
          name: string;
          personal: boolean;
          avatarFile?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        } | null;
        creator: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            thumbnail?: string | null;
          } | null;
        };
        settings?: {
          __typename?: 'UserProjectSetting';
          id: string;
          pin: boolean;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  recentProjects?: {
    __typename?: 'ProjectConnection';
    edges?: Array<{
      __typename?: 'ProjectEdge';
      cursor: string;
      node?: {
        __typename?: 'Project';
        id: string;
        uuid: string;
        name: string;
        initials: string;
        description?: string | null;
        address?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        archivedAt?: any | null;
        usersCount: number;
        tasksCount: number;
        currentUserRole?: ProjectMemberRole | null;
        teamId: string;
        color: string;
        icon?: string | null;
        createdAt: any;
        team?: {
          __typename?: 'Team';
          id: string;
          name: string;
          personal: boolean;
          avatarFile?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        } | null;
        creator: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            thumbnail?: string | null;
          } | null;
        };
        settings?: {
          __typename?: 'UserProjectSetting';
          id: string;
          pin: boolean;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListProjectsBasicInfoQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<ProjectSortOption>;
  role?: InputMaybe<ProjectMemberRole>;
  archivesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  locationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  filterTeamsProjects?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListProjectsBasicInfoQuery = {
  __typename?: 'Query';
  listProjects?: {
    __typename?: 'ProjectConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'ProjectEdge';
      cursor: string;
      node?: {
        __typename?: 'Project';
        id: string;
        name: string;
        initials: string;
        teamId: string;
        color: string;
      } | null;
    } | null> | null;
  } | null;
};

export type ListProjectsBasicInfoForEditTaskQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<ProjectSortOption>;
  role?: InputMaybe<ProjectMemberRole>;
  archivesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  locationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  filterTeamsProjects?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListProjectsBasicInfoForEditTaskQuery = {
  __typename?: 'Query';
  listProjects?: {
    __typename?: 'ProjectConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'ProjectEdge';
      cursor: string;
      node?: {
        __typename?: 'Project';
        id: string;
        name: string;
        initials: string;
        teamId: string;
        color: string;
        currentUserRole?: ProjectMemberRole | null;
        currentUserTeamRole?: TeamMemberRole | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListProjectsByLocationQueryVariables = Exact<{
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
}>;

export type ListProjectsByLocationQuery = {
  __typename?: 'Query';
  listProjectsByLocation: Array<{
    __typename?: 'Project';
    id: string;
    uuid: string;
    name: string;
    initials: string;
    description?: string | null;
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    archivedAt?: any | null;
    color: string;
    icon?: string | null;
    team?: {
      __typename?: 'Team';
      avatar?: string | null;
      createdAt: any;
      id: string;
      uuid: string;
      name: string;
      personal: boolean;
      hasReachedMaxProjects: boolean;
      currentUserRole?: TeamRole | null;
      storageRemaining: any;
      users: Array<{
        __typename?: 'User';
        teamRoles?: Array<TeamRole> | null;
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      }>;
      owner: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
      subscriptionDetails?: {
        __typename?: 'SubscriptionDetails';
        expirationDate?: any | null;
        subscriptionInterval?: string | null;
        subscriptionPlanName?: string | null;
        subscriptionStatus?: string | null;
        isSubscriptionCanceled: boolean;
        isSubscriptionActive: boolean;
        isSubscriptionOnTrial: boolean;
        trialEndsAt?: any | null;
        updatedAt?: any | null;
      } | null;
    } | null;
  }>;
};

export type ListProjectsRecentQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ProjectSortOption>;
  role?: InputMaybe<ProjectMemberRole>;
}>;

export type ListProjectsRecentQuery = {
  __typename?: 'Query';
  listProjects?: {
    __typename?: 'ProjectConnection';
    edges?: Array<{
      __typename?: 'ProjectEdge';
      node?: {
        __typename?: 'Project';
        id: string;
        uuid: string;
        name: string;
        initials: string;
        description?: string | null;
        address?: string | null;
        color: string;
        icon?: string | null;
        createdAt: any;
        coverImage?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
          path: string;
        } | null;
        team?: {
          __typename?: 'Team';
          avatar?: string | null;
          id: string;
          name: string;
          personal: boolean;
        } | null;
        creator: {
          __typename?: 'User';
          id: string;
          email: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          phoneNumber: string;
          primaryTeamId?: string | null;
          createdAt: any;
          inviteUrl: string;
          avatarId?: string | null;
          avatarIsPreviewable?: boolean | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
          skills?: Array<{
            __typename?: 'Skill';
            id: string;
            name: string;
            createdAt: any;
          }> | null;
        };
      } | null;
    } | null> | null;
  } | null;
};

export type ListProjectsTasksQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  collaboratorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ListProjectsTasksQuery = {
  __typename?: 'Query';
  listProjectsTasks?: {
    __typename?: 'ProjectTaskConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'ProjectTaskEdge';
      cursor: string;
      node?: {
        __typename?: 'ProjectTask';
        id: string;
        uuid: string;
        name: string;
        archivedAt?: any | null;
        currentUserRole?: ProjectMemberRole | null;
        currentUserTeamRole?: TeamMemberRole | null;
        team?: {
          __typename?: 'Team';
          subscriptionDetails?: {
            __typename?: 'SubscriptionDetails';
            expirationDate?: any | null;
            subscriptionStatus?: string | null;
            isSubscriptionCanceled: boolean;
          } | null;
        } | null;
        members: Array<{
          __typename?: 'ProjectMember';
          user: { __typename?: 'User'; id: string };
        }>;
        tasks?: Array<{
          __typename?: 'Task';
          id: string;
          name: string;
          status?: TaskStatus | null;
          priority?: TaskPriority | null;
          deletedAt?: any | null;
          completedAt?: any | null;
          dueDate?: any | null;
          projectId: string;
          userIds: Array<string>;
          currentUserRole?: TaskMemberRole | null;
          project: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
            team?: {
              __typename?: 'Team';
              subscriptionDetails?: {
                __typename?: 'SubscriptionDetails';
                expirationDate?: any | null;
                subscriptionStatus?: string | null;
                isSubscriptionCanceled: boolean;
              } | null;
            } | null;
          };
          members: Array<{
            __typename?: 'TaskMember';
            id: string;
            role: TaskMemberRole;
            user: {
              __typename?: 'User';
              id: string;
              email: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              phoneNumber: string;
              primaryTeamId?: string | null;
              createdAt: any;
              inviteUrl: string;
              avatarId?: string | null;
              avatarIsPreviewable?: boolean | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
              skills?: Array<{
                __typename?: 'Skill';
                id: string;
                name: string;
                createdAt: any;
              }> | null;
            };
          }>;
        }> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListProjectsWithDocumentsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ListProjectsWithDocumentsQuery = {
  __typename?: 'Query';
  listProjectsWithDocuments: Array<{
    __typename?: 'Project';
    id: string;
    address?: string | null;
    name: string;
    initials: string;
    icon?: string | null;
    color: string;
    teamId: string;
    team?: {
      __typename?: 'Team';
      avatar?: string | null;
      createdAt: any;
      id: string;
      name: string;
      personal: boolean;
    } | null;
    tasks?: Array<{ __typename?: 'Task'; id: string; name: string }> | null;
  }>;
};

export type ListProjectsWithoutSpecifiedRolesQueryVariables = Exact<{
  roles: Array<ProjectMemberRole> | ProjectMemberRole;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ProjectSortOption>;
}>;

export type ListProjectsWithoutSpecifiedRolesQuery = {
  __typename?: 'Query';
  listProjectsWithoutSpecifiedRoles?: {
    __typename?: 'ProjectConnection';
    edges?: Array<{
      __typename?: 'ProjectEdge';
      cursor: string;
      node?: {
        __typename?: 'Project';
        id: string;
        name: string;
        members: Array<{
          __typename?: 'ProjectMember';
          user: { __typename?: 'User'; id: string };
        }>;
      } | null;
    } | null> | null;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
  } | null;
};

export type ListRecentProjectsTasksQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  collaboratorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListRecentProjectsTasksQuery = {
  __typename?: 'Query';
  listRecentProjectsTasks: Array<
    | {
        __typename?: 'Project';
        id: string;
        uuid: string;
        name: string;
        archivedAt?: any | null;
        createdAt: any;
        latitude?: number | null;
        longitude?: number | null;
        currentUserRole?: ProjectMemberRole | null;
        currentUserTeamRole?: TeamMemberRole | null;
        color: string;
        icon?: string | null;
        members: Array<{
          __typename?: 'ProjectMember';
          user: { __typename?: 'User'; id: string };
        }>;
        team?: {
          __typename?: 'Team';
          subscriptionDetails?: {
            __typename?: 'SubscriptionDetails';
            expirationDate?: any | null;
            subscriptionStatus?: string | null;
            isSubscriptionCanceled: boolean;
          } | null;
        } | null;
      }
    | {
        __typename?: 'Task';
        id: string;
        name: string;
        status?: TaskStatus | null;
        priority?: TaskPriority | null;
        completedAt?: any | null;
        deletedAt?: any | null;
        dueDate?: any | null;
        projectId: string;
        userIds: Array<string>;
        project: {
          __typename?: 'Project';
          id: string;
          uuid: string;
          name: string;
          latitude?: number | null;
          longitude?: number | null;
          color: string;
          icon?: string | null;
          team?: {
            __typename?: 'Team';
            subscriptionDetails?: {
              __typename?: 'SubscriptionDetails';
              expirationDate?: any | null;
              subscriptionInterval?: string | null;
              subscriptionPlanName?: string | null;
              subscriptionStatus?: string | null;
              isSubscriptionCanceled: boolean;
              trialEndsAt?: any | null;
              updatedAt?: any | null;
            } | null;
          } | null;
        };
        members: Array<{
          __typename?: 'TaskMember';
          id: string;
          user: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          };
        }>;
      }
  >;
};

export type ListRecentTasksQueryVariables = Exact<{
  projectIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  projectCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListRecentTasksQuery = {
  __typename?: 'Query';
  listRecentTasks: Array<{
    __typename?: 'RecentTask';
    id: string;
    name: string;
    members: Array<{
      __typename?: 'TaskMember';
      id: string;
      role: TaskMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    project: {
      __typename?: 'Project';
      id: string;
      uuid: string;
      name: string;
      color: string;
    };
  }>;
};

export type ListSkillsQueryVariables = Exact<{ [key: string]: never }>;

export type ListSkillsQuery = {
  __typename?: 'Query';
  listSkills: Array<{ __typename?: 'Skill'; id: string; name: string }>;
};

export type ListTagGroupsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListTagGroupsQuery = {
  __typename?: 'Query';
  listTagGroups: Array<{
    __typename?: 'TagGroup';
    id: string;
    isImageGroup: boolean;
    updatedAt: any;
    createdAt: any;
    author: { __typename?: 'User'; id: string; name?: string | null };
    project: { __typename?: 'Project'; id: string; uuid: string; name: string };
    task?: { __typename?: 'Task'; id: string; name: string } | null;
    documents?: Array<{
      __typename?: 'Document';
      id: string;
      name: string;
      contentType?: string | null;
      createdAt: any;
      size?: number | null;
      isImage: boolean;
      clientId: string;
      isAudio: boolean;
      duration?: number | null;
      file: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
        path: string;
      };
      projectDocuments?: Array<{
        __typename?: 'ProjectDocument';
        id: string;
        project?: {
          __typename?: 'Project';
          id: string;
          uuid: string;
          name: string;
        } | null;
      }> | null;
      taskDocuments?: Array<{
        __typename?: 'TaskDocument';
        id: string;
        task?: {
          __typename?: 'Task';
          id: string;
          name: string;
          projectId: string;
          project: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
          };
        } | null;
      }> | null;
    }> | null;
  }>;
};

export type ListTaskChecklistQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ListTaskChecklistQuery = {
  __typename?: 'Query';
  listTaskChecklist: Array<{
    __typename?: 'TaskChecklist';
    id: string;
    taskId: string;
    name: string;
    createdAt: any;
    completedAt?: any | null;
    sort?: number | null;
  }>;
};

export type ListTaskDocumentsQueryVariables = Exact<{
  projectIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  taskIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  sortBy?: InputMaybe<DocumentSortOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  includeFiles?: InputMaybe<Scalars['Boolean']['input']>;
  includeMedia?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListTaskDocumentsQuery = {
  __typename?: 'Query';
  listTaskDocuments?: {
    __typename?: 'DocumentConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'DocumentEdge';
      cursor: string;
      node?: {
        __typename?: 'Document';
        id: string;
        name: string;
        contentType?: string | null;
        createdAt: any;
        size?: number | null;
        isImage: boolean;
        isVideo: boolean;
        clientId: string;
        owner: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        };
        file: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        };
        messageDocuments?: Array<{
          __typename?: 'MessageDocument';
          id: string;
          message?: {
            __typename?: 'Message';
            id: string;
            clientId: string;
            chatId: string;
          } | null;
        }> | null;
        projectDocuments?: Array<{
          __typename?: 'ProjectDocument';
          id: string;
          project?: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
          } | null;
        }> | null;
        taskDocuments?: Array<{
          __typename?: 'TaskDocument';
          id: string;
          task?: {
            __typename?: 'Task';
            id: string;
            name: string;
            projectId: string;
            project: {
              __typename?: 'Project';
              id: string;
              uuid: string;
              name: string;
            };
          } | null;
        }> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListTaskTagsQueryVariables = Exact<{
  projectIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<TaskSortOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  collaboratorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  taskCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListTaskTagsQuery = {
  __typename?: 'Query';
  listTasks?: {
    __typename?: 'TaskConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'TaskEdge';
      cursor: string;
      node?: {
        __typename?: 'Task';
        id: string;
        userIds: Array<string>;
        projectId: string;
        name: string;
        status?: TaskStatus | null;
        priority?: TaskPriority | null;
        dueDate?: any | null;
        currentUserRole?: TaskMemberRole | null;
        currentUserProjectRole?: ProjectMemberRole | null;
        deletedAt?: any | null;
        completedAt?: any | null;
        project: {
          __typename?: 'Project';
          id: string;
          uuid: string;
          name: string;
          team?: {
            __typename?: 'Team';
            subscriptionDetails?: {
              __typename?: 'SubscriptionDetails';
              expirationDate?: any | null;
              subscriptionInterval?: string | null;
              subscriptionPlanName?: string | null;
              subscriptionStatus?: string | null;
              isSubscriptionCanceled: boolean;
              isSubscriptionActive: boolean;
              isSubscriptionOnTrial: boolean;
              trialEndsAt?: any | null;
              updatedAt?: any | null;
            } | null;
          } | null;
        };
        members: Array<{
          __typename?: 'TaskMember';
          id: string;
          role: TaskMemberRole;
          user: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          };
        }>;
      } | null;
    } | null> | null;
  } | null;
};

export type ListTasksQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  memberIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  projectIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<TaskSortOption>;
  status?: InputMaybe<TaskStatus>;
  dueGroup?: InputMaybe<TaskGroup>;
  dueDateBegin?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  dueDateEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  withoutPhase?: InputMaybe<Scalars['Boolean']['input']>;
  withoutDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  collaboratorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  taskCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Array<TaskPriority> | TaskPriority>;
}>;

export type ListTasksQuery = {
  __typename?: 'Query';
  listTasks?: {
    __typename?: 'TaskConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'TaskEdge';
      cursor: string;
      node?: {
        __typename?: 'Task';
        id: string;
        name: string;
        status?: TaskStatus | null;
        priority?: TaskPriority | null;
        startDate?: any | null;
        dueDate?: any | null;
        completedAt?: any | null;
        createdAt: any;
        phaseId?: string | null;
        projectId: string;
        deletedAt?: any | null;
        skillIds?: Array<string> | null;
        userIds: Array<string>;
        dueGroup?: string | null;
        fixedOrder?: boolean | null;
        recurring?: boolean | null;
        description?: string | null;
        frequency?: TaskFrequency | null;
        currentUserRole?: TaskMemberRole | null;
        currentUserProjectRole?: ProjectMemberRole | null;
        currentUserProjectTeamRole?: TeamMemberRole | null;
        dependencies?: Array<{
          __typename?: 'Task';
          id: string;
          name: string;
        }> | null;
        checklists?: Array<{
          __typename?: 'TaskChecklist';
          id: string;
          name: string;
          completedAt?: any | null;
          createdAt: any;
        }> | null;
        members: Array<{
          __typename?: 'TaskMember';
          id: string;
          role: TaskMemberRole;
          user: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          };
        }>;
        invitations?: Array<{
          __typename?: 'TaskInvitation';
          id: string;
          email: string;
          role: TaskMemberRole;
          expiredAt?: any | null;
        }> | null;
        userRequests?: Array<{
          __typename?: 'UserRequest';
          id: string;
          role?: string | null;
          expiredAt?: any | null;
          user?: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          } | null;
        }> | null;
        creator: {
          __typename?: 'User';
          id: string;
          email: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          phoneNumber: string;
          primaryTeamId?: string | null;
          createdAt: any;
          inviteUrl: string;
          avatarId?: string | null;
          avatarIsPreviewable?: boolean | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
          skills?: Array<{
            __typename?: 'Skill';
            id: string;
            name: string;
            createdAt: any;
          }> | null;
        };
        completor?: {
          __typename?: 'User';
          id: string;
          email: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          phoneNumber: string;
          primaryTeamId?: string | null;
          createdAt: any;
          inviteUrl: string;
          avatarId?: string | null;
          avatarIsPreviewable?: boolean | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
          skills?: Array<{
            __typename?: 'Skill';
            id: string;
            name: string;
            createdAt: any;
          }> | null;
        } | null;
        project: {
          __typename?: 'Project';
          id: string;
          uuid: string;
          name: string;
          color: string;
          icon?: string | null;
          currentUserTeamRole?: TeamMemberRole | null;
          currentUserRole?: ProjectMemberRole | null;
          initials: string;
          archivedAt?: any | null;
          team?: {
            __typename?: 'Team';
            avatar?: string | null;
            createdAt: any;
            id: string;
            name: string;
            personal: boolean;
          } | null;
        };
        phase?: { __typename?: 'Phase'; id: string; name: string } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListTasksLightQueryVariables = Exact<{
  projectIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  memberIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  priority?: InputMaybe<Array<TaskPriority> | TaskPriority>;
  sortBy?: InputMaybe<TaskSortOption>;
  dueDateBegin?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  dueDateEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  withoutDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  taskCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListTasksLightQuery = {
  __typename?: 'Query';
  listTasks?: {
    __typename?: 'TaskConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'TaskEdge';
      cursor: string;
      node?: {
        __typename?: 'Task';
        id: string;
        name: string;
        status?: TaskStatus | null;
        priority?: TaskPriority | null;
        startDate?: any | null;
        dueDate?: any | null;
        completedAt?: any | null;
        createdAt: any;
        projectId: string;
        currentUserRole?: TaskMemberRole | null;
        currentUserProjectRole?: ProjectMemberRole | null;
        currentUserProjectTeamRole?: TeamMemberRole | null;
        project: {
          __typename?: 'Project';
          id: string;
          name: string;
          icon?: string | null;
          color: string;
        };
        members: Array<{
          __typename?: 'TaskMember';
          role: TaskMemberRole;
          user: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          };
        }>;
      } | null;
    } | null> | null;
  } | null;
};

export type ListTasksNamesUnderProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListTasksNamesUnderProjectQuery = {
  __typename?: 'Query';
  listTasks?: {
    __typename?: 'TaskConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'TaskEdge';
      cursor: string;
      node?: { __typename?: 'Task'; id: string; name: string } | null;
    } | null> | null;
  } | null;
};

export type ListTeamInvoicesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ListTeamInvoicesQuery = {
  __typename?: 'Query';
  getTeam: {
    __typename?: 'Team';
    id: string;
    invoices?: Array<{
      __typename?: 'Invoice';
      amount: number;
      date: any;
      description: string;
      id: string;
      invoiceUrl: string;
      status: string;
    }> | null;
  };
};

export type ListTeamSubscriptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ListTeamSubscriptionsQuery = {
  __typename?: 'Query';
  listTeams: Array<{
    __typename?: 'Team';
    id: string;
    personal: boolean;
    subscriptionDetails?: {
      __typename?: 'SubscriptionDetails';
      expirationDate?: any | null;
      subscriptionStatus?: string | null;
      isSubscriptionCanceled: boolean;
      isSubscriptionActive: boolean;
      isSubscriptionOnTrial: boolean;
      paymentCardLast4?: string | null;
    } | null;
  }>;
};

export type ListTeamsQueryVariables = Exact<{
  role?: InputMaybe<ProjectMemberRole>;
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListTeamsQuery = {
  __typename?: 'Query';
  listTeams: Array<{
    __typename?: 'Team';
    id: string;
    uuid: string;
    avatar?: string | null;
    usersCount: number;
    personal: boolean;
    name: string;
    currentUserRole?: TeamRole | null;
    createdAt: any;
    hasReachedMaxProjects: boolean;
    hasProjects: boolean;
    numberOfProjectsUsed: number;
    maxNumberOfProjects: number;
    billingSource?: string | null;
    teamSubscriptionStatus?: string | null;
    entitlementExpiration?: any | null;
    avatarFile?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    owner: { __typename?: 'User'; id: string };
  }>;
};

export type ListTeamsProjectsQueryVariables = Exact<{
  role?: InputMaybe<ProjectMemberRole>;
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListTeamsProjectsQuery = {
  __typename?: 'Query';
  listTeams: Array<{
    __typename?: 'Team';
    id: string;
    name: string;
    personal: boolean;
    avatar?: string | null;
    avatarFile?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    projectPreviews: Array<{
      __typename?: 'Project';
      id: string;
      uuid: string;
      name: string;
      color: string;
      icon?: string | null;
      initials: string;
      address?: string | null;
      teamId: string;
      team?: {
        __typename?: 'Team';
        id: string;
        name: string;
        personal: boolean;
      } | null;
    }>;
  }>;
};

export type ListTeamsTasksCountQueryVariables = Exact<{ [key: string]: never }>;

export type ListTeamsTasksCountQuery = {
  __typename?: 'Query';
  listTeams: Array<{ __typename?: 'Team'; id: string; tasksCount: number }>;
};

export type ListTeamsUsersQueryVariables = Exact<{
  role?: InputMaybe<ProjectMemberRole>;
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListTeamsUsersQuery = {
  __typename?: 'Query';
  listTeams: Array<{
    __typename?: 'Team';
    id: string;
    uuid: string;
    name: string;
    personal: boolean;
    avatar?: string | null;
    usersCount: number;
    avatarFile?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    users: Array<{
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    }>;
  }>;
};

export type ListUsersQueryVariables = Exact<{
  term: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListUsersQuery = {
  __typename?: 'Query';
  listUsers: Array<{
    __typename?: 'User';
    id: string;
    name?: string | null;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    friendRequestPending?: boolean | null;
    avatar?: {
      __typename?: 'File';
      id: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
  }>;
};

export type ListUsersPaginationQueryVariables = Exact<{
  term: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListUsersPaginationQuery = {
  __typename?: 'Query';
  listUsersPagination?: {
    __typename?: 'UserConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'UserEdge';
      cursor: string;
      node?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        email: string;
        firstName?: string | null;
        lastName?: string | null;
        friendRequestPending?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type NewListDocumentsQueryVariables = Exact<{
  chatId?: InputMaybe<Scalars['ID']['input']>;
  includeMedia?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type NewListDocumentsQuery = {
  __typename?: 'Query';
  newListDocuments: {
    __typename?: 'DocumentCollection';
    metadata: {
      __typename?: 'CollectionMetadata';
      currentPage: number;
      limitValue: number;
      totalCount: number;
      totalPages: number;
    };
    collection: Array<{
      __typename?: 'Document';
      id: string;
      name: string;
      contentType?: string | null;
      createdAt: any;
      size?: number | null;
      isImage: boolean;
      isVideo: boolean;
      clientId: string;
      owner: { __typename?: 'User'; id: string; name?: string | null };
      file: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      };
      messageDocuments?: Array<{
        __typename?: 'MessageDocument';
        id: string;
        message?: {
          __typename?: 'Message';
          id: string;
          clientId: string;
          chatId: string;
        } | null;
      }> | null;
      projectDocuments?: Array<{
        __typename?: 'ProjectDocument';
        id: string;
        project?: {
          __typename?: 'Project';
          id: string;
          uuid: string;
          name: string;
        } | null;
      }> | null;
      taskDocuments?: Array<{
        __typename?: 'TaskDocument';
        id: string;
        task?: {
          __typename?: 'Task';
          id: string;
          name: string;
          projectId: string;
          project: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
          };
        } | null;
      }> | null;
    }>;
  };
};

export type SearchQueryVariables = Exact<{
  term: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  includeChats?: InputMaybe<Scalars['Boolean']['input']>;
  includeMessages?: InputMaybe<Scalars['Boolean']['input']>;
  includeProjects?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasks?: InputMaybe<Scalars['Boolean']['input']>;
  includeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  includeContacts?: InputMaybe<Scalars['Boolean']['input']>;
  includeCompletedTask?: InputMaybe<Scalars['Boolean']['input']>;
  includeTeams?: InputMaybe<Scalars['Boolean']['input']>;
  includeGroups?: InputMaybe<Scalars['Boolean']['input']>;
  includeUsers?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<Scalars['Boolean']['input']>;
  collaboratorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeActivities?: InputMaybe<Scalars['Boolean']['input']>;
  documentOwnerIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  archiveProjectsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  taskDueGroup?: InputMaybe<TaskGroup>;
  completedTasksOnly?: InputMaybe<Scalars['Boolean']['input']>;
  documentGroup?: InputMaybe<DocumentGroup>;
  projectOwnerIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  projectUserIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  taskUserIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  projectIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  taskPriority?: InputMaybe<Array<TaskPriority> | TaskPriority>;
  taskDueDateBegin?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  taskDueDateEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  taskSort?: InputMaybe<TaskSearchSortOption>;
}>;

export type SearchQuery = {
  __typename?: 'Query';
  search: Array<{
    __typename?: 'Search';
    total: number;
    highlight?: {
      __typename?: 'Highlight';
      authorName?: Array<string> | null;
      body?: Array<string> | null;
      chatName?: Array<string> | null;
      name?: Array<string> | null;
      projectNames?: Array<string> | null;
      taskNames?: Array<string> | null;
    } | null;
    record:
      | {
          __typename?: 'Audit';
          event: string;
          createdAt: any;
          id: string;
          user?: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          } | null;
          attachment?:
            | {
                __typename?: 'Document';
                id: string;
                blobId?: string | null;
                name: string;
                contentType?: string | null;
                createdAt: any;
                size?: number | null;
                isImage: boolean;
                isVideo: boolean;
                clientId: string;
                isAudio: boolean;
                duration?: number | null;
                file: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                };
                owner: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  createdAt: any;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                };
              }
            | {
                __typename?: 'EntityUser';
                id: string;
                user?: {
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  phoneNumber: string;
                  primaryTeamId?: string | null;
                  createdAt: any;
                  inviteUrl: string;
                  avatarId?: string | null;
                  avatarIsPreviewable?: boolean | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                  skills?: Array<{
                    __typename?: 'Skill';
                    id: string;
                    name: string;
                    createdAt: any;
                  }> | null;
                } | null;
                entityTask?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  deletedAt?: any | null;
                  members: Array<{
                    __typename?: 'TaskMember';
                    id: string;
                    role: TaskMemberRole;
                    user: {
                      __typename?: 'User';
                      id: string;
                      email: string;
                      name?: string | null;
                      firstName?: string | null;
                      lastName?: string | null;
                      phoneNumber: string;
                      primaryTeamId?: string | null;
                      createdAt: any;
                      inviteUrl: string;
                      avatarId?: string | null;
                      avatarIsPreviewable?: boolean | null;
                      avatar?: {
                        __typename?: 'File';
                        id: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      } | null;
                      skills?: Array<{
                        __typename?: 'Skill';
                        id: string;
                        name: string;
                        createdAt: any;
                      }> | null;
                    };
                  }>;
                  project: {
                    __typename?: 'Project';
                    id: string;
                    uuid: string;
                    name: string;
                  };
                } | null;
                entityProject?: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                } | null;
              }
            | { __typename?: 'Folder' }
            | { __typename?: 'LocalFile' }
            | {
                __typename?: 'Message';
                id: string;
                chatId: string;
                clientId: string;
                body?: string | null;
                createdAt: any;
                isSender: boolean;
                isDraft: boolean;
                publishedAt?: any | null;
                authorId: string;
                authorAvatarId?: string | null;
                authorName?: string | null;
                authorFirstName?: string | null;
                authorLastName?: string | null;
                authorEmail?: string | null;
                readAt?: any | null;
                isRetry: boolean;
                replyId?: string | null;
                readReceipts?: Array<{
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  phoneNumber: string;
                  primaryTeamId?: string | null;
                  createdAt: any;
                  inviteUrl: string;
                  avatarId?: string | null;
                  avatarIsPreviewable?: boolean | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                  skills?: Array<{
                    __typename?: 'Skill';
                    id: string;
                    name: string;
                    createdAt: any;
                  }> | null;
                }> | null;
                checkin?: {
                  __typename?: 'MessageCheckin';
                  id: string;
                  address?: string | null;
                  city?: string | null;
                  zipcode?: string | null;
                  state?: string | null;
                  country?: string | null;
                  latitude?: number | null;
                  longitude?: number | null;
                  withinGeofence: boolean;
                } | null;
                userRequest?: {
                  __typename?: 'UserRequest';
                  id: string;
                  requestType: UserRequestCategory;
                  status: string;
                  canBeReviewed: boolean;
                  expiredAt?: any | null;
                  userRequestableId: string;
                  userRequestableType: UserRequestable;
                  invitedBy?: {
                    __typename?: 'User';
                    id: string;
                    name?: string | null;
                    firstName?: string | null;
                  } | null;
                  reviewedBy?: {
                    __typename?: 'User';
                    id: string;
                    name?: string | null;
                    firstName?: string | null;
                  } | null;
                  user?: {
                    __typename?: 'User';
                    id: string;
                    email: string;
                    name?: string | null;
                  } | null;
                } | null;
                replyMessage?: {
                  __typename?: 'Message';
                  id: string;
                  chatId: string;
                  clientId: string;
                  body?: string | null;
                  deletedAt?: any | null;
                  createdAt: any;
                  isSender: boolean;
                  isDraft: boolean;
                  publishedAt?: any | null;
                  authorId: string;
                  authorAvatarId?: string | null;
                  authorName?: string | null;
                  authorFirstName?: string | null;
                  authorLastName?: string | null;
                  authorEmail?: string | null;
                  attachments?: Array<
                    | {
                        __typename?: 'Document';
                        id: string;
                        name: string;
                        contentType?: string | null;
                        createdAt: any;
                        size?: number | null;
                        isImage: boolean;
                        clientId: string;
                        isAudio: boolean;
                        duration?: number | null;
                        file: {
                          __typename?: 'File';
                          id: string;
                          url: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        };
                        owner: {
                          __typename?: 'User';
                          id: string;
                          name?: string | null;
                          firstName?: string | null;
                          lastName?: string | null;
                          createdAt: any;
                        };
                      }
                    | { __typename?: 'EntityUser' }
                    | { __typename?: 'Folder' }
                    | { __typename?: 'LocalFile' }
                    | { __typename?: 'Message' }
                    | {
                        __typename?: 'MessageProject';
                        id: string;
                        authorId: string;
                        author?: {
                          __typename?: 'User';
                          id: string;
                          name?: string | null;
                          avatar?: {
                            __typename?: 'File';
                            id: string;
                            cdnBaseUrl: string;
                            path: string;
                            isPreviewable: boolean;
                            thumbnail?: string | null;
                          } | null;
                        } | null;
                        project?: {
                          __typename?: 'Project';
                          id: string;
                          uuid: string;
                          name: string;
                          team?: {
                            __typename?: 'Team';
                            subscriptionDetails?: {
                              __typename?: 'SubscriptionDetails';
                              expirationDate?: any | null;
                              subscriptionStatus?: string | null;
                            } | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: 'MessageTask';
                        id: string;
                        authorId: string;
                        author?: {
                          __typename?: 'User';
                          id: string;
                          name?: string | null;
                          avatar?: {
                            __typename?: 'File';
                            id: string;
                            cdnBaseUrl: string;
                            path: string;
                            isPreviewable: boolean;
                            thumbnail?: string | null;
                          } | null;
                        } | null;
                        task?: {
                          __typename?: 'Task';
                          id: string;
                          projectId: string;
                          name: string;
                        } | null;
                      }
                    | {
                        __typename?: 'MessageTaskAssignment';
                        id: string;
                        messageId: string;
                        assignees: Array<{
                          __typename?: 'User';
                          id: string;
                          email: string;
                          name?: string | null;
                          firstName?: string | null;
                          lastName?: string | null;
                          phoneNumber: string;
                          primaryTeamId?: string | null;
                          createdAt: any;
                          inviteUrl: string;
                          avatarId?: string | null;
                          avatarIsPreviewable?: boolean | null;
                          avatar?: {
                            __typename?: 'File';
                            id: string;
                            cdnBaseUrl: string;
                            path: string;
                            isPreviewable: boolean;
                            thumbnail?: string | null;
                          } | null;
                          skills?: Array<{
                            __typename?: 'Skill';
                            id: string;
                            name: string;
                            createdAt: any;
                          }> | null;
                        }>;
                        task?: {
                          __typename?: 'Task';
                          id: string;
                          name: string;
                          deletedAt?: any | null;
                          completedAt?: any | null;
                        } | null;
                      }
                    | {
                        __typename?: 'MessageTaskComplete';
                        id: string;
                        messageId: string;
                        completor?: {
                          __typename?: 'User';
                          id: string;
                          name?: string | null;
                          avatar?: {
                            __typename?: 'File';
                            id: string;
                            cdnBaseUrl: string;
                            path: string;
                            isPreviewable: boolean;
                            thumbnail?: string | null;
                          } | null;
                        } | null;
                      }
                    | { __typename?: 'Project' }
                    | { __typename?: 'ProjectUser' }
                    | { __typename?: 'PublicTeam' }
                    | { __typename?: 'Task' }
                    | { __typename?: 'TaskUser' }
                    | { __typename?: 'UserRequest' }
                  > | null;
                } | null;
                attachments?: Array<
                  | {
                      __typename?: 'Document';
                      id: string;
                      blobId?: string | null;
                      name: string;
                      contentType?: string | null;
                      createdAt: any;
                      size?: number | null;
                      isImage: boolean;
                      clientId: string;
                      isAudio: boolean;
                      duration?: number | null;
                      file: {
                        __typename?: 'File';
                        id: string;
                        url: string;
                        cdnBaseUrl: string;
                        path: string;
                        isPreviewable: boolean;
                        thumbnail?: string | null;
                      };
                      owner: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        createdAt: any;
                      };
                      taskDocuments?: Array<{
                        __typename?: 'TaskDocument';
                        id: string;
                        owner?: { __typename?: 'User'; id: string } | null;
                        task?: {
                          __typename?: 'Task';
                          id: string;
                          name: string;
                          projectId: string;
                          project: {
                            __typename?: 'Project';
                            id: string;
                            name: string;
                          };
                        } | null;
                      }> | null;
                      projectDocuments?: Array<{
                        __typename?: 'ProjectDocument';
                        id: string;
                        owner?: { __typename?: 'User'; id: string } | null;
                        project?: {
                          __typename?: 'Project';
                          id: string;
                          name: string;
                        } | null;
                      }> | null;
                    }
                  | { __typename?: 'EntityUser' }
                  | { __typename?: 'Folder' }
                  | { __typename?: 'LocalFile' }
                  | { __typename?: 'Message' }
                  | {
                      __typename?: 'MessageProject';
                      id: string;
                      authorId: string;
                      author?: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                      } | null;
                      project?: {
                        __typename?: 'Project';
                        id: string;
                        uuid: string;
                        name: string;
                        team?: {
                          __typename?: 'Team';
                          subscriptionDetails?: {
                            __typename?: 'SubscriptionDetails';
                            expirationDate?: any | null;
                            subscriptionStatus?: string | null;
                          } | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: 'MessageTask';
                      id: string;
                      authorId: string;
                      author?: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                      } | null;
                      task?: {
                        __typename?: 'Task';
                        id: string;
                        projectId: string;
                        deletedAt?: any | null;
                        name: string;
                      } | null;
                    }
                  | {
                      __typename?: 'MessageTaskAssignment';
                      id: string;
                      messageId: string;
                      assignees: Array<{
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                      }>;
                      task?: {
                        __typename?: 'Task';
                        id: string;
                        name: string;
                        deletedAt?: any | null;
                        completedAt?: any | null;
                        currentUserRole?: TaskMemberRole | null;
                      } | null;
                    }
                  | {
                      __typename?: 'MessageTaskComplete';
                      id: string;
                      messageId: string;
                      completor?: {
                        __typename?: 'User';
                        id: string;
                        name?: string | null;
                        avatar?: {
                          __typename?: 'File';
                          id: string;
                          cdnBaseUrl: string;
                          path: string;
                          isPreviewable: boolean;
                          thumbnail?: string | null;
                        } | null;
                      } | null;
                    }
                  | { __typename?: 'Project' }
                  | { __typename?: 'ProjectUser' }
                  | { __typename?: 'PublicTeam' }
                  | { __typename?: 'Task' }
                  | { __typename?: 'TaskUser' }
                  | { __typename?: 'UserRequest' }
                > | null;
                reaction?: Array<{
                  __typename?: 'MessageReaction';
                  id: string;
                  reaction: string;
                  count: number;
                  user?: Array<{
                    __typename?: 'User';
                    id: string;
                    name?: string | null;
                  }> | null;
                }> | null;
              }
            | { __typename?: 'MessageProject' }
            | { __typename?: 'MessageTask' }
            | { __typename?: 'MessageTaskAssignment' }
            | { __typename?: 'MessageTaskComplete' }
            | { __typename?: 'Project'; id: string; uuid: string; name: string }
            | { __typename?: 'ProjectUser' }
            | { __typename?: 'PublicTeam' }
            | {
                __typename?: 'Task';
                id: string;
                name: string;
                projectId: string;
                deletedAt?: any | null;
                project: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  name: string;
                };
              }
            | {
                __typename?: 'TaskUser';
                id: string;
                task: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  project: {
                    __typename?: 'Project';
                    id: string;
                    uuid: string;
                    name: string;
                  };
                };
                user?: {
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  phoneNumber: string;
                  primaryTeamId?: string | null;
                  createdAt: any;
                  inviteUrl: string;
                  avatarId?: string | null;
                  avatarIsPreviewable?: boolean | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                  skills?: Array<{
                    __typename?: 'Skill';
                    id: string;
                    name: string;
                    createdAt: any;
                  }> | null;
                } | null;
              }
            | { __typename?: 'UserRequest' }
            | null;
        }
      | {
          __typename?: 'Chat';
          id: string;
          name: string;
          description?: string | null;
          avatarUrl?: string | null;
          isGroupChat: boolean;
          messageIcon?: string | null;
          messageBody?: string | null;
          recentActivityAt?: any | null;
          unreadCount?: number | null;
          createdAt: any;
          leaveOn?: any | null;
          isPendingRequest: boolean;
          canCurrentUserDecide: boolean;
          ownerId: string;
          userIds: Array<string>;
          settings?: {
            __typename?: 'UserChatSetting';
            id: string;
            pin: boolean;
            mute: boolean;
            archivedAt?: any | null;
          } | null;
          pendingInvitations: Array<{
            __typename?: 'ChatInvitation';
            email: string;
            expiredAt: any;
            id: string;
          }>;
          chatUsers: Array<{
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          }>;
          owner: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
          };
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        }
      | {
          __typename?: 'Document';
          id: string;
          name: string;
          contentType?: string | null;
          createdAt: any;
          size?: number | null;
          isImage: boolean;
          clientId: string;
          owner: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          };
          file: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          };
          messageDocuments?: Array<{
            __typename?: 'MessageDocument';
            id: string;
            message?: {
              __typename?: 'Message';
              id: string;
              clientId: string;
              authorId: string;
              chat: { __typename?: 'Chat'; id: string; name: string };
            } | null;
          }> | null;
          projectDocuments?: Array<{
            __typename?: 'ProjectDocument';
            id: string;
            project?: {
              __typename?: 'Project';
              id: string;
              uuid: string;
              name: string;
              team?: {
                __typename?: 'Team';
                avatar?: string | null;
                createdAt: any;
                id: string;
                name: string;
                personal: boolean;
              } | null;
            } | null;
          }> | null;
          taskDocuments?: Array<{
            __typename?: 'TaskDocument';
            id: string;
            task?: {
              __typename?: 'Task';
              id: string;
              name: string;
              projectId: string;
              project: {
                __typename?: 'Project';
                id: string;
                uuid: string;
                name: string;
              };
            } | null;
          }> | null;
        }
      | {
          __typename?: 'Group';
          id: string;
          name: string;
          users?: Array<{
            __typename?: 'User';
            id: string;
            name?: string | null;
            email: string;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          }> | null;
        }
      | {
          __typename?: 'Message';
          id: string;
          body?: string | null;
          publishedAt?: any | null;
          isSender: boolean;
          clientId: string;
          authorId: string;
          chatId: string;
          createdAt: any;
          isDraft: boolean;
          deletedAt?: any | null;
          authorAvatarId?: string | null;
          authorName?: string | null;
          authorFirstName?: string | null;
          authorLastName?: string | null;
          authorEmail?: string | null;
          author: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            email: string;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          };
          checkin?: {
            __typename?: 'MessageCheckin';
            id: string;
            address?: string | null;
            city?: string | null;
            zipcode?: string | null;
            state?: string | null;
            country?: string | null;
            latitude?: number | null;
            longitude?: number | null;
            withinGeofence: boolean;
          } | null;
          chat: {
            __typename?: 'Chat';
            id: string;
            name: string;
            description?: string | null;
            avatarUrl?: string | null;
            isGroupChat: boolean;
            messageIcon?: string | null;
            messageBody?: string | null;
            recentActivityAt?: any | null;
            unreadCount?: number | null;
            createdAt: any;
            leaveOn?: any | null;
            isPendingRequest: boolean;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            settings?: {
              __typename?: 'UserChatSetting';
              id: string;
              pin: boolean;
              mute: boolean;
              archivedAt?: any | null;
            } | null;
            users: Array<{
              __typename?: 'User';
              id: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            }>;
            pendingInvitations: Array<{
              __typename?: 'ChatInvitation';
              email: string;
              expiredAt: any;
              id: string;
            }>;
            userRequests: Array<{
              __typename?: 'UserRequest';
              id: string;
              status: string;
              expiredAt?: any | null;
              user?: {
                __typename?: 'User';
                id: string;
                name?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                email: string;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              } | null;
            }>;
            owner: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
            };
          };
          reaction?: Array<{
            __typename?: 'MessageReaction';
            id: string;
            reaction: string;
            count: number;
            user?: Array<{ __typename?: 'User'; id: string }> | null;
          }> | null;
          attachments?: Array<
            | {
                __typename?: 'Document';
                id: string;
                isImage: boolean;
                isAudio: boolean;
                clientId: string;
                duration?: number | null;
                name: string;
                createdAt: any;
                contentType?: string | null;
                blobId?: string | null;
                size?: number | null;
                isVideo: boolean;
                file: {
                  __typename?: 'File';
                  id: string;
                  url: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                };
                owner: {
                  __typename?: 'User';
                  id: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  createdAt: any;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                };
              }
            | { __typename?: 'EntityUser' }
            | { __typename?: 'Folder' }
            | { __typename?: 'LocalFile' }
            | { __typename?: 'Message' }
            | {
                __typename?: 'MessageProject';
                id: string;
                authorId: string;
                author?: {
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  phoneNumber: string;
                  primaryTeamId?: string | null;
                  createdAt: any;
                  inviteUrl: string;
                  avatarId?: string | null;
                  avatarIsPreviewable?: boolean | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                  skills?: Array<{
                    __typename?: 'Skill';
                    id: string;
                    name: string;
                    createdAt: any;
                  }> | null;
                } | null;
                project?: {
                  __typename?: 'Project';
                  id: string;
                  uuid: string;
                  initials: string;
                  name: string;
                  description?: string | null;
                  address?: string | null;
                  color: string;
                  createdAt: any;
                  creator: {
                    __typename?: 'User';
                    id: string;
                    email: string;
                    name?: string | null;
                    firstName?: string | null;
                    lastName?: string | null;
                    phoneNumber: string;
                    primaryTeamId?: string | null;
                    createdAt: any;
                    inviteUrl: string;
                    avatarId?: string | null;
                    avatarIsPreviewable?: boolean | null;
                    avatar?: {
                      __typename?: 'File';
                      id: string;
                      cdnBaseUrl: string;
                      path: string;
                      isPreviewable: boolean;
                      thumbnail?: string | null;
                    } | null;
                    skills?: Array<{
                      __typename?: 'Skill';
                      id: string;
                      name: string;
                      createdAt: any;
                    }> | null;
                  };
                  team?: {
                    __typename?: 'Team';
                    subscriptionDetails?: {
                      __typename?: 'SubscriptionDetails';
                      expirationDate?: any | null;
                      subscriptionStatus?: string | null;
                    } | null;
                  } | null;
                } | null;
              }
            | {
                __typename?: 'MessageTask';
                id: string;
                authorId: string;
                author?: {
                  __typename?: 'User';
                  id: string;
                  email: string;
                  name?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  phoneNumber: string;
                  primaryTeamId?: string | null;
                  createdAt: any;
                  inviteUrl: string;
                  avatarId?: string | null;
                  avatarIsPreviewable?: boolean | null;
                  avatar?: {
                    __typename?: 'File';
                    id: string;
                    cdnBaseUrl: string;
                    path: string;
                    isPreviewable: boolean;
                    thumbnail?: string | null;
                  } | null;
                  skills?: Array<{
                    __typename?: 'Skill';
                    id: string;
                    name: string;
                    createdAt: any;
                  }> | null;
                } | null;
                task?: {
                  __typename?: 'Task';
                  id: string;
                  name: string;
                  status?: TaskStatus | null;
                  priority?: TaskPriority | null;
                  dueDate?: any | null;
                  projectId: string;
                  userIds: Array<string>;
                  deletedAt?: any | null;
                  creator: {
                    __typename?: 'User';
                    id: string;
                    email: string;
                    name?: string | null;
                    firstName?: string | null;
                    lastName?: string | null;
                    phoneNumber: string;
                    primaryTeamId?: string | null;
                    createdAt: any;
                    inviteUrl: string;
                    avatarId?: string | null;
                    avatarIsPreviewable?: boolean | null;
                    avatar?: {
                      __typename?: 'File';
                      id: string;
                      cdnBaseUrl: string;
                      path: string;
                      isPreviewable: boolean;
                      thumbnail?: string | null;
                    } | null;
                    skills?: Array<{
                      __typename?: 'Skill';
                      id: string;
                      name: string;
                      createdAt: any;
                    }> | null;
                  };
                  project: {
                    __typename?: 'Project';
                    id: string;
                    uuid: string;
                    name: string;
                    color: string;
                  };
                } | null;
              }
            | { __typename?: 'MessageTaskAssignment' }
            | { __typename?: 'MessageTaskComplete' }
            | { __typename?: 'Project' }
            | { __typename?: 'ProjectUser' }
            | { __typename?: 'PublicTeam' }
            | { __typename?: 'Task' }
            | { __typename?: 'TaskUser' }
            | { __typename?: 'UserRequest' }
          > | null;
        }
      | {
          __typename?: 'Project';
          id: string;
          uuid: string;
          initials: string;
          name: string;
          description?: string | null;
          address?: string | null;
          color: string;
          createdAt: any;
          icon?: string | null;
          usersCount: number;
          team?: {
            __typename?: 'Team';
            avatar?: string | null;
            createdAt: any;
            id: string;
            name: string;
            personal: boolean;
            avatarFile?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
          creator: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          };
          memberPreviews: Array<{
            __typename?: 'ProjectMember';
            id: string;
            user: { __typename?: 'User'; id: string };
          }>;
        }
      | {
          __typename?: 'Task';
          id: string;
          name: string;
          description?: string | null;
          status?: TaskStatus | null;
          priority?: TaskPriority | null;
          dueDate?: any | null;
          projectId: string;
          userIds: Array<string>;
          completedAt?: any | null;
          deletedAt?: any | null;
          currentUserRole?: TaskMemberRole | null;
          currentUserProjectRole?: ProjectMemberRole | null;
          currentUserProjectTeamRole?: TeamMemberRole | null;
          creator: {
            __typename?: 'User';
            id: string;
            email: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            phoneNumber: string;
            primaryTeamId?: string | null;
            createdAt: any;
            inviteUrl: string;
            avatarId?: string | null;
            avatarIsPreviewable?: boolean | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
            skills?: Array<{
              __typename?: 'Skill';
              id: string;
              name: string;
              createdAt: any;
            }> | null;
          };
          members: Array<{
            __typename?: 'TaskMember';
            id: string;
            role: TaskMemberRole;
            user: {
              __typename?: 'User';
              id: string;
              email: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              phoneNumber: string;
              primaryTeamId?: string | null;
              createdAt: any;
              inviteUrl: string;
              avatarId?: string | null;
              avatarIsPreviewable?: boolean | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
              skills?: Array<{
                __typename?: 'Skill';
                id: string;
                name: string;
                createdAt: any;
              }> | null;
            };
          }>;
          project: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
            color: string;
            team?: {
              __typename?: 'Team';
              id: string;
              name: string;
              personal: boolean;
              avatarFile?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
          };
        }
      | { __typename?: 'Team' }
      | {
          __typename?: 'User';
          id: string;
          firstName?: string | null;
          lastName?: string | null;
          email: string;
          fullName?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        };
  }>;
};

export type SearchChatsQueryVariables = Exact<{
  term: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type SearchChatsQuery = {
  __typename?: 'Query';
  searchChats: {
    __typename?: 'ChatConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
    edges?: Array<{
      __typename?: 'ChatEdge';
      cursor: string;
      node?: {
        __typename?: 'Chat';
        id: string;
        name: string;
        isGroupChat: boolean;
        avatarUrl?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        users: Array<{
          __typename?: 'User';
          id: string;
          name?: string | null;
          avatar?: {
            __typename?: 'File';
            id: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          } | null;
        }>;
      } | null;
    } | null> | null;
  };
};

export type SearchTagsQueryVariables = Exact<{
  term: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  includeChats?: InputMaybe<Scalars['Boolean']['input']>;
  includeMessages?: InputMaybe<Scalars['Boolean']['input']>;
  includeProjects?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasks?: InputMaybe<Scalars['Boolean']['input']>;
  includeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  includeContacts?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<Scalars['Boolean']['input']>;
  collaboratorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasksTags?: InputMaybe<Scalars['Boolean']['input']>;
  includeCompletedTask?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SearchTagsQuery = {
  __typename?: 'Query';
  search: Array<{
    __typename?: 'Search';
    total: number;
    highlight?: {
      __typename?: 'Highlight';
      authorName?: Array<string> | null;
      name?: Array<string> | null;
      projectNames?: Array<string> | null;
      taskNames?: Array<string> | null;
    } | null;
    record:
      | { __typename?: 'Audit' }
      | { __typename?: 'Chat' }
      | { __typename?: 'Document' }
      | { __typename?: 'Group' }
      | { __typename?: 'Message' }
      | {
          __typename?: 'Project';
          id: string;
          uuid: string;
          name: string;
          createdAt: any;
          currentUserRole?: ProjectMemberRole | null;
          currentUserTeamRole?: TeamMemberRole | null;
          team?: {
            __typename?: 'Team';
            subscriptionDetails?: {
              __typename?: 'SubscriptionDetails';
              expirationDate?: any | null;
              subscriptionInterval?: string | null;
              subscriptionPlanName?: string | null;
              subscriptionStatus?: string | null;
              isSubscriptionCanceled: boolean;
              isSubscriptionActive: boolean;
              isSubscriptionOnTrial: boolean;
              trialEndsAt?: any | null;
              updatedAt?: any | null;
            } | null;
          } | null;
          members: Array<{
            __typename?: 'ProjectMember';
            user: { __typename?: 'User'; id: string };
          }>;
          tasksTagList?: Array<{
            __typename?: 'Task';
            id: string;
            name: string;
            status?: TaskStatus | null;
            dueDate?: any | null;
            priority?: TaskPriority | null;
            projectId: string;
            deletedAt?: any | null;
            userIds: Array<string>;
            completedAt?: any | null;
            currentUserRole?: TaskMemberRole | null;
            currentUserProjectRole?: ProjectMemberRole | null;
            members: Array<{
              __typename?: 'TaskMember';
              id: string;
              role: TaskMemberRole;
              user: {
                __typename?: 'User';
                id: string;
                firstName?: string | null;
                lastName?: string | null;
                email: string;
                name?: string | null;
                phoneNumber: string;
                createdAt: any;
                avatar?: {
                  __typename?: 'File';
                  id: string;
                  cdnBaseUrl: string;
                  path: string;
                  isPreviewable: boolean;
                  thumbnail?: string | null;
                } | null;
              };
            }>;
            project: {
              __typename?: 'Project';
              id: string;
              uuid: string;
              name: string;
              team?: {
                __typename?: 'Team';
                subscriptionDetails?: {
                  __typename?: 'SubscriptionDetails';
                  expirationDate?: any | null;
                  subscriptionInterval?: string | null;
                  subscriptionPlanName?: string | null;
                  subscriptionStatus?: string | null;
                  isSubscriptionCanceled: boolean;
                  isSubscriptionActive: boolean;
                  isSubscriptionOnTrial: boolean;
                  trialEndsAt?: any | null;
                  updatedAt?: any | null;
                } | null;
              } | null;
            };
          }> | null;
        }
      | { __typename?: 'Task' }
      | { __typename?: 'Team' }
      | { __typename?: 'User' };
  }>;
};

export type SearchTemplatesQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;

export type SearchTemplatesQuery = {
  __typename?: 'Query';
  searchTemplates: Array<{
    __typename?: 'ChecklistTemplate';
    id: string;
    isFavorited: boolean;
    favoritedAt?: any | null;
    templateName: string;
    checklistTemplateItems: Array<{
      __typename?: 'ChecklistTemplateItem';
      id: string;
      checklistTemplateItemName: string;
    }>;
  }>;
};

export type SharedDocumentsByClientIdsQueryVariables = Exact<{
  clientIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
}>;

export type SharedDocumentsByClientIdsQuery = {
  __typename?: 'Query';
  sharedDocumentsByClientIds?: Array<{
    __typename?: 'Document';
    clientId: string;
    file: {
      __typename?: 'File';
      id: string;
      url: string;
      thumbnail?: string | null;
    };
  }> | null;
};

export type SharedMediaByTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type SharedMediaByTokenQuery = {
  __typename?: 'Query';
  sharedMediaByToken: {
    __typename?: 'SharedMedia';
    sharerName?: string | null;
    sharerAvatar?: {
      __typename?: 'File';
      id: string;
      url: string;
      thumbnail?: string | null;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
    } | null;
    documents: Array<{
      __typename?: 'SharedDocument';
      clientId: string;
      name: string;
      file: {
        __typename?: 'File';
        id: string;
        url: string;
        thumbnail?: string | null;
      };
    }>;
  };
};

export type TeamAvatarsByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type TeamAvatarsByIdsQuery = {
  __typename?: 'Query';
  teamAvatarsByIds?: Array<{
    __typename?: 'File';
    id: string;
    thumbnail?: string | null;
    url: string;
  }> | null;
};

export type TeamAvatarsThumbnailByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type TeamAvatarsThumbnailByIdsQuery = {
  __typename?: 'Query';
  teamAvatarsByIds?: Array<{
    __typename?: 'File';
    id: string;
    thumbnail?: string | null;
  }> | null;
};

export type UserAvatarsByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type UserAvatarsByIdsQuery = {
  __typename?: 'Query';
  userAvatarsByIds?: Array<{
    __typename?: 'File';
    id: string;
    thumbnail?: string | null;
    url: string;
  }> | null;
};

export type UserAvatarsThumbnailByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type UserAvatarsThumbnailByIdsQuery = {
  __typename?: 'Query';
  userAvatarsByIds?: Array<{
    __typename?: 'File';
    id: string;
    thumbnail?: string | null;
  }> | null;
};

export type ValidateContentTypeQueryVariables = Exact<{
  contentType: Scalars['String']['input'];
}>;

export type ValidateContentTypeQuery = {
  __typename?: 'Query';
  validateContentType: boolean;
};

export type ChatUpdateSubscriptionVariables = Exact<{ [key: string]: never }>;

export type ChatUpdateSubscription = {
  __typename?: 'Subscription';
  chatUpdate?: {
    __typename?: 'ChatUpdate';
    id: string;
    name: string;
    messageBody?: string | null;
    recentActivityAt?: any | null;
    unreadCount?: number | null;
  } | null;
};

export type MeUpdatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type MeUpdatedSubscription = {
  __typename?: 'Subscription';
  meUpdated: {
    __typename?: 'MeUpdatedPayload';
    profile?: {
      __typename?: 'Profile';
      address?: string | null;
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      userActiveTasksCount: number;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
      teams?: Array<{
        __typename?: 'Team';
        id: string;
        uuid: string;
        name: string;
        usersCount: number;
        users: Array<{ __typename?: 'User'; id: string; name?: string | null }>;
      }> | null;
    } | null;
    chats?: Array<{
      __typename?: 'Chat';
      id: string;
      unreadCount?: number | null;
      settings?: {
        __typename?: 'UserChatSetting';
        id: string;
        mute: boolean;
        pin: boolean;
      } | null;
    }> | null;
  };
};

export type MessageDeleteSubscriptionVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;

export type MessageDeleteSubscription = {
  __typename?: 'Subscription';
  messageDelete?: {
    __typename?: 'Message';
    id: string;
    chatId: string;
    clientId: string;
    body?: string | null;
    createdAt: any;
    isSender: boolean;
    isDraft: boolean;
    publishedAt?: any | null;
    authorId: string;
    authorAvatarId?: string | null;
    authorName?: string | null;
    authorFirstName?: string | null;
    authorLastName?: string | null;
    authorEmail?: string | null;
    readAt?: any | null;
    isRetry: boolean;
    replyId?: string | null;
    readReceipts?: Array<{
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    }> | null;
    checkin?: {
      __typename?: 'MessageCheckin';
      id: string;
      address?: string | null;
      city?: string | null;
      zipcode?: string | null;
      state?: string | null;
      country?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      withinGeofence: boolean;
    } | null;
    userRequest?: {
      __typename?: 'UserRequest';
      id: string;
      requestType: UserRequestCategory;
      status: string;
      canBeReviewed: boolean;
      expiredAt?: any | null;
      userRequestableId: string;
      userRequestableType: UserRequestable;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
      } | null;
      reviewedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
      } | null;
    } | null;
    replyMessage?: {
      __typename?: 'Message';
      id: string;
      chatId: string;
      clientId: string;
      body?: string | null;
      deletedAt?: any | null;
      createdAt: any;
      isSender: boolean;
      isDraft: boolean;
      publishedAt?: any | null;
      authorId: string;
      authorAvatarId?: string | null;
      authorName?: string | null;
      authorFirstName?: string | null;
      authorLastName?: string | null;
      authorEmail?: string | null;
      attachments?: Array<
        | {
            __typename?: 'Document';
            id: string;
            name: string;
            contentType?: string | null;
            createdAt: any;
            size?: number | null;
            isImage: boolean;
            clientId: string;
            isAudio: boolean;
            duration?: number | null;
            file: {
              __typename?: 'File';
              id: string;
              url: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            };
            owner: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              createdAt: any;
            };
          }
        | { __typename?: 'EntityUser' }
        | { __typename?: 'Folder' }
        | { __typename?: 'LocalFile' }
        | { __typename?: 'Message' }
        | {
            __typename?: 'MessageProject';
            id: string;
            authorId: string;
            author?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
            project?: {
              __typename?: 'Project';
              id: string;
              uuid: string;
              name: string;
              team?: {
                __typename?: 'Team';
                subscriptionDetails?: {
                  __typename?: 'SubscriptionDetails';
                  expirationDate?: any | null;
                  subscriptionStatus?: string | null;
                } | null;
              } | null;
            } | null;
          }
        | {
            __typename?: 'MessageTask';
            id: string;
            authorId: string;
            author?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
            task?: {
              __typename?: 'Task';
              id: string;
              projectId: string;
              name: string;
            } | null;
          }
        | {
            __typename?: 'MessageTaskAssignment';
            id: string;
            messageId: string;
            assignees: Array<{
              __typename?: 'User';
              id: string;
              email: string;
              name?: string | null;
              firstName?: string | null;
              lastName?: string | null;
              phoneNumber: string;
              primaryTeamId?: string | null;
              createdAt: any;
              inviteUrl: string;
              avatarId?: string | null;
              avatarIsPreviewable?: boolean | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
              skills?: Array<{
                __typename?: 'Skill';
                id: string;
                name: string;
                createdAt: any;
              }> | null;
            }>;
            task?: {
              __typename?: 'Task';
              id: string;
              name: string;
              deletedAt?: any | null;
              completedAt?: any | null;
            } | null;
          }
        | {
            __typename?: 'MessageTaskComplete';
            id: string;
            messageId: string;
            completor?: {
              __typename?: 'User';
              id: string;
              name?: string | null;
              avatar?: {
                __typename?: 'File';
                id: string;
                cdnBaseUrl: string;
                path: string;
                isPreviewable: boolean;
                thumbnail?: string | null;
              } | null;
            } | null;
          }
        | { __typename?: 'Project' }
        | { __typename?: 'ProjectUser' }
        | { __typename?: 'PublicTeam' }
        | { __typename?: 'Task' }
        | { __typename?: 'TaskUser' }
        | { __typename?: 'UserRequest' }
      > | null;
    } | null;
    attachments?: Array<
      | {
          __typename?: 'Document';
          id: string;
          blobId?: string | null;
          name: string;
          contentType?: string | null;
          createdAt: any;
          size?: number | null;
          isImage: boolean;
          clientId: string;
          isAudio: boolean;
          duration?: number | null;
          file: {
            __typename?: 'File';
            id: string;
            url: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          };
          owner: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            createdAt: any;
          };
          taskDocuments?: Array<{
            __typename?: 'TaskDocument';
            id: string;
            owner?: { __typename?: 'User'; id: string } | null;
            task?: {
              __typename?: 'Task';
              id: string;
              name: string;
              projectId: string;
              project: { __typename?: 'Project'; id: string; name: string };
            } | null;
          }> | null;
          projectDocuments?: Array<{
            __typename?: 'ProjectDocument';
            id: string;
            owner?: { __typename?: 'User'; id: string } | null;
            project?: {
              __typename?: 'Project';
              id: string;
              name: string;
            } | null;
          }> | null;
        }
      | { __typename?: 'EntityUser' }
      | { __typename?: 'Folder' }
      | { __typename?: 'LocalFile' }
      | { __typename?: 'Message' }
      | {
          __typename?: 'MessageProject';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
          project?: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
            team?: {
              __typename?: 'Team';
              subscriptionDetails?: {
                __typename?: 'SubscriptionDetails';
                expirationDate?: any | null;
                subscriptionStatus?: string | null;
              } | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'MessageTask';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
          task?: {
            __typename?: 'Task';
            id: string;
            projectId: string;
            deletedAt?: any | null;
            name: string;
          } | null;
        }
      | {
          __typename?: 'MessageTaskAssignment';
          id: string;
          messageId: string;
          assignees: Array<{
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          }>;
          task?: {
            __typename?: 'Task';
            id: string;
            name: string;
            deletedAt?: any | null;
            completedAt?: any | null;
            currentUserRole?: TaskMemberRole | null;
          } | null;
        }
      | {
          __typename?: 'MessageTaskComplete';
          id: string;
          messageId: string;
          completor?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
        }
      | { __typename?: 'Project' }
      | { __typename?: 'ProjectUser' }
      | { __typename?: 'PublicTeam' }
      | { __typename?: 'Task' }
      | { __typename?: 'TaskUser' }
      | { __typename?: 'UserRequest' }
    > | null;
    reaction?: Array<{
      __typename?: 'MessageReaction';
      id: string;
      reaction: string;
      count: number;
      user?: Array<{
        __typename?: 'User';
        id: string;
        name?: string | null;
      }> | null;
    }> | null;
  } | null;
};

export type MessageUpdateSubscriptionVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;

export type MessageUpdateSubscription = {
  __typename?: 'Subscription';
  messageUpdate?: {
    __typename?: 'Message';
    id: string;
    chatId: string;
    clientId: string;
    body?: string | null;
    createdAt: any;
    isSender: boolean;
    isDraft: boolean;
    publishedAt?: any | null;
    authorId: string;
    authorAvatarId?: string | null;
    authorName?: string | null;
    authorFirstName?: string | null;
    authorLastName?: string | null;
    authorEmail?: string | null;
    readAt?: any | null;
    isRetry: boolean;
    replyId?: string | null;
    readReceipts?: Array<{
      __typename?: 'User';
      id: string;
      name?: string | null;
    }> | null;
    checkin?: {
      __typename?: 'MessageCheckin';
      id: string;
      address?: string | null;
      city?: string | null;
      zipcode?: string | null;
      state?: string | null;
      country?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      withinGeofence: boolean;
    } | null;
    userRequest?: {
      __typename?: 'UserRequest';
      id: string;
      requestType: UserRequestCategory;
      status: string;
      canBeReviewed: boolean;
      expiredAt?: any | null;
      userRequestableId: string;
      userRequestableType: UserRequestable;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
      } | null;
      reviewedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
      } | null;
    } | null;
    replyMessage?: {
      __typename?: 'Message';
      id: string;
      chatId: string;
      clientId: string;
      body?: string | null;
      deletedAt?: any | null;
      createdAt: any;
      isSender: boolean;
      isDraft: boolean;
      publishedAt?: any | null;
      authorId: string;
      authorAvatarId?: string | null;
      authorName?: string | null;
      authorFirstName?: string | null;
      authorLastName?: string | null;
      authorEmail?: string | null;
    } | null;
    attachments?: Array<
      | {
          __typename?: 'Document';
          id: string;
          blobId?: string | null;
          name: string;
          contentType?: string | null;
          createdAt: any;
          size?: number | null;
          isImage: boolean;
          clientId: string;
          isAudio: boolean;
          duration?: number | null;
          file: {
            __typename?: 'File';
            id: string;
            url: string;
            cdnBaseUrl: string;
            path: string;
            isPreviewable: boolean;
            thumbnail?: string | null;
          };
          owner: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            createdAt: any;
          };
          taskDocuments?: Array<{
            __typename?: 'TaskDocument';
            id: string;
            owner?: { __typename?: 'User'; id: string } | null;
            task?: {
              __typename?: 'Task';
              id: string;
              name: string;
              projectId: string;
              project: { __typename?: 'Project'; id: string; name: string };
            } | null;
          }> | null;
          projectDocuments?: Array<{
            __typename?: 'ProjectDocument';
            id: string;
            owner?: { __typename?: 'User'; id: string } | null;
            project?: {
              __typename?: 'Project';
              id: string;
              name: string;
            } | null;
          }> | null;
        }
      | { __typename?: 'EntityUser' }
      | { __typename?: 'Folder' }
      | { __typename?: 'LocalFile' }
      | { __typename?: 'Message' }
      | {
          __typename?: 'MessageProject';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
          project?: {
            __typename?: 'Project';
            id: string;
            uuid: string;
            name: string;
            team?: {
              __typename?: 'Team';
              subscriptionDetails?: {
                __typename?: 'SubscriptionDetails';
                expirationDate?: any | null;
                subscriptionStatus?: string | null;
              } | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'MessageTask';
          id: string;
          authorId: string;
          author?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
          task?: {
            __typename?: 'Task';
            id: string;
            projectId: string;
            deletedAt?: any | null;
            name: string;
          } | null;
        }
      | {
          __typename?: 'MessageTaskAssignment';
          id: string;
          messageId: string;
          assignees: Array<{
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          }>;
          task?: {
            __typename?: 'Task';
            id: string;
            name: string;
            deletedAt?: any | null;
            completedAt?: any | null;
            currentUserRole?: TaskMemberRole | null;
          } | null;
        }
      | {
          __typename?: 'MessageTaskComplete';
          id: string;
          messageId: string;
          completor?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            avatar?: {
              __typename?: 'File';
              id: string;
              cdnBaseUrl: string;
              path: string;
              isPreviewable: boolean;
              thumbnail?: string | null;
            } | null;
          } | null;
        }
      | { __typename?: 'Project' }
      | { __typename?: 'ProjectUser' }
      | { __typename?: 'PublicTeam' }
      | { __typename?: 'Task' }
      | { __typename?: 'TaskUser' }
      | { __typename?: 'UserRequest' }
    > | null;
    reaction?: Array<{
      __typename?: 'MessageReaction';
      id: string;
      reaction: string;
      count: number;
      user?: Array<{
        __typename?: 'User';
        id: string;
        name?: string | null;
      }> | null;
    }> | null;
  } | null;
};

export type ProjectListNodeUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ProjectListNodeUpdatedSubscription = {
  __typename?: 'Subscription';
  projectUpdated?: {
    __typename?: 'Project';
    id: string;
    uuid: string;
    name: string;
    initials: string;
    description?: string | null;
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    archivedAt?: any | null;
    usersCount: number;
    tasksCount: number;
    currentUserRole?: ProjectMemberRole | null;
    teamId: string;
    color: string;
    icon?: string | null;
    createdAt: any;
    team?: {
      __typename?: 'Team';
      id: string;
      name: string;
      personal: boolean;
      avatarFile?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
    } | null;
    creator: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName?: string | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        thumbnail?: string | null;
      } | null;
    };
    settings?: {
      __typename?: 'UserProjectSetting';
      id: string;
      pin: boolean;
    } | null;
  } | null;
};

export type ProjectUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ProjectUpdatedSubscription = {
  __typename?: 'Subscription';
  projectUpdated?: {
    __typename?: 'Project';
    address?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    archivedAt?: any | null;
    usersCount: number;
    tasksCount: number;
    currentUserRole?: ProjectMemberRole | null;
    currentUserTeamRole?: TeamMemberRole | null;
    currentUserHasPendingMemberAdditionRequest: boolean;
    isTaskMember: boolean;
    teamId: string;
    color: string;
    icon?: string | null;
    createdAt: any;
    description?: string | null;
    id: string;
    uuid: string;
    initials: string;
    name: string;
    unreadAuditsCount?: number | null;
    activeTasksCount: number;
    upcomingTasksCount: number;
    overdueTasksCount: number;
    completedTasksCount: number;
    completedChecklistCount: number;
    creator: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    coverImage?: {
      __typename?: 'File';
      id: string;
      url: string;
      cdnBaseUrl: string;
      path: string;
      isPreviewable: boolean;
      thumbnail?: string | null;
    } | null;
    team?: {
      __typename?: 'Team';
      avatar?: string | null;
      createdAt: any;
      id: string;
      uuid: string;
      name: string;
      personal: boolean;
      hasReachedMaxProjects: boolean;
      currentUserRole?: TeamRole | null;
      storageRemaining: any;
      owner: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
      subscriptionDetails?: {
        __typename?: 'SubscriptionDetails';
        expirationDate?: any | null;
        subscriptionInterval?: string | null;
        subscriptionPlanName?: string | null;
        subscriptionStatus?: string | null;
        isSubscriptionCanceled: boolean;
        isSubscriptionActive: boolean;
        isSubscriptionOnTrial: boolean;
        trialEndsAt?: any | null;
        updatedAt?: any | null;
      } | null;
    } | null;
    memberPreviews: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          url: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    members: Array<{
      __typename?: 'ProjectMember';
      id: string;
      role: ProjectMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          url: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    audits?: Array<{ __typename?: 'Audit'; id: string; event: string }> | null;
    settings?: {
      __typename?: 'UserProjectSetting';
      id: string;
      pin: boolean;
    } | null;
    invitations?: Array<{
      __typename?: 'ProjectInvitation';
      id: string;
      email: string;
      role: ProjectMemberRole;
      expiredAt?: any | null;
      createdAt: any;
      invitedBy: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      };
    }> | null;
    userRequests?: Array<{
      __typename?: 'UserRequest';
      id: string;
      role?: string | null;
      status: string;
      expiredAt?: any | null;
      createdAt: any;
      requestType: UserRequestCategory;
      userRequestableId: string;
      userRequestableType: UserRequestable;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
      invitedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
      } | null;
      reviewedBy?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    }> | null;
  } | null;
};

export type TaskUpdatedSubscriptionVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type TaskUpdatedSubscription = {
  __typename?: 'Subscription';
  taskUpdated?: {
    __typename?: 'Task';
    auditsCount?: number | null;
    unreadAuditsCount?: number | null;
    id: string;
    name: string;
    status?: TaskStatus | null;
    priority?: TaskPriority | null;
    startDate?: any | null;
    dueDate?: any | null;
    completedAt?: any | null;
    createdAt: any;
    phaseId?: string | null;
    projectId: string;
    deletedAt?: any | null;
    skillIds?: Array<string> | null;
    userIds: Array<string>;
    dueGroup?: string | null;
    fixedOrder?: boolean | null;
    recurring?: boolean | null;
    description?: string | null;
    frequency?: TaskFrequency | null;
    currentUserRole?: TaskMemberRole | null;
    currentUserProjectRole?: ProjectMemberRole | null;
    currentUserProjectTeamRole?: TeamMemberRole | null;
    project: {
      __typename?: 'Project';
      id: string;
      uuid: string;
      name: string;
      color: string;
      icon?: string | null;
      currentUserTeamRole?: TeamMemberRole | null;
      currentUserRole?: ProjectMemberRole | null;
      initials: string;
      archivedAt?: any | null;
      team?: {
        __typename?: 'Team';
        avatar?: string | null;
        createdAt: any;
        id: string;
        name: string;
        personal: boolean;
        subscriptionDetails?: {
          __typename?: 'SubscriptionDetails';
          expirationDate?: any | null;
          subscriptionStatus?: string | null;
          isSubscriptionCanceled: boolean;
          isSubscriptionActive: boolean;
          isSubscriptionOnTrial: boolean;
          paymentCardLast4?: string | null;
        } | null;
      } | null;
    };
    dependencies?: Array<{
      __typename?: 'Task';
      id: string;
      name: string;
    }> | null;
    checklists?: Array<{
      __typename?: 'TaskChecklist';
      id: string;
      name: string;
      completedAt?: any | null;
      createdAt: any;
    }> | null;
    members: Array<{
      __typename?: 'TaskMember';
      id: string;
      role: TaskMemberRole;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      };
    }>;
    invitations?: Array<{
      __typename?: 'TaskInvitation';
      id: string;
      email: string;
      role: TaskMemberRole;
      expiredAt?: any | null;
    }> | null;
    userRequests?: Array<{
      __typename?: 'UserRequest';
      id: string;
      role?: string | null;
      expiredAt?: any | null;
      user?: {
        __typename?: 'User';
        id: string;
        email: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber: string;
        primaryTeamId?: string | null;
        createdAt: any;
        inviteUrl: string;
        avatarId?: string | null;
        avatarIsPreviewable?: boolean | null;
        avatar?: {
          __typename?: 'File';
          id: string;
          cdnBaseUrl: string;
          path: string;
          isPreviewable: boolean;
          thumbnail?: string | null;
        } | null;
        skills?: Array<{
          __typename?: 'Skill';
          id: string;
          name: string;
          createdAt: any;
        }> | null;
      } | null;
    }> | null;
    creator: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    };
    completor?: {
      __typename?: 'User';
      id: string;
      email: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber: string;
      primaryTeamId?: string | null;
      createdAt: any;
      inviteUrl: string;
      avatarId?: string | null;
      avatarIsPreviewable?: boolean | null;
      avatar?: {
        __typename?: 'File';
        id: string;
        cdnBaseUrl: string;
        path: string;
        isPreviewable: boolean;
        thumbnail?: string | null;
      } | null;
      skills?: Array<{
        __typename?: 'Skill';
        id: string;
        name: string;
        createdAt: any;
      }> | null;
    } | null;
    phase?: { __typename?: 'Phase'; id: string; name: string } | null;
  } | null;
};

export const AvatarDetailFragmentDoc = gql`
  fragment AvatarDetail on File {
    id
    cdnBaseUrl
    path
    isPreviewable
    thumbnail
  }
`;
export const FileDetailsFragmentDoc = gql`
  fragment FileDetails on File {
    id
    url
    cdnBaseUrl
    path
    isPreviewable
    thumbnail
  }
`;
export const AttachmentsFragmentDoc = gql`
  fragment Attachments on Attachment {
    ... on MessageTask {
      id
      authorId
      author {
        id
        firstName
        lastName
        avatar {
          ...AvatarDetail
        }
      }
      task {
        id
        name
      }
    }
    ... on MessageProject {
      id
      authorId
      author {
        id
        firstName
        lastName
        avatar {
          ...AvatarDetail
        }
      }
      project {
        id
        uuid
        name
        team {
          subscriptionDetails {
            expirationDate
            subscriptionStatus
          }
        }
      }
    }
    ... on Document {
      id
      blobId
      size
      name
      contentType
      clientId
      isImage
      isAudio
      duration
      file {
        ...FileDetails
      }
    }
  }
  ${AvatarDetailFragmentDoc}
  ${FileDetailsFragmentDoc}
`;
export const ChatDetailFragmentDoc = gql`
  fragment ChatDetail on Chat {
    id
    name
    description
    avatarUrl
    isGroupChat
    messageIcon
    messageBody
    recentActivityAt
    unreadCount
    createdAt
    leaveOn
    isPendingRequest
    settings {
      id
      pin
      mute
      archivedAt
    }
    users {
      id
      name
      firstName
      lastName
      avatar {
        ...AvatarDetail
      }
    }
    pendingInvitations {
      email
      expiredAt
      id
    }
    userRequests {
      id
      status
      expiredAt
      user {
        id
        name
        firstName
        lastName
        email
        avatar {
          ...AvatarDetail
        }
      }
    }
    owner {
      id
      name
      firstName
      lastName
    }
  }
  ${AvatarDetailFragmentDoc}
`;
export const DocumentDetailFragmentDoc = gql`
  fragment DocumentDetail on Document {
    id
    blobId
    name
    contentType
    createdAt
    size
    isImage
    isVideo
    clientId
    isAudio
    duration
    file {
      id
      cdnBaseUrl
      path
      isPreviewable
      thumbnail
    }
    owner {
      id
      name
      firstName
      lastName
      createdAt
      avatar {
        ...AvatarDetail
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;
export const UserDetailFragmentDoc = gql`
  fragment UserDetail on User {
    id
    email
    name
    firstName
    lastName
    phoneNumber
    primaryTeamId
    createdAt
    inviteUrl
    avatarId
    avatarIsPreviewable
    avatar {
      ...AvatarDetail
    }
    skills {
      id
      name
      createdAt
    }
  }
  ${AvatarDetailFragmentDoc}
`;
export const CheckinDetailFragmentDoc = gql`
  fragment checkinDetail on MessageCheckin {
    id
    address
    city
    zipcode
    state
    country
    latitude
    longitude
    withinGeofence
  }
`;
export const MessageDetailFragmentDoc = gql`
  fragment MessageDetail on Message {
    id
    chatId
    clientId
    body
    createdAt
    isSender
    isDraft
    publishedAt
    authorId
    authorAvatarId
    authorName
    authorFirstName
    authorLastName
    authorEmail
    readAt
    isRetry
    readReceipts {
      ...UserDetail
    }
    checkin {
      ...checkinDetail
    }
    replyId
    userRequest {
      id
      requestType
      status
      canBeReviewed
      expiredAt
      invitedBy {
        id
        name
        firstName
      }
      reviewedBy {
        id
        name
        firstName
      }
      user {
        id
        email
        name
      }
      userRequestableId
      userRequestableType
    }
    replyMessage {
      id
      chatId
      clientId
      body
      deletedAt
      createdAt
      isSender
      isDraft
      publishedAt
      authorId
      authorAvatarId
      authorName
      authorFirstName
      authorLastName
      authorEmail
      attachments {
        ... on MessageTask {
          id
          authorId
          author {
            id
            name
            avatar {
              ...AvatarDetail
            }
          }
          task {
            id
            projectId
            name
          }
        }
        ... on MessageProject {
          id
          authorId
          author {
            id
            name
            avatar {
              ...AvatarDetail
            }
          }
          project {
            id
            uuid
            name
            team {
              subscriptionDetails {
                expirationDate
                subscriptionStatus
              }
            }
          }
        }
        ... on Document {
          id
          name
          contentType
          createdAt
          size
          isImage
          clientId
          isAudio
          duration
          file {
            ...FileDetails
          }
          owner {
            id
            name
            firstName
            lastName
            createdAt
          }
        }
        ... on MessageTaskAssignment {
          id
          messageId
          assignees {
            ...UserDetail
          }
          task {
            id
            name
            deletedAt
            completedAt
          }
        }
        ... on MessageTaskComplete {
          id
          messageId
          completor {
            id
            name
            avatar {
              ...AvatarDetail
            }
          }
        }
      }
    }
    attachments {
      ... on MessageTask {
        id
        authorId
        author {
          id
          name
          avatar {
            ...AvatarDetail
          }
        }
        task {
          id
          projectId
          deletedAt
          name
        }
      }
      ... on MessageProject {
        id
        authorId
        author {
          id
          name
          avatar {
            ...AvatarDetail
          }
        }
        project {
          id
          uuid
          name
          team {
            subscriptionDetails {
              expirationDate
              subscriptionStatus
            }
          }
        }
      }
      ... on Document {
        id
        blobId
        name
        contentType
        createdAt
        size
        isImage
        clientId
        isAudio
        duration
        file {
          ...FileDetails
        }
        owner {
          id
          name
          firstName
          lastName
          createdAt
        }
        taskDocuments {
          id
          owner {
            id
          }
          task {
            id
            name
            projectId
            project {
              id
              name
            }
          }
        }
        projectDocuments {
          id
          owner {
            id
          }
          project {
            id
            name
          }
        }
      }
      ... on MessageTaskAssignment {
        id
        messageId
        assignees {
          id
          name
          avatar {
            ...AvatarDetail
          }
        }
        task {
          id
          name
          deletedAt
          completedAt
          currentUserRole
        }
      }
      ... on MessageTaskComplete {
        id
        messageId
        completor {
          id
          name
          avatar {
            ...AvatarDetail
          }
        }
      }
    }
    reaction {
      ... on MessageReaction {
        id
        reaction
        count
        user {
          id
          name
        }
      }
    }
  }
  ${UserDetailFragmentDoc}
  ${CheckinDetailFragmentDoc}
  ${AvatarDetailFragmentDoc}
  ${FileDetailsFragmentDoc}
`;
export const DraftMessageDetailFragmentDoc = gql`
  fragment DraftMessageDetail on DraftMessage {
    chatId
    body
    tagsCollection {
      tasks {
        id
        name
        userIds
        status
        projectId
        project {
          id
          name
          uuid
        }
      }
      project {
        id
        name
        uuid
      }
      author {
        id
        name
      }
    }
    localFiles {
      id
      name
      clientId
      url
      cdnBaseUrl
      path
      contentType
      isImage
      isVideo
      size
      isAudio
      duration
      isPreviewable
      thumbnail
      blobId
    }
    replyMessage {
      ...MessageDetail
    }
    checkin {
      ...checkinDetail
    }
  }
  ${MessageDetailFragmentDoc}
  ${CheckinDetailFragmentDoc}
`;
export const GetChatDetailFragmentDoc = gql`
  fragment GetChatDetail on Chat {
    id
    name
    description
    avatar {
      ...AvatarDetail
    }
    avatarUrl
    isGroupChat
    messageIcon
    messageBody
    recentActivityAt
    unreadCount
    isNewChat
    isUserBlocked
    canCurrentUserDecide
    isPendingRequest
    friendRequestAccepted
    createdAt
    leaveOn
    owner {
      id
      name
      firstName
      lastName
    }
    settings {
      id
      pin
      mute
      archivedAt
    }
    userIds
    users {
      id
      name
      firstName
      lastName
      email
      avatar {
        ...AvatarDetail
      }
    }
    pendingInvitations {
      email
      expiredAt
      id
    }
    userRequests {
      id
      status
      expiredAt
      user {
        id
        name
        firstName
        lastName
        email
        avatar {
          ...AvatarDetail
        }
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;
export const LocalDocumentDetailFragmentDoc = gql`
  fragment LocalDocumentDetail on Document {
    id
    blobId
    name
    contentType
    createdAt
    size
    isImage
    isVideo
    clientId
    isAudio
    duration
    failedAt
    file {
      id
      cdnBaseUrl
      path
      isPreviewable
      thumbnail
      url
    }
    owner {
      id
      name
      firstName
      lastName
      createdAt
      avatar {
        id
        cdnBaseUrl
        path
        isPreviewable
        thumbnail
      }
    }
  }
`;
export const MessageDetailForQueryFragmentDoc = gql`
  fragment MessageDetailForQuery on Message {
    id
    chatId
    clientId
    body
    createdAt
    isSender
    isDraft
    publishedAt
    authorId
    authorAvatarId
    authorName
    authorFirstName
    authorLastName
    authorEmail
    readAt
    isRetry
    readReceipts {
      ...UserDetail
    }
    checkin {
      ...checkinDetail
    }
    replyId
    userRequest {
      id
      requestType
      status
      canBeReviewed
      expiredAt
      invitedBy {
        id
        name
      }
      reviewedBy {
        id
        name
      }
      user {
        id
        email
        name
        firstName
      }
      userRequestableId
      userRequestableType
    }
    replyMessage {
      id
      chatId
      clientId
      body
      deletedAt
      createdAt
      isSender
      isDraft
      publishedAt
      authorId
      authorAvatarId
      authorName
      authorFirstName
      authorLastName
      authorEmail
      attachments {
        ... on MessageTask {
          id
          authorId
          author {
            id
            name
            avatar {
              id
            }
          }
          task {
            id
            projectId
            name
          }
        }
        ... on MessageProject {
          id
          authorId
          author {
            id
            name
            avatar {
              id
            }
          }
          project {
            id
            uuid
            name
            team {
              subscriptionDetails {
                expirationDate
                subscriptionStatus
              }
            }
          }
        }
        ... on Document {
          id
          name
          contentType
          createdAt
          size
          isImage
          clientId
          isAudio
          duration
          file {
            id
            cdnBaseUrl
            url
            isPreviewable
            thumbnail
          }
          owner {
            id
            name
            firstName
            lastName
            createdAt
          }
        }
        ... on MessageTaskAssignment {
          id
          messageId
          assignees {
            ...UserDetail
          }
          task {
            id
            name
            deletedAt
            completedAt
          }
        }
        ... on MessageTaskComplete {
          id
          messageId
          completor {
            id
            name
            avatar {
              id
            }
          }
        }
      }
    }
    attachments {
      ... on PublicTeam {
        uuid
        name
        avatarFile {
          ...AvatarDetail
        }
        hasPendingMemberAdditionRequest
      }
      ... on MessageTask {
        id
        authorId
        author {
          id
          name
          avatar {
            id
          }
        }
        task {
          id
          projectId
          deletedAt
          name
          priority
          dueDate
          members {
            id
            role
            user {
              id
              name
              avatar {
                id
              }
            }
          }
        }
      }
      ... on MessageProject {
        id
        authorId
        author {
          id
          name
          avatar {
            id
          }
        }
        project {
          id
          uuid
          name
          team {
            subscriptionDetails {
              expirationDate
              subscriptionStatus
            }
          }
        }
      }
      ... on Document {
        id
        blobId
        name
        contentType
        createdAt
        size
        isImage
        clientId
        isAudio
        duration
        file {
          id
          cdnBaseUrl
          url
          isPreviewable
          thumbnail
        }
        owner {
          id
          name
          firstName
          lastName
          createdAt
        }
        taskDocuments {
          id
          owner {
            id
          }
          task {
            id
            name
            projectId
            project {
              id
              name
            }
          }
        }
        projectDocuments {
          id
          owner {
            id
          }
          project {
            id
            name
          }
        }
      }
      ... on MessageTaskAssignment {
        id
        messageId
        assignees {
          id
          name
          firstName
          avatar {
            id
          }
        }
        task {
          id
          name
          deletedAt
          completedAt
          currentUserRole
        }
      }
      ... on MessageTaskComplete {
        id
        messageId
        completor {
          id
          name
          avatar {
            id
          }
        }
      }
    }
    reaction {
      ... on MessageReaction {
        id
        reaction
        count
        user {
          id
          name
        }
      }
    }
  }
  ${UserDetailFragmentDoc}
  ${CheckinDetailFragmentDoc}
  ${AvatarDetailFragmentDoc}
`;
export const MessageUpdateLiteFragmentDoc = gql`
  fragment MessageUpdateLite on Message {
    id
    chatId
    clientId
    body
    createdAt
    isSender
    isDraft
    publishedAt
    authorId
    authorAvatarId
    authorName
    authorFirstName
    authorLastName
    authorEmail
    readAt
    isRetry
    readReceipts {
      id
      name
    }
    checkin {
      ...checkinDetail
    }
    replyId
    userRequest {
      id
      requestType
      status
      canBeReviewed
      expiredAt
      invitedBy {
        id
        name
      }
      reviewedBy {
        id
        name
      }
      user {
        id
        email
        name
      }
      userRequestableId
      userRequestableType
    }
    replyMessage {
      id
      chatId
      clientId
      body
      deletedAt
      createdAt
      isSender
      isDraft
      publishedAt
      authorId
      authorAvatarId
      authorName
      authorFirstName
      authorLastName
      authorEmail
    }
    attachments {
      ... on MessageTask {
        id
        authorId
        author {
          id
          name
          avatar {
            ...AvatarDetail
          }
        }
        task {
          id
          projectId
          deletedAt
          name
        }
      }
      ... on MessageProject {
        id
        authorId
        author {
          id
          name
          avatar {
            ...AvatarDetail
          }
        }
        project {
          id
          uuid
          name
          team {
            subscriptionDetails {
              expirationDate
              subscriptionStatus
            }
          }
        }
      }
      ... on Document {
        id
        blobId
        name
        contentType
        createdAt
        size
        isImage
        clientId
        isAudio
        duration
        file {
          ...FileDetails
        }
        owner {
          id
          name
          firstName
          lastName
          createdAt
        }
        taskDocuments {
          id
          owner {
            id
          }
          task {
            id
            name
            projectId
            project {
              id
              name
            }
          }
        }
        projectDocuments {
          id
          owner {
            id
          }
          project {
            id
            name
          }
        }
      }
      ... on MessageTaskAssignment {
        id
        messageId
        assignees {
          id
          name
          avatar {
            ...AvatarDetail
          }
        }
        task {
          id
          name
          deletedAt
          completedAt
          currentUserRole
        }
      }
      ... on MessageTaskComplete {
        id
        messageId
        completor {
          id
          name
          avatar {
            ...AvatarDetail
          }
        }
      }
    }
    reaction {
      ... on MessageReaction {
        id
        reaction
        count
        user {
          id
          name
        }
      }
    }
  }
  ${CheckinDetailFragmentDoc}
  ${AvatarDetailFragmentDoc}
  ${FileDetailsFragmentDoc}
`;
export const MyTasksGroupTaskFragmentDoc = gql`
  fragment MyTasksGroupTask on Task {
    id
    name
    status
    priority
    startDate
    dueDate
    completedAt
    createdAt
    projectId
    currentUserRole
    currentUserProjectRole
    currentUserProjectTeamRole
    project {
      id
      name
      icon
      color
    }
    members {
      role
      user {
        id
        name
        avatar {
          ...AvatarDetail
        }
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;
export const PageInfoFragmentDoc = gql`
  fragment PageInfo on PageInfo {
    hasNextPage
    hasPreviousPage
    endCursor
    startCursor
  }
`;
export const ProjectDetailFragmentDoc = gql`
  fragment ProjectDetail on Project {
    address
    latitude
    longitude
    archivedAt
    usersCount
    tasksCount
    currentUserRole
    currentUserTeamRole
    currentUserHasPendingMemberAdditionRequest
    isTaskMember
    teamId
    color
    icon
    createdAt
    creator {
      ...UserDetail
      avatar {
        ...AvatarDetail
      }
    }
    description
    id
    uuid
    coverImage {
      ...FileDetails
    }
    initials
    name
    team {
      avatar
      createdAt
      id
      uuid
      name
      personal
      hasReachedMaxProjects
      currentUserRole
      storageRemaining
      owner {
        ...UserDetail
      }
      subscriptionDetails {
        expirationDate
        subscriptionInterval
        subscriptionPlanName
        subscriptionStatus
        isSubscriptionCanceled
        isSubscriptionActive
        isSubscriptionOnTrial
        trialEndsAt
        updatedAt
      }
    }
    memberPreviews {
      id
      role
      user {
        ...UserDetail
        avatar {
          ...FileDetails
        }
      }
    }
    members {
      id
      role
      user {
        ...UserDetail
        avatar {
          ...FileDetails
        }
      }
    }
    audits {
      id
      event
    }
    settings {
      id
      pin
    }
    invitations {
      id
      email
      role
      expiredAt
      createdAt
      invitedBy {
        id
        name
        firstName
        lastName
        avatar {
          ...AvatarDetail
        }
      }
    }
    userRequests {
      id
      role
      status
      expiredAt
      createdAt
      requestType
      userRequestableId
      userRequestableType
      user {
        id
        name
        firstName
        lastName
        avatar {
          ...AvatarDetail
        }
      }
      invitedBy {
        id
        name
        firstName
        lastName
        avatar {
          ...AvatarDetail
        }
      }
      reviewedBy {
        id
        name
        firstName
        lastName
      }
    }
    unreadAuditsCount
    activeTasksCount
    upcomingTasksCount
    overdueTasksCount
    completedTasksCount
    completedChecklistCount
  }
  ${UserDetailFragmentDoc}
  ${AvatarDetailFragmentDoc}
  ${FileDetailsFragmentDoc}
`;
export const ProjectListNodeFragmentDoc = gql`
  fragment ProjectListNode on Project {
    id
    uuid
    name
    initials
    description
    address
    latitude
    longitude
    archivedAt
    usersCount
    tasksCount
    currentUserRole
    teamId
    team {
      id
      name
      personal
      avatarFile {
        ...AvatarDetail
      }
    }
    color
    icon
    createdAt
    creator {
      id
      name
      firstName
      avatar {
        id
        cdnBaseUrl
        path
        thumbnail
      }
    }
    settings {
      id
      pin
    }
  }
  ${AvatarDetailFragmentDoc}
`;
export const PublicUserDetailFragmentDoc = gql`
  fragment PublicUserDetail on User {
    id
    name
    firstName
    lastName
    avatar {
      ...FileDetails
    }
  }
  ${FileDetailsFragmentDoc}
`;
export const RateUsTriggerStateDetailFragmentDoc = gql`
  fragment RateUsTriggerStateDetail on RateUsTriggerState {
    count
    promptStage
    lastPromptAt
  }
`;
export const RateUsStateDetailFragmentDoc = gql`
  fragment RateUsStateDetail on RateUsState {
    hasRated
    permanentlySuppressed
    triggers {
      uploadMedia {
        ...RateUsTriggerStateDetail
      }
      checkin {
        ...RateUsTriggerStateDetail
      }
      checklist {
        ...RateUsTriggerStateDetail
      }
      tasks {
        ...RateUsTriggerStateDetail
      }
      chatTags {
        ...RateUsTriggerStateDetail
      }
      assignTasks {
        ...RateUsTriggerStateDetail
      }
    }
  }
  ${RateUsTriggerStateDetailFragmentDoc}
`;
export const TaskRowFragmentDoc = gql`
  fragment TaskRow on Task {
    id
    name
    status
    priority
    startDate
    dueDate
    completedAt
    createdAt
    phaseId
    projectId
    deletedAt
    skillIds
    userIds
    dueGroup
    dependencies {
      id
      name
    }
    fixedOrder
    recurring
    description
    frequency
    currentUserRole
    currentUserProjectRole
    currentUserProjectTeamRole
    checklists {
      id
      name
      completedAt
      createdAt
    }
    members {
      id
      role
      user {
        ...UserDetail
        avatar {
          ...AvatarDetail
        }
      }
    }
    invitations {
      id
      email
      role
      expiredAt
    }
    userRequests {
      id
      role
      user {
        ...UserDetail
        avatar {
          ...AvatarDetail
        }
      }
      expiredAt
    }
    creator {
      ...UserDetail
      avatar {
        ...AvatarDetail
      }
    }
    completor {
      ...UserDetail
    }
    project {
      id
      uuid
      name
      color
      icon
      currentUserTeamRole
      currentUserRole
      team {
        avatar
        createdAt
        id
        name
        personal
      }
      initials
      archivedAt
    }
    phase {
      id
      name
    }
  }
  ${UserDetailFragmentDoc}
  ${AvatarDetailFragmentDoc}
`;
export const TeamSubscriptionFragmentDoc = gql`
  fragment TeamSubscription on Team {
    id
    personal
    subscriptionDetails {
      expirationDate
      subscriptionStatus
      isSubscriptionCanceled
      isSubscriptionActive
      isSubscriptionOnTrial
      paymentCardLast4
    }
  }
`;
export const TaskDetailFragmentDoc = gql`
  fragment TaskDetail on Task {
    ...TaskRow
    project {
      id
      team {
        ...TeamSubscription
      }
    }
  }
  ${TaskRowFragmentDoc}
  ${TeamSubscriptionFragmentDoc}
`;
export const TaskDocumentDetailFragmentDoc = gql`
  fragment TaskDocumentDetail on Task {
    id
    name
    startDate
    dueDate
    completedAt
    projectId
    deletedAt
    currentUserRole
    currentUserProjectRole
    currentUserProjectTeamRole
    project {
      id
      uuid
      name
      archivedAt
      team {
        subscriptionDetails {
          expirationDate
          subscriptionInterval
          subscriptionPlanName
          subscriptionStatus
          isSubscriptionCanceled
          isSubscriptionActive
          isSubscriptionOnTrial
          trialEndsAt
          updatedAt
        }
      }
    }
    documents {
      id
      name
      contentType
      createdAt
      size
      isImage
      clientId
      isAudio
      duration
      owner {
        id
        name
      }
      file {
        id
        cdnBaseUrl
        path
        isPreviewable
        thumbnail
      }
      messageDocuments {
        id
        message {
          id
          clientId
          chatId
          createdAt
          isSender
          isDraft
          publishedAt
          authorId
        }
      }
      projectDocuments {
        id
        project {
          id
          uuid
          name
        }
        owner {
          id
          name
        }
      }
      taskDocuments {
        id
        task {
          id
          name
          projectId
          project {
            id
            uuid
            name
          }
        }
        owner {
          id
          name
        }
      }
    }
  }
`;
export const TeamDetailFragmentDoc = gql`
  fragment TeamDetail on Team {
    address
    latitude
    longitude
    id
    uuid
    avatar
    avatarFile {
      ...AvatarDetail
    }
    createdAt
    name
    usersCount
    fileStorageUsed
    mediaStorageUsed
    pending
    maxDocumentStorage
    storageRemaining
    currentUserRole
    hasReachedMaxProjects
    numberOfProjectsUsed
    maxNumberOfProjects
    personal
    billingSource
    teamSubscriptionStatus
    entitlementExpiration
    tasksCount
    completedTasksCount
    subscriptionDetails {
      expirationDate
      subscriptionInterval
      subscriptionPlanName
      subscriptionStatus
      trialEndsAt
      canceledAt
      stripeProductId
      isSubscriptionCanceled
      isSubscriptionActive
      isSubscriptionOnTrial
      expirationDate
      updatedAt
      paymentCardLast4
      paymentCardBrand
      paymentCardExpMonth
      paymentCardExpYear
      currentSeatCount
      pricePerSeat
      isSubscriptionCanceled
      isSubscriptionActive
      isSubscriptionOnTrial
    }
    owner {
      ...UserDetail
    }
    skills {
      id
      name
      createdAt
    }
    product {
      id
      name
      prices {
        id
        interval
        intervalCount
        externalId
      }
    }
  }
  ${AvatarDetailFragmentDoc}
  ${UserDetailFragmentDoc}
`;
export const TeamMembersDetailFragmentDoc = gql`
  fragment TeamMembersDetail on Team {
    users {
      ...UserDetail
      teamRoles
    }
    invitations {
      email
      expiredAt
      id
      invitedBy {
        ...UserDetail
      }
      role
      user {
        id
        firstName
        lastName
        avatar {
          ...AvatarDetail
        }
      }
    }
    invoices {
      id
      invoiceUrl
      amount
      date
      description
      status
    }
  }
  ${UserDetailFragmentDoc}
  ${AvatarDetailFragmentDoc}
`;
export const UserProfileFragmentDoc = gql`
  fragment UserProfile on Profile {
    address
    id
    email
    name
    firstName
    lastName
    phoneNumber
    userActiveTasksCount
    avatar {
      ...AvatarDetail
    }
    skills {
      id
      name
      createdAt
    }
    teams {
      id
      uuid
      name
      users {
        id
        name
      }
      usersCount
    }
  }
  ${AvatarDetailFragmentDoc}
`;
export const GenerateProjectReportDocument = gql`
  mutation generateProjectReport($projectId: ID!) {
    generateProjectReport(projectId: $projectId) {
      uuid
    }
  }
`;
export type GenerateProjectReportMutationFn = Apollo.MutationFunction<
  GenerateProjectReportMutation,
  GenerateProjectReportMutationVariables
>;

/**
 * __useGenerateProjectReportMutation__
 *
 * To run a mutation, you first call `useGenerateProjectReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProjectReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProjectReportMutation, { data, loading, error }] = useGenerateProjectReportMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGenerateProjectReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateProjectReportMutation,
    GenerateProjectReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateProjectReportMutation,
    GenerateProjectReportMutationVariables
  >(GenerateProjectReportDocument, options);
}
export type GenerateProjectReportMutationHookResult = ReturnType<
  typeof useGenerateProjectReportMutation
>;
export type GenerateProjectReportMutationResult =
  Apollo.MutationResult<GenerateProjectReportMutation>;
export type GenerateProjectReportMutationOptions = Apollo.BaseMutationOptions<
  GenerateProjectReportMutation,
  GenerateProjectReportMutationVariables
>;
export const AcceptChatInvitationDocument = gql`
  mutation acceptChatInvitation($invitationToken: String!) {
    acceptChatInvitation(invitationToken: $invitationToken) {
      id
      name
    }
  }
`;
export type AcceptChatInvitationMutationFn = Apollo.MutationFunction<
  AcceptChatInvitationMutation,
  AcceptChatInvitationMutationVariables
>;

/**
 * __useAcceptChatInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptChatInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptChatInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptChatInvitationMutation, { data, loading, error }] = useAcceptChatInvitationMutation({
 *   variables: {
 *      invitationToken: // value for 'invitationToken'
 *   },
 * });
 */
export function useAcceptChatInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptChatInvitationMutation,
    AcceptChatInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptChatInvitationMutation,
    AcceptChatInvitationMutationVariables
  >(AcceptChatInvitationDocument, options);
}
export type AcceptChatInvitationMutationHookResult = ReturnType<
  typeof useAcceptChatInvitationMutation
>;
export type AcceptChatInvitationMutationResult =
  Apollo.MutationResult<AcceptChatInvitationMutation>;
export type AcceptChatInvitationMutationOptions = Apollo.BaseMutationOptions<
  AcceptChatInvitationMutation,
  AcceptChatInvitationMutationVariables
>;
export const AcceptTeamInvitationDocument = gql`
  mutation acceptTeamInvitation($invitationToken: String!) {
    acceptTeamInvitation(invitationToken: $invitationToken) {
      id
      name
      users {
        id
        name
      }
    }
  }
`;
export type AcceptTeamInvitationMutationFn = Apollo.MutationFunction<
  AcceptTeamInvitationMutation,
  AcceptTeamInvitationMutationVariables
>;

/**
 * __useAcceptTeamInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptTeamInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTeamInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTeamInvitationMutation, { data, loading, error }] = useAcceptTeamInvitationMutation({
 *   variables: {
 *      invitationToken: // value for 'invitationToken'
 *   },
 * });
 */
export function useAcceptTeamInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptTeamInvitationMutation,
    AcceptTeamInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptTeamInvitationMutation,
    AcceptTeamInvitationMutationVariables
  >(AcceptTeamInvitationDocument, options);
}
export type AcceptTeamInvitationMutationHookResult = ReturnType<
  typeof useAcceptTeamInvitationMutation
>;
export type AcceptTeamInvitationMutationResult =
  Apollo.MutationResult<AcceptTeamInvitationMutation>;
export type AcceptTeamInvitationMutationOptions = Apollo.BaseMutationOptions<
  AcceptTeamInvitationMutation,
  AcceptTeamInvitationMutationVariables
>;
export const AcceptUserInviteDocument = gql`
  mutation acceptUserInvite($invitationToken: String!) {
    acceptUserInvite(invitationToken: $invitationToken) {
      chat {
        id
      }
      inviter {
        id
        firstName
        lastName
      }
      status
    }
  }
`;
export type AcceptUserInviteMutationFn = Apollo.MutationFunction<
  AcceptUserInviteMutation,
  AcceptUserInviteMutationVariables
>;

/**
 * __useAcceptUserInviteMutation__
 *
 * To run a mutation, you first call `useAcceptUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptUserInviteMutation, { data, loading, error }] = useAcceptUserInviteMutation({
 *   variables: {
 *      invitationToken: // value for 'invitationToken'
 *   },
 * });
 */
export function useAcceptUserInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptUserInviteMutation,
    AcceptUserInviteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptUserInviteMutation,
    AcceptUserInviteMutationVariables
  >(AcceptUserInviteDocument, options);
}
export type AcceptUserInviteMutationHookResult = ReturnType<
  typeof useAcceptUserInviteMutation
>;
export type AcceptUserInviteMutationResult =
  Apollo.MutationResult<AcceptUserInviteMutation>;
export type AcceptUserInviteMutationOptions = Apollo.BaseMutationOptions<
  AcceptUserInviteMutation,
  AcceptUserInviteMutationVariables
>;
export const AddProjectChecklistDocument = gql`
  mutation addProjectChecklist(
    $projectUUId: ID!
    $attributes: AddProjectChecklistAttributes!
  ) {
    addProjectChecklist(uuid: $projectUUId, attributes: $attributes) {
      projectId
      id
      name
      completedAt
      createdAt
      sort
    }
  }
`;
export type AddProjectChecklistMutationFn = Apollo.MutationFunction<
  AddProjectChecklistMutation,
  AddProjectChecklistMutationVariables
>;

/**
 * __useAddProjectChecklistMutation__
 *
 * To run a mutation, you first call `useAddProjectChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectChecklistMutation, { data, loading, error }] = useAddProjectChecklistMutation({
 *   variables: {
 *      projectUUId: // value for 'projectUUId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAddProjectChecklistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddProjectChecklistMutation,
    AddProjectChecklistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddProjectChecklistMutation,
    AddProjectChecklistMutationVariables
  >(AddProjectChecklistDocument, options);
}
export type AddProjectChecklistMutationHookResult = ReturnType<
  typeof useAddProjectChecklistMutation
>;
export type AddProjectChecklistMutationResult =
  Apollo.MutationResult<AddProjectChecklistMutation>;
export type AddProjectChecklistMutationOptions = Apollo.BaseMutationOptions<
  AddProjectChecklistMutation,
  AddProjectChecklistMutationVariables
>;
export const AddProjectFilesDocument = gql`
  mutation addProjectFiles($id: ID!, $attributes: [DocumentAttributes!]!) {
    addProjectFiles(id: $id, attributes: $attributes) {
      id
    }
  }
`;
export type AddProjectFilesMutationFn = Apollo.MutationFunction<
  AddProjectFilesMutation,
  AddProjectFilesMutationVariables
>;

/**
 * __useAddProjectFilesMutation__
 *
 * To run a mutation, you first call `useAddProjectFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectFilesMutation, { data, loading, error }] = useAddProjectFilesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAddProjectFilesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddProjectFilesMutation,
    AddProjectFilesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddProjectFilesMutation,
    AddProjectFilesMutationVariables
  >(AddProjectFilesDocument, options);
}
export type AddProjectFilesMutationHookResult = ReturnType<
  typeof useAddProjectFilesMutation
>;
export type AddProjectFilesMutationResult =
  Apollo.MutationResult<AddProjectFilesMutation>;
export type AddProjectFilesMutationOptions = Apollo.BaseMutationOptions<
  AddProjectFilesMutation,
  AddProjectFilesMutationVariables
>;
export const AddTaskChecklistDocument = gql`
  mutation addTaskChecklist(
    $taskId: ID!
    $attributes: TaskChecklistAttributes!
  ) {
    addTaskChecklist(taskId: $taskId, attributes: $attributes) {
      taskId
      id
      name
      completedAt
      createdAt
      sort
    }
  }
`;
export type AddTaskChecklistMutationFn = Apollo.MutationFunction<
  AddTaskChecklistMutation,
  AddTaskChecklistMutationVariables
>;

/**
 * __useAddTaskChecklistMutation__
 *
 * To run a mutation, you first call `useAddTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaskChecklistMutation, { data, loading, error }] = useAddTaskChecklistMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAddTaskChecklistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddTaskChecklistMutation,
    AddTaskChecklistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddTaskChecklistMutation,
    AddTaskChecklistMutationVariables
  >(AddTaskChecklistDocument, options);
}
export type AddTaskChecklistMutationHookResult = ReturnType<
  typeof useAddTaskChecklistMutation
>;
export type AddTaskChecklistMutationResult =
  Apollo.MutationResult<AddTaskChecklistMutation>;
export type AddTaskChecklistMutationOptions = Apollo.BaseMutationOptions<
  AddTaskChecklistMutation,
  AddTaskChecklistMutationVariables
>;
export const AddTaskFilesDocument = gql`
  mutation addTaskFiles($id: ID!, $attributes: [DocumentAttributes!]!) {
    addTaskFiles(id: $id, attributes: $attributes) {
      id
    }
  }
`;
export type AddTaskFilesMutationFn = Apollo.MutationFunction<
  AddTaskFilesMutation,
  AddTaskFilesMutationVariables
>;

/**
 * __useAddTaskFilesMutation__
 *
 * To run a mutation, you first call `useAddTaskFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaskFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaskFilesMutation, { data, loading, error }] = useAddTaskFilesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAddTaskFilesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddTaskFilesMutation,
    AddTaskFilesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddTaskFilesMutation,
    AddTaskFilesMutationVariables
  >(AddTaskFilesDocument, options);
}
export type AddTaskFilesMutationHookResult = ReturnType<
  typeof useAddTaskFilesMutation
>;
export type AddTaskFilesMutationResult =
  Apollo.MutationResult<AddTaskFilesMutation>;
export type AddTaskFilesMutationOptions = Apollo.BaseMutationOptions<
  AddTaskFilesMutation,
  AddTaskFilesMutationVariables
>;
export const ApplyProjectChecklistTemplateDocument = gql`
  mutation applyProjectChecklistTemplate(
    $projectChecklistTemplateId: ID!
    $selectedItemIds: [ID!]!
    $uuid: ID!
  ) {
    applyProjectChecklistTemplate(
      projectChecklistTemplateId: $projectChecklistTemplateId
      selectedItemIds: $selectedItemIds
      uuid: $uuid
    ) {
      id
    }
  }
`;
export type ApplyProjectChecklistTemplateMutationFn = Apollo.MutationFunction<
  ApplyProjectChecklistTemplateMutation,
  ApplyProjectChecklistTemplateMutationVariables
>;

/**
 * __useApplyProjectChecklistTemplateMutation__
 *
 * To run a mutation, you first call `useApplyProjectChecklistTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyProjectChecklistTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyProjectChecklistTemplateMutation, { data, loading, error }] = useApplyProjectChecklistTemplateMutation({
 *   variables: {
 *      projectChecklistTemplateId: // value for 'projectChecklistTemplateId'
 *      selectedItemIds: // value for 'selectedItemIds'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useApplyProjectChecklistTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplyProjectChecklistTemplateMutation,
    ApplyProjectChecklistTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplyProjectChecklistTemplateMutation,
    ApplyProjectChecklistTemplateMutationVariables
  >(ApplyProjectChecklistTemplateDocument, options);
}
export type ApplyProjectChecklistTemplateMutationHookResult = ReturnType<
  typeof useApplyProjectChecklistTemplateMutation
>;
export type ApplyProjectChecklistTemplateMutationResult =
  Apollo.MutationResult<ApplyProjectChecklistTemplateMutation>;
export type ApplyProjectChecklistTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    ApplyProjectChecklistTemplateMutation,
    ApplyProjectChecklistTemplateMutationVariables
  >;
export const ApproveTaskInvitationDocument = gql`
  mutation approveTaskInvitation($id: ID!) {
    approveTaskInvitation(userRequestId: $id)
  }
`;
export type ApproveTaskInvitationMutationFn = Apollo.MutationFunction<
  ApproveTaskInvitationMutation,
  ApproveTaskInvitationMutationVariables
>;

/**
 * __useApproveTaskInvitationMutation__
 *
 * To run a mutation, you first call `useApproveTaskInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTaskInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTaskInvitationMutation, { data, loading, error }] = useApproveTaskInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveTaskInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveTaskInvitationMutation,
    ApproveTaskInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApproveTaskInvitationMutation,
    ApproveTaskInvitationMutationVariables
  >(ApproveTaskInvitationDocument, options);
}
export type ApproveTaskInvitationMutationHookResult = ReturnType<
  typeof useApproveTaskInvitationMutation
>;
export type ApproveTaskInvitationMutationResult =
  Apollo.MutationResult<ApproveTaskInvitationMutation>;
export type ApproveTaskInvitationMutationOptions = Apollo.BaseMutationOptions<
  ApproveTaskInvitationMutation,
  ApproveTaskInvitationMutationVariables
>;
export const ArchiveChatDocument = gql`
  mutation archiveChat($id: ID!) {
    archiveChat(id: $id) {
      id
      name
      description
      users {
        id
      }
      avatar {
        ...AvatarDetail
      }
      settings {
        mute
        pin
        archivedAt
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;
export type ArchiveChatMutationFn = Apollo.MutationFunction<
  ArchiveChatMutation,
  ArchiveChatMutationVariables
>;

/**
 * __useArchiveChatMutation__
 *
 * To run a mutation, you first call `useArchiveChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveChatMutation, { data, loading, error }] = useArchiveChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveChatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveChatMutation,
    ArchiveChatMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveChatMutation, ArchiveChatMutationVariables>(
    ArchiveChatDocument,
    options
  );
}
export type ArchiveChatMutationHookResult = ReturnType<
  typeof useArchiveChatMutation
>;
export type ArchiveChatMutationResult =
  Apollo.MutationResult<ArchiveChatMutation>;
export type ArchiveChatMutationOptions = Apollo.BaseMutationOptions<
  ArchiveChatMutation,
  ArchiveChatMutationVariables
>;
export const ArchiveProjectDocument = gql`
  mutation archiveProject($id: ID!) {
    archiveProject(id: $id) {
      ...ProjectDetail
    }
  }
  ${ProjectDetailFragmentDoc}
`;
export type ArchiveProjectMutationFn = Apollo.MutationFunction<
  ArchiveProjectMutation,
  ArchiveProjectMutationVariables
>;

/**
 * __useArchiveProjectMutation__
 *
 * To run a mutation, you first call `useArchiveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProjectMutation, { data, loading, error }] = useArchiveProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveProjectMutation,
    ArchiveProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveProjectMutation,
    ArchiveProjectMutationVariables
  >(ArchiveProjectDocument, options);
}
export type ArchiveProjectMutationHookResult = ReturnType<
  typeof useArchiveProjectMutation
>;
export type ArchiveProjectMutationResult =
  Apollo.MutationResult<ArchiveProjectMutation>;
export type ArchiveProjectMutationOptions = Apollo.BaseMutationOptions<
  ArchiveProjectMutation,
  ArchiveProjectMutationVariables
>;
export const AssignTaskOwnerDocument = gql`
  mutation assignTaskOwner($id: ID!, $newOwnerId: ID!) {
    assignTaskOwner(id: $id, newOwnerId: $newOwnerId) {
      id
    }
  }
`;
export type AssignTaskOwnerMutationFn = Apollo.MutationFunction<
  AssignTaskOwnerMutation,
  AssignTaskOwnerMutationVariables
>;

/**
 * __useAssignTaskOwnerMutation__
 *
 * To run a mutation, you first call `useAssignTaskOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTaskOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTaskOwnerMutation, { data, loading, error }] = useAssignTaskOwnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newOwnerId: // value for 'newOwnerId'
 *   },
 * });
 */
export function useAssignTaskOwnerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignTaskOwnerMutation,
    AssignTaskOwnerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignTaskOwnerMutation,
    AssignTaskOwnerMutationVariables
  >(AssignTaskOwnerDocument, options);
}
export type AssignTaskOwnerMutationHookResult = ReturnType<
  typeof useAssignTaskOwnerMutation
>;
export type AssignTaskOwnerMutationResult =
  Apollo.MutationResult<AssignTaskOwnerMutation>;
export type AssignTaskOwnerMutationOptions = Apollo.BaseMutationOptions<
  AssignTaskOwnerMutation,
  AssignTaskOwnerMutationVariables
>;
export const AssignTaskUsersDocument = gql`
  mutation assignTaskUsers(
    $id: ID!
    $members: [TaskMemberAttributes!]!
    $chatId: ID
    $sendCardImmediately: Boolean
    $sourceMessageId: ID
  ) {
    assignTaskUsers(
      id: $id
      members: $members
      chatId: $chatId
      sendCardImmediately: $sendCardImmediately
      sourceMessageId: $sourceMessageId
    ) {
      id
    }
  }
`;
export type AssignTaskUsersMutationFn = Apollo.MutationFunction<
  AssignTaskUsersMutation,
  AssignTaskUsersMutationVariables
>;

/**
 * __useAssignTaskUsersMutation__
 *
 * To run a mutation, you first call `useAssignTaskUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTaskUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTaskUsersMutation, { data, loading, error }] = useAssignTaskUsersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      members: // value for 'members'
 *      chatId: // value for 'chatId'
 *      sendCardImmediately: // value for 'sendCardImmediately'
 *      sourceMessageId: // value for 'sourceMessageId'
 *   },
 * });
 */
export function useAssignTaskUsersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignTaskUsersMutation,
    AssignTaskUsersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignTaskUsersMutation,
    AssignTaskUsersMutationVariables
  >(AssignTaskUsersDocument, options);
}
export type AssignTaskUsersMutationHookResult = ReturnType<
  typeof useAssignTaskUsersMutation
>;
export type AssignTaskUsersMutationResult =
  Apollo.MutationResult<AssignTaskUsersMutation>;
export type AssignTaskUsersMutationOptions = Apollo.BaseMutationOptions<
  AssignTaskUsersMutation,
  AssignTaskUsersMutationVariables
>;
export const AssignTeamOwnerDocument = gql`
  mutation assignTeamOwner($id: ID!, $newOwnerId: ID!) {
    assignTeamOwner(id: $id, newOwnerId: $newOwnerId) {
      id
    }
  }
`;
export type AssignTeamOwnerMutationFn = Apollo.MutationFunction<
  AssignTeamOwnerMutation,
  AssignTeamOwnerMutationVariables
>;

/**
 * __useAssignTeamOwnerMutation__
 *
 * To run a mutation, you first call `useAssignTeamOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTeamOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTeamOwnerMutation, { data, loading, error }] = useAssignTeamOwnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newOwnerId: // value for 'newOwnerId'
 *   },
 * });
 */
export function useAssignTeamOwnerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignTeamOwnerMutation,
    AssignTeamOwnerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignTeamOwnerMutation,
    AssignTeamOwnerMutationVariables
  >(AssignTeamOwnerDocument, options);
}
export type AssignTeamOwnerMutationHookResult = ReturnType<
  typeof useAssignTeamOwnerMutation
>;
export type AssignTeamOwnerMutationResult =
  Apollo.MutationResult<AssignTeamOwnerMutation>;
export type AssignTeamOwnerMutationOptions = Apollo.BaseMutationOptions<
  AssignTeamOwnerMutation,
  AssignTeamOwnerMutationVariables
>;
export const CancelStripeSubscriptionDocument = gql`
  mutation cancelStripeSubscription($id: ID!) {
    cancelStripeSubscription(id: $id) {
      id
    }
  }
`;
export type CancelStripeSubscriptionMutationFn = Apollo.MutationFunction<
  CancelStripeSubscriptionMutation,
  CancelStripeSubscriptionMutationVariables
>;

/**
 * __useCancelStripeSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelStripeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelStripeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelStripeSubscriptionMutation, { data, loading, error }] = useCancelStripeSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelStripeSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelStripeSubscriptionMutation,
    CancelStripeSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelStripeSubscriptionMutation,
    CancelStripeSubscriptionMutationVariables
  >(CancelStripeSubscriptionDocument, options);
}
export type CancelStripeSubscriptionMutationHookResult = ReturnType<
  typeof useCancelStripeSubscriptionMutation
>;
export type CancelStripeSubscriptionMutationResult =
  Apollo.MutationResult<CancelStripeSubscriptionMutation>;
export type CancelStripeSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    CancelStripeSubscriptionMutation,
    CancelStripeSubscriptionMutationVariables
  >;
export const ChatBlockUnblockUserDocument = gql`
  mutation chatBlockUnblockUser($userIdToBlock: ID!) {
    chatBlockUnblockUser(userIdToBlock: $userIdToBlock) {
      id
      email
      firstName
      lastName
      avatar {
        ...AvatarDetail
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;
export type ChatBlockUnblockUserMutationFn = Apollo.MutationFunction<
  ChatBlockUnblockUserMutation,
  ChatBlockUnblockUserMutationVariables
>;

/**
 * __useChatBlockUnblockUserMutation__
 *
 * To run a mutation, you first call `useChatBlockUnblockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatBlockUnblockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatBlockUnblockUserMutation, { data, loading, error }] = useChatBlockUnblockUserMutation({
 *   variables: {
 *      userIdToBlock: // value for 'userIdToBlock'
 *   },
 * });
 */
export function useChatBlockUnblockUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChatBlockUnblockUserMutation,
    ChatBlockUnblockUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChatBlockUnblockUserMutation,
    ChatBlockUnblockUserMutationVariables
  >(ChatBlockUnblockUserDocument, options);
}
export type ChatBlockUnblockUserMutationHookResult = ReturnType<
  typeof useChatBlockUnblockUserMutation
>;
export type ChatBlockUnblockUserMutationResult =
  Apollo.MutationResult<ChatBlockUnblockUserMutation>;
export type ChatBlockUnblockUserMutationOptions = Apollo.BaseMutationOptions<
  ChatBlockUnblockUserMutation,
  ChatBlockUnblockUserMutationVariables
>;
export const CompleteTaskDocument = gql`
  mutation completeTask($id: ID!, $chatId: ID) {
    completeTask(id: $id, chatId: $chatId) {
      id
      status
      completedAt
    }
  }
`;
export type CompleteTaskMutationFn = Apollo.MutationFunction<
  CompleteTaskMutation,
  CompleteTaskMutationVariables
>;

/**
 * __useCompleteTaskMutation__
 *
 * To run a mutation, you first call `useCompleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeTaskMutation, { data, loading, error }] = useCompleteTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useCompleteTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteTaskMutation,
    CompleteTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteTaskMutation,
    CompleteTaskMutationVariables
  >(CompleteTaskDocument, options);
}
export type CompleteTaskMutationHookResult = ReturnType<
  typeof useCompleteTaskMutation
>;
export type CompleteTaskMutationResult =
  Apollo.MutationResult<CompleteTaskMutation>;
export type CompleteTaskMutationOptions = Apollo.BaseMutationOptions<
  CompleteTaskMutation,
  CompleteTaskMutationVariables
>;
export const CompleteWebTutorialFlowsDocument = gql`
  mutation completeWebTutorialFlows($flowType: WebTutorialFlow!) {
    completeWebTutorialFlows(flowType: $flowType)
  }
`;
export type CompleteWebTutorialFlowsMutationFn = Apollo.MutationFunction<
  CompleteWebTutorialFlowsMutation,
  CompleteWebTutorialFlowsMutationVariables
>;

/**
 * __useCompleteWebTutorialFlowsMutation__
 *
 * To run a mutation, you first call `useCompleteWebTutorialFlowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteWebTutorialFlowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeWebTutorialFlowsMutation, { data, loading, error }] = useCompleteWebTutorialFlowsMutation({
 *   variables: {
 *      flowType: // value for 'flowType'
 *   },
 * });
 */
export function useCompleteWebTutorialFlowsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteWebTutorialFlowsMutation,
    CompleteWebTutorialFlowsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteWebTutorialFlowsMutation,
    CompleteWebTutorialFlowsMutationVariables
  >(CompleteWebTutorialFlowsDocument, options);
}
export type CompleteWebTutorialFlowsMutationHookResult = ReturnType<
  typeof useCompleteWebTutorialFlowsMutation
>;
export type CompleteWebTutorialFlowsMutationResult =
  Apollo.MutationResult<CompleteWebTutorialFlowsMutation>;
export type CompleteWebTutorialFlowsMutationOptions =
  Apollo.BaseMutationOptions<
    CompleteWebTutorialFlowsMutation,
    CompleteWebTutorialFlowsMutationVariables
  >;
export const ConvertProjectChecklistToTaskDocument = gql`
  mutation convertProjectChecklistToTask($projectChecklistIds: [ID!]!) {
    convertProjectChecklistToTask(projectChecklistIds: $projectChecklistIds) {
      projectId
      id
      name
    }
  }
`;
export type ConvertProjectChecklistToTaskMutationFn = Apollo.MutationFunction<
  ConvertProjectChecklistToTaskMutation,
  ConvertProjectChecklistToTaskMutationVariables
>;

/**
 * __useConvertProjectChecklistToTaskMutation__
 *
 * To run a mutation, you first call `useConvertProjectChecklistToTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertProjectChecklistToTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertProjectChecklistToTaskMutation, { data, loading, error }] = useConvertProjectChecklistToTaskMutation({
 *   variables: {
 *      projectChecklistIds: // value for 'projectChecklistIds'
 *   },
 * });
 */
export function useConvertProjectChecklistToTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConvertProjectChecklistToTaskMutation,
    ConvertProjectChecklistToTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConvertProjectChecklistToTaskMutation,
    ConvertProjectChecklistToTaskMutationVariables
  >(ConvertProjectChecklistToTaskDocument, options);
}
export type ConvertProjectChecklistToTaskMutationHookResult = ReturnType<
  typeof useConvertProjectChecklistToTaskMutation
>;
export type ConvertProjectChecklistToTaskMutationResult =
  Apollo.MutationResult<ConvertProjectChecklistToTaskMutation>;
export type ConvertProjectChecklistToTaskMutationOptions =
  Apollo.BaseMutationOptions<
    ConvertProjectChecklistToTaskMutation,
    ConvertProjectChecklistToTaskMutationVariables
  >;
export const CreateChatDocument = gql`
  mutation CreateChat($attributes: ChatAttributes!) {
    createChat(attributes: $attributes) {
      ...GetChatDetail
    }
  }
  ${GetChatDetailFragmentDoc}
`;
export type CreateChatMutationFn = Apollo.MutationFunction<
  CreateChatMutation,
  CreateChatMutationVariables
>;

/**
 * __useCreateChatMutation__
 *
 * To run a mutation, you first call `useCreateChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatMutation, { data, loading, error }] = useCreateChatMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateChatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateChatMutation,
    CreateChatMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateChatMutation, CreateChatMutationVariables>(
    CreateChatDocument,
    options
  );
}
export type CreateChatMutationHookResult = ReturnType<
  typeof useCreateChatMutation
>;
export type CreateChatMutationResult =
  Apollo.MutationResult<CreateChatMutation>;
export type CreateChatMutationOptions = Apollo.BaseMutationOptions<
  CreateChatMutation,
  CreateChatMutationVariables
>;
export const CreateChatInvitationDocument = gql`
  mutation createChatInvitation($chatId: ID!, $emails: [String!]!) {
    createChatInvitation(id: $chatId, emails: $emails) {
      id
      name
    }
  }
`;
export type CreateChatInvitationMutationFn = Apollo.MutationFunction<
  CreateChatInvitationMutation,
  CreateChatInvitationMutationVariables
>;

/**
 * __useCreateChatInvitationMutation__
 *
 * To run a mutation, you first call `useCreateChatInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatInvitationMutation, { data, loading, error }] = useCreateChatInvitationMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useCreateChatInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateChatInvitationMutation,
    CreateChatInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateChatInvitationMutation,
    CreateChatInvitationMutationVariables
  >(CreateChatInvitationDocument, options);
}
export type CreateChatInvitationMutationHookResult = ReturnType<
  typeof useCreateChatInvitationMutation
>;
export type CreateChatInvitationMutationResult =
  Apollo.MutationResult<CreateChatInvitationMutation>;
export type CreateChatInvitationMutationOptions = Apollo.BaseMutationOptions<
  CreateChatInvitationMutation,
  CreateChatInvitationMutationVariables
>;
export const CreateChatInviteDocument = gql`
  mutation createChatInvite($chatId: ID!) {
    createInvite(chatId: $chatId)
  }
`;
export type CreateChatInviteMutationFn = Apollo.MutationFunction<
  CreateChatInviteMutation,
  CreateChatInviteMutationVariables
>;

/**
 * __useCreateChatInviteMutation__
 *
 * To run a mutation, you first call `useCreateChatInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatInviteMutation, { data, loading, error }] = useCreateChatInviteMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useCreateChatInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateChatInviteMutation,
    CreateChatInviteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateChatInviteMutation,
    CreateChatInviteMutationVariables
  >(CreateChatInviteDocument, options);
}
export type CreateChatInviteMutationHookResult = ReturnType<
  typeof useCreateChatInviteMutation
>;
export type CreateChatInviteMutationResult =
  Apollo.MutationResult<CreateChatInviteMutation>;
export type CreateChatInviteMutationOptions = Apollo.BaseMutationOptions<
  CreateChatInviteMutation,
  CreateChatInviteMutationVariables
>;
export const CreateContactInvitationUrlDocument = gql`
  mutation createContactInvitationUrl(
    $attributes: CreateContactInvitationUrlAttributes!
  ) {
    createContactInvitationUrl(attributes: $attributes)
  }
`;
export type CreateContactInvitationUrlMutationFn = Apollo.MutationFunction<
  CreateContactInvitationUrlMutation,
  CreateContactInvitationUrlMutationVariables
>;

/**
 * __useCreateContactInvitationUrlMutation__
 *
 * To run a mutation, you first call `useCreateContactInvitationUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactInvitationUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactInvitationUrlMutation, { data, loading, error }] = useCreateContactInvitationUrlMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateContactInvitationUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateContactInvitationUrlMutation,
    CreateContactInvitationUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateContactInvitationUrlMutation,
    CreateContactInvitationUrlMutationVariables
  >(CreateContactInvitationUrlDocument, options);
}
export type CreateContactInvitationUrlMutationHookResult = ReturnType<
  typeof useCreateContactInvitationUrlMutation
>;
export type CreateContactInvitationUrlMutationResult =
  Apollo.MutationResult<CreateContactInvitationUrlMutation>;
export type CreateContactInvitationUrlMutationOptions =
  Apollo.BaseMutationOptions<
    CreateContactInvitationUrlMutation,
    CreateContactInvitationUrlMutationVariables
  >;
export const CreateDeviceDocument = gql`
  mutation createDevice($attributes: DeviceAttributes!) {
    createDevice(attributes: $attributes) {
      token
    }
  }
`;
export type CreateDeviceMutationFn = Apollo.MutationFunction<
  CreateDeviceMutation,
  CreateDeviceMutationVariables
>;

/**
 * __useCreateDeviceMutation__
 *
 * To run a mutation, you first call `useCreateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviceMutation, { data, loading, error }] = useCreateDeviceMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDeviceMutation,
    CreateDeviceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDeviceMutation,
    CreateDeviceMutationVariables
  >(CreateDeviceDocument, options);
}
export type CreateDeviceMutationHookResult = ReturnType<
  typeof useCreateDeviceMutation
>;
export type CreateDeviceMutationResult =
  Apollo.MutationResult<CreateDeviceMutation>;
export type CreateDeviceMutationOptions = Apollo.BaseMutationOptions<
  CreateDeviceMutation,
  CreateDeviceMutationVariables
>;
export const CreateDirectUploadsDocument = gql`
  mutation createDirectUploads($attributes: [DirectUploadAttributes!]!) {
    createDirectUploads(attributes: $attributes) {
      clientId
      url
      headers
      blobId
      signedBlobId
    }
  }
`;
export type CreateDirectUploadsMutationFn = Apollo.MutationFunction<
  CreateDirectUploadsMutation,
  CreateDirectUploadsMutationVariables
>;

/**
 * __useCreateDirectUploadsMutation__
 *
 * To run a mutation, you first call `useCreateDirectUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDirectUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDirectUploadsMutation, { data, loading, error }] = useCreateDirectUploadsMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateDirectUploadsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDirectUploadsMutation,
    CreateDirectUploadsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDirectUploadsMutation,
    CreateDirectUploadsMutationVariables
  >(CreateDirectUploadsDocument, options);
}
export type CreateDirectUploadsMutationHookResult = ReturnType<
  typeof useCreateDirectUploadsMutation
>;
export type CreateDirectUploadsMutationResult =
  Apollo.MutationResult<CreateDirectUploadsMutation>;
export type CreateDirectUploadsMutationOptions = Apollo.BaseMutationOptions<
  CreateDirectUploadsMutation,
  CreateDirectUploadsMutationVariables
>;
export const CreateGroupDocument = gql`
  mutation createGroup($attributes: GroupAttributes!) {
    createGroup(attributes: $attributes) {
      id
      name
      team {
        id
        name
      }
      users {
        id
        name
        avatar {
          ...AvatarDetail
        }
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;
export type CreateGroupMutationFn = Apollo.MutationFunction<
  CreateGroupMutation,
  CreateGroupMutationVariables
>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateGroupMutation,
    CreateGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(
    CreateGroupDocument,
    options
  );
}
export type CreateGroupMutationHookResult = ReturnType<
  typeof useCreateGroupMutation
>;
export type CreateGroupMutationResult =
  Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateGroupMutation,
  CreateGroupMutationVariables
>;
export const CreateInviteDocument = gql`
  mutation createInvite($projectId: ID, $taskId: ID) {
    createInvite(taskId: $taskId, projectId: $projectId)
  }
`;
export type CreateInviteMutationFn = Apollo.MutationFunction<
  CreateInviteMutation,
  CreateInviteMutationVariables
>;

/**
 * __useCreateInviteMutation__
 *
 * To run a mutation, you first call `useCreateInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInviteMutation, { data, loading, error }] = useCreateInviteMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useCreateInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInviteMutation,
    CreateInviteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateInviteMutation,
    CreateInviteMutationVariables
  >(CreateInviteDocument, options);
}
export type CreateInviteMutationHookResult = ReturnType<
  typeof useCreateInviteMutation
>;
export type CreateInviteMutationResult =
  Apollo.MutationResult<CreateInviteMutation>;
export type CreateInviteMutationOptions = Apollo.BaseMutationOptions<
  CreateInviteMutation,
  CreateInviteMutationVariables
>;
export const CreateMediaShareLinkDocument = gql`
  mutation createMediaShareLink($documentIds: [ID!]!) {
    createMediaShareLink(documentIds: $documentIds) {
      token
    }
  }
`;
export type CreateMediaShareLinkMutationFn = Apollo.MutationFunction<
  CreateMediaShareLinkMutation,
  CreateMediaShareLinkMutationVariables
>;

/**
 * __useCreateMediaShareLinkMutation__
 *
 * To run a mutation, you first call `useCreateMediaShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMediaShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMediaShareLinkMutation, { data, loading, error }] = useCreateMediaShareLinkMutation({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useCreateMediaShareLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMediaShareLinkMutation,
    CreateMediaShareLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMediaShareLinkMutation,
    CreateMediaShareLinkMutationVariables
  >(CreateMediaShareLinkDocument, options);
}
export type CreateMediaShareLinkMutationHookResult = ReturnType<
  typeof useCreateMediaShareLinkMutation
>;
export type CreateMediaShareLinkMutationResult =
  Apollo.MutationResult<CreateMediaShareLinkMutation>;
export type CreateMediaShareLinkMutationOptions = Apollo.BaseMutationOptions<
  CreateMediaShareLinkMutation,
  CreateMediaShareLinkMutationVariables
>;
export const CreateMessageIndividualDocument = gql`
  mutation createMessageIndividual($attributes: MessageAttributes!) {
    createMessageIndividual(attributes: $attributes) {
      id
      chatId
      clientId
      body
      createdAt
      isSender
      isDraft
      publishedAt
      authorId
      author {
        ...UserDetail
        avatar {
          ...AvatarDetail
        }
      }
      chat {
        id
        name
      }
      replyMessage {
        id
        chatId
        clientId
        body
        createdAt
        isSender
        isDraft
        publishedAt
        authorId
        author {
          ...UserDetail
        }
      }
      attachments {
        ... on MessageTask {
          id
          authorId
          author {
            ...UserDetail
          }
          task {
            id
            projectId
            name
          }
        }
        ... on MessageProject {
          id
          authorId
          author {
            ...UserDetail
          }
          project {
            id
            uuid
            name
          }
        }
        ... on Document {
          id
          blobId
          name
          contentType
          createdAt
          size
          isImage
          isVideo
          clientId
          isAudio
          duration
          file {
            ...FileDetails
          }
          owner {
            id
            name
            firstName
            lastName
            createdAt
            avatar {
              ...AvatarDetail
            }
          }
          taskDocuments {
            id
            owner {
              id
            }
            task {
              id
              name
              projectId
              project {
                id
                name
              }
            }
          }
          projectDocuments {
            id
            owner {
              id
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
  ${UserDetailFragmentDoc}
  ${AvatarDetailFragmentDoc}
  ${FileDetailsFragmentDoc}
`;
export type CreateMessageIndividualMutationFn = Apollo.MutationFunction<
  CreateMessageIndividualMutation,
  CreateMessageIndividualMutationVariables
>;

/**
 * __useCreateMessageIndividualMutation__
 *
 * To run a mutation, you first call `useCreateMessageIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageIndividualMutation, { data, loading, error }] = useCreateMessageIndividualMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateMessageIndividualMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMessageIndividualMutation,
    CreateMessageIndividualMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMessageIndividualMutation,
    CreateMessageIndividualMutationVariables
  >(CreateMessageIndividualDocument, options);
}
export type CreateMessageIndividualMutationHookResult = ReturnType<
  typeof useCreateMessageIndividualMutation
>;
export type CreateMessageIndividualMutationResult =
  Apollo.MutationResult<CreateMessageIndividualMutation>;
export type CreateMessageIndividualMutationOptions = Apollo.BaseMutationOptions<
  CreateMessageIndividualMutation,
  CreateMessageIndividualMutationVariables
>;
export const CreateMessageReactionDocument = gql`
  mutation createMessageReaction($messageId: ID!, $reaction: String!) {
    createMessageReaction(messageId: $messageId, reaction: $reaction) {
      count
      id
      reaction
      reactionId
    }
  }
`;
export type CreateMessageReactionMutationFn = Apollo.MutationFunction<
  CreateMessageReactionMutation,
  CreateMessageReactionMutationVariables
>;

/**
 * __useCreateMessageReactionMutation__
 *
 * To run a mutation, you first call `useCreateMessageReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageReactionMutation, { data, loading, error }] = useCreateMessageReactionMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      reaction: // value for 'reaction'
 *   },
 * });
 */
export function useCreateMessageReactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMessageReactionMutation,
    CreateMessageReactionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMessageReactionMutation,
    CreateMessageReactionMutationVariables
  >(CreateMessageReactionDocument, options);
}
export type CreateMessageReactionMutationHookResult = ReturnType<
  typeof useCreateMessageReactionMutation
>;
export type CreateMessageReactionMutationResult =
  Apollo.MutationResult<CreateMessageReactionMutation>;
export type CreateMessageReactionMutationOptions = Apollo.BaseMutationOptions<
  CreateMessageReactionMutation,
  CreateMessageReactionMutationVariables
>;
export const CreatePhaseDocument = gql`
  mutation createPhase($attributes: PhaseAttributes!) {
    createPhase(attributes: $attributes) {
      id
      name
    }
  }
`;
export type CreatePhaseMutationFn = Apollo.MutationFunction<
  CreatePhaseMutation,
  CreatePhaseMutationVariables
>;

/**
 * __useCreatePhaseMutation__
 *
 * To run a mutation, you first call `useCreatePhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhaseMutation, { data, loading, error }] = useCreatePhaseMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreatePhaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePhaseMutation,
    CreatePhaseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePhaseMutation, CreatePhaseMutationVariables>(
    CreatePhaseDocument,
    options
  );
}
export type CreatePhaseMutationHookResult = ReturnType<
  typeof useCreatePhaseMutation
>;
export type CreatePhaseMutationResult =
  Apollo.MutationResult<CreatePhaseMutation>;
export type CreatePhaseMutationOptions = Apollo.BaseMutationOptions<
  CreatePhaseMutation,
  CreatePhaseMutationVariables
>;
export const CreateProjectDocument = gql`
  mutation createProject($attributes: ProjectAttributes!) {
    createProject(attributes: $attributes) {
      id
      uuid
      name
      description
      address
      latitude
      longitude
      color
      icon
      createdAt
      creator {
        ...UserDetail
      }
      team {
        id
        name
        avatar
        personal
      }
      members {
        id
        role
        user {
          ...UserDetail
        }
      }
      invitations {
        email
        role
        expiredAt
      }
    }
  }
  ${UserDetailFragmentDoc}
`;
export type CreateProjectMutationFn = Apollo.MutationFunction<
  CreateProjectMutation,
  CreateProjectMutationVariables
>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProjectMutation,
    CreateProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateProjectMutation,
    CreateProjectMutationVariables
  >(CreateProjectDocument, options);
}
export type CreateProjectMutationHookResult = ReturnType<
  typeof useCreateProjectMutation
>;
export type CreateProjectMutationResult =
  Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<
  CreateProjectMutation,
  CreateProjectMutationVariables
>;
export const CreateProjectInvitationDocument = gql`
  mutation createProjectInvitation(
    $projectId: ID!
    $projectMembers: [ProjectMemberRoleAttributes!]!
  ) {
    createProjectInvitation(id: $projectId, projectMembers: $projectMembers) {
      id
      name
      invitations {
        id
        email
        role
        expiredAt
        createdAt
        invitedBy {
          id
          name
          firstName
          lastName
          avatar {
            id
            cdnBaseUrl
            path
            isPreviewable
            thumbnail
          }
        }
      }
    }
  }
`;
export type CreateProjectInvitationMutationFn = Apollo.MutationFunction<
  CreateProjectInvitationMutation,
  CreateProjectInvitationMutationVariables
>;

/**
 * __useCreateProjectInvitationMutation__
 *
 * To run a mutation, you first call `useCreateProjectInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectInvitationMutation, { data, loading, error }] = useCreateProjectInvitationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      projectMembers: // value for 'projectMembers'
 *   },
 * });
 */
export function useCreateProjectInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProjectInvitationMutation,
    CreateProjectInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateProjectInvitationMutation,
    CreateProjectInvitationMutationVariables
  >(CreateProjectInvitationDocument, options);
}
export type CreateProjectInvitationMutationHookResult = ReturnType<
  typeof useCreateProjectInvitationMutation
>;
export type CreateProjectInvitationMutationResult =
  Apollo.MutationResult<CreateProjectInvitationMutation>;
export type CreateProjectInvitationMutationOptions = Apollo.BaseMutationOptions<
  CreateProjectInvitationMutation,
  CreateProjectInvitationMutationVariables
>;
export const CreateShareLinkDocument = gql`
  mutation createShareLink($documentIds: [ID!]!) {
    createShareLink(documentIds: $documentIds) {
      sharedUrl
    }
  }
`;
export type CreateShareLinkMutationFn = Apollo.MutationFunction<
  CreateShareLinkMutation,
  CreateShareLinkMutationVariables
>;

/**
 * __useCreateShareLinkMutation__
 *
 * To run a mutation, you first call `useCreateShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShareLinkMutation, { data, loading, error }] = useCreateShareLinkMutation({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useCreateShareLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateShareLinkMutation,
    CreateShareLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateShareLinkMutation,
    CreateShareLinkMutationVariables
  >(CreateShareLinkDocument, options);
}
export type CreateShareLinkMutationHookResult = ReturnType<
  typeof useCreateShareLinkMutation
>;
export type CreateShareLinkMutationResult =
  Apollo.MutationResult<CreateShareLinkMutation>;
export type CreateShareLinkMutationOptions = Apollo.BaseMutationOptions<
  CreateShareLinkMutation,
  CreateShareLinkMutationVariables
>;
export const CreateStripeSubscriptionDocument = gql`
  mutation createStripeSubscription(
    $teamAttributes: TeamAttributes
    $stripeSubscriptionAttributes: StripeSubscriptionAttributes!
  ) {
    createStripeSubscription(
      teamAttributes: $teamAttributes
      stripeSubscriptionAttributes: $stripeSubscriptionAttributes
    ) {
      clientSecret
      id
      intentType
      team {
        id
        uuid
      }
    }
  }
`;
export type CreateStripeSubscriptionMutationFn = Apollo.MutationFunction<
  CreateStripeSubscriptionMutation,
  CreateStripeSubscriptionMutationVariables
>;

/**
 * __useCreateStripeSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateStripeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeSubscriptionMutation, { data, loading, error }] = useCreateStripeSubscriptionMutation({
 *   variables: {
 *      teamAttributes: // value for 'teamAttributes'
 *      stripeSubscriptionAttributes: // value for 'stripeSubscriptionAttributes'
 *   },
 * });
 */
export function useCreateStripeSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateStripeSubscriptionMutation,
    CreateStripeSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateStripeSubscriptionMutation,
    CreateStripeSubscriptionMutationVariables
  >(CreateStripeSubscriptionDocument, options);
}
export type CreateStripeSubscriptionMutationHookResult = ReturnType<
  typeof useCreateStripeSubscriptionMutation
>;
export type CreateStripeSubscriptionMutationResult =
  Apollo.MutationResult<CreateStripeSubscriptionMutation>;
export type CreateStripeSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    CreateStripeSubscriptionMutation,
    CreateStripeSubscriptionMutationVariables
  >;
export const CreateTaskDocument = gql`
  mutation createTask(
    $attributes: TaskAttributes!
    $chatId: ID
    $sourceMessageId: ID
  ) {
    createTask(
      attributes: $attributes
      chatId: $chatId
      sourceMessageId: $sourceMessageId
    ) {
      ...TaskDetail
    }
  }
  ${TaskDetailFragmentDoc}
`;
export type CreateTaskMutationFn = Apollo.MutationFunction<
  CreateTaskMutation,
  CreateTaskMutationVariables
>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      chatId: // value for 'chatId'
 *      sourceMessageId: // value for 'sourceMessageId'
 *   },
 * });
 */
export function useCreateTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTaskMutation,
    CreateTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(
    CreateTaskDocument,
    options
  );
}
export type CreateTaskMutationHookResult = ReturnType<
  typeof useCreateTaskMutation
>;
export type CreateTaskMutationResult =
  Apollo.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<
  CreateTaskMutation,
  CreateTaskMutationVariables
>;
export const CreateTaskInvitationDocument = gql`
  mutation createTaskInvitation(
    $taskId: ID!
    $taskMembers: [TaskMemberRoleAttributes!]!
  ) {
    createTaskInvitation(id: $taskId, taskMembers: $taskMembers) {
      id
      name
      invitations {
        email
        role
        expiredAt
      }
      userRequests {
        id
        role
        user {
          id
          email
        }
        expiredAt
      }
    }
  }
`;
export type CreateTaskInvitationMutationFn = Apollo.MutationFunction<
  CreateTaskInvitationMutation,
  CreateTaskInvitationMutationVariables
>;

/**
 * __useCreateTaskInvitationMutation__
 *
 * To run a mutation, you first call `useCreateTaskInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskInvitationMutation, { data, loading, error }] = useCreateTaskInvitationMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      taskMembers: // value for 'taskMembers'
 *   },
 * });
 */
export function useCreateTaskInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTaskInvitationMutation,
    CreateTaskInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTaskInvitationMutation,
    CreateTaskInvitationMutationVariables
  >(CreateTaskInvitationDocument, options);
}
export type CreateTaskInvitationMutationHookResult = ReturnType<
  typeof useCreateTaskInvitationMutation
>;
export type CreateTaskInvitationMutationResult =
  Apollo.MutationResult<CreateTaskInvitationMutation>;
export type CreateTaskInvitationMutationOptions = Apollo.BaseMutationOptions<
  CreateTaskInvitationMutation,
  CreateTaskInvitationMutationVariables
>;
export const CreateTeamDocument = gql`
  mutation createTeam($attributes: TeamAttributes!, $billingSource: String) {
    createTeam(attributes: $attributes, billingSource: $billingSource) {
      ...TeamDetail
      ...TeamMembersDetail
    }
  }
  ${TeamDetailFragmentDoc}
  ${TeamMembersDetailFragmentDoc}
`;
export type CreateTeamMutationFn = Apollo.MutationFunction<
  CreateTeamMutation,
  CreateTeamMutationVariables
>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      billingSource: // value for 'billingSource'
 *   },
 * });
 */
export function useCreateTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTeamMutation,
    CreateTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(
    CreateTeamDocument,
    options
  );
}
export type CreateTeamMutationHookResult = ReturnType<
  typeof useCreateTeamMutation
>;
export type CreateTeamMutationResult =
  Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<
  CreateTeamMutation,
  CreateTeamMutationVariables
>;
export const CreateTeamInvitationDocument = gql`
  mutation createTeamInvitation($id: ID!) {
    createTeamInvitation(id: $id)
  }
`;
export type CreateTeamInvitationMutationFn = Apollo.MutationFunction<
  CreateTeamInvitationMutation,
  CreateTeamInvitationMutationVariables
>;

/**
 * __useCreateTeamInvitationMutation__
 *
 * To run a mutation, you first call `useCreateTeamInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamInvitationMutation, { data, loading, error }] = useCreateTeamInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateTeamInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTeamInvitationMutation,
    CreateTeamInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTeamInvitationMutation,
    CreateTeamInvitationMutationVariables
  >(CreateTeamInvitationDocument, options);
}
export type CreateTeamInvitationMutationHookResult = ReturnType<
  typeof useCreateTeamInvitationMutation
>;
export type CreateTeamInvitationMutationResult =
  Apollo.MutationResult<CreateTeamInvitationMutation>;
export type CreateTeamInvitationMutationOptions = Apollo.BaseMutationOptions<
  CreateTeamInvitationMutation,
  CreateTeamInvitationMutationVariables
>;
export const CreateTeamMemberInvitationDocument = gql`
  mutation createTeamMemberInvitation(
    $id: ID!
    $teamMembers: [TeamMemberRoleAttributes!]!
  ) {
    createTeamMemberInvitation(id: $id, teamMembers: $teamMembers) {
      ...TeamDetail
      ...TeamMembersDetail
    }
  }
  ${TeamDetailFragmentDoc}
  ${TeamMembersDetailFragmentDoc}
`;
export type CreateTeamMemberInvitationMutationFn = Apollo.MutationFunction<
  CreateTeamMemberInvitationMutation,
  CreateTeamMemberInvitationMutationVariables
>;

/**
 * __useCreateTeamMemberInvitationMutation__
 *
 * To run a mutation, you first call `useCreateTeamMemberInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMemberInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMemberInvitationMutation, { data, loading, error }] = useCreateTeamMemberInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      teamMembers: // value for 'teamMembers'
 *   },
 * });
 */
export function useCreateTeamMemberInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTeamMemberInvitationMutation,
    CreateTeamMemberInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTeamMemberInvitationMutation,
    CreateTeamMemberInvitationMutationVariables
  >(CreateTeamMemberInvitationDocument, options);
}
export type CreateTeamMemberInvitationMutationHookResult = ReturnType<
  typeof useCreateTeamMemberInvitationMutation
>;
export type CreateTeamMemberInvitationMutationResult =
  Apollo.MutationResult<CreateTeamMemberInvitationMutation>;
export type CreateTeamMemberInvitationMutationOptions =
  Apollo.BaseMutationOptions<
    CreateTeamMemberInvitationMutation,
    CreateTeamMemberInvitationMutationVariables
  >;
export const CreateUserRequestDocument = gql`
  mutation createUserRequest($attributes: UserRequestAttributes!) {
    createUserRequest(attributes: $attributes) {
      id
      requestType
      status
      userRequestableType
      userRequestableId
    }
  }
`;
export type CreateUserRequestMutationFn = Apollo.MutationFunction<
  CreateUserRequestMutation,
  CreateUserRequestMutationVariables
>;

/**
 * __useCreateUserRequestMutation__
 *
 * To run a mutation, you first call `useCreateUserRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserRequestMutation, { data, loading, error }] = useCreateUserRequestMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateUserRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserRequestMutation,
    CreateUserRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateUserRequestMutation,
    CreateUserRequestMutationVariables
  >(CreateUserRequestDocument, options);
}
export type CreateUserRequestMutationHookResult = ReturnType<
  typeof useCreateUserRequestMutation
>;
export type CreateUserRequestMutationResult =
  Apollo.MutationResult<CreateUserRequestMutation>;
export type CreateUserRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateUserRequestMutation,
  CreateUserRequestMutationVariables
>;
export const DeleteChatInvitationDocument = gql`
  mutation deleteChatInvitation($chatInvitationId: ID!) {
    deleteChatInvitation(chatInvitationId: $chatInvitationId)
  }
`;
export type DeleteChatInvitationMutationFn = Apollo.MutationFunction<
  DeleteChatInvitationMutation,
  DeleteChatInvitationMutationVariables
>;

/**
 * __useDeleteChatInvitationMutation__
 *
 * To run a mutation, you first call `useDeleteChatInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatInvitationMutation, { data, loading, error }] = useDeleteChatInvitationMutation({
 *   variables: {
 *      chatInvitationId: // value for 'chatInvitationId'
 *   },
 * });
 */
export function useDeleteChatInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteChatInvitationMutation,
    DeleteChatInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteChatInvitationMutation,
    DeleteChatInvitationMutationVariables
  >(DeleteChatInvitationDocument, options);
}
export type DeleteChatInvitationMutationHookResult = ReturnType<
  typeof useDeleteChatInvitationMutation
>;
export type DeleteChatInvitationMutationResult =
  Apollo.MutationResult<DeleteChatInvitationMutation>;
export type DeleteChatInvitationMutationOptions = Apollo.BaseMutationOptions<
  DeleteChatInvitationMutation,
  DeleteChatInvitationMutationVariables
>;
export const DeleteDeviceDocument = gql`
  mutation deleteDevice($expoToken: String!, $apiToken: String!) {
    deleteDevice(expoToken: $expoToken, apiToken: $apiToken) {
      id
    }
  }
`;
export type DeleteDeviceMutationFn = Apollo.MutationFunction<
  DeleteDeviceMutation,
  DeleteDeviceMutationVariables
>;

/**
 * __useDeleteDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceMutation, { data, loading, error }] = useDeleteDeviceMutation({
 *   variables: {
 *      expoToken: // value for 'expoToken'
 *      apiToken: // value for 'apiToken'
 *   },
 * });
 */
export function useDeleteDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDeviceMutation,
    DeleteDeviceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDeviceMutation,
    DeleteDeviceMutationVariables
  >(DeleteDeviceDocument, options);
}
export type DeleteDeviceMutationHookResult = ReturnType<
  typeof useDeleteDeviceMutation
>;
export type DeleteDeviceMutationResult =
  Apollo.MutationResult<DeleteDeviceMutation>;
export type DeleteDeviceMutationOptions = Apollo.BaseMutationOptions<
  DeleteDeviceMutation,
  DeleteDeviceMutationVariables
>;
export const DeleteDirectUploadsDocument = gql`
  mutation deleteDirectUploads($blobId: ID!) {
    deleteDirectUploads(blobId: $blobId)
  }
`;
export type DeleteDirectUploadsMutationFn = Apollo.MutationFunction<
  DeleteDirectUploadsMutation,
  DeleteDirectUploadsMutationVariables
>;

/**
 * __useDeleteDirectUploadsMutation__
 *
 * To run a mutation, you first call `useDeleteDirectUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDirectUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDirectUploadsMutation, { data, loading, error }] = useDeleteDirectUploadsMutation({
 *   variables: {
 *      blobId: // value for 'blobId'
 *   },
 * });
 */
export function useDeleteDirectUploadsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDirectUploadsMutation,
    DeleteDirectUploadsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDirectUploadsMutation,
    DeleteDirectUploadsMutationVariables
  >(DeleteDirectUploadsDocument, options);
}
export type DeleteDirectUploadsMutationHookResult = ReturnType<
  typeof useDeleteDirectUploadsMutation
>;
export type DeleteDirectUploadsMutationResult =
  Apollo.MutationResult<DeleteDirectUploadsMutation>;
export type DeleteDirectUploadsMutationOptions = Apollo.BaseMutationOptions<
  DeleteDirectUploadsMutation,
  DeleteDirectUploadsMutationVariables
>;
export const DeleteFriendRequestDocument = gql`
  mutation DeleteFriendRequest($id: ID!, $friendRequest: Boolean!) {
    deleteFriendRequest(id: $id, friendRequest: $friendRequest) {
      id
    }
  }
`;
export type DeleteFriendRequestMutationFn = Apollo.MutationFunction<
  DeleteFriendRequestMutation,
  DeleteFriendRequestMutationVariables
>;

/**
 * __useDeleteFriendRequestMutation__
 *
 * To run a mutation, you first call `useDeleteFriendRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFriendRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFriendRequestMutation, { data, loading, error }] = useDeleteFriendRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      friendRequest: // value for 'friendRequest'
 *   },
 * });
 */
export function useDeleteFriendRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFriendRequestMutation,
    DeleteFriendRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteFriendRequestMutation,
    DeleteFriendRequestMutationVariables
  >(DeleteFriendRequestDocument, options);
}
export type DeleteFriendRequestMutationHookResult = ReturnType<
  typeof useDeleteFriendRequestMutation
>;
export type DeleteFriendRequestMutationResult =
  Apollo.MutationResult<DeleteFriendRequestMutation>;
export type DeleteFriendRequestMutationOptions = Apollo.BaseMutationOptions<
  DeleteFriendRequestMutation,
  DeleteFriendRequestMutationVariables
>;
export const DeleteGroupDocument = gql`
  mutation deleteGroup($id: ID!) {
    deleteGroup(id: $id) {
      id
    }
  }
`;
export type DeleteGroupMutationFn = Apollo.MutationFunction<
  DeleteGroupMutation,
  DeleteGroupMutationVariables
>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteGroupMutation,
    DeleteGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(
    DeleteGroupDocument,
    options
  );
}
export type DeleteGroupMutationHookResult = ReturnType<
  typeof useDeleteGroupMutation
>;
export type DeleteGroupMutationResult =
  Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteGroupMutation,
  DeleteGroupMutationVariables
>;
export const DeleteGroupChatDocument = gql`
  mutation deleteGroupChat($id: ID!) {
    deleteGroupChat(id: $id) {
      id
    }
  }
`;
export type DeleteGroupChatMutationFn = Apollo.MutationFunction<
  DeleteGroupChatMutation,
  DeleteGroupChatMutationVariables
>;

/**
 * __useDeleteGroupChatMutation__
 *
 * To run a mutation, you first call `useDeleteGroupChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupChatMutation, { data, loading, error }] = useDeleteGroupChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGroupChatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteGroupChatMutation,
    DeleteGroupChatMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteGroupChatMutation,
    DeleteGroupChatMutationVariables
  >(DeleteGroupChatDocument, options);
}
export type DeleteGroupChatMutationHookResult = ReturnType<
  typeof useDeleteGroupChatMutation
>;
export type DeleteGroupChatMutationResult =
  Apollo.MutationResult<DeleteGroupChatMutation>;
export type DeleteGroupChatMutationOptions = Apollo.BaseMutationOptions<
  DeleteGroupChatMutation,
  DeleteGroupChatMutationVariables
>;
export const DeleteMessageDocument = gql`
  mutation deleteMessage($id: ID!) {
    deleteMessage(id: $id) {
      id
      clientId
      authorId
    }
  }
`;
export type DeleteMessageMutationFn = Apollo.MutationFunction<
  DeleteMessageMutation,
  DeleteMessageMutationVariables
>;

/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMessageMutation,
    DeleteMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteMessageMutation,
    DeleteMessageMutationVariables
  >(DeleteMessageDocument, options);
}
export type DeleteMessageMutationHookResult = ReturnType<
  typeof useDeleteMessageMutation
>;
export type DeleteMessageMutationResult =
  Apollo.MutationResult<DeleteMessageMutation>;
export type DeleteMessageMutationOptions = Apollo.BaseMutationOptions<
  DeleteMessageMutation,
  DeleteMessageMutationVariables
>;
export const DeleteMessageDocumentDocument = gql`
  mutation deleteMessageDocument($id: ID!) {
    deleteMessageDocument(id: $id) {
      id
      clientId
    }
  }
`;
export type DeleteMessageDocumentMutationFn = Apollo.MutationFunction<
  DeleteMessageDocumentMutation,
  DeleteMessageDocumentMutationVariables
>;

/**
 * __useDeleteMessageDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteMessageDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageDocumentMutation, { data, loading, error }] = useDeleteMessageDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMessageDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMessageDocumentMutation,
    DeleteMessageDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteMessageDocumentMutation,
    DeleteMessageDocumentMutationVariables
  >(DeleteMessageDocumentDocument, options);
}
export type DeleteMessageDocumentMutationHookResult = ReturnType<
  typeof useDeleteMessageDocumentMutation
>;
export type DeleteMessageDocumentMutationResult =
  Apollo.MutationResult<DeleteMessageDocumentMutation>;
export type DeleteMessageDocumentMutationOptions = Apollo.BaseMutationOptions<
  DeleteMessageDocumentMutation,
  DeleteMessageDocumentMutationVariables
>;
export const DeleteProjectDocument = gql`
  mutation deleteProject($id: ID!) {
    deleteProject(id: $id) {
      id
    }
  }
`;
export type DeleteProjectMutationFn = Apollo.MutationFunction<
  DeleteProjectMutation,
  DeleteProjectMutationVariables
>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteProjectMutation,
    DeleteProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteProjectMutation,
    DeleteProjectMutationVariables
  >(DeleteProjectDocument, options);
}
export type DeleteProjectMutationHookResult = ReturnType<
  typeof useDeleteProjectMutation
>;
export type DeleteProjectMutationResult =
  Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<
  DeleteProjectMutation,
  DeleteProjectMutationVariables
>;
export const DeleteProjectFilesDocument = gql`
  mutation deleteProjectFiles($ids: [ID!]) {
    deleteProjectFiles(ids: $ids) {
      id
    }
  }
`;
export type DeleteProjectFilesMutationFn = Apollo.MutationFunction<
  DeleteProjectFilesMutation,
  DeleteProjectFilesMutationVariables
>;

/**
 * __useDeleteProjectFilesMutation__
 *
 * To run a mutation, you first call `useDeleteProjectFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectFilesMutation, { data, loading, error }] = useDeleteProjectFilesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteProjectFilesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteProjectFilesMutation,
    DeleteProjectFilesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteProjectFilesMutation,
    DeleteProjectFilesMutationVariables
  >(DeleteProjectFilesDocument, options);
}
export type DeleteProjectFilesMutationHookResult = ReturnType<
  typeof useDeleteProjectFilesMutation
>;
export type DeleteProjectFilesMutationResult =
  Apollo.MutationResult<DeleteProjectFilesMutation>;
export type DeleteProjectFilesMutationOptions = Apollo.BaseMutationOptions<
  DeleteProjectFilesMutation,
  DeleteProjectFilesMutationVariables
>;
export const DeleteProjectInvitationDocument = gql`
  mutation deleteProjectInvitation($projectInvitationId: ID!) {
    deleteProjectInvitation(projectInvitationId: $projectInvitationId)
  }
`;
export type DeleteProjectInvitationMutationFn = Apollo.MutationFunction<
  DeleteProjectInvitationMutation,
  DeleteProjectInvitationMutationVariables
>;

/**
 * __useDeleteProjectInvitationMutation__
 *
 * To run a mutation, you first call `useDeleteProjectInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectInvitationMutation, { data, loading, error }] = useDeleteProjectInvitationMutation({
 *   variables: {
 *      projectInvitationId: // value for 'projectInvitationId'
 *   },
 * });
 */
export function useDeleteProjectInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteProjectInvitationMutation,
    DeleteProjectInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteProjectInvitationMutation,
    DeleteProjectInvitationMutationVariables
  >(DeleteProjectInvitationDocument, options);
}
export type DeleteProjectInvitationMutationHookResult = ReturnType<
  typeof useDeleteProjectInvitationMutation
>;
export type DeleteProjectInvitationMutationResult =
  Apollo.MutationResult<DeleteProjectInvitationMutation>;
export type DeleteProjectInvitationMutationOptions = Apollo.BaseMutationOptions<
  DeleteProjectInvitationMutation,
  DeleteProjectInvitationMutationVariables
>;
export const DeleteTaskDocument = gql`
  mutation deleteTask($id: ID!) {
    deleteTask(id: $id) {
      id
    }
  }
`;
export type DeleteTaskMutationFn = Apollo.MutationFunction<
  DeleteTaskMutation,
  DeleteTaskMutationVariables
>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTaskMutation,
    DeleteTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(
    DeleteTaskDocument,
    options
  );
}
export type DeleteTaskMutationHookResult = ReturnType<
  typeof useDeleteTaskMutation
>;
export type DeleteTaskMutationResult =
  Apollo.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = Apollo.BaseMutationOptions<
  DeleteTaskMutation,
  DeleteTaskMutationVariables
>;
export const DeleteTaskFilesDocument = gql`
  mutation deleteTaskFiles($ids: [ID!]) {
    deleteTaskFiles(ids: $ids) {
      id
    }
  }
`;
export type DeleteTaskFilesMutationFn = Apollo.MutationFunction<
  DeleteTaskFilesMutation,
  DeleteTaskFilesMutationVariables
>;

/**
 * __useDeleteTaskFilesMutation__
 *
 * To run a mutation, you first call `useDeleteTaskFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskFilesMutation, { data, loading, error }] = useDeleteTaskFilesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteTaskFilesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTaskFilesMutation,
    DeleteTaskFilesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteTaskFilesMutation,
    DeleteTaskFilesMutationVariables
  >(DeleteTaskFilesDocument, options);
}
export type DeleteTaskFilesMutationHookResult = ReturnType<
  typeof useDeleteTaskFilesMutation
>;
export type DeleteTaskFilesMutationResult =
  Apollo.MutationResult<DeleteTaskFilesMutation>;
export type DeleteTaskFilesMutationOptions = Apollo.BaseMutationOptions<
  DeleteTaskFilesMutation,
  DeleteTaskFilesMutationVariables
>;
export const DeleteTaskInvitationDocument = gql`
  mutation deleteTaskInvitation($taskInvitationId: ID!) {
    deleteTaskInvitation(taskInvitationId: $taskInvitationId)
  }
`;
export type DeleteTaskInvitationMutationFn = Apollo.MutationFunction<
  DeleteTaskInvitationMutation,
  DeleteTaskInvitationMutationVariables
>;

/**
 * __useDeleteTaskInvitationMutation__
 *
 * To run a mutation, you first call `useDeleteTaskInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskInvitationMutation, { data, loading, error }] = useDeleteTaskInvitationMutation({
 *   variables: {
 *      taskInvitationId: // value for 'taskInvitationId'
 *   },
 * });
 */
export function useDeleteTaskInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTaskInvitationMutation,
    DeleteTaskInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteTaskInvitationMutation,
    DeleteTaskInvitationMutationVariables
  >(DeleteTaskInvitationDocument, options);
}
export type DeleteTaskInvitationMutationHookResult = ReturnType<
  typeof useDeleteTaskInvitationMutation
>;
export type DeleteTaskInvitationMutationResult =
  Apollo.MutationResult<DeleteTaskInvitationMutation>;
export type DeleteTaskInvitationMutationOptions = Apollo.BaseMutationOptions<
  DeleteTaskInvitationMutation,
  DeleteTaskInvitationMutationVariables
>;
export const DeleteTeamDocument = gql`
  mutation deleteTeam($id: ID!) {
    deleteTeam(id: $id) {
      id
    }
  }
`;
export type DeleteTeamMutationFn = Apollo.MutationFunction<
  DeleteTeamMutation,
  DeleteTeamMutationVariables
>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTeamMutation,
    DeleteTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(
    DeleteTeamDocument,
    options
  );
}
export type DeleteTeamMutationHookResult = ReturnType<
  typeof useDeleteTeamMutation
>;
export type DeleteTeamMutationResult =
  Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<
  DeleteTeamMutation,
  DeleteTeamMutationVariables
>;
export const DeleteTeamInvitationDocument = gql`
  mutation deleteTeamInvitation($accountInvitationId: ID, $userRequestId: ID) {
    deleteTeamInvitation(
      accountInvitationId: $accountInvitationId
      userRequestId: $userRequestId
    )
  }
`;
export type DeleteTeamInvitationMutationFn = Apollo.MutationFunction<
  DeleteTeamInvitationMutation,
  DeleteTeamInvitationMutationVariables
>;

/**
 * __useDeleteTeamInvitationMutation__
 *
 * To run a mutation, you first call `useDeleteTeamInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamInvitationMutation, { data, loading, error }] = useDeleteTeamInvitationMutation({
 *   variables: {
 *      accountInvitationId: // value for 'accountInvitationId'
 *      userRequestId: // value for 'userRequestId'
 *   },
 * });
 */
export function useDeleteTeamInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTeamInvitationMutation,
    DeleteTeamInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteTeamInvitationMutation,
    DeleteTeamInvitationMutationVariables
  >(DeleteTeamInvitationDocument, options);
}
export type DeleteTeamInvitationMutationHookResult = ReturnType<
  typeof useDeleteTeamInvitationMutation
>;
export type DeleteTeamInvitationMutationResult =
  Apollo.MutationResult<DeleteTeamInvitationMutation>;
export type DeleteTeamInvitationMutationOptions = Apollo.BaseMutationOptions<
  DeleteTeamInvitationMutation,
  DeleteTeamInvitationMutationVariables
>;
export const DeleteUserRequestDocument = gql`
  mutation deleteUserRequest($id: ID!) {
    deleteUserRequest(id: $id) {
      id
    }
  }
`;
export type DeleteUserRequestMutationFn = Apollo.MutationFunction<
  DeleteUserRequestMutation,
  DeleteUserRequestMutationVariables
>;

/**
 * __useDeleteUserRequestMutation__
 *
 * To run a mutation, you first call `useDeleteUserRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserRequestMutation, { data, loading, error }] = useDeleteUserRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUserRequestMutation,
    DeleteUserRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteUserRequestMutation,
    DeleteUserRequestMutationVariables
  >(DeleteUserRequestDocument, options);
}
export type DeleteUserRequestMutationHookResult = ReturnType<
  typeof useDeleteUserRequestMutation
>;
export type DeleteUserRequestMutationResult =
  Apollo.MutationResult<DeleteUserRequestMutation>;
export type DeleteUserRequestMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserRequestMutation,
  DeleteUserRequestMutationVariables
>;
export const DuplicateProjectDocument = gql`
  mutation duplicateProject(
    $id: ID!
    $includeTasks: Boolean
    $includeMembers: Boolean
    $includePhases: Boolean
    $includeAdmins: Boolean
    $includeEditors: Boolean
    $includeViewers: Boolean
    $includeFiles: Boolean
  ) {
    duplicateProject(
      id: $id
      includeTasks: $includeTasks
      includeMembers: $includeMembers
      includePhases: $includePhases
      includeAdmins: $includeAdmins
      includeEditors: $includeEditors
      includeViewers: $includeViewers
      includeFiles: $includeFiles
    ) {
      ...ProjectDetail
      duplicationStatus
    }
  }
  ${ProjectDetailFragmentDoc}
`;
export type DuplicateProjectMutationFn = Apollo.MutationFunction<
  DuplicateProjectMutation,
  DuplicateProjectMutationVariables
>;

/**
 * __useDuplicateProjectMutation__
 *
 * To run a mutation, you first call `useDuplicateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateProjectMutation, { data, loading, error }] = useDuplicateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      includeTasks: // value for 'includeTasks'
 *      includeMembers: // value for 'includeMembers'
 *      includePhases: // value for 'includePhases'
 *      includeAdmins: // value for 'includeAdmins'
 *      includeEditors: // value for 'includeEditors'
 *      includeViewers: // value for 'includeViewers'
 *      includeFiles: // value for 'includeFiles'
 *   },
 * });
 */
export function useDuplicateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateProjectMutation,
    DuplicateProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DuplicateProjectMutation,
    DuplicateProjectMutationVariables
  >(DuplicateProjectDocument, options);
}
export type DuplicateProjectMutationHookResult = ReturnType<
  typeof useDuplicateProjectMutation
>;
export type DuplicateProjectMutationResult =
  Apollo.MutationResult<DuplicateProjectMutation>;
export type DuplicateProjectMutationOptions = Apollo.BaseMutationOptions<
  DuplicateProjectMutation,
  DuplicateProjectMutationVariables
>;
export const DuplicateTaskDocument = gql`
  mutation duplicateTask(
    $id: ID!
    $includeCheckLists: Boolean
    $includeCreator: Boolean
    $includeAssignees: Boolean
    $includeViewers: Boolean
    $includeFiles: Boolean
  ) {
    duplicateTask(
      id: $id
      includeCheckLists: $includeCheckLists
      includeCreator: $includeCreator
      includeAssignees: $includeAssignees
      includeViewers: $includeViewers
      includeFiles: $includeFiles
    ) {
      id
      name
      status
      priority
      startDate
      dueDate
      completedAt
      createdAt
      phaseId
      projectId
      skillIds
      members {
        id
        role
        user {
          ...UserDetail
        }
      }
      skills {
        id
        name
      }
      creator {
        ...UserDetail
      }
      completor {
        ...UserDetail
      }
      project {
        id
        uuid
        name
        color
      }
    }
  }
  ${UserDetailFragmentDoc}
`;
export type DuplicateTaskMutationFn = Apollo.MutationFunction<
  DuplicateTaskMutation,
  DuplicateTaskMutationVariables
>;

/**
 * __useDuplicateTaskMutation__
 *
 * To run a mutation, you first call `useDuplicateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateTaskMutation, { data, loading, error }] = useDuplicateTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      includeCheckLists: // value for 'includeCheckLists'
 *      includeCreator: // value for 'includeCreator'
 *      includeAssignees: // value for 'includeAssignees'
 *      includeViewers: // value for 'includeViewers'
 *      includeFiles: // value for 'includeFiles'
 *   },
 * });
 */
export function useDuplicateTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateTaskMutation,
    DuplicateTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DuplicateTaskMutation,
    DuplicateTaskMutationVariables
  >(DuplicateTaskDocument, options);
}
export type DuplicateTaskMutationHookResult = ReturnType<
  typeof useDuplicateTaskMutation
>;
export type DuplicateTaskMutationResult =
  Apollo.MutationResult<DuplicateTaskMutation>;
export type DuplicateTaskMutationOptions = Apollo.BaseMutationOptions<
  DuplicateTaskMutation,
  DuplicateTaskMutationVariables
>;
export const DuplicateTaskFilesDocument = gql`
  mutation duplicateTaskFiles($sourceId: ID!, $destinationId: ID!) {
    duplicateTaskFiles(sourceId: $sourceId, destinationId: $destinationId) {
      id
    }
  }
`;
export type DuplicateTaskFilesMutationFn = Apollo.MutationFunction<
  DuplicateTaskFilesMutation,
  DuplicateTaskFilesMutationVariables
>;

/**
 * __useDuplicateTaskFilesMutation__
 *
 * To run a mutation, you first call `useDuplicateTaskFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateTaskFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateTaskFilesMutation, { data, loading, error }] = useDuplicateTaskFilesMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      destinationId: // value for 'destinationId'
 *   },
 * });
 */
export function useDuplicateTaskFilesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateTaskFilesMutation,
    DuplicateTaskFilesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DuplicateTaskFilesMutation,
    DuplicateTaskFilesMutationVariables
  >(DuplicateTaskFilesDocument, options);
}
export type DuplicateTaskFilesMutationHookResult = ReturnType<
  typeof useDuplicateTaskFilesMutation
>;
export type DuplicateTaskFilesMutationResult =
  Apollo.MutationResult<DuplicateTaskFilesMutation>;
export type DuplicateTaskFilesMutationOptions = Apollo.BaseMutationOptions<
  DuplicateTaskFilesMutation,
  DuplicateTaskFilesMutationVariables
>;
export const EditStripeSubscriptionDocument = gql`
  mutation editStripeSubscription(
    $stripeSubscriptionAttributes: StripeSubscriptionAttributes!
  ) {
    editStripeSubscription(
      stripeSubscriptionAttributes: $stripeSubscriptionAttributes
    ) {
      clientSecret
      id
      intentType
      team {
        id
      }
    }
  }
`;
export type EditStripeSubscriptionMutationFn = Apollo.MutationFunction<
  EditStripeSubscriptionMutation,
  EditStripeSubscriptionMutationVariables
>;

/**
 * __useEditStripeSubscriptionMutation__
 *
 * To run a mutation, you first call `useEditStripeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditStripeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editStripeSubscriptionMutation, { data, loading, error }] = useEditStripeSubscriptionMutation({
 *   variables: {
 *      stripeSubscriptionAttributes: // value for 'stripeSubscriptionAttributes'
 *   },
 * });
 */
export function useEditStripeSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditStripeSubscriptionMutation,
    EditStripeSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditStripeSubscriptionMutation,
    EditStripeSubscriptionMutationVariables
  >(EditStripeSubscriptionDocument, options);
}
export type EditStripeSubscriptionMutationHookResult = ReturnType<
  typeof useEditStripeSubscriptionMutation
>;
export type EditStripeSubscriptionMutationResult =
  Apollo.MutationResult<EditStripeSubscriptionMutation>;
export type EditStripeSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  EditStripeSubscriptionMutation,
  EditStripeSubscriptionMutationVariables
>;
export const ExportCheckinsDocument = gql`
  mutation exportCheckins(
    $projectId: ID!
    $from: ISO8601DateTime
    $to: ISO8601DateTime
  ) {
    exportCheckins(projectId: $projectId, from: $from, to: $to) {
      url
      filename
    }
  }
`;
export type ExportCheckinsMutationFn = Apollo.MutationFunction<
  ExportCheckinsMutation,
  ExportCheckinsMutationVariables
>;

/**
 * __useExportCheckinsMutation__
 *
 * To run a mutation, you first call `useExportCheckinsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportCheckinsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportCheckinsMutation, { data, loading, error }] = useExportCheckinsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useExportCheckinsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportCheckinsMutation,
    ExportCheckinsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExportCheckinsMutation,
    ExportCheckinsMutationVariables
  >(ExportCheckinsDocument, options);
}
export type ExportCheckinsMutationHookResult = ReturnType<
  typeof useExportCheckinsMutation
>;
export type ExportCheckinsMutationResult =
  Apollo.MutationResult<ExportCheckinsMutation>;
export type ExportCheckinsMutationOptions = Apollo.BaseMutationOptions<
  ExportCheckinsMutation,
  ExportCheckinsMutationVariables
>;
export const ExportGlobalCheckinsDocument = gql`
  mutation exportGlobalCheckins($from: ISO8601DateTime, $to: ISO8601DateTime) {
    exportGlobalCheckins(from: $from, to: $to) {
      url
      filename
    }
  }
`;
export type ExportGlobalCheckinsMutationFn = Apollo.MutationFunction<
  ExportGlobalCheckinsMutation,
  ExportGlobalCheckinsMutationVariables
>;

/**
 * __useExportGlobalCheckinsMutation__
 *
 * To run a mutation, you first call `useExportGlobalCheckinsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportGlobalCheckinsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportGlobalCheckinsMutation, { data, loading, error }] = useExportGlobalCheckinsMutation({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useExportGlobalCheckinsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportGlobalCheckinsMutation,
    ExportGlobalCheckinsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExportGlobalCheckinsMutation,
    ExportGlobalCheckinsMutationVariables
  >(ExportGlobalCheckinsDocument, options);
}
export type ExportGlobalCheckinsMutationHookResult = ReturnType<
  typeof useExportGlobalCheckinsMutation
>;
export type ExportGlobalCheckinsMutationResult =
  Apollo.MutationResult<ExportGlobalCheckinsMutation>;
export type ExportGlobalCheckinsMutationOptions = Apollo.BaseMutationOptions<
  ExportGlobalCheckinsMutation,
  ExportGlobalCheckinsMutationVariables
>;
export const ForwardDocumentsDocument = gql`
  mutation ForwardDocuments($documentIds: [ID!]!, $targetChatIds: [ID!]!) {
    forwardDocuments(documentIds: $documentIds, targetChatIds: $targetChatIds) {
      messages {
        id
        clientId
        chatId
      }
      errors
    }
  }
`;
export type ForwardDocumentsMutationFn = Apollo.MutationFunction<
  ForwardDocumentsMutation,
  ForwardDocumentsMutationVariables
>;

/**
 * __useForwardDocumentsMutation__
 *
 * To run a mutation, you first call `useForwardDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForwardDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forwardDocumentsMutation, { data, loading, error }] = useForwardDocumentsMutation({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *      targetChatIds: // value for 'targetChatIds'
 *   },
 * });
 */
export function useForwardDocumentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ForwardDocumentsMutation,
    ForwardDocumentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ForwardDocumentsMutation,
    ForwardDocumentsMutationVariables
  >(ForwardDocumentsDocument, options);
}
export type ForwardDocumentsMutationHookResult = ReturnType<
  typeof useForwardDocumentsMutation
>;
export type ForwardDocumentsMutationResult =
  Apollo.MutationResult<ForwardDocumentsMutation>;
export type ForwardDocumentsMutationOptions = Apollo.BaseMutationOptions<
  ForwardDocumentsMutation,
  ForwardDocumentsMutationVariables
>;
export const FriendRequestDocument = gql`
  mutation FriendRequest($attributes: ChatAttributes!) {
    friendRequest(attributes: $attributes) {
      id
      name
      description
      isGroupChat
      createdAt
      owner {
        id
      }
      users {
        id
      }
      avatar {
        ...AvatarDetail
      }
      settings {
        mute
        pin
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;
export type FriendRequestMutationFn = Apollo.MutationFunction<
  FriendRequestMutation,
  FriendRequestMutationVariables
>;

/**
 * __useFriendRequestMutation__
 *
 * To run a mutation, you first call `useFriendRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFriendRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [friendRequestMutation, { data, loading, error }] = useFriendRequestMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useFriendRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FriendRequestMutation,
    FriendRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FriendRequestMutation,
    FriendRequestMutationVariables
  >(FriendRequestDocument, options);
}
export type FriendRequestMutationHookResult = ReturnType<
  typeof useFriendRequestMutation
>;
export type FriendRequestMutationResult =
  Apollo.MutationResult<FriendRequestMutation>;
export type FriendRequestMutationOptions = Apollo.BaseMutationOptions<
  FriendRequestMutation,
  FriendRequestMutationVariables
>;
export const GeneratePublicCalendarUrlDocument = gql`
  mutation generatePublicCalendarUrl {
    generatePublicCalendarUrl
  }
`;
export type GeneratePublicCalendarUrlMutationFn = Apollo.MutationFunction<
  GeneratePublicCalendarUrlMutation,
  GeneratePublicCalendarUrlMutationVariables
>;

/**
 * __useGeneratePublicCalendarUrlMutation__
 *
 * To run a mutation, you first call `useGeneratePublicCalendarUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePublicCalendarUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePublicCalendarUrlMutation, { data, loading, error }] = useGeneratePublicCalendarUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useGeneratePublicCalendarUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GeneratePublicCalendarUrlMutation,
    GeneratePublicCalendarUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GeneratePublicCalendarUrlMutation,
    GeneratePublicCalendarUrlMutationVariables
  >(GeneratePublicCalendarUrlDocument, options);
}
export type GeneratePublicCalendarUrlMutationHookResult = ReturnType<
  typeof useGeneratePublicCalendarUrlMutation
>;
export type GeneratePublicCalendarUrlMutationResult =
  Apollo.MutationResult<GeneratePublicCalendarUrlMutation>;
export type GeneratePublicCalendarUrlMutationOptions =
  Apollo.BaseMutationOptions<
    GeneratePublicCalendarUrlMutation,
    GeneratePublicCalendarUrlMutationVariables
  >;
export const InvalidatePublicCalendarUrlDocument = gql`
  mutation invalidatePublicCalendarUrl {
    invalidatePublicCalendarUrl
  }
`;
export type InvalidatePublicCalendarUrlMutationFn = Apollo.MutationFunction<
  InvalidatePublicCalendarUrlMutation,
  InvalidatePublicCalendarUrlMutationVariables
>;

/**
 * __useInvalidatePublicCalendarUrlMutation__
 *
 * To run a mutation, you first call `useInvalidatePublicCalendarUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvalidatePublicCalendarUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invalidatePublicCalendarUrlMutation, { data, loading, error }] = useInvalidatePublicCalendarUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useInvalidatePublicCalendarUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InvalidatePublicCalendarUrlMutation,
    InvalidatePublicCalendarUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InvalidatePublicCalendarUrlMutation,
    InvalidatePublicCalendarUrlMutationVariables
  >(InvalidatePublicCalendarUrlDocument, options);
}
export type InvalidatePublicCalendarUrlMutationHookResult = ReturnType<
  typeof useInvalidatePublicCalendarUrlMutation
>;
export type InvalidatePublicCalendarUrlMutationResult =
  Apollo.MutationResult<InvalidatePublicCalendarUrlMutation>;
export type InvalidatePublicCalendarUrlMutationOptions =
  Apollo.BaseMutationOptions<
    InvalidatePublicCalendarUrlMutation,
    InvalidatePublicCalendarUrlMutationVariables
  >;
export const JoinRequestedTaskDocument = gql`
  mutation joinRequestedTask($userRequestId: ID!) {
    joinRequestedTask(userRequestId: $userRequestId)
  }
`;
export type JoinRequestedTaskMutationFn = Apollo.MutationFunction<
  JoinRequestedTaskMutation,
  JoinRequestedTaskMutationVariables
>;

/**
 * __useJoinRequestedTaskMutation__
 *
 * To run a mutation, you first call `useJoinRequestedTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinRequestedTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinRequestedTaskMutation, { data, loading, error }] = useJoinRequestedTaskMutation({
 *   variables: {
 *      userRequestId: // value for 'userRequestId'
 *   },
 * });
 */
export function useJoinRequestedTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JoinRequestedTaskMutation,
    JoinRequestedTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JoinRequestedTaskMutation,
    JoinRequestedTaskMutationVariables
  >(JoinRequestedTaskDocument, options);
}
export type JoinRequestedTaskMutationHookResult = ReturnType<
  typeof useJoinRequestedTaskMutation
>;
export type JoinRequestedTaskMutationResult =
  Apollo.MutationResult<JoinRequestedTaskMutation>;
export type JoinRequestedTaskMutationOptions = Apollo.BaseMutationOptions<
  JoinRequestedTaskMutation,
  JoinRequestedTaskMutationVariables
>;
export const LeaveChatDocument = gql`
  mutation leaveChat($id: ID!) {
    leaveChat(id: $id) {
      id
    }
  }
`;
export type LeaveChatMutationFn = Apollo.MutationFunction<
  LeaveChatMutation,
  LeaveChatMutationVariables
>;

/**
 * __useLeaveChatMutation__
 *
 * To run a mutation, you first call `useLeaveChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveChatMutation, { data, loading, error }] = useLeaveChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeaveChatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LeaveChatMutation,
    LeaveChatMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LeaveChatMutation, LeaveChatMutationVariables>(
    LeaveChatDocument,
    options
  );
}
export type LeaveChatMutationHookResult = ReturnType<
  typeof useLeaveChatMutation
>;
export type LeaveChatMutationResult = Apollo.MutationResult<LeaveChatMutation>;
export type LeaveChatMutationOptions = Apollo.BaseMutationOptions<
  LeaveChatMutation,
  LeaveChatMutationVariables
>;
export const LeaveProjectDocument = gql`
  mutation leaveProject($id: ID!) {
    leaveProject(id: $id) {
      id
    }
  }
`;
export type LeaveProjectMutationFn = Apollo.MutationFunction<
  LeaveProjectMutation,
  LeaveProjectMutationVariables
>;

/**
 * __useLeaveProjectMutation__
 *
 * To run a mutation, you first call `useLeaveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveProjectMutation, { data, loading, error }] = useLeaveProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeaveProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LeaveProjectMutation,
    LeaveProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LeaveProjectMutation,
    LeaveProjectMutationVariables
  >(LeaveProjectDocument, options);
}
export type LeaveProjectMutationHookResult = ReturnType<
  typeof useLeaveProjectMutation
>;
export type LeaveProjectMutationResult =
  Apollo.MutationResult<LeaveProjectMutation>;
export type LeaveProjectMutationOptions = Apollo.BaseMutationOptions<
  LeaveProjectMutation,
  LeaveProjectMutationVariables
>;
export const LeaveTaskDocument = gql`
  mutation leaveTask($id: ID!, $userId: ID!) {
    leaveTask(id: $id, userId: $userId) {
      id
      name
      status
      priority
      startDate
      dueDate
      completedAt
      createdAt
      phaseId
      projectId
      skillIds
      userIds
      members {
        id
        role
        user {
          ...UserDetail
        }
      }
      skills {
        id
        name
      }
      creator {
        ...UserDetail
      }
      completor {
        ...UserDetail
      }
      project {
        id
        uuid
        name
        color
      }
    }
  }
  ${UserDetailFragmentDoc}
`;
export type LeaveTaskMutationFn = Apollo.MutationFunction<
  LeaveTaskMutation,
  LeaveTaskMutationVariables
>;

/**
 * __useLeaveTaskMutation__
 *
 * To run a mutation, you first call `useLeaveTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveTaskMutation, { data, loading, error }] = useLeaveTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLeaveTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LeaveTaskMutation,
    LeaveTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LeaveTaskMutation, LeaveTaskMutationVariables>(
    LeaveTaskDocument,
    options
  );
}
export type LeaveTaskMutationHookResult = ReturnType<
  typeof useLeaveTaskMutation
>;
export type LeaveTaskMutationResult = Apollo.MutationResult<LeaveTaskMutation>;
export type LeaveTaskMutationOptions = Apollo.BaseMutationOptions<
  LeaveTaskMutation,
  LeaveTaskMutationVariables
>;
export const LeaveTeamDocument = gql`
  mutation leaveTeam($id: ID!) {
    leaveTeam(id: $id) {
      id
      name
    }
  }
`;
export type LeaveTeamMutationFn = Apollo.MutationFunction<
  LeaveTeamMutation,
  LeaveTeamMutationVariables
>;

/**
 * __useLeaveTeamMutation__
 *
 * To run a mutation, you first call `useLeaveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveTeamMutation, { data, loading, error }] = useLeaveTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeaveTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LeaveTeamMutation,
    LeaveTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LeaveTeamMutation, LeaveTeamMutationVariables>(
    LeaveTeamDocument,
    options
  );
}
export type LeaveTeamMutationHookResult = ReturnType<
  typeof useLeaveTeamMutation
>;
export type LeaveTeamMutationResult = Apollo.MutationResult<LeaveTeamMutation>;
export type LeaveTeamMutationOptions = Apollo.BaseMutationOptions<
  LeaveTeamMutation,
  LeaveTeamMutationVariables
>;
export const MarkAuditsReadDocument = gql`
  mutation markAuditsRead($attributes: ReadReceiptAuditAttributes!) {
    markAuditsRead(attributes: $attributes) {
      id
      event
    }
  }
`;
export type MarkAuditsReadMutationFn = Apollo.MutationFunction<
  MarkAuditsReadMutation,
  MarkAuditsReadMutationVariables
>;

/**
 * __useMarkAuditsReadMutation__
 *
 * To run a mutation, you first call `useMarkAuditsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAuditsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAuditsReadMutation, { data, loading, error }] = useMarkAuditsReadMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useMarkAuditsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkAuditsReadMutation,
    MarkAuditsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkAuditsReadMutation,
    MarkAuditsReadMutationVariables
  >(MarkAuditsReadDocument, options);
}
export type MarkAuditsReadMutationHookResult = ReturnType<
  typeof useMarkAuditsReadMutation
>;
export type MarkAuditsReadMutationResult =
  Apollo.MutationResult<MarkAuditsReadMutation>;
export type MarkAuditsReadMutationOptions = Apollo.BaseMutationOptions<
  MarkAuditsReadMutation,
  MarkAuditsReadMutationVariables
>;
export const MarkChatsReadDocument = gql`
  mutation markChatsRead($attributes: ReadReceiptChatAttributes!) {
    markChatsRead(attributes: $attributes) {
      id
      unreadCount
      recentActivityAt
    }
  }
`;
export type MarkChatsReadMutationFn = Apollo.MutationFunction<
  MarkChatsReadMutation,
  MarkChatsReadMutationVariables
>;

/**
 * __useMarkChatsReadMutation__
 *
 * To run a mutation, you first call `useMarkChatsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkChatsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markChatsReadMutation, { data, loading, error }] = useMarkChatsReadMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useMarkChatsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkChatsReadMutation,
    MarkChatsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkChatsReadMutation,
    MarkChatsReadMutationVariables
  >(MarkChatsReadDocument, options);
}
export type MarkChatsReadMutationHookResult = ReturnType<
  typeof useMarkChatsReadMutation
>;
export type MarkChatsReadMutationResult =
  Apollo.MutationResult<MarkChatsReadMutation>;
export type MarkChatsReadMutationOptions = Apollo.BaseMutationOptions<
  MarkChatsReadMutation,
  MarkChatsReadMutationVariables
>;
export const NotifyTeamExpiryDocument = gql`
  mutation notifyTeamExpiry($projectId: ID!) {
    notifyTeamExpiry(projectId: $projectId) {
      success
    }
  }
`;
export type NotifyTeamExpiryMutationFn = Apollo.MutationFunction<
  NotifyTeamExpiryMutation,
  NotifyTeamExpiryMutationVariables
>;

/**
 * __useNotifyTeamExpiryMutation__
 *
 * To run a mutation, you first call `useNotifyTeamExpiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyTeamExpiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyTeamExpiryMutation, { data, loading, error }] = useNotifyTeamExpiryMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useNotifyTeamExpiryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NotifyTeamExpiryMutation,
    NotifyTeamExpiryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    NotifyTeamExpiryMutation,
    NotifyTeamExpiryMutationVariables
  >(NotifyTeamExpiryDocument, options);
}
export type NotifyTeamExpiryMutationHookResult = ReturnType<
  typeof useNotifyTeamExpiryMutation
>;
export type NotifyTeamExpiryMutationResult =
  Apollo.MutationResult<NotifyTeamExpiryMutation>;
export type NotifyTeamExpiryMutationOptions = Apollo.BaseMutationOptions<
  NotifyTeamExpiryMutation,
  NotifyTeamExpiryMutationVariables
>;
export const NotifyTeamOwnerDocument = gql`
  mutation notifyTeamOwner($teamId: ID!) {
    notifyTeamOwner(teamId: $teamId) {
      success
    }
  }
`;
export type NotifyTeamOwnerMutationFn = Apollo.MutationFunction<
  NotifyTeamOwnerMutation,
  NotifyTeamOwnerMutationVariables
>;

/**
 * __useNotifyTeamOwnerMutation__
 *
 * To run a mutation, you first call `useNotifyTeamOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyTeamOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyTeamOwnerMutation, { data, loading, error }] = useNotifyTeamOwnerMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useNotifyTeamOwnerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NotifyTeamOwnerMutation,
    NotifyTeamOwnerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    NotifyTeamOwnerMutation,
    NotifyTeamOwnerMutationVariables
  >(NotifyTeamOwnerDocument, options);
}
export type NotifyTeamOwnerMutationHookResult = ReturnType<
  typeof useNotifyTeamOwnerMutation
>;
export type NotifyTeamOwnerMutationResult =
  Apollo.MutationResult<NotifyTeamOwnerMutation>;
export type NotifyTeamOwnerMutationOptions = Apollo.BaseMutationOptions<
  NotifyTeamOwnerMutation,
  NotifyTeamOwnerMutationVariables
>;
export const OrderTasksDocument = gql`
  mutation orderTasks(
    $taskIds: [ID!]!
    $section: TaskSection!
    $afterTaskId: ID
    $beforeTaskId: ID
  ) {
    orderTasks(
      taskIds: $taskIds
      section: $section
      afterTaskId: $afterTaskId
      beforeTaskId: $beforeTaskId
    ) {
      id
      position
      rank
      section
      taskId
    }
  }
`;
export type OrderTasksMutationFn = Apollo.MutationFunction<
  OrderTasksMutation,
  OrderTasksMutationVariables
>;

/**
 * __useOrderTasksMutation__
 *
 * To run a mutation, you first call `useOrderTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderTasksMutation, { data, loading, error }] = useOrderTasksMutation({
 *   variables: {
 *      taskIds: // value for 'taskIds'
 *      section: // value for 'section'
 *      afterTaskId: // value for 'afterTaskId'
 *      beforeTaskId: // value for 'beforeTaskId'
 *   },
 * });
 */
export function useOrderTasksMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OrderTasksMutation,
    OrderTasksMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<OrderTasksMutation, OrderTasksMutationVariables>(
    OrderTasksDocument,
    options
  );
}
export type OrderTasksMutationHookResult = ReturnType<
  typeof useOrderTasksMutation
>;
export type OrderTasksMutationResult =
  Apollo.MutationResult<OrderTasksMutation>;
export type OrderTasksMutationOptions = Apollo.BaseMutationOptions<
  OrderTasksMutation,
  OrderTasksMutationVariables
>;
export const UpdateOnboardingProgressDocument = gql`
  mutation updateOnboardingProgress($onboardingFlow: OnboardingFlow!) {
    updateOnboardingProgress(onboardingFlow: $onboardingFlow) {
      id
      onboardingFlow
      name
      email
    }
  }
`;
export type UpdateOnboardingProgressMutationFn = Apollo.MutationFunction<
  UpdateOnboardingProgressMutation,
  UpdateOnboardingProgressMutationVariables
>;

/**
 * __useUpdateOnboardingProgressMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingProgressMutation, { data, loading, error }] = useUpdateOnboardingProgressMutation({
 *   variables: {
 *      onboardingFlow: // value for 'onboardingFlow'
 *   },
 * });
 */
export function useUpdateOnboardingProgressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOnboardingProgressMutation,
    UpdateOnboardingProgressMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOnboardingProgressMutation,
    UpdateOnboardingProgressMutationVariables
  >(UpdateOnboardingProgressDocument, options);
}
export type UpdateOnboardingProgressMutationHookResult = ReturnType<
  typeof useUpdateOnboardingProgressMutation
>;
export type UpdateOnboardingProgressMutationResult =
  Apollo.MutationResult<UpdateOnboardingProgressMutation>;
export type UpdateOnboardingProgressMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateOnboardingProgressMutation,
    UpdateOnboardingProgressMutationVariables
  >;
export const RejectTaskInvitationDocument = gql`
  mutation rejectTaskInvitation($id: ID!) {
    rejectTaskInvitation(userRequestId: $id)
  }
`;
export type RejectTaskInvitationMutationFn = Apollo.MutationFunction<
  RejectTaskInvitationMutation,
  RejectTaskInvitationMutationVariables
>;

/**
 * __useRejectTaskInvitationMutation__
 *
 * To run a mutation, you first call `useRejectTaskInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectTaskInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectTaskInvitationMutation, { data, loading, error }] = useRejectTaskInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRejectTaskInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RejectTaskInvitationMutation,
    RejectTaskInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RejectTaskInvitationMutation,
    RejectTaskInvitationMutationVariables
  >(RejectTaskInvitationDocument, options);
}
export type RejectTaskInvitationMutationHookResult = ReturnType<
  typeof useRejectTaskInvitationMutation
>;
export type RejectTaskInvitationMutationResult =
  Apollo.MutationResult<RejectTaskInvitationMutation>;
export type RejectTaskInvitationMutationOptions = Apollo.BaseMutationOptions<
  RejectTaskInvitationMutation,
  RejectTaskInvitationMutationVariables
>;
export const RemoveMeDocument = gql`
  mutation removeMe {
    removeMe {
      id
    }
  }
`;
export type RemoveMeMutationFn = Apollo.MutationFunction<
  RemoveMeMutation,
  RemoveMeMutationVariables
>;

/**
 * __useRemoveMeMutation__
 *
 * To run a mutation, you first call `useRemoveMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMeMutation, { data, loading, error }] = useRemoveMeMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveMeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveMeMutation,
    RemoveMeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveMeMutation, RemoveMeMutationVariables>(
    RemoveMeDocument,
    options
  );
}
export type RemoveMeMutationHookResult = ReturnType<typeof useRemoveMeMutation>;
export type RemoveMeMutationResult = Apollo.MutationResult<RemoveMeMutation>;
export type RemoveMeMutationOptions = Apollo.BaseMutationOptions<
  RemoveMeMutation,
  RemoveMeMutationVariables
>;
export const RemoveMessageReactionDocument = gql`
  mutation removeMessageReaction($messageReactionId: ID!) {
    removeMessageReaction(id: $messageReactionId) {
      id
      reaction
      count
    }
  }
`;
export type RemoveMessageReactionMutationFn = Apollo.MutationFunction<
  RemoveMessageReactionMutation,
  RemoveMessageReactionMutationVariables
>;

/**
 * __useRemoveMessageReactionMutation__
 *
 * To run a mutation, you first call `useRemoveMessageReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMessageReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMessageReactionMutation, { data, loading, error }] = useRemoveMessageReactionMutation({
 *   variables: {
 *      messageReactionId: // value for 'messageReactionId'
 *   },
 * });
 */
export function useRemoveMessageReactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveMessageReactionMutation,
    RemoveMessageReactionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveMessageReactionMutation,
    RemoveMessageReactionMutationVariables
  >(RemoveMessageReactionDocument, options);
}
export type RemoveMessageReactionMutationHookResult = ReturnType<
  typeof useRemoveMessageReactionMutation
>;
export type RemoveMessageReactionMutationResult =
  Apollo.MutationResult<RemoveMessageReactionMutation>;
export type RemoveMessageReactionMutationOptions = Apollo.BaseMutationOptions<
  RemoveMessageReactionMutation,
  RemoveMessageReactionMutationVariables
>;
export const RemoveProjectChecklistDocument = gql`
  mutation removeProjectChecklist($projectChecklistId: ID!) {
    removeProjectChecklist(projectChecklistId: $projectChecklistId)
  }
`;
export type RemoveProjectChecklistMutationFn = Apollo.MutationFunction<
  RemoveProjectChecklistMutation,
  RemoveProjectChecklistMutationVariables
>;

/**
 * __useRemoveProjectChecklistMutation__
 *
 * To run a mutation, you first call `useRemoveProjectChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectChecklistMutation, { data, loading, error }] = useRemoveProjectChecklistMutation({
 *   variables: {
 *      projectChecklistId: // value for 'projectChecklistId'
 *   },
 * });
 */
export function useRemoveProjectChecklistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveProjectChecklistMutation,
    RemoveProjectChecklistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveProjectChecklistMutation,
    RemoveProjectChecklistMutationVariables
  >(RemoveProjectChecklistDocument, options);
}
export type RemoveProjectChecklistMutationHookResult = ReturnType<
  typeof useRemoveProjectChecklistMutation
>;
export type RemoveProjectChecklistMutationResult =
  Apollo.MutationResult<RemoveProjectChecklistMutation>;
export type RemoveProjectChecklistMutationOptions = Apollo.BaseMutationOptions<
  RemoveProjectChecklistMutation,
  RemoveProjectChecklistMutationVariables
>;
export const RemoveProjectMembersDocument = gql`
  mutation removeProjectMembers($id: ID!, $attributes: ProjectAttributes!) {
    updateProject(id: $id, attributes: $attributes) {
      id
      usersCount
      members {
        id
        role
        user {
          ...UserDetail
        }
      }
    }
  }
  ${UserDetailFragmentDoc}
`;
export type RemoveProjectMembersMutationFn = Apollo.MutationFunction<
  RemoveProjectMembersMutation,
  RemoveProjectMembersMutationVariables
>;

/**
 * __useRemoveProjectMembersMutation__
 *
 * To run a mutation, you first call `useRemoveProjectMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectMembersMutation, { data, loading, error }] = useRemoveProjectMembersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useRemoveProjectMembersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveProjectMembersMutation,
    RemoveProjectMembersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveProjectMembersMutation,
    RemoveProjectMembersMutationVariables
  >(RemoveProjectMembersDocument, options);
}
export type RemoveProjectMembersMutationHookResult = ReturnType<
  typeof useRemoveProjectMembersMutation
>;
export type RemoveProjectMembersMutationResult =
  Apollo.MutationResult<RemoveProjectMembersMutation>;
export type RemoveProjectMembersMutationOptions = Apollo.BaseMutationOptions<
  RemoveProjectMembersMutation,
  RemoveProjectMembersMutationVariables
>;
export const RemoveProjectMemberByIdDocument = gql`
  mutation removeProjectMemberById($id: ID!, $userId: ID!) {
    removeProjectMember(id: $id, userId: $userId) {
      id
      usersCount
      members {
        id
        role
      }
    }
  }
`;
export type RemoveProjectMemberByIdMutationFn = Apollo.MutationFunction<
  RemoveProjectMemberByIdMutation,
  RemoveProjectMemberByIdMutationVariables
>;

/**
 * __useRemoveProjectMemberByIdMutation__
 *
 * To run a mutation, you first call `useRemoveProjectMemberByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectMemberByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectMemberByIdMutation, { data, loading, error }] = useRemoveProjectMemberByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveProjectMemberByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveProjectMemberByIdMutation,
    RemoveProjectMemberByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveProjectMemberByIdMutation,
    RemoveProjectMemberByIdMutationVariables
  >(RemoveProjectMemberByIdDocument, options);
}
export type RemoveProjectMemberByIdMutationHookResult = ReturnType<
  typeof useRemoveProjectMemberByIdMutation
>;
export type RemoveProjectMemberByIdMutationResult =
  Apollo.MutationResult<RemoveProjectMemberByIdMutation>;
export type RemoveProjectMemberByIdMutationOptions = Apollo.BaseMutationOptions<
  RemoveProjectMemberByIdMutation,
  RemoveProjectMemberByIdMutationVariables
>;
export const RemoveTaskChecklistDocument = gql`
  mutation removeTaskChecklist($id: ID!) {
    removeTaskChecklist(id: $id) {
      taskId
      id
      name
      completedAt
      createdAt
      sort
    }
  }
`;
export type RemoveTaskChecklistMutationFn = Apollo.MutationFunction<
  RemoveTaskChecklistMutation,
  RemoveTaskChecklistMutationVariables
>;

/**
 * __useRemoveTaskChecklistMutation__
 *
 * To run a mutation, you first call `useRemoveTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTaskChecklistMutation, { data, loading, error }] = useRemoveTaskChecklistMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveTaskChecklistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveTaskChecklistMutation,
    RemoveTaskChecklistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveTaskChecklistMutation,
    RemoveTaskChecklistMutationVariables
  >(RemoveTaskChecklistDocument, options);
}
export type RemoveTaskChecklistMutationHookResult = ReturnType<
  typeof useRemoveTaskChecklistMutation
>;
export type RemoveTaskChecklistMutationResult =
  Apollo.MutationResult<RemoveTaskChecklistMutation>;
export type RemoveTaskChecklistMutationOptions = Apollo.BaseMutationOptions<
  RemoveTaskChecklistMutation,
  RemoveTaskChecklistMutationVariables
>;
export const RemoveTeamMemberDocument = gql`
  mutation removeTeamMember($id: ID!, $userId: ID!) {
    removeTeamMember(id: $id, userId: $userId) {
      ...TeamDetail
      ...TeamMembersDetail
    }
  }
  ${TeamDetailFragmentDoc}
  ${TeamMembersDetailFragmentDoc}
`;
export type RemoveTeamMemberMutationFn = Apollo.MutationFunction<
  RemoveTeamMemberMutation,
  RemoveTeamMemberMutationVariables
>;

/**
 * __useRemoveTeamMemberMutation__
 *
 * To run a mutation, you first call `useRemoveTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamMemberMutation, { data, loading, error }] = useRemoveTeamMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveTeamMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveTeamMemberMutation,
    RemoveTeamMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveTeamMemberMutation,
    RemoveTeamMemberMutationVariables
  >(RemoveTeamMemberDocument, options);
}
export type RemoveTeamMemberMutationHookResult = ReturnType<
  typeof useRemoveTeamMemberMutation
>;
export type RemoveTeamMemberMutationResult =
  Apollo.MutationResult<RemoveTeamMemberMutation>;
export type RemoveTeamMemberMutationOptions = Apollo.BaseMutationOptions<
  RemoveTeamMemberMutation,
  RemoveTeamMemberMutationVariables
>;
export const RenameDocumentDocument = gql`
  mutation renameDocument($id: ID!, $name: String!) {
    renameDocument(id: $id, name: $name) {
      id
      clientId
      name
    }
  }
`;
export type RenameDocumentMutationFn = Apollo.MutationFunction<
  RenameDocumentMutation,
  RenameDocumentMutationVariables
>;

/**
 * __useRenameDocumentMutation__
 *
 * To run a mutation, you first call `useRenameDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameDocumentMutation, { data, loading, error }] = useRenameDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RenameDocumentMutation,
    RenameDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RenameDocumentMutation,
    RenameDocumentMutationVariables
  >(RenameDocumentDocument, options);
}
export type RenameDocumentMutationHookResult = ReturnType<
  typeof useRenameDocumentMutation
>;
export type RenameDocumentMutationResult =
  Apollo.MutationResult<RenameDocumentMutation>;
export type RenameDocumentMutationOptions = Apollo.BaseMutationOptions<
  RenameDocumentMutation,
  RenameDocumentMutationVariables
>;
export const ResendChatInvitationDocument = gql`
  mutation resendChatInvitation($chatInvitationId: ID!) {
    resendChatInvitation(chatInvitationId: $chatInvitationId)
  }
`;
export type ResendChatInvitationMutationFn = Apollo.MutationFunction<
  ResendChatInvitationMutation,
  ResendChatInvitationMutationVariables
>;

/**
 * __useResendChatInvitationMutation__
 *
 * To run a mutation, you first call `useResendChatInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendChatInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendChatInvitationMutation, { data, loading, error }] = useResendChatInvitationMutation({
 *   variables: {
 *      chatInvitationId: // value for 'chatInvitationId'
 *   },
 * });
 */
export function useResendChatInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendChatInvitationMutation,
    ResendChatInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResendChatInvitationMutation,
    ResendChatInvitationMutationVariables
  >(ResendChatInvitationDocument, options);
}
export type ResendChatInvitationMutationHookResult = ReturnType<
  typeof useResendChatInvitationMutation
>;
export type ResendChatInvitationMutationResult =
  Apollo.MutationResult<ResendChatInvitationMutation>;
export type ResendChatInvitationMutationOptions = Apollo.BaseMutationOptions<
  ResendChatInvitationMutation,
  ResendChatInvitationMutationVariables
>;
export const ResendProjectInvitationDocument = gql`
  mutation resendProjectInvitation($projectInvitationId: ID!) {
    resendProjectInvitation(projectInvitationId: $projectInvitationId)
  }
`;
export type ResendProjectInvitationMutationFn = Apollo.MutationFunction<
  ResendProjectInvitationMutation,
  ResendProjectInvitationMutationVariables
>;

/**
 * __useResendProjectInvitationMutation__
 *
 * To run a mutation, you first call `useResendProjectInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendProjectInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendProjectInvitationMutation, { data, loading, error }] = useResendProjectInvitationMutation({
 *   variables: {
 *      projectInvitationId: // value for 'projectInvitationId'
 *   },
 * });
 */
export function useResendProjectInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendProjectInvitationMutation,
    ResendProjectInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResendProjectInvitationMutation,
    ResendProjectInvitationMutationVariables
  >(ResendProjectInvitationDocument, options);
}
export type ResendProjectInvitationMutationHookResult = ReturnType<
  typeof useResendProjectInvitationMutation
>;
export type ResendProjectInvitationMutationResult =
  Apollo.MutationResult<ResendProjectInvitationMutation>;
export type ResendProjectInvitationMutationOptions = Apollo.BaseMutationOptions<
  ResendProjectInvitationMutation,
  ResendProjectInvitationMutationVariables
>;
export const ResendTaskInvitationDocument = gql`
  mutation resendTaskInvitation($taskInvitationId: ID!) {
    resendTaskInvitation(taskInvitationId: $taskInvitationId)
  }
`;
export type ResendTaskInvitationMutationFn = Apollo.MutationFunction<
  ResendTaskInvitationMutation,
  ResendTaskInvitationMutationVariables
>;

/**
 * __useResendTaskInvitationMutation__
 *
 * To run a mutation, you first call `useResendTaskInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendTaskInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendTaskInvitationMutation, { data, loading, error }] = useResendTaskInvitationMutation({
 *   variables: {
 *      taskInvitationId: // value for 'taskInvitationId'
 *   },
 * });
 */
export function useResendTaskInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendTaskInvitationMutation,
    ResendTaskInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResendTaskInvitationMutation,
    ResendTaskInvitationMutationVariables
  >(ResendTaskInvitationDocument, options);
}
export type ResendTaskInvitationMutationHookResult = ReturnType<
  typeof useResendTaskInvitationMutation
>;
export type ResendTaskInvitationMutationResult =
  Apollo.MutationResult<ResendTaskInvitationMutation>;
export type ResendTaskInvitationMutationOptions = Apollo.BaseMutationOptions<
  ResendTaskInvitationMutation,
  ResendTaskInvitationMutationVariables
>;
export const ResendTeamInvitationDocument = gql`
  mutation resendTeamInvitation($accountInvitationId: ID, $userRequestId: ID) {
    resendTeamInvitation(
      accountInvitationId: $accountInvitationId
      userRequestId: $userRequestId
    )
  }
`;
export type ResendTeamInvitationMutationFn = Apollo.MutationFunction<
  ResendTeamInvitationMutation,
  ResendTeamInvitationMutationVariables
>;

/**
 * __useResendTeamInvitationMutation__
 *
 * To run a mutation, you first call `useResendTeamInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendTeamInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendTeamInvitationMutation, { data, loading, error }] = useResendTeamInvitationMutation({
 *   variables: {
 *      accountInvitationId: // value for 'accountInvitationId'
 *      userRequestId: // value for 'userRequestId'
 *   },
 * });
 */
export function useResendTeamInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendTeamInvitationMutation,
    ResendTeamInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResendTeamInvitationMutation,
    ResendTeamInvitationMutationVariables
  >(ResendTeamInvitationDocument, options);
}
export type ResendTeamInvitationMutationHookResult = ReturnType<
  typeof useResendTeamInvitationMutation
>;
export type ResendTeamInvitationMutationResult =
  Apollo.MutationResult<ResendTeamInvitationMutation>;
export type ResendTeamInvitationMutationOptions = Apollo.BaseMutationOptions<
  ResendTeamInvitationMutation,
  ResendTeamInvitationMutationVariables
>;
export const SaveChecklistAsTemplateDocument = gql`
  mutation saveChecklistAsTemplate(
    $projectUuid: ID!
    $attributes: SaveChecklistAsTemplateAttributes!
    $templateName: String!
  ) {
    saveChecklistAsTemplate(
      projectUuid: $projectUuid
      attributes: $attributes
      templateName: $templateName
    ) {
      id
    }
  }
`;
export type SaveChecklistAsTemplateMutationFn = Apollo.MutationFunction<
  SaveChecklistAsTemplateMutation,
  SaveChecklistAsTemplateMutationVariables
>;

/**
 * __useSaveChecklistAsTemplateMutation__
 *
 * To run a mutation, you first call `useSaveChecklistAsTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveChecklistAsTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveChecklistAsTemplateMutation, { data, loading, error }] = useSaveChecklistAsTemplateMutation({
 *   variables: {
 *      projectUuid: // value for 'projectUuid'
 *      attributes: // value for 'attributes'
 *      templateName: // value for 'templateName'
 *   },
 * });
 */
export function useSaveChecklistAsTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveChecklistAsTemplateMutation,
    SaveChecklistAsTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveChecklistAsTemplateMutation,
    SaveChecklistAsTemplateMutationVariables
  >(SaveChecklistAsTemplateDocument, options);
}
export type SaveChecklistAsTemplateMutationHookResult = ReturnType<
  typeof useSaveChecklistAsTemplateMutation
>;
export type SaveChecklistAsTemplateMutationResult =
  Apollo.MutationResult<SaveChecklistAsTemplateMutation>;
export type SaveChecklistAsTemplateMutationOptions = Apollo.BaseMutationOptions<
  SaveChecklistAsTemplateMutation,
  SaveChecklistAsTemplateMutationVariables
>;
export const SetPrimaryTeamDocument = gql`
  mutation SetPrimaryTeam($accountId: ID!) {
    setPrimaryTeam(accountId: $accountId) {
      id
      name
    }
  }
`;
export type SetPrimaryTeamMutationFn = Apollo.MutationFunction<
  SetPrimaryTeamMutation,
  SetPrimaryTeamMutationVariables
>;

/**
 * __useSetPrimaryTeamMutation__
 *
 * To run a mutation, you first call `useSetPrimaryTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimaryTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPrimaryTeamMutation, { data, loading, error }] = useSetPrimaryTeamMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useSetPrimaryTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetPrimaryTeamMutation,
    SetPrimaryTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetPrimaryTeamMutation,
    SetPrimaryTeamMutationVariables
  >(SetPrimaryTeamDocument, options);
}
export type SetPrimaryTeamMutationHookResult = ReturnType<
  typeof useSetPrimaryTeamMutation
>;
export type SetPrimaryTeamMutationResult =
  Apollo.MutationResult<SetPrimaryTeamMutation>;
export type SetPrimaryTeamMutationOptions = Apollo.BaseMutationOptions<
  SetPrimaryTeamMutation,
  SetPrimaryTeamMutationVariables
>;
export const ToggleChecklistTemplateFavoriteDocument = gql`
  mutation toggleChecklistTemplateFavorite($checklistTemplateId: ID!) {
    toggleChecklistTemplateFavorite(checklistTemplateId: $checklistTemplateId)
  }
`;
export type ToggleChecklistTemplateFavoriteMutationFn = Apollo.MutationFunction<
  ToggleChecklistTemplateFavoriteMutation,
  ToggleChecklistTemplateFavoriteMutationVariables
>;

/**
 * __useToggleChecklistTemplateFavoriteMutation__
 *
 * To run a mutation, you first call `useToggleChecklistTemplateFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleChecklistTemplateFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleChecklistTemplateFavoriteMutation, { data, loading, error }] = useToggleChecklistTemplateFavoriteMutation({
 *   variables: {
 *      checklistTemplateId: // value for 'checklistTemplateId'
 *   },
 * });
 */
export function useToggleChecklistTemplateFavoriteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleChecklistTemplateFavoriteMutation,
    ToggleChecklistTemplateFavoriteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleChecklistTemplateFavoriteMutation,
    ToggleChecklistTemplateFavoriteMutationVariables
  >(ToggleChecklistTemplateFavoriteDocument, options);
}
export type ToggleChecklistTemplateFavoriteMutationHookResult = ReturnType<
  typeof useToggleChecklistTemplateFavoriteMutation
>;
export type ToggleChecklistTemplateFavoriteMutationResult =
  Apollo.MutationResult<ToggleChecklistTemplateFavoriteMutation>;
export type ToggleChecklistTemplateFavoriteMutationOptions =
  Apollo.BaseMutationOptions<
    ToggleChecklistTemplateFavoriteMutation,
    ToggleChecklistTemplateFavoriteMutationVariables
  >;
export const UnarchiveChatDocument = gql`
  mutation unarchiveChat($id: ID!) {
    unarchiveChat(id: $id) {
      id
      name
      description
      users {
        id
      }
    }
  }
`;
export type UnarchiveChatMutationFn = Apollo.MutationFunction<
  UnarchiveChatMutation,
  UnarchiveChatMutationVariables
>;

/**
 * __useUnarchiveChatMutation__
 *
 * To run a mutation, you first call `useUnarchiveChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveChatMutation, { data, loading, error }] = useUnarchiveChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveChatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnarchiveChatMutation,
    UnarchiveChatMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnarchiveChatMutation,
    UnarchiveChatMutationVariables
  >(UnarchiveChatDocument, options);
}
export type UnarchiveChatMutationHookResult = ReturnType<
  typeof useUnarchiveChatMutation
>;
export type UnarchiveChatMutationResult =
  Apollo.MutationResult<UnarchiveChatMutation>;
export type UnarchiveChatMutationOptions = Apollo.BaseMutationOptions<
  UnarchiveChatMutation,
  UnarchiveChatMutationVariables
>;
export const UnarchiveProjectDocument = gql`
  mutation unarchiveProject($id: ID!) {
    unarchiveProject(id: $id) {
      ...ProjectDetail
    }
  }
  ${ProjectDetailFragmentDoc}
`;
export type UnarchiveProjectMutationFn = Apollo.MutationFunction<
  UnarchiveProjectMutation,
  UnarchiveProjectMutationVariables
>;

/**
 * __useUnarchiveProjectMutation__
 *
 * To run a mutation, you first call `useUnarchiveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveProjectMutation, { data, loading, error }] = useUnarchiveProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnarchiveProjectMutation,
    UnarchiveProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnarchiveProjectMutation,
    UnarchiveProjectMutationVariables
  >(UnarchiveProjectDocument, options);
}
export type UnarchiveProjectMutationHookResult = ReturnType<
  typeof useUnarchiveProjectMutation
>;
export type UnarchiveProjectMutationResult =
  Apollo.MutationResult<UnarchiveProjectMutation>;
export type UnarchiveProjectMutationOptions = Apollo.BaseMutationOptions<
  UnarchiveProjectMutation,
  UnarchiveProjectMutationVariables
>;
export const UpdateChatDocument = gql`
  mutation updateChat($id: ID!, $attributes: ChatAttributes!) {
    updateChat(id: $id, attributes: $attributes) {
      id
      name
      description
      avatar {
        ...AvatarDetail
      }
      settingsPin
      settingsMute
      settings {
        id
        pin
        mute
        archivedAt
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;
export type UpdateChatMutationFn = Apollo.MutationFunction<
  UpdateChatMutation,
  UpdateChatMutationVariables
>;

/**
 * __useUpdateChatMutation__
 *
 * To run a mutation, you first call `useUpdateChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatMutation, { data, loading, error }] = useUpdateChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateChatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateChatMutation,
    UpdateChatMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateChatMutation, UpdateChatMutationVariables>(
    UpdateChatDocument,
    options
  );
}
export type UpdateChatMutationHookResult = ReturnType<
  typeof useUpdateChatMutation
>;
export type UpdateChatMutationResult =
  Apollo.MutationResult<UpdateChatMutation>;
export type UpdateChatMutationOptions = Apollo.BaseMutationOptions<
  UpdateChatMutation,
  UpdateChatMutationVariables
>;
export const UpdateChatAdminDocument = gql`
  mutation updateChatAdmin($id: ID!, $userId: ID!) {
    updateChatAdmin(id: $id, userId: $userId) {
      id
      name
      description
      owner {
        id
      }
      avatar {
        ...AvatarDetail
      }
      settings {
        mute
        pin
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;
export type UpdateChatAdminMutationFn = Apollo.MutationFunction<
  UpdateChatAdminMutation,
  UpdateChatAdminMutationVariables
>;

/**
 * __useUpdateChatAdminMutation__
 *
 * To run a mutation, you first call `useUpdateChatAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatAdminMutation, { data, loading, error }] = useUpdateChatAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateChatAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateChatAdminMutation,
    UpdateChatAdminMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateChatAdminMutation,
    UpdateChatAdminMutationVariables
  >(UpdateChatAdminDocument, options);
}
export type UpdateChatAdminMutationHookResult = ReturnType<
  typeof useUpdateChatAdminMutation
>;
export type UpdateChatAdminMutationResult =
  Apollo.MutationResult<UpdateChatAdminMutation>;
export type UpdateChatAdminMutationOptions = Apollo.BaseMutationOptions<
  UpdateChatAdminMutation,
  UpdateChatAdminMutationVariables
>;
export const UpdateDocumentTagsDocument = gql`
  mutation updateDocumentTags(
    $id: ID!
    $messageId: ID!
    $attributes: MessageTagAttributes!
  ) {
    updateDocumentTags(
      id: $id
      messageId: $messageId
      attributes: $attributes
    ) {
      id
      clientId
      taskDocuments {
        id
        owner {
          id
        }
        task {
          id
          name
          projectId
          project {
            id
            name
          }
        }
      }
      projectDocuments {
        id
        owner {
          id
        }
        project {
          id
          name
        }
      }
      messageDocuments {
        message {
          ...MessageDetail
        }
      }
    }
  }
  ${MessageDetailFragmentDoc}
`;
export type UpdateDocumentTagsMutationFn = Apollo.MutationFunction<
  UpdateDocumentTagsMutation,
  UpdateDocumentTagsMutationVariables
>;

/**
 * __useUpdateDocumentTagsMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentTagsMutation, { data, loading, error }] = useUpdateDocumentTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      messageId: // value for 'messageId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateDocumentTagsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDocumentTagsMutation,
    UpdateDocumentTagsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDocumentTagsMutation,
    UpdateDocumentTagsMutationVariables
  >(UpdateDocumentTagsDocument, options);
}
export type UpdateDocumentTagsMutationHookResult = ReturnType<
  typeof useUpdateDocumentTagsMutation
>;
export type UpdateDocumentTagsMutationResult =
  Apollo.MutationResult<UpdateDocumentTagsMutation>;
export type UpdateDocumentTagsMutationOptions = Apollo.BaseMutationOptions<
  UpdateDocumentTagsMutation,
  UpdateDocumentTagsMutationVariables
>;
export const UpdateDraftMessageDocument = gql`
  mutation updateDraftMessage(
    $chatId: ID!
    $attributes: DraftMessageAttributes!
  ) {
    updateDraftMessage(chatId: $chatId, attributes: $attributes) @client {
      ...DraftMessageDetail
    }
  }
  ${DraftMessageDetailFragmentDoc}
`;
export type UpdateDraftMessageMutationFn = Apollo.MutationFunction<
  UpdateDraftMessageMutation,
  UpdateDraftMessageMutationVariables
>;

/**
 * __useUpdateDraftMessageMutation__
 *
 * To run a mutation, you first call `useUpdateDraftMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftMessageMutation, { data, loading, error }] = useUpdateDraftMessageMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateDraftMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDraftMessageMutation,
    UpdateDraftMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDraftMessageMutation,
    UpdateDraftMessageMutationVariables
  >(UpdateDraftMessageDocument, options);
}
export type UpdateDraftMessageMutationHookResult = ReturnType<
  typeof useUpdateDraftMessageMutation
>;
export type UpdateDraftMessageMutationResult =
  Apollo.MutationResult<UpdateDraftMessageMutation>;
export type UpdateDraftMessageMutationOptions = Apollo.BaseMutationOptions<
  UpdateDraftMessageMutation,
  UpdateDraftMessageMutationVariables
>;
export const UpdateGroupDocument = gql`
  mutation updateGroup($id: ID!, $attributes: GroupAttributes!) {
    updateGroup(id: $id, attributes: $attributes) {
      id
      name
      team {
        id
      }
      users {
        id
      }
    }
  }
`;
export type UpdateGroupMutationFn = Apollo.MutationFunction<
  UpdateGroupMutation,
  UpdateGroupMutationVariables
>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateGroupMutation,
    UpdateGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(
    UpdateGroupDocument,
    options
  );
}
export type UpdateGroupMutationHookResult = ReturnType<
  typeof useUpdateGroupMutation
>;
export type UpdateGroupMutationResult =
  Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateGroupMutation,
  UpdateGroupMutationVariables
>;
export const UpdateHashtagTooltipSeenDocument = gql`
  mutation updateHashtagTooltipSeen($web: Boolean!) {
    updateHashtagTooltipSeen(web: $web) {
      id
      hasSeenTagTooltipWeb
      hasSeenTagTooltipNative
    }
  }
`;
export type UpdateHashtagTooltipSeenMutationFn = Apollo.MutationFunction<
  UpdateHashtagTooltipSeenMutation,
  UpdateHashtagTooltipSeenMutationVariables
>;

/**
 * __useUpdateHashtagTooltipSeenMutation__
 *
 * To run a mutation, you first call `useUpdateHashtagTooltipSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHashtagTooltipSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHashtagTooltipSeenMutation, { data, loading, error }] = useUpdateHashtagTooltipSeenMutation({
 *   variables: {
 *      web: // value for 'web'
 *   },
 * });
 */
export function useUpdateHashtagTooltipSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateHashtagTooltipSeenMutation,
    UpdateHashtagTooltipSeenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateHashtagTooltipSeenMutation,
    UpdateHashtagTooltipSeenMutationVariables
  >(UpdateHashtagTooltipSeenDocument, options);
}
export type UpdateHashtagTooltipSeenMutationHookResult = ReturnType<
  typeof useUpdateHashtagTooltipSeenMutation
>;
export type UpdateHashtagTooltipSeenMutationResult =
  Apollo.MutationResult<UpdateHashtagTooltipSeenMutation>;
export type UpdateHashtagTooltipSeenMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateHashtagTooltipSeenMutation,
    UpdateHashtagTooltipSeenMutationVariables
  >;
export const UpdateMeDocument = gql`
  mutation updateMe($attributes: UserAttributes!) {
    updateMe(attributes: $attributes) {
      id
      name
      email
      phoneNumber
      address
      latitude
      longitude
      timeZone
      skills {
        name
      }
      avatar {
        ...AvatarDetail
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;
export type UpdateMeMutationFn = Apollo.MutationFunction<
  UpdateMeMutation,
  UpdateMeMutationVariables
>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateMeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMeMutation,
    UpdateMeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(
    UpdateMeDocument,
    options
  );
}
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<
  UpdateMeMutation,
  UpdateMeMutationVariables
>;
export const UpdateMessageIndividualDocument = gql`
  mutation updateMessageIndividual(
    $id: ID
    $clientId: String
    $attributes: MessageAttributes!
  ) {
    updateMessageIndividual(
      id: $id
      clientId: $clientId
      attributes: $attributes
    ) {
      ...MessageDetail
    }
  }
  ${MessageDetailFragmentDoc}
`;
export type UpdateMessageIndividualMutationFn = Apollo.MutationFunction<
  UpdateMessageIndividualMutation,
  UpdateMessageIndividualMutationVariables
>;

/**
 * __useUpdateMessageIndividualMutation__
 *
 * To run a mutation, you first call `useUpdateMessageIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageIndividualMutation, { data, loading, error }] = useUpdateMessageIndividualMutation({
 *   variables: {
 *      id: // value for 'id'
 *      clientId: // value for 'clientId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateMessageIndividualMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMessageIndividualMutation,
    UpdateMessageIndividualMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMessageIndividualMutation,
    UpdateMessageIndividualMutationVariables
  >(UpdateMessageIndividualDocument, options);
}
export type UpdateMessageIndividualMutationHookResult = ReturnType<
  typeof useUpdateMessageIndividualMutation
>;
export type UpdateMessageIndividualMutationResult =
  Apollo.MutationResult<UpdateMessageIndividualMutation>;
export type UpdateMessageIndividualMutationOptions = Apollo.BaseMutationOptions<
  UpdateMessageIndividualMutation,
  UpdateMessageIndividualMutationVariables
>;
export const UpdateMessageTagsDocument = gql`
  mutation updateMessageTags($id: ID!, $attributes: MessageTagAttributes!) {
    updateMessageTags(id: $id, attributes: $attributes) {
      ...MessageDetail
    }
  }
  ${MessageDetailFragmentDoc}
`;
export type UpdateMessageTagsMutationFn = Apollo.MutationFunction<
  UpdateMessageTagsMutation,
  UpdateMessageTagsMutationVariables
>;

/**
 * __useUpdateMessageTagsMutation__
 *
 * To run a mutation, you first call `useUpdateMessageTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageTagsMutation, { data, loading, error }] = useUpdateMessageTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateMessageTagsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMessageTagsMutation,
    UpdateMessageTagsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMessageTagsMutation,
    UpdateMessageTagsMutationVariables
  >(UpdateMessageTagsDocument, options);
}
export type UpdateMessageTagsMutationHookResult = ReturnType<
  typeof useUpdateMessageTagsMutation
>;
export type UpdateMessageTagsMutationResult =
  Apollo.MutationResult<UpdateMessageTagsMutation>;
export type UpdateMessageTagsMutationOptions = Apollo.BaseMutationOptions<
  UpdateMessageTagsMutation,
  UpdateMessageTagsMutationVariables
>;
export const UpdateNotificationSettingDocument = gql`
  mutation updateNotificationSetting(
    $attributes: [NotificationSettingAttributes!]!
  ) {
    updateNotificationSetting(attributes: $attributes) {
      settingType
      mute
      duration
    }
  }
`;
export type UpdateNotificationSettingMutationFn = Apollo.MutationFunction<
  UpdateNotificationSettingMutation,
  UpdateNotificationSettingMutationVariables
>;

/**
 * __useUpdateNotificationSettingMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationSettingMutation, { data, loading, error }] = useUpdateNotificationSettingMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateNotificationSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNotificationSettingMutation,
    UpdateNotificationSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateNotificationSettingMutation,
    UpdateNotificationSettingMutationVariables
  >(UpdateNotificationSettingDocument, options);
}
export type UpdateNotificationSettingMutationHookResult = ReturnType<
  typeof useUpdateNotificationSettingMutation
>;
export type UpdateNotificationSettingMutationResult =
  Apollo.MutationResult<UpdateNotificationSettingMutation>;
export type UpdateNotificationSettingMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateNotificationSettingMutation,
    UpdateNotificationSettingMutationVariables
  >;
export const UpdateOnboardingStateDocument = gql`
  mutation UpdateOnboardingState($attributes: OnboardingStateAttributes!) {
    updateOnboardingState(attributes: $attributes) {
      id
    }
  }
`;
export type UpdateOnboardingStateMutationFn = Apollo.MutationFunction<
  UpdateOnboardingStateMutation,
  UpdateOnboardingStateMutationVariables
>;

/**
 * __useUpdateOnboardingStateMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingStateMutation, { data, loading, error }] = useUpdateOnboardingStateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateOnboardingStateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOnboardingStateMutation,
    UpdateOnboardingStateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOnboardingStateMutation,
    UpdateOnboardingStateMutationVariables
  >(UpdateOnboardingStateDocument, options);
}
export type UpdateOnboardingStateMutationHookResult = ReturnType<
  typeof useUpdateOnboardingStateMutation
>;
export type UpdateOnboardingStateMutationResult =
  Apollo.MutationResult<UpdateOnboardingStateMutation>;
export type UpdateOnboardingStateMutationOptions = Apollo.BaseMutationOptions<
  UpdateOnboardingStateMutation,
  UpdateOnboardingStateMutationVariables
>;
export const UpdatePaymentMethodDocument = gql`
  mutation updatePaymentMethod($teamId: ID!, $paymentMethodToken: String!) {
    updatePaymentMethod(
      teamId: $teamId
      paymentMethodToken: $paymentMethodToken
    ) {
      ...TeamDetail
      ...TeamMembersDetail
    }
  }
  ${TeamDetailFragmentDoc}
  ${TeamMembersDetailFragmentDoc}
`;
export type UpdatePaymentMethodMutationFn = Apollo.MutationFunction<
  UpdatePaymentMethodMutation,
  UpdatePaymentMethodMutationVariables
>;

/**
 * __useUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMethodMutation, { data, loading, error }] = useUpdatePaymentMethodMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      paymentMethodToken: // value for 'paymentMethodToken'
 *   },
 * });
 */
export function useUpdatePaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePaymentMethodMutation,
    UpdatePaymentMethodMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePaymentMethodMutation,
    UpdatePaymentMethodMutationVariables
  >(UpdatePaymentMethodDocument, options);
}
export type UpdatePaymentMethodMutationHookResult = ReturnType<
  typeof useUpdatePaymentMethodMutation
>;
export type UpdatePaymentMethodMutationResult =
  Apollo.MutationResult<UpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<
  UpdatePaymentMethodMutation,
  UpdatePaymentMethodMutationVariables
>;
export const UpdateProjectDocument = gql`
  mutation updateProject($id: ID!, $attributes: ProjectAttributes!) {
    updateProject(id: $id, attributes: $attributes) {
      id
      teamId
      initials
      name
      description
      coverImage {
        ...FileDetails
      }
      address
      latitude
      longitude
      color
      icon
      createdAt
      archivedAt
      team {
        id
        name
        avatar
      }
      members {
        id
        role
        user {
          ...UserDetail
        }
      }
      creator {
        ...UserDetail
      }
      tasks {
        id
      }
      settings {
        id
        pin
      }
    }
  }
  ${FileDetailsFragmentDoc}
  ${UserDetailFragmentDoc}
`;
export type UpdateProjectMutationFn = Apollo.MutationFunction<
  UpdateProjectMutation,
  UpdateProjectMutationVariables
>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProjectMutation,
    UpdateProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProjectMutation,
    UpdateProjectMutationVariables
  >(UpdateProjectDocument, options);
}
export type UpdateProjectMutationHookResult = ReturnType<
  typeof useUpdateProjectMutation
>;
export type UpdateProjectMutationResult =
  Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<
  UpdateProjectMutation,
  UpdateProjectMutationVariables
>;
export const UpdateProjectChecklistDocument = gql`
  mutation updateProjectChecklist(
    $projectChecklistId: ID!
    $attributes: UpdateProjectChecklistAttributes!
  ) {
    updateProjectChecklist(
      projectChecklistId: $projectChecklistId
      attributes: $attributes
    ) {
      projectId
      id
      name
      completedAt
      createdAt
      sort
    }
  }
`;
export type UpdateProjectChecklistMutationFn = Apollo.MutationFunction<
  UpdateProjectChecklistMutation,
  UpdateProjectChecklistMutationVariables
>;

/**
 * __useUpdateProjectChecklistMutation__
 *
 * To run a mutation, you first call `useUpdateProjectChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectChecklistMutation, { data, loading, error }] = useUpdateProjectChecklistMutation({
 *   variables: {
 *      projectChecklistId: // value for 'projectChecklistId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateProjectChecklistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProjectChecklistMutation,
    UpdateProjectChecklistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProjectChecklistMutation,
    UpdateProjectChecklistMutationVariables
  >(UpdateProjectChecklistDocument, options);
}
export type UpdateProjectChecklistMutationHookResult = ReturnType<
  typeof useUpdateProjectChecklistMutation
>;
export type UpdateProjectChecklistMutationResult =
  Apollo.MutationResult<UpdateProjectChecklistMutation>;
export type UpdateProjectChecklistMutationOptions = Apollo.BaseMutationOptions<
  UpdateProjectChecklistMutation,
  UpdateProjectChecklistMutationVariables
>;
export const UpdateProjectChecklistSortDocument = gql`
  mutation updateProjectChecklistSort(
    $projectUUId: ID!
    $attributes: [ProjectChecklistSortAttributes!]!
  ) {
    updateProjectChecklistSort(uuid: $projectUUId, attributes: $attributes) {
      projectId
    }
  }
`;
export type UpdateProjectChecklistSortMutationFn = Apollo.MutationFunction<
  UpdateProjectChecklistSortMutation,
  UpdateProjectChecklistSortMutationVariables
>;

/**
 * __useUpdateProjectChecklistSortMutation__
 *
 * To run a mutation, you first call `useUpdateProjectChecklistSortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectChecklistSortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectChecklistSortMutation, { data, loading, error }] = useUpdateProjectChecklistSortMutation({
 *   variables: {
 *      projectUUId: // value for 'projectUUId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateProjectChecklistSortMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProjectChecklistSortMutation,
    UpdateProjectChecklistSortMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProjectChecklistSortMutation,
    UpdateProjectChecklistSortMutationVariables
  >(UpdateProjectChecklistSortDocument, options);
}
export type UpdateProjectChecklistSortMutationHookResult = ReturnType<
  typeof useUpdateProjectChecklistSortMutation
>;
export type UpdateProjectChecklistSortMutationResult =
  Apollo.MutationResult<UpdateProjectChecklistSortMutation>;
export type UpdateProjectChecklistSortMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateProjectChecklistSortMutation,
    UpdateProjectChecklistSortMutationVariables
  >;
export const UpdateProjectFileTagsDocument = gql`
  mutation updateProjectFileTags($id: ID!, $taskIds: [ID!], $projectId: ID!) {
    updateProjectFileTags(id: $id, taskIds: $taskIds, projectId: $projectId) {
      id
      clientId
    }
  }
`;
export type UpdateProjectFileTagsMutationFn = Apollo.MutationFunction<
  UpdateProjectFileTagsMutation,
  UpdateProjectFileTagsMutationVariables
>;

/**
 * __useUpdateProjectFileTagsMutation__
 *
 * To run a mutation, you first call `useUpdateProjectFileTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectFileTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectFileTagsMutation, { data, loading, error }] = useUpdateProjectFileTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      taskIds: // value for 'taskIds'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUpdateProjectFileTagsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProjectFileTagsMutation,
    UpdateProjectFileTagsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProjectFileTagsMutation,
    UpdateProjectFileTagsMutationVariables
  >(UpdateProjectFileTagsDocument, options);
}
export type UpdateProjectFileTagsMutationHookResult = ReturnType<
  typeof useUpdateProjectFileTagsMutation
>;
export type UpdateProjectFileTagsMutationResult =
  Apollo.MutationResult<UpdateProjectFileTagsMutation>;
export type UpdateProjectFileTagsMutationOptions = Apollo.BaseMutationOptions<
  UpdateProjectFileTagsMutation,
  UpdateProjectFileTagsMutationVariables
>;
export const UpdateProjectMembersDocument = gql`
  mutation updateProjectMembers(
    $id: ID!
    $attributes: [ProjectMemberAttributes!]!
  ) {
    updateProjectMembers(id: $id, attributes: $attributes) {
      id
      usersCount
      members {
        id
        role
        user {
          ...UserDetail
        }
      }
    }
  }
  ${UserDetailFragmentDoc}
`;
export type UpdateProjectMembersMutationFn = Apollo.MutationFunction<
  UpdateProjectMembersMutation,
  UpdateProjectMembersMutationVariables
>;

/**
 * __useUpdateProjectMembersMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMembersMutation, { data, loading, error }] = useUpdateProjectMembersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateProjectMembersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProjectMembersMutation,
    UpdateProjectMembersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProjectMembersMutation,
    UpdateProjectMembersMutationVariables
  >(UpdateProjectMembersDocument, options);
}
export type UpdateProjectMembersMutationHookResult = ReturnType<
  typeof useUpdateProjectMembersMutation
>;
export type UpdateProjectMembersMutationResult =
  Apollo.MutationResult<UpdateProjectMembersMutation>;
export type UpdateProjectMembersMutationOptions = Apollo.BaseMutationOptions<
  UpdateProjectMembersMutation,
  UpdateProjectMembersMutationVariables
>;
export const UpdateRateUsStateDocument = gql`
  mutation updateRateUsState($attributes: UpdateRateUsStateAttributes!) {
    updateRateUsState(attributes: $attributes) {
      ...RateUsStateDetail
    }
  }
  ${RateUsStateDetailFragmentDoc}
`;
export type UpdateRateUsStateMutationFn = Apollo.MutationFunction<
  UpdateRateUsStateMutation,
  UpdateRateUsStateMutationVariables
>;

/**
 * __useUpdateRateUsStateMutation__
 *
 * To run a mutation, you first call `useUpdateRateUsStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRateUsStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRateUsStateMutation, { data, loading, error }] = useUpdateRateUsStateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateRateUsStateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRateUsStateMutation,
    UpdateRateUsStateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateRateUsStateMutation,
    UpdateRateUsStateMutationVariables
  >(UpdateRateUsStateDocument, options);
}
export type UpdateRateUsStateMutationHookResult = ReturnType<
  typeof useUpdateRateUsStateMutation
>;
export type UpdateRateUsStateMutationResult =
  Apollo.MutationResult<UpdateRateUsStateMutation>;
export type UpdateRateUsStateMutationOptions = Apollo.BaseMutationOptions<
  UpdateRateUsStateMutation,
  UpdateRateUsStateMutationVariables
>;
export const UpdateTaskDocument = gql`
  mutation updateTask($id: ID!, $attributes: TaskAttributes!) {
    updateTask(id: $id, attributes: $attributes) {
      ...TaskDetail
    }
  }
  ${TaskDetailFragmentDoc}
`;
export type UpdateTaskMutationFn = Apollo.MutationFunction<
  UpdateTaskMutation,
  UpdateTaskMutationVariables
>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTaskMutation,
    UpdateTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(
    UpdateTaskDocument,
    options
  );
}
export type UpdateTaskMutationHookResult = ReturnType<
  typeof useUpdateTaskMutation
>;
export type UpdateTaskMutationResult =
  Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<
  UpdateTaskMutation,
  UpdateTaskMutationVariables
>;
export const UpdateTaskChecklistDocument = gql`
  mutation updateTaskChecklist(
    $id: ID!
    $attributes: TaskChecklistAttributes!
  ) {
    updateTaskChecklist(id: $id, attributes: $attributes) {
      taskId
      id
      name
      completedAt
      createdAt
      sort
    }
  }
`;
export type UpdateTaskChecklistMutationFn = Apollo.MutationFunction<
  UpdateTaskChecklistMutation,
  UpdateTaskChecklistMutationVariables
>;

/**
 * __useUpdateTaskChecklistMutation__
 *
 * To run a mutation, you first call `useUpdateTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskChecklistMutation, { data, loading, error }] = useUpdateTaskChecklistMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateTaskChecklistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTaskChecklistMutation,
    UpdateTaskChecklistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTaskChecklistMutation,
    UpdateTaskChecklistMutationVariables
  >(UpdateTaskChecklistDocument, options);
}
export type UpdateTaskChecklistMutationHookResult = ReturnType<
  typeof useUpdateTaskChecklistMutation
>;
export type UpdateTaskChecklistMutationResult =
  Apollo.MutationResult<UpdateTaskChecklistMutation>;
export type UpdateTaskChecklistMutationOptions = Apollo.BaseMutationOptions<
  UpdateTaskChecklistMutation,
  UpdateTaskChecklistMutationVariables
>;
export const UpdateTaskChecklistSortDocument = gql`
  mutation updateTaskChecklistSort(
    $taskId: ID!
    $attributes: [TaskChecklistAttributes!]!
  ) {
    updateTaskChecklistSort(taskId: $taskId, attributes: $attributes) {
      taskId
      id
      name
      completedAt
      createdAt
      sort
    }
  }
`;
export type UpdateTaskChecklistSortMutationFn = Apollo.MutationFunction<
  UpdateTaskChecklistSortMutation,
  UpdateTaskChecklistSortMutationVariables
>;

/**
 * __useUpdateTaskChecklistSortMutation__
 *
 * To run a mutation, you first call `useUpdateTaskChecklistSortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskChecklistSortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskChecklistSortMutation, { data, loading, error }] = useUpdateTaskChecklistSortMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateTaskChecklistSortMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTaskChecklistSortMutation,
    UpdateTaskChecklistSortMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTaskChecklistSortMutation,
    UpdateTaskChecklistSortMutationVariables
  >(UpdateTaskChecklistSortDocument, options);
}
export type UpdateTaskChecklistSortMutationHookResult = ReturnType<
  typeof useUpdateTaskChecklistSortMutation
>;
export type UpdateTaskChecklistSortMutationResult =
  Apollo.MutationResult<UpdateTaskChecklistSortMutation>;
export type UpdateTaskChecklistSortMutationOptions = Apollo.BaseMutationOptions<
  UpdateTaskChecklistSortMutation,
  UpdateTaskChecklistSortMutationVariables
>;
export const UpdateTaskMembersDocument = gql`
  mutation updateTaskMembers($id: ID!, $attributes: [TaskMemberAttributes!]!) {
    updateTaskMembers(id: $id, attributes: $attributes) {
      id
      members {
        id
        role
        user {
          ...UserDetail
        }
      }
    }
  }
  ${UserDetailFragmentDoc}
`;
export type UpdateTaskMembersMutationFn = Apollo.MutationFunction<
  UpdateTaskMembersMutation,
  UpdateTaskMembersMutationVariables
>;

/**
 * __useUpdateTaskMembersMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMembersMutation, { data, loading, error }] = useUpdateTaskMembersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateTaskMembersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTaskMembersMutation,
    UpdateTaskMembersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTaskMembersMutation,
    UpdateTaskMembersMutationVariables
  >(UpdateTaskMembersDocument, options);
}
export type UpdateTaskMembersMutationHookResult = ReturnType<
  typeof useUpdateTaskMembersMutation
>;
export type UpdateTaskMembersMutationResult =
  Apollo.MutationResult<UpdateTaskMembersMutation>;
export type UpdateTaskMembersMutationOptions = Apollo.BaseMutationOptions<
  UpdateTaskMembersMutation,
  UpdateTaskMembersMutationVariables
>;
export const UpdateTeamDocument = gql`
  mutation updateTeam($id: ID!, $attributes: TeamAttributes!) {
    updateTeam(id: $id, attributes: $attributes) {
      ...TeamDetail
      ...TeamMembersDetail
    }
  }
  ${TeamDetailFragmentDoc}
  ${TeamMembersDetailFragmentDoc}
`;
export type UpdateTeamMutationFn = Apollo.MutationFunction<
  UpdateTeamMutation,
  UpdateTeamMutationVariables
>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeamMutation,
    UpdateTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(
    UpdateTeamDocument,
    options
  );
}
export type UpdateTeamMutationHookResult = ReturnType<
  typeof useUpdateTeamMutation
>;
export type UpdateTeamMutationResult =
  Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeamMutation,
  UpdateTeamMutationVariables
>;
export const UpdateTeamMembersDocument = gql`
  mutation updateTeamMembers($teamId: ID!, $attributes: [MemberAttributes!]!) {
    updateTeamMembers(teamId: $teamId, attributes: $attributes) {
      ...TeamDetail
      ...TeamMembersDetail
    }
  }
  ${TeamDetailFragmentDoc}
  ${TeamMembersDetailFragmentDoc}
`;
export type UpdateTeamMembersMutationFn = Apollo.MutationFunction<
  UpdateTeamMembersMutation,
  UpdateTeamMembersMutationVariables
>;

/**
 * __useUpdateTeamMembersMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMembersMutation, { data, loading, error }] = useUpdateTeamMembersMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateTeamMembersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeamMembersMutation,
    UpdateTeamMembersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTeamMembersMutation,
    UpdateTeamMembersMutationVariables
  >(UpdateTeamMembersDocument, options);
}
export type UpdateTeamMembersMutationHookResult = ReturnType<
  typeof useUpdateTeamMembersMutation
>;
export type UpdateTeamMembersMutationResult =
  Apollo.MutationResult<UpdateTeamMembersMutation>;
export type UpdateTeamMembersMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeamMembersMutation,
  UpdateTeamMembersMutationVariables
>;
export const UpdateTutoralizationSettingDocument = gql`
  mutation updateTutoralizationSetting(
    $attributes: [TutoralizationSettingAttributes!]!
  ) {
    updateTutoralizationSetting(attributes: $attributes) {
      close
      settingType
    }
  }
`;
export type UpdateTutoralizationSettingMutationFn = Apollo.MutationFunction<
  UpdateTutoralizationSettingMutation,
  UpdateTutoralizationSettingMutationVariables
>;

/**
 * __useUpdateTutoralizationSettingMutation__
 *
 * To run a mutation, you first call `useUpdateTutoralizationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTutoralizationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTutoralizationSettingMutation, { data, loading, error }] = useUpdateTutoralizationSettingMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateTutoralizationSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTutoralizationSettingMutation,
    UpdateTutoralizationSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTutoralizationSettingMutation,
    UpdateTutoralizationSettingMutationVariables
  >(UpdateTutoralizationSettingDocument, options);
}
export type UpdateTutoralizationSettingMutationHookResult = ReturnType<
  typeof useUpdateTutoralizationSettingMutation
>;
export type UpdateTutoralizationSettingMutationResult =
  Apollo.MutationResult<UpdateTutoralizationSettingMutation>;
export type UpdateTutoralizationSettingMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateTutoralizationSettingMutation,
    UpdateTutoralizationSettingMutationVariables
  >;
export const UpdateUserRequestStatusDocument = gql`
  mutation updateUserRequestStatus($id: ID!, $status: String!) {
    updateUserRequestStatus(id: $id, status: $status) {
      id
      status
    }
  }
`;
export type UpdateUserRequestStatusMutationFn = Apollo.MutationFunction<
  UpdateUserRequestStatusMutation,
  UpdateUserRequestStatusMutationVariables
>;

/**
 * __useUpdateUserRequestStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUserRequestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRequestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRequestStatusMutation, { data, loading, error }] = useUpdateUserRequestStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateUserRequestStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserRequestStatusMutation,
    UpdateUserRequestStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserRequestStatusMutation,
    UpdateUserRequestStatusMutationVariables
  >(UpdateUserRequestStatusDocument, options);
}
export type UpdateUserRequestStatusMutationHookResult = ReturnType<
  typeof useUpdateUserRequestStatusMutation
>;
export type UpdateUserRequestStatusMutationResult =
  Apollo.MutationResult<UpdateUserRequestStatusMutation>;
export type UpdateUserRequestStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserRequestStatusMutation,
  UpdateUserRequestStatusMutationVariables
>;
export const UploadContactsDocument = gql`
  mutation uploadContacts($attributes: UploadContactAttributes!) {
    uploadContacts(attributes: $attributes) {
      phoneNumber
    }
  }
`;
export type UploadContactsMutationFn = Apollo.MutationFunction<
  UploadContactsMutation,
  UploadContactsMutationVariables
>;

/**
 * __useUploadContactsMutation__
 *
 * To run a mutation, you first call `useUploadContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadContactsMutation, { data, loading, error }] = useUploadContactsMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUploadContactsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadContactsMutation,
    UploadContactsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadContactsMutation,
    UploadContactsMutationVariables
  >(UploadContactsDocument, options);
}
export type UploadContactsMutationHookResult = ReturnType<
  typeof useUploadContactsMutation
>;
export type UploadContactsMutationResult =
  Apollo.MutationResult<UploadContactsMutation>;
export type UploadContactsMutationOptions = Apollo.BaseMutationOptions<
  UploadContactsMutation,
  UploadContactsMutationVariables
>;
export const GetProjectChatActivityReportDocument = gql`
  query getProjectChatActivityReport($uuid: ID!, $limit: Int) {
    getProjectChatActivityReport(uuid: $uuid, limit: $limit) {
      createdAt
      event
      createdAt
      id
      user {
        ...PublicUserDetail
      }
      attachment {
        ... on Message {
          id
          chatId
          body
          clientId
          createdAt
          publishedAt
          authorId
          author {
            id
            name
            firstName
            lastName
            createdAt
          }
        }
      }
    }
  }
  ${PublicUserDetailFragmentDoc}
`;

/**
 * __useGetProjectChatActivityReportQuery__
 *
 * To run a query within a React component, call `useGetProjectChatActivityReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectChatActivityReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectChatActivityReportQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetProjectChatActivityReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProjectChatActivityReportQuery,
    GetProjectChatActivityReportQueryVariables
  > &
    (
      | {
          variables: GetProjectChatActivityReportQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProjectChatActivityReportQuery,
    GetProjectChatActivityReportQueryVariables
  >(GetProjectChatActivityReportDocument, options);
}
export function useGetProjectChatActivityReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProjectChatActivityReportQuery,
    GetProjectChatActivityReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProjectChatActivityReportQuery,
    GetProjectChatActivityReportQueryVariables
  >(GetProjectChatActivityReportDocument, options);
}
// @ts-ignore
export function useGetProjectChatActivityReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProjectChatActivityReportQuery,
    GetProjectChatActivityReportQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetProjectChatActivityReportQuery,
  GetProjectChatActivityReportQueryVariables
>;
export function useGetProjectChatActivityReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectChatActivityReportQuery,
        GetProjectChatActivityReportQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetProjectChatActivityReportQuery | undefined,
  GetProjectChatActivityReportQueryVariables
>;
export function useGetProjectChatActivityReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectChatActivityReportQuery,
        GetProjectChatActivityReportQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetProjectChatActivityReportQuery,
    GetProjectChatActivityReportQueryVariables
  >(GetProjectChatActivityReportDocument, options);
}
export type GetProjectChatActivityReportQueryHookResult = ReturnType<
  typeof useGetProjectChatActivityReportQuery
>;
export type GetProjectChatActivityReportLazyQueryHookResult = ReturnType<
  typeof useGetProjectChatActivityReportLazyQuery
>;
export type GetProjectChatActivityReportSuspenseQueryHookResult = ReturnType<
  typeof useGetProjectChatActivityReportSuspenseQuery
>;
export type GetProjectChatActivityReportQueryResult = Apollo.QueryResult<
  GetProjectChatActivityReportQuery,
  GetProjectChatActivityReportQueryVariables
>;
export const GetProjectReportDocument = gql`
  query getProjectReport($id: ID!) {
    getProjectReport(id: $id)
  }
`;

/**
 * __useGetProjectReportQuery__
 *
 * To run a query within a React component, call `useGetProjectReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProjectReportQuery,
    GetProjectReportQueryVariables
  > &
    (
      | { variables: GetProjectReportQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProjectReportQuery, GetProjectReportQueryVariables>(
    GetProjectReportDocument,
    options
  );
}
export function useGetProjectReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProjectReportQuery,
    GetProjectReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProjectReportQuery,
    GetProjectReportQueryVariables
  >(GetProjectReportDocument, options);
}
// @ts-ignore
export function useGetProjectReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProjectReportQuery,
    GetProjectReportQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetProjectReportQuery,
  GetProjectReportQueryVariables
>;
export function useGetProjectReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectReportQuery,
        GetProjectReportQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetProjectReportQuery | undefined,
  GetProjectReportQueryVariables
>;
export function useGetProjectReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectReportQuery,
        GetProjectReportQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetProjectReportQuery,
    GetProjectReportQueryVariables
  >(GetProjectReportDocument, options);
}
export type GetProjectReportQueryHookResult = ReturnType<
  typeof useGetProjectReportQuery
>;
export type GetProjectReportLazyQueryHookResult = ReturnType<
  typeof useGetProjectReportLazyQuery
>;
export type GetProjectReportSuspenseQueryHookResult = ReturnType<
  typeof useGetProjectReportSuspenseQuery
>;
export type GetProjectReportQueryResult = Apollo.QueryResult<
  GetProjectReportQuery,
  GetProjectReportQueryVariables
>;
export const GetProjectTaskActivityReportDocument = gql`
  query getProjectTaskActivityReport($uuid: ID!, $taskId: ID!, $limit: Int) {
    getProjectTaskActivityReport(uuid: $uuid, taskId: $taskId, limit: $limit) {
      createdAt
      event
      createdAt
      id
      user {
        ...PublicUserDetail
      }
      attachment {
        ... on Document {
          ...DocumentDetail
        }
        ... on Message {
          id
          chatId
          clientId
          body
          createdAt
          publishedAt
          authorId
          author {
            id
            name
          }
        }
        ... on EntityUser {
          id
          user {
            ...PublicUserDetail
          }
          entityTask: task {
            id
            name
            deletedAt
            members {
              id
              role
              user {
                ...PublicUserDetail
              }
            }
            project {
              id
              uuid
              name
            }
          }
          entityProject: project {
            id
            uuid
            name
          }
        }
      }
    }
  }
  ${PublicUserDetailFragmentDoc}
  ${DocumentDetailFragmentDoc}
`;

/**
 * __useGetProjectTaskActivityReportQuery__
 *
 * To run a query within a React component, call `useGetProjectTaskActivityReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectTaskActivityReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectTaskActivityReportQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      taskId: // value for 'taskId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetProjectTaskActivityReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProjectTaskActivityReportQuery,
    GetProjectTaskActivityReportQueryVariables
  > &
    (
      | {
          variables: GetProjectTaskActivityReportQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProjectTaskActivityReportQuery,
    GetProjectTaskActivityReportQueryVariables
  >(GetProjectTaskActivityReportDocument, options);
}
export function useGetProjectTaskActivityReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProjectTaskActivityReportQuery,
    GetProjectTaskActivityReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProjectTaskActivityReportQuery,
    GetProjectTaskActivityReportQueryVariables
  >(GetProjectTaskActivityReportDocument, options);
}
// @ts-ignore
export function useGetProjectTaskActivityReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProjectTaskActivityReportQuery,
    GetProjectTaskActivityReportQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetProjectTaskActivityReportQuery,
  GetProjectTaskActivityReportQueryVariables
>;
export function useGetProjectTaskActivityReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectTaskActivityReportQuery,
        GetProjectTaskActivityReportQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetProjectTaskActivityReportQuery | undefined,
  GetProjectTaskActivityReportQueryVariables
>;
export function useGetProjectTaskActivityReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectTaskActivityReportQuery,
        GetProjectTaskActivityReportQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetProjectTaskActivityReportQuery,
    GetProjectTaskActivityReportQueryVariables
  >(GetProjectTaskActivityReportDocument, options);
}
export type GetProjectTaskActivityReportQueryHookResult = ReturnType<
  typeof useGetProjectTaskActivityReportQuery
>;
export type GetProjectTaskActivityReportLazyQueryHookResult = ReturnType<
  typeof useGetProjectTaskActivityReportLazyQuery
>;
export type GetProjectTaskActivityReportSuspenseQueryHookResult = ReturnType<
  typeof useGetProjectTaskActivityReportSuspenseQuery
>;
export type GetProjectTaskActivityReportQueryResult = Apollo.QueryResult<
  GetProjectTaskActivityReportQuery,
  GetProjectTaskActivityReportQueryVariables
>;
export const ListProjectMediaDocument = gql`
  query listProjectMedia($uuid: ID!) {
    listProjectMedia(uuid: $uuid) {
      ...DocumentDetail
    }
  }
  ${DocumentDetailFragmentDoc}
`;

/**
 * __useListProjectMediaQuery__
 *
 * To run a query within a React component, call `useListProjectMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectMediaQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useListProjectMediaQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListProjectMediaQuery,
    ListProjectMediaQueryVariables
  > &
    (
      | { variables: ListProjectMediaQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListProjectMediaQuery, ListProjectMediaQueryVariables>(
    ListProjectMediaDocument,
    options
  );
}
export function useListProjectMediaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProjectMediaQuery,
    ListProjectMediaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListProjectMediaQuery,
    ListProjectMediaQueryVariables
  >(ListProjectMediaDocument, options);
}
// @ts-ignore
export function useListProjectMediaSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProjectMediaQuery,
    ListProjectMediaQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListProjectMediaQuery,
  ListProjectMediaQueryVariables
>;
export function useListProjectMediaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectMediaQuery,
        ListProjectMediaQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListProjectMediaQuery | undefined,
  ListProjectMediaQueryVariables
>;
export function useListProjectMediaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectMediaQuery,
        ListProjectMediaQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListProjectMediaQuery,
    ListProjectMediaQueryVariables
  >(ListProjectMediaDocument, options);
}
export type ListProjectMediaQueryHookResult = ReturnType<
  typeof useListProjectMediaQuery
>;
export type ListProjectMediaLazyQueryHookResult = ReturnType<
  typeof useListProjectMediaLazyQuery
>;
export type ListProjectMediaSuspenseQueryHookResult = ReturnType<
  typeof useListProjectMediaSuspenseQuery
>;
export type ListProjectMediaQueryResult = Apollo.QueryResult<
  ListProjectMediaQuery,
  ListProjectMediaQueryVariables
>;
export const ListProjectReportTasksDocument = gql`
  query listProjectReportTasks($uuid: ID!) {
    listProjectReportTasks(uuid: $uuid) {
      id
      dueDate
      members {
        id
        role
        user {
          ...PublicUserDetail
        }
      }
      name
      description
      priority
      status
      creator {
        ...PublicUserDetail
      }
      startDate
      completedAt
    }
  }
  ${PublicUserDetailFragmentDoc}
`;

/**
 * __useListProjectReportTasksQuery__
 *
 * To run a query within a React component, call `useListProjectReportTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectReportTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectReportTasksQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useListProjectReportTasksQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListProjectReportTasksQuery,
    ListProjectReportTasksQueryVariables
  > &
    (
      | { variables: ListProjectReportTasksQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListProjectReportTasksQuery,
    ListProjectReportTasksQueryVariables
  >(ListProjectReportTasksDocument, options);
}
export function useListProjectReportTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProjectReportTasksQuery,
    ListProjectReportTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListProjectReportTasksQuery,
    ListProjectReportTasksQueryVariables
  >(ListProjectReportTasksDocument, options);
}
// @ts-ignore
export function useListProjectReportTasksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProjectReportTasksQuery,
    ListProjectReportTasksQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListProjectReportTasksQuery,
  ListProjectReportTasksQueryVariables
>;
export function useListProjectReportTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectReportTasksQuery,
        ListProjectReportTasksQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListProjectReportTasksQuery | undefined,
  ListProjectReportTasksQueryVariables
>;
export function useListProjectReportTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectReportTasksQuery,
        ListProjectReportTasksQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListProjectReportTasksQuery,
    ListProjectReportTasksQueryVariables
  >(ListProjectReportTasksDocument, options);
}
export type ListProjectReportTasksQueryHookResult = ReturnType<
  typeof useListProjectReportTasksQuery
>;
export type ListProjectReportTasksLazyQueryHookResult = ReturnType<
  typeof useListProjectReportTasksLazyQuery
>;
export type ListProjectReportTasksSuspenseQueryHookResult = ReturnType<
  typeof useListProjectReportTasksSuspenseQuery
>;
export type ListProjectReportTasksQueryResult = Apollo.QueryResult<
  ListProjectReportTasksQuery,
  ListProjectReportTasksQueryVariables
>;
export const ProjectReportCoverPageDocument = gql`
  query projectReportCoverPage($uuid: ID!) {
    projectReportCoverPage(uuid: $uuid) {
      team {
        name
        avatarFile {
          ...FileDetails
        }
      }
      generatedBy
      projectName
      createdAt
      title
    }
  }
  ${FileDetailsFragmentDoc}
`;

/**
 * __useProjectReportCoverPageQuery__
 *
 * To run a query within a React component, call `useProjectReportCoverPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectReportCoverPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectReportCoverPageQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useProjectReportCoverPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProjectReportCoverPageQuery,
    ProjectReportCoverPageQueryVariables
  > &
    (
      | { variables: ProjectReportCoverPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ProjectReportCoverPageQuery,
    ProjectReportCoverPageQueryVariables
  >(ProjectReportCoverPageDocument, options);
}
export function useProjectReportCoverPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectReportCoverPageQuery,
    ProjectReportCoverPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ProjectReportCoverPageQuery,
    ProjectReportCoverPageQueryVariables
  >(ProjectReportCoverPageDocument, options);
}
// @ts-ignore
export function useProjectReportCoverPageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectReportCoverPageQuery,
    ProjectReportCoverPageQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProjectReportCoverPageQuery,
  ProjectReportCoverPageQueryVariables
>;
export function useProjectReportCoverPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectReportCoverPageQuery,
        ProjectReportCoverPageQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProjectReportCoverPageQuery | undefined,
  ProjectReportCoverPageQueryVariables
>;
export function useProjectReportCoverPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectReportCoverPageQuery,
        ProjectReportCoverPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ProjectReportCoverPageQuery,
    ProjectReportCoverPageQueryVariables
  >(ProjectReportCoverPageDocument, options);
}
export type ProjectReportCoverPageQueryHookResult = ReturnType<
  typeof useProjectReportCoverPageQuery
>;
export type ProjectReportCoverPageLazyQueryHookResult = ReturnType<
  typeof useProjectReportCoverPageLazyQuery
>;
export type ProjectReportCoverPageSuspenseQueryHookResult = ReturnType<
  typeof useProjectReportCoverPageSuspenseQuery
>;
export type ProjectReportCoverPageQueryResult = Apollo.QueryResult<
  ProjectReportCoverPageQuery,
  ProjectReportCoverPageQueryVariables
>;
export const ProjectReportOverviewDocument = gql`
  query projectReportOverview($uuid: ID!) {
    projectReportOverview(uuid: $uuid) {
      address
      createdAt
      creator {
        ...PublicUserDetail
      }
      id
      description
      members {
        id
        role
        user {
          ...PublicUserDetail
        }
      }
      name
    }
  }
  ${PublicUserDetailFragmentDoc}
`;

/**
 * __useProjectReportOverviewQuery__
 *
 * To run a query within a React component, call `useProjectReportOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectReportOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectReportOverviewQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useProjectReportOverviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProjectReportOverviewQuery,
    ProjectReportOverviewQueryVariables
  > &
    (
      | { variables: ProjectReportOverviewQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ProjectReportOverviewQuery,
    ProjectReportOverviewQueryVariables
  >(ProjectReportOverviewDocument, options);
}
export function useProjectReportOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectReportOverviewQuery,
    ProjectReportOverviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ProjectReportOverviewQuery,
    ProjectReportOverviewQueryVariables
  >(ProjectReportOverviewDocument, options);
}
// @ts-ignore
export function useProjectReportOverviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectReportOverviewQuery,
    ProjectReportOverviewQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProjectReportOverviewQuery,
  ProjectReportOverviewQueryVariables
>;
export function useProjectReportOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectReportOverviewQuery,
        ProjectReportOverviewQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProjectReportOverviewQuery | undefined,
  ProjectReportOverviewQueryVariables
>;
export function useProjectReportOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectReportOverviewQuery,
        ProjectReportOverviewQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ProjectReportOverviewQuery,
    ProjectReportOverviewQueryVariables
  >(ProjectReportOverviewDocument, options);
}
export type ProjectReportOverviewQueryHookResult = ReturnType<
  typeof useProjectReportOverviewQuery
>;
export type ProjectReportOverviewLazyQueryHookResult = ReturnType<
  typeof useProjectReportOverviewLazyQuery
>;
export type ProjectReportOverviewSuspenseQueryHookResult = ReturnType<
  typeof useProjectReportOverviewSuspenseQuery
>;
export type ProjectReportOverviewQueryResult = Apollo.QueryResult<
  ProjectReportOverviewQuery,
  ProjectReportOverviewQueryVariables
>;
export const ChatAvatarsByIdsDocument = gql`
  query chatAvatarsByIds($ids: [ID!]) {
    chatAvatarsByIds(ids: $ids) {
      id
      thumbnail
      url
    }
  }
`;

/**
 * __useChatAvatarsByIdsQuery__
 *
 * To run a query within a React component, call `useChatAvatarsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatAvatarsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatAvatarsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useChatAvatarsByIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ChatAvatarsByIdsQuery,
    ChatAvatarsByIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChatAvatarsByIdsQuery, ChatAvatarsByIdsQueryVariables>(
    ChatAvatarsByIdsDocument,
    options
  );
}
export function useChatAvatarsByIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChatAvatarsByIdsQuery,
    ChatAvatarsByIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChatAvatarsByIdsQuery,
    ChatAvatarsByIdsQueryVariables
  >(ChatAvatarsByIdsDocument, options);
}
// @ts-ignore
export function useChatAvatarsByIdsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ChatAvatarsByIdsQuery,
    ChatAvatarsByIdsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ChatAvatarsByIdsQuery,
  ChatAvatarsByIdsQueryVariables
>;
export function useChatAvatarsByIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChatAvatarsByIdsQuery,
        ChatAvatarsByIdsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ChatAvatarsByIdsQuery | undefined,
  ChatAvatarsByIdsQueryVariables
>;
export function useChatAvatarsByIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChatAvatarsByIdsQuery,
        ChatAvatarsByIdsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChatAvatarsByIdsQuery,
    ChatAvatarsByIdsQueryVariables
  >(ChatAvatarsByIdsDocument, options);
}
export type ChatAvatarsByIdsQueryHookResult = ReturnType<
  typeof useChatAvatarsByIdsQuery
>;
export type ChatAvatarsByIdsLazyQueryHookResult = ReturnType<
  typeof useChatAvatarsByIdsLazyQuery
>;
export type ChatAvatarsByIdsSuspenseQueryHookResult = ReturnType<
  typeof useChatAvatarsByIdsSuspenseQuery
>;
export type ChatAvatarsByIdsQueryResult = Apollo.QueryResult<
  ChatAvatarsByIdsQuery,
  ChatAvatarsByIdsQueryVariables
>;
export const ChatAvatarsThumbnailByIdsDocument = gql`
  query chatAvatarsThumbnailByIds($ids: [ID!]) {
    chatAvatarsByIds(ids: $ids) {
      id
      thumbnail
    }
  }
`;

/**
 * __useChatAvatarsThumbnailByIdsQuery__
 *
 * To run a query within a React component, call `useChatAvatarsThumbnailByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatAvatarsThumbnailByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatAvatarsThumbnailByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useChatAvatarsThumbnailByIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ChatAvatarsThumbnailByIdsQuery,
    ChatAvatarsThumbnailByIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ChatAvatarsThumbnailByIdsQuery,
    ChatAvatarsThumbnailByIdsQueryVariables
  >(ChatAvatarsThumbnailByIdsDocument, options);
}
export function useChatAvatarsThumbnailByIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChatAvatarsThumbnailByIdsQuery,
    ChatAvatarsThumbnailByIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChatAvatarsThumbnailByIdsQuery,
    ChatAvatarsThumbnailByIdsQueryVariables
  >(ChatAvatarsThumbnailByIdsDocument, options);
}
// @ts-ignore
export function useChatAvatarsThumbnailByIdsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ChatAvatarsThumbnailByIdsQuery,
    ChatAvatarsThumbnailByIdsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ChatAvatarsThumbnailByIdsQuery,
  ChatAvatarsThumbnailByIdsQueryVariables
>;
export function useChatAvatarsThumbnailByIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChatAvatarsThumbnailByIdsQuery,
        ChatAvatarsThumbnailByIdsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ChatAvatarsThumbnailByIdsQuery | undefined,
  ChatAvatarsThumbnailByIdsQueryVariables
>;
export function useChatAvatarsThumbnailByIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChatAvatarsThumbnailByIdsQuery,
        ChatAvatarsThumbnailByIdsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChatAvatarsThumbnailByIdsQuery,
    ChatAvatarsThumbnailByIdsQueryVariables
  >(ChatAvatarsThumbnailByIdsDocument, options);
}
export type ChatAvatarsThumbnailByIdsQueryHookResult = ReturnType<
  typeof useChatAvatarsThumbnailByIdsQuery
>;
export type ChatAvatarsThumbnailByIdsLazyQueryHookResult = ReturnType<
  typeof useChatAvatarsThumbnailByIdsLazyQuery
>;
export type ChatAvatarsThumbnailByIdsSuspenseQueryHookResult = ReturnType<
  typeof useChatAvatarsThumbnailByIdsSuspenseQuery
>;
export type ChatAvatarsThumbnailByIdsQueryResult = Apollo.QueryResult<
  ChatAvatarsThumbnailByIdsQuery,
  ChatAvatarsThumbnailByIdsQueryVariables
>;
export const CheckGeofenceDocument = gql`
  query checkGeofence(
    $userLatitude: Float!
    $userLongitude: Float!
    $projectLatitude: Float!
    $projectLongitude: Float!
  ) {
    checkGeofence(
      userLatitude: $userLatitude
      userLongitude: $userLongitude
      projectLatitude: $projectLatitude
      projectLongitude: $projectLongitude
    )
  }
`;

/**
 * __useCheckGeofenceQuery__
 *
 * To run a query within a React component, call `useCheckGeofenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckGeofenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckGeofenceQuery({
 *   variables: {
 *      userLatitude: // value for 'userLatitude'
 *      userLongitude: // value for 'userLongitude'
 *      projectLatitude: // value for 'projectLatitude'
 *      projectLongitude: // value for 'projectLongitude'
 *   },
 * });
 */
export function useCheckGeofenceQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckGeofenceQuery,
    CheckGeofenceQueryVariables
  > &
    (
      | { variables: CheckGeofenceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckGeofenceQuery, CheckGeofenceQueryVariables>(
    CheckGeofenceDocument,
    options
  );
}
export function useCheckGeofenceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckGeofenceQuery,
    CheckGeofenceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckGeofenceQuery, CheckGeofenceQueryVariables>(
    CheckGeofenceDocument,
    options
  );
}
// @ts-ignore
export function useCheckGeofenceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckGeofenceQuery,
    CheckGeofenceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CheckGeofenceQuery,
  CheckGeofenceQueryVariables
>;
export function useCheckGeofenceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckGeofenceQuery,
        CheckGeofenceQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CheckGeofenceQuery | undefined,
  CheckGeofenceQueryVariables
>;
export function useCheckGeofenceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckGeofenceQuery,
        CheckGeofenceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckGeofenceQuery,
    CheckGeofenceQueryVariables
  >(CheckGeofenceDocument, options);
}
export type CheckGeofenceQueryHookResult = ReturnType<
  typeof useCheckGeofenceQuery
>;
export type CheckGeofenceLazyQueryHookResult = ReturnType<
  typeof useCheckGeofenceLazyQuery
>;
export type CheckGeofenceSuspenseQueryHookResult = ReturnType<
  typeof useCheckGeofenceSuspenseQuery
>;
export type CheckGeofenceQueryResult = Apollo.QueryResult<
  CheckGeofenceQuery,
  CheckGeofenceQueryVariables
>;
export const DocumentsByClientIdsDocument = gql`
  query documentsByClientIds($clientIds: [ID!]) {
    documentsByClientIds(clientIds: $clientIds) {
      clientId
      file {
        id
        url
      }
    }
  }
`;

/**
 * __useDocumentsByClientIdsQuery__
 *
 * To run a query within a React component, call `useDocumentsByClientIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsByClientIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsByClientIdsQuery({
 *   variables: {
 *      clientIds: // value for 'clientIds'
 *   },
 * });
 */
export function useDocumentsByClientIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DocumentsByClientIdsQuery,
    DocumentsByClientIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DocumentsByClientIdsQuery,
    DocumentsByClientIdsQueryVariables
  >(DocumentsByClientIdsDocument, options);
}
export function useDocumentsByClientIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DocumentsByClientIdsQuery,
    DocumentsByClientIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DocumentsByClientIdsQuery,
    DocumentsByClientIdsQueryVariables
  >(DocumentsByClientIdsDocument, options);
}
// @ts-ignore
export function useDocumentsByClientIdsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DocumentsByClientIdsQuery,
    DocumentsByClientIdsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  DocumentsByClientIdsQuery,
  DocumentsByClientIdsQueryVariables
>;
export function useDocumentsByClientIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DocumentsByClientIdsQuery,
        DocumentsByClientIdsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  DocumentsByClientIdsQuery | undefined,
  DocumentsByClientIdsQueryVariables
>;
export function useDocumentsByClientIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DocumentsByClientIdsQuery,
        DocumentsByClientIdsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DocumentsByClientIdsQuery,
    DocumentsByClientIdsQueryVariables
  >(DocumentsByClientIdsDocument, options);
}
export type DocumentsByClientIdsQueryHookResult = ReturnType<
  typeof useDocumentsByClientIdsQuery
>;
export type DocumentsByClientIdsLazyQueryHookResult = ReturnType<
  typeof useDocumentsByClientIdsLazyQuery
>;
export type DocumentsByClientIdsSuspenseQueryHookResult = ReturnType<
  typeof useDocumentsByClientIdsSuspenseQuery
>;
export type DocumentsByClientIdsQueryResult = Apollo.QueryResult<
  DocumentsByClientIdsQuery,
  DocumentsByClientIdsQueryVariables
>;
export const DocumentsByClientIdsForEditImageDocument = gql`
  query documentsByClientIdsForEditImage($clientIds: [ID!]) {
    documentsByClientIds(clientIds: $clientIds) {
      id
      name
      contentType
      createdAt
      size
      isImage
      isVideo
      clientId
      owner {
        id
        name
        avatar {
          ...AvatarDetail
        }
      }
      file {
        id
        cdnBaseUrl
        isPreviewable
        thumbnail
      }
      messageDocuments {
        id
        message {
          id
          clientId
          chatId
        }
      }
      projectDocuments {
        id
        project {
          id
          uuid
          name
        }
      }
      taskDocuments {
        id
        task {
          id
          name
          projectId
          project {
            id
            uuid
            name
          }
        }
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useDocumentsByClientIdsForEditImageQuery__
 *
 * To run a query within a React component, call `useDocumentsByClientIdsForEditImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsByClientIdsForEditImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsByClientIdsForEditImageQuery({
 *   variables: {
 *      clientIds: // value for 'clientIds'
 *   },
 * });
 */
export function useDocumentsByClientIdsForEditImageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DocumentsByClientIdsForEditImageQuery,
    DocumentsByClientIdsForEditImageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DocumentsByClientIdsForEditImageQuery,
    DocumentsByClientIdsForEditImageQueryVariables
  >(DocumentsByClientIdsForEditImageDocument, options);
}
export function useDocumentsByClientIdsForEditImageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DocumentsByClientIdsForEditImageQuery,
    DocumentsByClientIdsForEditImageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DocumentsByClientIdsForEditImageQuery,
    DocumentsByClientIdsForEditImageQueryVariables
  >(DocumentsByClientIdsForEditImageDocument, options);
}
// @ts-ignore
export function useDocumentsByClientIdsForEditImageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DocumentsByClientIdsForEditImageQuery,
    DocumentsByClientIdsForEditImageQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  DocumentsByClientIdsForEditImageQuery,
  DocumentsByClientIdsForEditImageQueryVariables
>;
export function useDocumentsByClientIdsForEditImageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DocumentsByClientIdsForEditImageQuery,
        DocumentsByClientIdsForEditImageQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  DocumentsByClientIdsForEditImageQuery | undefined,
  DocumentsByClientIdsForEditImageQueryVariables
>;
export function useDocumentsByClientIdsForEditImageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DocumentsByClientIdsForEditImageQuery,
        DocumentsByClientIdsForEditImageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DocumentsByClientIdsForEditImageQuery,
    DocumentsByClientIdsForEditImageQueryVariables
  >(DocumentsByClientIdsForEditImageDocument, options);
}
export type DocumentsByClientIdsForEditImageQueryHookResult = ReturnType<
  typeof useDocumentsByClientIdsForEditImageQuery
>;
export type DocumentsByClientIdsForEditImageLazyQueryHookResult = ReturnType<
  typeof useDocumentsByClientIdsForEditImageLazyQuery
>;
export type DocumentsByClientIdsForEditImageSuspenseQueryHookResult =
  ReturnType<typeof useDocumentsByClientIdsForEditImageSuspenseQuery>;
export type DocumentsByClientIdsForEditImageQueryResult = Apollo.QueryResult<
  DocumentsByClientIdsForEditImageQuery,
  DocumentsByClientIdsForEditImageQueryVariables
>;
export const DocumentsByClientIdsForImageViewerDocument = gql`
  query documentsByClientIdsForImageViewer($clientIds: [ID!]) {
    documentsByClientIds(clientIds: $clientIds) {
      clientId
      updatedAt
      width
      height
    }
  }
`;

/**
 * __useDocumentsByClientIdsForImageViewerQuery__
 *
 * To run a query within a React component, call `useDocumentsByClientIdsForImageViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsByClientIdsForImageViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsByClientIdsForImageViewerQuery({
 *   variables: {
 *      clientIds: // value for 'clientIds'
 *   },
 * });
 */
export function useDocumentsByClientIdsForImageViewerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DocumentsByClientIdsForImageViewerQuery,
    DocumentsByClientIdsForImageViewerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DocumentsByClientIdsForImageViewerQuery,
    DocumentsByClientIdsForImageViewerQueryVariables
  >(DocumentsByClientIdsForImageViewerDocument, options);
}
export function useDocumentsByClientIdsForImageViewerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DocumentsByClientIdsForImageViewerQuery,
    DocumentsByClientIdsForImageViewerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DocumentsByClientIdsForImageViewerQuery,
    DocumentsByClientIdsForImageViewerQueryVariables
  >(DocumentsByClientIdsForImageViewerDocument, options);
}
// @ts-ignore
export function useDocumentsByClientIdsForImageViewerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DocumentsByClientIdsForImageViewerQuery,
    DocumentsByClientIdsForImageViewerQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  DocumentsByClientIdsForImageViewerQuery,
  DocumentsByClientIdsForImageViewerQueryVariables
>;
export function useDocumentsByClientIdsForImageViewerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DocumentsByClientIdsForImageViewerQuery,
        DocumentsByClientIdsForImageViewerQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  DocumentsByClientIdsForImageViewerQuery | undefined,
  DocumentsByClientIdsForImageViewerQueryVariables
>;
export function useDocumentsByClientIdsForImageViewerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DocumentsByClientIdsForImageViewerQuery,
        DocumentsByClientIdsForImageViewerQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DocumentsByClientIdsForImageViewerQuery,
    DocumentsByClientIdsForImageViewerQueryVariables
  >(DocumentsByClientIdsForImageViewerDocument, options);
}
export type DocumentsByClientIdsForImageViewerQueryHookResult = ReturnType<
  typeof useDocumentsByClientIdsForImageViewerQuery
>;
export type DocumentsByClientIdsForImageViewerLazyQueryHookResult = ReturnType<
  typeof useDocumentsByClientIdsForImageViewerLazyQuery
>;
export type DocumentsByClientIdsForImageViewerSuspenseQueryHookResult =
  ReturnType<typeof useDocumentsByClientIdsForImageViewerSuspenseQuery>;
export type DocumentsByClientIdsForImageViewerQueryResult = Apollo.QueryResult<
  DocumentsByClientIdsForImageViewerQuery,
  DocumentsByClientIdsForImageViewerQueryVariables
>;
export const GetChatDocument = gql`
  query getChat($id: ID!) {
    getChat(id: $id) {
      ...GetChatDetail
    }
  }
  ${GetChatDetailFragmentDoc}
`;

/**
 * __useGetChatQuery__
 *
 * To run a query within a React component, call `useGetChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChatQuery(
  baseOptions: Apollo.QueryHookOptions<GetChatQuery, GetChatQueryVariables> &
    ({ variables: GetChatQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChatQuery, GetChatQueryVariables>(
    GetChatDocument,
    options
  );
}
export function useGetChatLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetChatQuery, GetChatQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChatQuery, GetChatQueryVariables>(
    GetChatDocument,
    options
  );
}
// @ts-ignore
export function useGetChatSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetChatQuery,
    GetChatQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetChatQuery, GetChatQueryVariables>;
export function useGetChatSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChatQuery, GetChatQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetChatQuery | undefined,
  GetChatQueryVariables
>;
export function useGetChatSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChatQuery, GetChatQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetChatQuery, GetChatQueryVariables>(
    GetChatDocument,
    options
  );
}
export type GetChatQueryHookResult = ReturnType<typeof useGetChatQuery>;
export type GetChatLazyQueryHookResult = ReturnType<typeof useGetChatLazyQuery>;
export type GetChatSuspenseQueryHookResult = ReturnType<
  typeof useGetChatSuspenseQuery
>;
export type GetChatQueryResult = Apollo.QueryResult<
  GetChatQuery,
  GetChatQueryVariables
>;
export const GetChatForNotificationDocument = gql`
  query getChatForNotification($id: ID!) {
    getChat(id: $id) {
      id
      name
    }
  }
`;

/**
 * __useGetChatForNotificationQuery__
 *
 * To run a query within a React component, call `useGetChatForNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatForNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatForNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChatForNotificationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChatForNotificationQuery,
    GetChatForNotificationQueryVariables
  > &
    (
      | { variables: GetChatForNotificationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetChatForNotificationQuery,
    GetChatForNotificationQueryVariables
  >(GetChatForNotificationDocument, options);
}
export function useGetChatForNotificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChatForNotificationQuery,
    GetChatForNotificationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChatForNotificationQuery,
    GetChatForNotificationQueryVariables
  >(GetChatForNotificationDocument, options);
}
// @ts-ignore
export function useGetChatForNotificationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetChatForNotificationQuery,
    GetChatForNotificationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetChatForNotificationQuery,
  GetChatForNotificationQueryVariables
>;
export function useGetChatForNotificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetChatForNotificationQuery,
        GetChatForNotificationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetChatForNotificationQuery | undefined,
  GetChatForNotificationQueryVariables
>;
export function useGetChatForNotificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetChatForNotificationQuery,
        GetChatForNotificationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetChatForNotificationQuery,
    GetChatForNotificationQueryVariables
  >(GetChatForNotificationDocument, options);
}
export type GetChatForNotificationQueryHookResult = ReturnType<
  typeof useGetChatForNotificationQuery
>;
export type GetChatForNotificationLazyQueryHookResult = ReturnType<
  typeof useGetChatForNotificationLazyQuery
>;
export type GetChatForNotificationSuspenseQueryHookResult = ReturnType<
  typeof useGetChatForNotificationSuspenseQuery
>;
export type GetChatForNotificationQueryResult = Apollo.QueryResult<
  GetChatForNotificationQuery,
  GetChatForNotificationQueryVariables
>;
export const GetDraftMessageDocument = gql`
  query getDraftMessage($chatId: ID!) {
    getDraftMessage(chatId: $chatId) {
      ...DraftMessageDetail
    }
  }
  ${DraftMessageDetailFragmentDoc}
`;

/**
 * __useGetDraftMessageQuery__
 *
 * To run a query within a React component, call `useGetDraftMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDraftMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDraftMessageQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useGetDraftMessageQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDraftMessageQuery,
    GetDraftMessageQueryVariables
  > &
    (
      | { variables: GetDraftMessageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDraftMessageQuery, GetDraftMessageQueryVariables>(
    GetDraftMessageDocument,
    options
  );
}
export function useGetDraftMessageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDraftMessageQuery,
    GetDraftMessageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDraftMessageQuery,
    GetDraftMessageQueryVariables
  >(GetDraftMessageDocument, options);
}
// @ts-ignore
export function useGetDraftMessageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDraftMessageQuery,
    GetDraftMessageQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetDraftMessageQuery,
  GetDraftMessageQueryVariables
>;
export function useGetDraftMessageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDraftMessageQuery,
        GetDraftMessageQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetDraftMessageQuery | undefined,
  GetDraftMessageQueryVariables
>;
export function useGetDraftMessageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDraftMessageQuery,
        GetDraftMessageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDraftMessageQuery,
    GetDraftMessageQueryVariables
  >(GetDraftMessageDocument, options);
}
export type GetDraftMessageQueryHookResult = ReturnType<
  typeof useGetDraftMessageQuery
>;
export type GetDraftMessageLazyQueryHookResult = ReturnType<
  typeof useGetDraftMessageLazyQuery
>;
export type GetDraftMessageSuspenseQueryHookResult = ReturnType<
  typeof useGetDraftMessageSuspenseQuery
>;
export type GetDraftMessageQueryResult = Apollo.QueryResult<
  GetDraftMessageQuery,
  GetDraftMessageQueryVariables
>;
export const GetGroupDocument = gql`
  query getGroup($id: ID!) {
    getGroup(id: $id) {
      id
      name
      currentUserTeamRole
      team {
        id
        avatar
        name
        personal
        avatarFile {
          ...AvatarDetail
        }
      }
      users {
        id
        name
        firstName
        avatar {
          ...AvatarDetail
        }
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupQuery(
  baseOptions: Apollo.QueryHookOptions<GetGroupQuery, GetGroupQueryVariables> &
    ({ variables: GetGroupQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGroupQuery, GetGroupQueryVariables>(
    GetGroupDocument,
    options
  );
}
export function useGetGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupQuery,
    GetGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGroupQuery, GetGroupQueryVariables>(
    GetGroupDocument,
    options
  );
}
// @ts-ignore
export function useGetGroupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetGroupQuery,
    GetGroupQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetGroupQuery, GetGroupQueryVariables>;
export function useGetGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetGroupQuery | undefined,
  GetGroupQueryVariables
>;
export function useGetGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetGroupQuery, GetGroupQueryVariables>(
    GetGroupDocument,
    options
  );
}
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<
  typeof useGetGroupLazyQuery
>;
export type GetGroupSuspenseQueryHookResult = ReturnType<
  typeof useGetGroupSuspenseQuery
>;
export type GetGroupQueryResult = Apollo.QueryResult<
  GetGroupQuery,
  GetGroupQueryVariables
>;
export const GetMeDocument = gql`
  query getMe {
    getMe {
      ...UserDetail
      calendarUrl
      contactsCount
      contactsSyncedAt
      address
      latitude
      personalProjectsCount
      longitude
      onboardingComplete
      onboardingFlow
      lastActiveDatetime
      ownedProjectsCount
      ownedTasksCount
      completedWebTutorialFlows
      hasSeenTagTooltipWeb
      hasSeenTagTooltipNative
      notificationSetting {
        duration
        mute
        settingType
      }
      timeZone
      teams {
        id
      }
      onboardingState {
        welcomeModalSeen
        projectCreationComplete
        taskCreationComplete
        checklistCreationComplete
        inviteMemberComplete
        firstChatSent
        firstTagUsed
        photoRequestNudgeShown
        tagPillCoachmarkShown
      }
      tutoralizationSetting {
        settingType
        close
      }
    }
  }
  ${UserDetailFragmentDoc}
`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(
    GetMeDocument,
    options
  );
}
export function useGetMeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(
    GetMeDocument,
    options
  );
}
// @ts-ignore
export function useGetMeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>
): Apollo.UseSuspenseQueryResult<GetMeQuery, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>
): Apollo.UseSuspenseQueryResult<GetMeQuery | undefined, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMeQuery, GetMeQueryVariables>(
    GetMeDocument,
    options
  );
}
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeSuspenseQueryHookResult = ReturnType<
  typeof useGetMeSuspenseQuery
>;
export type GetMeQueryResult = Apollo.QueryResult<
  GetMeQuery,
  GetMeQueryVariables
>;
export const GetPaywallStatusDocument = gql`
  query getPaywallStatus {
    getPaywallStatus {
      isPaywalled
      upgradeTeam {
        id
        uuid
        name
        usersCount
      }
    }
  }
`;

/**
 * __useGetPaywallStatusQuery__
 *
 * To run a query within a React component, call `useGetPaywallStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaywallStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaywallStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaywallStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPaywallStatusQuery,
    GetPaywallStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPaywallStatusQuery, GetPaywallStatusQueryVariables>(
    GetPaywallStatusDocument,
    options
  );
}
export function useGetPaywallStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPaywallStatusQuery,
    GetPaywallStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPaywallStatusQuery,
    GetPaywallStatusQueryVariables
  >(GetPaywallStatusDocument, options);
}
// @ts-ignore
export function useGetPaywallStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPaywallStatusQuery,
    GetPaywallStatusQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetPaywallStatusQuery,
  GetPaywallStatusQueryVariables
>;
export function useGetPaywallStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPaywallStatusQuery,
        GetPaywallStatusQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetPaywallStatusQuery | undefined,
  GetPaywallStatusQueryVariables
>;
export function useGetPaywallStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPaywallStatusQuery,
        GetPaywallStatusQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPaywallStatusQuery,
    GetPaywallStatusQueryVariables
  >(GetPaywallStatusDocument, options);
}
export type GetPaywallStatusQueryHookResult = ReturnType<
  typeof useGetPaywallStatusQuery
>;
export type GetPaywallStatusLazyQueryHookResult = ReturnType<
  typeof useGetPaywallStatusLazyQuery
>;
export type GetPaywallStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetPaywallStatusSuspenseQuery
>;
export type GetPaywallStatusQueryResult = Apollo.QueryResult<
  GetPaywallStatusQuery,
  GetPaywallStatusQueryVariables
>;
export const GetProductDocument = gql`
  query getProduct($id: ID!) {
    getProduct(id: $id) {
      allowMembers
      externalId
      guestsOnly
      id
      maxDocumentStorage
      maxNumberOfProjects
      name
    }
  }
`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProductQuery,
    GetProductQueryVariables
  > &
    (
      | { variables: GetProductQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(
    GetProductDocument,
    options
  );
}
export function useGetProductLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProductQuery,
    GetProductQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(
    GetProductDocument,
    options
  );
}
// @ts-ignore
export function useGetProductSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProductQuery,
    GetProductQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetProductQuery, GetProductQueryVariables>;
export function useGetProductSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetProductQuery | undefined,
  GetProductQueryVariables
>;
export function useGetProductSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProductQuery, GetProductQueryVariables>(
    GetProductDocument,
    options
  );
}
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<
  typeof useGetProductLazyQuery
>;
export type GetProductSuspenseQueryHookResult = ReturnType<
  typeof useGetProductSuspenseQuery
>;
export type GetProductQueryResult = Apollo.QueryResult<
  GetProductQuery,
  GetProductQueryVariables
>;
export const GetProfileDocument = gql`
  query getProfile($id: ID!) {
    getProfile(id: $id) {
      ...UserProfile
    }
  }
  ${UserProfileFragmentDoc}
`;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProfileQuery,
    GetProfileQueryVariables
  > &
    (
      | { variables: GetProfileQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(
    GetProfileDocument,
    options
  );
}
export function useGetProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProfileQuery,
    GetProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(
    GetProfileDocument,
    options
  );
}
// @ts-ignore
export function useGetProfileSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProfileQuery,
    GetProfileQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetProfileQuery, GetProfileQueryVariables>;
export function useGetProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetProfileQuery | undefined,
  GetProfileQueryVariables
>;
export function useGetProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProfileQuery, GetProfileQueryVariables>(
    GetProfileDocument,
    options
  );
}
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<
  typeof useGetProfileLazyQuery
>;
export type GetProfileSuspenseQueryHookResult = ReturnType<
  typeof useGetProfileSuspenseQuery
>;
export type GetProfileQueryResult = Apollo.QueryResult<
  GetProfileQuery,
  GetProfileQueryVariables
>;
export const GetProjectDocument = gql`
  query getProject($id: ID!) {
    getProject(id: $id) {
      ...ProjectDetail
    }
  }
  ${ProjectDetailFragmentDoc}
`;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProjectQuery,
    GetProjectQueryVariables
  > &
    (
      | { variables: GetProjectQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(
    GetProjectDocument,
    options
  );
}
export function useGetProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProjectQuery,
    GetProjectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(
    GetProjectDocument,
    options
  );
}
// @ts-ignore
export function useGetProjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProjectQuery,
    GetProjectQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetProjectQuery, GetProjectQueryVariables>;
export function useGetProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetProjectQuery | undefined,
  GetProjectQueryVariables
>;
export function useGetProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProjectQuery, GetProjectQueryVariables>(
    GetProjectDocument,
    options
  );
}
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<
  typeof useGetProjectLazyQuery
>;
export type GetProjectSuspenseQueryHookResult = ReturnType<
  typeof useGetProjectSuspenseQuery
>;
export type GetProjectQueryResult = Apollo.QueryResult<
  GetProjectQuery,
  GetProjectQueryVariables
>;
export const GetProjectByInvitationTokenDocument = gql`
  query getProjectByInvitationToken($id: ID!, $token: String) {
    getProjectByInvitationToken: getPublicProject(id: $id, token: $token) {
      ... on PublicProject {
        id
        uuid
        name
        description
        address
        usersCount
        members {
          id
          role
          name
          avatar {
            ...AvatarDetail
          }
        }
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useGetProjectByInvitationTokenQuery__
 *
 * To run a query within a React component, call `useGetProjectByInvitationTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectByInvitationTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectByInvitationTokenQuery({
 *   variables: {
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetProjectByInvitationTokenQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProjectByInvitationTokenQuery,
    GetProjectByInvitationTokenQueryVariables
  > &
    (
      | { variables: GetProjectByInvitationTokenQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProjectByInvitationTokenQuery,
    GetProjectByInvitationTokenQueryVariables
  >(GetProjectByInvitationTokenDocument, options);
}
export function useGetProjectByInvitationTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProjectByInvitationTokenQuery,
    GetProjectByInvitationTokenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProjectByInvitationTokenQuery,
    GetProjectByInvitationTokenQueryVariables
  >(GetProjectByInvitationTokenDocument, options);
}
// @ts-ignore
export function useGetProjectByInvitationTokenSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProjectByInvitationTokenQuery,
    GetProjectByInvitationTokenQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetProjectByInvitationTokenQuery,
  GetProjectByInvitationTokenQueryVariables
>;
export function useGetProjectByInvitationTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectByInvitationTokenQuery,
        GetProjectByInvitationTokenQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetProjectByInvitationTokenQuery | undefined,
  GetProjectByInvitationTokenQueryVariables
>;
export function useGetProjectByInvitationTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectByInvitationTokenQuery,
        GetProjectByInvitationTokenQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetProjectByInvitationTokenQuery,
    GetProjectByInvitationTokenQueryVariables
  >(GetProjectByInvitationTokenDocument, options);
}
export type GetProjectByInvitationTokenQueryHookResult = ReturnType<
  typeof useGetProjectByInvitationTokenQuery
>;
export type GetProjectByInvitationTokenLazyQueryHookResult = ReturnType<
  typeof useGetProjectByInvitationTokenLazyQuery
>;
export type GetProjectByInvitationTokenSuspenseQueryHookResult = ReturnType<
  typeof useGetProjectByInvitationTokenSuspenseQuery
>;
export type GetProjectByInvitationTokenQueryResult = Apollo.QueryResult<
  GetProjectByInvitationTokenQuery,
  GetProjectByInvitationTokenQueryVariables
>;
export const GetProjectForNotificationDocument = gql`
  query getProjectForNotification($id: ID!) {
    getProject(id: $id) {
      id
      name
    }
  }
`;

/**
 * __useGetProjectForNotificationQuery__
 *
 * To run a query within a React component, call `useGetProjectForNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectForNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectForNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectForNotificationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProjectForNotificationQuery,
    GetProjectForNotificationQueryVariables
  > &
    (
      | { variables: GetProjectForNotificationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProjectForNotificationQuery,
    GetProjectForNotificationQueryVariables
  >(GetProjectForNotificationDocument, options);
}
export function useGetProjectForNotificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProjectForNotificationQuery,
    GetProjectForNotificationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProjectForNotificationQuery,
    GetProjectForNotificationQueryVariables
  >(GetProjectForNotificationDocument, options);
}
// @ts-ignore
export function useGetProjectForNotificationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProjectForNotificationQuery,
    GetProjectForNotificationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetProjectForNotificationQuery,
  GetProjectForNotificationQueryVariables
>;
export function useGetProjectForNotificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectForNotificationQuery,
        GetProjectForNotificationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetProjectForNotificationQuery | undefined,
  GetProjectForNotificationQueryVariables
>;
export function useGetProjectForNotificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectForNotificationQuery,
        GetProjectForNotificationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetProjectForNotificationQuery,
    GetProjectForNotificationQueryVariables
  >(GetProjectForNotificationDocument, options);
}
export type GetProjectForNotificationQueryHookResult = ReturnType<
  typeof useGetProjectForNotificationQuery
>;
export type GetProjectForNotificationLazyQueryHookResult = ReturnType<
  typeof useGetProjectForNotificationLazyQuery
>;
export type GetProjectForNotificationSuspenseQueryHookResult = ReturnType<
  typeof useGetProjectForNotificationSuspenseQuery
>;
export type GetProjectForNotificationQueryResult = Apollo.QueryResult<
  GetProjectForNotificationQuery,
  GetProjectForNotificationQueryVariables
>;
export const GetProjectMembersDocument = gql`
  query getProjectMembers($id: ID!) {
    getProject(id: $id) {
      id
      teamId
      name
      address
      description
      color
      members {
        id
        role
        user {
          ...UserDetail
        }
      }
    }
  }
  ${UserDetailFragmentDoc}
`;

/**
 * __useGetProjectMembersQuery__
 *
 * To run a query within a React component, call `useGetProjectMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProjectMembersQuery,
    GetProjectMembersQueryVariables
  > &
    (
      | { variables: GetProjectMembersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProjectMembersQuery,
    GetProjectMembersQueryVariables
  >(GetProjectMembersDocument, options);
}
export function useGetProjectMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProjectMembersQuery,
    GetProjectMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProjectMembersQuery,
    GetProjectMembersQueryVariables
  >(GetProjectMembersDocument, options);
}
// @ts-ignore
export function useGetProjectMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProjectMembersQuery,
    GetProjectMembersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetProjectMembersQuery,
  GetProjectMembersQueryVariables
>;
export function useGetProjectMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectMembersQuery,
        GetProjectMembersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetProjectMembersQuery | undefined,
  GetProjectMembersQueryVariables
>;
export function useGetProjectMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectMembersQuery,
        GetProjectMembersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetProjectMembersQuery,
    GetProjectMembersQueryVariables
  >(GetProjectMembersDocument, options);
}
export type GetProjectMembersQueryHookResult = ReturnType<
  typeof useGetProjectMembersQuery
>;
export type GetProjectMembersLazyQueryHookResult = ReturnType<
  typeof useGetProjectMembersLazyQuery
>;
export type GetProjectMembersSuspenseQueryHookResult = ReturnType<
  typeof useGetProjectMembersSuspenseQuery
>;
export type GetProjectMembersQueryResult = Apollo.QueryResult<
  GetProjectMembersQuery,
  GetProjectMembersQueryVariables
>;
export const GetProjectTasksDocument = gql`
  query getProjectTasks($id: ID!) {
    getProject(id: $id) {
      id
      name
      tasks {
        id
        name
      }
    }
  }
`;

/**
 * __useGetProjectTasksQuery__
 *
 * To run a query within a React component, call `useGetProjectTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectTasksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectTasksQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProjectTasksQuery,
    GetProjectTasksQueryVariables
  > &
    (
      | { variables: GetProjectTasksQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProjectTasksQuery, GetProjectTasksQueryVariables>(
    GetProjectTasksDocument,
    options
  );
}
export function useGetProjectTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProjectTasksQuery,
    GetProjectTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProjectTasksQuery,
    GetProjectTasksQueryVariables
  >(GetProjectTasksDocument, options);
}
// @ts-ignore
export function useGetProjectTasksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProjectTasksQuery,
    GetProjectTasksQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetProjectTasksQuery,
  GetProjectTasksQueryVariables
>;
export function useGetProjectTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectTasksQuery,
        GetProjectTasksQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetProjectTasksQuery | undefined,
  GetProjectTasksQueryVariables
>;
export function useGetProjectTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectTasksQuery,
        GetProjectTasksQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetProjectTasksQuery,
    GetProjectTasksQueryVariables
  >(GetProjectTasksDocument, options);
}
export type GetProjectTasksQueryHookResult = ReturnType<
  typeof useGetProjectTasksQuery
>;
export type GetProjectTasksLazyQueryHookResult = ReturnType<
  typeof useGetProjectTasksLazyQuery
>;
export type GetProjectTasksSuspenseQueryHookResult = ReturnType<
  typeof useGetProjectTasksSuspenseQuery
>;
export type GetProjectTasksQueryResult = Apollo.QueryResult<
  GetProjectTasksQuery,
  GetProjectTasksQueryVariables
>;
export const GetProjectTeamSubscriptionDocument = gql`
  query getProjectTeamSubscription($id: ID!) {
    getProject(id: $id) {
      id
      team {
        ...TeamSubscription
      }
    }
  }
  ${TeamSubscriptionFragmentDoc}
`;

/**
 * __useGetProjectTeamSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetProjectTeamSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectTeamSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectTeamSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectTeamSubscriptionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProjectTeamSubscriptionQuery,
    GetProjectTeamSubscriptionQueryVariables
  > &
    (
      | { variables: GetProjectTeamSubscriptionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProjectTeamSubscriptionQuery,
    GetProjectTeamSubscriptionQueryVariables
  >(GetProjectTeamSubscriptionDocument, options);
}
export function useGetProjectTeamSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProjectTeamSubscriptionQuery,
    GetProjectTeamSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProjectTeamSubscriptionQuery,
    GetProjectTeamSubscriptionQueryVariables
  >(GetProjectTeamSubscriptionDocument, options);
}
// @ts-ignore
export function useGetProjectTeamSubscriptionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProjectTeamSubscriptionQuery,
    GetProjectTeamSubscriptionQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetProjectTeamSubscriptionQuery,
  GetProjectTeamSubscriptionQueryVariables
>;
export function useGetProjectTeamSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectTeamSubscriptionQuery,
        GetProjectTeamSubscriptionQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetProjectTeamSubscriptionQuery | undefined,
  GetProjectTeamSubscriptionQueryVariables
>;
export function useGetProjectTeamSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectTeamSubscriptionQuery,
        GetProjectTeamSubscriptionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetProjectTeamSubscriptionQuery,
    GetProjectTeamSubscriptionQueryVariables
  >(GetProjectTeamSubscriptionDocument, options);
}
export type GetProjectTeamSubscriptionQueryHookResult = ReturnType<
  typeof useGetProjectTeamSubscriptionQuery
>;
export type GetProjectTeamSubscriptionLazyQueryHookResult = ReturnType<
  typeof useGetProjectTeamSubscriptionLazyQuery
>;
export type GetProjectTeamSubscriptionSuspenseQueryHookResult = ReturnType<
  typeof useGetProjectTeamSubscriptionSuspenseQuery
>;
export type GetProjectTeamSubscriptionQueryResult = Apollo.QueryResult<
  GetProjectTeamSubscriptionQuery,
  GetProjectTeamSubscriptionQueryVariables
>;
export const GetProjectUnreadAuditsDocument = gql`
  query getProjectUnreadAudits($id: ID!) {
    getProject(id: $id) {
      id
      unreadAudits {
        id
      }
    }
  }
`;

/**
 * __useGetProjectUnreadAuditsQuery__
 *
 * To run a query within a React component, call `useGetProjectUnreadAuditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectUnreadAuditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectUnreadAuditsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectUnreadAuditsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProjectUnreadAuditsQuery,
    GetProjectUnreadAuditsQueryVariables
  > &
    (
      | { variables: GetProjectUnreadAuditsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProjectUnreadAuditsQuery,
    GetProjectUnreadAuditsQueryVariables
  >(GetProjectUnreadAuditsDocument, options);
}
export function useGetProjectUnreadAuditsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProjectUnreadAuditsQuery,
    GetProjectUnreadAuditsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProjectUnreadAuditsQuery,
    GetProjectUnreadAuditsQueryVariables
  >(GetProjectUnreadAuditsDocument, options);
}
// @ts-ignore
export function useGetProjectUnreadAuditsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProjectUnreadAuditsQuery,
    GetProjectUnreadAuditsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetProjectUnreadAuditsQuery,
  GetProjectUnreadAuditsQueryVariables
>;
export function useGetProjectUnreadAuditsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectUnreadAuditsQuery,
        GetProjectUnreadAuditsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetProjectUnreadAuditsQuery | undefined,
  GetProjectUnreadAuditsQueryVariables
>;
export function useGetProjectUnreadAuditsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProjectUnreadAuditsQuery,
        GetProjectUnreadAuditsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetProjectUnreadAuditsQuery,
    GetProjectUnreadAuditsQueryVariables
  >(GetProjectUnreadAuditsDocument, options);
}
export type GetProjectUnreadAuditsQueryHookResult = ReturnType<
  typeof useGetProjectUnreadAuditsQuery
>;
export type GetProjectUnreadAuditsLazyQueryHookResult = ReturnType<
  typeof useGetProjectUnreadAuditsLazyQuery
>;
export type GetProjectUnreadAuditsSuspenseQueryHookResult = ReturnType<
  typeof useGetProjectUnreadAuditsSuspenseQuery
>;
export type GetProjectUnreadAuditsQueryResult = Apollo.QueryResult<
  GetProjectUnreadAuditsQuery,
  GetProjectUnreadAuditsQueryVariables
>;
export const GetPublicProjectDocument = gql`
  query getPublicProject($id: ID!, $token: String) {
    getPublicProject(id: $id, token: $token) {
      ... on PublicProject {
        id
        uuid
        name
        description
        address
        usersCount
        hasPendingMemberAdditionRequest
        invitationEmail
        invitationType
        inviteeRole
        inviterName
        team {
          name
          avatarFile {
            id
            cdnBaseUrl
            path
            isPreviewable
            thumbnail
          }
        }
        icon
        color
        members {
          id
          role
          name
          avatar {
            id
            cdnBaseUrl
            path
            isPreviewable
            thumbnail
          }
        }
      }
      ... on Project {
        id
        uuid
        name
        description
        address
        usersCount
      }
    }
  }
`;

/**
 * __useGetPublicProjectQuery__
 *
 * To run a query within a React component, call `useGetPublicProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetPublicProjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPublicProjectQuery,
    GetPublicProjectQueryVariables
  > &
    (
      | { variables: GetPublicProjectQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPublicProjectQuery, GetPublicProjectQueryVariables>(
    GetPublicProjectDocument,
    options
  );
}
export function useGetPublicProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPublicProjectQuery,
    GetPublicProjectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPublicProjectQuery,
    GetPublicProjectQueryVariables
  >(GetPublicProjectDocument, options);
}
// @ts-ignore
export function useGetPublicProjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPublicProjectQuery,
    GetPublicProjectQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetPublicProjectQuery,
  GetPublicProjectQueryVariables
>;
export function useGetPublicProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPublicProjectQuery,
        GetPublicProjectQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetPublicProjectQuery | undefined,
  GetPublicProjectQueryVariables
>;
export function useGetPublicProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPublicProjectQuery,
        GetPublicProjectQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPublicProjectQuery,
    GetPublicProjectQueryVariables
  >(GetPublicProjectDocument, options);
}
export type GetPublicProjectQueryHookResult = ReturnType<
  typeof useGetPublicProjectQuery
>;
export type GetPublicProjectLazyQueryHookResult = ReturnType<
  typeof useGetPublicProjectLazyQuery
>;
export type GetPublicProjectSuspenseQueryHookResult = ReturnType<
  typeof useGetPublicProjectSuspenseQuery
>;
export type GetPublicProjectQueryResult = Apollo.QueryResult<
  GetPublicProjectQuery,
  GetPublicProjectQueryVariables
>;
export const GetPublicTaskDocument = gql`
  query getPublicTask($id: ID!) {
    getPublicTask(id: $id) {
      ... on PublicTask {
        id
        hasPendingMemberAdditionRequest
      }
      ... on Task {
        id
      }
    }
  }
`;

/**
 * __useGetPublicTaskQuery__
 *
 * To run a query within a React component, call `useGetPublicTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPublicTaskQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPublicTaskQuery,
    GetPublicTaskQueryVariables
  > &
    (
      | { variables: GetPublicTaskQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPublicTaskQuery, GetPublicTaskQueryVariables>(
    GetPublicTaskDocument,
    options
  );
}
export function useGetPublicTaskLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPublicTaskQuery,
    GetPublicTaskQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPublicTaskQuery, GetPublicTaskQueryVariables>(
    GetPublicTaskDocument,
    options
  );
}
// @ts-ignore
export function useGetPublicTaskSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPublicTaskQuery,
    GetPublicTaskQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetPublicTaskQuery,
  GetPublicTaskQueryVariables
>;
export function useGetPublicTaskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPublicTaskQuery,
        GetPublicTaskQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetPublicTaskQuery | undefined,
  GetPublicTaskQueryVariables
>;
export function useGetPublicTaskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPublicTaskQuery,
        GetPublicTaskQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPublicTaskQuery,
    GetPublicTaskQueryVariables
  >(GetPublicTaskDocument, options);
}
export type GetPublicTaskQueryHookResult = ReturnType<
  typeof useGetPublicTaskQuery
>;
export type GetPublicTaskLazyQueryHookResult = ReturnType<
  typeof useGetPublicTaskLazyQuery
>;
export type GetPublicTaskSuspenseQueryHookResult = ReturnType<
  typeof useGetPublicTaskSuspenseQuery
>;
export type GetPublicTaskQueryResult = Apollo.QueryResult<
  GetPublicTaskQuery,
  GetPublicTaskQueryVariables
>;
export const GetPublicTeamDocument = gql`
  query getPublicTeam($id: ID!) {
    getPublicTeam(id: $id) {
      ... on PublicTeam {
        address
        avatarFile {
          ...AvatarDetail
        }
        createdAt
        hasPendingMemberAdditionRequest
        name
        uuid
        totalMembers
        skills {
          id
          name
        }
      }
      ... on Team {
        address
        latitude
        longitude
        id
        uuid
        avatar
        avatarFile {
          ...AvatarDetail
        }
        createdAt
        name
        usersCount
        fileStorageUsed
        mediaStorageUsed
        pending
        maxDocumentStorage
        storageRemaining
        currentUserRole
        hasPendingMemberAdditionRequest
        hasReachedMaxProjects
        numberOfProjectsUsed
        maxNumberOfProjects
        personal
        tasksCount
        completedTasksCount
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useGetPublicTeamQuery__
 *
 * To run a query within a React component, call `useGetPublicTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPublicTeamQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPublicTeamQuery,
    GetPublicTeamQueryVariables
  > &
    (
      | { variables: GetPublicTeamQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPublicTeamQuery, GetPublicTeamQueryVariables>(
    GetPublicTeamDocument,
    options
  );
}
export function useGetPublicTeamLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPublicTeamQuery,
    GetPublicTeamQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPublicTeamQuery, GetPublicTeamQueryVariables>(
    GetPublicTeamDocument,
    options
  );
}
// @ts-ignore
export function useGetPublicTeamSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPublicTeamQuery,
    GetPublicTeamQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetPublicTeamQuery,
  GetPublicTeamQueryVariables
>;
export function useGetPublicTeamSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPublicTeamQuery,
        GetPublicTeamQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetPublicTeamQuery | undefined,
  GetPublicTeamQueryVariables
>;
export function useGetPublicTeamSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPublicTeamQuery,
        GetPublicTeamQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPublicTeamQuery,
    GetPublicTeamQueryVariables
  >(GetPublicTeamDocument, options);
}
export type GetPublicTeamQueryHookResult = ReturnType<
  typeof useGetPublicTeamQuery
>;
export type GetPublicTeamLazyQueryHookResult = ReturnType<
  typeof useGetPublicTeamLazyQuery
>;
export type GetPublicTeamSuspenseQueryHookResult = ReturnType<
  typeof useGetPublicTeamSuspenseQuery
>;
export type GetPublicTeamQueryResult = Apollo.QueryResult<
  GetPublicTeamQuery,
  GetPublicTeamQueryVariables
>;
export const GetRateUsStateDocument = gql`
  query getRateUsState {
    getRateUsState {
      ...RateUsStateDetail
    }
  }
  ${RateUsStateDetailFragmentDoc}
`;

/**
 * __useGetRateUsStateQuery__
 *
 * To run a query within a React component, call `useGetRateUsStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRateUsStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRateUsStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRateUsStateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetRateUsStateQuery,
    GetRateUsStateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRateUsStateQuery, GetRateUsStateQueryVariables>(
    GetRateUsStateDocument,
    options
  );
}
export function useGetRateUsStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRateUsStateQuery,
    GetRateUsStateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRateUsStateQuery, GetRateUsStateQueryVariables>(
    GetRateUsStateDocument,
    options
  );
}
// @ts-ignore
export function useGetRateUsStateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRateUsStateQuery,
    GetRateUsStateQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetRateUsStateQuery,
  GetRateUsStateQueryVariables
>;
export function useGetRateUsStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRateUsStateQuery,
        GetRateUsStateQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetRateUsStateQuery | undefined,
  GetRateUsStateQueryVariables
>;
export function useGetRateUsStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRateUsStateQuery,
        GetRateUsStateQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRateUsStateQuery,
    GetRateUsStateQueryVariables
  >(GetRateUsStateDocument, options);
}
export type GetRateUsStateQueryHookResult = ReturnType<
  typeof useGetRateUsStateQuery
>;
export type GetRateUsStateLazyQueryHookResult = ReturnType<
  typeof useGetRateUsStateLazyQuery
>;
export type GetRateUsStateSuspenseQueryHookResult = ReturnType<
  typeof useGetRateUsStateSuspenseQuery
>;
export type GetRateUsStateQueryResult = Apollo.QueryResult<
  GetRateUsStateQuery,
  GetRateUsStateQueryVariables
>;
export const GetTaskDocument = gql`
  query getTask($id: ID!) {
    getTask(id: $id) {
      id
      name
      status
      priority
      startDate
      dueDate
      completedAt
      createdAt
      phaseId
      projectId
      deletedAt
      skillIds
      userIds
      dueGroup
      dependencies {
        id
        name
      }
      fixedOrder
      recurring
      description
      frequency
      currentUserRole
      currentUserProjectRole
      currentUserProjectTeamRole
      auditsCount
      checklists {
        id
        name
        completedAt
        createdAt
      }
      members {
        id
        role
        user {
          ...UserDetail
        }
      }
      userRequests {
        id
        role
        user {
          ...UserDetail
          avatar {
            ...AvatarDetail
          }
        }
        expiredAt
      }
      invitations {
        id
        email
        role
        expiredAt
      }
      userRequests {
        id
        role
        expiredAt
        user {
          ...UserDetail
        }
      }
      creator {
        ...UserDetail
      }
      completor {
        ...UserDetail
      }
      project {
        id
        uuid
        name
        icon
        color
        currentUserTeamRole
        currentUserRole
        team {
          avatar
          createdAt
          id
          name
          personal
          storageRemaining
          subscriptionDetails {
            expirationDate
            subscriptionInterval
            subscriptionPlanName
            subscriptionStatus
            isSubscriptionCanceled
            isSubscriptionActive
            isSubscriptionOnTrial
            paymentCardLast4
            trialEndsAt
            updatedAt
          }
        }
        initials
        archivedAt
      }
      unreadAuditsCount
      phase {
        id
        name
      }
    }
  }
  ${UserDetailFragmentDoc}
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useGetTaskQuery__
 *
 * To run a query within a React component, call `useGetTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskQuery(
  baseOptions: Apollo.QueryHookOptions<GetTaskQuery, GetTaskQueryVariables> &
    ({ variables: GetTaskQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTaskQuery, GetTaskQueryVariables>(
    GetTaskDocument,
    options
  );
}
export function useGetTaskLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTaskQuery, GetTaskQueryVariables>(
    GetTaskDocument,
    options
  );
}
// @ts-ignore
export function useGetTaskSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTaskQuery,
    GetTaskQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetTaskQuery, GetTaskQueryVariables>;
export function useGetTaskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetTaskQuery | undefined,
  GetTaskQueryVariables
>;
export function useGetTaskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTaskQuery, GetTaskQueryVariables>(
    GetTaskDocument,
    options
  );
}
export type GetTaskQueryHookResult = ReturnType<typeof useGetTaskQuery>;
export type GetTaskLazyQueryHookResult = ReturnType<typeof useGetTaskLazyQuery>;
export type GetTaskSuspenseQueryHookResult = ReturnType<
  typeof useGetTaskSuspenseQuery
>;
export type GetTaskQueryResult = Apollo.QueryResult<
  GetTaskQuery,
  GetTaskQueryVariables
>;
export const GetTaskCompletionDocument = gql`
  query getTaskCompletion($id: ID!) {
    getTask(id: $id) {
      id
      status
      completedAt
    }
  }
`;

/**
 * __useGetTaskCompletionQuery__
 *
 * To run a query within a React component, call `useGetTaskCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskCompletionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskCompletionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTaskCompletionQuery,
    GetTaskCompletionQueryVariables
  > &
    (
      | { variables: GetTaskCompletionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTaskCompletionQuery,
    GetTaskCompletionQueryVariables
  >(GetTaskCompletionDocument, options);
}
export function useGetTaskCompletionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTaskCompletionQuery,
    GetTaskCompletionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTaskCompletionQuery,
    GetTaskCompletionQueryVariables
  >(GetTaskCompletionDocument, options);
}
// @ts-ignore
export function useGetTaskCompletionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTaskCompletionQuery,
    GetTaskCompletionQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetTaskCompletionQuery,
  GetTaskCompletionQueryVariables
>;
export function useGetTaskCompletionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTaskCompletionQuery,
        GetTaskCompletionQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetTaskCompletionQuery | undefined,
  GetTaskCompletionQueryVariables
>;
export function useGetTaskCompletionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTaskCompletionQuery,
        GetTaskCompletionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTaskCompletionQuery,
    GetTaskCompletionQueryVariables
  >(GetTaskCompletionDocument, options);
}
export type GetTaskCompletionQueryHookResult = ReturnType<
  typeof useGetTaskCompletionQuery
>;
export type GetTaskCompletionLazyQueryHookResult = ReturnType<
  typeof useGetTaskCompletionLazyQuery
>;
export type GetTaskCompletionSuspenseQueryHookResult = ReturnType<
  typeof useGetTaskCompletionSuspenseQuery
>;
export type GetTaskCompletionQueryResult = Apollo.QueryResult<
  GetTaskCompletionQuery,
  GetTaskCompletionQueryVariables
>;
export const GetTaskForNotificationDocument = gql`
  query getTaskForNotification($id: ID!) {
    getTask(id: $id) {
      id
      name
    }
  }
`;

/**
 * __useGetTaskForNotificationQuery__
 *
 * To run a query within a React component, call `useGetTaskForNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskForNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskForNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskForNotificationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTaskForNotificationQuery,
    GetTaskForNotificationQueryVariables
  > &
    (
      | { variables: GetTaskForNotificationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTaskForNotificationQuery,
    GetTaskForNotificationQueryVariables
  >(GetTaskForNotificationDocument, options);
}
export function useGetTaskForNotificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTaskForNotificationQuery,
    GetTaskForNotificationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTaskForNotificationQuery,
    GetTaskForNotificationQueryVariables
  >(GetTaskForNotificationDocument, options);
}
// @ts-ignore
export function useGetTaskForNotificationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTaskForNotificationQuery,
    GetTaskForNotificationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetTaskForNotificationQuery,
  GetTaskForNotificationQueryVariables
>;
export function useGetTaskForNotificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTaskForNotificationQuery,
        GetTaskForNotificationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetTaskForNotificationQuery | undefined,
  GetTaskForNotificationQueryVariables
>;
export function useGetTaskForNotificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTaskForNotificationQuery,
        GetTaskForNotificationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTaskForNotificationQuery,
    GetTaskForNotificationQueryVariables
  >(GetTaskForNotificationDocument, options);
}
export type GetTaskForNotificationQueryHookResult = ReturnType<
  typeof useGetTaskForNotificationQuery
>;
export type GetTaskForNotificationLazyQueryHookResult = ReturnType<
  typeof useGetTaskForNotificationLazyQuery
>;
export type GetTaskForNotificationSuspenseQueryHookResult = ReturnType<
  typeof useGetTaskForNotificationSuspenseQuery
>;
export type GetTaskForNotificationQueryResult = Apollo.QueryResult<
  GetTaskForNotificationQuery,
  GetTaskForNotificationQueryVariables
>;
export const GetTaskMembersDocument = gql`
  query getTaskMembers($id: ID!) {
    getTask(id: $id) {
      id
      name
      members {
        id
        role
        user {
          ...UserDetail
        }
      }
    }
  }
  ${UserDetailFragmentDoc}
`;

/**
 * __useGetTaskMembersQuery__
 *
 * To run a query within a React component, call `useGetTaskMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTaskMembersQuery,
    GetTaskMembersQueryVariables
  > &
    (
      | { variables: GetTaskMembersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTaskMembersQuery, GetTaskMembersQueryVariables>(
    GetTaskMembersDocument,
    options
  );
}
export function useGetTaskMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTaskMembersQuery,
    GetTaskMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTaskMembersQuery, GetTaskMembersQueryVariables>(
    GetTaskMembersDocument,
    options
  );
}
// @ts-ignore
export function useGetTaskMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTaskMembersQuery,
    GetTaskMembersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetTaskMembersQuery,
  GetTaskMembersQueryVariables
>;
export function useGetTaskMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTaskMembersQuery,
        GetTaskMembersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetTaskMembersQuery | undefined,
  GetTaskMembersQueryVariables
>;
export function useGetTaskMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTaskMembersQuery,
        GetTaskMembersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTaskMembersQuery,
    GetTaskMembersQueryVariables
  >(GetTaskMembersDocument, options);
}
export type GetTaskMembersQueryHookResult = ReturnType<
  typeof useGetTaskMembersQuery
>;
export type GetTaskMembersLazyQueryHookResult = ReturnType<
  typeof useGetTaskMembersLazyQuery
>;
export type GetTaskMembersSuspenseQueryHookResult = ReturnType<
  typeof useGetTaskMembersSuspenseQuery
>;
export type GetTaskMembersQueryResult = Apollo.QueryResult<
  GetTaskMembersQuery,
  GetTaskMembersQueryVariables
>;
export const GetTaskUnreadAuditsDocument = gql`
  query getTaskUnreadAudits($id: ID!) {
    getTask(id: $id) {
      id
      name
      unreadAudits {
        id
      }
    }
  }
`;

/**
 * __useGetTaskUnreadAuditsQuery__
 *
 * To run a query within a React component, call `useGetTaskUnreadAuditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskUnreadAuditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskUnreadAuditsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskUnreadAuditsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTaskUnreadAuditsQuery,
    GetTaskUnreadAuditsQueryVariables
  > &
    (
      | { variables: GetTaskUnreadAuditsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTaskUnreadAuditsQuery,
    GetTaskUnreadAuditsQueryVariables
  >(GetTaskUnreadAuditsDocument, options);
}
export function useGetTaskUnreadAuditsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTaskUnreadAuditsQuery,
    GetTaskUnreadAuditsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTaskUnreadAuditsQuery,
    GetTaskUnreadAuditsQueryVariables
  >(GetTaskUnreadAuditsDocument, options);
}
// @ts-ignore
export function useGetTaskUnreadAuditsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTaskUnreadAuditsQuery,
    GetTaskUnreadAuditsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetTaskUnreadAuditsQuery,
  GetTaskUnreadAuditsQueryVariables
>;
export function useGetTaskUnreadAuditsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTaskUnreadAuditsQuery,
        GetTaskUnreadAuditsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetTaskUnreadAuditsQuery | undefined,
  GetTaskUnreadAuditsQueryVariables
>;
export function useGetTaskUnreadAuditsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTaskUnreadAuditsQuery,
        GetTaskUnreadAuditsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTaskUnreadAuditsQuery,
    GetTaskUnreadAuditsQueryVariables
  >(GetTaskUnreadAuditsDocument, options);
}
export type GetTaskUnreadAuditsQueryHookResult = ReturnType<
  typeof useGetTaskUnreadAuditsQuery
>;
export type GetTaskUnreadAuditsLazyQueryHookResult = ReturnType<
  typeof useGetTaskUnreadAuditsLazyQuery
>;
export type GetTaskUnreadAuditsSuspenseQueryHookResult = ReturnType<
  typeof useGetTaskUnreadAuditsSuspenseQuery
>;
export type GetTaskUnreadAuditsQueryResult = Apollo.QueryResult<
  GetTaskUnreadAuditsQuery,
  GetTaskUnreadAuditsQueryVariables
>;
export const GetTeamDocument = gql`
  query getTeam(
    $id: ID!
    $includePending: Boolean
    $withMembers: Boolean = true
  ) {
    getTeam(id: $id, includePending: $includePending) {
      ...TeamDetail
      ...TeamMembersDetail @include(if: $withMembers)
      highPriorityCompletionRate
      onTimeDeliveryRate
    }
  }
  ${TeamDetailFragmentDoc}
  ${TeamMembersDetailFragmentDoc}
`;

/**
 * __useGetTeamQuery__
 *
 * To run a query within a React component, call `useGetTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includePending: // value for 'includePending'
 *      withMembers: // value for 'withMembers'
 *   },
 * });
 */
export function useGetTeamQuery(
  baseOptions: Apollo.QueryHookOptions<GetTeamQuery, GetTeamQueryVariables> &
    ({ variables: GetTeamQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamQuery, GetTeamQueryVariables>(
    GetTeamDocument,
    options
  );
}
export function useGetTeamLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTeamQuery, GetTeamQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamQuery, GetTeamQueryVariables>(
    GetTeamDocument,
    options
  );
}
// @ts-ignore
export function useGetTeamSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTeamQuery,
    GetTeamQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetTeamQuery, GetTeamQueryVariables>;
export function useGetTeamSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTeamQuery, GetTeamQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetTeamQuery | undefined,
  GetTeamQueryVariables
>;
export function useGetTeamSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTeamQuery, GetTeamQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTeamQuery, GetTeamQueryVariables>(
    GetTeamDocument,
    options
  );
}
export type GetTeamQueryHookResult = ReturnType<typeof useGetTeamQuery>;
export type GetTeamLazyQueryHookResult = ReturnType<typeof useGetTeamLazyQuery>;
export type GetTeamSuspenseQueryHookResult = ReturnType<
  typeof useGetTeamSuspenseQuery
>;
export type GetTeamQueryResult = Apollo.QueryResult<
  GetTeamQuery,
  GetTeamQueryVariables
>;
export const GetTeamBillingDocument = gql`
  query getTeamBilling($role: ProjectMemberRole, $includePending: Boolean) {
    listTeams(role: $role, includePending: $includePending) {
      id
      product {
        allowMembers
        externalId
        features
        guestsOnly
        id
        maxDocumentStorage
        maxNumberOfProjects
        name
        position
        prices {
          amount
          externalId
          id
          interval
          intervalCount
        }
      }
      invoices {
        amount
        date
        description
        id
        invoiceUrl
        status
      }
      subscriptionDetails {
        paymentCardLast4
        paymentCardBrand
        paymentCardExpMonth
        paymentCardExpYear
        expirationDate
        subscriptionInterval
        subscriptionPlanName
        subscriptionStatus
        stripeProductId
        trialEndsAt
        isSubscriptionCanceled
        isSubscriptionActive
        isSubscriptionOnTrial
        updatedAt
        currentSeatCount
        pricePerSeat
      }
    }
  }
`;

/**
 * __useGetTeamBillingQuery__
 *
 * To run a query within a React component, call `useGetTeamBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamBillingQuery({
 *   variables: {
 *      role: // value for 'role'
 *      includePending: // value for 'includePending'
 *   },
 * });
 */
export function useGetTeamBillingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTeamBillingQuery,
    GetTeamBillingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamBillingQuery, GetTeamBillingQueryVariables>(
    GetTeamBillingDocument,
    options
  );
}
export function useGetTeamBillingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTeamBillingQuery,
    GetTeamBillingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamBillingQuery, GetTeamBillingQueryVariables>(
    GetTeamBillingDocument,
    options
  );
}
// @ts-ignore
export function useGetTeamBillingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTeamBillingQuery,
    GetTeamBillingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetTeamBillingQuery,
  GetTeamBillingQueryVariables
>;
export function useGetTeamBillingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTeamBillingQuery,
        GetTeamBillingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetTeamBillingQuery | undefined,
  GetTeamBillingQueryVariables
>;
export function useGetTeamBillingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTeamBillingQuery,
        GetTeamBillingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTeamBillingQuery,
    GetTeamBillingQueryVariables
  >(GetTeamBillingDocument, options);
}
export type GetTeamBillingQueryHookResult = ReturnType<
  typeof useGetTeamBillingQuery
>;
export type GetTeamBillingLazyQueryHookResult = ReturnType<
  typeof useGetTeamBillingLazyQuery
>;
export type GetTeamBillingSuspenseQueryHookResult = ReturnType<
  typeof useGetTeamBillingSuspenseQuery
>;
export type GetTeamBillingQueryResult = Apollo.QueryResult<
  GetTeamBillingQuery,
  GetTeamBillingQueryVariables
>;
export const GetTeamDetailDocument = gql`
  query getTeamDetail(
    $id: ID!
    $includePending: Boolean
    $withMembers: Boolean = true
  ) {
    getPublicTeam(id: $id, includePending: $includePending) {
      ... on PublicTeam {
        address
        avatarFile {
          ...AvatarDetail
        }
        createdAt
        hasPendingMemberAdditionRequest
        name
        uuid
        totalMembers
        skills {
          id
          name
        }
      }
      ... on Team {
        ...TeamDetail
        ...TeamMembersDetail @include(if: $withMembers)
        hasPendingMemberAdditionRequest
        highPriorityCompletionRate
        onTimeDeliveryRate
      }
    }
  }
  ${AvatarDetailFragmentDoc}
  ${TeamDetailFragmentDoc}
  ${TeamMembersDetailFragmentDoc}
`;

/**
 * __useGetTeamDetailQuery__
 *
 * To run a query within a React component, call `useGetTeamDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includePending: // value for 'includePending'
 *      withMembers: // value for 'withMembers'
 *   },
 * });
 */
export function useGetTeamDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTeamDetailQuery,
    GetTeamDetailQueryVariables
  > &
    (
      | { variables: GetTeamDetailQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamDetailQuery, GetTeamDetailQueryVariables>(
    GetTeamDetailDocument,
    options
  );
}
export function useGetTeamDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTeamDetailQuery,
    GetTeamDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamDetailQuery, GetTeamDetailQueryVariables>(
    GetTeamDetailDocument,
    options
  );
}
// @ts-ignore
export function useGetTeamDetailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTeamDetailQuery,
    GetTeamDetailQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetTeamDetailQuery,
  GetTeamDetailQueryVariables
>;
export function useGetTeamDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTeamDetailQuery,
        GetTeamDetailQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetTeamDetailQuery | undefined,
  GetTeamDetailQueryVariables
>;
export function useGetTeamDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTeamDetailQuery,
        GetTeamDetailQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTeamDetailQuery,
    GetTeamDetailQueryVariables
  >(GetTeamDetailDocument, options);
}
export type GetTeamDetailQueryHookResult = ReturnType<
  typeof useGetTeamDetailQuery
>;
export type GetTeamDetailLazyQueryHookResult = ReturnType<
  typeof useGetTeamDetailLazyQuery
>;
export type GetTeamDetailSuspenseQueryHookResult = ReturnType<
  typeof useGetTeamDetailSuspenseQuery
>;
export type GetTeamDetailQueryResult = Apollo.QueryResult<
  GetTeamDetailQuery,
  GetTeamDetailQueryVariables
>;
export const GetTeamForNotificationDocument = gql`
  query getTeamForNotification($id: ID!, $includePending: Boolean) {
    getTeam(id: $id, includePending: $includePending) {
      id
      name
    }
  }
`;

/**
 * __useGetTeamForNotificationQuery__
 *
 * To run a query within a React component, call `useGetTeamForNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamForNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamForNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includePending: // value for 'includePending'
 *   },
 * });
 */
export function useGetTeamForNotificationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTeamForNotificationQuery,
    GetTeamForNotificationQueryVariables
  > &
    (
      | { variables: GetTeamForNotificationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTeamForNotificationQuery,
    GetTeamForNotificationQueryVariables
  >(GetTeamForNotificationDocument, options);
}
export function useGetTeamForNotificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTeamForNotificationQuery,
    GetTeamForNotificationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTeamForNotificationQuery,
    GetTeamForNotificationQueryVariables
  >(GetTeamForNotificationDocument, options);
}
// @ts-ignore
export function useGetTeamForNotificationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTeamForNotificationQuery,
    GetTeamForNotificationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetTeamForNotificationQuery,
  GetTeamForNotificationQueryVariables
>;
export function useGetTeamForNotificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTeamForNotificationQuery,
        GetTeamForNotificationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetTeamForNotificationQuery | undefined,
  GetTeamForNotificationQueryVariables
>;
export function useGetTeamForNotificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTeamForNotificationQuery,
        GetTeamForNotificationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTeamForNotificationQuery,
    GetTeamForNotificationQueryVariables
  >(GetTeamForNotificationDocument, options);
}
export type GetTeamForNotificationQueryHookResult = ReturnType<
  typeof useGetTeamForNotificationQuery
>;
export type GetTeamForNotificationLazyQueryHookResult = ReturnType<
  typeof useGetTeamForNotificationLazyQuery
>;
export type GetTeamForNotificationSuspenseQueryHookResult = ReturnType<
  typeof useGetTeamForNotificationSuspenseQuery
>;
export type GetTeamForNotificationQueryResult = Apollo.QueryResult<
  GetTeamForNotificationQuery,
  GetTeamForNotificationQueryVariables
>;
export const GlobalActivitySearchDocument = gql`
  query globalActivitySearch(
    $term: String!
    $size: Int
    $from: Int
    $userIds: [ID!]
    $teamIds: [ID!]
    $projectIds: [ID!]
    $startDate: ISO8601DateTime
    $endDate: ISO8601DateTime
  ) {
    globalActivitySearch(
      term: $term
      size: $size
      from: $from
      userIds: $userIds
      teamIds: $teamIds
      projectIds: $projectIds
      startDate: $startDate
      endDate: $endDate
    ) {
      total
      highlight {
        authorName
        body
        chatName
        name
        projectNames
        taskNames
      }
      record {
        ... on Document {
          id
          name
          contentType
          createdAt
          size
          isImage
          clientId
          owner {
            ...UserDetail
          }
          file {
            id
            isPreviewable
            thumbnail
          }
          messageDocuments {
            id
            message {
              id
              clientId
              authorId
              chat {
                id
                name
              }
            }
          }
          projectDocuments {
            id
            project {
              id
              uuid
              name
              team {
                avatar
                createdAt
                id
                name
                personal
              }
            }
          }
        }
        ... on Task {
          id
          name
          status
          priority
          dueDate
          projectId
          userIds
          completedAt
          deletedAt
          currentUserRole
          creator {
            ...UserDetail
          }
          members {
            id
            role
            user {
              ...UserDetail
              avatar {
                ...AvatarDetail
              }
            }
          }
          project {
            id
            uuid
            name
            color
            team {
              name
              personal
            }
          }
        }
        ... on Project {
          id
          uuid
          initials
          name
          description
          address
          color
          createdAt
          icon
          team {
            avatar
            createdAt
            id
            name
            personal
          }
          creator {
            ...UserDetail
          }
        }
        ... on Chat {
          id
          name
        }
        ... on Message {
          id
          body
          publishedAt
          isSender
          clientId
          authorId
          chatId
          clientId
          createdAt
          isDraft
          author {
            id
            name
            ...UserDetail
          }
          chat {
            ...ChatDetail
            avatar {
              ...AvatarDetail
            }
          }
          reaction {
            ... on MessageReaction {
              id
              reaction
              count
              user {
                id
              }
            }
          }
          attachments {
            ... on Document {
              id
              isImage
              isAudio
              clientId
              duration
              name
              createdAt
              contentType
              file {
                id
                cdnBaseUrl
                path
                isPreviewable
                thumbnail
              }
              ...DocumentDetail
            }
            ... on MessageTask {
              id
              author {
                ...UserDetail
              }
              task {
                id
                name
                status
                priority
                dueDate
                projectId
                userIds
                deletedAt
                creator {
                  ...UserDetail
                }
                project {
                  id
                  uuid
                  name
                  color
                }
              }
            }
            ... on MessageProject {
              id
              author {
                ...UserDetail
              }
              project {
                id
                uuid
                initials
                name
                description
                address
                color
                createdAt
                creator {
                  ...UserDetail
                }
              }
            }
            ... on MessageTask {
              id
              author {
                ...UserDetail
              }
              task {
                id
                name
                status
                priority
                dueDate
                projectId
                userIds
                deletedAt
                creator {
                  ...UserDetail
                }
                project {
                  id
                  uuid
                  name
                  color
                }
              }
            }
            ... on MessageProject {
              id
              author {
                ...UserDetail
              }
              project {
                id
                uuid
                initials
                name
                description
                address
                color
                createdAt
                creator {
                  ...UserDetail
                }
              }
            }
          }
        }
        ... on User {
          id
          firstName
          lastName
          email
          fullName: name
          avatar {
            id
            cdnBaseUrl
            path
            isPreviewable
            thumbnail
          }
        }
        ... on Audit {
          event
          createdAt
          id
          changes
          projectRole
          user {
            ...UserDetail
          }
          documents {
            ...DocumentDetail
          }
          attachment {
            ... on Document {
              ...DocumentDetail
              projectDocuments {
                id
                project {
                  id
                  uuid
                  name
                }
              }
              taskDocuments {
                id
                task {
                  id
                  name
                  projectId
                  deletedAt
                  project {
                    id
                    uuid
                    name
                  }
                }
              }
            }
            ... on Message {
              ...MessageDetail
            }
            ... on Task {
              id
              name
              projectId
              deletedAt
              project {
                id
                uuid
                name
              }
            }
            ... on Project {
              id
              uuid
              name
            }
            ... on TaskUser {
              id
              task {
                id
                name
                deletedAt
                project {
                  id
                  uuid
                  name
                }
              }
              user {
                ...UserDetail
              }
            }
            ... on EntityUser {
              id
              user {
                ...UserDetail
              }
              entityTask: task {
                id
                name
                deletedAt
                members {
                  id
                  role
                  user {
                    ...UserDetail
                    avatar {
                      ...AvatarDetail
                    }
                  }
                }
                project {
                  id
                  uuid
                  name
                }
              }
              entityProject: project {
                id
                uuid
                name
              }
            }
          }
        }
      }
    }
  }
  ${UserDetailFragmentDoc}
  ${AvatarDetailFragmentDoc}
  ${ChatDetailFragmentDoc}
  ${DocumentDetailFragmentDoc}
  ${MessageDetailFragmentDoc}
`;

/**
 * __useGlobalActivitySearchQuery__
 *
 * To run a query within a React component, call `useGlobalActivitySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalActivitySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalActivitySearchQuery({
 *   variables: {
 *      term: // value for 'term'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *      userIds: // value for 'userIds'
 *      teamIds: // value for 'teamIds'
 *      projectIds: // value for 'projectIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGlobalActivitySearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    GlobalActivitySearchQuery,
    GlobalActivitySearchQueryVariables
  > &
    (
      | { variables: GlobalActivitySearchQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GlobalActivitySearchQuery,
    GlobalActivitySearchQueryVariables
  >(GlobalActivitySearchDocument, options);
}
export function useGlobalActivitySearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GlobalActivitySearchQuery,
    GlobalActivitySearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GlobalActivitySearchQuery,
    GlobalActivitySearchQueryVariables
  >(GlobalActivitySearchDocument, options);
}
// @ts-ignore
export function useGlobalActivitySearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GlobalActivitySearchQuery,
    GlobalActivitySearchQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GlobalActivitySearchQuery,
  GlobalActivitySearchQueryVariables
>;
export function useGlobalActivitySearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GlobalActivitySearchQuery,
        GlobalActivitySearchQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GlobalActivitySearchQuery | undefined,
  GlobalActivitySearchQueryVariables
>;
export function useGlobalActivitySearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GlobalActivitySearchQuery,
        GlobalActivitySearchQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GlobalActivitySearchQuery,
    GlobalActivitySearchQueryVariables
  >(GlobalActivitySearchDocument, options);
}
export type GlobalActivitySearchQueryHookResult = ReturnType<
  typeof useGlobalActivitySearchQuery
>;
export type GlobalActivitySearchLazyQueryHookResult = ReturnType<
  typeof useGlobalActivitySearchLazyQuery
>;
export type GlobalActivitySearchSuspenseQueryHookResult = ReturnType<
  typeof useGlobalActivitySearchSuspenseQuery
>;
export type GlobalActivitySearchQueryResult = Apollo.QueryResult<
  GlobalActivitySearchQuery,
  GlobalActivitySearchQueryVariables
>;
export const InvitationDetailsDocument = gql`
  query invitationDetails(
    $token: String!
    $type: Invitation!
    $entityId: String
  ) {
    invitationDetails(token: $token, type: $type, entityId: $entityId) {
      autoJoin
      invitationStatus
      isLinkInvite
      invitationEmail
      invitationName
      invitationRole
      invitedByName
      invitedBy {
        id
      }
      chat {
        id
        name
        userCount
        ownerName
      }
      team {
        address
        avatarFile {
          ...AvatarDetail
        }
        createdAt
        hasPendingMemberAdditionRequest
        name
        totalMembers
        uuid
      }
      project {
        id
        uuid
        name
        address
        description
        usersCount
        team {
          name
          avatarFile {
            ...AvatarDetail
          }
        }
        icon
        color
      }
      task {
        description
        dueDate
        id
        inviterName
        name
        ownerName
        priority
        projectIcon
        projectName
        projectUuid
        startDate
        usersCount
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useInvitationDetailsQuery__
 *
 * To run a query within a React component, call `useInvitationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationDetailsQuery({
 *   variables: {
 *      token: // value for 'token'
 *      type: // value for 'type'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useInvitationDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    InvitationDetailsQuery,
    InvitationDetailsQueryVariables
  > &
    (
      | { variables: InvitationDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InvitationDetailsQuery,
    InvitationDetailsQueryVariables
  >(InvitationDetailsDocument, options);
}
export function useInvitationDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InvitationDetailsQuery,
    InvitationDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InvitationDetailsQuery,
    InvitationDetailsQueryVariables
  >(InvitationDetailsDocument, options);
}
// @ts-ignore
export function useInvitationDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InvitationDetailsQuery,
    InvitationDetailsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  InvitationDetailsQuery,
  InvitationDetailsQueryVariables
>;
export function useInvitationDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvitationDetailsQuery,
        InvitationDetailsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  InvitationDetailsQuery | undefined,
  InvitationDetailsQueryVariables
>;
export function useInvitationDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvitationDetailsQuery,
        InvitationDetailsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InvitationDetailsQuery,
    InvitationDetailsQueryVariables
  >(InvitationDetailsDocument, options);
}
export type InvitationDetailsQueryHookResult = ReturnType<
  typeof useInvitationDetailsQuery
>;
export type InvitationDetailsLazyQueryHookResult = ReturnType<
  typeof useInvitationDetailsLazyQuery
>;
export type InvitationDetailsSuspenseQueryHookResult = ReturnType<
  typeof useInvitationDetailsSuspenseQuery
>;
export type InvitationDetailsQueryResult = Apollo.QueryResult<
  InvitationDetailsQuery,
  InvitationDetailsQueryVariables
>;
export const ListActivitiesDocument = gql`
  query listActivities(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $userIds: [ID!]
    $teamIds: [ID!]
    $projectIds: [ID!]
    $startDate: ISO8601DateTime
    $endDate: ISO8601DateTime
  ) {
    listActivities(
      first: $first
      last: $last
      after: $after
      before: $before
      userIds: $userIds
      teamIds: $teamIds
      projectIds: $projectIds
      startDate: $startDate
      endDate: $endDate
    ) {
      isPaywalled
      totalEventCount
      upgradeTeam {
        id
        uuid
        name
        usersCount
      }
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          event
          createdAt
          id
          changes
          user {
            ...UserDetail
          }
          projectRole
          documents {
            ...DocumentDetail
          }
          attachment {
            ... on Document {
              ...DocumentDetail
              projectDocuments {
                id
                project {
                  id
                  uuid
                  name
                }
              }
              taskDocuments {
                id
                task {
                  id
                  name
                  projectId
                  project {
                    id
                    uuid
                    name
                  }
                }
              }
            }
            ... on Message {
              ...MessageDetailForQuery
            }
            ... on Task {
              id
              name
              projectId
              deletedAt
              project {
                id
                uuid
                name
              }
            }
            ... on Project {
              id
              uuid
              name
            }
            ... on ProjectUser {
              id
              user {
                ...UserDetail
              }
            }
            ... on TaskUser {
              id
              task {
                id
                name
                project {
                  id
                  uuid
                  name
                }
              }
              user {
                ...UserDetail
              }
            }
            ... on EntityUser {
              id
              user {
                ...UserDetail
              }
              entityTask: task {
                id
                name
                deletedAt
                members {
                  id
                  role
                  user {
                    ...UserDetail
                  }
                }
                project {
                  id
                  uuid
                  name
                }
              }
              entityProject: project {
                id
                uuid
                name
              }
            }
          }
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${UserDetailFragmentDoc}
  ${DocumentDetailFragmentDoc}
  ${MessageDetailForQueryFragmentDoc}
`;

/**
 * __useListActivitiesQuery__
 *
 * To run a query within a React component, call `useListActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActivitiesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      userIds: // value for 'userIds'
 *      teamIds: // value for 'teamIds'
 *      projectIds: // value for 'projectIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useListActivitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListActivitiesQuery,
    ListActivitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListActivitiesQuery, ListActivitiesQueryVariables>(
    ListActivitiesDocument,
    options
  );
}
export function useListActivitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListActivitiesQuery,
    ListActivitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListActivitiesQuery, ListActivitiesQueryVariables>(
    ListActivitiesDocument,
    options
  );
}
// @ts-ignore
export function useListActivitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListActivitiesQuery,
    ListActivitiesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListActivitiesQuery,
  ListActivitiesQueryVariables
>;
export function useListActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListActivitiesQuery,
        ListActivitiesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListActivitiesQuery | undefined,
  ListActivitiesQueryVariables
>;
export function useListActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListActivitiesQuery,
        ListActivitiesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListActivitiesQuery,
    ListActivitiesQueryVariables
  >(ListActivitiesDocument, options);
}
export type ListActivitiesQueryHookResult = ReturnType<
  typeof useListActivitiesQuery
>;
export type ListActivitiesLazyQueryHookResult = ReturnType<
  typeof useListActivitiesLazyQuery
>;
export type ListActivitiesSuspenseQueryHookResult = ReturnType<
  typeof useListActivitiesSuspenseQuery
>;
export type ListActivitiesQueryResult = Apollo.QueryResult<
  ListActivitiesQuery,
  ListActivitiesQueryVariables
>;
export const ListActivitiesByProjectForNudgeDocument = gql`
  query listActivitiesByProjectForNudge(
    $projectId: ID!
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    listActivitiesByProject(
      projectId: $projectId
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      edges {
        node {
          event
        }
      }
    }
  }
`;

/**
 * __useListActivitiesByProjectForNudgeQuery__
 *
 * To run a query within a React component, call `useListActivitiesByProjectForNudgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActivitiesByProjectForNudgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActivitiesByProjectForNudgeQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useListActivitiesByProjectForNudgeQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListActivitiesByProjectForNudgeQuery,
    ListActivitiesByProjectForNudgeQueryVariables
  > &
    (
      | {
          variables: ListActivitiesByProjectForNudgeQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListActivitiesByProjectForNudgeQuery,
    ListActivitiesByProjectForNudgeQueryVariables
  >(ListActivitiesByProjectForNudgeDocument, options);
}
export function useListActivitiesByProjectForNudgeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListActivitiesByProjectForNudgeQuery,
    ListActivitiesByProjectForNudgeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListActivitiesByProjectForNudgeQuery,
    ListActivitiesByProjectForNudgeQueryVariables
  >(ListActivitiesByProjectForNudgeDocument, options);
}
// @ts-ignore
export function useListActivitiesByProjectForNudgeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListActivitiesByProjectForNudgeQuery,
    ListActivitiesByProjectForNudgeQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListActivitiesByProjectForNudgeQuery,
  ListActivitiesByProjectForNudgeQueryVariables
>;
export function useListActivitiesByProjectForNudgeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListActivitiesByProjectForNudgeQuery,
        ListActivitiesByProjectForNudgeQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListActivitiesByProjectForNudgeQuery | undefined,
  ListActivitiesByProjectForNudgeQueryVariables
>;
export function useListActivitiesByProjectForNudgeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListActivitiesByProjectForNudgeQuery,
        ListActivitiesByProjectForNudgeQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListActivitiesByProjectForNudgeQuery,
    ListActivitiesByProjectForNudgeQueryVariables
  >(ListActivitiesByProjectForNudgeDocument, options);
}
export type ListActivitiesByProjectForNudgeQueryHookResult = ReturnType<
  typeof useListActivitiesByProjectForNudgeQuery
>;
export type ListActivitiesByProjectForNudgeLazyQueryHookResult = ReturnType<
  typeof useListActivitiesByProjectForNudgeLazyQuery
>;
export type ListActivitiesByProjectForNudgeSuspenseQueryHookResult = ReturnType<
  typeof useListActivitiesByProjectForNudgeSuspenseQuery
>;
export type ListActivitiesByProjectForNudgeQueryResult = Apollo.QueryResult<
  ListActivitiesByProjectForNudgeQuery,
  ListActivitiesByProjectForNudgeQueryVariables
>;
export const ListActivitiesByTaskDocument = gql`
  query listActivitiesByTask(
    $taskId: ID!
    $first: Int
    $last: Int
    $after: String
    $before: String
    $term: String
    $startDate: ISO8601DateTime
    $endDate: ISO8601DateTime
    $userIds: [ID!]
  ) {
    listActivitiesByTask(
      taskId: $taskId
      first: $first
      last: $last
      after: $after
      before: $before
      term: $term
      startDate: $startDate
      endDate: $endDate
      userIds: $userIds
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          event
          createdAt
          id
          changes
          user {
            ...UserDetail
          }
          documents {
            ...DocumentDetail
          }
          attachment {
            ... on Document {
              ...DocumentDetail
              projectDocuments {
                id
                project {
                  id
                  uuid
                  name
                }
              }
              taskDocuments {
                id
                task {
                  id
                  name
                  projectId
                  project {
                    id
                    uuid
                    name
                  }
                }
              }
            }
            ... on Message {
              ...MessageDetail
            }
            ... on Task {
              id
              name
              projectId
              deletedAt
              project {
                id
                uuid
                name
              }
              completedAt
              completor {
                avatar {
                  ...AvatarDetail
                }
              }
            }
            ... on Project {
              id
              uuid
              name
            }
            ... on ProjectUser {
              id
              user {
                ...UserDetail
              }
            }
            ... on TaskUser {
              id
              task {
                id
                name
                project {
                  id
                  uuid
                  name
                }
              }
              user {
                ...UserDetail
              }
            }
            ... on EntityUser {
              id
              user {
                ...UserDetail
              }
              entityTask: task {
                id
                name
                deletedAt
                members {
                  id
                  role
                  user {
                    ...UserDetail
                  }
                }
                project {
                  id
                  uuid
                  name
                }
              }
              entityProject: project {
                id
                uuid
                name
              }
            }
          }
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${UserDetailFragmentDoc}
  ${DocumentDetailFragmentDoc}
  ${MessageDetailFragmentDoc}
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useListActivitiesByTaskQuery__
 *
 * To run a query within a React component, call `useListActivitiesByTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActivitiesByTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActivitiesByTaskQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      term: // value for 'term'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useListActivitiesByTaskQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListActivitiesByTaskQuery,
    ListActivitiesByTaskQueryVariables
  > &
    (
      | { variables: ListActivitiesByTaskQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListActivitiesByTaskQuery,
    ListActivitiesByTaskQueryVariables
  >(ListActivitiesByTaskDocument, options);
}
export function useListActivitiesByTaskLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListActivitiesByTaskQuery,
    ListActivitiesByTaskQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListActivitiesByTaskQuery,
    ListActivitiesByTaskQueryVariables
  >(ListActivitiesByTaskDocument, options);
}
// @ts-ignore
export function useListActivitiesByTaskSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListActivitiesByTaskQuery,
    ListActivitiesByTaskQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListActivitiesByTaskQuery,
  ListActivitiesByTaskQueryVariables
>;
export function useListActivitiesByTaskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListActivitiesByTaskQuery,
        ListActivitiesByTaskQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListActivitiesByTaskQuery | undefined,
  ListActivitiesByTaskQueryVariables
>;
export function useListActivitiesByTaskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListActivitiesByTaskQuery,
        ListActivitiesByTaskQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListActivitiesByTaskQuery,
    ListActivitiesByTaskQueryVariables
  >(ListActivitiesByTaskDocument, options);
}
export type ListActivitiesByTaskQueryHookResult = ReturnType<
  typeof useListActivitiesByTaskQuery
>;
export type ListActivitiesByTaskLazyQueryHookResult = ReturnType<
  typeof useListActivitiesByTaskLazyQuery
>;
export type ListActivitiesByTaskSuspenseQueryHookResult = ReturnType<
  typeof useListActivitiesByTaskSuspenseQuery
>;
export type ListActivitiesByTaskQueryResult = Apollo.QueryResult<
  ListActivitiesByTaskQuery,
  ListActivitiesByTaskQueryVariables
>;
export const ListBlockedUsersDocument = gql`
  query listBlockedUsers {
    listBlockedUsers {
      ...UserDetail
    }
  }
  ${UserDetailFragmentDoc}
`;

/**
 * __useListBlockedUsersQuery__
 *
 * To run a query within a React component, call `useListBlockedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBlockedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBlockedUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useListBlockedUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListBlockedUsersQuery,
    ListBlockedUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListBlockedUsersQuery, ListBlockedUsersQueryVariables>(
    ListBlockedUsersDocument,
    options
  );
}
export function useListBlockedUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListBlockedUsersQuery,
    ListBlockedUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListBlockedUsersQuery,
    ListBlockedUsersQueryVariables
  >(ListBlockedUsersDocument, options);
}
// @ts-ignore
export function useListBlockedUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListBlockedUsersQuery,
    ListBlockedUsersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListBlockedUsersQuery,
  ListBlockedUsersQueryVariables
>;
export function useListBlockedUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListBlockedUsersQuery,
        ListBlockedUsersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListBlockedUsersQuery | undefined,
  ListBlockedUsersQueryVariables
>;
export function useListBlockedUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListBlockedUsersQuery,
        ListBlockedUsersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListBlockedUsersQuery,
    ListBlockedUsersQueryVariables
  >(ListBlockedUsersDocument, options);
}
export type ListBlockedUsersQueryHookResult = ReturnType<
  typeof useListBlockedUsersQuery
>;
export type ListBlockedUsersLazyQueryHookResult = ReturnType<
  typeof useListBlockedUsersLazyQuery
>;
export type ListBlockedUsersSuspenseQueryHookResult = ReturnType<
  typeof useListBlockedUsersSuspenseQuery
>;
export type ListBlockedUsersQueryResult = Apollo.QueryResult<
  ListBlockedUsersQuery,
  ListBlockedUsersQueryVariables
>;
export const ListChatPaginationIdentifiersDocument = gql`
  query listChatPaginationIdentifiers($first: Int, $after: String) {
    listChatsPagination(first: $first, after: $after) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          id
          name
          ...ChatDetail
          avatar {
            ...AvatarDetail
          }
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${ChatDetailFragmentDoc}
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useListChatPaginationIdentifiersQuery__
 *
 * To run a query within a React component, call `useListChatPaginationIdentifiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChatPaginationIdentifiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChatPaginationIdentifiersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListChatPaginationIdentifiersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListChatPaginationIdentifiersQuery,
    ListChatPaginationIdentifiersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListChatPaginationIdentifiersQuery,
    ListChatPaginationIdentifiersQueryVariables
  >(ListChatPaginationIdentifiersDocument, options);
}
export function useListChatPaginationIdentifiersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListChatPaginationIdentifiersQuery,
    ListChatPaginationIdentifiersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListChatPaginationIdentifiersQuery,
    ListChatPaginationIdentifiersQueryVariables
  >(ListChatPaginationIdentifiersDocument, options);
}
// @ts-ignore
export function useListChatPaginationIdentifiersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListChatPaginationIdentifiersQuery,
    ListChatPaginationIdentifiersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListChatPaginationIdentifiersQuery,
  ListChatPaginationIdentifiersQueryVariables
>;
export function useListChatPaginationIdentifiersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListChatPaginationIdentifiersQuery,
        ListChatPaginationIdentifiersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListChatPaginationIdentifiersQuery | undefined,
  ListChatPaginationIdentifiersQueryVariables
>;
export function useListChatPaginationIdentifiersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListChatPaginationIdentifiersQuery,
        ListChatPaginationIdentifiersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListChatPaginationIdentifiersQuery,
    ListChatPaginationIdentifiersQueryVariables
  >(ListChatPaginationIdentifiersDocument, options);
}
export type ListChatPaginationIdentifiersQueryHookResult = ReturnType<
  typeof useListChatPaginationIdentifiersQuery
>;
export type ListChatPaginationIdentifiersLazyQueryHookResult = ReturnType<
  typeof useListChatPaginationIdentifiersLazyQuery
>;
export type ListChatPaginationIdentifiersSuspenseQueryHookResult = ReturnType<
  typeof useListChatPaginationIdentifiersSuspenseQuery
>;
export type ListChatPaginationIdentifiersQueryResult = Apollo.QueryResult<
  ListChatPaginationIdentifiersQuery,
  ListChatPaginationIdentifiersQueryVariables
>;
export const ListChatPaginationIdentifiersForwardDocument = gql`
  query listChatPaginationIdentifiersForward($first: Int, $after: String) {
    listChatsPagination(first: $first, after: $after) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          id
          name
          isGroupChat
          avatarUrl
          avatar {
            ...AvatarDetail
          }
          users {
            id
            name
            avatar {
              ...AvatarDetail
            }
          }
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useListChatPaginationIdentifiersForwardQuery__
 *
 * To run a query within a React component, call `useListChatPaginationIdentifiersForwardQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChatPaginationIdentifiersForwardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChatPaginationIdentifiersForwardQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListChatPaginationIdentifiersForwardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListChatPaginationIdentifiersForwardQuery,
    ListChatPaginationIdentifiersForwardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListChatPaginationIdentifiersForwardQuery,
    ListChatPaginationIdentifiersForwardQueryVariables
  >(ListChatPaginationIdentifiersForwardDocument, options);
}
export function useListChatPaginationIdentifiersForwardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListChatPaginationIdentifiersForwardQuery,
    ListChatPaginationIdentifiersForwardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListChatPaginationIdentifiersForwardQuery,
    ListChatPaginationIdentifiersForwardQueryVariables
  >(ListChatPaginationIdentifiersForwardDocument, options);
}
// @ts-ignore
export function useListChatPaginationIdentifiersForwardSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListChatPaginationIdentifiersForwardQuery,
    ListChatPaginationIdentifiersForwardQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListChatPaginationIdentifiersForwardQuery,
  ListChatPaginationIdentifiersForwardQueryVariables
>;
export function useListChatPaginationIdentifiersForwardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListChatPaginationIdentifiersForwardQuery,
        ListChatPaginationIdentifiersForwardQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListChatPaginationIdentifiersForwardQuery | undefined,
  ListChatPaginationIdentifiersForwardQueryVariables
>;
export function useListChatPaginationIdentifiersForwardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListChatPaginationIdentifiersForwardQuery,
        ListChatPaginationIdentifiersForwardQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListChatPaginationIdentifiersForwardQuery,
    ListChatPaginationIdentifiersForwardQueryVariables
  >(ListChatPaginationIdentifiersForwardDocument, options);
}
export type ListChatPaginationIdentifiersForwardQueryHookResult = ReturnType<
  typeof useListChatPaginationIdentifiersForwardQuery
>;
export type ListChatPaginationIdentifiersForwardLazyQueryHookResult =
  ReturnType<typeof useListChatPaginationIdentifiersForwardLazyQuery>;
export type ListChatPaginationIdentifiersForwardSuspenseQueryHookResult =
  ReturnType<typeof useListChatPaginationIdentifiersForwardSuspenseQuery>;
export type ListChatPaginationIdentifiersForwardQueryResult =
  Apollo.QueryResult<
    ListChatPaginationIdentifiersForwardQuery,
    ListChatPaginationIdentifiersForwardQueryVariables
  >;
export const ListChatRelatedProjectsDocument = gql`
  query listChatRelatedProjects($chatId: ID, $first: Int, $after: String) {
    listChatRelatedProjects(chatId: $chatId, first: $first, after: $after) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          id
          name
          currentUserRole
          archivedAt
          tasks {
            id
            name
            status
            priority
            deletedAt
            dueDate
            completedAt
            projectId
            userIds
            currentUserRole
            project {
              id
              uuid
              name
            }
            members {
              id
              role
              user {
                ...UserDetail
              }
            }
          }
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${UserDetailFragmentDoc}
`;

/**
 * __useListChatRelatedProjectsQuery__
 *
 * To run a query within a React component, call `useListChatRelatedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChatRelatedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChatRelatedProjectsQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListChatRelatedProjectsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListChatRelatedProjectsQuery,
    ListChatRelatedProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListChatRelatedProjectsQuery,
    ListChatRelatedProjectsQueryVariables
  >(ListChatRelatedProjectsDocument, options);
}
export function useListChatRelatedProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListChatRelatedProjectsQuery,
    ListChatRelatedProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListChatRelatedProjectsQuery,
    ListChatRelatedProjectsQueryVariables
  >(ListChatRelatedProjectsDocument, options);
}
// @ts-ignore
export function useListChatRelatedProjectsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListChatRelatedProjectsQuery,
    ListChatRelatedProjectsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListChatRelatedProjectsQuery,
  ListChatRelatedProjectsQueryVariables
>;
export function useListChatRelatedProjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListChatRelatedProjectsQuery,
        ListChatRelatedProjectsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListChatRelatedProjectsQuery | undefined,
  ListChatRelatedProjectsQueryVariables
>;
export function useListChatRelatedProjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListChatRelatedProjectsQuery,
        ListChatRelatedProjectsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListChatRelatedProjectsQuery,
    ListChatRelatedProjectsQueryVariables
  >(ListChatRelatedProjectsDocument, options);
}
export type ListChatRelatedProjectsQueryHookResult = ReturnType<
  typeof useListChatRelatedProjectsQuery
>;
export type ListChatRelatedProjectsLazyQueryHookResult = ReturnType<
  typeof useListChatRelatedProjectsLazyQuery
>;
export type ListChatRelatedProjectsSuspenseQueryHookResult = ReturnType<
  typeof useListChatRelatedProjectsSuspenseQuery
>;
export type ListChatRelatedProjectsQueryResult = Apollo.QueryResult<
  ListChatRelatedProjectsQuery,
  ListChatRelatedProjectsQueryVariables
>;
export const ListChatsPaginationDocument = gql`
  query listChatsPagination(
    $archivesOnly: Boolean
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    listChatsPagination(
      archivesOnly: $archivesOnly
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          id
          name
          description
          avatarUrl
          isGroupChat
          messageIcon
          messageBody
          recentActivityAt
          friendRequestAccepted
          unreadCount
          createdAt
          leaveOn
          userIds
          settingsPin
          settingsMute
          canCurrentUserDecide
          isPendingRequest
          settingsArchivedAt
          pendingInvitations {
            email
          }
          ownerId
          ownerName
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
`;

/**
 * __useListChatsPaginationQuery__
 *
 * To run a query within a React component, call `useListChatsPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChatsPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChatsPaginationQuery({
 *   variables: {
 *      archivesOnly: // value for 'archivesOnly'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useListChatsPaginationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListChatsPaginationQuery,
    ListChatsPaginationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListChatsPaginationQuery,
    ListChatsPaginationQueryVariables
  >(ListChatsPaginationDocument, options);
}
export function useListChatsPaginationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListChatsPaginationQuery,
    ListChatsPaginationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListChatsPaginationQuery,
    ListChatsPaginationQueryVariables
  >(ListChatsPaginationDocument, options);
}
// @ts-ignore
export function useListChatsPaginationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListChatsPaginationQuery,
    ListChatsPaginationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListChatsPaginationQuery,
  ListChatsPaginationQueryVariables
>;
export function useListChatsPaginationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListChatsPaginationQuery,
        ListChatsPaginationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListChatsPaginationQuery | undefined,
  ListChatsPaginationQueryVariables
>;
export function useListChatsPaginationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListChatsPaginationQuery,
        ListChatsPaginationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListChatsPaginationQuery,
    ListChatsPaginationQueryVariables
  >(ListChatsPaginationDocument, options);
}
export type ListChatsPaginationQueryHookResult = ReturnType<
  typeof useListChatsPaginationQuery
>;
export type ListChatsPaginationLazyQueryHookResult = ReturnType<
  typeof useListChatsPaginationLazyQuery
>;
export type ListChatsPaginationSuspenseQueryHookResult = ReturnType<
  typeof useListChatsPaginationSuspenseQuery
>;
export type ListChatsPaginationQueryResult = Apollo.QueryResult<
  ListChatsPaginationQuery,
  ListChatsPaginationQueryVariables
>;
export const ListChecklistTemplatesDocument = gql`
  query listChecklistTemplates {
    listChecklistTemplates {
      id
      isFavorited
      favoritedAt
      templateName
      checklistTemplateItems {
        id
        checklistTemplateItemName
      }
    }
  }
`;

/**
 * __useListChecklistTemplatesQuery__
 *
 * To run a query within a React component, call `useListChecklistTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChecklistTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChecklistTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListChecklistTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListChecklistTemplatesQuery,
    ListChecklistTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListChecklistTemplatesQuery,
    ListChecklistTemplatesQueryVariables
  >(ListChecklistTemplatesDocument, options);
}
export function useListChecklistTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListChecklistTemplatesQuery,
    ListChecklistTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListChecklistTemplatesQuery,
    ListChecklistTemplatesQueryVariables
  >(ListChecklistTemplatesDocument, options);
}
// @ts-ignore
export function useListChecklistTemplatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListChecklistTemplatesQuery,
    ListChecklistTemplatesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListChecklistTemplatesQuery,
  ListChecklistTemplatesQueryVariables
>;
export function useListChecklistTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListChecklistTemplatesQuery,
        ListChecklistTemplatesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListChecklistTemplatesQuery | undefined,
  ListChecklistTemplatesQueryVariables
>;
export function useListChecklistTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListChecklistTemplatesQuery,
        ListChecklistTemplatesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListChecklistTemplatesQuery,
    ListChecklistTemplatesQueryVariables
  >(ListChecklistTemplatesDocument, options);
}
export type ListChecklistTemplatesQueryHookResult = ReturnType<
  typeof useListChecklistTemplatesQuery
>;
export type ListChecklistTemplatesLazyQueryHookResult = ReturnType<
  typeof useListChecklistTemplatesLazyQuery
>;
export type ListChecklistTemplatesSuspenseQueryHookResult = ReturnType<
  typeof useListChecklistTemplatesSuspenseQuery
>;
export type ListChecklistTemplatesQueryResult = Apollo.QueryResult<
  ListChecklistTemplatesQuery,
  ListChecklistTemplatesQueryVariables
>;
export const ListChecklistTemplatesNoItemsDocument = gql`
  query listChecklistTemplatesNoItems {
    listChecklistTemplates {
      id
      templateName
      isFavorited
      favoritedAt
      owner {
        id
      }
    }
  }
`;

/**
 * __useListChecklistTemplatesNoItemsQuery__
 *
 * To run a query within a React component, call `useListChecklistTemplatesNoItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChecklistTemplatesNoItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChecklistTemplatesNoItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListChecklistTemplatesNoItemsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListChecklistTemplatesNoItemsQuery,
    ListChecklistTemplatesNoItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListChecklistTemplatesNoItemsQuery,
    ListChecklistTemplatesNoItemsQueryVariables
  >(ListChecklistTemplatesNoItemsDocument, options);
}
export function useListChecklistTemplatesNoItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListChecklistTemplatesNoItemsQuery,
    ListChecklistTemplatesNoItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListChecklistTemplatesNoItemsQuery,
    ListChecklistTemplatesNoItemsQueryVariables
  >(ListChecklistTemplatesNoItemsDocument, options);
}
// @ts-ignore
export function useListChecklistTemplatesNoItemsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListChecklistTemplatesNoItemsQuery,
    ListChecklistTemplatesNoItemsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListChecklistTemplatesNoItemsQuery,
  ListChecklistTemplatesNoItemsQueryVariables
>;
export function useListChecklistTemplatesNoItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListChecklistTemplatesNoItemsQuery,
        ListChecklistTemplatesNoItemsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListChecklistTemplatesNoItemsQuery | undefined,
  ListChecklistTemplatesNoItemsQueryVariables
>;
export function useListChecklistTemplatesNoItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListChecklistTemplatesNoItemsQuery,
        ListChecklistTemplatesNoItemsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListChecklistTemplatesNoItemsQuery,
    ListChecklistTemplatesNoItemsQueryVariables
  >(ListChecklistTemplatesNoItemsDocument, options);
}
export type ListChecklistTemplatesNoItemsQueryHookResult = ReturnType<
  typeof useListChecklistTemplatesNoItemsQuery
>;
export type ListChecklistTemplatesNoItemsLazyQueryHookResult = ReturnType<
  typeof useListChecklistTemplatesNoItemsLazyQuery
>;
export type ListChecklistTemplatesNoItemsSuspenseQueryHookResult = ReturnType<
  typeof useListChecklistTemplatesNoItemsSuspenseQuery
>;
export type ListChecklistTemplatesNoItemsQueryResult = Apollo.QueryResult<
  ListChecklistTemplatesNoItemsQuery,
  ListChecklistTemplatesNoItemsQueryVariables
>;
export const ListContactUsersDocument = gql`
  query listContactUsers($term: String!) {
    listContactUsers(term: $term) {
      ...UserDetail
    }
  }
  ${UserDetailFragmentDoc}
`;

/**
 * __useListContactUsersQuery__
 *
 * To run a query within a React component, call `useListContactUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContactUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContactUsersQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useListContactUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListContactUsersQuery,
    ListContactUsersQueryVariables
  > &
    (
      | { variables: ListContactUsersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListContactUsersQuery, ListContactUsersQueryVariables>(
    ListContactUsersDocument,
    options
  );
}
export function useListContactUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListContactUsersQuery,
    ListContactUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListContactUsersQuery,
    ListContactUsersQueryVariables
  >(ListContactUsersDocument, options);
}
// @ts-ignore
export function useListContactUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListContactUsersQuery,
    ListContactUsersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListContactUsersQuery,
  ListContactUsersQueryVariables
>;
export function useListContactUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListContactUsersQuery,
        ListContactUsersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListContactUsersQuery | undefined,
  ListContactUsersQueryVariables
>;
export function useListContactUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListContactUsersQuery,
        ListContactUsersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListContactUsersQuery,
    ListContactUsersQueryVariables
  >(ListContactUsersDocument, options);
}
export type ListContactUsersQueryHookResult = ReturnType<
  typeof useListContactUsersQuery
>;
export type ListContactUsersLazyQueryHookResult = ReturnType<
  typeof useListContactUsersLazyQuery
>;
export type ListContactUsersSuspenseQueryHookResult = ReturnType<
  typeof useListContactUsersSuspenseQuery
>;
export type ListContactUsersQueryResult = Apollo.QueryResult<
  ListContactUsersQuery,
  ListContactUsersQueryVariables
>;
export const ListDeletedMessageIdsDocument = gql`
  query listDeletedMessageIds($chatId: ID!) {
    listDeletedMessageIds(chatId: $chatId)
  }
`;

/**
 * __useListDeletedMessageIdsQuery__
 *
 * To run a query within a React component, call `useListDeletedMessageIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDeletedMessageIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDeletedMessageIdsQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useListDeletedMessageIdsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListDeletedMessageIdsQuery,
    ListDeletedMessageIdsQueryVariables
  > &
    (
      | { variables: ListDeletedMessageIdsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListDeletedMessageIdsQuery,
    ListDeletedMessageIdsQueryVariables
  >(ListDeletedMessageIdsDocument, options);
}
export function useListDeletedMessageIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListDeletedMessageIdsQuery,
    ListDeletedMessageIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListDeletedMessageIdsQuery,
    ListDeletedMessageIdsQueryVariables
  >(ListDeletedMessageIdsDocument, options);
}
// @ts-ignore
export function useListDeletedMessageIdsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListDeletedMessageIdsQuery,
    ListDeletedMessageIdsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListDeletedMessageIdsQuery,
  ListDeletedMessageIdsQueryVariables
>;
export function useListDeletedMessageIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDeletedMessageIdsQuery,
        ListDeletedMessageIdsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListDeletedMessageIdsQuery | undefined,
  ListDeletedMessageIdsQueryVariables
>;
export function useListDeletedMessageIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDeletedMessageIdsQuery,
        ListDeletedMessageIdsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListDeletedMessageIdsQuery,
    ListDeletedMessageIdsQueryVariables
  >(ListDeletedMessageIdsDocument, options);
}
export type ListDeletedMessageIdsQueryHookResult = ReturnType<
  typeof useListDeletedMessageIdsQuery
>;
export type ListDeletedMessageIdsLazyQueryHookResult = ReturnType<
  typeof useListDeletedMessageIdsLazyQuery
>;
export type ListDeletedMessageIdsSuspenseQueryHookResult = ReturnType<
  typeof useListDeletedMessageIdsSuspenseQuery
>;
export type ListDeletedMessageIdsQueryResult = Apollo.QueryResult<
  ListDeletedMessageIdsQuery,
  ListDeletedMessageIdsQueryVariables
>;
export const ListDraftDocumentsDocument = gql`
  query ListDraftDocuments($chatId: ID!) {
    listDraftDocuments(chatId: $chatId) {
      ...DocumentDetail
      messageClientId
      messageCreateYn
      blobId
      file {
        id
        url
      }
    }
  }
  ${DocumentDetailFragmentDoc}
`;

/**
 * __useListDraftDocumentsQuery__
 *
 * To run a query within a React component, call `useListDraftDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDraftDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDraftDocumentsQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useListDraftDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListDraftDocumentsQuery,
    ListDraftDocumentsQueryVariables
  > &
    (
      | { variables: ListDraftDocumentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListDraftDocumentsQuery,
    ListDraftDocumentsQueryVariables
  >(ListDraftDocumentsDocument, options);
}
export function useListDraftDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListDraftDocumentsQuery,
    ListDraftDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListDraftDocumentsQuery,
    ListDraftDocumentsQueryVariables
  >(ListDraftDocumentsDocument, options);
}
// @ts-ignore
export function useListDraftDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListDraftDocumentsQuery,
    ListDraftDocumentsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListDraftDocumentsQuery,
  ListDraftDocumentsQueryVariables
>;
export function useListDraftDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDraftDocumentsQuery,
        ListDraftDocumentsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListDraftDocumentsQuery | undefined,
  ListDraftDocumentsQueryVariables
>;
export function useListDraftDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDraftDocumentsQuery,
        ListDraftDocumentsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListDraftDocumentsQuery,
    ListDraftDocumentsQueryVariables
  >(ListDraftDocumentsDocument, options);
}
export type ListDraftDocumentsQueryHookResult = ReturnType<
  typeof useListDraftDocumentsQuery
>;
export type ListDraftDocumentsLazyQueryHookResult = ReturnType<
  typeof useListDraftDocumentsLazyQuery
>;
export type ListDraftDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useListDraftDocumentsSuspenseQuery
>;
export type ListDraftDocumentsQueryResult = Apollo.QueryResult<
  ListDraftDocumentsQuery,
  ListDraftDocumentsQueryVariables
>;
export const ListDraftMessagesDocument = gql`
  query listDraftMessages {
    listDraftMessages @client {
      id
      chatId
      clientId
      body
      createdAt
      isSender
      isDraft
      publishedAt
      failedAt @client
      isRetry @client
      authorId
      authorAvatarId
      authorName
      authorFirstName
      authorLastName
      authorEmail
      chat {
        ...ChatDetail
      }
      checkin {
        ...checkinDetail
      }
      replyId
      replyMessage {
        id
        chatId
        clientId
        body
        createdAt
        isSender
        isDraft
        publishedAt
        authorId
        authorAvatarId
        authorName
        authorFirstName
        authorLastName
        authorEmail
      }
      attachments {
        ... on MessageTask {
          author {
            id
            name
          }
          task {
            id
            name
            projectId
          }
        }
        ... on MessageProject {
          author {
            id
            name
          }
          project {
            id
            uuid
            name
          }
        }
        ... on Document {
          id
          blobId
          clientId
          name
          contentType
          isImage
          size
          isAudio
          duration
          file {
            id
            url
            cdnBaseUrl
            path
            isPreviewable
            thumbnail
          }
        }
      }
    }
  }
  ${ChatDetailFragmentDoc}
  ${CheckinDetailFragmentDoc}
`;

/**
 * __useListDraftMessagesQuery__
 *
 * To run a query within a React component, call `useListDraftMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDraftMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDraftMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListDraftMessagesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListDraftMessagesQuery,
    ListDraftMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListDraftMessagesQuery,
    ListDraftMessagesQueryVariables
  >(ListDraftMessagesDocument, options);
}
export function useListDraftMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListDraftMessagesQuery,
    ListDraftMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListDraftMessagesQuery,
    ListDraftMessagesQueryVariables
  >(ListDraftMessagesDocument, options);
}
// @ts-ignore
export function useListDraftMessagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListDraftMessagesQuery,
    ListDraftMessagesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListDraftMessagesQuery,
  ListDraftMessagesQueryVariables
>;
export function useListDraftMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDraftMessagesQuery,
        ListDraftMessagesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListDraftMessagesQuery | undefined,
  ListDraftMessagesQueryVariables
>;
export function useListDraftMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDraftMessagesQuery,
        ListDraftMessagesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListDraftMessagesQuery,
    ListDraftMessagesQueryVariables
  >(ListDraftMessagesDocument, options);
}
export type ListDraftMessagesQueryHookResult = ReturnType<
  typeof useListDraftMessagesQuery
>;
export type ListDraftMessagesLazyQueryHookResult = ReturnType<
  typeof useListDraftMessagesLazyQuery
>;
export type ListDraftMessagesSuspenseQueryHookResult = ReturnType<
  typeof useListDraftMessagesSuspenseQuery
>;
export type ListDraftMessagesQueryResult = Apollo.QueryResult<
  ListDraftMessagesQuery,
  ListDraftMessagesQueryVariables
>;
export const ListDraftProjectDocumentsDocument = gql`
  query listDraftProjectDocuments($projectId: ID!) {
    listDraftProjectDocuments(projectId: $projectId) {
      ...LocalDocumentDetail
    }
  }
  ${LocalDocumentDetailFragmentDoc}
`;

/**
 * __useListDraftProjectDocumentsQuery__
 *
 * To run a query within a React component, call `useListDraftProjectDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDraftProjectDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDraftProjectDocumentsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListDraftProjectDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListDraftProjectDocumentsQuery,
    ListDraftProjectDocumentsQueryVariables
  > &
    (
      | { variables: ListDraftProjectDocumentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListDraftProjectDocumentsQuery,
    ListDraftProjectDocumentsQueryVariables
  >(ListDraftProjectDocumentsDocument, options);
}
export function useListDraftProjectDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListDraftProjectDocumentsQuery,
    ListDraftProjectDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListDraftProjectDocumentsQuery,
    ListDraftProjectDocumentsQueryVariables
  >(ListDraftProjectDocumentsDocument, options);
}
// @ts-ignore
export function useListDraftProjectDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListDraftProjectDocumentsQuery,
    ListDraftProjectDocumentsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListDraftProjectDocumentsQuery,
  ListDraftProjectDocumentsQueryVariables
>;
export function useListDraftProjectDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDraftProjectDocumentsQuery,
        ListDraftProjectDocumentsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListDraftProjectDocumentsQuery | undefined,
  ListDraftProjectDocumentsQueryVariables
>;
export function useListDraftProjectDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDraftProjectDocumentsQuery,
        ListDraftProjectDocumentsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListDraftProjectDocumentsQuery,
    ListDraftProjectDocumentsQueryVariables
  >(ListDraftProjectDocumentsDocument, options);
}
export type ListDraftProjectDocumentsQueryHookResult = ReturnType<
  typeof useListDraftProjectDocumentsQuery
>;
export type ListDraftProjectDocumentsLazyQueryHookResult = ReturnType<
  typeof useListDraftProjectDocumentsLazyQuery
>;
export type ListDraftProjectDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useListDraftProjectDocumentsSuspenseQuery
>;
export type ListDraftProjectDocumentsQueryResult = Apollo.QueryResult<
  ListDraftProjectDocumentsQuery,
  ListDraftProjectDocumentsQueryVariables
>;
export const ListDraftTaskDocumentsDocument = gql`
  query listDraftTaskDocuments($taskId: ID!) {
    listDraftTaskDocuments(taskId: $taskId) {
      ...LocalDocumentDetail
    }
  }
  ${LocalDocumentDetailFragmentDoc}
`;

/**
 * __useListDraftTaskDocumentsQuery__
 *
 * To run a query within a React component, call `useListDraftTaskDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDraftTaskDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDraftTaskDocumentsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useListDraftTaskDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListDraftTaskDocumentsQuery,
    ListDraftTaskDocumentsQueryVariables
  > &
    (
      | { variables: ListDraftTaskDocumentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListDraftTaskDocumentsQuery,
    ListDraftTaskDocumentsQueryVariables
  >(ListDraftTaskDocumentsDocument, options);
}
export function useListDraftTaskDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListDraftTaskDocumentsQuery,
    ListDraftTaskDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListDraftTaskDocumentsQuery,
    ListDraftTaskDocumentsQueryVariables
  >(ListDraftTaskDocumentsDocument, options);
}
// @ts-ignore
export function useListDraftTaskDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListDraftTaskDocumentsQuery,
    ListDraftTaskDocumentsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListDraftTaskDocumentsQuery,
  ListDraftTaskDocumentsQueryVariables
>;
export function useListDraftTaskDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDraftTaskDocumentsQuery,
        ListDraftTaskDocumentsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListDraftTaskDocumentsQuery | undefined,
  ListDraftTaskDocumentsQueryVariables
>;
export function useListDraftTaskDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListDraftTaskDocumentsQuery,
        ListDraftTaskDocumentsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListDraftTaskDocumentsQuery,
    ListDraftTaskDocumentsQueryVariables
  >(ListDraftTaskDocumentsDocument, options);
}
export type ListDraftTaskDocumentsQueryHookResult = ReturnType<
  typeof useListDraftTaskDocumentsQuery
>;
export type ListDraftTaskDocumentsLazyQueryHookResult = ReturnType<
  typeof useListDraftTaskDocumentsLazyQuery
>;
export type ListDraftTaskDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useListDraftTaskDocumentsSuspenseQuery
>;
export type ListDraftTaskDocumentsQueryResult = Apollo.QueryResult<
  ListDraftTaskDocumentsQuery,
  ListDraftTaskDocumentsQueryVariables
>;
export const ListFeatureFlagsDocument = gql`
  query listFeatureFlags {
    listFeatureFlags {
      name
      enabled
    }
  }
`;

/**
 * __useListFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useListFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListFeatureFlagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListFeatureFlagsQuery,
    ListFeatureFlagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListFeatureFlagsQuery, ListFeatureFlagsQueryVariables>(
    ListFeatureFlagsDocument,
    options
  );
}
export function useListFeatureFlagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListFeatureFlagsQuery,
    ListFeatureFlagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListFeatureFlagsQuery,
    ListFeatureFlagsQueryVariables
  >(ListFeatureFlagsDocument, options);
}
// @ts-ignore
export function useListFeatureFlagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListFeatureFlagsQuery,
    ListFeatureFlagsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListFeatureFlagsQuery,
  ListFeatureFlagsQueryVariables
>;
export function useListFeatureFlagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListFeatureFlagsQuery,
        ListFeatureFlagsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListFeatureFlagsQuery | undefined,
  ListFeatureFlagsQueryVariables
>;
export function useListFeatureFlagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListFeatureFlagsQuery,
        ListFeatureFlagsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListFeatureFlagsQuery,
    ListFeatureFlagsQueryVariables
  >(ListFeatureFlagsDocument, options);
}
export type ListFeatureFlagsQueryHookResult = ReturnType<
  typeof useListFeatureFlagsQuery
>;
export type ListFeatureFlagsLazyQueryHookResult = ReturnType<
  typeof useListFeatureFlagsLazyQuery
>;
export type ListFeatureFlagsSuspenseQueryHookResult = ReturnType<
  typeof useListFeatureFlagsSuspenseQuery
>;
export type ListFeatureFlagsQueryResult = Apollo.QueryResult<
  ListFeatureFlagsQuery,
  ListFeatureFlagsQueryVariables
>;
export const ListGroupsDocument = gql`
  query listGroups {
    listGroups {
      id
      name
      currentUserTeamRole
      team {
        id
        avatar
        name
        personal
        avatarFile {
          ...AvatarDetail
        }
      }
      users {
        id
        name
        avatar {
          ...AvatarDetail
        }
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useListGroupsQuery__
 *
 * To run a query within a React component, call `useListGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListGroupsQuery,
    ListGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListGroupsQuery, ListGroupsQueryVariables>(
    ListGroupsDocument,
    options
  );
}
export function useListGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListGroupsQuery,
    ListGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListGroupsQuery, ListGroupsQueryVariables>(
    ListGroupsDocument,
    options
  );
}
// @ts-ignore
export function useListGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListGroupsQuery,
    ListGroupsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ListGroupsQuery, ListGroupsQueryVariables>;
export function useListGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  ListGroupsQuery | undefined,
  ListGroupsQueryVariables
>;
export function useListGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListGroupsQuery, ListGroupsQueryVariables>(
    ListGroupsDocument,
    options
  );
}
export type ListGroupsQueryHookResult = ReturnType<typeof useListGroupsQuery>;
export type ListGroupsLazyQueryHookResult = ReturnType<
  typeof useListGroupsLazyQuery
>;
export type ListGroupsSuspenseQueryHookResult = ReturnType<
  typeof useListGroupsSuspenseQuery
>;
export type ListGroupsQueryResult = Apollo.QueryResult<
  ListGroupsQuery,
  ListGroupsQueryVariables
>;
export const ListMessagesDocument = gql`
  query listMessages(
    $chatId: ID!
    $includeDraft: Boolean
    $includePublished: Boolean
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    listMessages(
      chatId: $chatId
      includeDraft: $includeDraft
      includePublished: $includePublished
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          ...MessageDetailForQuery
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${MessageDetailForQueryFragmentDoc}
`;

/**
 * __useListMessagesQuery__
 *
 * To run a query within a React component, call `useListMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMessagesQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      includeDraft: // value for 'includeDraft'
 *      includePublished: // value for 'includePublished'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useListMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListMessagesQuery,
    ListMessagesQueryVariables
  > &
    (
      | { variables: ListMessagesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListMessagesQuery, ListMessagesQueryVariables>(
    ListMessagesDocument,
    options
  );
}
export function useListMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListMessagesQuery,
    ListMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListMessagesQuery, ListMessagesQueryVariables>(
    ListMessagesDocument,
    options
  );
}
// @ts-ignore
export function useListMessagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListMessagesQuery,
    ListMessagesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ListMessagesQuery, ListMessagesQueryVariables>;
export function useListMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListMessagesQuery,
        ListMessagesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListMessagesQuery | undefined,
  ListMessagesQueryVariables
>;
export function useListMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListMessagesQuery,
        ListMessagesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListMessagesQuery, ListMessagesQueryVariables>(
    ListMessagesDocument,
    options
  );
}
export type ListMessagesQueryHookResult = ReturnType<
  typeof useListMessagesQuery
>;
export type ListMessagesLazyQueryHookResult = ReturnType<
  typeof useListMessagesLazyQuery
>;
export type ListMessagesSuspenseQueryHookResult = ReturnType<
  typeof useListMessagesSuspenseQuery
>;
export type ListMessagesQueryResult = Apollo.QueryResult<
  ListMessagesQuery,
  ListMessagesQueryVariables
>;
export const ListMyTasksProjectGroupsDocument = gql`
  query listMyTasksProjectGroups(
    $userId: ID
    $teamIds: [ID!]
    $projectIds: [ID!]
    $memberIds: [ID!]
    $groupBy: TaskGroupBy
    $sortBy: TaskSortOption
    $status: TaskStatus
    $priority: [TaskPriority!]
    $dueDateBegin: ISO8601DateTime
    $dueDateEnd: ISO8601DateTime
    $dueGroup: TaskGroup
    $requireDueDate: Boolean
    $excludeCompleted: Boolean
    $taskCollaborators: Boolean
    $collaboratorsOnly: Boolean
    $withoutPhase: Boolean
    $phaseId: ID
    $first: Int
    $after: String
    $tasksAfter: String
    $completedTasksAfter: String
  ) {
    listMyTasksProjectGroups(
      userId: $userId
      teamIds: $teamIds
      projectIds: $projectIds
      memberIds: $memberIds
      groupBy: $groupBy
      sortBy: $sortBy
      status: $status
      priority: $priority
      dueDateBegin: $dueDateBegin
      dueDateEnd: $dueDateEnd
      dueGroup: $dueGroup
      requireDueDate: $requireDueDate
      excludeCompleted: $excludeCompleted
      taskCollaborators: $taskCollaborators
      collaboratorsOnly: $collaboratorsOnly
      withoutPhase: $withoutPhase
      phaseId: $phaseId
      first: $first
      after: $after
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          taskCount
          completedCount
          tasks(first: 100, after: $tasksAfter) {
            pageInfo {
              ...PageInfo
            }
            edges {
              node {
                ...MyTasksGroupTask
              }
            }
          }
          completedTasks(first: 100, after: $completedTasksAfter) {
            pageInfo {
              ...PageInfo
            }
            edges {
              node {
                ...MyTasksGroupTask
              }
            }
          }
          ... on ProjectTaskGroup {
            taskCount
            completedCount
            project {
              id
              name
            }
          }
          ... on PriorityTaskGroup {
            taskCount
            completedCount
            priority
          }
          ... on AssigneeTaskGroup {
            taskCount
            completedCount
            assignee {
              ...UserDetail
            }
          }
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${MyTasksGroupTaskFragmentDoc}
  ${UserDetailFragmentDoc}
`;

/**
 * __useListMyTasksProjectGroupsQuery__
 *
 * To run a query within a React component, call `useListMyTasksProjectGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMyTasksProjectGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMyTasksProjectGroupsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      teamIds: // value for 'teamIds'
 *      projectIds: // value for 'projectIds'
 *      memberIds: // value for 'memberIds'
 *      groupBy: // value for 'groupBy'
 *      sortBy: // value for 'sortBy'
 *      status: // value for 'status'
 *      priority: // value for 'priority'
 *      dueDateBegin: // value for 'dueDateBegin'
 *      dueDateEnd: // value for 'dueDateEnd'
 *      dueGroup: // value for 'dueGroup'
 *      requireDueDate: // value for 'requireDueDate'
 *      excludeCompleted: // value for 'excludeCompleted'
 *      taskCollaborators: // value for 'taskCollaborators'
 *      collaboratorsOnly: // value for 'collaboratorsOnly'
 *      withoutPhase: // value for 'withoutPhase'
 *      phaseId: // value for 'phaseId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      tasksAfter: // value for 'tasksAfter'
 *      completedTasksAfter: // value for 'completedTasksAfter'
 *   },
 * });
 */
export function useListMyTasksProjectGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListMyTasksProjectGroupsQuery,
    ListMyTasksProjectGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListMyTasksProjectGroupsQuery,
    ListMyTasksProjectGroupsQueryVariables
  >(ListMyTasksProjectGroupsDocument, options);
}
export function useListMyTasksProjectGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListMyTasksProjectGroupsQuery,
    ListMyTasksProjectGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListMyTasksProjectGroupsQuery,
    ListMyTasksProjectGroupsQueryVariables
  >(ListMyTasksProjectGroupsDocument, options);
}
// @ts-ignore
export function useListMyTasksProjectGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListMyTasksProjectGroupsQuery,
    ListMyTasksProjectGroupsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListMyTasksProjectGroupsQuery,
  ListMyTasksProjectGroupsQueryVariables
>;
export function useListMyTasksProjectGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListMyTasksProjectGroupsQuery,
        ListMyTasksProjectGroupsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListMyTasksProjectGroupsQuery | undefined,
  ListMyTasksProjectGroupsQueryVariables
>;
export function useListMyTasksProjectGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListMyTasksProjectGroupsQuery,
        ListMyTasksProjectGroupsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListMyTasksProjectGroupsQuery,
    ListMyTasksProjectGroupsQueryVariables
  >(ListMyTasksProjectGroupsDocument, options);
}
export type ListMyTasksProjectGroupsQueryHookResult = ReturnType<
  typeof useListMyTasksProjectGroupsQuery
>;
export type ListMyTasksProjectGroupsLazyQueryHookResult = ReturnType<
  typeof useListMyTasksProjectGroupsLazyQuery
>;
export type ListMyTasksProjectGroupsSuspenseQueryHookResult = ReturnType<
  typeof useListMyTasksProjectGroupsSuspenseQuery
>;
export type ListMyTasksProjectGroupsQueryResult = Apollo.QueryResult<
  ListMyTasksProjectGroupsQuery,
  ListMyTasksProjectGroupsQueryVariables
>;
export const ListNearbyMessagesDocument = gql`
  query listNearbyMessages($messageId: ID!, $nearbyCount: Int) {
    listNearbyMessages(messageId: $messageId, nearbyCount: $nearbyCount) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          ...MessageDetailForQuery
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${MessageDetailForQueryFragmentDoc}
`;

/**
 * __useListNearbyMessagesQuery__
 *
 * To run a query within a React component, call `useListNearbyMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNearbyMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNearbyMessagesQuery({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      nearbyCount: // value for 'nearbyCount'
 *   },
 * });
 */
export function useListNearbyMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListNearbyMessagesQuery,
    ListNearbyMessagesQueryVariables
  > &
    (
      | { variables: ListNearbyMessagesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListNearbyMessagesQuery,
    ListNearbyMessagesQueryVariables
  >(ListNearbyMessagesDocument, options);
}
export function useListNearbyMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListNearbyMessagesQuery,
    ListNearbyMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListNearbyMessagesQuery,
    ListNearbyMessagesQueryVariables
  >(ListNearbyMessagesDocument, options);
}
// @ts-ignore
export function useListNearbyMessagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListNearbyMessagesQuery,
    ListNearbyMessagesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListNearbyMessagesQuery,
  ListNearbyMessagesQueryVariables
>;
export function useListNearbyMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListNearbyMessagesQuery,
        ListNearbyMessagesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListNearbyMessagesQuery | undefined,
  ListNearbyMessagesQueryVariables
>;
export function useListNearbyMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListNearbyMessagesQuery,
        ListNearbyMessagesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListNearbyMessagesQuery,
    ListNearbyMessagesQueryVariables
  >(ListNearbyMessagesDocument, options);
}
export type ListNearbyMessagesQueryHookResult = ReturnType<
  typeof useListNearbyMessagesQuery
>;
export type ListNearbyMessagesLazyQueryHookResult = ReturnType<
  typeof useListNearbyMessagesLazyQuery
>;
export type ListNearbyMessagesSuspenseQueryHookResult = ReturnType<
  typeof useListNearbyMessagesSuspenseQuery
>;
export type ListNearbyMessagesQueryResult = Apollo.QueryResult<
  ListNearbyMessagesQuery,
  ListNearbyMessagesQueryVariables
>;
export const ListPendingUserRequestsDocument = gql`
  query listPendingUserRequests($attributes: UserRequestAttributes!) {
    listPendingUserRequests(attributes: $attributes) {
      id
      requestType
      status
      canCurrentUserDecide
      createdAt
      expiredAt
      invitedBy {
        id
        name
        email
        phoneNumber
        avatar {
          ...AvatarDetail
        }
      }
      role
      user {
        id
        name
        email
        phoneNumber
        avatar {
          ...AvatarDetail
        }
        skills {
          id
          name
          createdAt
        }
      }
      userRequestableId
      userRequestableType
    }
  }
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useListPendingUserRequestsQuery__
 *
 * To run a query within a React component, call `useListPendingUserRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPendingUserRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPendingUserRequestsQuery({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useListPendingUserRequestsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListPendingUserRequestsQuery,
    ListPendingUserRequestsQueryVariables
  > &
    (
      | { variables: ListPendingUserRequestsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListPendingUserRequestsQuery,
    ListPendingUserRequestsQueryVariables
  >(ListPendingUserRequestsDocument, options);
}
export function useListPendingUserRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListPendingUserRequestsQuery,
    ListPendingUserRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListPendingUserRequestsQuery,
    ListPendingUserRequestsQueryVariables
  >(ListPendingUserRequestsDocument, options);
}
// @ts-ignore
export function useListPendingUserRequestsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListPendingUserRequestsQuery,
    ListPendingUserRequestsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListPendingUserRequestsQuery,
  ListPendingUserRequestsQueryVariables
>;
export function useListPendingUserRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPendingUserRequestsQuery,
        ListPendingUserRequestsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListPendingUserRequestsQuery | undefined,
  ListPendingUserRequestsQueryVariables
>;
export function useListPendingUserRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPendingUserRequestsQuery,
        ListPendingUserRequestsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListPendingUserRequestsQuery,
    ListPendingUserRequestsQueryVariables
  >(ListPendingUserRequestsDocument, options);
}
export type ListPendingUserRequestsQueryHookResult = ReturnType<
  typeof useListPendingUserRequestsQuery
>;
export type ListPendingUserRequestsLazyQueryHookResult = ReturnType<
  typeof useListPendingUserRequestsLazyQuery
>;
export type ListPendingUserRequestsSuspenseQueryHookResult = ReturnType<
  typeof useListPendingUserRequestsSuspenseQuery
>;
export type ListPendingUserRequestsQueryResult = Apollo.QueryResult<
  ListPendingUserRequestsQuery,
  ListPendingUserRequestsQueryVariables
>;
export const ListProductsDocument = gql`
  query listProducts {
    listProducts {
      id
      name
      allowMembers
      features
      prices {
        id
        amount
        externalId
        interval
        intervalCount
        externalId
      }
    }
  }
`;

/**
 * __useListProductsQuery__
 *
 * To run a query within a React component, call `useListProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListProductsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListProductsQuery,
    ListProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListProductsQuery, ListProductsQueryVariables>(
    ListProductsDocument,
    options
  );
}
export function useListProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProductsQuery,
    ListProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListProductsQuery, ListProductsQueryVariables>(
    ListProductsDocument,
    options
  );
}
// @ts-ignore
export function useListProductsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProductsQuery,
    ListProductsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ListProductsQuery, ListProductsQueryVariables>;
export function useListProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProductsQuery,
        ListProductsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListProductsQuery | undefined,
  ListProductsQueryVariables
>;
export function useListProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProductsQuery,
        ListProductsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListProductsQuery, ListProductsQueryVariables>(
    ListProductsDocument,
    options
  );
}
export type ListProductsQueryHookResult = ReturnType<
  typeof useListProductsQuery
>;
export type ListProductsLazyQueryHookResult = ReturnType<
  typeof useListProductsLazyQuery
>;
export type ListProductsSuspenseQueryHookResult = ReturnType<
  typeof useListProductsSuspenseQuery
>;
export type ListProductsQueryResult = Apollo.QueryResult<
  ListProductsQuery,
  ListProductsQueryVariables
>;
export const ListProjectActivityFeedDocument = gql`
  query listProjectActivityFeed(
    $projectId: ID!
    $first: Int
    $last: Int
    $after: String
    $before: String
    $term: String
    $userIds: [ID!]
    $startDate: ISO8601DateTime
    $endDate: ISO8601DateTime
  ) {
    listActivitiesByProject(
      projectId: $projectId
      first: $first
      last: $last
      after: $after
      before: $before
      term: $term
      userIds: $userIds
      startDate: $startDate
      endDate: $endDate
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          event
          createdAt
          id
          changes
          user {
            ...UserDetail
          }
          projectRole
          documents {
            ...DocumentDetail
          }
          attachment {
            ... on Document {
              ...DocumentDetail
              projectDocuments {
                id
                project {
                  id
                  uuid
                  name
                }
              }
              taskDocuments {
                id
                task {
                  id
                  name
                  projectId
                  deletedAt
                  project {
                    id
                    uuid
                    name
                  }
                }
              }
            }
            ... on UserRequest {
              id
              status
              userRequestableId
              userRequestableType
              user {
                id
                name
              }
            }
            ... on Message {
              ...MessageDetail
            }
            ... on Task {
              id
              name
              projectId
              deletedAt
              project {
                id
                uuid
                name
              }
            }
            ... on Project {
              id
              uuid
              name
            }
            ... on ProjectUser {
              id
              user {
                ...UserDetail
              }
            }
            ... on TaskUser {
              id
              task {
                id
                name
                deletedAt
                project {
                  id
                  uuid
                  name
                }
              }
              user {
                ...UserDetail
              }
            }
            ... on EntityUser {
              id
              user {
                ...UserDetail
              }
              entityTask: task {
                id
                name
                deletedAt
                members {
                  id
                  role
                  user {
                    ...UserDetail
                    avatar {
                      ...AvatarDetail
                    }
                  }
                }
                project {
                  id
                  uuid
                  name
                }
              }
              entityProject: project {
                id
                uuid
                name
              }
            }
          }
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${UserDetailFragmentDoc}
  ${DocumentDetailFragmentDoc}
  ${MessageDetailFragmentDoc}
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useListProjectActivityFeedQuery__
 *
 * To run a query within a React component, call `useListProjectActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectActivityFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectActivityFeedQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      term: // value for 'term'
 *      userIds: // value for 'userIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useListProjectActivityFeedQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListProjectActivityFeedQuery,
    ListProjectActivityFeedQueryVariables
  > &
    (
      | { variables: ListProjectActivityFeedQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListProjectActivityFeedQuery,
    ListProjectActivityFeedQueryVariables
  >(ListProjectActivityFeedDocument, options);
}
export function useListProjectActivityFeedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProjectActivityFeedQuery,
    ListProjectActivityFeedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListProjectActivityFeedQuery,
    ListProjectActivityFeedQueryVariables
  >(ListProjectActivityFeedDocument, options);
}
// @ts-ignore
export function useListProjectActivityFeedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProjectActivityFeedQuery,
    ListProjectActivityFeedQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListProjectActivityFeedQuery,
  ListProjectActivityFeedQueryVariables
>;
export function useListProjectActivityFeedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectActivityFeedQuery,
        ListProjectActivityFeedQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListProjectActivityFeedQuery | undefined,
  ListProjectActivityFeedQueryVariables
>;
export function useListProjectActivityFeedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectActivityFeedQuery,
        ListProjectActivityFeedQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListProjectActivityFeedQuery,
    ListProjectActivityFeedQueryVariables
  >(ListProjectActivityFeedDocument, options);
}
export type ListProjectActivityFeedQueryHookResult = ReturnType<
  typeof useListProjectActivityFeedQuery
>;
export type ListProjectActivityFeedLazyQueryHookResult = ReturnType<
  typeof useListProjectActivityFeedLazyQuery
>;
export type ListProjectActivityFeedSuspenseQueryHookResult = ReturnType<
  typeof useListProjectActivityFeedSuspenseQuery
>;
export type ListProjectActivityFeedQueryResult = Apollo.QueryResult<
  ListProjectActivityFeedQuery,
  ListProjectActivityFeedQueryVariables
>;
export const ListProjectChecklistDocument = gql`
  query listProjectChecklist($projectUUId: ID!) {
    listProjectChecklist(uuid: $projectUUId) {
      id
      projectId
      name
      createdAt
      completedAt
      sort
    }
  }
`;

/**
 * __useListProjectChecklistQuery__
 *
 * To run a query within a React component, call `useListProjectChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectChecklistQuery({
 *   variables: {
 *      projectUUId: // value for 'projectUUId'
 *   },
 * });
 */
export function useListProjectChecklistQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListProjectChecklistQuery,
    ListProjectChecklistQueryVariables
  > &
    (
      | { variables: ListProjectChecklistQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListProjectChecklistQuery,
    ListProjectChecklistQueryVariables
  >(ListProjectChecklistDocument, options);
}
export function useListProjectChecklistLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProjectChecklistQuery,
    ListProjectChecklistQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListProjectChecklistQuery,
    ListProjectChecklistQueryVariables
  >(ListProjectChecklistDocument, options);
}
// @ts-ignore
export function useListProjectChecklistSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProjectChecklistQuery,
    ListProjectChecklistQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListProjectChecklistQuery,
  ListProjectChecklistQueryVariables
>;
export function useListProjectChecklistSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectChecklistQuery,
        ListProjectChecklistQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListProjectChecklistQuery | undefined,
  ListProjectChecklistQueryVariables
>;
export function useListProjectChecklistSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectChecklistQuery,
        ListProjectChecklistQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListProjectChecklistQuery,
    ListProjectChecklistQueryVariables
  >(ListProjectChecklistDocument, options);
}
export type ListProjectChecklistQueryHookResult = ReturnType<
  typeof useListProjectChecklistQuery
>;
export type ListProjectChecklistLazyQueryHookResult = ReturnType<
  typeof useListProjectChecklistLazyQuery
>;
export type ListProjectChecklistSuspenseQueryHookResult = ReturnType<
  typeof useListProjectChecklistSuspenseQuery
>;
export type ListProjectChecklistQueryResult = Apollo.QueryResult<
  ListProjectChecklistQuery,
  ListProjectChecklistQueryVariables
>;
export const ListProjectDocumentsDocument = gql`
  query listProjectDocuments(
    $projectIds: [ID!]
    $ownerIds: [ID!]
    $sortBy: DocumentSortOption
    $first: Int
    $last: Int
    $after: String
    $before: String
    $includeFiles: Boolean
    $includeMedia: Boolean
  ) {
    listProjectDocuments(
      projectIds: $projectIds
      ownerIds: $ownerIds
      sortBy: $sortBy
      first: $first
      last: $last
      after: $after
      before: $before
      includeFiles: $includeFiles
      includeMedia: $includeMedia
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          id
          name
          contentType
          createdAt
          size
          isImage
          isVideo
          clientId
          owner {
            id
            name
            avatar {
              ...AvatarDetail
            }
          }
          file {
            id
            cdnBaseUrl
            path
            isPreviewable
            thumbnail
          }
          messageDocuments {
            id
            message {
              id
              clientId
              chatId
            }
          }
          projectDocuments {
            id
            project {
              id
              uuid
              name
            }
          }
          taskDocuments {
            id
            task {
              id
              name
              projectId
              project {
                id
                uuid
                name
              }
            }
          }
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useListProjectDocumentsQuery__
 *
 * To run a query within a React component, call `useListProjectDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectDocumentsQuery({
 *   variables: {
 *      projectIds: // value for 'projectIds'
 *      ownerIds: // value for 'ownerIds'
 *      sortBy: // value for 'sortBy'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      includeFiles: // value for 'includeFiles'
 *      includeMedia: // value for 'includeMedia'
 *   },
 * });
 */
export function useListProjectDocumentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListProjectDocumentsQuery,
    ListProjectDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListProjectDocumentsQuery,
    ListProjectDocumentsQueryVariables
  >(ListProjectDocumentsDocument, options);
}
export function useListProjectDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProjectDocumentsQuery,
    ListProjectDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListProjectDocumentsQuery,
    ListProjectDocumentsQueryVariables
  >(ListProjectDocumentsDocument, options);
}
// @ts-ignore
export function useListProjectDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProjectDocumentsQuery,
    ListProjectDocumentsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListProjectDocumentsQuery,
  ListProjectDocumentsQueryVariables
>;
export function useListProjectDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectDocumentsQuery,
        ListProjectDocumentsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListProjectDocumentsQuery | undefined,
  ListProjectDocumentsQueryVariables
>;
export function useListProjectDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectDocumentsQuery,
        ListProjectDocumentsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListProjectDocumentsQuery,
    ListProjectDocumentsQueryVariables
  >(ListProjectDocumentsDocument, options);
}
export type ListProjectDocumentsQueryHookResult = ReturnType<
  typeof useListProjectDocumentsQuery
>;
export type ListProjectDocumentsLazyQueryHookResult = ReturnType<
  typeof useListProjectDocumentsLazyQuery
>;
export type ListProjectDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useListProjectDocumentsSuspenseQuery
>;
export type ListProjectDocumentsQueryResult = Apollo.QueryResult<
  ListProjectDocumentsQuery,
  ListProjectDocumentsQueryVariables
>;
export const ListProjectTagsDocument = gql`
  query listProjectTags(
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    listProjects(first: $first, last: $last, after: $after, before: $before) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          id
          name
          usersCount
          tasksCount
          chatProjectsCount
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
`;

/**
 * __useListProjectTagsQuery__
 *
 * To run a query within a React component, call `useListProjectTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectTagsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useListProjectTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListProjectTagsQuery,
    ListProjectTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListProjectTagsQuery, ListProjectTagsQueryVariables>(
    ListProjectTagsDocument,
    options
  );
}
export function useListProjectTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProjectTagsQuery,
    ListProjectTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListProjectTagsQuery,
    ListProjectTagsQueryVariables
  >(ListProjectTagsDocument, options);
}
// @ts-ignore
export function useListProjectTagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProjectTagsQuery,
    ListProjectTagsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListProjectTagsQuery,
  ListProjectTagsQueryVariables
>;
export function useListProjectTagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectTagsQuery,
        ListProjectTagsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListProjectTagsQuery | undefined,
  ListProjectTagsQueryVariables
>;
export function useListProjectTagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectTagsQuery,
        ListProjectTagsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListProjectTagsQuery,
    ListProjectTagsQueryVariables
  >(ListProjectTagsDocument, options);
}
export type ListProjectTagsQueryHookResult = ReturnType<
  typeof useListProjectTagsQuery
>;
export type ListProjectTagsLazyQueryHookResult = ReturnType<
  typeof useListProjectTagsLazyQuery
>;
export type ListProjectTagsSuspenseQueryHookResult = ReturnType<
  typeof useListProjectTagsSuspenseQuery
>;
export type ListProjectTagsQueryResult = Apollo.QueryResult<
  ListProjectTagsQuery,
  ListProjectTagsQueryVariables
>;
export const ListProjectsDocument = gql`
  query listProjects(
    $userId: ID
    $sortBy: ProjectSortOption
    $role: ProjectMemberRole
    $archivesOnly: Boolean
    $locationOnly: Boolean
    $filterTeamsProjects: Boolean
    $first: Int
    $last: Int
    $after: String
    $before: String
    $ownerIds: [ID!]
    $memberIds: [ID!]
    $teamIds: [ID!]
    $recentFirst: Int
    $includeRecent: Boolean! = false
  ) {
    allProjects: listProjects(
      userId: $userId
      sortBy: $sortBy
      role: $role
      archivesOnly: $archivesOnly
      locationOnly: $locationOnly
      filterTeamsProjects: $filterTeamsProjects
      ownerIds: $ownerIds
      memberIds: $memberIds
      teamIds: $teamIds
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          ...ProjectListNode
        }
      }
    }
    recentProjects: listProjects(first: $recentFirst, sortBy: ACTIVITY_DESC)
      @include(if: $includeRecent) {
      edges {
        cursor
        node {
          ...ProjectListNode
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${ProjectListNodeFragmentDoc}
`;

/**
 * __useListProjectsQuery__
 *
 * To run a query within a React component, call `useListProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      sortBy: // value for 'sortBy'
 *      role: // value for 'role'
 *      archivesOnly: // value for 'archivesOnly'
 *      locationOnly: // value for 'locationOnly'
 *      filterTeamsProjects: // value for 'filterTeamsProjects'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      ownerIds: // value for 'ownerIds'
 *      memberIds: // value for 'memberIds'
 *      teamIds: // value for 'teamIds'
 *      recentFirst: // value for 'recentFirst'
 *      includeRecent: // value for 'includeRecent'
 *   },
 * });
 */
export function useListProjectsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListProjectsQuery,
    ListProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListProjectsQuery, ListProjectsQueryVariables>(
    ListProjectsDocument,
    options
  );
}
export function useListProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProjectsQuery,
    ListProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListProjectsQuery, ListProjectsQueryVariables>(
    ListProjectsDocument,
    options
  );
}
// @ts-ignore
export function useListProjectsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProjectsQuery,
    ListProjectsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ListProjectsQuery, ListProjectsQueryVariables>;
export function useListProjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsQuery,
        ListProjectsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListProjectsQuery | undefined,
  ListProjectsQueryVariables
>;
export function useListProjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsQuery,
        ListProjectsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListProjectsQuery, ListProjectsQueryVariables>(
    ListProjectsDocument,
    options
  );
}
export type ListProjectsQueryHookResult = ReturnType<
  typeof useListProjectsQuery
>;
export type ListProjectsLazyQueryHookResult = ReturnType<
  typeof useListProjectsLazyQuery
>;
export type ListProjectsSuspenseQueryHookResult = ReturnType<
  typeof useListProjectsSuspenseQuery
>;
export type ListProjectsQueryResult = Apollo.QueryResult<
  ListProjectsQuery,
  ListProjectsQueryVariables
>;
export const ListProjectsBasicInfoDocument = gql`
  query listProjectsBasicInfo(
    $userId: ID
    $sortBy: ProjectSortOption
    $role: ProjectMemberRole
    $archivesOnly: Boolean
    $locationOnly: Boolean
    $filterTeamsProjects: Boolean
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    listProjects(
      userId: $userId
      sortBy: $sortBy
      role: $role
      archivesOnly: $archivesOnly
      locationOnly: $locationOnly
      filterTeamsProjects: $filterTeamsProjects
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          id
          name
          initials
          teamId
          color
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
`;

/**
 * __useListProjectsBasicInfoQuery__
 *
 * To run a query within a React component, call `useListProjectsBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectsBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectsBasicInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      sortBy: // value for 'sortBy'
 *      role: // value for 'role'
 *      archivesOnly: // value for 'archivesOnly'
 *      locationOnly: // value for 'locationOnly'
 *      filterTeamsProjects: // value for 'filterTeamsProjects'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useListProjectsBasicInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListProjectsBasicInfoQuery,
    ListProjectsBasicInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListProjectsBasicInfoQuery,
    ListProjectsBasicInfoQueryVariables
  >(ListProjectsBasicInfoDocument, options);
}
export function useListProjectsBasicInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProjectsBasicInfoQuery,
    ListProjectsBasicInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListProjectsBasicInfoQuery,
    ListProjectsBasicInfoQueryVariables
  >(ListProjectsBasicInfoDocument, options);
}
// @ts-ignore
export function useListProjectsBasicInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProjectsBasicInfoQuery,
    ListProjectsBasicInfoQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListProjectsBasicInfoQuery,
  ListProjectsBasicInfoQueryVariables
>;
export function useListProjectsBasicInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsBasicInfoQuery,
        ListProjectsBasicInfoQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListProjectsBasicInfoQuery | undefined,
  ListProjectsBasicInfoQueryVariables
>;
export function useListProjectsBasicInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsBasicInfoQuery,
        ListProjectsBasicInfoQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListProjectsBasicInfoQuery,
    ListProjectsBasicInfoQueryVariables
  >(ListProjectsBasicInfoDocument, options);
}
export type ListProjectsBasicInfoQueryHookResult = ReturnType<
  typeof useListProjectsBasicInfoQuery
>;
export type ListProjectsBasicInfoLazyQueryHookResult = ReturnType<
  typeof useListProjectsBasicInfoLazyQuery
>;
export type ListProjectsBasicInfoSuspenseQueryHookResult = ReturnType<
  typeof useListProjectsBasicInfoSuspenseQuery
>;
export type ListProjectsBasicInfoQueryResult = Apollo.QueryResult<
  ListProjectsBasicInfoQuery,
  ListProjectsBasicInfoQueryVariables
>;
export const ListProjectsBasicInfoForEditTaskDocument = gql`
  query listProjectsBasicInfoForEditTask(
    $userId: ID
    $sortBy: ProjectSortOption
    $role: ProjectMemberRole
    $archivesOnly: Boolean
    $locationOnly: Boolean
    $filterTeamsProjects: Boolean
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    listProjects(
      userId: $userId
      sortBy: $sortBy
      role: $role
      archivesOnly: $archivesOnly
      locationOnly: $locationOnly
      filterTeamsProjects: $filterTeamsProjects
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          id
          name
          initials
          teamId
          color
          currentUserRole
          currentUserTeamRole
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
`;

/**
 * __useListProjectsBasicInfoForEditTaskQuery__
 *
 * To run a query within a React component, call `useListProjectsBasicInfoForEditTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectsBasicInfoForEditTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectsBasicInfoForEditTaskQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      sortBy: // value for 'sortBy'
 *      role: // value for 'role'
 *      archivesOnly: // value for 'archivesOnly'
 *      locationOnly: // value for 'locationOnly'
 *      filterTeamsProjects: // value for 'filterTeamsProjects'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useListProjectsBasicInfoForEditTaskQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListProjectsBasicInfoForEditTaskQuery,
    ListProjectsBasicInfoForEditTaskQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListProjectsBasicInfoForEditTaskQuery,
    ListProjectsBasicInfoForEditTaskQueryVariables
  >(ListProjectsBasicInfoForEditTaskDocument, options);
}
export function useListProjectsBasicInfoForEditTaskLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProjectsBasicInfoForEditTaskQuery,
    ListProjectsBasicInfoForEditTaskQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListProjectsBasicInfoForEditTaskQuery,
    ListProjectsBasicInfoForEditTaskQueryVariables
  >(ListProjectsBasicInfoForEditTaskDocument, options);
}
// @ts-ignore
export function useListProjectsBasicInfoForEditTaskSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProjectsBasicInfoForEditTaskQuery,
    ListProjectsBasicInfoForEditTaskQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListProjectsBasicInfoForEditTaskQuery,
  ListProjectsBasicInfoForEditTaskQueryVariables
>;
export function useListProjectsBasicInfoForEditTaskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsBasicInfoForEditTaskQuery,
        ListProjectsBasicInfoForEditTaskQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListProjectsBasicInfoForEditTaskQuery | undefined,
  ListProjectsBasicInfoForEditTaskQueryVariables
>;
export function useListProjectsBasicInfoForEditTaskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsBasicInfoForEditTaskQuery,
        ListProjectsBasicInfoForEditTaskQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListProjectsBasicInfoForEditTaskQuery,
    ListProjectsBasicInfoForEditTaskQueryVariables
  >(ListProjectsBasicInfoForEditTaskDocument, options);
}
export type ListProjectsBasicInfoForEditTaskQueryHookResult = ReturnType<
  typeof useListProjectsBasicInfoForEditTaskQuery
>;
export type ListProjectsBasicInfoForEditTaskLazyQueryHookResult = ReturnType<
  typeof useListProjectsBasicInfoForEditTaskLazyQuery
>;
export type ListProjectsBasicInfoForEditTaskSuspenseQueryHookResult =
  ReturnType<typeof useListProjectsBasicInfoForEditTaskSuspenseQuery>;
export type ListProjectsBasicInfoForEditTaskQueryResult = Apollo.QueryResult<
  ListProjectsBasicInfoForEditTaskQuery,
  ListProjectsBasicInfoForEditTaskQueryVariables
>;
export const ListProjectsByLocationDocument = gql`
  query listProjectsByLocation($latitude: Float!, $longitude: Float!) {
    listProjectsByLocation(latitude: $latitude, longitude: $longitude) {
      id
      uuid
      name
      initials
      description
      address
      latitude
      longitude
      archivedAt
      color
      icon
      team {
        avatar
        createdAt
        id
        uuid
        name
        personal
        hasReachedMaxProjects
        currentUserRole
        storageRemaining
        users {
          ...UserDetail
          teamRoles
        }
        owner {
          ...UserDetail
        }
        subscriptionDetails {
          expirationDate
          subscriptionInterval
          subscriptionPlanName
          subscriptionStatus
          isSubscriptionCanceled
          isSubscriptionActive
          isSubscriptionOnTrial
          trialEndsAt
          updatedAt
        }
      }
    }
  }
  ${UserDetailFragmentDoc}
`;

/**
 * __useListProjectsByLocationQuery__
 *
 * To run a query within a React component, call `useListProjectsByLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectsByLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectsByLocationQuery({
 *   variables: {
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *   },
 * });
 */
export function useListProjectsByLocationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListProjectsByLocationQuery,
    ListProjectsByLocationQueryVariables
  > &
    (
      | { variables: ListProjectsByLocationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListProjectsByLocationQuery,
    ListProjectsByLocationQueryVariables
  >(ListProjectsByLocationDocument, options);
}
export function useListProjectsByLocationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProjectsByLocationQuery,
    ListProjectsByLocationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListProjectsByLocationQuery,
    ListProjectsByLocationQueryVariables
  >(ListProjectsByLocationDocument, options);
}
// @ts-ignore
export function useListProjectsByLocationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProjectsByLocationQuery,
    ListProjectsByLocationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListProjectsByLocationQuery,
  ListProjectsByLocationQueryVariables
>;
export function useListProjectsByLocationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsByLocationQuery,
        ListProjectsByLocationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListProjectsByLocationQuery | undefined,
  ListProjectsByLocationQueryVariables
>;
export function useListProjectsByLocationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsByLocationQuery,
        ListProjectsByLocationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListProjectsByLocationQuery,
    ListProjectsByLocationQueryVariables
  >(ListProjectsByLocationDocument, options);
}
export type ListProjectsByLocationQueryHookResult = ReturnType<
  typeof useListProjectsByLocationQuery
>;
export type ListProjectsByLocationLazyQueryHookResult = ReturnType<
  typeof useListProjectsByLocationLazyQuery
>;
export type ListProjectsByLocationSuspenseQueryHookResult = ReturnType<
  typeof useListProjectsByLocationSuspenseQuery
>;
export type ListProjectsByLocationQueryResult = Apollo.QueryResult<
  ListProjectsByLocationQuery,
  ListProjectsByLocationQueryVariables
>;
export const ListProjectsRecentDocument = gql`
  query listProjectsRecent(
    $first: Int
    $sortBy: ProjectSortOption
    $role: ProjectMemberRole
  ) {
    listProjects(first: $first, sortBy: $sortBy, role: $role) {
      edges {
        node {
          id
          uuid
          name
          coverImage {
            id
            cdnBaseUrl
            isPreviewable
            thumbnail
            path
          }
          initials
          description
          address
          team {
            avatar
            id
            name
            personal
          }
          color
          icon
          createdAt
          creator {
            ...UserDetail
          }
        }
      }
    }
  }
  ${UserDetailFragmentDoc}
`;

/**
 * __useListProjectsRecentQuery__
 *
 * To run a query within a React component, call `useListProjectsRecentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectsRecentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectsRecentQuery({
 *   variables: {
 *      first: // value for 'first'
 *      sortBy: // value for 'sortBy'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useListProjectsRecentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListProjectsRecentQuery,
    ListProjectsRecentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListProjectsRecentQuery,
    ListProjectsRecentQueryVariables
  >(ListProjectsRecentDocument, options);
}
export function useListProjectsRecentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProjectsRecentQuery,
    ListProjectsRecentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListProjectsRecentQuery,
    ListProjectsRecentQueryVariables
  >(ListProjectsRecentDocument, options);
}
// @ts-ignore
export function useListProjectsRecentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProjectsRecentQuery,
    ListProjectsRecentQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListProjectsRecentQuery,
  ListProjectsRecentQueryVariables
>;
export function useListProjectsRecentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsRecentQuery,
        ListProjectsRecentQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListProjectsRecentQuery | undefined,
  ListProjectsRecentQueryVariables
>;
export function useListProjectsRecentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsRecentQuery,
        ListProjectsRecentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListProjectsRecentQuery,
    ListProjectsRecentQueryVariables
  >(ListProjectsRecentDocument, options);
}
export type ListProjectsRecentQueryHookResult = ReturnType<
  typeof useListProjectsRecentQuery
>;
export type ListProjectsRecentLazyQueryHookResult = ReturnType<
  typeof useListProjectsRecentLazyQuery
>;
export type ListProjectsRecentSuspenseQueryHookResult = ReturnType<
  typeof useListProjectsRecentSuspenseQuery
>;
export type ListProjectsRecentQueryResult = Apollo.QueryResult<
  ListProjectsRecentQuery,
  ListProjectsRecentQueryVariables
>;
export const ListProjectsTasksDocument = gql`
  query listProjectsTasks(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $excludeCompleted: Boolean
    $collaboratorsOnly: Boolean
    $chatId: ID
  ) {
    listProjectsTasks(
      before: $before
      after: $after
      first: $first
      last: $last
      excludeCompleted: $excludeCompleted
      collaboratorsOnly: $collaboratorsOnly
      chatId: $chatId
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          id
          uuid
          name
          archivedAt
          currentUserRole
          currentUserTeamRole
          team {
            subscriptionDetails {
              expirationDate
              subscriptionStatus
              isSubscriptionCanceled
            }
          }
          members {
            user {
              id
            }
          }
          tasks {
            id
            name
            status
            priority
            deletedAt
            completedAt
            dueDate
            projectId
            userIds
            currentUserRole
            project {
              id
              uuid
              name
              team {
                subscriptionDetails {
                  expirationDate
                  subscriptionStatus
                  isSubscriptionCanceled
                }
              }
            }
            members {
              id
              role
              user {
                ...UserDetail
              }
            }
          }
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${UserDetailFragmentDoc}
`;

/**
 * __useListProjectsTasksQuery__
 *
 * To run a query within a React component, call `useListProjectsTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectsTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectsTasksQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      excludeCompleted: // value for 'excludeCompleted'
 *      collaboratorsOnly: // value for 'collaboratorsOnly'
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useListProjectsTasksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListProjectsTasksQuery,
    ListProjectsTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListProjectsTasksQuery,
    ListProjectsTasksQueryVariables
  >(ListProjectsTasksDocument, options);
}
export function useListProjectsTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProjectsTasksQuery,
    ListProjectsTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListProjectsTasksQuery,
    ListProjectsTasksQueryVariables
  >(ListProjectsTasksDocument, options);
}
// @ts-ignore
export function useListProjectsTasksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProjectsTasksQuery,
    ListProjectsTasksQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListProjectsTasksQuery,
  ListProjectsTasksQueryVariables
>;
export function useListProjectsTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsTasksQuery,
        ListProjectsTasksQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListProjectsTasksQuery | undefined,
  ListProjectsTasksQueryVariables
>;
export function useListProjectsTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsTasksQuery,
        ListProjectsTasksQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListProjectsTasksQuery,
    ListProjectsTasksQueryVariables
  >(ListProjectsTasksDocument, options);
}
export type ListProjectsTasksQueryHookResult = ReturnType<
  typeof useListProjectsTasksQuery
>;
export type ListProjectsTasksLazyQueryHookResult = ReturnType<
  typeof useListProjectsTasksLazyQuery
>;
export type ListProjectsTasksSuspenseQueryHookResult = ReturnType<
  typeof useListProjectsTasksSuspenseQuery
>;
export type ListProjectsTasksQueryResult = Apollo.QueryResult<
  ListProjectsTasksQuery,
  ListProjectsTasksQueryVariables
>;
export const ListProjectsWithDocumentsDocument = gql`
  query listProjectsWithDocuments {
    listProjectsWithDocuments {
      id
      address
      name
      initials
      icon
      color
      teamId
      team {
        avatar
        createdAt
        id
        name
        personal
      }
      tasks {
        id
        name
      }
    }
  }
`;

/**
 * __useListProjectsWithDocumentsQuery__
 *
 * To run a query within a React component, call `useListProjectsWithDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectsWithDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectsWithDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListProjectsWithDocumentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListProjectsWithDocumentsQuery,
    ListProjectsWithDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListProjectsWithDocumentsQuery,
    ListProjectsWithDocumentsQueryVariables
  >(ListProjectsWithDocumentsDocument, options);
}
export function useListProjectsWithDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProjectsWithDocumentsQuery,
    ListProjectsWithDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListProjectsWithDocumentsQuery,
    ListProjectsWithDocumentsQueryVariables
  >(ListProjectsWithDocumentsDocument, options);
}
// @ts-ignore
export function useListProjectsWithDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProjectsWithDocumentsQuery,
    ListProjectsWithDocumentsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListProjectsWithDocumentsQuery,
  ListProjectsWithDocumentsQueryVariables
>;
export function useListProjectsWithDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsWithDocumentsQuery,
        ListProjectsWithDocumentsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListProjectsWithDocumentsQuery | undefined,
  ListProjectsWithDocumentsQueryVariables
>;
export function useListProjectsWithDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsWithDocumentsQuery,
        ListProjectsWithDocumentsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListProjectsWithDocumentsQuery,
    ListProjectsWithDocumentsQueryVariables
  >(ListProjectsWithDocumentsDocument, options);
}
export type ListProjectsWithDocumentsQueryHookResult = ReturnType<
  typeof useListProjectsWithDocumentsQuery
>;
export type ListProjectsWithDocumentsLazyQueryHookResult = ReturnType<
  typeof useListProjectsWithDocumentsLazyQuery
>;
export type ListProjectsWithDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useListProjectsWithDocumentsSuspenseQuery
>;
export type ListProjectsWithDocumentsQueryResult = Apollo.QueryResult<
  ListProjectsWithDocumentsQuery,
  ListProjectsWithDocumentsQueryVariables
>;
export const ListProjectsWithoutSpecifiedRolesDocument = gql`
  query listProjectsWithoutSpecifiedRoles(
    $roles: [ProjectMemberRole!]!
    $before: String
    $after: String
    $first: Int
    $last: Int
    $sortBy: ProjectSortOption
  ) {
    listProjectsWithoutSpecifiedRoles(
      roles: $roles
      before: $before
      after: $after
      first: $first
      last: $last
      sortBy: $sortBy
    ) {
      edges {
        cursor
        node {
          id
          name
          members {
            user {
              id
            }
          }
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`;

/**
 * __useListProjectsWithoutSpecifiedRolesQuery__
 *
 * To run a query within a React component, call `useListProjectsWithoutSpecifiedRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectsWithoutSpecifiedRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectsWithoutSpecifiedRolesQuery({
 *   variables: {
 *      roles: // value for 'roles'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useListProjectsWithoutSpecifiedRolesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListProjectsWithoutSpecifiedRolesQuery,
    ListProjectsWithoutSpecifiedRolesQueryVariables
  > &
    (
      | {
          variables: ListProjectsWithoutSpecifiedRolesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListProjectsWithoutSpecifiedRolesQuery,
    ListProjectsWithoutSpecifiedRolesQueryVariables
  >(ListProjectsWithoutSpecifiedRolesDocument, options);
}
export function useListProjectsWithoutSpecifiedRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListProjectsWithoutSpecifiedRolesQuery,
    ListProjectsWithoutSpecifiedRolesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListProjectsWithoutSpecifiedRolesQuery,
    ListProjectsWithoutSpecifiedRolesQueryVariables
  >(ListProjectsWithoutSpecifiedRolesDocument, options);
}
// @ts-ignore
export function useListProjectsWithoutSpecifiedRolesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListProjectsWithoutSpecifiedRolesQuery,
    ListProjectsWithoutSpecifiedRolesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListProjectsWithoutSpecifiedRolesQuery,
  ListProjectsWithoutSpecifiedRolesQueryVariables
>;
export function useListProjectsWithoutSpecifiedRolesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsWithoutSpecifiedRolesQuery,
        ListProjectsWithoutSpecifiedRolesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListProjectsWithoutSpecifiedRolesQuery | undefined,
  ListProjectsWithoutSpecifiedRolesQueryVariables
>;
export function useListProjectsWithoutSpecifiedRolesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListProjectsWithoutSpecifiedRolesQuery,
        ListProjectsWithoutSpecifiedRolesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListProjectsWithoutSpecifiedRolesQuery,
    ListProjectsWithoutSpecifiedRolesQueryVariables
  >(ListProjectsWithoutSpecifiedRolesDocument, options);
}
export type ListProjectsWithoutSpecifiedRolesQueryHookResult = ReturnType<
  typeof useListProjectsWithoutSpecifiedRolesQuery
>;
export type ListProjectsWithoutSpecifiedRolesLazyQueryHookResult = ReturnType<
  typeof useListProjectsWithoutSpecifiedRolesLazyQuery
>;
export type ListProjectsWithoutSpecifiedRolesSuspenseQueryHookResult =
  ReturnType<typeof useListProjectsWithoutSpecifiedRolesSuspenseQuery>;
export type ListProjectsWithoutSpecifiedRolesQueryResult = Apollo.QueryResult<
  ListProjectsWithoutSpecifiedRolesQuery,
  ListProjectsWithoutSpecifiedRolesQueryVariables
>;
export const ListRecentProjectsTasksDocument = gql`
  query listRecentProjectsTasks(
    $chatId: ID!
    $excludeCompleted: Boolean
    $collaboratorsOnly: Boolean
  ) {
    listRecentProjectsTasks(
      chatId: $chatId
      excludeCompleted: $excludeCompleted
      collaboratorsOnly: $collaboratorsOnly
    ) {
      ... on Project {
        id
        uuid
        name
        archivedAt
        createdAt
        latitude
        longitude
        currentUserRole
        currentUserTeamRole
        color
        icon
        members {
          user {
            id
          }
        }
        team {
          subscriptionDetails {
            expirationDate
            subscriptionStatus
            isSubscriptionCanceled
          }
        }
      }
      ... on Task {
        id
        name
        status
        priority
        completedAt
        deletedAt
        dueDate
        projectId
        project {
          id
          uuid
          name
          latitude
          longitude
          color
          icon
          team {
            subscriptionDetails {
              expirationDate
              subscriptionInterval
              subscriptionPlanName
              subscriptionStatus
              isSubscriptionCanceled
              trialEndsAt
              updatedAt
            }
          }
        }
        userIds
        members {
          id
          user {
            ...UserDetail
          }
        }
      }
    }
  }
  ${UserDetailFragmentDoc}
`;

/**
 * __useListRecentProjectsTasksQuery__
 *
 * To run a query within a React component, call `useListRecentProjectsTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRecentProjectsTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRecentProjectsTasksQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      excludeCompleted: // value for 'excludeCompleted'
 *      collaboratorsOnly: // value for 'collaboratorsOnly'
 *   },
 * });
 */
export function useListRecentProjectsTasksQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListRecentProjectsTasksQuery,
    ListRecentProjectsTasksQueryVariables
  > &
    (
      | { variables: ListRecentProjectsTasksQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListRecentProjectsTasksQuery,
    ListRecentProjectsTasksQueryVariables
  >(ListRecentProjectsTasksDocument, options);
}
export function useListRecentProjectsTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListRecentProjectsTasksQuery,
    ListRecentProjectsTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListRecentProjectsTasksQuery,
    ListRecentProjectsTasksQueryVariables
  >(ListRecentProjectsTasksDocument, options);
}
// @ts-ignore
export function useListRecentProjectsTasksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListRecentProjectsTasksQuery,
    ListRecentProjectsTasksQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListRecentProjectsTasksQuery,
  ListRecentProjectsTasksQueryVariables
>;
export function useListRecentProjectsTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListRecentProjectsTasksQuery,
        ListRecentProjectsTasksQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListRecentProjectsTasksQuery | undefined,
  ListRecentProjectsTasksQueryVariables
>;
export function useListRecentProjectsTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListRecentProjectsTasksQuery,
        ListRecentProjectsTasksQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListRecentProjectsTasksQuery,
    ListRecentProjectsTasksQueryVariables
  >(ListRecentProjectsTasksDocument, options);
}
export type ListRecentProjectsTasksQueryHookResult = ReturnType<
  typeof useListRecentProjectsTasksQuery
>;
export type ListRecentProjectsTasksLazyQueryHookResult = ReturnType<
  typeof useListRecentProjectsTasksLazyQuery
>;
export type ListRecentProjectsTasksSuspenseQueryHookResult = ReturnType<
  typeof useListRecentProjectsTasksSuspenseQuery
>;
export type ListRecentProjectsTasksQueryResult = Apollo.QueryResult<
  ListRecentProjectsTasksQuery,
  ListRecentProjectsTasksQueryVariables
>;
export const ListRecentTasksDocument = gql`
  query listRecentTasks(
    $projectIds: [ID!]
    $excludeCompleted: Boolean
    $projectCollaborators: Boolean
  ) {
    listRecentTasks(
      projectIds: $projectIds
      excludeCompleted: $excludeCompleted
      projectCollaborators: $projectCollaborators
    ) {
      id
      name
      members {
        id
        role
        user {
          ...UserDetail
        }
      }
      project {
        id
        uuid
        name
        color
      }
    }
  }
  ${UserDetailFragmentDoc}
`;

/**
 * __useListRecentTasksQuery__
 *
 * To run a query within a React component, call `useListRecentTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRecentTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRecentTasksQuery({
 *   variables: {
 *      projectIds: // value for 'projectIds'
 *      excludeCompleted: // value for 'excludeCompleted'
 *      projectCollaborators: // value for 'projectCollaborators'
 *   },
 * });
 */
export function useListRecentTasksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListRecentTasksQuery,
    ListRecentTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListRecentTasksQuery, ListRecentTasksQueryVariables>(
    ListRecentTasksDocument,
    options
  );
}
export function useListRecentTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListRecentTasksQuery,
    ListRecentTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListRecentTasksQuery,
    ListRecentTasksQueryVariables
  >(ListRecentTasksDocument, options);
}
// @ts-ignore
export function useListRecentTasksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListRecentTasksQuery,
    ListRecentTasksQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListRecentTasksQuery,
  ListRecentTasksQueryVariables
>;
export function useListRecentTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListRecentTasksQuery,
        ListRecentTasksQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListRecentTasksQuery | undefined,
  ListRecentTasksQueryVariables
>;
export function useListRecentTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListRecentTasksQuery,
        ListRecentTasksQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListRecentTasksQuery,
    ListRecentTasksQueryVariables
  >(ListRecentTasksDocument, options);
}
export type ListRecentTasksQueryHookResult = ReturnType<
  typeof useListRecentTasksQuery
>;
export type ListRecentTasksLazyQueryHookResult = ReturnType<
  typeof useListRecentTasksLazyQuery
>;
export type ListRecentTasksSuspenseQueryHookResult = ReturnType<
  typeof useListRecentTasksSuspenseQuery
>;
export type ListRecentTasksQueryResult = Apollo.QueryResult<
  ListRecentTasksQuery,
  ListRecentTasksQueryVariables
>;
export const ListSkillsDocument = gql`
  query listSkills {
    listSkills {
      id
      name
    }
  }
`;

/**
 * __useListSkillsQuery__
 *
 * To run a query within a React component, call `useListSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListSkillsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListSkillsQuery,
    ListSkillsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListSkillsQuery, ListSkillsQueryVariables>(
    ListSkillsDocument,
    options
  );
}
export function useListSkillsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListSkillsQuery,
    ListSkillsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListSkillsQuery, ListSkillsQueryVariables>(
    ListSkillsDocument,
    options
  );
}
// @ts-ignore
export function useListSkillsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListSkillsQuery,
    ListSkillsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ListSkillsQuery, ListSkillsQueryVariables>;
export function useListSkillsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListSkillsQuery, ListSkillsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  ListSkillsQuery | undefined,
  ListSkillsQueryVariables
>;
export function useListSkillsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListSkillsQuery, ListSkillsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListSkillsQuery, ListSkillsQueryVariables>(
    ListSkillsDocument,
    options
  );
}
export type ListSkillsQueryHookResult = ReturnType<typeof useListSkillsQuery>;
export type ListSkillsLazyQueryHookResult = ReturnType<
  typeof useListSkillsLazyQuery
>;
export type ListSkillsSuspenseQueryHookResult = ReturnType<
  typeof useListSkillsSuspenseQuery
>;
export type ListSkillsQueryResult = Apollo.QueryResult<
  ListSkillsQuery,
  ListSkillsQueryVariables
>;
export const ListTagGroupsDocument = gql`
  query listTagGroups($limit: Int) {
    listTagGroups(limit: $limit) {
      id
      isImageGroup
      updatedAt
      createdAt
      author {
        id
        name
      }
      project {
        id
        uuid
        name
      }
      task {
        id
        name
      }
      documents {
        id
        name
        contentType
        createdAt
        size
        isImage
        clientId
        isAudio
        duration
        file {
          id
          cdnBaseUrl
          isPreviewable
          thumbnail
          path
        }
        projectDocuments {
          id
          project {
            id
            uuid
            name
          }
        }
        taskDocuments {
          id
          task {
            id
            name
            projectId
            project {
              id
              uuid
              name
            }
          }
        }
      }
    }
  }
`;

/**
 * __useListTagGroupsQuery__
 *
 * To run a query within a React component, call `useListTagGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTagGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTagGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListTagGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListTagGroupsQuery,
    ListTagGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTagGroupsQuery, ListTagGroupsQueryVariables>(
    ListTagGroupsDocument,
    options
  );
}
export function useListTagGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTagGroupsQuery,
    ListTagGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTagGroupsQuery, ListTagGroupsQueryVariables>(
    ListTagGroupsDocument,
    options
  );
}
// @ts-ignore
export function useListTagGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTagGroupsQuery,
    ListTagGroupsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListTagGroupsQuery,
  ListTagGroupsQueryVariables
>;
export function useListTagGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTagGroupsQuery,
        ListTagGroupsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListTagGroupsQuery | undefined,
  ListTagGroupsQueryVariables
>;
export function useListTagGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTagGroupsQuery,
        ListTagGroupsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListTagGroupsQuery,
    ListTagGroupsQueryVariables
  >(ListTagGroupsDocument, options);
}
export type ListTagGroupsQueryHookResult = ReturnType<
  typeof useListTagGroupsQuery
>;
export type ListTagGroupsLazyQueryHookResult = ReturnType<
  typeof useListTagGroupsLazyQuery
>;
export type ListTagGroupsSuspenseQueryHookResult = ReturnType<
  typeof useListTagGroupsSuspenseQuery
>;
export type ListTagGroupsQueryResult = Apollo.QueryResult<
  ListTagGroupsQuery,
  ListTagGroupsQueryVariables
>;
export const ListTaskChecklistDocument = gql`
  query listTaskChecklist($id: ID!) {
    listTaskChecklist(id: $id) {
      id
      taskId
      name
      createdAt
      completedAt
      sort
    }
  }
`;

/**
 * __useListTaskChecklistQuery__
 *
 * To run a query within a React component, call `useListTaskChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTaskChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTaskChecklistQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListTaskChecklistQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListTaskChecklistQuery,
    ListTaskChecklistQueryVariables
  > &
    (
      | { variables: ListTaskChecklistQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListTaskChecklistQuery,
    ListTaskChecklistQueryVariables
  >(ListTaskChecklistDocument, options);
}
export function useListTaskChecklistLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTaskChecklistQuery,
    ListTaskChecklistQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListTaskChecklistQuery,
    ListTaskChecklistQueryVariables
  >(ListTaskChecklistDocument, options);
}
// @ts-ignore
export function useListTaskChecklistSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTaskChecklistQuery,
    ListTaskChecklistQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListTaskChecklistQuery,
  ListTaskChecklistQueryVariables
>;
export function useListTaskChecklistSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTaskChecklistQuery,
        ListTaskChecklistQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListTaskChecklistQuery | undefined,
  ListTaskChecklistQueryVariables
>;
export function useListTaskChecklistSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTaskChecklistQuery,
        ListTaskChecklistQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListTaskChecklistQuery,
    ListTaskChecklistQueryVariables
  >(ListTaskChecklistDocument, options);
}
export type ListTaskChecklistQueryHookResult = ReturnType<
  typeof useListTaskChecklistQuery
>;
export type ListTaskChecklistLazyQueryHookResult = ReturnType<
  typeof useListTaskChecklistLazyQuery
>;
export type ListTaskChecklistSuspenseQueryHookResult = ReturnType<
  typeof useListTaskChecklistSuspenseQuery
>;
export type ListTaskChecklistQueryResult = Apollo.QueryResult<
  ListTaskChecklistQuery,
  ListTaskChecklistQueryVariables
>;
export const ListTaskDocumentsDocument = gql`
  query listTaskDocuments(
    $projectIds: [ID!]
    $taskIds: [ID!]
    $ownerIds: [ID!]
    $sortBy: DocumentSortOption
    $first: Int
    $last: Int
    $after: String
    $before: String
    $includeFiles: Boolean
    $includeMedia: Boolean
  ) {
    listTaskDocuments(
      projectIds: $projectIds
      taskIds: $taskIds
      ownerIds: $ownerIds
      sortBy: $sortBy
      first: $first
      last: $last
      after: $after
      before: $before
      includeFiles: $includeFiles
      includeMedia: $includeMedia
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          id
          name
          contentType
          createdAt
          size
          isImage
          isVideo
          clientId
          owner {
            id
            name
            avatar {
              ...AvatarDetail
            }
          }
          file {
            id
            cdnBaseUrl
            path
            isPreviewable
            thumbnail
          }
          messageDocuments {
            id
            message {
              id
              clientId
              chatId
            }
          }
          projectDocuments {
            id
            project {
              id
              uuid
              name
            }
          }
          taskDocuments {
            id
            task {
              id
              name
              projectId
              project {
                id
                uuid
                name
              }
            }
          }
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useListTaskDocumentsQuery__
 *
 * To run a query within a React component, call `useListTaskDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTaskDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTaskDocumentsQuery({
 *   variables: {
 *      projectIds: // value for 'projectIds'
 *      taskIds: // value for 'taskIds'
 *      ownerIds: // value for 'ownerIds'
 *      sortBy: // value for 'sortBy'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      includeFiles: // value for 'includeFiles'
 *      includeMedia: // value for 'includeMedia'
 *   },
 * });
 */
export function useListTaskDocumentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListTaskDocumentsQuery,
    ListTaskDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListTaskDocumentsQuery,
    ListTaskDocumentsQueryVariables
  >(ListTaskDocumentsDocument, options);
}
export function useListTaskDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTaskDocumentsQuery,
    ListTaskDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListTaskDocumentsQuery,
    ListTaskDocumentsQueryVariables
  >(ListTaskDocumentsDocument, options);
}
// @ts-ignore
export function useListTaskDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTaskDocumentsQuery,
    ListTaskDocumentsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListTaskDocumentsQuery,
  ListTaskDocumentsQueryVariables
>;
export function useListTaskDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTaskDocumentsQuery,
        ListTaskDocumentsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListTaskDocumentsQuery | undefined,
  ListTaskDocumentsQueryVariables
>;
export function useListTaskDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTaskDocumentsQuery,
        ListTaskDocumentsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListTaskDocumentsQuery,
    ListTaskDocumentsQueryVariables
  >(ListTaskDocumentsDocument, options);
}
export type ListTaskDocumentsQueryHookResult = ReturnType<
  typeof useListTaskDocumentsQuery
>;
export type ListTaskDocumentsLazyQueryHookResult = ReturnType<
  typeof useListTaskDocumentsLazyQuery
>;
export type ListTaskDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useListTaskDocumentsSuspenseQuery
>;
export type ListTaskDocumentsQueryResult = Apollo.QueryResult<
  ListTaskDocumentsQuery,
  ListTaskDocumentsQueryVariables
>;
export const ListTaskTagsDocument = gql`
  query listTaskTags(
    $projectIds: [ID!]
    $chatId: ID
    $sortBy: TaskSortOption
    $first: Int
    $last: Int
    $after: String
    $before: String
    $excludeCompleted: Boolean
    $collaboratorsOnly: Boolean
    $taskCollaborators: Boolean
  ) {
    listTasks(
      projectIds: $projectIds
      chatId: $chatId
      sortBy: $sortBy
      first: $first
      last: $last
      after: $after
      before: $before
      excludeCompleted: $excludeCompleted
      collaboratorsOnly: $collaboratorsOnly
      taskCollaborators: $taskCollaborators
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          id
          userIds
          projectId
          name
          status
          priority
          dueDate
          currentUserRole
          currentUserProjectRole
          deletedAt
          completedAt
          project {
            id
            uuid
            name
            team {
              subscriptionDetails {
                expirationDate
                subscriptionInterval
                subscriptionPlanName
                subscriptionStatus
                isSubscriptionCanceled
                isSubscriptionActive
                isSubscriptionOnTrial
                trialEndsAt
                updatedAt
              }
            }
          }
          members {
            id
            role
            user {
              ...UserDetail
            }
          }
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${UserDetailFragmentDoc}
`;

/**
 * __useListTaskTagsQuery__
 *
 * To run a query within a React component, call `useListTaskTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTaskTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTaskTagsQuery({
 *   variables: {
 *      projectIds: // value for 'projectIds'
 *      chatId: // value for 'chatId'
 *      sortBy: // value for 'sortBy'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      excludeCompleted: // value for 'excludeCompleted'
 *      collaboratorsOnly: // value for 'collaboratorsOnly'
 *      taskCollaborators: // value for 'taskCollaborators'
 *   },
 * });
 */
export function useListTaskTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListTaskTagsQuery,
    ListTaskTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTaskTagsQuery, ListTaskTagsQueryVariables>(
    ListTaskTagsDocument,
    options
  );
}
export function useListTaskTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTaskTagsQuery,
    ListTaskTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTaskTagsQuery, ListTaskTagsQueryVariables>(
    ListTaskTagsDocument,
    options
  );
}
// @ts-ignore
export function useListTaskTagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTaskTagsQuery,
    ListTaskTagsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ListTaskTagsQuery, ListTaskTagsQueryVariables>;
export function useListTaskTagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTaskTagsQuery,
        ListTaskTagsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListTaskTagsQuery | undefined,
  ListTaskTagsQueryVariables
>;
export function useListTaskTagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTaskTagsQuery,
        ListTaskTagsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListTaskTagsQuery, ListTaskTagsQueryVariables>(
    ListTaskTagsDocument,
    options
  );
}
export type ListTaskTagsQueryHookResult = ReturnType<
  typeof useListTaskTagsQuery
>;
export type ListTaskTagsLazyQueryHookResult = ReturnType<
  typeof useListTaskTagsLazyQuery
>;
export type ListTaskTagsSuspenseQueryHookResult = ReturnType<
  typeof useListTaskTagsSuspenseQuery
>;
export type ListTaskTagsQueryResult = Apollo.QueryResult<
  ListTaskTagsQuery,
  ListTaskTagsQueryVariables
>;
export const ListTasksDocument = gql`
  query listTasks(
    $userId: ID
    $teamIds: [ID!]
    $memberIds: [ID!]
    $projectIds: [ID!]
    $chatId: ID
    $sortBy: TaskSortOption
    $status: TaskStatus
    $dueGroup: TaskGroup
    $dueDateBegin: ISO8601DateTime
    $dueDateEnd: ISO8601DateTime
    $first: Int
    $last: Int
    $after: String
    $before: String
    $withoutPhase: Boolean
    $withoutDueDate: Boolean
    $excludeCompleted: Boolean
    $collaboratorsOnly: Boolean
    $taskCollaborators: Boolean
    $priority: [TaskPriority!]
  ) {
    listTasks(
      userId: $userId
      teamIds: $teamIds
      memberIds: $memberIds
      chatId: $chatId
      projectIds: $projectIds
      sortBy: $sortBy
      status: $status
      dueGroup: $dueGroup
      dueDateBegin: $dueDateBegin
      dueDateEnd: $dueDateEnd
      first: $first
      last: $last
      after: $after
      before: $before
      withoutPhase: $withoutPhase
      withoutDueDate: $withoutDueDate
      excludeCompleted: $excludeCompleted
      collaboratorsOnly: $collaboratorsOnly
      taskCollaborators: $taskCollaborators
      priority: $priority
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          ...TaskRow
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${TaskRowFragmentDoc}
`;

/**
 * __useListTasksQuery__
 *
 * To run a query within a React component, call `useListTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTasksQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      teamIds: // value for 'teamIds'
 *      memberIds: // value for 'memberIds'
 *      projectIds: // value for 'projectIds'
 *      chatId: // value for 'chatId'
 *      sortBy: // value for 'sortBy'
 *      status: // value for 'status'
 *      dueGroup: // value for 'dueGroup'
 *      dueDateBegin: // value for 'dueDateBegin'
 *      dueDateEnd: // value for 'dueDateEnd'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      withoutPhase: // value for 'withoutPhase'
 *      withoutDueDate: // value for 'withoutDueDate'
 *      excludeCompleted: // value for 'excludeCompleted'
 *      collaboratorsOnly: // value for 'collaboratorsOnly'
 *      taskCollaborators: // value for 'taskCollaborators'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function useListTasksQuery(
  baseOptions?: Apollo.QueryHookOptions<ListTasksQuery, ListTasksQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTasksQuery, ListTasksQueryVariables>(
    ListTasksDocument,
    options
  );
}
export function useListTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTasksQuery,
    ListTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTasksQuery, ListTasksQueryVariables>(
    ListTasksDocument,
    options
  );
}
// @ts-ignore
export function useListTasksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTasksQuery,
    ListTasksQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ListTasksQuery, ListTasksQueryVariables>;
export function useListTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTasksQuery, ListTasksQueryVariables>
): Apollo.UseSuspenseQueryResult<
  ListTasksQuery | undefined,
  ListTasksQueryVariables
>;
export function useListTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTasksQuery, ListTasksQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListTasksQuery, ListTasksQueryVariables>(
    ListTasksDocument,
    options
  );
}
export type ListTasksQueryHookResult = ReturnType<typeof useListTasksQuery>;
export type ListTasksLazyQueryHookResult = ReturnType<
  typeof useListTasksLazyQuery
>;
export type ListTasksSuspenseQueryHookResult = ReturnType<
  typeof useListTasksSuspenseQuery
>;
export type ListTasksQueryResult = Apollo.QueryResult<
  ListTasksQuery,
  ListTasksQueryVariables
>;
export const ListTasksLightDocument = gql`
  query listTasksLight(
    $projectIds: [ID!]
    $memberIds: [ID!]
    $priority: [TaskPriority!]
    $sortBy: TaskSortOption
    $dueDateBegin: ISO8601DateTime
    $dueDateEnd: ISO8601DateTime
    $withoutDueDate: Boolean
    $excludeCompleted: Boolean
    $taskCollaborators: Boolean
    $first: Int
    $after: String
  ) {
    listTasks(
      projectIds: $projectIds
      memberIds: $memberIds
      priority: $priority
      sortBy: $sortBy
      dueDateBegin: $dueDateBegin
      dueDateEnd: $dueDateEnd
      withoutDueDate: $withoutDueDate
      excludeCompleted: $excludeCompleted
      taskCollaborators: $taskCollaborators
      first: $first
      after: $after
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          ...MyTasksGroupTask
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${MyTasksGroupTaskFragmentDoc}
`;

/**
 * __useListTasksLightQuery__
 *
 * To run a query within a React component, call `useListTasksLightQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTasksLightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTasksLightQuery({
 *   variables: {
 *      projectIds: // value for 'projectIds'
 *      memberIds: // value for 'memberIds'
 *      priority: // value for 'priority'
 *      sortBy: // value for 'sortBy'
 *      dueDateBegin: // value for 'dueDateBegin'
 *      dueDateEnd: // value for 'dueDateEnd'
 *      withoutDueDate: // value for 'withoutDueDate'
 *      excludeCompleted: // value for 'excludeCompleted'
 *      taskCollaborators: // value for 'taskCollaborators'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListTasksLightQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListTasksLightQuery,
    ListTasksLightQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTasksLightQuery, ListTasksLightQueryVariables>(
    ListTasksLightDocument,
    options
  );
}
export function useListTasksLightLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTasksLightQuery,
    ListTasksLightQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTasksLightQuery, ListTasksLightQueryVariables>(
    ListTasksLightDocument,
    options
  );
}
// @ts-ignore
export function useListTasksLightSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTasksLightQuery,
    ListTasksLightQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListTasksLightQuery,
  ListTasksLightQueryVariables
>;
export function useListTasksLightSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTasksLightQuery,
        ListTasksLightQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListTasksLightQuery | undefined,
  ListTasksLightQueryVariables
>;
export function useListTasksLightSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTasksLightQuery,
        ListTasksLightQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListTasksLightQuery,
    ListTasksLightQueryVariables
  >(ListTasksLightDocument, options);
}
export type ListTasksLightQueryHookResult = ReturnType<
  typeof useListTasksLightQuery
>;
export type ListTasksLightLazyQueryHookResult = ReturnType<
  typeof useListTasksLightLazyQuery
>;
export type ListTasksLightSuspenseQueryHookResult = ReturnType<
  typeof useListTasksLightSuspenseQuery
>;
export type ListTasksLightQueryResult = Apollo.QueryResult<
  ListTasksLightQuery,
  ListTasksLightQueryVariables
>;
export const ListTasksNamesUnderProjectDocument = gql`
  query listTasksNamesUnderProject(
    $projectId: ID!
    $first: Int
    $after: String
  ) {
    listTasks(
      projectIds: [$projectId]
      first: $first
      after: $after
      excludeCompleted: false
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          id
          name
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
`;

/**
 * __useListTasksNamesUnderProjectQuery__
 *
 * To run a query within a React component, call `useListTasksNamesUnderProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTasksNamesUnderProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTasksNamesUnderProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListTasksNamesUnderProjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListTasksNamesUnderProjectQuery,
    ListTasksNamesUnderProjectQueryVariables
  > &
    (
      | { variables: ListTasksNamesUnderProjectQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListTasksNamesUnderProjectQuery,
    ListTasksNamesUnderProjectQueryVariables
  >(ListTasksNamesUnderProjectDocument, options);
}
export function useListTasksNamesUnderProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTasksNamesUnderProjectQuery,
    ListTasksNamesUnderProjectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListTasksNamesUnderProjectQuery,
    ListTasksNamesUnderProjectQueryVariables
  >(ListTasksNamesUnderProjectDocument, options);
}
// @ts-ignore
export function useListTasksNamesUnderProjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTasksNamesUnderProjectQuery,
    ListTasksNamesUnderProjectQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListTasksNamesUnderProjectQuery,
  ListTasksNamesUnderProjectQueryVariables
>;
export function useListTasksNamesUnderProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTasksNamesUnderProjectQuery,
        ListTasksNamesUnderProjectQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListTasksNamesUnderProjectQuery | undefined,
  ListTasksNamesUnderProjectQueryVariables
>;
export function useListTasksNamesUnderProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTasksNamesUnderProjectQuery,
        ListTasksNamesUnderProjectQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListTasksNamesUnderProjectQuery,
    ListTasksNamesUnderProjectQueryVariables
  >(ListTasksNamesUnderProjectDocument, options);
}
export type ListTasksNamesUnderProjectQueryHookResult = ReturnType<
  typeof useListTasksNamesUnderProjectQuery
>;
export type ListTasksNamesUnderProjectLazyQueryHookResult = ReturnType<
  typeof useListTasksNamesUnderProjectLazyQuery
>;
export type ListTasksNamesUnderProjectSuspenseQueryHookResult = ReturnType<
  typeof useListTasksNamesUnderProjectSuspenseQuery
>;
export type ListTasksNamesUnderProjectQueryResult = Apollo.QueryResult<
  ListTasksNamesUnderProjectQuery,
  ListTasksNamesUnderProjectQueryVariables
>;
export const ListTeamInvoicesDocument = gql`
  query listTeamInvoices($id: ID!) {
    getTeam(id: $id) {
      id
      invoices {
        amount
        date
        description
        id
        invoiceUrl
        status
      }
    }
  }
`;

/**
 * __useListTeamInvoicesQuery__
 *
 * To run a query within a React component, call `useListTeamInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTeamInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTeamInvoicesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListTeamInvoicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListTeamInvoicesQuery,
    ListTeamInvoicesQueryVariables
  > &
    (
      | { variables: ListTeamInvoicesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTeamInvoicesQuery, ListTeamInvoicesQueryVariables>(
    ListTeamInvoicesDocument,
    options
  );
}
export function useListTeamInvoicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTeamInvoicesQuery,
    ListTeamInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListTeamInvoicesQuery,
    ListTeamInvoicesQueryVariables
  >(ListTeamInvoicesDocument, options);
}
// @ts-ignore
export function useListTeamInvoicesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTeamInvoicesQuery,
    ListTeamInvoicesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListTeamInvoicesQuery,
  ListTeamInvoicesQueryVariables
>;
export function useListTeamInvoicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTeamInvoicesQuery,
        ListTeamInvoicesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListTeamInvoicesQuery | undefined,
  ListTeamInvoicesQueryVariables
>;
export function useListTeamInvoicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTeamInvoicesQuery,
        ListTeamInvoicesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListTeamInvoicesQuery,
    ListTeamInvoicesQueryVariables
  >(ListTeamInvoicesDocument, options);
}
export type ListTeamInvoicesQueryHookResult = ReturnType<
  typeof useListTeamInvoicesQuery
>;
export type ListTeamInvoicesLazyQueryHookResult = ReturnType<
  typeof useListTeamInvoicesLazyQuery
>;
export type ListTeamInvoicesSuspenseQueryHookResult = ReturnType<
  typeof useListTeamInvoicesSuspenseQuery
>;
export type ListTeamInvoicesQueryResult = Apollo.QueryResult<
  ListTeamInvoicesQuery,
  ListTeamInvoicesQueryVariables
>;
export const ListTeamSubscriptionsDocument = gql`
  query listTeamSubscriptions {
    listTeams(includePending: true) {
      ...TeamSubscription
    }
  }
  ${TeamSubscriptionFragmentDoc}
`;

/**
 * __useListTeamSubscriptionsQuery__
 *
 * To run a query within a React component, call `useListTeamSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTeamSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTeamSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListTeamSubscriptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListTeamSubscriptionsQuery,
    ListTeamSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListTeamSubscriptionsQuery,
    ListTeamSubscriptionsQueryVariables
  >(ListTeamSubscriptionsDocument, options);
}
export function useListTeamSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTeamSubscriptionsQuery,
    ListTeamSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListTeamSubscriptionsQuery,
    ListTeamSubscriptionsQueryVariables
  >(ListTeamSubscriptionsDocument, options);
}
// @ts-ignore
export function useListTeamSubscriptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTeamSubscriptionsQuery,
    ListTeamSubscriptionsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListTeamSubscriptionsQuery,
  ListTeamSubscriptionsQueryVariables
>;
export function useListTeamSubscriptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTeamSubscriptionsQuery,
        ListTeamSubscriptionsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListTeamSubscriptionsQuery | undefined,
  ListTeamSubscriptionsQueryVariables
>;
export function useListTeamSubscriptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTeamSubscriptionsQuery,
        ListTeamSubscriptionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListTeamSubscriptionsQuery,
    ListTeamSubscriptionsQueryVariables
  >(ListTeamSubscriptionsDocument, options);
}
export type ListTeamSubscriptionsQueryHookResult = ReturnType<
  typeof useListTeamSubscriptionsQuery
>;
export type ListTeamSubscriptionsLazyQueryHookResult = ReturnType<
  typeof useListTeamSubscriptionsLazyQuery
>;
export type ListTeamSubscriptionsSuspenseQueryHookResult = ReturnType<
  typeof useListTeamSubscriptionsSuspenseQuery
>;
export type ListTeamSubscriptionsQueryResult = Apollo.QueryResult<
  ListTeamSubscriptionsQuery,
  ListTeamSubscriptionsQueryVariables
>;
export const ListTeamsDocument = gql`
  query listTeams($role: ProjectMemberRole, $includePending: Boolean) {
    listTeams(role: $role, includePending: $includePending) {
      id
      uuid
      avatar
      avatarFile {
        ...AvatarDetail
      }
      usersCount
      personal
      name
      currentUserRole
      createdAt
      hasReachedMaxProjects
      hasProjects
      numberOfProjectsUsed
      maxNumberOfProjects
      billingSource
      teamSubscriptionStatus
      entitlementExpiration
      owner {
        id
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useListTeamsQuery__
 *
 * To run a query within a React component, call `useListTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTeamsQuery({
 *   variables: {
 *      role: // value for 'role'
 *      includePending: // value for 'includePending'
 *   },
 * });
 */
export function useListTeamsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListTeamsQuery, ListTeamsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTeamsQuery, ListTeamsQueryVariables>(
    ListTeamsDocument,
    options
  );
}
export function useListTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTeamsQuery,
    ListTeamsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTeamsQuery, ListTeamsQueryVariables>(
    ListTeamsDocument,
    options
  );
}
// @ts-ignore
export function useListTeamsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTeamsQuery,
    ListTeamsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ListTeamsQuery, ListTeamsQueryVariables>;
export function useListTeamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTeamsQuery, ListTeamsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  ListTeamsQuery | undefined,
  ListTeamsQueryVariables
>;
export function useListTeamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTeamsQuery, ListTeamsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListTeamsQuery, ListTeamsQueryVariables>(
    ListTeamsDocument,
    options
  );
}
export type ListTeamsQueryHookResult = ReturnType<typeof useListTeamsQuery>;
export type ListTeamsLazyQueryHookResult = ReturnType<
  typeof useListTeamsLazyQuery
>;
export type ListTeamsSuspenseQueryHookResult = ReturnType<
  typeof useListTeamsSuspenseQuery
>;
export type ListTeamsQueryResult = Apollo.QueryResult<
  ListTeamsQuery,
  ListTeamsQueryVariables
>;
export const ListTeamsProjectsDocument = gql`
  query listTeamsProjects($role: ProjectMemberRole, $includePending: Boolean) {
    listTeams(role: $role, includePending: $includePending) {
      id
      name
      personal
      avatar
      avatarFile {
        ...AvatarDetail
      }
      projectPreviews {
        id
        uuid
        name
        color
        icon
        initials
        address
        teamId
        team {
          id
          name
          personal
        }
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useListTeamsProjectsQuery__
 *
 * To run a query within a React component, call `useListTeamsProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTeamsProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTeamsProjectsQuery({
 *   variables: {
 *      role: // value for 'role'
 *      includePending: // value for 'includePending'
 *   },
 * });
 */
export function useListTeamsProjectsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListTeamsProjectsQuery,
    ListTeamsProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListTeamsProjectsQuery,
    ListTeamsProjectsQueryVariables
  >(ListTeamsProjectsDocument, options);
}
export function useListTeamsProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTeamsProjectsQuery,
    ListTeamsProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListTeamsProjectsQuery,
    ListTeamsProjectsQueryVariables
  >(ListTeamsProjectsDocument, options);
}
// @ts-ignore
export function useListTeamsProjectsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTeamsProjectsQuery,
    ListTeamsProjectsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListTeamsProjectsQuery,
  ListTeamsProjectsQueryVariables
>;
export function useListTeamsProjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTeamsProjectsQuery,
        ListTeamsProjectsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListTeamsProjectsQuery | undefined,
  ListTeamsProjectsQueryVariables
>;
export function useListTeamsProjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTeamsProjectsQuery,
        ListTeamsProjectsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListTeamsProjectsQuery,
    ListTeamsProjectsQueryVariables
  >(ListTeamsProjectsDocument, options);
}
export type ListTeamsProjectsQueryHookResult = ReturnType<
  typeof useListTeamsProjectsQuery
>;
export type ListTeamsProjectsLazyQueryHookResult = ReturnType<
  typeof useListTeamsProjectsLazyQuery
>;
export type ListTeamsProjectsSuspenseQueryHookResult = ReturnType<
  typeof useListTeamsProjectsSuspenseQuery
>;
export type ListTeamsProjectsQueryResult = Apollo.QueryResult<
  ListTeamsProjectsQuery,
  ListTeamsProjectsQueryVariables
>;
export const ListTeamsTasksCountDocument = gql`
  query listTeamsTasksCount {
    listTeams {
      id
      tasksCount
    }
  }
`;

/**
 * __useListTeamsTasksCountQuery__
 *
 * To run a query within a React component, call `useListTeamsTasksCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTeamsTasksCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTeamsTasksCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useListTeamsTasksCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListTeamsTasksCountQuery,
    ListTeamsTasksCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListTeamsTasksCountQuery,
    ListTeamsTasksCountQueryVariables
  >(ListTeamsTasksCountDocument, options);
}
export function useListTeamsTasksCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTeamsTasksCountQuery,
    ListTeamsTasksCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListTeamsTasksCountQuery,
    ListTeamsTasksCountQueryVariables
  >(ListTeamsTasksCountDocument, options);
}
// @ts-ignore
export function useListTeamsTasksCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTeamsTasksCountQuery,
    ListTeamsTasksCountQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListTeamsTasksCountQuery,
  ListTeamsTasksCountQueryVariables
>;
export function useListTeamsTasksCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTeamsTasksCountQuery,
        ListTeamsTasksCountQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListTeamsTasksCountQuery | undefined,
  ListTeamsTasksCountQueryVariables
>;
export function useListTeamsTasksCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTeamsTasksCountQuery,
        ListTeamsTasksCountQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListTeamsTasksCountQuery,
    ListTeamsTasksCountQueryVariables
  >(ListTeamsTasksCountDocument, options);
}
export type ListTeamsTasksCountQueryHookResult = ReturnType<
  typeof useListTeamsTasksCountQuery
>;
export type ListTeamsTasksCountLazyQueryHookResult = ReturnType<
  typeof useListTeamsTasksCountLazyQuery
>;
export type ListTeamsTasksCountSuspenseQueryHookResult = ReturnType<
  typeof useListTeamsTasksCountSuspenseQuery
>;
export type ListTeamsTasksCountQueryResult = Apollo.QueryResult<
  ListTeamsTasksCountQuery,
  ListTeamsTasksCountQueryVariables
>;
export const ListTeamsUsersDocument = gql`
  query listTeamsUsers($role: ProjectMemberRole, $includePending: Boolean) {
    listTeams(role: $role, includePending: $includePending) {
      id
      uuid
      name
      personal
      avatar
      usersCount
      avatarFile {
        ...AvatarDetail
      }
      users {
        ...UserDetail
      }
    }
  }
  ${AvatarDetailFragmentDoc}
  ${UserDetailFragmentDoc}
`;

/**
 * __useListTeamsUsersQuery__
 *
 * To run a query within a React component, call `useListTeamsUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTeamsUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTeamsUsersQuery({
 *   variables: {
 *      role: // value for 'role'
 *      includePending: // value for 'includePending'
 *   },
 * });
 */
export function useListTeamsUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListTeamsUsersQuery,
    ListTeamsUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTeamsUsersQuery, ListTeamsUsersQueryVariables>(
    ListTeamsUsersDocument,
    options
  );
}
export function useListTeamsUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTeamsUsersQuery,
    ListTeamsUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTeamsUsersQuery, ListTeamsUsersQueryVariables>(
    ListTeamsUsersDocument,
    options
  );
}
// @ts-ignore
export function useListTeamsUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListTeamsUsersQuery,
    ListTeamsUsersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListTeamsUsersQuery,
  ListTeamsUsersQueryVariables
>;
export function useListTeamsUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTeamsUsersQuery,
        ListTeamsUsersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListTeamsUsersQuery | undefined,
  ListTeamsUsersQueryVariables
>;
export function useListTeamsUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTeamsUsersQuery,
        ListTeamsUsersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListTeamsUsersQuery,
    ListTeamsUsersQueryVariables
  >(ListTeamsUsersDocument, options);
}
export type ListTeamsUsersQueryHookResult = ReturnType<
  typeof useListTeamsUsersQuery
>;
export type ListTeamsUsersLazyQueryHookResult = ReturnType<
  typeof useListTeamsUsersLazyQuery
>;
export type ListTeamsUsersSuspenseQueryHookResult = ReturnType<
  typeof useListTeamsUsersSuspenseQuery
>;
export type ListTeamsUsersQueryResult = Apollo.QueryResult<
  ListTeamsUsersQuery,
  ListTeamsUsersQueryVariables
>;
export const ListUsersDocument = gql`
  query listUsers($term: String!, $size: Int) {
    listUsers(term: $term, size: $size) {
      id
      name
      email
      firstName
      lastName
      friendRequestPending
      avatar {
        ...AvatarDetail
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      term: // value for 'term'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useListUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListUsersQuery,
    ListUsersQueryVariables
  > &
    ({ variables: ListUsersQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(
    ListUsersDocument,
    options
  );
}
export function useListUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListUsersQuery,
    ListUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(
    ListUsersDocument,
    options
  );
}
// @ts-ignore
export function useListUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListUsersQuery,
    ListUsersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ListUsersQuery, ListUsersQueryVariables>;
export function useListUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>
): Apollo.UseSuspenseQueryResult<
  ListUsersQuery | undefined,
  ListUsersQueryVariables
>;
export function useListUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListUsersQuery, ListUsersQueryVariables>(
    ListUsersDocument,
    options
  );
}
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<
  typeof useListUsersLazyQuery
>;
export type ListUsersSuspenseQueryHookResult = ReturnType<
  typeof useListUsersSuspenseQuery
>;
export type ListUsersQueryResult = Apollo.QueryResult<
  ListUsersQuery,
  ListUsersQueryVariables
>;
export const ListUsersPaginationDocument = gql`
  query listUsersPagination(
    $term: String!
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    listUsersPagination(
      term: $term
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
          name
          email
          firstName
          lastName
          friendRequestPending
          avatar {
            ...AvatarDetail
          }
        }
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useListUsersPaginationQuery__
 *
 * To run a query within a React component, call `useListUsersPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersPaginationQuery({
 *   variables: {
 *      term: // value for 'term'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useListUsersPaginationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListUsersPaginationQuery,
    ListUsersPaginationQueryVariables
  > &
    (
      | { variables: ListUsersPaginationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListUsersPaginationQuery,
    ListUsersPaginationQueryVariables
  >(ListUsersPaginationDocument, options);
}
export function useListUsersPaginationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListUsersPaginationQuery,
    ListUsersPaginationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListUsersPaginationQuery,
    ListUsersPaginationQueryVariables
  >(ListUsersPaginationDocument, options);
}
// @ts-ignore
export function useListUsersPaginationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListUsersPaginationQuery,
    ListUsersPaginationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ListUsersPaginationQuery,
  ListUsersPaginationQueryVariables
>;
export function useListUsersPaginationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListUsersPaginationQuery,
        ListUsersPaginationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ListUsersPaginationQuery | undefined,
  ListUsersPaginationQueryVariables
>;
export function useListUsersPaginationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListUsersPaginationQuery,
        ListUsersPaginationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListUsersPaginationQuery,
    ListUsersPaginationQueryVariables
  >(ListUsersPaginationDocument, options);
}
export type ListUsersPaginationQueryHookResult = ReturnType<
  typeof useListUsersPaginationQuery
>;
export type ListUsersPaginationLazyQueryHookResult = ReturnType<
  typeof useListUsersPaginationLazyQuery
>;
export type ListUsersPaginationSuspenseQueryHookResult = ReturnType<
  typeof useListUsersPaginationSuspenseQuery
>;
export type ListUsersPaginationQueryResult = Apollo.QueryResult<
  ListUsersPaginationQuery,
  ListUsersPaginationQueryVariables
>;
export const NewListDocumentsDocument = gql`
  query newListDocuments(
    $chatId: ID
    $includeMedia: Boolean
    $limit: Int
    $page: Int
  ) {
    newListDocuments(
      chatId: $chatId
      includeMedia: $includeMedia
      limit: $limit
      page: $page
    ) {
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
      collection {
        id
        name
        contentType
        createdAt
        size
        isImage
        isVideo
        clientId
        owner {
          id
          name
        }
        file {
          id
          cdnBaseUrl
          path
          isPreviewable
          thumbnail
        }
        messageDocuments {
          id
          message {
            id
            clientId
            chatId
          }
        }
        projectDocuments {
          id
          project {
            id
            uuid
            name
          }
        }
        taskDocuments {
          id
          task {
            id
            name
            projectId
            project {
              id
              uuid
              name
            }
          }
        }
      }
    }
  }
`;

/**
 * __useNewListDocumentsQuery__
 *
 * To run a query within a React component, call `useNewListDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewListDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewListDocumentsQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      includeMedia: // value for 'includeMedia'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useNewListDocumentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    NewListDocumentsQuery,
    NewListDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NewListDocumentsQuery, NewListDocumentsQueryVariables>(
    NewListDocumentsDocument,
    options
  );
}
export function useNewListDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NewListDocumentsQuery,
    NewListDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NewListDocumentsQuery,
    NewListDocumentsQueryVariables
  >(NewListDocumentsDocument, options);
}
// @ts-ignore
export function useNewListDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NewListDocumentsQuery,
    NewListDocumentsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  NewListDocumentsQuery,
  NewListDocumentsQueryVariables
>;
export function useNewListDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NewListDocumentsQuery,
        NewListDocumentsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  NewListDocumentsQuery | undefined,
  NewListDocumentsQueryVariables
>;
export function useNewListDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NewListDocumentsQuery,
        NewListDocumentsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    NewListDocumentsQuery,
    NewListDocumentsQueryVariables
  >(NewListDocumentsDocument, options);
}
export type NewListDocumentsQueryHookResult = ReturnType<
  typeof useNewListDocumentsQuery
>;
export type NewListDocumentsLazyQueryHookResult = ReturnType<
  typeof useNewListDocumentsLazyQuery
>;
export type NewListDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useNewListDocumentsSuspenseQuery
>;
export type NewListDocumentsQueryResult = Apollo.QueryResult<
  NewListDocumentsQuery,
  NewListDocumentsQueryVariables
>;
export const SearchDocument = gql`
  query search(
    $term: String!
    $size: Int
    $from: Int
    $includeChats: Boolean
    $includeMessages: Boolean
    $includeProjects: Boolean
    $includeTasks: Boolean
    $includeDocuments: Boolean
    $includeContacts: Boolean
    $includeCompletedTask: Boolean
    $includeTeams: Boolean
    $includeGroups: Boolean
    $includeUsers: Boolean
    $projectId: ID
    $taskId: ID
    $chatId: ID
    $tags: Boolean
    $media: Boolean
    $files: Boolean
    $collaboratorsOnly: Boolean
    $includeActivities: Boolean
    $documentOwnerIds: [ID!]
    $archiveProjectsOnly: Boolean
    $taskDueGroup: TaskGroup
    $completedTasksOnly: Boolean
    $documentGroup: DocumentGroup
    $projectOwnerIds: [ID!]
    $projectUserIds: [ID!]
    $teamIds: [ID!]
    $taskUserIds: [ID!]
    $projectIds: [ID!]
    $taskPriority: [TaskPriority!]
    $taskDueDateBegin: ISO8601DateTime
    $taskDueDateEnd: ISO8601DateTime
    $taskSort: TaskSearchSortOption
  ) {
    search(
      term: $term
      size: $size
      from: $from
      includeChats: $includeChats
      includeMessages: $includeMessages
      includeProjects: $includeProjects
      includeDocuments: $includeDocuments
      includeTasks: $includeTasks
      includeContacts: $includeContacts
      includeCompletedTask: $includeCompletedTask
      includeTeams: $includeTeams
      includeGroups: $includeGroups
      includeUsers: $includeUsers
      projectId: $projectId
      taskId: $taskId
      chatId: $chatId
      tags: $tags
      media: $media
      files: $files
      collaboratorsOnly: $collaboratorsOnly
      includeActivities: $includeActivities
      archiveProjectsOnly: $archiveProjectsOnly
      taskDueGroup: $taskDueGroup
      completedTasksOnly: $completedTasksOnly
      documentOwnerIds: $documentOwnerIds
      documentGroup: $documentGroup
      projectOwnerIds: $projectOwnerIds
      projectUserIds: $projectUserIds
      teamIds: $teamIds
      taskUserIds: $taskUserIds
      projectIds: $projectIds
      taskPriority: $taskPriority
      taskDueDateBegin: $taskDueDateBegin
      taskDueDateEnd: $taskDueDateEnd
      taskSort: $taskSort
    ) {
      total
      highlight {
        authorName
        body
        chatName
        name
        projectNames
        taskNames
      }
      record {
        ... on Group {
          id
          name
          users {
            id
            name
            email
            avatar {
              ...AvatarDetail
            }
          }
        }
        ... on Document {
          id
          name
          contentType
          createdAt
          size
          isImage
          clientId
          owner {
            ...UserDetail
          }
          file {
            id
            cdnBaseUrl
            path
            isPreviewable
            thumbnail
          }
          messageDocuments {
            id
            message {
              id
              clientId
              authorId
              chat {
                id
                name
              }
            }
          }
          projectDocuments {
            id
            project {
              id
              uuid
              name
              team {
                avatar
                createdAt
                id
                name
                personal
              }
            }
          }
          taskDocuments {
            id
            task {
              id
              name
              projectId
              project {
                id
                uuid
                name
              }
            }
          }
        }
        ... on Task {
          id
          name
          description
          status
          priority
          dueDate
          projectId
          userIds
          completedAt
          deletedAt
          currentUserRole
          currentUserProjectRole
          currentUserProjectTeamRole
          creator {
            ...UserDetail
          }
          members {
            id
            role
            user {
              ...UserDetail
              avatar {
                ...AvatarDetail
              }
            }
          }
          project {
            id
            uuid
            name
            color
            team {
              id
              name
              personal
              avatarFile {
                ...AvatarDetail
              }
            }
          }
        }
        ... on Project {
          id
          uuid
          initials
          name
          description
          address
          color
          createdAt
          icon
          team {
            avatar
            createdAt
            id
            name
            personal
            avatarFile {
              ...AvatarDetail
            }
          }
          creator {
            ...UserDetail
          }
          usersCount
          memberPreviews {
            id
            user {
              id
            }
          }
        }
        ... on Chat {
          id
          name
          description
          avatarUrl
          isGroupChat
          messageIcon
          messageBody
          recentActivityAt
          unreadCount
          createdAt
          leaveOn
          isPendingRequest
          canCurrentUserDecide
          ownerId
          userIds
          settings {
            id
            pin
            mute
            archivedAt
          }
          pendingInvitations {
            email
            expiredAt
            id
          }
          chatUsers: users {
            id
            name
            firstName
            lastName
            avatar {
              ...AvatarDetail
            }
          }
          owner {
            id
            name
            firstName
            lastName
          }
          avatar {
            ...AvatarDetail
          }
        }
        ... on Message {
          id
          body
          publishedAt
          isSender
          clientId
          authorId
          chatId
          clientId
          createdAt
          isDraft
          deletedAt
          authorAvatarId
          authorName
          authorFirstName
          authorLastName
          authorEmail
          author {
            id
            name
            ...UserDetail
          }
          checkin {
            ...checkinDetail
          }
          chat {
            ...ChatDetail
            avatar {
              ...AvatarDetail
            }
          }
          reaction {
            ... on MessageReaction {
              id
              reaction
              count
              user {
                id
              }
            }
          }
          attachments {
            ... on Document {
              id
              isImage
              isAudio
              clientId
              duration
              name
              createdAt
              contentType
              file {
                id
                cdnBaseUrl
                url
                path
                isPreviewable
                thumbnail
              }
              ...DocumentDetail
            }
            ... on MessageTask {
              id
              authorId
              author {
                ...UserDetail
              }
              task {
                id
                name
                status
                priority
                dueDate
                projectId
                userIds
                deletedAt
                creator {
                  ...UserDetail
                }
                project {
                  id
                  uuid
                  name
                  color
                }
              }
            }
            ... on MessageProject {
              id
              authorId
              author {
                ...UserDetail
              }
              project {
                id
                uuid
                initials
                name
                description
                address
                color
                createdAt
                creator {
                  ...UserDetail
                }
                team {
                  subscriptionDetails {
                    expirationDate
                    subscriptionStatus
                  }
                }
              }
            }
            ... on MessageTask {
              id
              author {
                ...UserDetail
              }
              task {
                id
                name
                status
                priority
                dueDate
                projectId
                userIds
                deletedAt
                creator {
                  ...UserDetail
                }
                project {
                  id
                  uuid
                  name
                  color
                }
              }
            }
            ... on MessageProject {
              id
              author {
                ...UserDetail
              }
              project {
                id
                uuid
                initials
                name
                description
                address
                color
                createdAt
                creator {
                  ...UserDetail
                }
              }
            }
          }
        }
        ... on User {
          id
          firstName
          lastName
          email
          fullName: name
          avatar {
            ...AvatarDetail
          }
        }
        ... on Audit {
          event
          createdAt
          id
          user {
            ...UserDetail
          }
          attachment {
            ... on Document {
              ...DocumentDetail
            }
            ... on Message {
              ...MessageDetail
            }
            ... on Task {
              id
              name
              projectId
              deletedAt
              project {
                id
                uuid
                name
              }
            }
            ... on Project {
              id
              uuid
              name
            }
            ... on TaskUser {
              id
              task {
                id
                name
                project {
                  id
                  uuid
                  name
                }
              }
              user {
                ...UserDetail
              }
            }
            ... on EntityUser {
              id
              user {
                ...UserDetail
              }
              entityTask: task {
                id
                name
                deletedAt
                members {
                  id
                  role
                  user {
                    ...UserDetail
                    avatar {
                      ...AvatarDetail
                    }
                  }
                }
                project {
                  id
                  uuid
                  name
                }
              }
              entityProject: project {
                id
                uuid
                name
              }
            }
          }
        }
      }
    }
  }
  ${AvatarDetailFragmentDoc}
  ${UserDetailFragmentDoc}
  ${CheckinDetailFragmentDoc}
  ${ChatDetailFragmentDoc}
  ${DocumentDetailFragmentDoc}
  ${MessageDetailFragmentDoc}
`;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      term: // value for 'term'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *      includeChats: // value for 'includeChats'
 *      includeMessages: // value for 'includeMessages'
 *      includeProjects: // value for 'includeProjects'
 *      includeTasks: // value for 'includeTasks'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeContacts: // value for 'includeContacts'
 *      includeCompletedTask: // value for 'includeCompletedTask'
 *      includeTeams: // value for 'includeTeams'
 *      includeGroups: // value for 'includeGroups'
 *      includeUsers: // value for 'includeUsers'
 *      projectId: // value for 'projectId'
 *      taskId: // value for 'taskId'
 *      chatId: // value for 'chatId'
 *      tags: // value for 'tags'
 *      media: // value for 'media'
 *      files: // value for 'files'
 *      collaboratorsOnly: // value for 'collaboratorsOnly'
 *      includeActivities: // value for 'includeActivities'
 *      documentOwnerIds: // value for 'documentOwnerIds'
 *      archiveProjectsOnly: // value for 'archiveProjectsOnly'
 *      taskDueGroup: // value for 'taskDueGroup'
 *      completedTasksOnly: // value for 'completedTasksOnly'
 *      documentGroup: // value for 'documentGroup'
 *      projectOwnerIds: // value for 'projectOwnerIds'
 *      projectUserIds: // value for 'projectUserIds'
 *      teamIds: // value for 'teamIds'
 *      taskUserIds: // value for 'taskUserIds'
 *      projectIds: // value for 'projectIds'
 *      taskPriority: // value for 'taskPriority'
 *      taskDueDateBegin: // value for 'taskDueDateBegin'
 *      taskDueDateEnd: // value for 'taskDueDateEnd'
 *      taskSort: // value for 'taskSort'
 *   },
 * });
 */
export function useSearchQuery(
  baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables> &
    ({ variables: SearchQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchQuery, SearchQueryVariables>(
    SearchDocument,
    options
  );
}
export function useSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(
    SearchDocument,
    options
  );
}
// @ts-ignore
export function useSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchQuery,
    SearchQueryVariables
  >
): Apollo.UseSuspenseQueryResult<SearchQuery, SearchQueryVariables>;
export function useSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>
): Apollo.UseSuspenseQueryResult<SearchQuery | undefined, SearchQueryVariables>;
export function useSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchQuery, SearchQueryVariables>(
    SearchDocument,
    options
  );
}
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchSuspenseQueryHookResult = ReturnType<
  typeof useSearchSuspenseQuery
>;
export type SearchQueryResult = Apollo.QueryResult<
  SearchQuery,
  SearchQueryVariables
>;
export const SearchChatsDocument = gql`
  query searchChats($term: String!, $first: Int, $after: String) {
    searchChats(term: $term, first: $first, after: $after) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          id
          name
          isGroupChat
          avatarUrl
          avatar {
            ...AvatarDetail
          }
          users {
            id
            name
            avatar {
              ...AvatarDetail
            }
          }
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useSearchChatsQuery__
 *
 * To run a query within a React component, call `useSearchChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchChatsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchChatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchChatsQuery,
    SearchChatsQueryVariables
  > &
    (
      | { variables: SearchChatsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchChatsQuery, SearchChatsQueryVariables>(
    SearchChatsDocument,
    options
  );
}
export function useSearchChatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchChatsQuery,
    SearchChatsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchChatsQuery, SearchChatsQueryVariables>(
    SearchChatsDocument,
    options
  );
}
// @ts-ignore
export function useSearchChatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchChatsQuery,
    SearchChatsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<SearchChatsQuery, SearchChatsQueryVariables>;
export function useSearchChatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchChatsQuery,
        SearchChatsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  SearchChatsQuery | undefined,
  SearchChatsQueryVariables
>;
export function useSearchChatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchChatsQuery,
        SearchChatsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchChatsQuery, SearchChatsQueryVariables>(
    SearchChatsDocument,
    options
  );
}
export type SearchChatsQueryHookResult = ReturnType<typeof useSearchChatsQuery>;
export type SearchChatsLazyQueryHookResult = ReturnType<
  typeof useSearchChatsLazyQuery
>;
export type SearchChatsSuspenseQueryHookResult = ReturnType<
  typeof useSearchChatsSuspenseQuery
>;
export type SearchChatsQueryResult = Apollo.QueryResult<
  SearchChatsQuery,
  SearchChatsQueryVariables
>;
export const SearchTagsDocument = gql`
  query searchTags(
    $term: String!
    $size: Int
    $from: Int
    $includeChats: Boolean
    $includeMessages: Boolean
    $includeProjects: Boolean
    $includeTasks: Boolean
    $includeDocuments: Boolean
    $includeContacts: Boolean
    $projectId: ID
    $taskId: ID
    $chatId: ID
    $tags: Boolean
    $media: Boolean
    $files: Boolean
    $collaboratorsOnly: Boolean
    $includeTasksTags: Boolean
    $includeCompletedTask: Boolean
  ) {
    search(
      term: $term
      size: $size
      from: $from
      includeChats: $includeChats
      includeMessages: $includeMessages
      includeProjects: $includeProjects
      includeDocuments: $includeDocuments
      includeTasks: $includeTasks
      includeContacts: $includeContacts
      includeCompletedTask: $includeCompletedTask
      projectId: $projectId
      taskId: $taskId
      chatId: $chatId
      tags: $tags
      media: $media
      files: $files
      collaboratorsOnly: $collaboratorsOnly
      includeTasksTags: $includeTasksTags
    ) {
      total
      highlight {
        authorName
        name
        projectNames
        taskNames
      }
      record {
        ... on Project {
          id
          uuid
          name
          createdAt
          currentUserRole
          currentUserTeamRole
          team {
            subscriptionDetails {
              expirationDate
              subscriptionInterval
              subscriptionPlanName
              subscriptionStatus
              isSubscriptionCanceled
              isSubscriptionActive
              isSubscriptionOnTrial
              trialEndsAt
              updatedAt
            }
          }
          members {
            user {
              id
            }
          }
          tasksTagList {
            id
            name
            status
            dueDate
            priority
            projectId
            deletedAt
            userIds
            completedAt
            currentUserRole
            currentUserProjectRole
            members {
              id
              role
              user {
                id
                firstName
                lastName
                email
                name
                phoneNumber
                createdAt
                avatar {
                  ...AvatarDetail
                }
              }
            }
            project {
              id
              uuid
              name
              team {
                subscriptionDetails {
                  expirationDate
                  subscriptionInterval
                  subscriptionPlanName
                  subscriptionStatus
                  isSubscriptionCanceled
                  isSubscriptionActive
                  isSubscriptionOnTrial
                  trialEndsAt
                  updatedAt
                }
              }
            }
          }
        }
      }
    }
  }
  ${AvatarDetailFragmentDoc}
`;

/**
 * __useSearchTagsQuery__
 *
 * To run a query within a React component, call `useSearchTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTagsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *      includeChats: // value for 'includeChats'
 *      includeMessages: // value for 'includeMessages'
 *      includeProjects: // value for 'includeProjects'
 *      includeTasks: // value for 'includeTasks'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeContacts: // value for 'includeContacts'
 *      projectId: // value for 'projectId'
 *      taskId: // value for 'taskId'
 *      chatId: // value for 'chatId'
 *      tags: // value for 'tags'
 *      media: // value for 'media'
 *      files: // value for 'files'
 *      collaboratorsOnly: // value for 'collaboratorsOnly'
 *      includeTasksTags: // value for 'includeTasksTags'
 *      includeCompletedTask: // value for 'includeCompletedTask'
 *   },
 * });
 */
export function useSearchTagsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchTagsQuery,
    SearchTagsQueryVariables
  > &
    (
      | { variables: SearchTagsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchTagsQuery, SearchTagsQueryVariables>(
    SearchTagsDocument,
    options
  );
}
export function useSearchTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchTagsQuery,
    SearchTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchTagsQuery, SearchTagsQueryVariables>(
    SearchTagsDocument,
    options
  );
}
// @ts-ignore
export function useSearchTagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchTagsQuery,
    SearchTagsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<SearchTagsQuery, SearchTagsQueryVariables>;
export function useSearchTagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  SearchTagsQuery | undefined,
  SearchTagsQueryVariables
>;
export function useSearchTagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchTagsQuery, SearchTagsQueryVariables>(
    SearchTagsDocument,
    options
  );
}
export type SearchTagsQueryHookResult = ReturnType<typeof useSearchTagsQuery>;
export type SearchTagsLazyQueryHookResult = ReturnType<
  typeof useSearchTagsLazyQuery
>;
export type SearchTagsSuspenseQueryHookResult = ReturnType<
  typeof useSearchTagsSuspenseQuery
>;
export type SearchTagsQueryResult = Apollo.QueryResult<
  SearchTagsQuery,
  SearchTagsQueryVariables
>;
export const SearchTemplatesDocument = gql`
  query searchTemplates($term: String!) {
    searchTemplates(term: $term) {
      id
      isFavorited
      favoritedAt
      templateName
      checklistTemplateItems {
        id
        checklistTemplateItemName
      }
    }
  }
`;

/**
 * __useSearchTemplatesQuery__
 *
 * To run a query within a React component, call `useSearchTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTemplatesQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchTemplatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchTemplatesQuery,
    SearchTemplatesQueryVariables
  > &
    (
      | { variables: SearchTemplatesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchTemplatesQuery, SearchTemplatesQueryVariables>(
    SearchTemplatesDocument,
    options
  );
}
export function useSearchTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchTemplatesQuery,
    SearchTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchTemplatesQuery,
    SearchTemplatesQueryVariables
  >(SearchTemplatesDocument, options);
}
// @ts-ignore
export function useSearchTemplatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchTemplatesQuery,
    SearchTemplatesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  SearchTemplatesQuery,
  SearchTemplatesQueryVariables
>;
export function useSearchTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchTemplatesQuery,
        SearchTemplatesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  SearchTemplatesQuery | undefined,
  SearchTemplatesQueryVariables
>;
export function useSearchTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchTemplatesQuery,
        SearchTemplatesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchTemplatesQuery,
    SearchTemplatesQueryVariables
  >(SearchTemplatesDocument, options);
}
export type SearchTemplatesQueryHookResult = ReturnType<
  typeof useSearchTemplatesQuery
>;
export type SearchTemplatesLazyQueryHookResult = ReturnType<
  typeof useSearchTemplatesLazyQuery
>;
export type SearchTemplatesSuspenseQueryHookResult = ReturnType<
  typeof useSearchTemplatesSuspenseQuery
>;
export type SearchTemplatesQueryResult = Apollo.QueryResult<
  SearchTemplatesQuery,
  SearchTemplatesQueryVariables
>;
export const SharedDocumentsByClientIdsDocument = gql`
  query sharedDocumentsByClientIds($clientIds: [ID!]) {
    sharedDocumentsByClientIds(clientIds: $clientIds) {
      clientId
      file {
        id
        url
        thumbnail
      }
    }
  }
`;

/**
 * __useSharedDocumentsByClientIdsQuery__
 *
 * To run a query within a React component, call `useSharedDocumentsByClientIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedDocumentsByClientIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedDocumentsByClientIdsQuery({
 *   variables: {
 *      clientIds: // value for 'clientIds'
 *   },
 * });
 */
export function useSharedDocumentsByClientIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SharedDocumentsByClientIdsQuery,
    SharedDocumentsByClientIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SharedDocumentsByClientIdsQuery,
    SharedDocumentsByClientIdsQueryVariables
  >(SharedDocumentsByClientIdsDocument, options);
}
export function useSharedDocumentsByClientIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SharedDocumentsByClientIdsQuery,
    SharedDocumentsByClientIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SharedDocumentsByClientIdsQuery,
    SharedDocumentsByClientIdsQueryVariables
  >(SharedDocumentsByClientIdsDocument, options);
}
// @ts-ignore
export function useSharedDocumentsByClientIdsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SharedDocumentsByClientIdsQuery,
    SharedDocumentsByClientIdsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  SharedDocumentsByClientIdsQuery,
  SharedDocumentsByClientIdsQueryVariables
>;
export function useSharedDocumentsByClientIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SharedDocumentsByClientIdsQuery,
        SharedDocumentsByClientIdsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  SharedDocumentsByClientIdsQuery | undefined,
  SharedDocumentsByClientIdsQueryVariables
>;
export function useSharedDocumentsByClientIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SharedDocumentsByClientIdsQuery,
        SharedDocumentsByClientIdsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SharedDocumentsByClientIdsQuery,
    SharedDocumentsByClientIdsQueryVariables
  >(SharedDocumentsByClientIdsDocument, options);
}
export type SharedDocumentsByClientIdsQueryHookResult = ReturnType<
  typeof useSharedDocumentsByClientIdsQuery
>;
export type SharedDocumentsByClientIdsLazyQueryHookResult = ReturnType<
  typeof useSharedDocumentsByClientIdsLazyQuery
>;
export type SharedDocumentsByClientIdsSuspenseQueryHookResult = ReturnType<
  typeof useSharedDocumentsByClientIdsSuspenseQuery
>;
export type SharedDocumentsByClientIdsQueryResult = Apollo.QueryResult<
  SharedDocumentsByClientIdsQuery,
  SharedDocumentsByClientIdsQueryVariables
>;
export const SharedMediaByTokenDocument = gql`
  query sharedMediaByToken($token: String!) {
    sharedMediaByToken(token: $token) {
      sharerName
      sharerAvatar {
        id
        url
        thumbnail
        cdnBaseUrl
        path
        isPreviewable
      }
      documents {
        clientId
        name
        file {
          id
          url
          thumbnail
        }
      }
    }
  }
`;

/**
 * __useSharedMediaByTokenQuery__
 *
 * To run a query within a React component, call `useSharedMediaByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedMediaByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedMediaByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSharedMediaByTokenQuery(
  baseOptions: Apollo.QueryHookOptions<
    SharedMediaByTokenQuery,
    SharedMediaByTokenQueryVariables
  > &
    (
      | { variables: SharedMediaByTokenQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SharedMediaByTokenQuery,
    SharedMediaByTokenQueryVariables
  >(SharedMediaByTokenDocument, options);
}
export function useSharedMediaByTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SharedMediaByTokenQuery,
    SharedMediaByTokenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SharedMediaByTokenQuery,
    SharedMediaByTokenQueryVariables
  >(SharedMediaByTokenDocument, options);
}
// @ts-ignore
export function useSharedMediaByTokenSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SharedMediaByTokenQuery,
    SharedMediaByTokenQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  SharedMediaByTokenQuery,
  SharedMediaByTokenQueryVariables
>;
export function useSharedMediaByTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SharedMediaByTokenQuery,
        SharedMediaByTokenQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  SharedMediaByTokenQuery | undefined,
  SharedMediaByTokenQueryVariables
>;
export function useSharedMediaByTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SharedMediaByTokenQuery,
        SharedMediaByTokenQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SharedMediaByTokenQuery,
    SharedMediaByTokenQueryVariables
  >(SharedMediaByTokenDocument, options);
}
export type SharedMediaByTokenQueryHookResult = ReturnType<
  typeof useSharedMediaByTokenQuery
>;
export type SharedMediaByTokenLazyQueryHookResult = ReturnType<
  typeof useSharedMediaByTokenLazyQuery
>;
export type SharedMediaByTokenSuspenseQueryHookResult = ReturnType<
  typeof useSharedMediaByTokenSuspenseQuery
>;
export type SharedMediaByTokenQueryResult = Apollo.QueryResult<
  SharedMediaByTokenQuery,
  SharedMediaByTokenQueryVariables
>;
export const TeamAvatarsByIdsDocument = gql`
  query teamAvatarsByIds($ids: [ID!]) {
    teamAvatarsByIds(ids: $ids) {
      id
      thumbnail
      url
    }
  }
`;

/**
 * __useTeamAvatarsByIdsQuery__
 *
 * To run a query within a React component, call `useTeamAvatarsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamAvatarsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamAvatarsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTeamAvatarsByIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TeamAvatarsByIdsQuery,
    TeamAvatarsByIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TeamAvatarsByIdsQuery, TeamAvatarsByIdsQueryVariables>(
    TeamAvatarsByIdsDocument,
    options
  );
}
export function useTeamAvatarsByIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TeamAvatarsByIdsQuery,
    TeamAvatarsByIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TeamAvatarsByIdsQuery,
    TeamAvatarsByIdsQueryVariables
  >(TeamAvatarsByIdsDocument, options);
}
// @ts-ignore
export function useTeamAvatarsByIdsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TeamAvatarsByIdsQuery,
    TeamAvatarsByIdsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  TeamAvatarsByIdsQuery,
  TeamAvatarsByIdsQueryVariables
>;
export function useTeamAvatarsByIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TeamAvatarsByIdsQuery,
        TeamAvatarsByIdsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  TeamAvatarsByIdsQuery | undefined,
  TeamAvatarsByIdsQueryVariables
>;
export function useTeamAvatarsByIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TeamAvatarsByIdsQuery,
        TeamAvatarsByIdsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TeamAvatarsByIdsQuery,
    TeamAvatarsByIdsQueryVariables
  >(TeamAvatarsByIdsDocument, options);
}
export type TeamAvatarsByIdsQueryHookResult = ReturnType<
  typeof useTeamAvatarsByIdsQuery
>;
export type TeamAvatarsByIdsLazyQueryHookResult = ReturnType<
  typeof useTeamAvatarsByIdsLazyQuery
>;
export type TeamAvatarsByIdsSuspenseQueryHookResult = ReturnType<
  typeof useTeamAvatarsByIdsSuspenseQuery
>;
export type TeamAvatarsByIdsQueryResult = Apollo.QueryResult<
  TeamAvatarsByIdsQuery,
  TeamAvatarsByIdsQueryVariables
>;
export const TeamAvatarsThumbnailByIdsDocument = gql`
  query teamAvatarsThumbnailByIds($ids: [ID!]) {
    teamAvatarsByIds(ids: $ids) {
      id
      thumbnail
    }
  }
`;

/**
 * __useTeamAvatarsThumbnailByIdsQuery__
 *
 * To run a query within a React component, call `useTeamAvatarsThumbnailByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamAvatarsThumbnailByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamAvatarsThumbnailByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTeamAvatarsThumbnailByIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TeamAvatarsThumbnailByIdsQuery,
    TeamAvatarsThumbnailByIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TeamAvatarsThumbnailByIdsQuery,
    TeamAvatarsThumbnailByIdsQueryVariables
  >(TeamAvatarsThumbnailByIdsDocument, options);
}
export function useTeamAvatarsThumbnailByIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TeamAvatarsThumbnailByIdsQuery,
    TeamAvatarsThumbnailByIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TeamAvatarsThumbnailByIdsQuery,
    TeamAvatarsThumbnailByIdsQueryVariables
  >(TeamAvatarsThumbnailByIdsDocument, options);
}
// @ts-ignore
export function useTeamAvatarsThumbnailByIdsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TeamAvatarsThumbnailByIdsQuery,
    TeamAvatarsThumbnailByIdsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  TeamAvatarsThumbnailByIdsQuery,
  TeamAvatarsThumbnailByIdsQueryVariables
>;
export function useTeamAvatarsThumbnailByIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TeamAvatarsThumbnailByIdsQuery,
        TeamAvatarsThumbnailByIdsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  TeamAvatarsThumbnailByIdsQuery | undefined,
  TeamAvatarsThumbnailByIdsQueryVariables
>;
export function useTeamAvatarsThumbnailByIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TeamAvatarsThumbnailByIdsQuery,
        TeamAvatarsThumbnailByIdsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TeamAvatarsThumbnailByIdsQuery,
    TeamAvatarsThumbnailByIdsQueryVariables
  >(TeamAvatarsThumbnailByIdsDocument, options);
}
export type TeamAvatarsThumbnailByIdsQueryHookResult = ReturnType<
  typeof useTeamAvatarsThumbnailByIdsQuery
>;
export type TeamAvatarsThumbnailByIdsLazyQueryHookResult = ReturnType<
  typeof useTeamAvatarsThumbnailByIdsLazyQuery
>;
export type TeamAvatarsThumbnailByIdsSuspenseQueryHookResult = ReturnType<
  typeof useTeamAvatarsThumbnailByIdsSuspenseQuery
>;
export type TeamAvatarsThumbnailByIdsQueryResult = Apollo.QueryResult<
  TeamAvatarsThumbnailByIdsQuery,
  TeamAvatarsThumbnailByIdsQueryVariables
>;
export const UserAvatarsByIdsDocument = gql`
  query userAvatarsByIds($ids: [ID!]) {
    userAvatarsByIds(ids: $ids) {
      id
      thumbnail
      url
    }
  }
`;

/**
 * __useUserAvatarsByIdsQuery__
 *
 * To run a query within a React component, call `useUserAvatarsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAvatarsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAvatarsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUserAvatarsByIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserAvatarsByIdsQuery,
    UserAvatarsByIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserAvatarsByIdsQuery, UserAvatarsByIdsQueryVariables>(
    UserAvatarsByIdsDocument,
    options
  );
}
export function useUserAvatarsByIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserAvatarsByIdsQuery,
    UserAvatarsByIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserAvatarsByIdsQuery,
    UserAvatarsByIdsQueryVariables
  >(UserAvatarsByIdsDocument, options);
}
// @ts-ignore
export function useUserAvatarsByIdsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserAvatarsByIdsQuery,
    UserAvatarsByIdsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  UserAvatarsByIdsQuery,
  UserAvatarsByIdsQueryVariables
>;
export function useUserAvatarsByIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserAvatarsByIdsQuery,
        UserAvatarsByIdsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  UserAvatarsByIdsQuery | undefined,
  UserAvatarsByIdsQueryVariables
>;
export function useUserAvatarsByIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserAvatarsByIdsQuery,
        UserAvatarsByIdsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    UserAvatarsByIdsQuery,
    UserAvatarsByIdsQueryVariables
  >(UserAvatarsByIdsDocument, options);
}
export type UserAvatarsByIdsQueryHookResult = ReturnType<
  typeof useUserAvatarsByIdsQuery
>;
export type UserAvatarsByIdsLazyQueryHookResult = ReturnType<
  typeof useUserAvatarsByIdsLazyQuery
>;
export type UserAvatarsByIdsSuspenseQueryHookResult = ReturnType<
  typeof useUserAvatarsByIdsSuspenseQuery
>;
export type UserAvatarsByIdsQueryResult = Apollo.QueryResult<
  UserAvatarsByIdsQuery,
  UserAvatarsByIdsQueryVariables
>;
export const UserAvatarsThumbnailByIdsDocument = gql`
  query userAvatarsThumbnailByIds($ids: [ID!]) {
    userAvatarsByIds(ids: $ids) {
      id
      thumbnail
    }
  }
`;

/**
 * __useUserAvatarsThumbnailByIdsQuery__
 *
 * To run a query within a React component, call `useUserAvatarsThumbnailByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAvatarsThumbnailByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAvatarsThumbnailByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUserAvatarsThumbnailByIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserAvatarsThumbnailByIdsQuery,
    UserAvatarsThumbnailByIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserAvatarsThumbnailByIdsQuery,
    UserAvatarsThumbnailByIdsQueryVariables
  >(UserAvatarsThumbnailByIdsDocument, options);
}
export function useUserAvatarsThumbnailByIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserAvatarsThumbnailByIdsQuery,
    UserAvatarsThumbnailByIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserAvatarsThumbnailByIdsQuery,
    UserAvatarsThumbnailByIdsQueryVariables
  >(UserAvatarsThumbnailByIdsDocument, options);
}
// @ts-ignore
export function useUserAvatarsThumbnailByIdsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserAvatarsThumbnailByIdsQuery,
    UserAvatarsThumbnailByIdsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  UserAvatarsThumbnailByIdsQuery,
  UserAvatarsThumbnailByIdsQueryVariables
>;
export function useUserAvatarsThumbnailByIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserAvatarsThumbnailByIdsQuery,
        UserAvatarsThumbnailByIdsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  UserAvatarsThumbnailByIdsQuery | undefined,
  UserAvatarsThumbnailByIdsQueryVariables
>;
export function useUserAvatarsThumbnailByIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserAvatarsThumbnailByIdsQuery,
        UserAvatarsThumbnailByIdsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    UserAvatarsThumbnailByIdsQuery,
    UserAvatarsThumbnailByIdsQueryVariables
  >(UserAvatarsThumbnailByIdsDocument, options);
}
export type UserAvatarsThumbnailByIdsQueryHookResult = ReturnType<
  typeof useUserAvatarsThumbnailByIdsQuery
>;
export type UserAvatarsThumbnailByIdsLazyQueryHookResult = ReturnType<
  typeof useUserAvatarsThumbnailByIdsLazyQuery
>;
export type UserAvatarsThumbnailByIdsSuspenseQueryHookResult = ReturnType<
  typeof useUserAvatarsThumbnailByIdsSuspenseQuery
>;
export type UserAvatarsThumbnailByIdsQueryResult = Apollo.QueryResult<
  UserAvatarsThumbnailByIdsQuery,
  UserAvatarsThumbnailByIdsQueryVariables
>;
export const ValidateContentTypeDocument = gql`
  query validateContentType($contentType: String!) {
    validateContentType(contentType: $contentType)
  }
`;

/**
 * __useValidateContentTypeQuery__
 *
 * To run a query within a React component, call `useValidateContentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateContentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateContentTypeQuery({
 *   variables: {
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useValidateContentTypeQuery(
  baseOptions: Apollo.QueryHookOptions<
    ValidateContentTypeQuery,
    ValidateContentTypeQueryVariables
  > &
    (
      | { variables: ValidateContentTypeQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ValidateContentTypeQuery,
    ValidateContentTypeQueryVariables
  >(ValidateContentTypeDocument, options);
}
export function useValidateContentTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValidateContentTypeQuery,
    ValidateContentTypeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ValidateContentTypeQuery,
    ValidateContentTypeQueryVariables
  >(ValidateContentTypeDocument, options);
}
// @ts-ignore
export function useValidateContentTypeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ValidateContentTypeQuery,
    ValidateContentTypeQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ValidateContentTypeQuery,
  ValidateContentTypeQueryVariables
>;
export function useValidateContentTypeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ValidateContentTypeQuery,
        ValidateContentTypeQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ValidateContentTypeQuery | undefined,
  ValidateContentTypeQueryVariables
>;
export function useValidateContentTypeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ValidateContentTypeQuery,
        ValidateContentTypeQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ValidateContentTypeQuery,
    ValidateContentTypeQueryVariables
  >(ValidateContentTypeDocument, options);
}
export type ValidateContentTypeQueryHookResult = ReturnType<
  typeof useValidateContentTypeQuery
>;
export type ValidateContentTypeLazyQueryHookResult = ReturnType<
  typeof useValidateContentTypeLazyQuery
>;
export type ValidateContentTypeSuspenseQueryHookResult = ReturnType<
  typeof useValidateContentTypeSuspenseQuery
>;
export type ValidateContentTypeQueryResult = Apollo.QueryResult<
  ValidateContentTypeQuery,
  ValidateContentTypeQueryVariables
>;
export const ChatUpdateDocument = gql`
  subscription chatUpdate {
    chatUpdate {
      id
      name
      messageBody
      recentActivityAt
      unreadCount
    }
  }
`;

/**
 * __useChatUpdateSubscription__
 *
 * To run a query within a React component, call `useChatUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useChatUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ChatUpdateSubscription,
    ChatUpdateSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ChatUpdateSubscription,
    ChatUpdateSubscriptionVariables
  >(ChatUpdateDocument, options);
}
export type ChatUpdateSubscriptionHookResult = ReturnType<
  typeof useChatUpdateSubscription
>;
export type ChatUpdateSubscriptionResult =
  Apollo.SubscriptionResult<ChatUpdateSubscription>;
export const MeUpdatedDocument = gql`
  subscription meUpdated {
    meUpdated {
      profile {
        ...UserProfile
      }
      chats {
        id
        unreadCount
        settings {
          id
          mute
          pin
        }
      }
    }
  }
  ${UserProfileFragmentDoc}
`;

/**
 * __useMeUpdatedSubscription__
 *
 * To run a query within a React component, call `useMeUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMeUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMeUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    MeUpdatedSubscription,
    MeUpdatedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    MeUpdatedSubscription,
    MeUpdatedSubscriptionVariables
  >(MeUpdatedDocument, options);
}
export type MeUpdatedSubscriptionHookResult = ReturnType<
  typeof useMeUpdatedSubscription
>;
export type MeUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<MeUpdatedSubscription>;
export const MessageDeleteDocument = gql`
  subscription messageDelete($chatId: ID!) {
    messageDelete(chatId: $chatId) {
      ...MessageDetail
    }
  }
  ${MessageDetailFragmentDoc}
`;

/**
 * __useMessageDeleteSubscription__
 *
 * To run a query within a React component, call `useMessageDeleteSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMessageDeleteSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageDeleteSubscription({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useMessageDeleteSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    MessageDeleteSubscription,
    MessageDeleteSubscriptionVariables
  > &
    (
      | { variables: MessageDeleteSubscriptionVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    MessageDeleteSubscription,
    MessageDeleteSubscriptionVariables
  >(MessageDeleteDocument, options);
}
export type MessageDeleteSubscriptionHookResult = ReturnType<
  typeof useMessageDeleteSubscription
>;
export type MessageDeleteSubscriptionResult =
  Apollo.SubscriptionResult<MessageDeleteSubscription>;
export const MessageUpdateDocument = gql`
  subscription messageUpdate($chatId: ID!) {
    messageUpdate(chatId: $chatId) {
      ...MessageUpdateLite
    }
  }
  ${MessageUpdateLiteFragmentDoc}
`;

/**
 * __useMessageUpdateSubscription__
 *
 * To run a query within a React component, call `useMessageUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMessageUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageUpdateSubscription({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useMessageUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    MessageUpdateSubscription,
    MessageUpdateSubscriptionVariables
  > &
    (
      | { variables: MessageUpdateSubscriptionVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    MessageUpdateSubscription,
    MessageUpdateSubscriptionVariables
  >(MessageUpdateDocument, options);
}
export type MessageUpdateSubscriptionHookResult = ReturnType<
  typeof useMessageUpdateSubscription
>;
export type MessageUpdateSubscriptionResult =
  Apollo.SubscriptionResult<MessageUpdateSubscription>;
export const ProjectListNodeUpdatedDocument = gql`
  subscription projectListNodeUpdated {
    projectUpdated {
      ...ProjectListNode
    }
  }
  ${ProjectListNodeFragmentDoc}
`;

/**
 * __useProjectListNodeUpdatedSubscription__
 *
 * To run a query within a React component, call `useProjectListNodeUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectListNodeUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectListNodeUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProjectListNodeUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ProjectListNodeUpdatedSubscription,
    ProjectListNodeUpdatedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ProjectListNodeUpdatedSubscription,
    ProjectListNodeUpdatedSubscriptionVariables
  >(ProjectListNodeUpdatedDocument, options);
}
export type ProjectListNodeUpdatedSubscriptionHookResult = ReturnType<
  typeof useProjectListNodeUpdatedSubscription
>;
export type ProjectListNodeUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<ProjectListNodeUpdatedSubscription>;
export const ProjectUpdatedDocument = gql`
  subscription projectUpdated {
    projectUpdated {
      ...ProjectDetail
    }
  }
  ${ProjectDetailFragmentDoc}
`;

/**
 * __useProjectUpdatedSubscription__
 *
 * To run a query within a React component, call `useProjectUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProjectUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ProjectUpdatedSubscription,
    ProjectUpdatedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ProjectUpdatedSubscription,
    ProjectUpdatedSubscriptionVariables
  >(ProjectUpdatedDocument, options);
}
export type ProjectUpdatedSubscriptionHookResult = ReturnType<
  typeof useProjectUpdatedSubscription
>;
export type ProjectUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<ProjectUpdatedSubscription>;
export const TaskUpdatedDocument = gql`
  subscription taskUpdated($taskId: ID!) {
    taskUpdated(taskId: $taskId) {
      ...TaskDetail
      auditsCount
      unreadAuditsCount
    }
  }
  ${TaskDetailFragmentDoc}
`;

/**
 * __useTaskUpdatedSubscription__
 *
 * To run a query within a React component, call `useTaskUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTaskUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskUpdatedSubscription({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTaskUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    TaskUpdatedSubscription,
    TaskUpdatedSubscriptionVariables
  > &
    (
      | { variables: TaskUpdatedSubscriptionVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    TaskUpdatedSubscription,
    TaskUpdatedSubscriptionVariables
  >(TaskUpdatedDocument, options);
}
export type TaskUpdatedSubscriptionHookResult = ReturnType<
  typeof useTaskUpdatedSubscription
>;
export type TaskUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<TaskUpdatedSubscription>;
